function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self1) {
    if (self1 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self1;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self1, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self1);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSErrorSummaryFragment on EGDSErrorSummary {\n    egdsElementId\n    goToErrorLinkText\n    goToFirstErrorLinkText\n    heading\n    body {\n      text\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    headingTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      id\n      description\n      token\n      title\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormButtonFragment on EGDSSearchFormButton {\n    egdsElementId\n    ...EGDSButtonFragment\n    onClick {\n      ...EGDSSubmitSearchFormActionFragment\n    }\n  }\n\n  fragment EGDSSubmitSearchFormActionFragment on EGDSSubmitSearchFormAction {\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    id\n    title\n    token\n    description\n    size\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    selected\n    selectedText\n    value\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibilityCalendarContentFragment on EGDSDatePickerFlexibilityCalendarContent {\n    __typename\n    flexibleDateOptions {\n      ...EGDSBasicPillFragment\n    }\n    formElementId\n    title {\n      text\n      accessibility\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTabsFragment on EGDSBasicTabs {\n    __typename\n    egdsElementId\n    selectedTabId\n    tabs {\n      ... on EGDSBasicTab {\n        __typename\n        accessibility\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n        label\n        tabId\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    __typename\n    text\n    theme\n    size\n    accessibility\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    __typename\n\n    ...EGDSStandardBadgeFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSToggleButtonFragment on EGDSToggleButton {\n    __typename\n    egdsElementId\n    primary\n    subText\n    name\n    selectedAnalytics {\n      linkName\n      referrerId\n    }\n    unselectedAnalytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ... on Icon {\n        id\n        size\n      }\n    }\n    selected\n    disabled\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSToggleButtonGroupFragment on EGDSToggleButtonGroup {\n    __typename\n    options {\n      ...EGDSToggleButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibleMonthsFragment on EGDSDatePickerFlexibleMonths {\n    heading\n    subHeading\n    options {\n      ...EGDSToggleButtonGroupFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    label {\n      text\n    }\n    name\n    required\n    state\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCheckBoxFragment on EGDSCheckBox {\n    __typename\n\n    ...EGDSBasicCheckBoxFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    name\n    accessibility\n    id\n    removeAnalytics {\n      referrerId\n      linkName\n    }\n    value\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTriggerPillFragment on EGDSBasicTriggerPill {\n    id\n    disabled\n    primary\n    selected\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n    accessibility\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n\n    ...EGDSBasicPillFragment\n    ...EGDSBasicTriggerPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibleNightsFragment on EGDSDatePickerFlexibleNights {\n    heading\n    includeWeekend {\n      ...EGDSCheckBoxFragment\n    }\n    options {\n      ...EGDSPillFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibilityDatesContentFragment on EGDSDatePickerFlexibilityDatesContent {\n    __typename\n    nightsSelection {\n      ...EGDSDatePickerFlexibleNightsFragment\n    }\n    monthsSelection {\n      ...EGDSDatePickerFlexibleMonthsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibilityContentFragment on EGDSDatePickerFlexibilityContent {\n    __typename\n    calendarContent {\n      ...EGDSDatePickerFlexibilityCalendarContentFragment\n    }\n    contentSelector {\n      ...EGDSBasicTabsFragment\n    }\n    flexibleDatesContent {\n      ...EGDSDatePickerFlexibilityDatesContentFragment\n    }\n    flexibilityLabel {\n      templates {\n        template\n        category\n      }\n      models {\n        key\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormFlexibleDatesPriceInsightsMonthlyFragment on SearchFormPriceInsightsMonthlyResponse {\n    options {\n      ... on SearchFormPriceInsightsMonthlyOption {\n        __typename\n        button {\n          ...EGDSToggleButtonFragment\n        }\n        price {\n          ...EGDSBadgeFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  query SearchFormPriceInsights($context: ContextInput!, $gaiaId: String!) {\n    searchFormPriceInsights(context: $context) {\n      flexibleDatesMonthly(gaiaId: $gaiaId) {\n        __typename\n        ...SearchFormFlexibleDatesPriceInsightsMonthlyFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n  }\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    accessibility\n    text\n    graphic {\n      ...UIGraphicFragment\n    }\n    trailingGraphics {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  query FlightsPriceCalendar(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput!\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $queryState: FlightsQueryState\n    $searchFilterValuesList: [FlightsSearchFilterValuesInput!]\n    $searchPreferences: FlightsSearchPreferencesInput\n  ) {\n    flightsPriceCalendar(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      queryState: $queryState\n      searchFilterValuesList: $searchFilterValuesList\n      searchPreferences: $searchPreferences\n    ) {\n      alertText {\n        ...EGDSGraphicTextFragment\n      }\n      disclaimerText\n      coverageAnalytics {\n        linkName\n        referrerId\n      }\n      calendarPrices {\n        date\n        label\n        selectAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n        theme\n        weight\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDateRangePickerFragment on EGDSDateRangePicker {\n    buttonText\n    buttonTextTemplate {\n      ... on EGDSCardinalLocalizedText {\n        text\n        models {\n          key\n          source\n          __typename\n        }\n        templates {\n          category\n          template\n          __typename\n        }\n        __typename\n      }\n    }\n    clearButtonText\n    firstDayOfWeek\n    maxNumberOfDaysSelected\n    sameDaySelectionAllowed\n    selectedStartDate {\n      ...DateFragment\n    }\n    startDatePlaceholderText\n    selectedEndDate {\n      ...DateFragment\n    }\n    endDatePlaceholderText\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    nextButtonAnalytics {\n      linkName\n      referrerId\n    }\n    previousButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    endDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    clearDatesButtonAnalytics {\n      linkName\n      referrerId\n    }\n    showClearDatesButton\n\n    flexibleDateContent {\n      ...EGDSDatePickerFlexibilityContentFragment\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSingleDatePickerFragment on EGDSSingleDatePicker {\n    buttonText\n    selectedStartDate {\n      ...DateFragment\n    }\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    firstDayOfWeek\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormDatePickerFieldFragment on EGDSSearchFormDatePickerField {\n    egdsElementId\n    label\n    placeholder\n    errorMessage\n    validations {\n      ... on EGDSMaxLengthInputValidation {\n        errorMessage\n      }\n    }\n    action {\n      ...EGDSOpenDatePickerActionFragment\n    }\n  }\n\n  fragment EGDSOpenDatePickerActionFragment on EGDSOpenDatePickerAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    datePicker {\n      ...EGDSDateRangePickerFragment\n      ...EGDSSingleDatePickerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment SearchLocationFragment on SearchLocation {\n    __typename\n    analytics {\n      open\n      close\n      itemSelected\n      recommendationsPresented\n      recommendationSelected\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormLocationFieldFragment on EGDSSearchFormLocationField {\n    __typename\n    egdsElementId\n    label\n    placeholder\n    value\n    errorMessage\n    regionId\n    required\n    leftIcon {\n      title\n    }\n    action {\n      ...OpenTypeaheadActionFragment\n    }\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n    multiLocations {\n      text\n      value\n    }\n    validations {\n      ... on EGDSInputValidation {\n        errorMessage\n        __typename\n      }\n    }\n    debounceRate\n  }\n\n  fragment OpenTypeaheadActionFragment on OpenTypeaheadAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    info {\n      ...TypeaheadInfoFragment\n    }\n    emptyResultsPlaceholder\n    categorize\n    allowExactMatch\n    listTitle\n    selectedItemHeading\n    clearAllText\n    dismissButtonText\n  }\n\n  fragment TypeaheadInfoFragment on TypeaheadInfo {\n    client\n    drivable\n    isDestination\n    lineOfBusiness\n    maxNumberOfResults\n    packageType\n    personalize\n    regionType\n    typeaheadFeatures\n    isMultiLocation\n    domain\n    regionId\n    showCurrentLocation\n    subLob\n    expUserId\n    trending\n  }\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTertiaryButtonFragment on UITertiaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicOptionFragment on EGDSBasicOption {\n    label\n    value\n    egdsElementId\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerChildAgeSelectFragment on EGDSTravelerChildAgeSelect {\n    labelTemplate {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    options {\n      ...EGDSBasicOptionFragment\n    }\n    egdsElementId\n    value\n  }\n\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment TemplateModelFragment on TemplateModel {\n    key\n    source\n  }\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    egdsElementId\n    text\n    models {\n      ...TemplateModelFragment\n    }\n    templates {\n      ...CardinalTemplateFragment\n    }\n  }\n\n  fragment CardinalTemplateFragment on CardinalTemplate {\n    template\n    category\n  }\n\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCompositeLocalizedTextFragment on EGDSCompositeLocalizedText {\n    egdsElementId\n    text\n    template\n    models {\n      ...CompositeLocalizedTextModelFragment\n    }\n  }\n\n  fragment CompositeLocalizedTextModelFragment on CompositeLocalizedTextModel {\n    key\n    models {\n      ...EGDSTemplateModelsFragment\n    }\n  }\n\n  fragment EGDSTemplateModelsFragment on EGDSTemplateModels {\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSLocalizedTextFragment on EGDSLocalizedText {\n    ...EGDSBasicLocalizedTextFragment\n    ...EGDSCardinalLocalizedTextFragment\n    ...EGDSCompositeLocalizedTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerStepInputFragment on EGDSStepInput {\n    ... on EGDSTravelerStepInput {\n      decreaseAnalytics {\n        linkName\n        referrerId\n      }\n      increaseAnalytics {\n        linkName\n        referrerId\n      }\n      decreaseText\n      decreaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      increaseText\n      increaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      egdsElementId\n    }\n    label\n    max\n    min\n    step\n    subLabel\n    value\n  }\n\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerChildrenFragment on EGDSTraveler {\n    count {\n      ...EGDSTravelerStepInputFragment\n    }\n    ... on EGDSBasicTraveler {\n      type\n    }\n    ... on EGDSTravelerChildren {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n    ... on EGDSTravelerInfant {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelersFragment on EGDSTravelers {\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    infantsInSeat {\n      ...EGDSTravelerChildrenFragment\n    }\n    infantsOnLap {\n      ...EGDSTravelerChildrenFragment\n    }\n    pets {\n      ...EGDSBasicCheckBoxFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTravelerSelectorFragment on EGDSBasicTravelerSelector {\n    closeButton {\n      ...EGDSPrimaryButtonFragment\n      ...EGDSTertiaryButtonFragment\n    }\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    title\n    travelers {\n      ...EGDSTravelersFragment\n    }\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        infantsInSeatPerAdult\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    egdsElementId\n    action {\n      accessibility\n      target\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    icon {\n      id\n    }\n    iconPosition\n  }\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerInfantSeatSelectFragment on EGDSTravelerInfantSeatSelection {\n    airlineAgeRule {\n      ...EGDSStandardLinkFragment\n    }\n    groupName\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        text\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n    options {\n      label\n      value\n    }\n    selected\n  }\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerSelectorRoomFragment on EGDSTravelerSelectorRoom {\n    label {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    infants {\n      ...EGDSTravelerChildrenFragment\n    }\n    removeRoomButton {\n      ...EGDSTertiaryButtonFragment\n    }\n    removeRoomAnnouncement\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSRoomsTravelerSelectorFragment on EGDSRoomsTravelerSelector {\n    addAnotherRoomButton {\n      ...EGDSTertiaryButtonFragment\n    }\n    closeButton {\n      ...EGDSPrimaryButtonFragment\n      ...EGDSTertiaryButtonFragment\n    }\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    infantSeatSelection {\n      ...EGDSTravelerInfantSeatSelectFragment\n    }\n    maxRoomCount\n    rooms {\n      ...EGDSTravelerSelectorRoomFragment\n    }\n    title\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        infantsInSeatPerAdult\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormTravelersFieldFragment on EGDSSearchFormTravelersField {\n    action {\n      ... on EGDSOpenTravelerSelectorAction {\n        analytics {\n          linkName\n          referrerId\n        }\n        travelerSelector {\n          ...EGDSBasicTravelerSelectorFragment\n          ...EGDSRoomsTravelerSelectorFragment\n        }\n        accessibility\n      }\n    }\n    label\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        secondaryTemplates {\n          category\n          template\n        }\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        models {\n          key\n          models {\n            ... on EGDSCardinalLocalizedText {\n              models {\n                key\n                source\n              }\n              templates {\n                category\n                template\n              }\n            }\n          }\n        }\n        template\n        text\n      }\n    }\n    leftIcon {\n      id\n    }\n    readOnly\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchPlaybackFragment on EGDSSearchPlayback {\n    primary {\n      text\n    }\n    primaryTemplate {\n      ... on EGDSBasicLocalizedText {\n        text\n      }\n    }\n    secondaries {\n      ... on EGDSPlainText {\n        text\n        accessibility\n      }\n      ... on EGDSBasicLocalizedText {\n        text\n        template\n        accessibilityTemplate\n        models {\n          key\n          source\n        }\n        egdsElementId\n      }\n      ... on EGDSCardinalLocalizedText {\n        text\n        accessibilityText\n        egdsElementId\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n    showAction {\n      ... on EGDSShowSearchFormAction {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        icon {\n          id\n          size\n        }\n        resource {\n          value\n        }\n      }\n    }\n    hideButton {\n      ...EGDSTertiaryButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormPopularFiltersFragment on SearchFormPopularFilters {\n    filters {\n      __typename\n      ...EGDSPillFragment\n    }\n    template {\n      template\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment SoftPackagesFragment on SoftPackages {\n    actionURL\n    addCar {\n      ...EGDSCheckBoxFragment\n    }\n    addFlight {\n      ...EGDSCheckBoxFragment\n    }\n    addHotel {\n      ...EGDSCheckBoxFragment\n    }\n    origin {\n      ...EGDSSearchFormLocationFieldFragment\n    }\n    datesForHotelStay {\n      ...EGDSSearchFormDatePickerFieldFragment\n    }\n    maxBookableTravelers\n    maxTravelersErrorMessage\n    validDaysUpperBoundInclusive {\n      day\n      month\n      year\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment EGUisMicroMessageFragment on EGUisMicroMessage {\n    schemaName\n    messageContent\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment AdaptexTrackingSuccessFragment on SearchFormAdaptExSuccessEvent {\n    __typename\n    datePrefill {\n      ...EGUisMicroMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingSearchFormFragment on LodgingSearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n\n    softPackages {\n      ...SoftPackagesFragment\n    }\n\n    adaptExSuccessEvent {\n      ...AdaptexTrackingSuccessFragment\n    }\n\n    searchLocation {\n      ...SearchLocationFragment\n    }\n\n    popularFilters {\n      ...SearchFormPopularFiltersFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  query LodgingSearchFormQuery(\n    $context: ContextInput!\n    $propertySearchCriteriaInput: PropertySearchCriteriaInput\n    $includePlayback: Boolean = false\n    $features: [String!]\n  ) {\n    searchForm(context: $context) {\n      lodging(propertySearchCriteria: $propertySearchCriteriaInput, features: $features) {\n        __typename\n        ...LodgingSearchFormFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormSelectActionFragment on EGDSSearchFormSelectAction {\n    analytics {\n      linkName\n      referrerId\n    }\n\n    options {\n      label\n      selected\n      value\n    }\n  }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormInputFieldFragment on EGDSSearchFormInputField {\n    egdsElementId\n    value\n    label\n    placeholder\n    leftIcon {\n      ...IconFragment\n    }\n    action {\n      ...EGDSSearchFormSelectActionFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment PackagesSearchFormSelectionFragment on PackagesSearchFormSelection {\n    car {\n      ...EGDSPillFragment\n    }\n    flight {\n      ...EGDSPillFragment\n    }\n    stay {\n      ...EGDSPillFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  query PackagesOptionsQuery(\n    $context: ContextInput!\n    $packageSearchCriteria: PackageSearchCriteriaInput\n    $packageShoppingCriteria: ProductShoppingCriteriaInput\n    $packageType: PackageType\n    $includePackageType: Boolean = false\n  ) {\n    searchForm(context: $context) {\n      packages(packageSearchCriteria: $packageSearchCriteria, packageShoppingCriteria: $packageShoppingCriteria, packageType: $packageType) {\n        __typename\n        ... on PackagesSearchForm {\n          packageSelection @include(if: $includePackageType) {\n            ...PackagesSearchFormSelectionFragment\n          }\n          directFlightsOnly {\n            ...EGDSPillFragment\n          }\n        }\n        elements {\n          ...EGDSSearchFormInputFieldFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSecondaryButtonFragment on UISecondaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormLocationsFieldFragment on EGDSSearchFormLocationsField {\n    egdsElementId\n    origin {\n      ...EGDSSearchFormLocationFieldFragment\n    }\n    destination {\n      ...EGDSSearchFormLocationFieldFragment\n    }\n    horizontalSwapper {\n      ...EGDSSecondaryButtonFragment\n    }\n    verticalSwapper {\n      ...EGDSSecondaryButtonFragment\n    }\n    validations {\n      ... on EGDSInputValidation {\n        errorMessage\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormMessagingSheetFragment on EGDSSheet {\n    closeAccessibility\n    closeAnalytics {\n      referrerId\n      linkName\n    }\n    sheetTypes {\n      ... on EGDSSheetTypePerViewSize {\n        sheetType\n        viewSize\n      }\n    }\n  }\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment MoreInfoTriggerFragment on EGDSMoreInfoTrigger {\n    text\n    icon {\n      ...IconFragment\n    }\n    triggerAction {\n      accessibility\n      text\n      analytics {\n        referrerId\n        linkName\n      }\n      sheet {\n        ...SearchFormMessagingSheetFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormMessagingFragment on SearchFormMessaging {\n    text {\n      template\n      replacementTexts\n    }\n    icon {\n      ...IconFragment\n    }\n    moreInfoTrigger {\n      ...MoreInfoTriggerFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormPartialStayFragment on SearchFormPartialStay {\n    __typename\n    addPartialStay {\n      ...EGDSCheckBoxFragment\n      __typename\n    }\n    dates {\n      ...EGDSSearchFormDatePickerFieldFragment\n      __typename\n    }\n    errorMessage\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  fragment MultiPackagesSearchFormFragment on PackagesSearchForm {\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormLocationsFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n      ...EGDSSearchFormInputFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n    valuePropMessage {\n      ...SearchFormMessagingFragment\n    }\n    directFlightsOnly {\n      ...EGDSPillFragment\n    }\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    partialStay {\n      ...SearchFormPartialStayFragment\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  fragment NoSelectionMessageFragment on UIEmptyState {\n    body\n    heading\n    icon {\n      ...IconFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  fragment PrebundlesSearchFormFragment on PackagesSearchForm {\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  query PackagesSearchFormQuery(\n    $context: ContextInput!\n    $packageSearchCriteria: PackageSearchCriteriaInput\n    $packageShoppingCriteria: ProductShoppingCriteriaInput\n    $includePlayback: Boolean = false\n    $packageType: PackageType\n  ) {\n    searchForm(context: $context) {\n      packages(packageSearchCriteria: $packageSearchCriteria, packageShoppingCriteria: $packageShoppingCriteria, packageType: $packageType) {\n        ...PrebundlesSearchFormFragment\n        ...MultiPackagesSearchFormFragment\n        ... on PackagesSearchForm {\n          packageSelection {\n            noSelectionMessage {\n              ...NoSelectionMessageFragment\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormProductSelectorFragment on SearchFormProductSelector {\n    products {\n      ...SearchFormProductFragment\n    }\n  }\n\n  fragment SearchFormProductFragment on SearchFormProduct {\n    clickAnalytics {\n      linkName\n      referrerId\n    }\n    id\n    label\n    selected\n    type\n    targetURI\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  query ProductSelectorQuery($context: ContextInput!) {\n    searchForm(context: $context) {\n      productSelector {\n        ...SearchFormProductSelectorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  query SearchFormBackgroundImageQuery($context: ContextInput!, $uriContext: UriContextInput!, $contentTopic: String!, $experienceType: String!) {\n    travelExperienceManagerContent(context: $context, uriContext: $uriContext, contentTopic: $contentTopic, experienceType: $experienceType) {\n      editorialComponent {\n        content {\n          ... on EMMediaComponents {\n            items {\n              mediaType {\n                ... on Image {\n                  description\n                  src: url\n                  aspectRatio\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicSelectFragment on EGDSBasicSelect {\n    egdsElementId\n    clickAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      id\n    }\n    label\n    options {\n      label\n      selected\n      value\n    }\n    disabled\n    errorMessage\n    readOnly\n    value\n  }\n\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSelectFragment on EGDSSelect {\n    __typename\n\n    ...EGDSBasicSelectFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  fragment GroundTransportationSearchFormSelectionFragment on GroundTransportationSearchFormSelection {\n    airportToHotel {\n      ...EGDSPillFragment\n      __typename\n    }\n    hotelToAirport {\n      ...EGDSPillFragment\n      __typename\n    }\n    roundTrip {\n      ...EGDSPillFragment\n      __typename\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  fragment GroundTransportationSearchFormFragment on GroundTransportationSearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n      __typename\n    }\n    elements {\n      __typename\n    }\n    dates {\n      ...EGDSSearchFormDatePickerFieldFragment\n      __typename\n    }\n    travelers {\n      ...EGDSSearchFormTravelersFieldFragment\n      __typename\n    }\n    airportLocation {\n      ...EGDSSearchFormLocationFieldFragment\n      __typename\n    }\n    hotelLocation {\n      ...EGDSSearchFormLocationFieldFragment\n      __typename\n    }\n    pickupTime {\n      ...EGDSSelectFragment\n      __typename\n    }\n    dropoffTime {\n      ...EGDSSelectFragment\n      __typename\n    }\n    groundTransportationSelection {\n      ...GroundTransportationSearchFormSelectionFragment\n      __typename\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n      __typename\n    }\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n      __typename\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  query GroundTransportationSearchFormQuery(\n    $context: ContextInput!\n    $groundTransportationSearchCriteria: ProductShoppingCriteriaInput\n    $includePlayback: Boolean = false\n  ) {\n    searchForm(context: $context) {\n      groundTransportation(groundTransportationSearchCriteria: $groundTransportationSearchCriteria) {\n        __typename\n        ...GroundTransportationSearchFormFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextInputFieldFragment on EGDSTextInputField {\n    egdsElementId\n    errorMessage\n    instructions\n    label\n    placeholder\n    readOnly\n    required\n    validations {\n      ... on EGDSRequiredInputValidation {\n        errorMessage\n      }\n    }\n    value\n  }\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  fragment CarSearchFormSpecialOrAdvertisedOptionFragment on CarSearchFormSpecialOrAdvertisedOption {\n    __typename\n    addAnotherDiscountCode {\n      ...EGDSTertiaryButtonFragment\n    }\n    discountCodeType {\n      label\n    }\n    discountCodeOptions {\n      discountCodeInput {\n        ...EGDSTextInputFieldFragment\n      }\n      discountCodeTypeOption\n    }\n    maxDiscountCode\n    optionLabel\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  fragment CarSearchFormDiscountTypeOptionFragment on CarSearchFormDiscountTypeOption {\n    __typename\n    corporateOrContractedOption {\n      discountCode {\n        ...EGDSTextInputFieldFragment\n      }\n      optionLabel\n    }\n    preferredBrand\n    specialOrAdvertisedOption {\n      ...CarSearchFormSpecialOrAdvertisedOptionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  fragment CarSearchFormDiscountCodeFragment on CarSearchFormDiscountCode {\n    __typename\n    discountCode {\n      ...EGDSPillFragment\n    }\n    action {\n      discountType {\n        ...EGDSSelectFragment\n      }\n      discountTypeOptions {\n        ...CarSearchFormDiscountTypeOptionFragment\n      }\n      preferredBrand {\n        ...EGDSSelectFragment\n      }\n      errorSummary {\n        ...EGDSErrorSummaryFragment\n      }\n      toolbar {\n        primary\n        actions {\n          primary {\n            ...EGDSTertiaryButtonFragment\n          }\n          secondaries {\n            icon {\n              description\n            }\n          }\n        }\n      }\n      done {\n        ...EGDSPrimaryButtonFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSNumberInputFieldFragment on EGDSNumberInputField {\n    egdsElementId\n    errorMessage\n    instructions\n    label\n    max\n    min\n    placeholder\n    step\n    readOnly\n    required\n    validations {\n      ... on EGDSInputValidation {\n        errorMessage\n      }\n      ... on EGDSRangeInputValidation {\n        errorMessage\n        min\n        max\n      }\n    }\n    value\n  }\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  fragment CarSearchFormDriverAgeCheckFragment on CarSearchFormDriverAgeCheck {\n    __typename\n    label\n    driverAge {\n      ...EGDSNumberInputFieldFragment\n    }\n    driverAgeRequired {\n      ...EGDSCheckBoxFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  fragment RentalTypesSelectorFrament on EGDSBasicTabs {\n    __typename\n    ...EGDSBasicTabsFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  fragment CarsSearchFormFragment on CarSearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    pickUpLocation {\n      ...EGDSSearchFormLocationFieldFragment\n      validations {\n        __typename\n      }\n    }\n    dropOffLocation {\n      ...EGDSSearchFormLocationFieldFragment\n      validations {\n        __typename\n      }\n    }\n    alternativeDropOffLocationLabel\n    dates {\n      ...EGDSSearchFormDatePickerFieldFragment\n    }\n    pickUpTime {\n      ...EGDSSelectFragment\n    }\n    dropOffTime {\n      ...EGDSSelectFragment\n    }\n    driverAgeCheck {\n      ...CarSearchFormDriverAgeCheckFragment\n    }\n    specialRates {\n      label\n      discountCode {\n        ...CarSearchFormDiscountCodeFragment\n      }\n      showAarpRate {\n        ...EGDSPillFragment\n      }\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n    localDateFormat\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    rentalTypes {\n      ...RentalTypesSelectorFrament\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  query CarSearchFormQuery($context: ContextInput!, $carSearchCriteria: CarSearchCriteriaInput, $includePlayback: Boolean = false) {\n    searchForm(context: $context) {\n      car(carSearchCriteria: $carSearchCriteria) {\n        __typename\n        ...CarsSearchFormFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextInlineContentFragment on EGDSSpannableTextItem {\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSPlainTextFragment\n      ...EGDSStandardLinkFragment\n    }\n    __typename\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  fragment ActivitySearchFormFragment on ActivitySearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n    subTitle {\n      ...EGDSSpannableTextFragment\n    }\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  query ActivitySearchFormQuery($context: ContextInput!, $activitySearchCriteria: ActivitiySearchCriteriaInput, $includePlayback: Boolean = false) {\n    searchForm(context: $context) {\n      activity(activitySearchCriteria: $activitySearchCriteria) {\n        __typename\n        ...ActivitySearchFormFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  fragment DurationSpanSelectorFragment on DurationSpanSelector {\n    egdsElementId\n    title\n    doneButton {\n      __typename\n      ...EGDSPrimaryButtonFragment\n    }\n    closeButton {\n      __typename\n      ...EGDSTertiaryButtonFragment\n    }\n    minDurationSpanLimit {\n      __typename\n      ...DurationSpanLimitFragment\n    }\n    maxDurationSpanLimit {\n      __typename\n      ...DurationSpanLimitFragment\n    }\n    validations {\n      __typename\n      errorMessage\n      ... on DurationSpanInputValidation {\n        errorMessage\n        type\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  fragment DurationSpanLimitFragment on EGDSNumberInputField {\n    egdsElementId\n    label\n    value\n    placeholder\n    errorMessage\n    step\n    min\n    max\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFormDurationSpanFieldFragment on SearchFormDurationSpanField {\n    __typename\n    egdsElementId\n    label\n    labelTemplate {\n      ...TemplateEGDSBasicLocalizedTextFragment\n    }\n    leftIcon {\n      id\n    }\n    action {\n      __typename\n      ...OpenDurationSpanActionFragment\n    }\n  }\n\n  fragment TemplateEGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    __typename\n    egdsElementId\n    models {\n      key\n      source\n    }\n    template\n    text\n  }\n\n  fragment OpenDurationSpanActionFragment on OpenDurationSpanAction {\n    __typename\n    analytics {\n      __typename\n      linkName\n      referrerId\n    }\n    durationSpan {\n      __typename\n      ...DurationSpanSelectorFragment\n    }\n    accessibility\n  }\n\n  ",
        "\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  fragment CruiseSearchFormFragment on CruiseSearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...SearchFormDurationSpanFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    typeaheadAdapterDetails {\n      domainId\n      adapterRequest {\n        includeMetadata\n      }\n      categoryDetails {\n        key\n        value\n      }\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n    expertAdviceInfo @skip(if: $skipExpertAdviceInfo)\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  query CruiseSearchFormQuery(\n    $context: ContextInput!\n    $cruiseSearchCriteriaInput: CruiseSearchCriteriaInput\n    $includePlayback: Boolean = false\n    $skipExpertAdviceInfo: Boolean = false\n  ) {\n    searchForm(context: $context) {\n      cruise(cruiseSearchCriteria: $cruiseSearchCriteriaInput) {\n        __typename\n        ...CruiseSearchFormFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  fragment FlightTypeSelectorOptionsFragment on EGDSSearchFormSelectAction {\n    analytics {\n      linkName\n      referrerId\n    }\n    options {\n      ...FlightTypeSelectorOptionFragment\n    }\n    apply {\n      ...EGDSPrimaryButtonFragment\n    }\n  }\n\n  fragment FlightTypeSelectorOptionFragment on EGDSBasicOption {\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n    value\n    label\n    selected\n  }\n\n  ",
        "\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  query FlightOptionsQuery($context: ContextInput!, $flightSearchCriteria: FlightSearchCriteriaInput, $includeFlightType: Boolean = false) {\n    searchForm(context: $context) {\n      flight(flightSearchCriteria: $flightSearchCriteria) {\n        ...FlightsOptionsSearchFormFragment\n      }\n    }\n  }\n\n  fragment FlightsOptionsSearchFormFragment on FlightSearchForm {\n    flightTypeSelector @include(if: $includeFlightType) {\n      action {\n        ... on EGDSSearchFormSelectAction {\n          ...FlightTypeSelectorOptionsFragment\n        }\n      }\n    }\n\n    elements {\n      ...EGDSSearchFormInputFieldFragment\n    }\n\n    directFlightsOnly {\n      ...EGDSPillFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  fragment FlightSearchFormFragment on FlightSearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n    addLeg {\n      ...EGDSTertiaryButtonFragment\n    }\n    removeLeg {\n      ...EGDSTertiaryButtonFragment\n    }\n    legHeading {\n      ...EGDSBasicLocalizedTextFragment\n    }\n    legs {\n      id\n      locations {\n        ...EGDSSearchFormLocationsFieldFragment\n      }\n      date {\n        ...EGDSSearchFormDatePickerFieldFragment\n      }\n    }\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    maxAllowedLegs\n    localDateFormat\n\n    softPackages {\n      ...SoftPackagesFragment\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  query FlightSearchFormQuery(\n    $context: ContextInput!\n    $flightSearchCriteria: FlightSearchCriteriaInput\n    $fixedTravelers: Boolean\n    $includePlayback: Boolean = false\n    $disabledCabins: [FlightsCabinClass!]\n    $features: [String!]\n  ) {\n    searchForm(context: $context) {\n      flight(flightSearchCriteria: $flightSearchCriteria, fixedTravelers: $fixedTravelers, disabledCabins: $disabledCabins, features: $features) {\n        ...FlightSearchFormFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __commonJS = function(cb, mod) {
    return function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __publicField = function(obj, key, value) {
    __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// ../../../../node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js
var require_lodash = __commonJS({
    "../../../../node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js": function(exports, module) {
        var FUNC_ERROR_TEXT = "Expected a function";
        var NAN = 0 / 0;
        var symbolTag = "[object Symbol]";
        var reTrim = /^\s+|\s+$/g;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsOctal = /^0o[0-7]+$/i;
        var freeParseInt = parseInt;
        var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
        var freeSelf = typeof self == "object" && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function("return this")();
        var objectProto = Object.prototype;
        var objectToString = objectProto.toString;
        var nativeMax = Math.max;
        var nativeMin = Math.min;
        var now = function now() {
            return root.Date.now();
        };
        function debounce3(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = void 0;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                lastInvokeTime = time;
                timerId = setTimeout(timerExpired, wait);
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
                return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) {
                    return trailingEdge(time);
                }
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = void 0;
                if (trailing && lastArgs) {
                    return invokeFunc(time);
                }
                lastArgs = lastThis = void 0;
                return result;
            }
            function cancel() {
                if (timerId !== void 0) {
                    clearTimeout(timerId);
                }
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = void 0;
            }
            function flush() {
                return timerId === void 0 ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === void 0) {
                        return leadingEdge(lastCallTime);
                    }
                    if (maxing) {
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === void 0) {
                    timerId = setTimeout(timerExpired, wait);
                }
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : _type_of(value);
            return !!value && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
            return !!value && typeof value == "object";
        }
        function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : _type_of(value)) == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        function toNumber(value) {
            if (typeof value == "number") {
                return value;
            }
            if (isSymbol(value)) {
                return NAN;
            }
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") {
                return value === 0 ? value : +value;
            }
            value = value.replace(reTrim, "");
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        module.exports = debounce3;
    }
});
// src/components/multi-product-search-form/multi-product-search-form.tsx
import React94 from "react";
import { SearchFormReflectionProvider as SearchFormReflectionProvider3 } from "@shared-ui/retail-search-tools-reflection-provider";
// ../internal/src/components/form/sticky-search-form.tsx
import React from "react";
import { ViewRow } from "@egds/react-search-experience";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkSticky } from "uitk-react-sticky";
import { UitkToolbar } from "uitk-react-toolbar";
var StickySearchForm = function(props) {
    var _React_useState = _sliced_to_array(React.useState(false), 2), sticky = _React_useState[0], setSticky = _React_useState[1];
    var children = props.children;
    return /* @__PURE__ */ React.createElement(UitkSticky, {
        zIndex: 500,
        onFixed: function(isFixed) {
            setSticky(isFixed);
        }
    }, /* @__PURE__ */ React.createElement(UitkToolbar, {
        elevation: sticky ? "floating" : "default",
        toolbarType: sticky ? "standard" : "transparent"
    }, /* @__PURE__ */ React.createElement(ViewRow, {
        layout: "fullwidth",
        canvasTheme: sticky ? "primary" : "none",
        paddedViewRow: false
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            block: "four",
            inline: "three"
        }
    }, /* @__PURE__ */ React.createElement("div", {
        "data-stid": "sticky-search-form"
    }, children)))), !sticky && /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "six"
    }, /* @__PURE__ */ React.createElement("div", null)));
};
// src/components/multi-product-search-form/multi-product-search-form.tsx
import { ViewMedium as ViewMedium19, Viewport as Viewport22, ViewSmall as ViewSmall20 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing27 } from "uitk-react-spacing";
// src/__generated__/types.ts
var ClosedPeriodBounding = /* @__PURE__ */ function(ClosedPeriodBounding2) {
    ClosedPeriodBounding2["LOWER"] = "LOWER";
    ClosedPeriodBounding2["UPPER"] = "UPPER";
    return ClosedPeriodBounding2;
}(ClosedPeriodBounding || {});
var DatePeriodUnit = /* @__PURE__ */ function(DatePeriodUnit2) {
    DatePeriodUnit2["DAY"] = "DAY";
    DatePeriodUnit2["MONTH"] = "MONTH";
    DatePeriodUnit2["WEEK"] = "WEEK";
    DatePeriodUnit2["WEEKEND"] = "WEEKEND";
    return DatePeriodUnit2;
}(DatePeriodUnit || {});
var FlightsCabinClass = /* @__PURE__ */ function(FlightsCabinClass4) {
    FlightsCabinClass4["BUSINESS"] = "BUSINESS";
    FlightsCabinClass4["COACH"] = "COACH";
    FlightsCabinClass4["FIRST"] = "FIRST";
    FlightsCabinClass4["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
    return FlightsCabinClass4;
}(FlightsCabinClass || {});
var FlightsTripType = /* @__PURE__ */ function(FlightsTripType4) {
    FlightsTripType4["MULTI_DESTINATION"] = "MULTI_DESTINATION";
    FlightsTripType4["ONE_WAY"] = "ONE_WAY";
    FlightsTripType4["ROUND_TRIP"] = "ROUND_TRIP";
    return FlightsTripType4;
}(FlightsTripType || {});
var GroundTransfersDirection = /* @__PURE__ */ function(GroundTransfersDirection2) {
    GroundTransfersDirection2["FROM_AIRPORT"] = "FROM_AIRPORT";
    GroundTransfersDirection2["ROUNDTRIP"] = "ROUNDTRIP";
    GroundTransfersDirection2["TO_AIRPORT"] = "TO_AIRPORT";
    return GroundTransfersDirection2;
}(GroundTransfersDirection || {});
var PackageType = /* @__PURE__ */ function(PackageType2) {
    PackageType2["FLIGHT_CAR"] = "FLIGHT_CAR";
    PackageType2["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
    PackageType2["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
    PackageType2["HOTEL_ACTIVITY"] = "HOTEL_ACTIVITY";
    PackageType2["HOTEL_CAR"] = "HOTEL_CAR";
    return PackageType2;
}(PackageType || {});
var SearchFormProductType = /* @__PURE__ */ function(SearchFormProductType2) {
    SearchFormProductType2["ACTIVITIES"] = "ACTIVITIES";
    SearchFormProductType2["CARS"] = "CARS";
    SearchFormProductType2["CRUISES"] = "CRUISES";
    SearchFormProductType2["FLIGHTS"] = "FLIGHTS";
    SearchFormProductType2["LODGING"] = "LODGING";
    SearchFormProductType2["PACKAGES"] = "PACKAGES";
    return SearchFormProductType2;
}(SearchFormProductType || {});
var TravelerDetailsType = /* @__PURE__ */ function(TravelerDetailsType2) {
    TravelerDetailsType2["ADULT"] = "ADULT";
    TravelerDetailsType2["CHILD"] = "CHILD";
    TravelerDetailsType2["INFANT_IN_LAP"] = "INFANT_IN_LAP";
    TravelerDetailsType2["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
    return TravelerDetailsType2;
}(TravelerDetailsType || {});
// src/components/lodging/form/search-form.tsx
import React74 from "react";
import { gql as gql52, useQuery } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
import { SearchFormReflectionProvider } from "@shared-ui/retail-search-tools-reflection-provider";
// ../internal/src/components/common/fallback-indicator-wrapper.tsx
import React2 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSSpacing } from "@egds/react-core/spacing";
var developmentHostNames = [
    "localhost",
    "wwwexpediacom",
    "shared-ui.expedia.biz"
];
var FallbackIndicatorWrapper = function(props) {
    var children = props.children;
    var isDevelopment = developmentHostNames.includes(window.location.hostname);
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, isDevelopment && /* @__PURE__ */ React2.createElement(EGDSSpacing, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React2.createElement(EGDSBadgeStandard, {
        theme: "warning",
        text: "Fallback is in use"
    }, /* @__PURE__ */ React2.createElement(EGDSIcon, {
        size: EGDSIconSize.MEDIUM,
        name: "warning"
    }))), children);
};
FallbackIndicatorWrapper.displayName = "FallbackBadge";
// ../internal/src/components/form/form-skeleton.tsx
import React3 from "react";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var FormSkeleton = function(param) {
    var rows = param.rows;
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, rows.map(function(param, index) {
        var type = param.type;
        return /* @__PURE__ */ React3.createElement(UitkSpacing2, {
            key: index,
            padding: index === 0 ? void 0 : {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkLineSkeleton, {
            animation: true,
            type: type
        })));
    }));
};
// ../internal/src/utils/search-form-options.ts
var SearchFormLayout = /* @__PURE__ */ function(SearchFormLayout2) {
    SearchFormLayout2["IN_LINE"] = "IN_LINE";
    SearchFormLayout2["STACKED"] = "STACKED";
    return SearchFormLayout2;
}(SearchFormLayout || {});
// src/components/lodging/form/search-form.tsx
import { ViewMedium as ViewMedium10, Viewport as Viewport13, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
// ../internal/src/utils/search-location-fallback-data.ts
var searchLocationFallback = {
    __typename: "SearchLocation",
    analytics: {
        __typename: "SearchLocationAnalytics",
        open: '{"metadata":{"packer_version":"1.0.1"},"events":{"search_location.opened":{"v1":{"event_data":{"event":{"event_name":"search_location.opened","event_version":"1.0.0","event_category":"Search","event_type":"Interaction"}}}}}}',
        close: '{"metadata":{"packer_version":"1.0.1"},"events":{"search_location.closed":{"v1":{"event_data":{"event":{"event_name":"search_location.closed","event_version":"1.0.0","event_category":"Search","event_type":"Interaction"}}}}}}',
        itemSelected: '{"metadata":{"packer_version":"1.0.1"},"events":{"search_location.selected":{"v1":{"event_data":{"event":{"event_name":"search_location.selected","event_version":"1.0.0","event_category":"Search","event_type":"Interaction"}}}}}}',
        recommendationsPresented: '{"metadata":{"packer_version":"1.0.1"},"events":{"recommendations_module.presented":{"v2":{"event_data":{"event":{"event_name":"recommendations_module.presented","event_version":"2.1.0","event_category":"Search","event_type":"Impression"}}}}}}',
        recommendationSelected: '{"metadata":{"packer_version":"1.0.1"},"events":{"recommendations_module.selected":{"v2":{"event_data":{"event":{"event_name":"recommendations_module.selected","event_version":"2.1.0","event_category":"Search","event_type":"Interaction"}}}}}}'
    }
};
// src/components/lodging/utils/fallback-form-data.ts
var errorSummary = {
    egdsElementId: "search_form_error_summary",
    goToErrorLinkText: "Go to the error",
    goToFirstErrorLinkText: "Go to the first error",
    heading: "",
    body: null,
    analytics: {
        linkName: "Error summary link clicked on search form",
        referrerId: "Web.Hotels.Search.Error.Summary",
        __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
        linkName: "Error summary displayed on search form",
        referrerId: "Web.Hotels.Search.Error.Summary.Displayed",
        __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
        models: [
            {
                key: "errorCount",
                source: "errorCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "To continue, please correct the error below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            }
        ],
        __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
};
var destination = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "destination_form_field",
    label: "Going to",
    placeholder: "Going to",
    value: null,
    errorMessage: "Please select a destination",
    validations: [
        {
            errorMessage: "Please select a destination",
            __typename: "EGDSRequiredInputValidation"
        },
        {
            errorMessage: "Please make sure your departure and arrival cities are different",
            __typename: "EGDSSameValueInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    closeAnalytics: {
        linkName: "Location selection",
        referrerId: "Web.Hotels.Location.Open",
        __typename: "ClientSideAnalytics"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Location selection",
            referrerId: "Web.Hotels.Location.Open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "Homepage",
            drivable: true,
            isDestination: true,
            lineOfBusiness: "HOTELS",
            maxNumberOfResults: 8,
            packageType: null,
            personalize: true,
            regionType: 2047,
            typeaheadFeatures: "ta_hierarchy|postal_code|google|consistent_display",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: null,
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "Search by destination, accommodations, or landmark",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    multiLocations: null,
    changeAnalytics: null,
    regionId: null,
    debounceRate: null
};
var today = /* @__PURE__ */ new Date();
var startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14);
var endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);
var startDatePickerMonthValue = startDate.getMonth() + 1;
var endDatePickerMonthValue = endDate.getMonth() + 1;
var datePicker = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date_form_field",
    label: "Dates",
    placeholder: "Dates",
    errorMessage: "Check-out date must be after check-in date",
    validations: [
        {
            errorMessage: "Check out date must be within 29 days of check in date",
            __typename: "EGDSMaxLengthInputValidation"
        },
        {
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    action: {
        accessibility: null,
        analytics: {
            linkName: "Calendar selection",
            referrerId: "Web.Hotels.Calendar.Open",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            flexibleDateContent: null,
            nextButtonAnalytics: null,
            previousButtonAnalytics: null,
            buttonText: "Done",
            clearButtonText: "Clear dates",
            firstDayOfWeek: "SUN" /* SUN */ ,
            maxNumberOfDaysSelected: 29,
            sameDaySelectionAllowed: false,
            selectedStartDate: {
                day: startDate.getDate(),
                month: startDatePickerMonthValue,
                year: startDate.getFullYear(),
                __typename: "Date"
            },
            startDatePlaceholderText: "Check-in",
            selectedEndDate: {
                day: endDate.getDate(),
                month: endDatePickerMonthValue,
                year: endDate.getFullYear(),
                __typename: "Date"
            },
            endDatePlaceholderText: "Check-out",
            validDaysLowerBoundInclusive: {
                day: today.getDate(),
                month: today.getMonth(),
                year: today.getFullYear(),
                __typename: "Date"
            },
            validDaysUpperBoundInclusive: {
                day: today.getDate(),
                month: today.getMonth() + 4,
                year: today.getFullYear() + 1,
                __typename: "Date"
            },
            submitButtonAnalytics: {
                __typename: "ClientSideAnalytics",
                referrerId: "date picker submit",
                linkName: "date.picker.submit"
            },
            startDateButtonAnalytics: {
                __typename: "ClientSideAnalytics",
                linkName: "date picker start date",
                referrerId: "date.picker.start.date"
            },
            endDateButtonAnalytics: {
                __typename: "ClientSideAnalytics",
                linkName: "date picker end date",
                referrerId: "date.picker.end.date"
            },
            showClearDatesButton: false,
            buttonTextTemplate: null,
            clearDatesButtonAnalytics: null,
            __typename: "EGDSDateRangePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var travelerSelector = {
    __typename: "EGDSSearchFormTravelersField",
    readOnly: false,
    action: {
        analytics: {
            linkName: "Guests selection",
            referrerId: "Web.Hotels.Traveler.GuestPicker.Open",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            addAnotherRoomButton: {
                egdsElementId: "traveler_selector_add_room",
                primary: "Add another room",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: null,
                action: null,
                __typename: "UITertiaryButton"
            },
            closeButton: {
                egdsElementId: "traveler_selector_close_button",
                primary: null,
                disabled: false,
                accessibility: null,
                icon: {
                    id: "close",
                    description: "close",
                    token: "icon__close",
                    title: "",
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Travelers results not updated",
                    referrerId: "Web.Hotels.Traveler.Close",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            doneButton: {
                egdsElementId: "traveler_selector_done_button",
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers results updated",
                    referrerId: "Web.Hotels.Traveler.Done",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            maxRoomCount: 8,
            rooms: [
                {
                    label: {
                        models: [
                            {
                                key: "roomNumber",
                                source: "roomNumber",
                                __typename: "TemplateModel"
                            }
                        ],
                        template: "Room ${roomNumber}",
                        __typename: "EGDSBasicLocalizedText"
                    },
                    adults: {
                        decreaseAnalytics: {
                            linkName: "Adult traveler removed",
                            referrerId: "Web.Hotels.Traveler.Remove.Adult",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Adult traveler added",
                            referrerId: "Web.Hotels.Traveler.Add.Adult",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of adults",
                        decreaseTextTemplate: {
                            models: [
                                {
                                    key: "roomNumber",
                                    source: "roomNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Decrease the number of adults in room ${roomNumber}",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        increaseText: "Increase the number of adults",
                        increaseTextTemplate: {
                            models: [
                                {
                                    key: "roomNumber",
                                    source: "roomNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Increase the number of adults in room ${roomNumber}",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        egdsElementId: "traveler_selector_adult_step_input",
                        __typename: "EGDSTravelerStepInput",
                        label: "Adults",
                        max: 14,
                        min: 1,
                        step: 1,
                        subLabel: null,
                        value: 2
                    },
                    children: {
                        count: {
                            decreaseAnalytics: {
                                linkName: "Child traveler removed",
                                referrerId: "Web.Hotels.Traveler.Remove.Child",
                                __typename: "ClientSideAnalytics"
                            },
                            increaseAnalytics: {
                                linkName: "Child traveler added",
                                referrerId: "Web.Hotels.Traveler.Add.Child",
                                __typename: "ClientSideAnalytics"
                            },
                            decreaseText: "Decrease the number of children",
                            decreaseTextTemplate: {
                                models: [
                                    {
                                        key: "roomNumber",
                                        source: "roomNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Decrease the number of children in room ${roomNumber}",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            increaseText: "Increase the number of children",
                            increaseTextTemplate: {
                                models: [
                                    {
                                        key: "roomNumber",
                                        source: "roomNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Increase the number of children in room ${roomNumber}",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            egdsElementId: "traveler_selector_children_step_input",
                            __typename: "EGDSTravelerStepInput",
                            label: "Children",
                            max: 6,
                            min: 0,
                            step: 1,
                            subLabel: "Ages 0 to 17",
                            value: 0
                        },
                        ages: [],
                        ageTemplate: {
                            labelTemplate: {
                                models: [
                                    {
                                        key: "childNumber",
                                        source: "childNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Child ${childNumber} age",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            options: [
                                {
                                    changeAnalytics: null,
                                    label: "Select age",
                                    value: "",
                                    egdsElementId: "children_age_option",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "Under 1",
                                    value: "0",
                                    egdsElementId: "children_age_option_0",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "1",
                                    value: "1",
                                    egdsElementId: "children_age_option_1",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "2",
                                    value: "2",
                                    egdsElementId: "children_age_option_2",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "3",
                                    value: "3",
                                    egdsElementId: "children_age_option_3",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "4",
                                    value: "4",
                                    egdsElementId: "children_age_option_4",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "5",
                                    value: "5",
                                    egdsElementId: "children_age_option_5",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "6",
                                    value: "6",
                                    egdsElementId: "children_age_option_6",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "7",
                                    value: "7",
                                    egdsElementId: "children_age_option_7",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "8",
                                    value: "8",
                                    egdsElementId: "children_age_option_8",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "9",
                                    value: "9",
                                    egdsElementId: "children_age_option_9",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "10",
                                    value: "10",
                                    egdsElementId: "children_age_option_10",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "11",
                                    value: "11",
                                    egdsElementId: "children_age_option_11",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "12",
                                    value: "12",
                                    egdsElementId: "children_age_option_12",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "13",
                                    value: "13",
                                    egdsElementId: "children_age_option_13",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "14",
                                    value: "14",
                                    egdsElementId: "children_age_option_14",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "15",
                                    value: "15",
                                    egdsElementId: "children_age_option_15",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "16",
                                    value: "16",
                                    egdsElementId: "children_age_option_16",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "17",
                                    value: "17",
                                    egdsElementId: "children_age_option_17",
                                    __typename: "EGDSBasicOption"
                                }
                            ],
                            egdsElementId: "traveler_selector_children_age_selector",
                            value: null,
                            __typename: "EGDSTravelerChildAgeSelect"
                        },
                        __typename: "EGDSTravelerChildren"
                    },
                    infants: null,
                    removeRoomButton: {
                        egdsElementId: "traveler_selector_remove_room",
                        primary: "Remove room",
                        disabled: false,
                        accessibility: null,
                        icon: null,
                        analytics: null,
                        action: null,
                        __typename: "UITertiaryButton"
                    },
                    removeRoomAnnouncement: "Room removed",
                    __typename: "EGDSTravelerSelectorRoom"
                }
            ],
            infantSeatSelection: null,
            title: "Travelers",
            validations: [
                {
                    errorMessage: "We allow up to 20 travelers per booking.",
                    maxCount: 20,
                    type: "MAX_TRAVELERS" /* MAX_TRAVELERS */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "We allow up to 20 travelers per booking.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed on travelers",
                            referrerId: "Web.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                },
                {
                    errorMessage: "Provide the age of the child.",
                    maxCount: null,
                    type: "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: "Go to the error",
                        goToFirstErrorLinkText: "Go to the first error",
                        heading: "",
                        body: null,
                        analytics: {
                            linkName: "Error summary link clicked on travelers",
                            referrerId: "Web.Hotels.Traveler.Error.Summary",
                            __typename: "ClientSideAnalytics"
                        },
                        impressionAnalytics: {
                            linkName: "Error summary displayed on travelers",
                            referrerId: "Web.Hotels.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: {
                            models: [
                                {
                                    key: "errorCount",
                                    source: "errorCount",
                                    __typename: "TemplateModel"
                                }
                            ],
                            templates: [
                                {
                                    category: "ZERO" /* ZERO */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "ONE" /* ONE */ ,
                                    template: "To continue, please correct the error below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "TWO" /* TWO */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "FEW" /* FEW */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "MANY" /* MANY */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "OTHER" /* OTHER */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                }
                            ],
                            __typename: "EGDSCardinalLocalizedText"
                        },
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                }
            ],
            __typename: "EGDSRoomsTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "rooms",
                models: {
                    models: [
                        {
                            key: "roomCount",
                            source: "roomCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: [
                        {
                            category: "ZERO" /* ZERO */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "ONE" /* ONE */ ,
                            template: "${roomCount} room",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "TWO" /* TWO */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "FEW" /* FEW */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "MANY" /* MANY */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "OTHER" /* OTHER */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        }
                    ],
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            },
            {
                key: "travelers",
                models: {
                    models: [
                        {
                            key: "travelerCount",
                            source: "travelerCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: [
                        {
                            category: "ZERO" /* ZERO */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "ONE" /* ONE */ ,
                            template: "${travelerCount} traveler",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "TWO" /* TWO */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "FEW" /* FEW */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "MANY" /* MANY */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "OTHER" /* OTHER */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        }
                    ],
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            }
        ],
        template: "${travelers}, ${rooms}",
        text: "2 travelers, 1 room",
        __typename: "EGDSCompositeLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    }
};
var search = {
    egdsElementId: "submit_button",
    primary: "Search",
    disabled: false,
    accessibility: null,
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.Hotels.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var getFallbackFormData = function() {
    return {
        __typename: "LodgingSearchForm",
        egdsElementId: "lodging_search_form",
        actionURL: "/Hotel-Search",
        errorSummary: errorSummary,
        elements: [
            destination,
            datePicker,
            travelerSelector
        ],
        search: search,
        searchLocation: searchLocationFallback,
        playback: null,
        softPackages: null,
        adaptExSuccessEvent: null,
        popularFilters: null
    };
};
// src/components/lodging/form/__private/lodging-search-form.tsx
import React73 from "react";
import { gql as gql51 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { useLocalization as useLocalization11 } from "@shared-ui/localization-context";
// ../internal/src/components/common/egds-error-summary.tsx
import React4 from "react";
import { gql } from "@apollo/client";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/format-localized-token-string.ts
function formatLocalizedTokenString(localizedString, token, value) {
    return localizedString.replace("${".concat(token, "}"), value);
}
// ../internal/src/components/common/egds-error-summary.tsx
var __Fragment = gql(_templateObject());
var EGDSErrorSummary = function(param) {
    var _param_errorCount = param.errorCount, errorCount = _param_errorCount === void 0 ? 0 : _param_errorCount, inputErrorRef = param.inputErrorRef, data = param.data;
    var clickTracker = useClickTracker();
    var body = data.body, goToErrorLinkText = data.goToErrorLinkText, goToFirstErrorLinkText = data.goToFirstErrorLinkText, heading = data.heading, analytics = data.analytics, impressionAnalytics = data.impressionAnalytics, headingTemplate = data.headingTemplate;
    var hasNoErrors = errorCount === 0;
    var hasOneError = errorCount === 1;
    var linkRef = React4.createRef();
    React4.useEffect(function() {
        var _linkRef_current;
        liveAnnounce(headingText, Level.ASSERTIVE);
        (_linkRef_current = linkRef.current) === null || _linkRef_current === void 0 ? void 0 : _linkRef_current.focus();
    }, []);
    if (hasNoErrors) {
        return null;
    }
    var getLocalizedErrorHeading = function(errors) {
        if ((headingTemplate === null || headingTemplate === void 0 ? void 0 : headingTemplate.__typename) === "EGDSCardinalLocalizedText") {
            var headingTemplates = headingTemplate.templates.slice(1, 3);
            var key = hasOneError ? "" : headingTemplate.models[0].key;
            var template = hasOneError ? headingTemplates[0].template : headingTemplates[1].template;
            return formatLocalizedTokenString(template, key, errors.toString());
        }
        return "";
    };
    var linkText = hasOneError ? goToErrorLinkText : goToFirstErrorLinkText;
    var headingText = heading.trim() ? heading : getLocalizedErrorHeading(errorCount);
    var handleClick = function() {
        var _inputErrorRef_current;
        inputErrorRef === null || inputErrorRef === void 0 ? void 0 : (_inputErrorRef_current = inputErrorRef.current) === null || _inputErrorRef_current === void 0 ? void 0 : _inputErrorRef_current.focus();
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            var id = hasOneError ? "".concat(referrerId, ".One.Error") : "".concat(referrerId, ".Many.Errors");
            clickTracker(id, linkName);
        }
    };
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React4.createElement(IntersectionTracker, {
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, /* @__PURE__ */ React4.createElement(EGDSBanner, {
        theme: "error"
    }, /* @__PURE__ */ React4.createElement(EGDSHeading, {
        size: 7,
        "aria-level": 3
    }, headingText), body && /* @__PURE__ */ React4.createElement(EGDSText, {
        size: 300
    }, body.text), linkText && /* @__PURE__ */ React4.createElement(EGDSLink, {
        domRef: linkRef
    }, /* @__PURE__ */ React4.createElement("button", {
        type: "button",
        onClick: handleClick
    }, linkText))));
};
EGDSErrorSummary.displayName = "EGDSErrorSummaryFragment";
EGDSErrorSummary.fragment = __Fragment;
// ../internal/src/components/form/egds-search-form-button.tsx
import React5 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkButtonSize, UitkPrimaryButton } from "@egds/react-core/button";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkIcon } from "uitk-react-icons";
// ../internal/src/components/common/button/egds-button-fragment.ts
import { gql as gql2 } from "@apollo/client";
var EGDSButtonFragment = gql2(_templateObject1());
// ../internal/src/components/form/egds-search-form-button.tsx
var __Fragment2 = gql3(_templateObject2(), EGDSButtonFragment);
var Button = function(param) {
    var children = param.children, submitButtonProps = param.submitButtonProps, primary = param.primary, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth;
    return /* @__PURE__ */ React5.createElement(UitkPrimaryButton, _object_spread_props(_object_spread({}, submitButtonProps), {
        size: UitkButtonSize.LARGE,
        "aria-label": primary !== null && primary !== void 0 ? primary : "",
        isFullWidth: isFullWidth
    }), children);
};
var EGDSSearchFormButton = function(param) {
    var data = param.data;
    var track = useClickTracker2();
    var egdsElementId = data.egdsElementId, primary = data.primary, disabled = data.disabled, action = data.onClick, icon = data.icon;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_submit_button";
    var handleClick = React5.useCallback(function() {
        if (action && action.__typename === "EGDSSubmitSearchFormAction") {
            var _action_analytics = action.analytics, referrerId = _action_analytics.referrerId, linkName = _action_analytics.linkName;
            track(referrerId, linkName);
        }
    }, [
        action,
        track
    ]);
    var submitButtonProps = {
        id: id,
        disabled: disabled,
        onClick: handleClick,
        type: "submit"
    };
    var _icon_token, _icon_title;
    return /* @__PURE__ */ React5.createElement(Viewport, null, /* @__PURE__ */ React5.createElement(ViewSmall, null, /* @__PURE__ */ React5.createElement(Button, {
        isFullWidth: true,
        submitButtonProps: submitButtonProps,
        primary: primary
    }, primary)), /* @__PURE__ */ React5.createElement(ViewMedium, null, icon ? /* @__PURE__ */ React5.createElement(Button, {
        submitButtonProps: submitButtonProps,
        primary: primary
    }, /* @__PURE__ */ React5.createElement(UitkIcon, {
        name: (_icon_token = icon === null || icon === void 0 ? void 0 : icon.token) !== null && _icon_token !== void 0 ? _icon_token : "search",
        title: (_icon_title = icon === null || icon === void 0 ? void 0 : icon.title) !== null && _icon_title !== void 0 ? _icon_title : "",
        id: icon === null || icon === void 0 ? void 0 : icon.id
    })) : /* @__PURE__ */ React5.createElement(Button, {
        submitButtonProps: submitButtonProps,
        primary: primary
    }, primary)));
};
EGDSSearchFormButton.displayName = "EGDSSearchFormButton";
EGDSSearchFormButton.fragment = __Fragment2;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-search-form-date-picker-field.tsx
import React34 from "react";
import { gql as gql29 } from "@apollo/client";
// ../internal/src/utils/search-form-date-selector.ts
import React6 from "react";
var dialogIdCounter = 0;
function useUniqueDialogId() {
    var dialogName = /* @__PURE__ */ new Date().getTime();
    var uniqueId = dialogIdCounter;
    dialogIdCounter += 1;
    var dialogIdRef = React6.useRef("".concat(dialogName, "-").concat(uniqueId));
    return dialogIdRef.current;
}
var search_form_date_selector_default = useUniqueDialogId;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range-picker.tsx
import React32 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewMedium as ViewMedium3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector.tsx
import React25 from "react";
import { useLazyQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
import { UitkDateSelector } from "uitk-react-date-selector";
import { useFormCallback as useFormCallback3 } from "uitk-react-form";
// ../internal/src/utils/search-form-playback-dates.ts
var getFormattedDates = function(value, localizationContext, dateTimes) {
    var formatDateString = localizationContext.formatDateString;
    var _value_split = _sliced_to_array(value.split(" - "), 2), startDate5 = _value_split[0], endDate5 = _value_split[1];
    if (startDate5 === "" || endDate5 === "") {
        return "";
    }
    var updatedStartDate = formatDateString(startDate5, {
        skeleton: "MMMd"
    });
    var updatedEndDate = formatDateString(endDate5, {
        skeleton: "MMMd"
    });
    if ((dateTimes === null || dateTimes === void 0 ? void 0 : dateTimes.start) && (dateTimes === null || dateTimes === void 0 ? void 0 : dateTimes.end)) {
        return "".concat(updatedStartDate, ", ").concat(dateTimes.start, " - ").concat(updatedEndDate, ", ").concat(dateTimes.end);
    }
    return "".concat(updatedStartDate, " - ").concat(updatedEndDate);
};
var getSingleReplaceFormattedDates = function(value, prevValue, isStartDate, localizationContext) {
    var formatDateString = localizationContext.formatDateString;
    var _prevValue_split = _sliced_to_array(prevValue.split(" - "), 2), prevStartDate = _prevValue_split[0], prevEndDate = _prevValue_split[1];
    var startDate5 = isStartDate ? formatDateString(value, {
        skeleton: "MMMd"
    }) : prevStartDate;
    var endDate5 = isStartDate ? prevEndDate : formatDateString(value, {
        skeleton: "MMMd"
    });
    if (startDate5 === "Invalid date" || endDate5 === "Invalid date") {
        return "";
    }
    return "".concat(startDate5, " - ").concat(endDate5);
};
// ../internal/src/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function(value, handler, inputType) {
    var event = new CustomEvent("change");
    var input = document.createElement("input");
    if (inputType) {
        input.type = inputType;
    }
    input.value = value;
    var changeListener = function(inputEvent) {
        handler(inputEvent);
    };
    input.addEventListener("change", changeListener);
    input.dispatchEvent(event);
    input.removeEventListener("change", changeListener);
};
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector-day-template.tsx
import React7 from "react";
import { UitkDateNumber } from "uitk-react-calendar";
// ../internal/src/components/form/egds-search-form-date-picker-field/helpers.tsx
import { DayName } from "@egds/react-core/date-picker";
// ../internal/src/utils/search-form-plural-category.tsx
var getPluralCategory = function(value) {
    if (value === 0) {
        return "ZERO" /* ZERO */ ;
    }
    if (value === 1) {
        return "ONE" /* ONE */ ;
    }
    if (value === 2) {
        return "TWO" /* TWO */ ;
    }
    if (value > 2 && value < 5) {
        return "FEW" /* FEW */ ;
    }
    if (value >= 5 && value < 10) {
        return "MANY" /* MANY */ ;
    }
    return "OTHER" /* OTHER */ ;
};
// ../internal/src/components/form/egds-search-form-date-picker-field/helpers.tsx
var TO_DAY_MULTIPLIER = 1e3 * 60 * 60 * 24;
var addMaxDateToToday = function(daysInAdvance) {
    var today5 = /* @__PURE__ */ new Date();
    var daysInAdvanceInMiliseconds = daysInAdvance * TO_DAY_MULTIPLIER;
    var todayPlusDaysInAdvance = new Date(today5.getTime() + daysInAdvanceInMiliseconds);
    return todayPlusDaysInAdvance;
};
var convertFromMiliSecondsToDays = function(miliseconds) {
    return Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
};
var convertToDateObject = function(param) {
    var year = param.year, month = param.month, day = param.day;
    return new Date(year, month - 1, day);
};
var _obj;
var EGDSDayNameMap = (_obj = {}, _define_property(_obj, "SUN" /* SUN */ , DayName.SUN), _define_property(_obj, "MON" /* MON */ , DayName.MON), _define_property(_obj, "TUE" /* TUE */ , DayName.TUE), _define_property(_obj, "WED" /* WED */ , DayName.WED), _define_property(_obj, "THU" /* THU */ , DayName.THU), _define_property(_obj, "FRI" /* FRI */ , DayName.FRI), _define_property(_obj, "SAT" /* SAT */ , DayName.SAT), _obj);
var formatCardinalText = function(cardinalText, value) {
    var templateKey = "templates";
    var cardinalTemplate = cardinalText[templateKey].find(function(template) {
        return template.category === getPluralCategory(value);
    });
    if (!cardinalTemplate) {
        return "";
    }
    return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
var EXACT_DATES_PREFIX = "0";
var isFlexibleOptionExactDates = function(flexibleOption) {
    var _flexibleOption_value;
    return !!(flexibleOption === null || flexibleOption === void 0 ? void 0 : (_flexibleOption_value = flexibleOption.value) === null || _flexibleOption_value === void 0 ? void 0 : _flexibleOption_value.startsWith(EXACT_DATES_PREFIX));
};
var isDateEnabled = function(day, validStartDate, validEndDate) {
    var dayDate = new Date(day.year, day.month, day.day);
    if (day.isPast) {
        return false;
    }
    if (validStartDate && validEndDate) {
        return dayDate >= validStartDate && dayDate <= validEndDate;
    }
    if (validStartDate && !validEndDate) {
        return dayDate >= validStartDate;
    }
    if (!validStartDate && validEndDate) {
        return dayDate <= validEndDate;
    }
    return true;
};
var getNextDayOfDate = function(date) {
    var nextDate = new Date(date);
    nextDate === null || nextDate === void 0 ? void 0 : nextDate.setDate(nextDate.getDate() + 1);
    return nextDate;
};
var formatDateToString = function(date) {
    var _date_toISOString_match, _date_toISOString;
    return date === null || date === void 0 ? void 0 : (_date_toISOString = date.toISOString()) === null || _date_toISOString === void 0 ? void 0 : (_date_toISOString_match = _date_toISOString.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/gi)) === null || _date_toISOString_match === void 0 ? void 0 : _date_toISOString_match[0];
};
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector-day-template.tsx
var DateRangeSelectorDayTemplate = function(props) {
    var day = props.day, tmp = props.dayData, _ref = tmp === void 0 ? {} : tmp, validStartDate = _ref.validStartDate, validEndDate = _ref.validEndDate;
    var isDayDisabled = !isDateEnabled(day, validStartDate, validEndDate);
    var theme = React7.useMemo(function() {
        if (day.isPast) {
            return "muted";
        }
        if (day.isToday) {
            return "today";
        }
        return "default";
    }, [
        day.isPast,
        day.isToday
    ]);
    return /* @__PURE__ */ React7.createElement(UitkDateNumber, {
        theme: theme,
        disabled: isDayDisabled
    }, day.day);
};
var canClick = function(dayData, day) {
    return isDateEnabled(day, dayData.validStartDate, dayData.validEndDate);
};
var getAriaLabel = function(dayData, day, l10n) {
    var localeDateString = day.localeDateString;
    return !isDateEnabled(day, dayData.validStartDate, dayData.validEndDate) ? l10n.formatText("calendar.unavailable.a11yLabel", localeDateString) : localeDateString;
};
DateRangeSelectorDayTemplate.canClick = canClick;
DateRangeSelectorDayTemplate.canSpan = canClick;
DateRangeSelectorDayTemplate.getAriaLabel = getAriaLabel;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-calendar-content.tsx
import React10 from "react";
import { gql as gql6 } from "@apollo/client";
import { SingleSelectPillWrapper } from "@egds/react-search-experience";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
import React9, { useRef } from "react";
import { gql as gql5 } from "@apollo/client";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback } from "uitk-react-form";
import { UitkPill } from "uitk-react-pill";
// ../internal/src/components/common/icon.tsx
import React8 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize } from "@egds/react-core/icons";
var __Fragment3 = gql4(_templateObject3());
var _obj1;
var iconSizeMap = (_obj1 = {}, _define_property(_obj1, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _define_property(_obj1, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _define_property(_obj1, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _define_property(_obj1, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _define_property(_obj1, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj1);
var Icon = function(props) {
    var data = props.data;
    var id = data.id, title = data.title, description = data.description, size = data.size;
    var iconSize = iconSizeMap[size !== null && size !== void 0 ? size : "LARGE"];
    return /* @__PURE__ */ React8.createElement(UitkIcon2, {
        id: id,
        name: id,
        title: title !== null && title !== void 0 ? title : description,
        description: description,
        size: iconSize
    });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment3;
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
var EGDS_BASIC_PILL_PREFIX = "EGDSBasicPill";
var __Fragment4 = gql5(_templateObject4(), Icon.fragment);
var EGDSBasicPill = function(props) {
    var data = props.data, onChange = props.onChange, triggerPill = props.triggerPill, onClick = props.onClick, active = props.active;
    var accessibility = data.accessibility, name = data.name, primary = data.primary, selected = data.selected, value = data.value, disabled = data.disabled, icon = data.icon, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics, selectedText = data.selectedText;
    var clickTracker = useClickTracker3();
    var id = name !== null && name !== void 0 ? name : "egds-basic-pill";
    var _React9_useState = _sliced_to_array(React9.useState(selected), 2), checked = _React9_useState[0], setCheckState = _React9_useState[1];
    var pillRef = useRef(false);
    var onPillSelectText = selectedText || primary;
    var handleOnChange = useFormCallback(id, function(event) {
        var _event_currentTarget = event.currentTarget, newSelection = _event_currentTarget.checked;
        setCheckState(newSelection);
        if (!pillRef.current) {
            pillRef.current = true;
        }
        if (onChange) {
            onChange(event);
        }
        if (selectAnalytics && newSelection) {
            var linkName = selectAnalytics.linkName, referrerId = selectAnalytics.referrerId;
            clickTracker(referrerId, linkName);
            return event;
        }
        if (deselectAnalytics && !newSelection) {
            var linkName1 = deselectAnalytics.linkName, referrerId1 = deselectAnalytics.referrerId;
            clickTracker(referrerId1, linkName1);
        }
        return event;
    });
    var handleOnClick = function() {
        if (onClick) {
            onClick();
        }
    };
    React9.useEffect(function() {
        if (pillRef.current) {
            liveAnnounce2(accessibility !== null && accessibility !== void 0 ? accessibility : void 0, Level2.POLITE);
        }
    }, [
        accessibility
    ]);
    React9.useEffect(function() {
        setCheckState(selected);
    }, [
        selected
    ]);
    return /* @__PURE__ */ React9.createElement(UitkPill, {
        checked: checked,
        active: active,
        disabled: disabled,
        icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
        id: id,
        name: "".concat(EGDS_BASIC_PILL_PREFIX, "-").concat(name),
        onChange: handleOnChange,
        value: value !== null && value !== void 0 ? value : "",
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        triggerPill: triggerPill,
        onClick: handleOnClick
    }, checked ? onPillSelectText : primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = _object_spread_props(_object_spread({}, __Fragment4), {
    __typename: "EGDSBasicPill"
});
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-calendar-content.tsx
var __Fragment5 = gql6(_templateObject5(), EGDSBasicPill.fragment);
var DISPLAY_NAME = "EGDSDatePickerFlexibilityCalendarContent";
var FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX = "".concat(DISPLAY_NAME, "-SelectedOption");
var EGDSDatePickerFlexibilityCalendarContent = function(param) {
    var data = param.data, onSelect = param.onSelect, currentlySelectedPillValue = param.currentlySelectedPillValue, className = param.className;
    var handleSelectedPill = function(selectedPillValue) {
        onSelect(selectedPillValue);
    };
    var _data_flexibleDateOptions_map;
    var singleSelectOptions = (_data_flexibleDateOptions_map = data === null || data === void 0 ? void 0 : data.flexibleDateOptions.map(function(pillData) {
        var _pillData_primary, _pillData_value, _pillData_value1, _pillData_accessibility;
        return {
            selected: pillData.value === currentlySelectedPillValue,
            checked: pillData.value === currentlySelectedPillValue,
            text: (_pillData_primary = pillData.primary) !== null && _pillData_primary !== void 0 ? _pillData_primary : "",
            disabled: pillData.disabled,
            value: (_pillData_value = pillData.value) !== null && _pillData_value !== void 0 ? _pillData_value : "",
            id: (_pillData_value1 = pillData.value) !== null && _pillData_value1 !== void 0 ? _pillData_value1 : "",
            altText: (_pillData_accessibility = pillData.accessibility) !== null && _pillData_accessibility !== void 0 ? _pillData_accessibility : void 0
        };
    })) !== null && _data_flexibleDateOptions_map !== void 0 ? _data_flexibleDateOptions_map : [];
    return /* @__PURE__ */ React10.createElement(UitkSpacing3, {
        margin: {
            medium: {
                inlinestart: "two",
                blockend: "three",
                blockstart: "one"
            },
            small: {
                inlinestart: "two",
                blockend: "three",
                blockstart: "one"
            }
        }
    }, /* @__PURE__ */ React10.createElement("div", {
        className: className
    }, /* @__PURE__ */ React10.createElement(SingleSelectPillWrapper, {
        data: singleSelectOptions,
        handleSelectedPill: handleSelectedPill
    })));
};
EGDSDatePickerFlexibilityCalendarContent.displayName = DISPLAY_NAME;
EGDSDatePickerFlexibilityCalendarContent.fragment = __Fragment5;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-content.tsx
import React24 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { UitkTabsBackGroundColorType as UitkTabsBackGroundColorType2, UitkTabsType as UitkTabsType2 } from "@egds/react-core/tabs";
import { ViewMedium as ViewMedium2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// ../internal/src/components/common/egds-basic-tabs/egds-basic-tabs.tsx
import React11, { useState } from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkTab, UitkTabs, UitkTabsBackGroundColorType, UitkTabsType } from "@egds/react-core/tabs";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
var __Fragment6 = gql7(_templateObject6());
var EGDSBasicTabs = function(param) {
    var data = param.data, onTabSelected = param.onTabSelected, backgroundColor = param.backgroundColor, tabsType = param.tabsType;
    var tabs = data.tabs, selectedTabId = data.selectedTabId;
    var clickTracker = useClickTracker4();
    var defaultTabSelected = 0;
    var initialSelectedTab = selectedTabId ? tabs.findIndex(function(tab) {
        return tab.__typename === "EGDSBasicTab" ? tab.tabId === selectedTabId : defaultTabSelected;
    }) : defaultTabSelected;
    var _useState = _sliced_to_array(useState(initialSelectedTab), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var viewportSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var isSmallViewportSize = viewportSize <= defaultViewSizes.SMALL;
    var trackTabOnClick = function(analytics) {
        if (analytics && (analytics === null || analytics === void 0 ? void 0 : analytics.__typename) === "ClientSideAnalytics") {
            var linkName = analytics.linkName, referrerId = analytics.referrerId;
            clickTracker(referrerId, linkName);
        }
    };
    var onTabSelect = function(selectedIndex) {
        setSelectedTab(selectedIndex);
        var tab = tabs[selectedIndex];
        if (tab.__typename === "EGDSBasicTab") {
            var clickAnalytics = tab.clickAnalytics, tabId = tab.tabId;
            trackTabOnClick(clickAnalytics);
            if (onTabSelected) {
                onTabSelected(tabId);
            }
        }
    };
    var defaultTabsType = isSmallViewportSize ? UitkTabsType.EQUAL_WIDTH : UitkTabsType.NATURAL;
    var tabProps = {
        selectedTab: selectedTab !== -1 ? selectedTab : defaultTabSelected,
        onTabSelect: onTabSelect,
        tabsType: tabsType !== null && tabsType !== void 0 ? tabsType : defaultTabsType,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : UitkTabsBackGroundColorType.PRIMARY
    };
    return /* @__PURE__ */ React11.createElement(UitkTabs, _object_spread({}, tabProps), tabs.map(function(tab) {
        var tabId = tab.__typename === "EGDSBasicTab" ? tab.tabId : "";
        var label = tab.__typename === "EGDSBasicTab" ? tab.label : "";
        return /* @__PURE__ */ React11.createElement(UitkTab, {
            id: tabId,
            key: tabId,
            name: label,
            targetURI: "#EGDSBasicTabSearchForm_".concat(tabId)
        });
    }));
};
EGDSBasicTabs.fragment = __Fragment6;
EGDSBasicTabs.displayName = "EGDSBasicTabs";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-dates-content.tsx
import React23 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkSpacing as UitkSpacing4, UitkSpacingHr } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-months-section.tsx
import React16 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSSubheading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2, ViewLarge, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// ../internal/src/components/common/badge/egds-badge.tsx
import React13 from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/common/badge/egds-badge-standard.tsx
import React12 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSBadgeStandard as EGDSBadgeStandard2 } from "@egds/react-core/badge";
var __Fragment7 = gql8(_templateObject7());
var EGDSStandardBadge = function(param) {
    var data = param.data;
    var text = data.text, theme = data.theme, size = data.size, accessibility = data.accessibility;
    var _ref;
    var standardBadgeProps = {
        text: text !== null && text !== void 0 ? text : "",
        theme: theme !== null && theme !== void 0 ? theme : "standard",
        size: size !== null && size !== void 0 ? size : "large",
        a11yText: (_ref = accessibility !== null && accessibility !== void 0 ? accessibility : text) !== null && _ref !== void 0 ? _ref : ""
    };
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React12.createElement(EGDSBadgeStandard2, _object_spread({}, standardBadgeProps));
};
EGDSStandardBadge.displayName = "EGDSStandardBadge";
EGDSStandardBadge.fragment = __Fragment7;
// ../internal/src/components/common/badge/egds-badge.tsx
var __Fragment8 = gql9(_templateObject8(), EGDSStandardBadge.fragment);
var EGDSBadge = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "EGDSStandardBadge":
            return /* @__PURE__ */ React13.createElement(EGDSStandardBadge, {
                data: data
            });
        default:
            return null;
    }
};
EGDSBadge.displayName = "EGDSBadge";
EGDSBadge.fragment = __Fragment8;
// ../internal/src/components/common/button/toggle/egds-toggle-button.tsx
import React14 from "react";
import { gql as gql10 } from "@apollo/client";
import { ButtonToggleCustomContent } from "@egds/react-search-experience";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var __Fragment9 = gql10(_templateObject9());
var EGDSToggleButton = function(param) {
    var data = param.data, onChange = param.onChange, children = param.children, ariaLabel = param.ariaLabel;
    var primary = data.primary, subText = data.subText, disabled = data.disabled, selected = data.selected, name = data.name, selectedAnalytics = data.selectedAnalytics, unselectedAnalytics = data.unselectedAnalytics;
    var trackClick = useClickTracker5();
    var trackToggleButtonState = function(isStateSelected) {
        var state = isStateSelected ? selectedAnalytics : unselectedAnalytics;
        if ((state === null || state === void 0 ? void 0 : state.__typename) === "ClientSideAnalytics") {
            var linkName = state.linkName, referrerId = state.referrerId;
            trackClick(referrerId, linkName);
        }
    };
    var handleChange = function(event) {
        if (onChange) {
            onChange(event);
        }
        trackToggleButtonState(!selected);
    };
    return /* @__PURE__ */ React14.createElement(ButtonToggleCustomContent, {
        id: name !== null && name !== void 0 ? name : "",
        disabled: disabled,
        name: name !== null && name !== void 0 ? name : "",
        checked: selected,
        onChange: handleChange,
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "".concat(primary, " ").concat(subText)
    }, children);
};
EGDSToggleButton.displayName = "EGDSToggleButton";
EGDSToggleButton.fragment = __Fragment9;
// ../internal/src/components/common/button/toggle/egds-toggle-button-group.tsx
import React15 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkButtonToggleGroup } from "uitk-react-button-toggle";
var __Fragment10 = gql11(_templateObject10(), EGDSToggleButton.fragment);
var EGDSToggleButtonGroup = function(param) {
    var data = param.data;
    var options = data.options;
    var _React15_useState = _sliced_to_array(React15.useState(options), 2), buttons = _React15_useState[0], setButtons = _React15_useState[1];
    var handleChange = function(event) {
        setButtons(function(prevState) {
            return prevState.map(function(buttonToggleState) {
                return buttonToggleState.name === event.target.name ? _object_spread_props(_object_spread({}, buttonToggleState), {
                    selected: !buttonToggleState.selected
                }) : buttonToggleState;
            });
        });
    };
    return /* @__PURE__ */ React15.createElement(UitkButtonToggleGroup, {
        wrapButtons: true
    }, buttons.map(function(option, index) {
        return /* @__PURE__ */ React15.createElement(EGDSToggleButton, {
            key: index,
            data: option,
            onChange: handleChange
        });
    }));
};
EGDSToggleButtonGroup.displayName = "EGDSToggleButtonGroup";
EGDSToggleButtonGroup.fragment = __Fragment10;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-months-section.tsx
var __Fragment11 = gql12(_templateObject11(), EGDSToggleButtonGroup.fragment);
var DISPLAY_NAME2 = "EGDSDatePickerFlexibleMonths";
var FLEXIBILITY_MONTHS_NAME_PREFIX = "".concat(DISPLAY_NAME2, "-Options");
var EGDSDatePickerFlexibleMonthButton = function(param) {
    var monthSelectionButton = param.monthSelectionButton, onMonthSelectionToggle = param.onMonthSelectionToggle, badge = param.badge, isBadgeLoading = param.isBadgeLoading;
    var icon = monthSelectionButton.icon, primary = monthSelectionButton.primary, subText = monthSelectionButton.subText;
    return /* @__PURE__ */ React16.createElement(EGDSToggleButton, {
        data: monthSelectionButton,
        onChange: onMonthSelectionToggle,
        ariaLabel: "".concat(primary, " ").concat(subText)
    }, /* @__PURE__ */ React16.createElement(EGDSLayoutFlex, {
        direction: "column",
        alignItems: "center",
        blockSize: "full_size",
        justifyContent: "center"
    }, icon && /* @__PURE__ */ React16.createElement(EGDSIcon2, {
        name: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.id : ""
    }), primary && /* @__PURE__ */ React16.createElement(EGDSText2, {
        size: 100,
        weight: "bold",
        spacing: "one"
    }, primary !== null && primary !== void 0 ? primary : ""), subText && /* @__PURE__ */ React16.createElement(EGDSSpacing2, {
        padding: {
            blockend: badge || isBadgeLoading ? "one" : "unset"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(EGDSText2, {
        size: 100
    }, subText !== null && subText !== void 0 ? subText : ""))), badge && !isBadgeLoading && /* @__PURE__ */ React16.createElement(EGDSBadge, {
        data: badge
    }), isBadgeLoading && /* @__PURE__ */ React16.createElement(EGDSLineSkeleton, {
        animation: true,
        type: "secondary"
    })));
};
var EGDSDatePickerFlexibleMonths = function(param) {
    var data = param.data, monthsSelectionToggleButtons = param.monthsSelectionToggleButtons, onMonthSelectionToggle = param.onMonthSelectionToggle, priceInsightsPrices = param.priceInsightsPrices, isPriceInsightsDataLoading = param.isPriceInsightsDataLoading;
    var heading = data.heading, subHeading = data.subHeading;
    var viewportSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    });
    var isMediumViewportSize = viewportSize <= defaultViewSizes2.MEDIUM;
    var isSmallViewportSize = viewportSize <= defaultViewSizes2.SMALL;
    var buttonToggleLayoutItemProps = {
        grow: 1,
        maxWidth: isSmallViewportSize || isMediumViewportSize ? void 0 : "twenty_four",
        minWidth: isSmallViewportSize || isMediumViewportSize ? "quarter_width" : void 0
    };
    return /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(EGDSLayoutFlex, {
        alignItems: "center",
        direction: "column",
        space: "three"
    }, /* @__PURE__ */ React16.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(EGDSHeading2, {
        size: 6,
        align: "center"
    }, heading), /* @__PURE__ */ React16.createElement(EGDSSubheading, null, subHeading)))), monthsSelectionToggleButtons && /* @__PURE__ */ React16.createElement(Viewport2, null, /* @__PURE__ */ React16.createElement(ViewSmall2, null, /* @__PURE__ */ React16.createElement(EGDSSpacing2, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React16.createElement(EGDSLayoutFlex, {
        direction: "row",
        justifyContent: "space-around",
        wrap: "wrap",
        space: "three"
    }, monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options.map(function(option, index) {
        return /* @__PURE__ */ React16.createElement(EGDSLayoutFlexItem, _object_spread_props(_object_spread({}, buttonToggleLayoutItemProps), {
            key: index
        }), /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(EGDSDatePickerFlexibleMonthButton, {
            monthSelectionButton: option,
            onMonthSelectionToggle: onMonthSelectionToggle,
            badge: priceInsightsPrices ? priceInsightsPrices[index] : null,
            isBadgeLoading: isPriceInsightsDataLoading
        })));
    })))), /* @__PURE__ */ React16.createElement(ViewLarge, null, /* @__PURE__ */ React16.createElement(EGDSSpacing2, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React16.createElement(EGDSLayoutGrid, {
        columns: 6,
        space: "three"
    }, monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options.map(function(option, index) {
        return /* @__PURE__ */ React16.createElement(EGDSLayoutGridItem, _object_spread_props(_object_spread({}, buttonToggleLayoutItemProps), {
            key: index
        }), /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(EGDSDatePickerFlexibleMonthButton, {
            monthSelectionButton: option,
            onMonthSelectionToggle: onMonthSelectionToggle,
            badge: priceInsightsPrices ? priceInsightsPrices[index] : null,
            isBadgeLoading: isPriceInsightsDataLoading
        })));
    }))))));
};
EGDSDatePickerFlexibleMonths.displayName = DISPLAY_NAME2;
EGDSDatePickerFlexibleMonths.fragment = __Fragment11;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-nights-section.tsx
import React22 from "react";
import { gql as gql18 } from "@apollo/client";
import { SingleSelectPillWrapper as SingleSelectPillWrapper2 } from "@egds/react-search-experience";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkHeading } from "uitk-react-text";
// ../internal/src/components/common/checkbox/egds-checkbox.tsx
import React18 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/common/checkbox/egds-basic-checkbox.tsx
import React17 from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox } from "uitk-react-checkbox";
var __Fragment12 = gql13(_templateObject12());
var EGDSBasicCheckBox = function(param) {
    var data = param.data, checked = param.checked, onChange = param.onChange;
    var egdsElementId = data.egdsElementId, description = data.description, enabled = data.enabled, name = data.name, required = data.required, label = data.label, checkedAnalytics = data.checkedAnalytics, uncheckedAnalytics = data.uncheckedAnalytics, state = data.state;
    var _React17_useState = _sliced_to_array(React17.useState(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ ), 2), isChecked = _React17_useState[0], setIsChecked = _React17_useState[1];
    React17.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ );
    }, [
        checked,
        state
    ]);
    var track = useClickTracker6();
    var handleChange = React17.useCallback(function(event) {
        setIsChecked(event.currentTarget.checked);
        if (checkedAnalytics && !isChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && isChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }, [
        checkedAnalytics,
        isChecked,
        onChange,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React17.createElement(UitkCheckbox, {
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        checked: isChecked,
        description: description !== null && description !== void 0 ? description : void 0,
        disabled: !enabled,
        name: name !== null && name !== void 0 ? name : void 0,
        onChange: handleChange,
        required: required
    }, label === null || label === void 0 ? void 0 : label.text);
};
EGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
EGDSBasicCheckBox.fragment = _object_spread_props(_object_spread({}, __Fragment12), {
    __typename: "EGDSBasicCheckBox"
});
// ../internal/src/components/common/checkbox/egds-checkbox.tsx
var __Fragment13 = gql14(_templateObject13(), EGDSBasicCheckBox.fragment);
var EGDSCheckBox = function(param) {
    var data = param.data, onChange = param.onChange;
    switch(data.__typename){
        case "EGDSBasicCheckBox":
            return /* @__PURE__ */ React18.createElement(EGDSBasicCheckBox, {
                onChange: onChange,
                data: data
            });
        default:
            return null;
    }
};
EGDSCheckBox.displayName = "EGDSCheckBox";
EGDSCheckBox.fragment = __Fragment13;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
import React21 from "react";
import { gql as gql17 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
import React19 from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var __Fragment14 = gql15(_templateObject14());
var EGDSBasicRemovablePill = function(param) {
    var data = param.data, onClick = param.onClick;
    var id = data.id, primary = data.primary, accessibility = data.accessibility, removeAnalytics = data.removeAnalytics, name = data.name, value = data.value;
    var _ref;
    var title = (_ref = id !== null && id !== void 0 ? id : name) !== null && _ref !== void 0 ? _ref : "egds-basic-removable-pill";
    var clickTracker = useClickTracker7();
    var handleOnClick = function(event) {
        if (onClick) {
            onClick({
                event: event,
                id: id !== null && id !== void 0 ? id : ""
            });
        }
        if (removeAnalytics) {
            var referrerId = removeAnalytics.referrerId, linkName = removeAnalytics.linkName;
            clickTracker(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(UitkRemovablePill, {
        id: title,
        onClick: handleOnClick,
        a11yRemoveText: accessibility || ""
    }, primary), /* @__PURE__ */ React19.createElement("input", {
        type: "hidden",
        name: name !== null && name !== void 0 ? name : "",
        value: value !== null && value !== void 0 ? value : ""
    }));
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = __Fragment14;
// ../internal/src/components/common/egds-pill/egds-basic-trigger-pill.tsx
import React20 from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback2 } from "uitk-react-form";
import { UitkPill as UitkPill2 } from "uitk-react-pill";
var EGDS_BASIC_TRIGGER_PILL_PREFIX = "EGDSBasicTriggerPill";
var __Fragment15 = gql16(_templateObject15(), Icon.fragment);
var EGDSBasicTriggerPill = function(props) {
    var data = props.data, onChange = props.onChange, triggerPill = props.triggerPill, onClick = props.onClick, domRef = props.domRef, active = props.active;
    var id = data.id, primary = data.primary, selected = data.selected, disabled = data.disabled, icon = data.icon, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics, accessibility = data.accessibility;
    var clickTracker = useClickTracker8();
    var name = id !== null && id !== void 0 ? id : "egds-basic-pill";
    var _React20_useState = _sliced_to_array(React20.useState(active || selected), 2), checked = _React20_useState[0], check = _React20_useState[1];
    React20.useEffect(function() {
        check(active !== null && active !== void 0 ? active : false);
    }, [
        active
    ]);
    var handleOnClick = useFormCallback2(name, function(event) {
        check(!checked);
        if (onChange) {
            onChange(event);
        }
        if (onClick) {
            onClick();
        }
        if (selectAnalytics && checked) {
            var linkName = selectAnalytics.linkName, referrerId = selectAnalytics.referrerId;
            clickTracker(referrerId, linkName);
            return event;
        }
        if (deselectAnalytics && !checked) {
            var linkName1 = deselectAnalytics.linkName, referrerId1 = deselectAnalytics.referrerId;
            clickTracker(referrerId1, linkName1);
        }
        return event;
    });
    return /* @__PURE__ */ React20.createElement(UitkPill2, {
        checked: checked,
        active: checked,
        selected: selected,
        disabled: disabled,
        icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
        id: name,
        name: "".concat(EGDS_BASIC_TRIGGER_PILL_PREFIX, "-").concat(name),
        triggerPill: triggerPill,
        onClick: handleOnClick,
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        domRef: domRef
    }, primary);
};
EGDSBasicTriggerPill.displayName = "EGDSBasicTriggerPillFragment";
EGDSBasicTriggerPill.fragment = __Fragment15;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
var __Fragment16 = gql17(_templateObject16(), EGDSBasicPill.fragment, EGDSBasicTriggerPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function(props) {
    var data = props.data;
    switch(data.__typename){
        case "EGDSBasicPill":
            return /* @__PURE__ */ React21.createElement(EGDSBasicPill, _object_spread_props(_object_spread({}, props), {
                data: data
            }));
        case "EGDSBasicTriggerPill":
            return /* @__PURE__ */ React21.createElement(EGDSBasicTriggerPill, _object_spread_props(_object_spread({}, props), {
                data: data
            }));
        case "EGDSBasicRemovablePill":
            return /* @__PURE__ */ React21.createElement(EGDSBasicRemovablePill, _object_spread_props(_object_spread({}, props), {
                data: data
            }));
        default:
            return null;
    }
};
EGDSPill.displayName = "EGDSPill";
EGDSPill.fragment = __Fragment16;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-nights-section.tsx
var __Fragment17 = gql18(_templateObject17(), EGDSPill.fragment, EGDSCheckBox.fragment);
var DISPLAY_NAME3 = "EGDSDatePickerFlexibleNights";
var FLEXIBILITY_NIGHTS_OPTIONS_NAME_PREFIX = "".concat(DISPLAY_NAME3, "-Options");
var FLEXIBILITY_NIGHTS_WEEKEND_NAME_PREFIX = "".concat(DISPLAY_NAME3, "-Weekend");
var EGDSDatePickerFlexibleNights = function(param) {
    var data = param.data, onNightSelectionPillChange = param.onNightSelectionPillChange, nightsSelectionPills = param.nightsSelectionPills, onIncludeWeekendCheck = param.onIncludeWeekendCheck, includeWeekendCheckbox = param.includeWeekendCheckbox;
    var heading = data.heading;
    return /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(UitkLayoutFlex, {
        alignItems: "center",
        direction: "column",
        space: "three"
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React22.createElement(UitkHeading, {
        size: 6
    }, heading)), /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React22.createElement(SingleSelectPillWrapper2, {
        data: nightsSelectionPills,
        handleSelectedPill: onNightSelectionPillChange,
        wrap: true,
        align: "center"
    }), ";"), includeWeekendCheckbox && /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React22.createElement(EGDSCheckBox, {
        data: includeWeekendCheckbox,
        onChange: onIncludeWeekendCheck
    }))));
};
EGDSDatePickerFlexibleNights.displayName = DISPLAY_NAME3;
EGDSDatePickerFlexibleNights.fragment = __Fragment17;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-dates-content.tsx
var __Fragment18 = gql19(_templateObject18(), EGDSDatePickerFlexibleMonths.fragment, EGDSDatePickerFlexibleNights.fragment);
var DISPLAY_NAME4 = "EGDSDatePickerFlexibilityDatesContent";
var EGDSDatePickerFlexibilityDatesContent = function(param) {
    var data = param.data, className = param.className, onNightSelectionPillChange = param.onNightSelectionPillChange, nightsSelectionPills = param.nightsSelectionPills, onIncludeWeekendCheck = param.onIncludeWeekendCheck, includeWeekendCheckbox = param.includeWeekendCheckbox, monthsSelectionToggleButtons = param.monthsSelectionToggleButtons, onMonthSelectionToggle = param.onMonthSelectionToggle, priceInsightsPrices = param.priceInsightsPrices, isPriceInsightsDataLoading = param.isPriceInsightsDataLoading;
    var nightsSelection = data.nightsSelection, monthsSelection = data.monthsSelection;
    return /* @__PURE__ */ React23.createElement(UitkSpacing4, {
        padding: "four"
    }, /* @__PURE__ */ React23.createElement("div", {
        className: className
    }, nightsSelection && /* @__PURE__ */ React23.createElement(EGDSDatePickerFlexibleNights, {
        data: nightsSelection,
        onNightSelectionPillChange: onNightSelectionPillChange,
        nightsSelectionPills: nightsSelectionPills,
        onIncludeWeekendCheck: onIncludeWeekendCheck,
        includeWeekendCheckbox: includeWeekendCheckbox
    }), /* @__PURE__ */ React23.createElement(UitkSpacingHr, {
        blockMargin: "six"
    }), monthsSelection && /* @__PURE__ */ React23.createElement(EGDSDatePickerFlexibleMonths, {
        data: monthsSelection,
        isPriceInsightsDataLoading: isPriceInsightsDataLoading,
        priceInsightsPrices: priceInsightsPrices,
        monthsSelectionToggleButtons: monthsSelectionToggleButtons,
        onMonthSelectionToggle: onMonthSelectionToggle
    })));
};
EGDSDatePickerFlexibilityDatesContent.displayName = DISPLAY_NAME4;
EGDSDatePickerFlexibilityDatesContent.fragment = __Fragment18;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-content.tsx
var __Fragment19 = gql20(_templateObject19(), EGDSBasicTabs.fragment, EGDSDatePickerFlexibilityCalendarContent.fragment, EGDSDatePickerFlexibilityDatesContent.fragment);
var DISPLAY_NAME5 = "EGDSDatePickerFlexibilityContent";
var EGDSDatePickerFlexibilityContent = function(param) {
    var data = param.data, children = param.children, className = param.className, onContentSelectorSelection = param.onContentSelectorSelection, onNightSelectionPillChange = param.onNightSelectionPillChange, nightsSelectionPills = param.nightsSelectionPills, onIncludeWeekendCheck = param.onIncludeWeekendCheck, includeWeekendCheckbox = param.includeWeekendCheckbox, monthsSelectionToggleButtons = param.monthsSelectionToggleButtons, onMonthSelectionToggle = param.onMonthSelectionToggle, contentSelector = param.contentSelector, priceInsightsPrices = param.priceInsightsPrices, isPriceInsightsDataLoading = param.isPriceInsightsDataLoading;
    var flexibleDatesContent = data.flexibleDatesContent;
    var activeTab = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : "";
    var defaultTabIds = {
        calendarTabId: "calendar-tab",
        flexibleTabId: "flexible-dates-tab"
    };
    var getTabIds = function() {
        if ((contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs") {
            var tabs = contentSelector.tabs;
            if (tabs[0].__typename === "EGDSBasicTab" && tabs[1].__typename === "EGDSBasicTab") {
                return {
                    calendarTabId: tabs[0].tabId,
                    flexibleTabId: tabs[1].tabId
                };
            }
            return defaultTabIds;
        }
        return defaultTabIds;
    };
    var _getTabIds = getTabIds(), calendarTabId = _getTabIds.calendarTabId, flexibleTabId = _getTabIds.flexibleTabId;
    var flexibilityComponent = /* @__PURE__ */ React24.createElement("div", {
        className: className
    }, (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" && /* @__PURE__ */ React24.createElement(EGDSBasicTabs, {
        data: contentSelector,
        onTabSelected: onContentSelectorSelection,
        backgroundColor: UitkTabsBackGroundColorType2.SECONDARY,
        tabsType: UitkTabsType2.EQUAL_WIDTH
    }), activeTab === calendarTabId && children, activeTab === flexibleTabId && flexibleDatesContent && /* @__PURE__ */ React24.createElement(EGDSDatePickerFlexibilityDatesContent, {
        data: flexibleDatesContent,
        priceInsightsPrices: priceInsightsPrices,
        isPriceInsightsDataLoading: isPriceInsightsDataLoading,
        onNightSelectionPillChange: onNightSelectionPillChange,
        nightsSelectionPills: nightsSelectionPills,
        onIncludeWeekendCheck: onIncludeWeekendCheck,
        includeWeekendCheckbox: includeWeekendCheckbox,
        monthsSelectionToggleButtons: monthsSelectionToggleButtons,
        onMonthSelectionToggle: onMonthSelectionToggle
    }));
    return /* @__PURE__ */ React24.createElement(Viewport3, null, /* @__PURE__ */ React24.createElement(ViewSmall3, null, /* @__PURE__ */ React24.createElement(EGDSScrollable, {
        direction: "vertical"
    }, flexibilityComponent)), /* @__PURE__ */ React24.createElement(ViewMedium2, null, flexibilityComponent));
};
EGDSDatePickerFlexibilityContent.displayName = DISPLAY_NAME5;
EGDSDatePickerFlexibilityContent.fragment = __Fragment19;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/search-form-price-insights-monthly/search-form-price-insights.tsx
import { gql as gql21 } from "@apollo/client";
var __FragmentSearchFormFlexibleDatesMonthly = gql21(_templateObject20(), EGDSToggleButton.fragment, EGDSBadge.fragment);
var __SearchFormPriceInsightsQuery = gql21(_templateObject21(), __FragmentSearchFormFlexibleDatesMonthly);
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector.tsx
var DEFAULT_LOCALE = "en-US";
var TYPENAME_REFERENCE = "EGDSSearchFormDatePickerField";
var formatLocale = function(locale) {
    return locale.replace("_", "-");
};
var DIALOG_ACTIONS = {
    SUBMIT: "on_submit",
    CLOSE: "on_close"
};
function notNull(val) {
    return val !== null;
}
var DateRangeSelector = function(props) {
    var _flexibleDateContent_calendarContent, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent, _flexibleDateContent_flexibleDatesContent_nightsSelection1, _flexibleDateContent_flexibleDatesContent1, _flexibleDateContent_flexibleDatesContent_nightsSelection2, _flexibleDateContent_flexibleDatesContent2, _flexibleDateContent_flexibleDatesContent_monthsSelection, _flexibleDateContent_flexibleDatesContent3, _flexibleDateContent_flexibleDatesContent_nightsSelection3, _flexibleDateContent_flexibleDatesContent4, _flexibleDateContent_flexibleDatesContent_nightsSelection4, _flexibleDateContent_flexibleDatesContent_nightsSelection5, _flexibleDateContent_flexibleDatesContent5, _flexibleDateContent_flexibleDatesContent_monthsSelection1, _flexibleDateContent_flexibleDatesContent6, _flexibleDateContent_calendarContent1;
    var autoOpen = props.autoOpen, startDate5 = props.startDate, endDate5 = props.endDate, enableSameDayDateRange = props.enableSameDayDateRange, buttonText = props.buttonText, clearButtonText = props.clearButtonText, startButtonLabel = props.inputLabel1, endStartButtonLabel = props.inputLabel2, allowClearDates = props.allowClearDates, validDaysLowerBoundInclusive2 = props.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive, skipQuery = props.skipQuery, typename = props.typename, startDateErrorMessage = props.errorMessage, buttonTextTemplate = props.buttonTextTemplate, onClearDates = props.onClearDates, onSelectEndDate = props.onSelectEndDate, onSelectStartDate = props.onSelectStartDate, onChangeEndDate = props.onChangeEndDate, onChangeStartDate = props.onChangeStartDate, onClose = props.onClose, onOpen = props.onOpen, setFieldRefByTypename = props.setFieldRefByTypename, onNextCalendarClick = props.onNextCalendarClick, onPreviousCalendarClick = props.onPreviousCalendarClick, flexibleDateContent = props.flexibleDateContent, flexibleContentConfig = props.flexibleContentConfig, dialogId = props.dialogId, startDateString = props.startDateString, endDateString = props.endDateString, showCalendar = props.showCalendar, toggleCalendar = props.toggleCalendar, showStartDateEndDateHiddenInputs = props.showStartDateEndDateHiddenInputs, input1Stid = props.input1Stid, popoverWidth = props.popoverWidth, gaiaId = props.gaiaId, onFlexibleTabSelection = props.onFlexibleTabSelection;
    var context = useBexApi().context;
    var locale = context.locale ? formatLocale(context.locale) : DEFAULT_LOCALE;
    var clickTracker = useClickTracker9();
    var localizationContext = useLocalization();
    var formatDateString = localizationContext.formatDateString;
    var startDateRef = React25.useRef(null);
    var _React25_useState = _sliced_to_array(React25.useState(null), 2), priceInsightsMonths = _React25_useState[0], setPriceInsightsMonths = _React25_useState[1];
    var _React25_useState1 = _sliced_to_array(React25.useState(), 2), priceInsightsPrices = _React25_useState1[0], setPriceInsightsPrices = _React25_useState1[1];
    var _useExperiment = useExperiment("Monthly_Price_Insights_in_Flex_Search" /* Monthly_Price_Insights_in_Flex_Search */ ), showMonthlyPriceInsightsExposure = _useExperiment.exposure, logShowMonthlyPriceInsightsExposure = _useExperiment.logExperiment;
    var _useLazyQuery = _sliced_to_array(useLazyQuery(__SearchFormPriceInsightsQuery, {
        onCompleted: function(data) {
            var dataOptions = data.searchFormPriceInsights.flexibleDatesMonthly.options;
            if (dataOptions) {
                var months = data.searchFormPriceInsights.flexibleDatesMonthly.options.map(function(param) {
                    var button = param.button;
                    return button;
                }).filter(notNull);
                var prices = data.searchFormPriceInsights.flexibleDatesMonthly.options.map(function(param) {
                    var price = param.price;
                    return price;
                }).filter(notNull);
                if (showMonthlyPriceInsightsExposure.bucket === 1) {
                    if (!priceInsightsMonths) {
                        setPriceInsightsMonths(months);
                    }
                    setPriceInsightsPrices(prices);
                }
            }
        }
    }), 2), getPriceInsightsMonthly = _useLazyQuery[0], loading = _useLazyQuery[1].loading;
    var _useExperiment1 = useExperiment("Monthly_Price_Insights_api_call_gate_web" /* Monthly_Price_Insights_api_call_gate_web */ ), monthlyPriceInsightsExposure = _useExperiment1.exposure, logMonthlyPriceInsightsExperiment = _useExperiment1.logExperiment;
    var _useExperiment2 = useExperiment("Auto_close_date_selector_after_end_date_selection" /* Auto_close_date_selector_after_end_date_selection */ ), autoCloseCalendarExposure = _useExperiment2.exposure, logAutoCloseCalendarExperiment = _useExperiment2.logExperiment;
    var _useExperiment3 = useExperiment("Search_Form_No_Next_Day_End_Date" /* Search_Form_No_Next_Day_End_Date */ ), noNextDayEndDateExposure = _useExperiment3.exposure, logNoNextDayEndDateExposure = _useExperiment3.logExperiment;
    var getFormattedDateString = function(dateString, dateObject) {
        var dateStringFinal = dateString !== null && dateString !== void 0 ? dateString : dateObject ? convertToDateObject(dateObject) : "";
        if (dateStringFinal) {
            return formatDateString(dateStringFinal, {
                raw: "yyyy-MM-dd"
            });
        }
        return null;
    };
    if (autoOpen && onOpen) {
        onOpen();
    }
    var formattedStartDate = getFormattedDateString(startDateString, startDate5);
    var formattedEndDate = getFormattedDateString(endDateString, endDate5);
    var _React25_useState2 = _sliced_to_array(React25.useState(formattedStartDate), 2), prevCheckInDateString = _React25_useState2[0], setPrevCheckInDateString = _React25_useState2[1];
    var _React25_useState3 = _sliced_to_array(React25.useState(formattedEndDate), 2), prevCheckOutDateString = _React25_useState3[0], setPrevCheckOutDateString = _React25_useState3[1];
    var _React25_useState4 = _sliced_to_array(React25.useState(formattedStartDate), 2), checkInDateString = _React25_useState4[0], setCheckInDateString = _React25_useState4[1];
    var _React25_useState5 = _sliced_to_array(React25.useState(formattedEndDate), 2), checkOutDateString = _React25_useState5[0], setCheckOutDateString = _React25_useState5[1];
    var _React25_useState6 = _sliced_to_array(React25.useState(500), 2), daysBookableInAdvance = _React25_useState6[0], setDaysBookableInAdvance = _React25_useState6[1];
    var _React25_useState7 = _sliced_to_array(React25.useState(false), 2), shouldFireChangeEvent = _React25_useState7[0], setShouldFireChangeEvent = _React25_useState7[1];
    var allowToControlOpenStateFromOutside = typeof showCalendar === "boolean" && toggleCalendar;
    var _React25_useState8 = _sliced_to_array(React25.useState(allowToControlOpenStateFromOutside ? showCalendar : autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 2), initialOpenState = _React25_useState8[0], setInitialOpenState = _React25_useState8[1];
    var _React25_useState9 = _sliced_to_array(React25.useState(initialOpenState), 2), isCalendarOpen = _React25_useState9[0], setIsCalendarOpen = _React25_useState9[1];
    var _React25_useState10 = _sliced_to_array(React25.useState(false), 2), shouldCloseFireChangeEvent = _React25_useState10[0], setShouldCloseFireChangeEvent = _React25_useState10[1];
    var _React25_useState11 = _sliced_to_array(React25.useState((buttonTextTemplate === null || buttonTextTemplate === void 0 ? void 0 : buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" ? buttonTextTemplate.text : buttonText), 2), dynamicButtonText = _React25_useState11[0], setDynamicButtonText = _React25_useState11[1];
    var flexibleDateOptions = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_calendarContent = flexibleDateContent.calendarContent) === null || _flexibleDateContent_calendarContent === void 0 ? void 0 : _flexibleDateContent_calendarContent.flexibleDateOptions;
    var _flexibleDateOptions_find;
    var selectedFlexibleDateOptionsData = (_flexibleDateOptions_find = flexibleDateOptions === null || flexibleDateOptions === void 0 ? void 0 : flexibleDateOptions.find(function(option) {
        return checkInDateString && checkOutDateString ? option.selected : isFlexibleOptionExactDates(option);
    })) !== null && _flexibleDateOptions_find !== void 0 ? _flexibleDateOptions_find : null;
    var trailingTextForFlexibleDateOptions = (selectedFlexibleDateOptionsData === null || selectedFlexibleDateOptionsData === void 0 ? void 0 : selectedFlexibleDateOptionsData.primary) ? "(".concat(selectedFlexibleDateOptionsData.primary, ")") : void 0;
    var selectedCalendarPillState = {
        value: selectedFlexibleDateOptionsData === null || selectedFlexibleDateOptionsData === void 0 ? void 0 : selectedFlexibleDateOptionsData.value,
        hasValueChanged: false,
        trailingText: selectedFlexibleDateOptionsData && isFlexibleOptionExactDates(selectedFlexibleDateOptionsData) ? "" : trailingTextForFlexibleDateOptions
    };
    var _React25_useState12 = _sliced_to_array(React25.useState(selectedCalendarPillState), 2), selectedCalendarPill = _React25_useState12[0], setSelectedCalendarPill = _React25_useState12[1];
    var viewportSize = useMediaQueries3({
        viewSizes: defaultViewSizes3
    });
    var isLargeViewportSize = viewportSize >= defaultViewSizes3.LARGE;
    var _React25_useState13 = _sliced_to_array(React25.useState(flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector), 2), contentSelector = _React25_useState13[0], setContentSelector = _React25_useState13[1];
    var contentSelectorTabs = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.tabs : null;
    var calendarTabId = contentSelectorTabs && contentSelectorTabs[0].__typename === "EGDSBasicTab" ? contentSelectorTabs[0].tabId : "calendar-tab";
    var isCalendarTab = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId === calendarTabId : true;
    var _ref;
    var includeFlexibleDatesContent = (_ref = (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleDatesContent) && !isCalendarTab) !== null && _ref !== void 0 ? _ref : false;
    var _React25_useState14 = _sliced_to_array(React25.useState(), 2), prevFlexibleDatesState = _React25_useState14[0], setPrevFlexibleDatesState = _React25_useState14[1];
    var _React25_useState15 = _sliced_to_array(React25.useState(), 2), prevTabIdState = _React25_useState15[0], setPrevTabIdState = _React25_useState15[1];
    var _React25_useState16 = _sliced_to_array(React25.useState(), 2), flexibleLabel = _React25_useState16[0], setFlexibleLabel = _React25_useState16[1];
    var handleSubmit = useFormCallback3(function() {
        var hasTrailingText = isCalendarTab && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent) && selectedCalendarPill.trailingText;
        if (includeFlexibleDatesContent || hasTrailingText) {
            return "".concat(typename, "-Flexible");
        }
        return typename;
    }(), function(event) {
        return event;
    });
    var _React25_useState17 = _sliced_to_array(React25.useState(), 2), dialogActionsTracker = _React25_useState17[0], setDialogActionsTracker = _React25_useState17[1];
    React25.useEffect(function() {
        if ((dialogActionsTracker === null || dialogActionsTracker === void 0 ? void 0 : dialogActionsTracker.includes(DIALOG_ACTIONS.CLOSE)) && !(dialogActionsTracker === null || dialogActionsTracker === void 0 ? void 0 : dialogActionsTracker.includes(DIALOG_ACTIONS.SUBMIT)) && !isLargeViewportSize) {
            if (hasFlexibleDates) {
                resetContentSelector();
                resetFlexDateSelection();
            }
            if (!(noNextDayEndDateExposure.bucket === 1)) {
                resetCalendarValues();
            }
        } else {
            setDialogActionsTracker(null);
        }
    }, [
        dialogActionsTracker
    ]);
    React25.useEffect(function() {
        var _flexibleDateContent_flexibleDatesContent_monthsSelection, _flexibleDateContent_flexibleDatesContent, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent1;
        setPrevFlexibleDatesState({
            months: flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection = _flexibleDateContent_flexibleDatesContent.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection.options,
            nights: defaultNightsSelectionPills,
            weekend: flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent1 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent1 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent1.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection.includeWeekend
        });
        setPrevTabIdState((contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : calendarTabId);
    }, []);
    React25.useEffect(function() {
        if (shouldFireChangeEvent) {
            setShouldFireChangeEvent(false);
            var value = "";
            if (checkInDateString && checkOutDateString) {
                value = getInputTextValue();
            }
            triggerInputChangeEvent(!isCalendarTab ? flexibleLabel !== null && flexibleLabel !== void 0 ? flexibleLabel : "" : value, handleSubmit);
        }
    }, [
        shouldFireChangeEvent
    ]);
    React25.useEffect(function() {
        if (formattedStartDate) {
            setCheckInDateString(formattedStartDate);
            setPrevCheckInDateString(formattedStartDate);
        }
        if (formattedEndDate) {
            setCheckOutDateString(formattedEndDate);
            setPrevCheckOutDateString(formattedEndDate);
        }
        if (!formattedStartDate && !formattedEndDate) {
            setCheckInDateString("");
            setCheckOutDateString("");
        }
        if (validDaysUpperBoundInclusive) {
            var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */ new Date().getTime();
            setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
        }
    }, [
        formattedEndDate,
        formattedStartDate,
        skipQuery,
        validDaysLowerBoundInclusive2,
        validDaysUpperBoundInclusive
    ]);
    React25.useEffect(function() {
        if (!skipQuery && (selectedFlexibleDateOptionsData === null || selectedFlexibleDateOptionsData === void 0 ? void 0 : selectedFlexibleDateOptionsData.value) !== selectedCalendarPill.value) {
            setSelectedCalendarPill(selectedCalendarPillState);
        }
    }, [
        selectedFlexibleDateOptionsData,
        skipQuery
    ]);
    React25.useEffect(function() {
        setFieldRefByTypename(TYPENAME_REFERENCE, startDateRef);
    }, []);
    var calendarHandlerOnScroll = React25.useCallback(function() {
        var _startDateRef_current;
        var distanceToTopOfViewportToClose = 20;
        var _startDateRef_current_getBoundingClientRect_top;
        if (initialOpenState && ((_startDateRef_current_getBoundingClientRect_top = startDateRef === null || startDateRef === void 0 ? void 0 : (_startDateRef_current = startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.getBoundingClientRect().top) !== null && _startDateRef_current_getBoundingClientRect_top !== void 0 ? _startDateRef_current_getBoundingClientRect_top : distanceToTopOfViewportToClose) <= distanceToTopOfViewportToClose) {
            setInitialOpenState(false);
            document.body.click();
        }
    }, [
        initialOpenState
    ]);
    React25.useEffect(function() {
        if (initialOpenState) {
            window.addEventListener("scroll", calendarHandlerOnScroll);
            return function() {
                return window.removeEventListener("scroll", calendarHandlerOnScroll);
            };
        }
    }, [
        initialOpenState,
        calendarHandlerOnScroll
    ]);
    React25.useEffect(function() {
        if (allowToControlOpenStateFromOutside) {
            if (showCalendar && !isCalendarOpen) {
                var _startDateRef_current;
                (_startDateRef_current = startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.click();
            } else if (!showCalendar && isCalendarOpen) {
                document.body.click();
            }
        }
    }, [
        showCalendar,
        toggleCalendar
    ]);
    var resetCalendarValues = function() {
        setCheckInDateString(prevCheckInDateString);
        setCheckOutDateString(prevCheckOutDateString);
    };
    var updateButtonSubmitText = function(newStartDate, newEndDate) {
        if ((buttonTextTemplate === null || buttonTextTemplate === void 0 ? void 0 : buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" && newStartDate && newEndDate) {
            var startDateInMiliSeconds = Number(new Date(newStartDate));
            var formateCurrentEndDate = newEndDate !== null && newEndDate !== void 0 ? newEndDate : "";
            var endDateInMiliSeconds = Number(new Date(formateCurrentEndDate));
            var durationOfDays = convertFromMiliSecondsToDays(endDateInMiliSeconds - startDateInMiliSeconds);
            setDynamicButtonText(formatCardinalText(buttonTextTemplate, durationOfDays));
        }
    };
    var onDateRangeChange = function(newStartDate, endDateParam) {
        setShouldFireChangeEvent(false);
        setShouldCloseFireChangeEvent(true);
        if (!(newStartDate === null && checkInDateString !== null)) {
            setCheckInDateString(newStartDate);
        }
        if (newStartDate) {
            logNoNextDayEndDateExposure(noNextDayEndDateExposure);
            onChangeStartDate(newStartDate);
            onSelectStartDate();
        }
        if (!newStartDate) {
            setCheckInDateString("");
            onChangeStartDate("");
            onSelectStartDate();
        }
        var nextToStartDate = newStartDate && getNextDayOfDate(newStartDate);
        var enableNoNextDayEndDate = noNextDayEndDateExposure.bucket === 1;
        if (enableNoNextDayEndDate) {
            setCheckOutDateString("");
        }
        var formatedDefaultEndDate = enableNoNextDayEndDate ? null : formatDateToString(nextToStartDate);
        if (endDateParam) {
            logAutoCloseCalendarExperiment(autoCloseCalendarExposure);
        }
        if (endDateParam || formatedDefaultEndDate) {
            var finalEndDate = endDateParam || formatedDefaultEndDate || null;
            setCheckOutDateString(finalEndDate);
            onSelectEndDate();
            onChangeEndDate(finalEndDate);
            updateButtonSubmitText(newStartDate, finalEndDate);
        } else if (newStartDate) {
            setCheckInDateString(newStartDate);
        } else if (!newStartDate) {
            setCheckOutDateString("");
            onChangeEndDate("");
            onSelectEndDate();
        }
    };
    var resetFlexibleDateContent = function() {
        var _flexibleDateOptions_find;
        var defaultFlexibleDateOptionValue = (_flexibleDateOptions_find = flexibleDateOptions === null || flexibleDateOptions === void 0 ? void 0 : flexibleDateOptions.find(function(pill) {
            return pill.value === "0_day";
        })) !== null && _flexibleDateOptions_find !== void 0 ? _flexibleDateOptions_find : null;
        if (defaultFlexibleDateOptionValue) {
            var value = defaultFlexibleDateOptionValue.value;
            setSelectedCalendarPill({
                value: value,
                trailingText: "",
                hasValueChanged: true
            });
        }
    };
    var onDateRangeClear = function() {
        setCheckInDateString(null);
        setCheckOutDateString(null);
        resetFlexibleDateContent();
        onClearDates();
    };
    var getSearchFormPriceInsights = function() {
        logMonthlyPriceInsightsExperiment(monthlyPriceInsightsExposure);
        if (monthlyPriceInsightsExposure.bucket === 1) {
            var variables = {
                context: context,
                gaiaId: gaiaId !== null && gaiaId !== void 0 ? gaiaId : ""
            };
            getPriceInsightsMonthly({
                variables: variables
            });
        }
    };
    var onOpenCB = function() {
        if (allowToControlOpenStateFromOutside) {
            toggleCalendar(true);
        }
        if ((flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector) && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleDatesContent)) {
            if (gaiaId) {
                getSearchFormPriceInsights();
                if (!isCalendarTab) {
                    logShowMonthlyPriceInsightsExposure(showMonthlyPriceInsightsExposure);
                }
            } else if (priceInsightsPrices && (priceInsightsPrices === null || priceInsightsPrices === void 0 ? void 0 : priceInsightsPrices.length) > 0) {
                setPriceInsightsPrices(null);
            }
        }
        onOpen();
        setIsCalendarOpen(true);
        if (!isCalendarTab) {
            onFlexibleTabSelection === null || onFlexibleTabSelection === void 0 ? void 0 : onFlexibleTabSelection();
        }
    };
    var getFlexibleLabel = function() {
        var _flexibleDateContent_flexibilityLabel;
        var flexibilityLabels = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibilityLabel = flexibleDateContent.flexibilityLabel) === null || _flexibleDateContent_flexibilityLabel === void 0 ? void 0 : _flexibleDateContent_flexibilityLabel.templates;
        var nightSelection = selectedFlexibleDatesNights === null || selectedFlexibleDatesNights === void 0 ? void 0 : selectedFlexibleDatesNights.text;
        var monthsSelection = selectedFlexibleDatesMonths === null || selectedFlexibleDatesMonths === void 0 ? void 0 : selectedFlexibleDatesMonths.map(function(month) {
            return month.shortMonthName;
        });
        var monthsSelected = monthsSelection && monthsSelection.length > 0;
        var labelIndex = monthsSelected && monthsSelection.length > 6 ? 5 : monthsSelection.length - 1;
        var templateLabel = monthsSelected && flexibilityLabels ? flexibilityLabels[labelIndex].template : "";
        var keyValues = monthsSelected ? [
            nightSelection
        ].concat(_to_consumable_array(monthsSelection)) : [];
        var flexibleLocalizedLabel = templateLabel;
        keyValues.forEach(function(key, index) {
            var _flexibleDateContent_flexibilityLabel_models_index, _flexibleDateContent_flexibilityLabel;
            var modelKey = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibilityLabel = flexibleDateContent.flexibilityLabel) === null || _flexibleDateContent_flexibilityLabel === void 0 ? void 0 : (_flexibleDateContent_flexibilityLabel_models_index = _flexibleDateContent_flexibilityLabel.models[index]) === null || _flexibleDateContent_flexibilityLabel_models_index === void 0 ? void 0 : _flexibleDateContent_flexibilityLabel_models_index.key;
            flexibleLocalizedLabel = formatLocalizedTokenString(flexibleLocalizedLabel, modelKey !== null && modelKey !== void 0 ? modelKey : "", key !== null && key !== void 0 ? key : "");
        });
        return flexibleLocalizedLabel;
    };
    React25.useEffect(function() {
        if (includeFlexibleDatesContent) {
            setFlexibleLabel(getFlexibleLabel);
        }
    }, []);
    var getInputTextValue = function() {
        var dates = "".concat(checkInDateString, " - ").concat(checkOutDateString);
        var preFormattedDates = getFormattedDates(dates, localizationContext);
        var trailingText = selectedCalendarPill.trailingText;
        if (trailingText && isCalendarTab && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent)) {
            return "".concat(preFormattedDates, " ").concat(trailingText);
        }
        return dates;
    };
    var resetFlexDateSelection = function() {
        if (prevFlexibleDatesState) {
            var months = prevFlexibleDatesState.months, nights = prevFlexibleDatesState.nights, weekend = prevFlexibleDatesState.weekend;
            if (months) {
                setMonthsSelectionToggleButtons(months);
            }
            if (nights) {
                setNightsSelectionPills(nights);
            }
            if (weekend) {
                setIncludeWeekendCheckbox(weekend);
            }
        }
    };
    var resetContentSelector = function() {
        setContentSelector(function(prevState) {
            if (prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    selectedTabId: prevTabIdState !== null && prevTabIdState !== void 0 ? prevTabIdState : (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : ""
                });
            }
            return null;
        });
    };
    var getUpdatedFlexibleMonthsButtonDataWhenNoMonthsSelected = function() {
        if (monthsSelectionToggleButtons) {
            var options = monthsSelectionToggleButtons.options.map(function(option, index) {
                if (index === 0 || index === 1) {
                    return _object_spread_props(_object_spread({}, option), {
                        selected: !option.selected
                    });
                }
                return option;
            });
            return _object_spread_props(_object_spread({}, monthsSelectionToggleButtons), {
                options: options
            });
        }
        return null;
    };
    var updateFlexibleDates = function() {
        if (includeFlexibleDatesContent) {
            var _prevFlexibleDatesState_weekend;
            var newFlexibleLabel = getFlexibleLabel();
            setFlexibleLabel(newFlexibleLabel);
            var _monthsSelectionToggleButtons_options_some;
            var areMonthsSelectionToggleButtonsSelected = (_monthsSelectionToggleButtons_options_some = monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options.some(function(option) {
                return option.selected;
            })) !== null && _monthsSelectionToggleButtons_options_some !== void 0 ? _monthsSelectionToggleButtons_options_some : false;
            var firstTwoMonthsSelectedData = getUpdatedFlexibleMonthsButtonDataWhenNoMonthsSelected();
            if (!areMonthsSelectionToggleButtonsSelected && firstTwoMonthsSelectedData) {
                setMonthsSelectionToggleButtons(firstTwoMonthsSelectedData);
            }
            var monthsSelectedToggleButtons = areMonthsSelectionToggleButtonsSelected ? monthsSelectionToggleButtons : firstTwoMonthsSelectedData !== null && firstTwoMonthsSelectedData !== void 0 ? firstTwoMonthsSelectedData : monthsSelectionToggleButtons;
            var wasFlexibleDatesContentChanged = (prevFlexibleDatesState === null || prevFlexibleDatesState === void 0 ? void 0 : prevFlexibleDatesState.nights) !== nightsSelectionPills || (prevFlexibleDatesState === null || prevFlexibleDatesState === void 0 ? void 0 : (_prevFlexibleDatesState_weekend = prevFlexibleDatesState.weekend) === null || _prevFlexibleDatesState_weekend === void 0 ? void 0 : _prevFlexibleDatesState_weekend.state) !== (includeWeekendCheckbox === null || includeWeekendCheckbox === void 0 ? void 0 : includeWeekendCheckbox.state) || prevFlexibleDatesState.months !== monthsSelectedToggleButtons;
            setPrevFlexibleDatesState({
                months: monthsSelectedToggleButtons,
                nights: nightsSelectionPills,
                weekend: includeWeekendCheckbox
            });
            setShouldFireChangeEvent(wasFlexibleDatesContentChanged);
        }
        if (hasFlexibleDates) {
            var contentSelectorTabId = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : "";
            setPrevTabIdState(contentSelectorTabId);
            if (prevTabIdState !== contentSelectorTabId) {
                setShouldFireChangeEvent(true);
            }
        }
    };
    var onCloseCB = function() {
        if (allowToControlOpenStateFromOutside) {
            toggleCalendar(false);
        }
        if (!isLargeViewportSize) {
            setDialogActionsTracker(function(prevState) {
                if (prevState) {
                    return _to_consumable_array(prevState).concat([
                        DIALOG_ACTIONS.CLOSE
                    ]);
                }
                return [
                    DIALOG_ACTIONS.CLOSE
                ];
            });
        } else {
            updateFlexibleDates();
        }
        if (noNextDayEndDateExposure.bucket === 1 && checkInDateString && !checkOutDateString) {
            var startDateNextDay = getNextDayOfDate(checkInDateString);
            var _formatDateToString;
            var formattedNewDate = (_formatDateToString = formatDateToString(startDateNextDay)) !== null && _formatDateToString !== void 0 ? _formatDateToString : "";
            setCheckInDateString(checkInDateString);
            setCheckOutDateString(formattedNewDate);
        }
        if (selectedCalendarPill.hasValueChanged && checkInDateString !== "" && checkOutDateString !== "") {
            setShouldFireChangeEvent(true);
            setSelectedCalendarPill(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    hasValueChanged: false
                });
            });
        }
        if (shouldCloseFireChangeEvent) {
            setShouldFireChangeEvent(true);
            setShouldCloseFireChangeEvent(false);
        }
        onClose();
        setIsCalendarOpen(false);
    };
    var onSubmitCB = function(start, end) {
        if (!isLargeViewportSize && hasFlexibleDates) {
            setDialogActionsTracker([
                DIALOG_ACTIONS.SUBMIT
            ]);
            updateFlexibleDates();
        }
        if (!startDate5 && !endDate5 && start && end) {
            setPrevCheckInDateString(start);
            setPrevCheckOutDateString(end);
            setShouldFireChangeEvent(true);
            return;
        }
        if (!start && !end) {
            resetFlexibleDateContent();
        }
        if ((formattedStartDate !== null && formattedStartDate !== void 0 ? formattedStartDate : "") !== start || (formattedEndDate !== null && formattedEndDate !== void 0 ? formattedEndDate : "") !== end) {
            setPrevCheckInDateString(start);
            setPrevCheckOutDateString(end);
            setShouldFireChangeEvent(true);
        }
    };
    var handleFlexibleContentOptionSelection = function(newValue) {
        if (flexibleDateOptions === null || flexibleDateOptions === void 0 ? void 0 : flexibleDateOptions.length) {
            var selectedOption = flexibleDateOptions.find(function(selected) {
                return selected.value === newValue;
            });
            if (selectedOption) {
                var selectAnalytics = selectedOption.selectAnalytics, value = selectedOption.value, primary = selectedOption.primary;
                var trailingText = isFlexibleOptionExactDates(selectedOption) ? "" : "(".concat(primary, ")");
                setSelectedCalendarPill(function(prevState) {
                    var _flexibleDateOptions_find;
                    var _flexibleDateOptions_find_deselectAnalytics;
                    var prevOptionDeselectAnalytics = (_flexibleDateOptions_find_deselectAnalytics = (_flexibleDateOptions_find = flexibleDateOptions.find(function(selected) {
                        return selected.value === prevState.value;
                    })) === null || _flexibleDateOptions_find === void 0 ? void 0 : _flexibleDateOptions_find.deselectAnalytics) !== null && _flexibleDateOptions_find_deselectAnalytics !== void 0 ? _flexibleDateOptions_find_deselectAnalytics : null;
                    if (prevOptionDeselectAnalytics) {
                        clickTracker(prevOptionDeselectAnalytics.referrerId, prevOptionDeselectAnalytics.linkName);
                    }
                    return {
                        value: value,
                        trailingText: trailingText,
                        prevValue: prevState.value,
                        hasValueChanged: true
                    };
                });
                if (selectAnalytics) {
                    clickTracker(selectAnalytics.referrerId, selectAnalytics.linkName);
                }
            }
        }
    };
    var maxDate = React25.useMemo(function() {
        return validDaysUpperBoundInclusive ? convertToDateObject(validDaysUpperBoundInclusive) : addMaxDateToToday(daysBookableInAdvance);
    }, [
        daysBookableInAdvance,
        validDaysUpperBoundInclusive
    ]);
    var minDate = React25.useMemo(function() {
        return validDaysLowerBoundInclusive2 ? convertToDateObject(validDaysLowerBoundInclusive2) : void 0;
    }, [
        validDaysLowerBoundInclusive2
    ]);
    var dayData = React25.useMemo(function() {
        return {
            defaults: {
                validStartDate: minDate,
                validEndDate: maxDate
            }
        };
    }, [
        minDate,
        maxDate
    ]);
    var DATE_SELECTOR_NAME_PREFIX = "EGDSDateRange-date-selector-trigger";
    var onContentSelectorSelection = function(tabId) {
        showStartDateEndDateHiddenInputs((contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? tabId === calendarTabId : false);
        setContentSelector(function(prevState) {
            if (prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    selectedTabId: tabId
                });
            }
            return null;
        });
        if (tabId !== calendarTabId) {
            onFlexibleTabSelection === null || onFlexibleTabSelection === void 0 ? void 0 : onFlexibleTabSelection();
            logShowMonthlyPriceInsightsExposure(showMonthlyPriceInsightsExposure);
        }
    };
    var _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend;
    var _React25_useState18 = _sliced_to_array(React25.useState((_flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection.includeWeekend) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend : null), 2), includeWeekendCheckbox = _React25_useState18[0], setIncludeWeekendCheckbox = _React25_useState18[1];
    var _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state;
    var _React25_useState19 = _sliced_to_array(React25.useState((_flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent1 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent1 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection1 = _flexibleDateContent_flexibleDatesContent1.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection1 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection1.includeWeekend.state) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state : "UNCHECKED" /* UNCHECKED */ ), 2), includeWeekendCheckboxNightsState = _React25_useState19[0], setIncludeWeekendCheckboxDaysState = _React25_useState19[1];
    var onIncludeWeekendCheck = function(event) {
        var newCheckboxState = event.target.checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
        setIncludeWeekendCheckbox(function(prevState) {
            if (prevState != null) {
                var _nightsSelectionPills_find_value, _nightsSelectionPills_find;
                var areNightsSelected = nightsSelectionPills === null || nightsSelectionPills === void 0 ? void 0 : (_nightsSelectionPills_find = nightsSelectionPills.find(function(nights) {
                    return nights.selected;
                })) === null || _nightsSelectionPills_find === void 0 ? void 0 : (_nightsSelectionPills_find_value = _nightsSelectionPills_find.value) === null || _nightsSelectionPills_find_value === void 0 ? void 0 : _nightsSelectionPills_find_value.includes("DAY");
                if (areNightsSelected) {
                    setIncludeWeekendCheckboxDaysState(newCheckboxState);
                }
                return _object_spread_props(_object_spread({}, prevState), {
                    state: newCheckboxState
                });
            }
            return null;
        });
    };
    var _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map;
    var defaultNightsSelectionPills = (_flexibleDateContent_flexibleDatesContent_nightsSelection_options_map = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent2 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent2 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection2 = _flexibleDateContent_flexibleDatesContent2.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection2 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection2.options.map(function(option) {
        var _option_primary, _option_value, _option_name;
        return {
            selected: option.selected,
            checked: false,
            text: (_option_primary = option.primary) !== null && _option_primary !== void 0 ? _option_primary : "",
            disabled: option.disabled,
            value: (_option_value = option.value) !== null && _option_value !== void 0 ? _option_value : "",
            id: (_option_name = option.name) !== null && _option_name !== void 0 ? _option_name : "",
            altText: ""
        };
    })) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map : [];
    var _React25_useState20 = _sliced_to_array(React25.useState(defaultNightsSelectionPills), 2), nightsSelectionPills = _React25_useState20[0], setNightsSelectionPills = _React25_useState20[1];
    var trackOnPillSelect = function(selectedPillValue) {
        var _flexibleDateContent_flexibleDatesContent_nightsSelection_options_index, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent;
        var index = nightsSelectionPills.findIndex(function(pill) {
            return pill.value === selectedPillValue;
        });
        var analytics = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection_options_index = _flexibleDateContent_flexibleDatesContent_nightsSelection.options[index]) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection_options_index === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection_options_index.selectAnalytics;
        if ((analytics === null || analytics === void 0 ? void 0 : analytics.linkName) && (analytics === null || analytics === void 0 ? void 0 : analytics.referrerId)) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    };
    var onNightSelectionPillChange = function(selectedPillValue) {
        setNightsSelectionPills(function(prevState) {
            return prevState.map(function(option) {
                return option.value === selectedPillValue ? _object_spread_props(_object_spread({}, option), {
                    selected: true
                }) : _object_spread_props(_object_spread({}, option), {
                    selected: false
                });
            });
        });
        trackOnPillSelect(selectedPillValue);
        setIncludeWeekendCheckbox(function(prevState) {
            var _nightsSelectionPills_find;
            if (prevState === null) {
                return null;
            }
            if (selectedPillValue.includes("WEEK") || selectedPillValue.includes("6_DAY_LOWER,7_DAY_UPPER") || selectedPillValue.includes("MONTH")) {
                return _object_spread_props(_object_spread({}, prevState), {
                    state: "CHECKED" /* CHECKED */ ,
                    enabled: false
                });
            }
            var weekPreviousValue = nightsSelectionPills === null || nightsSelectionPills === void 0 ? void 0 : (_nightsSelectionPills_find = nightsSelectionPills.find(function(nights) {
                return nights.selected;
            })) === null || _nightsSelectionPills_find === void 0 ? void 0 : _nightsSelectionPills_find.value;
            var isWeekPreviousSelection = (weekPreviousValue === null || weekPreviousValue === void 0 ? void 0 : weekPreviousValue.includes("WEEK")) || (weekPreviousValue === null || weekPreviousValue === void 0 ? void 0 : weekPreviousValue.includes("6_DAY_LOWER,7_DAY_UPPER")) || (weekPreviousValue === null || weekPreviousValue === void 0 ? void 0 : weekPreviousValue.includes("MONTH"));
            if (selectedPillValue.includes("DAY") && isWeekPreviousSelection) {
                return _object_spread_props(_object_spread({}, prevState), {
                    state: includeWeekendCheckboxNightsState,
                    enabled: true
                });
            }
            return _object_spread_props(_object_spread({}, prevState), {
                enabled: true
            });
        });
    };
    var _flexibleDateContent_flexibleDatesContent_monthsSelection_options;
    var _React25_useState21 = _sliced_to_array(React25.useState((_flexibleDateContent_flexibleDatesContent_monthsSelection_options = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent3 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent3 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection = _flexibleDateContent_flexibleDatesContent3.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection.options) !== null && _flexibleDateContent_flexibleDatesContent_monthsSelection_options !== void 0 ? _flexibleDateContent_flexibleDatesContent_monthsSelection_options : null), 2), monthsSelectionToggleButtons = _React25_useState21[0], setMonthsSelectionToggleButtons = _React25_useState21[1];
    React25.useEffect(function() {
        if (priceInsightsMonths) {
            setMonthsSelectionToggleButtons(function(prevState) {
                if (prevState) {
                    return _object_spread_props(_object_spread({}, prevState), {
                        options: priceInsightsMonths
                    });
                }
                return null;
            });
        }
    }, [
        priceInsightsMonths
    ]);
    var onMonthSelectionToggle = function(selectedButton) {
        setMonthsSelectionToggleButtons(function(prevState) {
            if (prevState) {
                var options = prevState.options.map(function(option) {
                    if (option.name === selectedButton.target.name) {
                        return _object_spread_props(_object_spread({}, option), {
                            selected: !option.selected
                        });
                    }
                    return option;
                });
                return _object_spread_props(_object_spread({}, prevState), {
                    options: options
                });
            }
            return null;
        });
    };
    var getDateMonthStringAndShortName = function(selectedFlexibleMonths) {
        return selectedFlexibleMonths === null || selectedFlexibleMonths === void 0 ? void 0 : selectedFlexibleMonths.map(function(button) {
            var _button_name;
            var nameProperties = (_button_name = button.name) === null || _button_name === void 0 ? void 0 : _button_name.split("_");
            var _nameProperties_splice_join;
            var monthsDate = (_nameProperties_splice_join = nameProperties === null || nameProperties === void 0 ? void 0 : nameProperties.splice(nameProperties.length - 2, nameProperties.length).join("_")) !== null && _nameProperties_splice_join !== void 0 ? _nameProperties_splice_join : "";
            var shortMonthName = nameProperties ? nameProperties[nameProperties.length - 1] : "";
            return {
                shortMonthName: shortMonthName,
                monthsDate: monthsDate
            };
        }).filter(function(option) {
            return !!option.monthsDate && !!option.shortMonthName;
        });
    };
    var getSelectedFlexibleOptions = function() {
        var selectedFlexibleDatesNights2 = nightsSelectionPills.find(function(pill) {
            return pill.selected === true;
        });
        var defaultFlexibleMonths = monthsSelectionToggleButtons ? [
            monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options[0],
            monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options[1]
        ] : [];
        var selectedFlexibleMonthsToggleButtons = monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options.filter(function(option) {
            return option.selected;
        });
        var selectedFlexibleDatesMonths2 = getDateMonthStringAndShortName(selectedFlexibleMonthsToggleButtons && (selectedFlexibleMonthsToggleButtons === null || selectedFlexibleMonthsToggleButtons === void 0 ? void 0 : selectedFlexibleMonthsToggleButtons.length) > 0 ? selectedFlexibleMonthsToggleButtons : defaultFlexibleMonths);
        return {
            selectedFlexibleDatesNights: selectedFlexibleDatesNights2,
            selectedFlexibleDatesMonths: selectedFlexibleDatesMonths2
        };
    };
    var _ref1 = includeFlexibleDatesContent ? getSelectedFlexibleOptions() : {
        selectedFlexibleDatesNights: void 0,
        selectedFlexibleDatesMonths: []
    }, selectedFlexibleDatesNights = _ref1.selectedFlexibleDatesNights, selectedFlexibleDatesMonths = _ref1.selectedFlexibleDatesMonths;
    var calendarWrapperProps = {
        data: flexibleDateContent,
        onNightSelectionPillChange: onNightSelectionPillChange,
        nightsSelectionPills: nightsSelectionPills,
        includeWeekendCheckbox: includeWeekendCheckbox,
        onIncludeWeekendCheck: onIncludeWeekendCheck,
        onMonthSelectionToggle: onMonthSelectionToggle,
        monthsSelectionToggleButtons: monthsSelectionToggleButtons,
        onContentSelectorSelection: onContentSelectorSelection,
        contentSelector: contentSelector,
        priceInsightsPrices: priceInsightsPrices,
        isPriceInsightsDataLoading: loading
    };
    var calendarWrapper = (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector) && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleDatesContent) ? {
        component: EGDSDatePickerFlexibilityContent,
        props: calendarWrapperProps
    } : void 0;
    var alertTemplateComponent = (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent) && (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.calendarContent) ? EGDSDatePickerFlexibilityCalendarContent : void 0;
    var hasFlexibleDates = !!calendarWrapper;
    var hasFlexibleCalendarContent = flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent;
    var alertTemplateDataClassName = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" && isCalendarTab ? "" : "is-visually-hidden is-hidden";
    var _ref2, _selectedCalendarPill_trailingText;
    var dateSelectorProps = {
        inputName1: DATE_SELECTOR_NAME_PREFIX,
        input1Stid: input1Stid !== null && input1Stid !== void 0 ? input1Stid : "default",
        autoCloseOnSelection: autoCloseCalendarExposure.bucket === 1,
        allowClearDates: (_ref2 = allowClearDates && isCalendarTab) !== null && _ref2 !== void 0 ? _ref2 : false,
        clearButtonLabel: clearButtonText,
        dateFormatOptions: {
            month: "short",
            day: "numeric"
        },
        dayNameLength: "narrow",
        dayTemplateComponent: DateRangeSelectorDayTemplate,
        dayData: dayData,
        endDate: checkOutDateString,
        enableSameDayDateRange: enableSameDayDateRange,
        inputLabel1: startButtonLabel,
        inputLabel2: endStartButtonLabel,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onDateRangeChange: onDateRangeChange,
        onDateRangeClear: onDateRangeClear,
        onClose: onCloseCB,
        onSubmit: onSubmitCB,
        onOpen: onOpenCB,
        invalidInput1: startDateErrorMessage,
        startDate: checkInDateString,
        submitButtonLabel: dynamicButtonText,
        useSingleTrigger: true,
        initialOpenState: initialOpenState,
        startDateRef: startDateRef,
        onNextClicked: onNextCalendarClick,
        onPrevClicked: onPreviousCalendarClick,
        handleShape: "circle",
        alertTemplateComponent: alertTemplateComponent,
        alertTemplateData: {
            data: flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.calendarContent,
            onSelect: handleFlexibleContentOptionSelection,
            currentlySelectedPillValue: selectedCalendarPill.value,
            className: hasFlexibleDates ? alertTemplateDataClassName : ""
        },
        calendarWrapper: calendarWrapper,
        trailingText1: hasFlexibleCalendarContent && !includeFlexibleDatesContent ? (_selectedCalendarPill_trailingText = selectedCalendarPill.trailingText) !== null && _selectedCalendarPill_trailingText !== void 0 ? _selectedCalendarPill_trailingText : "" : void 0,
        dialogId: dialogId,
        inputValue1: includeFlexibleDatesContent ? flexibleLabel : void 0,
        popoverWidth: popoverWidth
    };
    var _selectedCalendarPill_value;
    return /* @__PURE__ */ React25.createElement(React25.Fragment, null, /* @__PURE__ */ React25.createElement(UitkDateSelector, _object_spread({}, dateSelectorProps)), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent4 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent4 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection3 = _flexibleDateContent_flexibleDatesContent4.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection3 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection3.includeWeekend) && (includeWeekendCheckbox === null || includeWeekendCheckbox === void 0 ? void 0 : includeWeekendCheckbox.state) === "CHECKED" /* CHECKED */  && hasFlexibleDates && !isCalendarTab && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": FLEXIBILITY_NIGHTS_WEEKEND_NAME_PREFIX,
        name: "".concat(FLEXIBILITY_NIGHTS_WEEKEND_NAME_PREFIX, "-").concat((_flexibleDateContent_flexibleDatesContent_nightsSelection4 = flexibleDateContent.flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection4 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection4.includeWeekend.name),
        value: "INCLUDE_WEEKEND"
    }), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent5 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent5 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection5 = _flexibleDateContent_flexibleDatesContent5.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection5 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection5.options) && selectedFlexibleDatesNights && hasFlexibleDates && !isCalendarTab && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": FLEXIBILITY_NIGHTS_OPTIONS_NAME_PREFIX,
        name: "".concat(FLEXIBILITY_NIGHTS_OPTIONS_NAME_PREFIX, "-").concat(selectedFlexibleDatesNights.id),
        value: selectedFlexibleDatesNights.value
    }), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent6 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent6 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection1 = _flexibleDateContent_flexibleDatesContent6.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection1 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection1.options) && hasFlexibleDates && !isCalendarTab && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": FLEXIBILITY_MONTHS_NAME_PREFIX,
        name: FLEXIBILITY_MONTHS_NAME_PREFIX,
        value: selectedFlexibleDatesMonths.map(function(month) {
            return month.monthsDate;
        }).join("/")
    }), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.calendarContent) && hasFlexibleCalendarContent && isCalendarTab && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX,
        name: "".concat(FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX, "-").concat((_flexibleDateContent_calendarContent1 = flexibleDateContent.calendarContent) === null || _flexibleDateContent_calendarContent1 === void 0 ? void 0 : _flexibleDateContent_calendarContent1.formElementId),
        value: (_selectedCalendarPill_value = selectedCalendarPill.value) !== null && _selectedCalendarPill_value !== void 0 ? _selectedCalendarPill_value : ""
    }));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/egds-price-calendar.tsx
var import_lodash = __toESM(require_lodash());
import React31 from "react";
import { UitkDateSelector as UitkDateSelector2 } from "@egds/react-core/date-selector";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/utils/date-utils.ts
var getLOBCalendarPrices = function(lobName, data) {
    switch(lobName){
        case "flights":
            var _data_flightsPriceCalendar;
            return data === null || data === void 0 ? void 0 : (_data_flightsPriceCalendar = data.flightsPriceCalendar) === null || _data_flightsPriceCalendar === void 0 ? void 0 : _data_flightsPriceCalendar.calendarPrices;
    }
};
var getDayData = function(lobName, data) {
    var availabilityDayData = {
        defaults: {
            dateText: {
                textWeight: "bold",
                textTheme: null,
                textValue: null
            }
        }
    };
    var calendarPrices = getLOBCalendarPrices(lobName, data);
    if (calendarPrices) {
        calendarPrices.forEach(function(dayPrice) {
            var _dayPrice_theme;
            var _dayPrice_theme_toLowerCase;
            var dateCell = {
                dateText: {
                    textWeight: dayPrice.theme ? "bold" : null,
                    textTheme: (_dayPrice_theme_toLowerCase = (_dayPrice_theme = dayPrice.theme) === null || _dayPrice_theme === void 0 ? void 0 : _dayPrice_theme.toLowerCase()) !== null && _dayPrice_theme_toLowerCase !== void 0 ? _dayPrice_theme_toLowerCase : null,
                    textValue: dayPrice.label
                }
            };
            availabilityDayData["".concat(dayPrice.date)] = dateCell;
        });
    }
    return availabilityDayData;
};
var getDateFromDateString = function(date) {
    if (date) {
        return /* @__PURE__ */ new Date("".concat(date, "T00:00:00"));
    }
    return /* @__PURE__ */ new Date();
};
var getToday = function() {
    var todayAsDate = /* @__PURE__ */ new Date();
    return new Date(todayAsDate.getFullYear(), todayAsDate.getMonth(), todayAsDate.getDate());
};
var addNDays = function(date, days) {
    var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
var getStringFromDate = function(date) {
    var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    var localDate = date.toLocaleDateString("en-US", options);
    var parts = localDate.split("/");
    return "".concat(parts[2], "-").concat(parts[0], "-").concat(parts[1]);
};
var updateJourneyCriteria = function(departureDate, returnDate, origin2, destination4) {
    var journeyCriteria = [
        {
            departureDate: {
                day: departureDate.getDate(),
                month: departureDate.getMonth() + 1,
                year: departureDate.getFullYear()
            },
            destination: destination4,
            origin: origin2
        }
    ];
    if (departureDate !== returnDate) {
        journeyCriteria = [
            {
                departureDate: {
                    day: departureDate.getDate(),
                    month: departureDate.getMonth() + 1,
                    year: departureDate.getFullYear()
                },
                destination: destination4,
                origin: origin2
            },
            {
                departureDate: {
                    day: returnDate.getDate(),
                    month: returnDate.getMonth() + 1,
                    year: returnDate.getFullYear()
                },
                destination: origin2,
                origin: destination4
            }
        ];
    }
    return journeyCriteria;
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/calendar-content-message.tsx
import React26 from "react";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing5 } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { ViewLarge as ViewLarge2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var calendarContentPropsSmall = {
    padding: {
        blockend: "three"
    }
};
var calendarContentProps = {
    padding: {
        blockend: "four"
    }
};
var CalendarContentMessage = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React26.createElement(UitkLayoutFlex2, {
        justifyContent: "center"
    }, /* @__PURE__ */ React26.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React26.createElement(Viewport4, null, /* @__PURE__ */ React26.createElement(ViewSmall4, null, /* @__PURE__ */ React26.createElement(UitkSpacing5, {
        padding: calendarContentPropsSmall.padding
    }, /* @__PURE__ */ React26.createElement(UitkText, {
        size: 200,
        weight: "regular"
    }, data))), /* @__PURE__ */ React26.createElement(ViewLarge2, null, /* @__PURE__ */ React26.createElement(UitkSpacing5, {
        padding: calendarContentProps.padding
    }, /* @__PURE__ */ React26.createElement(UitkText, {
        size: 200,
        weight: "regular"
    }, data))))));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/use-price-calendar.ts
import React30 from "react";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/utils/query-utils.ts
import { useLazyQuery as useLazyQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/flights-price-calendar-query.ts
import { gql as gql26 } from "@apollo/client";
// ../internal/src/components/common/client-side-analytics.ts
import { gql as gql22 } from "@apollo/client";
var clientSideAnalyticsFragment = gql22(_templateObject22());
// ../internal/src/components/common/egds-text/egds-graphic-text.tsx
import React29 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3, UitkSpacing as UitkSpacing6 } from "@egds/react-core/spacing";
import { UitkText as UitkText2 } from "@egds/react-core/text";
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
import React28 from "react";
import { gql as gql24 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic/mark.tsx
import React27 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment = gql23(_templateObject23());
var Mark = function(param) {
    var data = param.data, className = param.className;
    return /* @__PURE__ */ React27.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment;
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
var fragment2 = gql24(_templateObject24(), Icon.fragment, Mark.fragment);
var UIGraphic = function(param) {
    var data = param.data, markOptions = param.markOptions;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React28.createElement(Icon, {
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React28.createElement(Mark, _object_spread({
                data: data
            }, markOptions));
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment2;
// ../internal/src/components/common/egds-text/egds-graphic-text.tsx
var fragment3 = gql25(_templateObject25(), UIGraphic.fragment);
var EGDSGraphicText = function(param) {
    var inline = param.inline, size = param.size, graphicSpacing = param.graphicSpacing, data = param.data;
    var accessibility = data.accessibility, text = data.text, graphic = data.graphic, trailingGraphics = data.trailingGraphics;
    var hasA11yContent = accessibility && accessibility.length > 0;
    var textContent = hasA11yContent ? /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement("span", {
        "aria-hidden": hasA11yContent
    }, text), /* @__PURE__ */ React29.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)) : text;
    return /* @__PURE__ */ React29.createElement(UitkText2, {
        inline: inline
    }, /* @__PURE__ */ React29.createElement(EGDSSpacing3, {
        padding: graphicSpacing === null || graphicSpacing === void 0 ? void 0 : graphicSpacing.padding,
        margin: graphicSpacing === null || graphicSpacing === void 0 ? void 0 : graphicSpacing.margin
    }, /* @__PURE__ */ React29.createElement(UIGraphic, {
        data: graphic
    })), /* @__PURE__ */ React29.createElement(UitkSpacing6, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React29.createElement(UitkText2, {
        inline: true,
        size: size
    }, textContent)), trailingGraphics === null || trailingGraphics === void 0 ? void 0 : trailingGraphics.map(function(graphicItem, index) {
        return /* @__PURE__ */ React29.createElement(UIGraphic, {
            data: graphicItem,
            key: "trailing-graphic-".concat(index)
        });
    }));
};
EGDSGraphicText.displayName = "EGDSGraphicText";
EGDSGraphicText.fragment = fragment3;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/flights-price-calendar-query.ts
var __FlightsPriceCalendarQuery = gql26(_templateObject26(), EGDSGraphicText.fragment, clientSideAnalyticsFragment);
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/utils/query-utils.ts
var useLazyFetchFlightsPriceCalendar = function(queryInputs) {
    var context = useBexApi2().context;
    return useLazyQuery2(__FlightsPriceCalendarQuery, {
        ssr: false,
        fetchPolicy: "no-cache",
        variables: _object_spread({
            context: context
        }, queryInputs)
    });
};
var getODInputs = function(isOutbound, journeyCriteria) {
    if (isOutbound) {
        return {
            origin: journeyCriteria[0].origin,
            destination: journeyCriteria[0].destination
        };
    }
    return {
        origin: journeyCriteria[1].origin,
        destination: journeyCriteria[1].destination
    };
};
var getFlightsInputs = function(queryInputs) {
    var journeyCriteria = queryInputs.journeyCriteria, flightsSearchContext = queryInputs.flightsSearchContext;
    var _getODInputs = getODInputs(flightsSearchContext.tripType === "ROUND_TRIP" /* ROUND_TRIP */ , journeyCriteria), origin2 = _getODInputs.origin, destination4 = _getODInputs.destination;
    return {
        flightsSearchContext: flightsSearchContext,
        origin: origin2,
        destination: destination4
    };
};
var getUpdatedQueryVariables = function(props) {
    var lobName = props.lobName, effectiveStartDate = props.effectiveStartDate, effectiveEndDate = props.effectiveEndDate, flightsSearchContext = props.flightsSearchContext, origin2 = props.origin, destination4 = props.destination;
    switch(lobName){
        case "flights":
            {
                var journeyCriteria = updateJourneyCriteria(effectiveStartDate, effectiveEndDate, origin2, destination4);
                return {
                    journeyCriteria: journeyCriteria,
                    flightsSearchContext: flightsSearchContext
                };
            }
    }
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/use-price-calendar.ts
var getQueryFetcher = function(lobName) {
    switch(lobName){
        case "flights":
            return useLazyFetchFlightsPriceCalendar;
    }
};
var getQueryInputs = function(lobName, queryInputs) {
    switch(lobName){
        case "flights":
            return getFlightsInputs(queryInputs);
    }
};
var resolveCalendarSearchDates = function(startDate5, isEndDateSelected) {
    var today5 = getToday();
    var effectiveStartDate = startDate5 < today5 ? today5 : startDate5;
    var effectiveEndDate = effectiveStartDate;
    if (isEndDateSelected) {
        effectiveEndDate = addNDays(effectiveStartDate, 14);
    }
    return {
        effectiveStartDate: effectiveStartDate,
        effectiveEndDate: effectiveEndDate
    };
};
var usePriceCalendar = function(lobName, queryInputs) {
    var _React30_useState = _sliced_to_array(React30.useState(void 0), 2), dayData = _React30_useState[0], setDayData = _React30_useState[1];
    var queryFetchFunction = getQueryFetcher(lobName);
    var _queryFetchFunction = _sliced_to_array(queryFetchFunction(queryInputs), 2), fetchPriceCalendarLazy = _queryFetchFunction[0], data = _queryFetchFunction[1].data;
    var queryVariables = getQueryInputs(lobName, queryInputs);
    React30.useEffect(function() {
        if (data) {
            setDayData(getDayData(lobName, data));
        }
    }, [
        data,
        lobName
    ]);
    var fetchCalendarPrices = function(startDate5) {
        var isEndDateSelected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setDayData(void 0);
        var _resolveCalendarSearchDates = resolveCalendarSearchDates(startDate5, isEndDateSelected), effectiveStartDate = _resolveCalendarSearchDates.effectiveStartDate, effectiveEndDate = _resolveCalendarSearchDates.effectiveEndDate;
        var variables = getUpdatedQueryVariables(_object_spread({
            lobName: lobName,
            effectiveStartDate: effectiveStartDate,
            effectiveEndDate: effectiveEndDate
        }, queryVariables));
        fetchPriceCalendarLazy({
            variables: variables
        });
    };
    return [
        fetchCalendarPrices,
        dayData
    ];
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/egds-price-calendar.tsx
var SCROLL_DEBOUNCE_DELAY = 1e3;
var EGDSPriceCalendar = function(param) {
    var lobName = param.lobName, queryInputs = param.queryInputs;
    var _usePriceCalendar = _sliced_to_array(usePriceCalendar(lobName, queryInputs), 2), fetchCalendarPrices = _usePriceCalendar[0], dayData = _usePriceCalendar[1];
    var _React31_useState = _sliced_to_array(React31.useState(null), 2), startDate5 = _React31_useState[0], setStartDate = _React31_useState[1];
    var _React31_useState1 = _sliced_to_array(React31.useState(null), 2), endDate5 = _React31_useState1[0], setEndDate = _React31_useState1[1];
    var today5 = /* @__PURE__ */ new Date();
    var onOpen = function() {
        var startDateSelected = getDateFromDateString(startDate5);
        if (startDateSelected.getMonth() > today5.getMonth()) {
            fetchCalendarPrices(new Date(startDateSelected.getFullYear(), startDateSelected.getMonth(), 1), false);
        } else {
            fetchCalendarPrices(today5, false);
        }
    };
    var onNavigationClicked = function(param, isPreviousMonthClicked) {
        var month = param.month, year = param.year;
        var day = isPreviousMonthClicked && today5.getMonth() === month ? today5.getDate() : 1;
        fetchCalendarPrices(new Date(year, month, day), false);
    };
    var onPrevClicked = function(param) {
        var month = param.month, year = param.year;
        onNavigationClicked({
            month: month,
            year: year
        }, true);
    };
    var onNextClicked = function(param) {
        var month = param.month, year = param.year;
        onNavigationClicked({
            month: month,
            year: year
        }, false);
    };
    var onDateRangeChange = function(startDateString, endDateString) {
        setStartDate(startDateString);
        setEndDate(endDateString);
        if (startDateString && !endDateString && queryInputs.flightsSearchContext.tripType === "ROUND_TRIP" /* ROUND_TRIP */ ) {
            fetchCalendarPrices(getDateFromDateString(startDateString), true);
            setEndDate(getStringFromDate(addNDays(getDateFromDateString(startDateString), 1)));
        }
    };
    var maxDate = /* @__PURE__ */ new Date();
    maxDate.setDate(maxDate.getDate() + 330);
    var dateSelectorLabelProps = {
        startLabel: "Departure",
        endLabel: "Return",
        buttonText: "Done"
    };
    var onScrollHandler = (0, import_lodash.default)(function(date) {}, SCROLL_DEBOUNCE_DELAY);
    var onClose = function() {};
    var onSubmit = function() {};
    var dateSelectorProps = {
        locale: "en-US",
        useSingleTrigger: true,
        dayNameLength: "narrow",
        handleShape: "circle",
        startDate: startDate5,
        endDate: endDate5,
        dayData: dayData,
        onOpen: onOpen,
        onDateRangeChange: onDateRangeChange,
        onNextClicked: onNextClicked,
        onPrevClicked: onPrevClicked,
        dateFormatOptions: {
            month: "short",
            day: "numeric"
        },
        alertTemplateComponent: CalendarContentMessage,
        alertTemplateData: {
            data: "prices are shown as flightType in USD"
        },
        isSingleDateSelection: queryInputs.flightsSearchContext.tripType === "ONE_WAY" /* ONE_WAY */ ,
        enableSameDayDateRange: true,
        numMonthsToDisplay: 2,
        maxDate: maxDate,
        inputLabel1: dateSelectorLabelProps.startLabel,
        inputLabel2: dateSelectorLabelProps.endLabel,
        submitButtonLabel: dateSelectorLabelProps.buttonText,
        onScrollHandler: onScrollHandler,
        allowClearDates: false,
        onClose: onClose,
        onSubmit: onSubmit
    };
    return /* @__PURE__ */ React31.createElement("div", {
        "data-testid": "egds_price_calendar"
    }, /* @__PURE__ */ React31.createElement(UitkDateSelector2, _object_spread({}, dateSelectorProps)));
};
EGDSPriceCalendar.displayName = "EGDSPriceCalendar";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range-picker.tsx
var __Fragment20 = gql27(_templateObject27(), EGDSDatePickerFlexibilityContent.fragment);
var NIGHTS_FIELD_NAME = "EGDSDatePickerFlexibleNights";
var DISPLAY_NAME6 = "EGDSDateRangePicker";
var DATE_PICKER_PREFIX_MAP = {
    START_DATE_NAME_PREFIX: "".concat(DISPLAY_NAME6, "-StartDate"),
    END_DATE_NAME_PREFIX: "".concat(DISPLAY_NAME6, "-EndDate"),
    PARTIAL_STAY_START_DATE_NAME_PREFIX: "EGDSDateRangePartialStay-StartDate",
    PARTIAL_STAY_END_DATE_NAME_PREFIX: "EGDSDateRangePartialStay-EndDate",
    SOFT_PACKAGES_START_DATE_NAME_PREFIX: "EGDSDateRangePickerSoftPackages-StartDate",
    SOFT_PACKAGES_END_DATE_NAME_PREFIX: "EGDSDateRangePickerSoftPackages-EndDate",
    FLEXIBILITY_PREFIX: "EGDSDatePickerFlexibilityCalendarContent-SelectedOption",
    FLEXIBILITY_NIGHTS_PREFIX: "".concat(NIGHTS_FIELD_NAME, "-Options"),
    FLEXIBILITY_WEEKEND_PREFIX: "".concat(NIGHTS_FIELD_NAME, "-Weekend"),
    FLEXIBILITY_MONTHS_PREFIX: "EGDSDatePickerFlexibleMonths-Options"
};
var DATE_FORMAT = "yyyy-MM-dd";
var EGDSDateRangePicker = function(props) {
    var _flexibleDateContent_contentSelector, _flexibleDateContent_contentSelector1;
    var clickTracker = useClickTracker10();
    var data = props.data, analytics = props.analytics, egdsElementId = props.egdsElementId, label = props.label, overrideValidDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive, skipReflection = props.skipReflection, onOpenDatesField = props.onOpenDatesField, updatePlaybackDates = props.updatePlaybackDates, lobName = props.lobName, enablePriceCalendar = props.enablePriceCalendar, priceCalendarInputs = props.priceCalendarInputs, popoverWidth = props.popoverWidth;
    var __typename = data.__typename, selectedStartDate = data.selectedStartDate, selectedEndDate = data.selectedEndDate, validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive, sameDaySelectionAllowed = data.sameDaySelectionAllowed, clearButtonText = data.clearButtonText, showClearDatesButton = data.showClearDatesButton, startDatePlaceholderText = data.startDatePlaceholderText, endDatePlaceholderText = data.endDatePlaceholderText, clearDatesButtonAnalytics = data.clearDatesButtonAnalytics, endDateButtonAnalytics = data.endDateButtonAnalytics, startDateButtonAnalytics = data.startDateButtonAnalytics, submitButtonAnalytics = data.submitButtonAnalytics, nextButtonAnalytics = data.nextButtonAnalytics, previousButtonAnalytics = data.previousButtonAnalytics, flexibleDateContent = data.flexibleDateContent;
    var _useSearchFormReflectionContext = useSearchFormReflectionContext(), state = _useSearchFormReflectionContext.state, dispatchReflectionAction = _useSearchFormReflectionContext.dispatch;
    var _state_dates;
    var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {}, reflectionStartDate = _ref.start, reflectionEndDate = _ref.end;
    var formatDateString = useLocalization2().formatDateString;
    var defaultStartDate = selectedStartDate ? formatDateString(convertToDateObject(selectedStartDate), {
        raw: DATE_FORMAT
    }) : "";
    var defaultEndDate = selectedEndDate ? formatDateString(convertToDateObject(selectedEndDate), {
        raw: DATE_FORMAT
    }) : "";
    var _React32_useState = _sliced_to_array(React32.useState({
        startDate: defaultStartDate,
        endDate: defaultEndDate
    }), 2), dateState = _React32_useState[0], setDateState = _React32_useState[1];
    var contentSelectorTabs = (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_contentSelector = flexibleDateContent.contentSelector) === null || _flexibleDateContent_contentSelector === void 0 ? void 0 : _flexibleDateContent_contentSelector.__typename) === "EGDSBasicTabs" ? flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector.tabs : null;
    var calendarTabId = contentSelectorTabs && contentSelectorTabs[0].__typename === "EGDSBasicTab" ? contentSelectorTabs[0].tabId : "calendar-tab";
    var _React32_useState1 = _sliced_to_array(React32.useState((flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_contentSelector1 = flexibleDateContent.contentSelector) === null || _flexibleDateContent_contentSelector1 === void 0 ? void 0 : _flexibleDateContent_contentSelector1.__typename) === "EGDSBasicTabs" ? (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector.selectedTabId) === calendarTabId : true), 2), showHiddenInputs = _React32_useState1[0], setShowHiddenInputs = _React32_useState1[1];
    var onHandleHiddenInputsVisibility = function(visibleHiddenInputs) {
        return setShowHiddenInputs(visibleHiddenInputs);
    };
    var getPrefix = function(dateType) {
        if (egdsElementId === "partial-stay-date-range-select") {
            return DATE_PICKER_PREFIX_MAP["PARTIAL_STAY_".concat(dateType, "_DATE_NAME_PREFIX")];
        }
        if (egdsElementId === "soft_packages_date_form_field") {
            return DATE_PICKER_PREFIX_MAP["SOFT_PACKAGES_".concat(dateType, "_DATE_NAME_PREFIX")];
        }
        return DATE_PICKER_PREFIX_MAP["".concat(dateType, "_DATE_NAME_PREFIX")];
    };
    var trackAction = function(action) {
        var _action_referrerId;
        var referrerId = (_action_referrerId = action === null || action === void 0 ? void 0 : action.referrerId) !== null && _action_referrerId !== void 0 ? _action_referrerId : "";
        var _action_linkName;
        var linkName = (_action_linkName = action === null || action === void 0 ? void 0 : action.linkName) !== null && _action_linkName !== void 0 ? _action_linkName : "";
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    var onClearDates = function() {
        return trackAction(clearDatesButtonAnalytics);
    };
    var onSelectEndDate = function() {
        return trackAction(endDateButtonAnalytics);
    };
    var onSelectStartDate = function() {
        return trackAction(startDateButtonAnalytics);
    };
    var onChangeStartDate = function(startDate5) {
        setDateState(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), {
                startDate: startDate5 !== null && startDate5 !== void 0 ? startDate5 : prevState.startDate
            });
        });
        if (updatePlaybackDates) {
            updatePlaybackDates(startDate5, true);
        }
    };
    var onChangeEndDate = function(endDate5) {
        setDateState(function(prevState) {
            if (!skipReflection) {
                dispatchReflectionAction({
                    type: "UPDATE_DATES",
                    end: endDate5,
                    start: prevState.startDate
                });
            }
            if (updatePlaybackDates) {
                updatePlaybackDates(endDate5, false);
            }
            return _object_spread_props(_object_spread({}, prevState), {
                endDate: endDate5 !== null && endDate5 !== void 0 ? endDate5 : prevState.endDate
            });
        });
    };
    var onSubmit = function() {
        return trackAction(submitButtonAnalytics);
    };
    var onClose = function() {
        return trackAction(submitButtonAnalytics);
    };
    var onOpen = function() {
        onOpenDatesField === null || onOpenDatesField === void 0 ? void 0 : onOpenDatesField();
        trackAction(analytics);
    };
    var onNextCalendarClick = function() {
        return trackAction(nextButtonAnalytics);
    };
    var onPreviousCalendarClick = function() {
        return trackAction(previousButtonAnalytics);
    };
    var sharedDateRangeProps = _object_spread({
        onClearDates: onClearDates,
        onSelectEndDate: onSelectEndDate,
        onSelectStartDate: onSelectStartDate,
        onSubmit: onSubmit,
        onClose: onClose,
        onOpen: onOpen,
        onChangeStartDate: onChangeStartDate,
        onChangeEndDate: onChangeEndDate,
        onNextCalendarClick: onNextCalendarClick,
        onPreviousCalendarClick: onPreviousCalendarClick
    }, !skipReflection ? {
        startDateString: reflectionStartDate,
        endDateString: reflectionEndDate
    } : {});
    var dateRangeSelectorProps = _object_spread_props(_object_spread({}, props, data, sharedDateRangeProps), {
        typename: __typename,
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        validDaysUpperBoundInclusive: overrideValidDaysUpperBoundInclusive !== null && overrideValidDaysUpperBoundInclusive !== void 0 ? overrideValidDaysUpperBoundInclusive : validDaysUpperBoundInclusive,
        enableSameDayDateRange: sameDaySelectionAllowed,
        clearButtonText: clearButtonText !== null && clearButtonText !== void 0 ? clearButtonText : "",
        inputLabel1: label !== null && label !== void 0 ? label : startDatePlaceholderText,
        inputLabel2: label !== null && label !== void 0 ? label : endDatePlaceholderText,
        allowClearDates: showClearDatesButton !== null && showClearDatesButton !== void 0 ? showClearDatesButton : false,
        showStartDateEndDateHiddenInputs: onHandleHiddenInputsVisibility
    });
    React32.useEffect(function() {
        if (!skipReflection) {
            setDateState(function(prevState) {
                return _object_spread({}, prevState, reflectionStartDate ? {
                    startDate: reflectionStartDate
                } : {}, reflectionEndDate ? {
                    endDate: reflectionEndDate
                } : {});
            });
        }
    }, [
        setDateState,
        reflectionStartDate,
        reflectionEndDate,
        skipReflection
    ]);
    var verifyPriceCalendarInputs = React32.useCallback(function() {
        var _priceCalendarInputs_journeyCriteria;
        if (lobName === "flights" && priceCalendarInputs && ((_priceCalendarInputs_journeyCriteria = priceCalendarInputs.journeyCriteria) === null || _priceCalendarInputs_journeyCriteria === void 0 ? void 0 : _priceCalendarInputs_journeyCriteria.length) > 0) {
            return priceCalendarInputs;
        }
        return void 0;
    }, [
        lobName,
        priceCalendarInputs
    ]);
    var verifiedPriceCalendarInputs = verifyPriceCalendarInputs();
    var _dateState_startDate, _dateState_endDate;
    return enablePriceCalendar && lobName && verifiedPriceCalendarInputs ? /* @__PURE__ */ React32.createElement(EGDSPriceCalendar, {
        lobName: lobName,
        queryInputs: verifiedPriceCalendarInputs
    }) : /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement(Viewport5, null, /* @__PURE__ */ React32.createElement(ViewSmall5, null, /* @__PURE__ */ React32.createElement(DateRangeSelector, _object_spread_props(_object_spread({}, dateRangeSelectorProps), {
        autoOpen: false
    }))), /* @__PURE__ */ React32.createElement(ViewMedium3, null, /* @__PURE__ */ React32.createElement(DateRangeSelector, _object_spread_props(_object_spread({}, dateRangeSelectorProps), {
        popoverWidth: popoverWidth
    })))), showHiddenInputs && /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement("input", {
        type: "hidden",
        "data-stid": getPrefix("START"),
        name: "".concat(getPrefix("START"), "-").concat(egdsElementId),
        value: (_dateState_startDate = dateState.startDate) !== null && _dateState_startDate !== void 0 ? _dateState_startDate : ""
    }), /* @__PURE__ */ React32.createElement("input", {
        type: "hidden",
        "data-stid": getPrefix("END"),
        name: "".concat(getPrefix("END"), "-").concat(egdsElementId),
        value: (_dateState_endDate = dateState.endDate) !== null && _dateState_endDate !== void 0 ? _dateState_endDate : ""
    })));
};
EGDSDateRangePicker.displayName = DISPLAY_NAME6;
EGDSDateRangePicker.fragment = __Fragment20;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-single-date-picker.tsx
import React33 from "react";
import { gql as gql28 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization3 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext2 } from "@shared-ui/retail-search-tools-reflection-provider";
import { UitkDateSelector as UitkDateSelector3 } from "uitk-react-date-selector";
import { useFormCallback as useFormCallback4 } from "uitk-react-form";
var DISPLAY_NAME7 = "EGDSSingleDatePicker";
var DATE_NAME_PREFIX = "".concat(DISPLAY_NAME7, "-Date");
var DATE_FORMAT2 = "yyyy-MM-dd";
var __Fragment21 = gql28(_templateObject28());
var EGDSSingleDatePicker = function(param) {
    var analytics = param.analytics, data = param.data, egdsElementId = param.egdsElementId, label = param.label, setFieldRefByTypename = param.setFieldRefByTypename, errorMessage = param.errorMessage, index = param.index, showCalendar = param.showCalendar, toggleCalendar = param.toggleCalendar, autoOpen = param.autoOpen, dialogId = param.dialogId, skipReflection = param.skipReflection, updatePlaybackDates = param.updatePlaybackDates, totalLegs = param.totalLegs, input1Stid = param.input1Stid, lobName = param.lobName, enablePriceCalendar = param.enablePriceCalendar, priceCalendarInputs = param.priceCalendarInputs;
    var clickTracker = useClickTracker11();
    var __typename = data.__typename, buttonText = data.buttonText, selectedStartDate = data.selectedStartDate, validDaysLowerBoundInclusive2 = data.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive, startDateButtonAnalytics = data.startDateButtonAnalytics, submitButtonAnalytics = data.submitButtonAnalytics;
    var _useSearchFormReflectionContext2 = useSearchFormReflectionContext2(), state = _useSearchFormReflectionContext2.state, dispatchReflectionAction = _useSearchFormReflectionContext2.dispatch;
    var _state_dates;
    var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {}, reflectionStartDate = _ref.start, reflectionEndDate = _ref.end;
    var formatDateString = useLocalization3().formatDateString;
    var _React33_useState = _sliced_to_array(React33.useState(autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 1), isDateSelectorOpen = _React33_useState[0];
    var today5 = /* @__PURE__ */ new Date();
    var tomorrow = /* @__PURE__ */ new Date();
    tomorrow.setDate(today5.getDate() + 1);
    var _React33_useState1 = _sliced_to_array(React33.useState(formatDateString(today5, {
        raw: DATE_FORMAT2
    })), 2), startDate5 = _React33_useState1[0], setStartDate = _React33_useState1[1];
    var _React33_useState2 = _sliced_to_array(React33.useState(formatDateString(today5, {
        raw: DATE_FORMAT2
    })), 2), validStartDate = _React33_useState2[0], setValidStartDate = _React33_useState2[1];
    var defaultDaysBookableInAdvance = 330;
    var _React33_useState3 = _sliced_to_array(React33.useState(defaultDaysBookableInAdvance), 2), daysBookableInAdvance = _React33_useState3[0], setDaysBookableInAdvance = _React33_useState3[1];
    var handleSubmit = useFormCallback4(function() {
        return "".concat(__typename);
    }(), function(event) {
        return event;
    });
    var _React33_useState4 = _sliced_to_array(React33.useState(false), 2), shouldFireChangeEvent = _React33_useState4[0], setShouldFireChangeEvent = _React33_useState4[1];
    var _React33_useState5 = _sliced_to_array(React33.useState(false), 2), shouldCloseFireChangeEvent = _React33_useState5[0], setShouldCloseFireChangeEvent = _React33_useState5[1];
    React33.useEffect(function() {
        var dateFormatOptions = {
            raw: DATE_FORMAT2
        };
        if (!skipReflection && reflectionStartDate) {
            setStartDate(reflectionStartDate);
        } else if (selectedStartDate) {
            setStartDate(formatDateString(convertToDateObject(selectedStartDate), dateFormatOptions));
        }
        if (validDaysLowerBoundInclusive2) {
            setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive2), dateFormatOptions));
        }
        if (validDaysUpperBoundInclusive) {
            var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */ new Date().getTime();
            setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
        }
    }, [
        formatDateString,
        selectedStartDate,
        validDaysLowerBoundInclusive2,
        validDaysUpperBoundInclusive,
        reflectionStartDate
    ]);
    React33.useEffect(function() {
        if (shouldFireChangeEvent) {
            setShouldFireChangeEvent(false);
            var value = startDate5 ? "".concat(startDate5) : "";
            triggerInputChangeEvent(value, handleSubmit);
        }
    }, [
        shouldFireChangeEvent
    ]);
    var hiddenInputNameSuffix = "".concat(egdsElementId).concat(Number.isInteger(index) ? "-".concat(index) : "");
    var context = useBexApi3().context;
    var DEFAULT_LOCALE2 = "en-US";
    var TYPENAME_REFERENCE2 = "EGDSSearchFormDatePickerField";
    var formatLocale2 = function(locale2) {
        return locale2.replace("_", "-");
    };
    var locale = context.locale ? formatLocale2(context.locale) : DEFAULT_LOCALE2;
    var startDateRef = React33.useRef(null);
    var trackAction = function(action) {
        var _action_referrerId;
        var referrerId = (_action_referrerId = action === null || action === void 0 ? void 0 : action.referrerId) !== null && _action_referrerId !== void 0 ? _action_referrerId : "";
        var _action_linkName;
        var linkName = (_action_linkName = action === null || action === void 0 ? void 0 : action.linkName) !== null && _action_linkName !== void 0 ? _action_linkName : "";
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    React33.useEffect(function() {
        setFieldRefByTypename(TYPENAME_REFERENCE2, startDateRef);
    }, []);
    var onDateChange = function(newStartDate) {
        setShouldFireChangeEvent(false);
        setShouldCloseFireChangeEvent(true);
        setStartDate(newStartDate);
        if (updatePlaybackDates && totalLegs && (index === 0 || index === totalLegs - 1)) {
            updatePlaybackDates(newStartDate, index === 0);
        }
        trackAction(startDateButtonAnalytics);
    };
    var onOpen = function() {
        return trackAction(analytics);
    };
    var onClose = function() {
        trackAction(submitButtonAnalytics);
        if (shouldCloseFireChangeEvent) {
            setShouldFireChangeEvent(true);
            setShouldCloseFireChangeEvent(false);
        }
    };
    var dateSelectorProps = {
        isSingleDateSelection: true,
        input1Stid: input1Stid !== null && input1Stid !== void 0 ? input1Stid : "default",
        startDate: startDate5,
        submitButtonLabel: buttonText,
        inputLabel1: label !== null && label !== void 0 ? label : void 0,
        maxDate: addMaxDateToToday(daysBookableInAdvance),
        autoCloseOnSelection: false,
        allowClearDates: false,
        dateFormatOptions: {
            month: "short",
            day: "numeric"
        },
        dayNameLength: "narrow",
        initialOpenState: isDateSelectorOpen,
        locale: locale,
        handleShape: "circle",
        invalidInput1: errorMessage,
        dialogId: dialogId,
        startDateRef: startDateRef,
        onDateRangeChange: onDateChange,
        onOpen: onOpen,
        onClose: onClose,
        endDate: null
    };
    var verifyPriceCalendarInputs = React33.useCallback(function() {
        var _priceCalendarInputs_journeyCriteria;
        if (lobName === "flights" && priceCalendarInputs && ((_priceCalendarInputs_journeyCriteria = priceCalendarInputs.journeyCriteria) === null || _priceCalendarInputs_journeyCriteria === void 0 ? void 0 : _priceCalendarInputs_journeyCriteria.length) > 0) {
            return priceCalendarInputs;
        }
        return void 0;
    }, [
        lobName,
        priceCalendarInputs
    ]);
    var verifiedPriceCalendarInputs = verifyPriceCalendarInputs();
    return enablePriceCalendar && lobName && verifiedPriceCalendarInputs ? /* @__PURE__ */ React33.createElement(EGDSPriceCalendar, {
        lobName: lobName,
        queryInputs: verifiedPriceCalendarInputs
    }) : /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(UitkDateSelector3, _object_spread({}, dateSelectorProps)), /* @__PURE__ */ React33.createElement("input", {
        type: "hidden",
        "data-stid": DATE_NAME_PREFIX,
        name: "".concat(DATE_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: startDate5
    }));
};
EGDSSingleDatePicker.displayName = DISPLAY_NAME7;
EGDSSingleDatePicker.fragment = __Fragment21;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-search-form-date-picker-field.tsx
var __Fragment22 = gql29(_templateObject29(), EGDSDateRangePicker.fragment, EGDSSingleDatePicker.fragment);
var EGDSSearchFormDatePickerField = function(props) {
    var setFieldRefByTypename = props.setFieldRefByTypename, fieldError = props.fieldError, data = props.data, dialogId = props.dialogId, validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive, overrideErrorMessage = props.overrideErrorMessage, priceCalendarProps = props.priceCalendarProps, popoverWidth = props.popoverWidth;
    var action = data.action, errorMessage = data.errorMessage, validations2 = data.validations;
    var _ref = priceCalendarProps !== null && priceCalendarProps !== void 0 ? priceCalendarProps : {}, lobName = _ref.lobName, enablePriceCalendar = _ref.enablePriceCalendar, priceCalendarInputs = _ref.priceCalendarInputs;
    var dialogIdRef = search_form_date_selector_default();
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "EGDSOpenDatePickerAction") {
        return null;
    }
    var getErrorMessage = function(element) {
        var datePickerValidations = element.validations;
        if ((datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.sameDate) || (datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.endDateBeforeStartDate) || (datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.dateOutsideTripRange)) {
            var _ref;
            return (_ref = overrideErrorMessage !== null && overrideErrorMessage !== void 0 ? overrideErrorMessage : errorMessage) !== null && _ref !== void 0 ? _ref : "";
        }
        if ((datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.maxDate) && validations2 && validations2[0].__typename === "EGDSMaxLengthInputValidation") {
            var _validations2__errorMessage;
            return (_validations2__errorMessage = validations2[0].errorMessage) !== null && _validations2__errorMessage !== void 0 ? _validations2__errorMessage : "";
        }
        return "";
    };
    var errorText = fieldError ? getErrorMessage(fieldError) : "";
    var datePickerProps = _object_spread_props(_object_spread({}, props), {
        analytics: action.analytics,
        setFieldRefByTypename: setFieldRefByTypename,
        errorMessage: errorText,
        dialogId: dialogId || dialogIdRef
    });
    switch(action.datePicker.__typename){
        case "EGDSDateRangePicker":
            return /* @__PURE__ */ React34.createElement(EGDSDateRangePicker, _object_spread_props(_object_spread({}, data, datePickerProps), {
                data: action.datePicker,
                validDaysUpperBoundInclusive: validDaysUpperBoundInclusive,
                lobName: lobName,
                enablePriceCalendar: enablePriceCalendar,
                priceCalendarInputs: priceCalendarInputs,
                popoverWidth: popoverWidth
            }));
        case "EGDSSingleDatePicker":
            {
                return /* @__PURE__ */ React34.createElement(EGDSSingleDatePicker, _object_spread_props(_object_spread({}, data, datePickerProps), {
                    data: action.datePicker,
                    lobName: lobName,
                    enablePriceCalendar: enablePriceCalendar,
                    priceCalendarInputs: priceCalendarInputs
                }));
            }
        default:
            return null;
    }
};
EGDSSearchFormDatePickerField.displayName = "EGDSSearchFormDatePickerField";
EGDSSearchFormDatePickerField.fragment = __Fragment22;
// ../internal/src/components/form/egds-search-form-location-field/egds-search-form-location-field.tsx
import React50 from "react";
import { gql as gql31 } from "@apollo/client";
import { ESSAdapter } from "@egds/react-search-experience";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { useGoogleMapsSdkVersion } from "@shared-ui/retail-map-google-maps-sdk-version-provider";
import { useFormCallback as useFormCallback5 } from "uitk-react-form";
// ../internal/src/components/form/search-location/search-location-event-tracking/utils/optional.tsx
var Optional = /*#__PURE__*/ function() {
    "use strict";
    function _Optional(value) {
        _class_call_check(this, _Optional);
        __publicField(this, "value");
        this.value = value;
    }
    _create_class(_Optional, [
        {
            key: "get",
            value: function get() {
                if (this.isPresent()) {
                    return this.value;
                }
                throw new Error("Exception while trying to get the value of an empty Optional");
            }
        },
        {
            key: "isPresent",
            value: function isPresent() {
                return !_Optional.isEmpty(this.value);
            }
        },
        {
            key: "isNotPresent",
            value: function isNotPresent() {
                return !this.isPresent();
            }
        },
        {
            key: "orElse",
            value: function orElse(alt) {
                if (this.isPresent()) {
                    return this.value;
                }
                return alt;
            }
        }
    ], [
        {
            key: "of",
            value: function of(value) {
                if (_Optional.isEmpty(value)) {
                    throw new Error("Optional.of doesn't accept undefined or null values. Use Optional.ofNullable instead");
                }
                return new _Optional(value);
            }
        },
        {
            key: "ofNullable",
            value: function ofNullable(value) {
                return new _Optional(value);
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new _Optional(null);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === void 0 || typeof value === "undefined";
            }
        }
    ]);
    return _Optional;
}();
// ../internal/src/components/form/search-location/search-location-event-tracking/system-event.tsx
var SystemEvent = /*#__PURE__*/ function() {
    "use strict";
    function SystemEvent(level, name) {
        _class_call_check(this, SystemEvent);
        __publicField(this, "level");
        __publicField(this, "name");
        this.level = level;
        this.name = name;
    }
    _create_class(SystemEvent, [
        {
            /**
   * Get a string value of this event safe for Splunk.
   */ key: "toString",
            value: function toString() {
                return "SystemEvent(level=".concat(this.level.toString(), " name=").concat(this.name, ")");
            }
        }
    ]);
    return SystemEvent;
}();
// ../internal/src/components/form/search-location/search-location-event-tracking/utils/utils.tsx
var _Utils = /*#__PURE__*/ function() {
    "use strict";
    function _Utils() {
        _class_call_check(this, _Utils);
    }
    _create_class(_Utils, null, [
        {
            key: "init",
            value: function init(clientLogger) {
                if (clientLogger && typeof clientLogger.getLoggerWithIdentifier === "function") {
                    var logger = clientLogger.getLoggerWithIdentifier("uitk-react-typeahead");
                    if (logger && typeof logger.logEvent === "function") {
                        _Utils.logger = logger;
                    }
                }
            }
        },
        {
            key: "isOrigin",
            value: function isOrigin(domElementId) {
                var elementId = domElementId.toLowerCase();
                return elementId.indexOf("origin") > -1 || elementId.indexOf("from") > -1 || elementId.indexOf("departure") > -1 || elementId.indexOf("drop") > -1 || elementId.indexOf("home") > -1 || elementId.indexOf("loc2") > -1;
            }
        },
        {
            key: "isDestination",
            value: function isDestination(domElementId) {
                var elementId = domElementId.toLowerCase();
                return elementId.indexOf("dest") > -1 || elementId.indexOf("to") > -1 || elementId.indexOf("arrival") > -1 || elementId.indexOf("near") > -1 || elementId.indexOf("pick") > -1 || elementId.indexOf("location") === 0;
            }
        },
        {
            key: "getDomElement",
            value: function getDomElement() {
                var _document_querySelector;
                var element = (_document_querySelector = document.querySelector("#search-location-input-field")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getElementsByTagName("input")[0];
                if (!element) {
                    _Utils.logError({
                        message: "Failed to retrieve data for the typeahead UI component"
                    });
                }
                return element;
            }
        },
        {
            key: "logError",
            value: function logError(error) {
                try {
                    if (_Utils.logger) {
                        var errorToLog = error.stack ? {
                            message: error.message,
                            stack: error.stack
                        } : error;
                        _Utils.logger.logEvent(new SystemEvent("ERROR" /* ERROR */ , "TypeaheadLoggingError"), errorToLog);
                    }
                } catch (e) {
                    console.error("unable to log errors from typeaheadCustom logger. Reason:".concat(e));
                }
            }
        },
        {
            key: "getInputElementId",
            value: function getInputElementId(inputEl) {
                var id;
                if (inputEl) {
                    id = inputEl.getAttribute("data-stid");
                    if (!id) {
                        _Utils.logError({
                            message: "Failed to retrieve input element id from 'data-stid'"
                        });
                    }
                }
                return id || _Utils.UNKNOWN;
            }
        },
        {
            key: "getSubLob",
            value: function getSubLob(lob, sublob) {
                var updatedSublob = sublob;
                if (!sublob) {
                    var usp = new URLSearchParams(window.location.search);
                    updatedSublob = usp.get("pwaSubLOB") || "";
                }
                updatedSublob = updatedSublob === null || updatedSublob === void 0 ? void 0 : updatedSublob.toLowerCase();
                switch(lob.toLowerCase()){
                    case "flights":
                        switch(updatedSublob){
                            case "oneway":
                                return "OW";
                            case "multicity":
                                return "MD";
                            default:
                                return "RT";
                        }
                    case "packages":
                        switch(updatedSublob){
                            case "fhc":
                                return "FHC";
                            case "hc":
                                return "HC";
                            case "fc":
                                return "FC";
                            default:
                                return "FH";
                        }
                    default:
                        return "";
                }
            }
        }
    ]);
    return _Utils;
}();
__publicField(_Utils, "UNKNOWN", "UNKNOWN");
__publicField(_Utils, "logger");
var Utils = _Utils;
// ../internal/src/components/form/search-location/search-location-event-tracking/recommendation-event.tsx
var EVENT_VERSION = "2.1.0";
var EVENT_CATEGORY = "Search";
var RECOMMENDATION_TITLE_DEFAULT = {
    ALTERNATE: "People also searched",
    POPULAR: "Popular destinations"
};
var RECOMMENDATION_CATEGORIES = [
    "POPULAR",
    "ALTERNATE"
];
var RecommendationEvent = /*#__PURE__*/ function() {
    "use strict";
    function RecommendationEvent() {
        _class_call_check(this, RecommendationEvent);
    }
    _create_class(RecommendationEvent, null, [
        {
            key: "getRecommendationSeenMessage",
            value: function getRecommendationSeenMessage(response, elementName) {
                var _response_sr;
                if ((response === null || response === void 0 ? void 0 : (_response_sr = response.sr) === null || _response_sr === void 0 ? void 0 : _response_sr.length) > 0) {
                    var recommendedSuggestions = response.sr.filter(function(sr) {
                        return RECOMMENDATION_CATEGORIES.includes(sr.category);
                    });
                    if (recommendedSuggestions && (recommendedSuggestions === null || recommendedSuggestions === void 0 ? void 0 : recommendedSuggestions.length) > 0) {
                        return {
                            event: {
                                event_name: "recommendations_module.presented" /* SEEN */ ,
                                event_type: "Impression" /* SEEN */ ,
                                event_version: EVENT_VERSION,
                                event_category: EVENT_CATEGORY,
                                action_location: elementName
                            },
                            recommendation_module: {
                                recommendation_title: this.getRecommendationTitle(recommendedSuggestions[0].category),
                                eg_recommendation_response_id: this.getEgRecommendationResponseId(response.recId),
                                recommendations: this.getRecommendations(recommendedSuggestions)
                            }
                        };
                    }
                }
                return void 0;
            }
        },
        {
            key: "getRecommendationClickedMessage",
            value: function getRecommendationClickedMessage(selected, response, elementName) {
                if (selected && RECOMMENDATION_CATEGORIES.includes(selected.category)) {
                    var _response_sr;
                    var rank = selected.index;
                    if ((response === null || response === void 0 ? void 0 : (_response_sr = response.sr) === null || _response_sr === void 0 ? void 0 : _response_sr.length) > 0) {
                        var recommendations = response.sr.filter(function(sr) {
                            return sr.category === selected.category;
                        });
                        for(var i = 0; i < (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length); i += 1){
                            var _recommendations_i_essId, _selected_essId;
                            if (((_recommendations_i_essId = recommendations[i].essId) === null || _recommendations_i_essId === void 0 ? void 0 : _recommendations_i_essId.sourceId) === ((_selected_essId = selected.essId) === null || _selected_essId === void 0 ? void 0 : _selected_essId.sourceId)) {
                                rank = i;
                                break;
                            }
                        }
                    }
                    return {
                        event: {
                            event_name: "recommendations_module.selected" /* CLICK */ ,
                            event_type: "Interaction" /* CLICK */ ,
                            event_version: EVENT_VERSION,
                            event_category: EVENT_CATEGORY,
                            action_location: elementName
                        },
                        recommendation_module: {
                            recommendation_title: this.getRecommendationTitle(selected.category),
                            eg_recommendation_response_id: this.getEgRecommendationResponseId(response.recId),
                            recommendations: this.getSelectedRecommendations(selected, rank)
                        }
                    };
                }
                return void 0;
            }
        },
        {
            key: "getEgRecommendationResponseId",
            value: function getEgRecommendationResponseId(responseId) {
                if (responseId) {
                    this.egRecommendationResponseId = responseId;
                }
                return this.egRecommendationResponseId;
            }
        },
        {
            key: "getRecommendationTitle",
            value: function getRecommendationTitle(recommendationType) {
                if (!this.recommendationTitle) {
                    this.recommendationTitle = RECOMMENDATION_TITLE_DEFAULT[recommendationType];
                }
                return this.recommendationTitle;
            }
        },
        {
            key: "getRecommendations",
            value: function getRecommendations(results) {
                var _this = this;
                var recommendations = [];
                var trueIndex = 0;
                if (results && (results === null || results === void 0 ? void 0 : results.length) > 0) {
                    results.forEach(function(resultItem) {
                        recommendations.push(_this.getRecommendation(resultItem, trueIndex));
                        trueIndex += 1;
                    });
                    recommendations.push();
                }
                return recommendations;
            }
        },
        {
            key: "getSelectedRecommendations",
            value: function getSelectedRecommendations(result, rank) {
                var recommendations = [];
                if (result) {
                    recommendations.push(this.getRecommendation(result, rank));
                }
                return recommendations;
            }
        },
        {
            key: "getRecommendation",
            value: function getRecommendation(resultItem, rank) {
                var _resultItem_essId;
                return {
                    recommendation_id: (_resultItem_essId = resultItem.essId) === null || _resultItem_essId === void 0 ? void 0 : _resultItem_essId.sourceId,
                    recommendation_position: rank.toString(),
                    presentation_details_recommendation_name: resultItem.regionNames.primaryDisplayName
                };
            }
        }
    ]);
    return RecommendationEvent;
}();
__publicField(RecommendationEvent, "recommendationTitle");
__publicField(RecommendationEvent, "egRecommendationResponseId");
// ../internal/src/components/form/search-location/search-location-event-tracking/search-location-event.tsx
var EVENT_VERSION2 = "1.0.0";
var SearchLocationEvent = /*#__PURE__*/ function() {
    "use strict";
    function SearchLocationEvent(session) {
        _class_call_check(this, SearchLocationEvent);
        __publicField(this, "session");
        this.session = session;
    }
    _create_class(SearchLocationEvent, [
        {
            key: "getOpenEventPayload",
            value: function getOpenEventPayload() {
                var _this_session_input;
                this.session.focusTime = performance.now();
                return {
                    event: {
                        event_name: "search_location.opened" /* OPEN */ ,
                        event_type: "Interaction" /* INTERACTION */ ,
                        event_version: EVENT_VERSION2,
                        event_category: "Search",
                        action_location: this.session.fieldName
                    },
                    search_request: {
                        search_query: ((_this_session_input = this.session.input) === null || _this_session_input === void 0 ? void 0 : _this_session_input.value) || ""
                    },
                    typeahead: {
                        search_field: this.getSearchField(this.session.fieldName),
                        line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob)
                    }
                };
            }
        },
        {
            key: "getCloseEventPayload",
            value: function getCloseEventPayload() {
                var _this_session_response_sr, _this_session_response, _this_session_query;
                return {
                    event: {
                        event_name: "search_location.closed" /* CLOSE */ ,
                        event_type: "Interaction" /* INTERACTION */ ,
                        event_version: EVENT_VERSION2,
                        event_category: "Search",
                        action_location: this.session.fieldName
                    },
                    search_request: {
                        search_query: this.session.query === this.session.prefill ? "" : this.session.query || ""
                    },
                    typeahead: {
                        search_field: this.getSearchField(this.session.fieldName),
                        backspaces_count: this.session.noOfBackspaces,
                        suggestion_list: ((_this_session_response = this.session.response) === null || _this_session_response === void 0 ? void 0 : (_this_session_response_sr = _this_session_response.sr) === null || _this_session_response_sr === void 0 ? void 0 : _this_session_response_sr.length) ? this.getSuggestionList(this.session.response.sr) : [],
                        line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob),
                        typeahead_selection_bool: !!this.session.selected,
                        focus_to_blur_time: this.calculateTimeSpendOnTypeaheadInput().toString(),
                        characters_typed_count: (_this_session_query = this.session.query) === null || _this_session_query === void 0 ? void 0 : _this_session_query.length
                    }
                };
            }
        },
        {
            key: "getRemoveRecentEventPayload",
            value: function getRemoveRecentEventPayload() {
                var _this_session_removed, _this_session_response_sr, _this_session_response;
                var selectionDepth = null;
                if (((_this_session_removed = this.session.removed) === null || _this_session_removed === void 0 ? void 0 : _this_session_removed.displayType) === "CATEGORIZED") {
                    selectionDepth = parseInt(this.session.removed.index, 10);
                } else if (this.session.removed) {
                    selectionDepth = parseInt(this.session.removed.index, 10) + 1;
                }
                var _this_session_response_sr_length;
                return {
                    event: {
                        event_name: "search_location_recent_search.removed" /* RECENT_REMOVED */ ,
                        event_type: "Interaction" /* INTERACTION */ ,
                        event_version: EVENT_VERSION2,
                        event_category: "Search",
                        action_location: this.session.fieldName
                    },
                    destination: this.session.removed ? this.getRemovedDestinationField() : null,
                    typeahead: {
                        suggestion_type: "RecentHistory" /* RECENT_HISTORY */ ,
                        line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob),
                        suggestion_count: (_this_session_response_sr_length = (_this_session_response = this.session.response) === null || _this_session_response === void 0 ? void 0 : (_this_session_response_sr = _this_session_response.sr) === null || _this_session_response_sr === void 0 ? void 0 : _this_session_response_sr.length) !== null && _this_session_response_sr_length !== void 0 ? _this_session_response_sr_length : null,
                        selection_depth: selectionDepth
                    }
                };
            }
        },
        {
            key: "getSelectEventPayload",
            value: function getSelectEventPayload(isCurrLoc) {
                var _this_session_selected, _this_session_response, _this_session_response_sr, _this_session_response1, _this_session_response_sr1, _this_session_response2, _this_session_response_sr2, _this_session_response3;
                if (isCurrLoc) {
                    var _this_session_response4, _this_session_response_sr3, _this_session_response5, _this_session_response_sr4, _this_session_response6;
                    var _this_session_response_rid, _this_session_response_sr_length;
                    return {
                        event: {
                            event_name: "search_location.selected" /* SELECT */ ,
                            event_type: "Interaction" /* INTERACTION */ ,
                            event_version: EVENT_VERSION2,
                            event_category: "Search",
                            action_location: this.session.fieldName
                        },
                        search_request: {
                            search_query: this.session.query === this.session.prefill ? "" : this.session.query || "",
                            search_id: (_this_session_response_rid = (_this_session_response4 = this.session.response) === null || _this_session_response4 === void 0 ? void 0 : _this_session_response4.rid) !== null && _this_session_response_rid !== void 0 ? _this_session_response_rid : null
                        },
                        destination: {
                            destination_full_name: "CurrentLocation",
                            destination_geo_id: "",
                            destination_type: "CurrentLocation" /* CURRENT_LOCATION */ 
                        },
                        typeahead: {
                            search_field: this.getSearchField(this.session.fieldName),
                            backspaces_count: this.session.noOfBackspaces,
                            selection_depth: 1,
                            suggestion_count: (_this_session_response_sr_length = (_this_session_response5 = this.session.response) === null || _this_session_response5 === void 0 ? void 0 : (_this_session_response_sr3 = _this_session_response5.sr) === null || _this_session_response_sr3 === void 0 ? void 0 : _this_session_response_sr3.length) !== null && _this_session_response_sr_length !== void 0 ? _this_session_response_sr_length : null,
                            suggestion_type: "CurrentLocation" /* CURRENT_LOCATION */ ,
                            suggestion_list: ((_this_session_response6 = this.session.response) === null || _this_session_response6 === void 0 ? void 0 : (_this_session_response_sr4 = _this_session_response6.sr) === null || _this_session_response_sr4 === void 0 ? void 0 : _this_session_response_sr4.length) ? this.getSuggestionList(this.session.response.sr) : [],
                            line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob)
                        }
                    };
                }
                var selectionDepth = null;
                if (((_this_session_selected = this.session.selected) === null || _this_session_selected === void 0 ? void 0 : _this_session_selected.displayType) === "CATEGORIZED") {
                    selectionDepth = parseInt(this.session.selected.index, 10);
                } else if (this.session.selected) {
                    selectionDepth = parseInt(this.session.selected.index, 10) + 1;
                }
                var _this_session_response_rid1, _this_session_response_sr_length1;
                return {
                    event: {
                        event_name: "search_location.selected" /* SELECT */ ,
                        event_type: "Interaction" /* INTERACTION */ ,
                        event_version: EVENT_VERSION2,
                        event_category: "Search",
                        action_location: this.session.fieldName
                    },
                    search_request: {
                        search_query: this.session.query === this.session.prefill ? "" : this.session.query || "",
                        search_id: (_this_session_response_rid1 = (_this_session_response = this.session.response) === null || _this_session_response === void 0 ? void 0 : _this_session_response.rid) !== null && _this_session_response_rid1 !== void 0 ? _this_session_response_rid1 : null
                    },
                    destination: this.session.selected ? this.getSelectedDestinationField() : null,
                    typeahead: {
                        search_field: this.getSearchField(this.session.fieldName),
                        backspaces_count: this.session.noOfBackspaces,
                        selection_depth: selectionDepth,
                        suggestion_count: (_this_session_response_sr_length1 = (_this_session_response1 = this.session.response) === null || _this_session_response1 === void 0 ? void 0 : (_this_session_response_sr = _this_session_response1.sr) === null || _this_session_response_sr === void 0 ? void 0 : _this_session_response_sr.length) !== null && _this_session_response_sr_length1 !== void 0 ? _this_session_response_sr_length1 : null,
                        suggestion_type: ((_this_session_response2 = this.session.response) === null || _this_session_response2 === void 0 ? void 0 : (_this_session_response_sr1 = _this_session_response2.sr) === null || _this_session_response_sr1 === void 0 ? void 0 : _this_session_response_sr1.length) ? this.getSuggestionType(this.session.response.sr[0].category) : null,
                        suggestion_list: ((_this_session_response3 = this.session.response) === null || _this_session_response3 === void 0 ? void 0 : (_this_session_response_sr2 = _this_session_response3.sr) === null || _this_session_response_sr2 === void 0 ? void 0 : _this_session_response_sr2.length) ? this.getSuggestionList(this.session.response.sr) : [],
                        line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob)
                    }
                };
            }
        },
        {
            key: "getSearchField",
            value: function getSearchField(domElementId) {
                if (!domElementId) {
                    return "UNKNOWN" /* UNKNOWN */ ;
                }
                if (Utils.isOrigin(domElementId)) {
                    return "Origin" /* ORIGIN */ ;
                }
                if (Utils.isDestination(domElementId)) {
                    return "Destination" /* DESTINATION */ ;
                }
                return "UNKNOWN" /* UNKNOWN */ ;
            }
        },
        {
            key: "getSelectedDestinationField",
            value: function getSelectedDestinationField() {
                var _this_session_selected_regionNames;
                return {
                    destination_full_name: (_this_session_selected_regionNames = this.session.selected.regionNames) === null || _this_session_selected_regionNames === void 0 ? void 0 : _this_session_selected_regionNames.lastSearchName,
                    destination_geo_id: this.getSourceId(this.session.selected),
                    destination_geo_system: this.getSourceSystem(this.session.selected),
                    destination_type: this.session.selected.type
                };
            }
        },
        {
            key: "getRemovedDestinationField",
            value: function getRemovedDestinationField() {
                var _this_session_removed_regionNames;
                return {
                    destination_full_name: (_this_session_removed_regionNames = this.session.removed.regionNames) === null || _this_session_removed_regionNames === void 0 ? void 0 : _this_session_removed_regionNames.lastSearchName,
                    destination_geo_id: this.getSourceId(this.session.removed),
                    destination_geo_system: this.getSourceSystem(this.session.removed)
                };
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId(s) {
                var _s_essId;
                return s.sourceId || ((_s_essId = s.essId) === null || _s_essId === void 0 ? void 0 : _s_essId.sourceId) || s.hotelId || s.gaiaId || Utils.UNKNOWN;
            }
        },
        {
            key: "getSourceSystem",
            value: function getSourceSystem(s) {
                var _s_essId;
                var sourceName = s.sourceName || ((_s_essId = s.essId) === null || _s_essId === void 0 ? void 0 : _s_essId.sourceName) || (s.hotelId ? "LCM" : s.gaiaId ? "GAI" : "");
                switch(sourceName){
                    case "GAI":
                        return "GAIA" /* GAIA */ ;
                    case "LCM":
                        return "LCM" /* LCM */ ;
                    case "GPA":
                        return "GOOGLE" /* GOOGLE */ ;
                    default:
                        return sourceName || "UNKNOWN" /* UNKNOWN */ ;
                }
            }
        },
        {
            key: "getSuggestionType",
            value: function getSuggestionType(category) {
                switch(category){
                    case "GOOGLEMAPS":
                        return "Google" /* GOOGLE */ ;
                    case "USERHISTORY":
                        return "RecentHistory" /* RECENT_HISTORY */ ;
                    case "ALTERNATE":
                        return "Alternate" /* ALTERNATE */ ;
                    case "POPULAR":
                        return "Popular" /* POPULAR */ ;
                    case "CURRENTLOCATION":
                        return "CurrentLocation" /* CURRENT_LOCATION */ ;
                    default:
                        return "Normal" /* NORMAL */ ;
                }
            }
        },
        {
            key: "getSuggestionList",
            value: function getSuggestionList(suggestions) {
                var _this = this;
                return suggestions.map(function(suggestion) {
                    var _suggestion_hierarchyInfo_relation, _suggestion_hierarchyInfo;
                    var suggId = {
                        destination_geo_id: _this.getSourceId(suggestion),
                        destination_geo_system: _this.getSourceSystem(suggestion),
                        destination_type: _this.getDestinationType(suggestion.type),
                        reason: ((_suggestion_hierarchyInfo = suggestion.hierarchyInfo) === null || _suggestion_hierarchyInfo === void 0 ? void 0 : (_suggestion_hierarchyInfo_relation = _suggestion_hierarchyInfo.relation) === null || _suggestion_hierarchyInfo_relation === void 0 ? void 0 : _suggestion_hierarchyInfo_relation.length) ? suggestion.hierarchyInfo.relation[0] : null
                    };
                    return suggId;
                });
            }
        },
        {
            key: "getDestinationType",
            value: function getDestinationType(s) {
                switch(s){
                    case "MULTICITY":
                        return "MULTI_CITY" /* MULTICITY */ ;
                    case "MULTIREGION":
                        return "REGION" /* REGION */ ;
                    case "METROCODE":
                        return "REGION" /* REGION */ ;
                    case "TRAINSTATION":
                        return "TRAIN_STATION" /* TRAIN_STATION */ ;
                    case "METROSTATION":
                        return "METRO_STATION" /* METRO_STATION */ ;
                    case "BUSSTATION":
                        return "METRO_STATION" /* METRO_STATION */ ;
                    case "PREMISE":
                        return "LANDMARK" /* LANDMARK */ ;
                    case "POI":
                        return "LANDMARK" /* LANDMARK */ ;
                    case "ADDRESS":
                        return "LANDMARK" /* LANDMARK */ ;
                    case "LISTING":
                        return "HOTEL" /* HOTEL */ ;
                    default:
                        return s;
                }
            }
        },
        {
            key: "getSublob",
            value: function getSublob(lob, sublob) {
                var updatedSublob = Utils.getSubLob(lob, sublob);
                return updatedSublob ? ".".concat(updatedSublob) : "";
            }
        },
        {
            /*
    This method is used to calculate the time spent by user on typeahead input box
    It first calculate the timestamp and store it in case of blur event only.
     */ key: "calculateTimeSpendOnTypeaheadInput",
            value: function calculateTimeSpendOnTypeaheadInput() {
                var focus = this.session.focusTime;
                return focus ? performance.now() - focus : -1;
            }
        }
    ]);
    return SearchLocationEvent;
}();
// ../internal/src/components/form/search-location/search-location-event-tracking/search-location-event-tracker.tsx
var _SearchLocationEventTracker = /*#__PURE__*/ function() {
    "use strict";
    function _SearchLocationEventTracker() {
        _class_call_check(this, _SearchLocationEventTracker);
        __publicField(this, "metadata");
        __publicField(this, "prevResponse");
        __publicField(this, "response");
        __publicField(this, "shownResponse");
        if (!_SearchLocationEventTracker.sessionStore) {
            this.initSessionStore();
        }
    }
    _create_class(_SearchLocationEventTracker, [
        {
            key: "initMetadata",
            value: function initMetadata(metadata) {
                this.metadata = metadata;
            }
        },
        {
            key: "recordRequest",
            value: function recordRequest(query) {
                _SearchLocationEventTracker.sessionStore.query = query;
            }
        },
        {
            key: "recordResponse",
            value: function recordResponse(response) {
                this.prevResponse = this.response;
                this.response = response;
            }
        },
        {
            key: "getRecommendationPresentedPayload",
            value: function getRecommendationPresentedPayload(query) {
                var _this_response_q, _this_response, _this_prevResponse_q, _this_prevResponse;
                if ((_this_response = this.response) === null || _this_response === void 0 ? void 0 : (_this_response_q = _this_response.q) === null || _this_response_q === void 0 ? void 0 : _this_response_q.includes(query)) {
                    this.shownResponse = this.response;
                } else if ((_this_prevResponse = this.prevResponse) === null || _this_prevResponse === void 0 ? void 0 : (_this_prevResponse_q = _this_prevResponse.q) === null || _this_prevResponse_q === void 0 ? void 0 : _this_prevResponse_q.includes(query)) {
                    this.shownResponse = this.prevResponse;
                } else {
                    return void 0;
                }
                _SearchLocationEventTracker.sessionStore.response = this.shownResponse;
                _SearchLocationEventTracker.sessionStore.selected = void 0;
                var recEventMessage = RecommendationEvent.getRecommendationSeenMessage(this.shownResponse, _SearchLocationEventTracker.sessionStore.fieldName || "");
                return recEventMessage;
            }
        },
        {
            key: "getOpenEventPayload",
            value: function getOpenEventPayload(prefill) {
                this.initEventData();
                _SearchLocationEventTracker.sessionStore.prefill = prefill;
                return new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getOpenEventPayload();
            }
        },
        {
            key: "getRemoveRecentEventPayload",
            value: function getRemoveRecentEventPayload(removed) {
                if (Optional.ofNullable(removed).isPresent() && this.essResponseIsNotEmpty() && removed.index !== void 0) {
                    _SearchLocationEventTracker.sessionStore.removed = _SearchLocationEventTracker.sessionStore.response.sr[removed.index - 1];
                }
                return new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getRemoveRecentEventPayload();
            }
        },
        {
            key: "getSelectEventPayloads",
            value: function getSelectEventPayloads(selected) {
                var updatedSelected = selected;
                if (this.shownResponse && updatedSelected) {
                    if (updatedSelected.displayType === "CATEGORIZED") {
                        updatedSelected.index += 1;
                    }
                    var isCurrLoc = (updatedSelected === null || updatedSelected === void 0 ? void 0 : updatedSelected.type) === "CURRENT_LOCATION";
                    if (Optional.ofNullable(updatedSelected).isPresent() && this.essResponseIsNotEmpty()) {
                        _SearchLocationEventTracker.sessionStore.selected = _SearchLocationEventTracker.sessionStore.response.sr[updatedSelected.index - 1];
                    }
                    var selectEvent = new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getSelectEventPayload(isCurrLoc);
                    var recEvent = RecommendationEvent.getRecommendationClickedMessage(_SearchLocationEventTracker.sessionStore.selected, _SearchLocationEventTracker.sessionStore.response, _SearchLocationEventTracker.sessionStore.fieldName || "");
                    this.resetResponse();
                    return {
                        selectPayload: selectEvent,
                        recommendationSelectPayload: recEvent
                    };
                }
                return void 0;
            }
        },
        {
            key: "getCloseEventPayload",
            value: function getCloseEventPayload() {
                var _SearchLocationEventTracker_sessionStore_input;
                var closePayload = new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getCloseEventPayload();
                _SearchLocationEventTracker.sessionStore.noOfBackspaces = 0;
                (_SearchLocationEventTracker_sessionStore_input = _SearchLocationEventTracker.sessionStore.input) === null || _SearchLocationEventTracker_sessionStore_input === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_input.removeEventListener("keydown", this.keyDown);
                this.resetResponse();
                return closePayload;
            }
        },
        {
            /** ********* Util methods ************/ key: "essResponseIsNotEmpty",
            value: function essResponseIsNotEmpty() {
                var _SearchLocationEventTracker_sessionStore_response_sr, _SearchLocationEventTracker_sessionStore_response, _SearchLocationEventTracker_sessionStore;
                return ((_SearchLocationEventTracker_sessionStore = _SearchLocationEventTracker.sessionStore) === null || _SearchLocationEventTracker_sessionStore === void 0 ? void 0 : (_SearchLocationEventTracker_sessionStore_response = _SearchLocationEventTracker_sessionStore.response) === null || _SearchLocationEventTracker_sessionStore_response === void 0 ? void 0 : (_SearchLocationEventTracker_sessionStore_response_sr = _SearchLocationEventTracker_sessionStore_response.sr) === null || _SearchLocationEventTracker_sessionStore_response_sr === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_response_sr.length) > 0;
            }
        },
        {
            key: "keyDown",
            value: function keyDown(event) {
                if (event.key && [
                    "Delete",
                    "Backspace"
                ].indexOf(event.key) > -1 || event.keyCode && [
                    8,
                    46
                ].indexOf(event.keyCode) > -1) {
                    _SearchLocationEventTracker.sessionStore.noOfBackspaces += 1;
                }
            }
        },
        {
            key: "initEventData",
            value: function initEventData() {
                this.initSessionStore();
                var _this_metadata = this.metadata, subLob = _this_metadata.subLob, lob = _this_metadata.lob;
                _SearchLocationEventTracker.sessionStore.metadata = {
                    subLob: subLob,
                    lob: lob
                };
                if (!lob) {
                    _SearchLocationEventTracker.sessionStore.metadata.lob = Utils.UNKNOWN;
                }
                this.initializeInputField();
            }
        },
        {
            key: "initializeInputField",
            value: function initializeInputField() {
                var _SearchLocationEventTracker_sessionStore_input, _SearchLocationEventTracker_sessionStore_input1;
                _SearchLocationEventTracker.sessionStore.input = Utils.getDomElement();
                _SearchLocationEventTracker.sessionStore.fieldName = Utils.getInputElementId(_SearchLocationEventTracker.sessionStore.input);
                (_SearchLocationEventTracker_sessionStore_input = _SearchLocationEventTracker.sessionStore.input) === null || _SearchLocationEventTracker_sessionStore_input === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_input.removeEventListener("keydown", this.keyDown);
                (_SearchLocationEventTracker_sessionStore_input1 = _SearchLocationEventTracker.sessionStore.input) === null || _SearchLocationEventTracker_sessionStore_input1 === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_input1.addEventListener("keydown", this.keyDown);
            }
        },
        {
            key: "initSessionStore",
            value: function initSessionStore() {
                _SearchLocationEventTracker.sessionStore = {
                    metadata: {
                        lob: Utils.UNKNOWN
                    },
                    noOfBackspaces: 0,
                    query: ""
                };
            }
        },
        {
            key: "resetResponse",
            value: function resetResponse() {
                this.prevResponse = void 0;
                this.response = void 0;
                this.shownResponse = void 0;
            }
        }
    ]);
    return _SearchLocationEventTracker;
}();
__publicField(_SearchLocationEventTracker, "sessionStore");
var SearchLocationEventTracker = _SearchLocationEventTracker;
// ../internal/src/components/form/egds-search-form-location-field/location-field.tsx
import React48 from "react";
import { TypeaheadCustom, TypeaheadLocationType } from "@egds/react-search-experience";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker12, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization10 } from "@shared-ui/localization-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext3 } from "@shared-ui/retail-search-tools-reflection-provider";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
// ../internal/src/utils/logger-utils.ts
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2 } from "@shared-ui/logger-context";
var LOGGER_EVENTS = {
    SEARCH_LOCATION_TYPEAHEAD_DURATION: new SystemEvent2(SystemEventLevel2.INFO, "SEARCH_LOCATION_TYPEAHEAD_DURATION")
};
var jsonStringifyWithFormatForLogging = function() {
    var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return JSON.stringify(obj).replaceAll(":", "=").replaceAll('"', "");
};
// ../internal/src/utils/signal-subscribers.ts
var LOCATION_FIELD_UPDATE_SIGNAL_TYPE = "SEARCH_FORM_LOCATION_FIELD_UPDATE";
var locationFieldUpdateSubscriber = function(callback, isDestination) {
    return {
        query: {
            type: LOCATION_FIELD_UPDATE_SIGNAL_TYPE
        },
        onSignal: function(param) {
            var tmp = param.payload, locationValue = (tmp === void 0 ? {} : tmp).locationValue;
            if (!isDestination || typeof locationValue !== "string") {
                return;
            }
            callback({
                term: locationValue,
                data: {}
            });
        }
    };
};
// ../internal/src/components/form/search-location/search-location.tsx
import React47 from "react";
import { gql as gql30 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization as useLocalization9 } from "@shared-ui/localization-context";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium4, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { liveAnnounce as liveAnnounce6 } from "uitk-react-utils";
// ../internal/src/components/form/search-location/result-item-impression-tracker-context.tsx
import React35 from "react";
var ResultItemImpressionTrackerContext = React35.createContext({
    impressionWrapper: void 0
});
var getTypeOfResultSuffixForImpressionTracking = function(param) {
    var isPopularFilter = param.isPopularFilter, isUserHistory = param.isUserHistory;
    if (isPopularFilter) {
        return "PopularFilter";
    }
    if (isUserHistory) {
        return "UserHistory";
    }
    return "ResultItem";
};
// ../internal/src/components/form/search-location/search-location-results.tsx
import React45 from "react";
import { getSelectedResult, getSizeOfTypeaheadResults as getSizeOfTypeaheadResults2 } from "@egds/react-search-experience/typeahead-custom/src";
import { TypeaheadCustomTextInput } from "@egds/react-search-experience/typeahead-custom-text-input/src";
import { useLocalization as useLocalization8 } from "@shared-ui/localization-context";
import { ViewLarge as ViewLarge3, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkFloatingFullWidthButton, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
import { liveAnnounce as liveAnnounce5 } from "uitk-react-utils";
// ../internal/src/components/form/search-location/utils/predictive-text.tsx
var normalizeText = function(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
};
var handlePredictiveTitle = function(term, title) {
    var maxCharLength = 22;
    var termLen = term.length;
    if (termLen === 0 || termLen > maxCharLength) {
        return "";
    }
    var normalizedTitle = normalizeText(title);
    var normalizedTerm = normalizeText(term);
    var truncatedTitle = normalizedTitle.substring(0, termLen);
    if (truncatedTitle === normalizedTerm) {
        return term + title.substring(termLen);
    }
    return "";
};
// ../internal/src/components/form/search-location/search-location-results-list.tsx
import React43 from "react";
import { filterTypeaheadResults, getSizeOfTypeaheadResults } from "@egds/react-search-experience/typeahead-custom/src";
import { useLocalization as useLocalization7 } from "@shared-ui/localization-context";
// ../../../../node_modules/.pnpm/tslib@2.3.1/node_modules/tslib/tslib.es6.js
var __assign = function __assign1() {
    __assign = Object.assign || function __assign2(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/uitk-action-list.esm.js
import * as React36 from "react";
import { classNames } from "uitk-react-utils";
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/uitk-action-list-item.css
var uitk_action_list_item_default = {};
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/uitk-action-list.esm.js
var getClassNameList = classNames.bind(uitk_action_list_item_default);
var UitkActionList = function UitkActionList(props) {
    var _a;
    var border = props.border, className = props.className, children = props.children, cornerRadius = props.cornerRadius, attr = __rest(props, [
        "border",
        "className",
        "children",
        "cornerRadius"
    ]);
    var baseCssClass = "uitk-action-list";
    var cssClassNames = getClassNameList(baseCssClass, className, (_a = {}, _a["".concat(baseCssClass, "-has-border")] = border, _a["".concat(baseCssClass, "-has-corners")] = cornerRadius, _a));
    return React36.createElement("ul", __assign({
        className: cssClassNames
    }, attr), children);
};
UitkActionList.displayName = "UitkActionList";
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/uitk-action-list-item.esm.js
import * as React37 from "react";
import { classNames as classNames2, UitkContextProvider } from "uitk-react-utils";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { useLocalization as useLocalization4 } from "@shared-ui/localization-context";
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/types.esm.js
var UitkActionListItemSpacingMap = [
    [
        "standard",
        "standard"
    ],
    [
        "relaxed",
        "relaxed"
    ]
];
var UitkActionListItemSpacings = new Map(UitkActionListItemSpacingMap);
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/uitk-action-list-item.esm.js
var getClassNameList2 = classNames2.bind(uitk_action_list_item_default);
var ActionListItem = function ActionListItem(props) {
    var _a;
    var active = props.active, borderSeparator = props.borderSeparator, className = props.className, disabled = props.disabled, children = props.children, selected = props.selected, spacing = props.spacing, l10n = props.l10n, attr = __rest(props, [
        "active",
        "borderSeparator",
        "className",
        "disabled",
        "children",
        "selected",
        "spacing",
        "l10n"
    ]);
    var spacingType = spacing && UitkActionListItemSpacings.get(spacing);
    var ariaDesc = selected ? l10n.formatText("selected") : "";
    var baseCssClass = "uitk-action-list-item";
    var cssClassNames = getClassNameList2(baseCssClass, className, (_a = {}, _a["".concat(baseCssClass, "-selected")] = selected, _a["".concat(baseCssClass, "-active")] = active, _a["".concat(baseCssClass, "-disabled")] = disabled, _a["".concat(baseCssClass, "-").concat(spacingType)] = spacingType, _a["".concat(baseCssClass, "-border")] = borderSeparator, _a));
    return React37.createElement(UitkContextProvider, {
        config: {
            context: null,
            data: {
                contextAriaDesc: ariaDesc
            }
        }
    }, React37.createElement("li", __assign({
        className: cssClassNames
    }, attr), React37.createElement("div", {
        className: getClassNameList2("uitk-action-list-item-content")
    }, children), selected && React37.createElement(UitkIcon3, {
        className: getClassNameList2("uitk-action-list-item-check"),
        name: "check"
    })));
};
var UitkActionListItem = function UitkActionListItem(props) {
    var l10n = useLocalization4();
    return React37.createElement(ActionListItem, __assign({
        l10n: l10n
    }, props));
};
UitkActionListItem.defaultProps = {
    spacing: "standard"
};
UitkActionListItem.displayName = "UitkActionListItem";
// ../../../../node_modules/.pnpm/uitk-react-action-list-item@1.4.23_@egds+tokens-web@5.9.6_@shared-ui+localization-context@1.0_fltltc4pqv5rqlx2ctdbsmffzi/node_modules/uitk-react-action-list-item/dist/uitk-action-list-item-link.esm.js
import * as React38 from "react";
import { classNames as classNames3, useUitkContext } from "uitk-react-utils";
var getClassNameList3 = classNames3.bind(uitk_action_list_item_default);
var UitkActionListItemLink = function UitkActionListItemLink(props) {
    var children = props.children, visuallyHideLinkText = props.visuallyHideLinkText;
    var contextData = useUitkContext().data;
    var contextAriaDesc = (contextData !== null && contextData !== void 0 ? contextData : {}).contextAriaDesc;
    var childrenArray = React38.Children.toArray(children);
    var firstChild = childrenArray[0];
    var randomId = Math.random().toString(36).substring(7);
    var uniqueSpanId = "selector-description-".concat(randomId);
    var AriaDescription = function AriaDescription() {
        if (contextAriaDesc) {
            return React38.createElement("span", {
                className: "is-visually-hidden",
                id: uniqueSpanId
            }, contextAriaDesc);
        }
        return React38.createElement(React38.Fragment, null);
    };
    if (!childrenArray || childrenArray.length !== 1) {
        console.warn("UitkActionListItemLink uses the first child element. ".concat(childrenArray.length, " children found."));
        return null;
    }
    var decoratedFirstChild = React38.cloneElement(firstChild, {
        className: getClassNameList3(firstChild.props.className, "uitk-action-list-item-link", !visuallyHideLinkText && "uitk-action-list-item-link-has-visible-text"),
        "aria-describedby": contextAriaDesc ? uniqueSpanId : ""
    }, visuallyHideLinkText ? React38.createElement("span", {
        className: "is-visually-hidden"
    }, React38.createElement(AriaDescription, null), firstChild.props.children) : React38.createElement(React38.Fragment, null, React38.createElement(AriaDescription, null), firstChild.props.children));
    return decoratedFirstChild;
};
UitkActionListItemLink.defaultProps = {
    visuallyHideLinkText: true
};
UitkActionListItemLink.displayName = "UitkActionListItemLink";
// ../internal/src/components/form/search-location/search-location-results-list.tsx
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/form/search-location/search-location-attribution.tsx
import React39 from "react";
import { GOOGLEMAPS_CATEGORY } from "@egds/react-search-experience/typeahead-custom/src";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
// ../internal/src/components/form/search-location/assets/google-logo.ts
var POWERED_BY_GOOGLE_LOGO = "data:image/png;base64,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";
// ../internal/src/components/form/search-location/search-location-attribution.tsx
var TypeaheadCustomAttribution = function(props) {
    var results = props.results;
    var getCategoryFromResult = function(result) {
        var _result_data;
        var _result_data_category;
        return (_result_data_category = result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.category) !== null && _result_data_category !== void 0 ? _result_data_category : "";
    };
    var findAttributedCategory = function(result) {
        return result.find(function(res) {
            var _res_data;
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.category;
        });
    };
    var getCategoryForCategorizedResults = function(typeaheadResults) {
        var categorizedResult = typeaheadResults.find(function(item) {
            return findAttributedCategory(item === null || item === void 0 ? void 0 : item.typeaheadResults);
        });
        return (categorizedResult === null || categorizedResult === void 0 ? void 0 : categorizedResult.typeaheadResults) ? getCategoryFromResult(categorizedResult === null || categorizedResult === void 0 ? void 0 : categorizedResult.typeaheadResults[0]) : "";
    };
    var category = results.type === "categorized" ? getCategoryForCategorizedResults(results.items) : getCategoryFromResult(findAttributedCategory(results.items));
    var requiresAttribution = category === GOOGLEMAPS_CATEGORY;
    if (requiresAttribution) {
        return /* @__PURE__ */ React39.createElement(UitkSpacing7, {
            padding: {
                block: "three",
                inline: "four"
            }
        }, /* @__PURE__ */ React39.createElement("div", null, category === GOOGLEMAPS_CATEGORY && /* @__PURE__ */ React39.createElement("img", {
            src: POWERED_BY_GOOGLE_LOGO,
            alt: "Powered by Google Logo"
        })));
    }
    return null;
};
TypeaheadCustomAttribution.displayName = "TypeaheadCustomAttribution";
// ../internal/src/components/form/search-location/search-location-result-item.tsx
import React41 from "react";
import { useLocalization as useLocalization5 } from "@shared-ui/localization-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
import { liveAnnounce as liveAnnounce3 } from "uitk-react-utils";
// ../internal/src/components/form/search-location/bolded-text.tsx
import React40, { useMemo } from "react";
var normalizeText2 = function(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
var removeBoldTags = function(str) {
    return str.replace(/<\/?B>/gi, "");
};
var boldFirstMatch = function(line, query, regex) {
    var matchIndex = normalizeText2(line).search(regex);
    if (matchIndex !== -1) {
        return "".concat(line.substring(0, matchIndex), "<strong>").concat(line.substring(matchIndex, matchIndex + query.length), "</strong>").concat(line.substring(matchIndex + query.length));
    }
    return line;
};
var boldExceptFirstMatch = function(line, query, regex) {
    var matchIndex = normalizeText2(line).search(regex);
    if (matchIndex !== -1) {
        var beforeMatch = line.substring(0, matchIndex);
        var match = line.substring(matchIndex, matchIndex + query.length);
        var afterMatch = line.substring(matchIndex + query.length);
        return "<strong>".concat(beforeMatch, "</strong>").concat(match, "<strong>").concat(afterMatch, "</strong>");
    }
    return "<strong>".concat(line, "</strong>");
};
var addBoldingTags = function(text, query, boldingResultsType) {
    var normalizedQuery = normalizeText2(query);
    var regex = new RegExp("(".concat(normalizedQuery, ")"), "i");
    var lines = text.split("\n");
    return lines.map(function(line, index) {
        var boldedLine = boldingResultsType === "match" /* MATCH */  ? boldFirstMatch(line, query, regex) : boldExceptFirstMatch(line, query, regex);
        return boldedLine + (index < lines.length - 1 ? "\n" : "");
    }).join("");
};
var BoldedText = function(param) {
    var text = param.text, query = param.query, boldingResultsType = param.boldingResultsType, searchDetailID = param.searchDetailID;
    var cleanText = removeBoldTags(text);
    var htmlContent = useMemo(function() {
        return addBoldingTags(cleanText, query, boldingResultsType);
    }, [
        cleanText,
        query,
        boldingResultsType
    ]);
    return /* @__PURE__ */ React40.createElement("div", {
        "data-stid": searchDetailID,
        dangerouslySetInnerHTML: {
            __html: htmlContent
        }
    });
};
var bolded_text_default = BoldedText;
BoldedText.displayName = "BoldedText";
// ../internal/src/components/form/search-location/search-location-result-item.tsx
var SearchLocationResultItem = function(props) {
    var data = props.data, onResultItemSelect = props.onResultItemSelect, value = props.value, className = props.className, subtext = props.subtext, activeSuggestion = props.activeSuggestion, name = props.name, contentRef = props.contentRef, icon = props.icon, historyDetail = props.historyDetail, sanitized = props.sanitized, stid = props.stid, index = props.index, handleRemoveRecentSearch = props.handleRemoveRecentSearch, isNestedChild = props.isNestedChild, searchTerm = props.searchTerm, boldingType = props.boldingType;
    var formatText = useLocalization5().formatText;
    var ariaLabel = subtext ? "".concat(name, " ").concat(subtext).replace(/(<([^>]+)>)/gi, "") : name === null || name === void 0 ? void 0 : name.replace(/(<([^>]+)>)/gi, "");
    var searchDetailID = "full-search-detail-".concat(historyDetail || false);
    var isUserHistory = (data === null || data === void 0 ? void 0 : data.category) === "USERHISTORY";
    var isPopularFilter = !!(data === null || data === void 0 ? void 0 : data.popularFilter);
    var removeButtonAriaLabel = formatText("typeahead.custom.delete.recent.search.button.label.a11y", value);
    var removeButtonAnnounceMessage = formatText("typeahead.custom.delete.recent.search.button.announce.a11y", value);
    var handleClick = function() {
        onResultItemSelect(value, data);
    };
    var handleDeleteRecentSearchesButtonClick = function() {
        handleRemoveRecentSearch(data !== null && data !== void 0 ? data : {});
        liveAnnounce3(removeButtonAnnounceMessage.length === 1 ? "".concat(name, " was deleted from recent searches") : removeButtonAnnounceMessage);
    };
    if (activeSuggestion === true) {
        var sanitizedName = name.replace(/(<([^>]+)>)/gi, "");
        liveAnnounce3("".concat(sanitizedName), void 0, void 0, contentRef);
    }
    var boldingResultsType = function() {
        switch(boldingType){
            case "match":
                return "match" /* MATCH */ ;
            case "non-match":
                return "non-match" /* NON_MATCH */ ;
            default:
                return void 0;
        }
    }();
    var shouldBoldText = !sanitized && boldingResultsType !== void 0;
    var hasBolding = boldingType !== void 0;
    var contentFirstLine = function() {
        if (sanitized) {
            return /* @__PURE__ */ React41.createElement("span", null, name);
        }
        if (shouldBoldText) {
            return /* @__PURE__ */ React41.createElement(bolded_text_default, {
                text: name,
                query: searchTerm,
                boldingResultsType: boldingResultsType,
                searchDetailID: searchDetailID
            });
        }
        return /* @__PURE__ */ React41.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: name
            }
        });
    };
    var contentSecondLine = function() {
        if (sanitized || !subtext) {
            return;
        }
        return /* @__PURE__ */ React41.createElement(React41.Fragment, null, shouldBoldText ? /* @__PURE__ */ React41.createElement(bolded_text_default, {
            text: subtext,
            query: searchTerm,
            boldingResultsType: boldingResultsType,
            searchDetailID: searchDetailID
        }) : /* @__PURE__ */ React41.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: subtext
            },
            "data-stid": searchDetailID
        }));
    };
    var _React41_useContext = React41.useContext(ResultItemImpressionTrackerContext), wrapper = _React41_useContext.impressionWrapper;
    var ImpressionWrapper = wrapper !== null && wrapper !== void 0 ? wrapper : React41.Fragment;
    var typeOfResultSuffix = getTypeOfResultSuffixForImpressionTracking({
        isPopularFilter: isPopularFilter,
        isUserHistory: isUserHistory
    });
    var referrerIdSuffix = "".concat(typeOfResultSuffix, ".Presented.").concat(isPopularFilter ? "".concat(value, " - ").concat(subtext === null || subtext === void 0 ? void 0 : subtext.replace(/(<([^>]+)>)/gi, "")) : value);
    var impressionWrapperProps = wrapper ? {
        linkNameSuffix: typeOfResultSuffix,
        referrerIdSuffix: referrerIdSuffix
    } : {};
    return /* @__PURE__ */ React41.createElement(ImpressionWrapper, _object_spread({}, impressionWrapperProps), /* @__PURE__ */ React41.createElement(UitkActionListItem, {
        spacing: "relaxed",
        className: className,
        "data-stid": stid && "".concat(stid, "-result-item"),
        "data-index": index,
        active: activeSuggestion
    }, /* @__PURE__ */ React41.createElement(UitkSpacing8, {
        padding: {
            inlinestart: isNestedChild ? "eight" : "unset"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(UitkActionListItemLink, null, /* @__PURE__ */ React41.createElement("button", {
        "data-stid": stid && "".concat(stid, "-result-item-button"),
        onClick: handleClick,
        "aria-label": ariaLabel,
        type: "button"
    })), /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(UitkLayoutFlex3, null, icon && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React41.createElement(UitkIcon4, {
        name: icon,
        size: UitkIconSize2.MEDIUM
    })), /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React41.createElement(UitkSpacing8, {
        margin: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(UitkText3, _object_spread({
        size: 300,
        overflow: "truncate"
    }, sanitized || !hasBolding ? {
        inline: "strong"
    } : {}), contentFirstLine()), /* @__PURE__ */ React41.createElement(UitkText3, {
        size: 300,
        overflow: "truncate"
    }, contentSecondLine())))), isUserHistory && !isPopularFilter && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center",
        grow: 1
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlex3, {
        justifyContent: "end"
    }, /* @__PURE__ */ React41.createElement(UitkTertiaryButton, {
        onClick: handleDeleteRecentSearchesButtonClick,
        "aria-label": removeButtonAriaLabel.length === 0 ? "Delete ".concat(value, " from recent searches") : removeButtonAriaLabel
    }, /* @__PURE__ */ React41.createElement(UitkIcon4, {
        name: "close",
        size: UitkIconSize2.SMALL
    }))))))))));
};
SearchLocationResultItem.displayName = "SearchLocationResultItem";
// ../internal/src/components/form/search-location/search-location-selections.tsx
import React42 from "react";
import { useLocalization as useLocalization6 } from "@shared-ui/localization-context";
import { UitkButtonSize as UitkButtonSize2, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkRemovablePill as UitkRemovablePill2 } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
import { liveAnnounce as liveAnnounce4 } from "uitk-react-utils";
var SearchLocationSelections = function(props) {
    var headingText = props.headingText, _props_hideHeading = props.hideHeading, hideHeading = _props_hideHeading === void 0 ? false : _props_hideHeading, typeaheadLabel = props.typeaheadLabel, _props_stid = props.stid, stid = _props_stid === void 0 ? "" : _props_stid, values = props.values, onItemRemove = props.onItemRemove, onClear = props.onClear, clearAllText = props.clearAllText;
    var l10n = useLocalization6();
    var clearAll = clearAllText !== null && clearAllText !== void 0 ? clearAllText : l10n.formatText("typeahead.mulselect.clearAll");
    var heading = headingText !== null && headingText !== void 0 ? headingText : l10n.formatText("typeahead.multiselect.selectedItemHeading");
    var handleRemove = function(value, index) {
        liveAnnounce4(l10n.formatText("typeahead.removeSelection", value));
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(index);
    };
    var handleClear = function() {
        liveAnnounce4(l10n.formatText("typeahead.clearAllSelections", typeaheadLabel));
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    return /* @__PURE__ */ React42.createElement("div", null, !hideHeading && heading && (values === null || values === void 0 ? void 0 : values.length) && values.length > 0 && /* @__PURE__ */ React42.createElement(UitkSpacing9, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(UitkText4, {
        overflow: "truncate",
        size: 300,
        weight: "bold"
    }, heading))), /* @__PURE__ */ React42.createElement(UitkSpacing9, {
        padding: {
            blockstart: "three",
            inline: "four"
        }
    }, /* @__PURE__ */ React42.createElement("div", {
        "data-stid": stid
    }, values === null || values === void 0 ? void 0 : values.map(function(value, index) {
        return /* @__PURE__ */ React42.createElement(UitkSpacing9, {
            key: "".concat(stid, "-pill-").concat(index),
            margin: {
                block: "one"
            }
        }, /* @__PURE__ */ React42.createElement(UitkRemovablePill2, {
            onClick: function() {
                return handleRemove(value, index);
            },
            id: "".concat(stid, "-pill-").concat(index)
        }, value));
    }), (values === null || values === void 0 ? void 0 : values.length) && /* @__PURE__ */ React42.createElement(UitkTertiaryButton2, {
        onClick: handleClear,
        size: UitkButtonSize2.SMALL
    }, clearAll))));
};
SearchLocationSelections.displayName = "SearchLocationSelections";
// ../internal/src/components/form/search-location/search-location-results-list.tsx
var SearchLocationResultsList = function(props) {
    var activeSuggestion = props.activeSuggestion, allowExactMatch = props.allowExactMatch, listTitle = props.listTitle, typeaheadLabel = props.typeaheadLabel, onResultItemSelect = props.onResultItemSelect, results = props.results, searchTerm = props.searchTerm, stid = props.stid, emptyResultPlaceholder = props.emptyResultPlaceholder, isMulti = props.isMulti, onClearAll = props.onClearAll, onItemRemove = props.onItemRemove, clearAllText = props.clearAllText, selectedItemHeading = props.selectedItemHeading, value = props.value, domRef = props.domRef, contentRef = props.contentRef, historyDetail = props.historyDetail, handleRemoveRecentSearch = props.handleRemoveRecentSearch, boldingType = props.boldingType;
    var l10n = useLocalization7();
    var filteredResults = isMulti ? filterTypeaheadResults(results, value) : results;
    var resultsLen = getSizeOfTypeaheadResults(filteredResults);
    var selections2 = isMulti && value.length > 0 ? /* @__PURE__ */ React43.createElement(SearchLocationSelections, {
        typeaheadLabel: typeaheadLabel,
        values: value,
        stid: stid,
        clearAllText: clearAllText,
        onClear: onClearAll,
        onItemRemove: onItemRemove,
        headingText: selectedItemHeading
    }) : null;
    var handleResultItemSelect = function(itemValue, data) {
        onResultItemSelect(itemValue, data, filteredResults);
    };
    var isTypeaheadResultsLoading = function(typeaheadResults) {
        var _typeaheadResults_;
        return (_typeaheadResults_ = typeaheadResults[0]) === null || _typeaheadResults_ === void 0 ? void 0 : _typeaheadResults_.disabled;
    };
    var isTypeaheadCategorizedResultsLoading = function(categories) {
        var _categories__typeaheadResults_, _categories_;
        return (_categories_ = categories[0]) === null || _categories_ === void 0 ? void 0 : (_categories__typeaheadResults_ = _categories_.typeaheadResults[0]) === null || _categories__typeaheadResults_ === void 0 ? void 0 : _categories__typeaheadResults_.disabled;
    };
    var isResultsLoading = function(typeaheadResults) {
        switch(typeaheadResults.type){
            case "categorized":
                return isTypeaheadCategorizedResultsLoading(typeaheadResults.items);
            case "uncategorized":
                return isTypeaheadResultsLoading(typeaheadResults.items);
            default:
                return void 0;
        }
    };
    var skeletons = /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        padding: {
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React43.createElement(UitkLineSkeleton2, null)), /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        margin: {
            block: "eight"
        }
    }, /* @__PURE__ */ React43.createElement(UitkLineSkeleton2, null)), /* @__PURE__ */ React43.createElement(UitkLineSkeleton2, null)));
    var getUnCategorizedItems = function(typeaheadResults) {
        var elements = typeaheadResults.map(function(result, index) {
            var _result_data;
            var isNestedChild = result.data && (result.isChild || ((_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.popularFilter));
            return /* @__PURE__ */ React43.createElement(React43.Fragment, {
                key: index
            }, listTitle && /* @__PURE__ */ React43.createElement(UitkSpacing10, {
                padding: {
                    block: "three",
                    inlinestart: "six"
                }
            }, /* @__PURE__ */ React43.createElement("li", null, /* @__PURE__ */ React43.createElement(UitkText5, {
                overflow: "truncate",
                size: 300,
                weight: "bold"
            }, result.title))), /* @__PURE__ */ React43.createElement(SearchLocationResultItem, {
                data: result.data,
                key: index,
                index: index,
                icon: result.icon,
                name: result.name,
                onResultItemSelect: handleResultItemSelect,
                handleRemoveRecentSearch: handleRemoveRecentSearch,
                stid: stid,
                value: result.value,
                subtext: result.subtext,
                activeSuggestion: activeSuggestion !== -1 && activeSuggestion === index,
                contentRef: contentRef,
                historyDetail: historyDetail,
                isNestedChild: isNestedChild,
                searchTerm: searchTerm,
                boldingType: boldingType
            }));
        });
        return elements.filter(function(element) {
            return element !== null;
        }).length > 0 ? elements : null;
    };
    var getCategorizedItems = function(categorizedResults) {
        var elements = categorizedResults === null || categorizedResults === void 0 ? void 0 : categorizedResults.map(function(category) {
            var _category_typeaheadResults, _category_typeaheadResults1;
            return ((_category_typeaheadResults = category.typeaheadResults) === null || _category_typeaheadResults === void 0 ? void 0 : _category_typeaheadResults.length) > 0 ? /* @__PURE__ */ React43.createElement(React43.Fragment, {
                key: category.heading
            }, category.heading && /* @__PURE__ */ React43.createElement(UitkSpacing10, {
                padding: {
                    block: "three",
                    inlinestart: "six"
                }
            }, /* @__PURE__ */ React43.createElement("li", null, /* @__PURE__ */ React43.createElement(UitkText5, {
                overflow: "truncate",
                size: 300,
                weight: "bold"
            }, category.heading))), (_category_typeaheadResults1 = category.typeaheadResults) === null || _category_typeaheadResults1 === void 0 ? void 0 : _category_typeaheadResults1.map(function(item, index) {
                var _item_data;
                return /* @__PURE__ */ React43.createElement(SearchLocationResultItem, {
                    data: item.data,
                    key: index,
                    index: index,
                    icon: item.icon,
                    name: item.name,
                    handleRemoveRecentSearch: handleRemoveRecentSearch,
                    onResultItemSelect: handleResultItemSelect,
                    stid: stid,
                    value: item.value,
                    subtext: item.subtext,
                    activeSuggestion: activeSuggestion !== -1 && activeSuggestion === ((_item_data = item.data) === null || _item_data === void 0 ? void 0 : _item_data.index),
                    historyDetail: historyDetail,
                    searchTerm: searchTerm,
                    boldingType: boldingType
                });
            })) : null;
        });
        return elements.filter(function(element) {
            return element !== null;
        }).length > 0 ? elements : null;
    };
    var getItems = function(typeaheadResults) {
        switch(typeaheadResults.type){
            case "categorized":
                return isTypeaheadCategorizedResultsLoading(typeaheadResults.items) ? skeletons : getCategorizedItems(typeaheadResults.items);
            case "uncategorized":
                return isTypeaheadResultsLoading(typeaheadResults.items) ? skeletons : getUnCategorizedItems(typeaheadResults.items);
            default:
                return null;
        }
    };
    var emptyPlaceholderElement = emptyResultPlaceholder && /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React43.createElement(UitkLayoutFlex4, {
        justifyContent: "center",
        alignContent: "center",
        className: "typeahead-custom-empty-results-placeholder"
    }, /* @__PURE__ */ React43.createElement(UitkText5, {
        align: "center"
    }, /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React43.createElement(UitkIcon5, {
        name: "search",
        size: UitkIconSize3.XLARGE
    })), /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React43.createElement(UitkText5, {
        size: 300
    }, emptyResultPlaceholder)))));
    var exactMatchItem = allowExactMatch && searchTerm && !isResultsLoading(filteredResults) && /* @__PURE__ */ React43.createElement(SearchLocationResultItem, {
        icon: "search",
        name: l10n.formatText("typeahead.searchFor", [
            searchTerm
        ]),
        onResultItemSelect: handleResultItemSelect,
        handleRemoveRecentSearch: handleRemoveRecentSearch,
        index: resultsLen,
        stid: stid,
        value: searchTerm,
        sanitized: true,
        activeSuggestion: !!(activeSuggestion !== -1 && activeSuggestion === resultsLen),
        historyDetail: historyDetail,
        searchTerm: searchTerm,
        boldingType: boldingType
    });
    var items = getItems(filteredResults);
    return /* @__PURE__ */ React43.createElement(UitkSpacing10, {
        padding: {
            blockstart: "one",
            blockend: "sixteen"
        }
    }, /* @__PURE__ */ React43.createElement("div", {
        ref: domRef
    }, selections2, !items && emptyPlaceholderElement, items && /* @__PURE__ */ React43.createElement(UitkActionList, {
        "data-stid": stid && "".concat(stid, "-results")
    }, items, exactMatchItem), /* @__PURE__ */ React43.createElement(UitkLayoutFlex4, {
        justifyContent: "end"
    }, /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React43.createElement(TypeaheadCustomAttribution, {
        results: filteredResults
    })))));
};
SearchLocationResultsList.displayName = "SearchLocationResultsList";
// ../internal/src/components/form/search-location/search-location-results-loading.tsx
import React44 from "react";
import { UitkLineSkeleton as UitkLineSkeleton3 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
var LoadingSkeleton = function() {
    return /* @__PURE__ */ React44.createElement(UitkSpacing11, {
        margin: {
            block: "eight"
        }
    }, /* @__PURE__ */ React44.createElement(UitkLineSkeleton3, {
        animation: true,
        type: "primary"
    }));
};
var SearchLocationResultsLoading = function() {
    return /* @__PURE__ */ React44.createElement(React44.Fragment, null, Array.from({
        length: 3
    }).map(function(_, index) {
        return /* @__PURE__ */ React44.createElement(LoadingSkeleton, {
            key: index
        });
    }));
};
SearchLocationResultsLoading.displayName = "SearchLocationResultsLoading";
// ../internal/src/components/form/search-location/search-location-results.tsx
import { debounce as debounce2 } from "throttle-debounce";
var INPUT_ID = "search-location-input-field";
var isCategorizedResult = function(result) {
    return "heading" in result;
};
var TypeaheadCustomResults = function(props) {
    var debounceRate = props.debounceRate, initialSearchTerm = props.initialSearchTerm, isMulti = props.isMulti, adapter = props.adapter, onResultItemSelect = props.onResultItemSelect, label = props.label, value = props.value, allowExactMatch = props.allowExactMatch, categorize = props.categorize, onClose = props.onClose, stid = props.stid, placeholder = props.placeholder, emptyResultPlaceholder = props.emptyResultPlaceholder, listTitle = props.listTitle, handleClear = props.handleClear, dismissButtonText = props.dismissButtonText, clearAllText = props.clearAllText, onClearAll = props.onClearAll, onItemRemove = props.onItemRemove, selectedItemHeading = props.selectedItemHeading, historyDetail = props.historyDetail, required = props.required, handleRecentSearchRemoval = props.handleRecentSearchRemoval, searchTermForMultiSelection = props.searchTermForMultiSelection, onInputChange = props.onInputChange, resultsRequestDurationTimeCallback = props.resultsRequestDurationTimeCallback, onRecommendationImpression = props.onRecommendationImpression, predictiveText = props.predictiveText, boldingType = props.boldingType;
    var formatText = useLocalization8().formatText;
    var typingTimeoutRef = React45.useRef(null);
    var inputRef = React45.useRef(null);
    var resultsDomRef = React45.useRef(null);
    var _React45_useState = _sliced_to_array(React45.useState(false), 2), isLoading = _React45_useState[0], setIsLoading = _React45_useState[1];
    var stringValue = typeof value === "string" ? value : "";
    var _React45_useState1 = _sliced_to_array(React45.useState(initialSearchTerm || stringValue || searchTermForMultiSelection || ""), 2), searchTerm = _React45_useState1[0], setSearchTerm = _React45_useState1[1];
    var previousSearchTerm = React45.useRef(initialSearchTerm);
    var _React45_useState2 = _sliced_to_array(React45.useState(-1), 2), activeSuggestion = _React45_useState2[0], setActiveSuggestion = _React45_useState2[1];
    var _React45_useState3 = _sliced_to_array(React45.useState(""), 2), predictiveTextValue = _React45_useState3[0], setPredictiveTextValue = _React45_useState3[1];
    var _React45_useState4 = _sliced_to_array(React45.useState(false), 2), showPredictiveText = _React45_useState4[0], setShowPredictiveText = _React45_useState4[1];
    var _React45_useState5 = _sliced_to_array(React45.useState([]), 2), results = _React45_useState5[0], setResults = _React45_useState5[1];
    var _React45_useState6 = _sliced_to_array(React45.useState([]), 2), categorizedResults = _React45_useState6[0], setCategorizedResults = _React45_useState6[1];
    var announceChangeOfResults = function(resultsToAnnounce, term) {
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        if ((resultsToAnnounce === null || resultsToAnnounce === void 0 ? void 0 : resultsToAnnounce.length) > 0) {
            typingTimeoutRef.current = window.setTimeout(function() {
                var searchChars = term === null || term === void 0 ? void 0 : term.split("");
                var isTypeAheadFocused = document.activeElement === inputRef.current;
                if (searchChars && resultsToAnnounce && isTypeAheadFocused) {
                    var outputWithQuotes = "'".concat(searchChars.join("' , '"), " '");
                    liveAnnounce5(formatText("typeahead.announceResults.resultsAvailable", outputWithQuotes, resultsToAnnounce.length));
                }
            }, 1e3);
        }
    };
    var updateResults = function() {
        var _ref = _async_to_generator(function(term, makeRecentHistoryCall, makeAltDestCall) {
            var newResults, newCategorizedResults, queryResults, recentHistoryResults, termOrDefault, startTime, ref, _tmp, tempResults, tempResults1, _newResults_, predictiveValue;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        previousSearchTerm.current = term;
                        termOrDefault = term;
                        startTime = performance.now();
                        if (!(termOrDefault !== "" && !!makeRecentHistoryCall)) return [
                            3,
                            5
                        ];
                        if (!categorize) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.all([
                                adapter.fetchResultsCategorized(termOrDefault),
                                adapter.fetchRecentSearchResultsCategorized()
                            ])
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            Promise.all([
                                adapter.fetchResults(termOrDefault),
                                adapter.fetchRecentSearchResults()
                            ])
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        ref = _sliced_to_array.apply(void 0, [
                            _tmp,
                            2
                        ]), queryResults = ref[0], recentHistoryResults = ref[1], ref;
                        if ((recentHistoryResults === null || recentHistoryResults === void 0 ? void 0 : recentHistoryResults.length) > 0) {
                            if (categorize || isCategorizedResult(recentHistoryResults[0])) {
                                newCategorizedResults = recentHistoryResults;
                            } else {
                                newResults = recentHistoryResults;
                            }
                        } else if (categorize) {
                            newCategorizedResults = queryResults;
                        } else {
                            newResults = queryResults;
                        }
                        return [
                            3,
                            11
                        ];
                    case 5:
                        if (!categorize) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            adapter.fetchResultsCategorized(termOrDefault)
                        ];
                    case 6:
                        newCategorizedResults = _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 7:
                        if (!(termOrDefault !== "" && !!makeAltDestCall)) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            adapter.fetchAlternativeResults(termOrDefault)
                        ];
                    case 8:
                        tempResults = _state.sent();
                        if ((tempResults === null || tempResults === void 0 ? void 0 : tempResults.length) && isCategorizedResult(tempResults[0])) {
                            newCategorizedResults = tempResults;
                        } else {
                            newResults = tempResults;
                        }
                        return [
                            3,
                            11
                        ];
                    case 9:
                        return [
                            4,
                            adapter.fetchResults(termOrDefault)
                        ];
                    case 10:
                        tempResults1 = _state.sent();
                        if ((tempResults1 === null || tempResults1 === void 0 ? void 0 : tempResults1.length) && isCategorizedResult(tempResults1[0])) {
                            newCategorizedResults = tempResults1;
                        } else {
                            newResults = tempResults1;
                        }
                        _state.label = 11;
                    case 11:
                        resultsRequestDurationTimeCallback === null || resultsRequestDurationTimeCallback === void 0 ? void 0 : resultsRequestDurationTimeCallback(performance.now() - startTime, termOrDefault.trim() !== "");
                        if (previousSearchTerm.current !== term) {
                            return [
                                2
                            ];
                        }
                        if (newResults === null || newResults === void 0 ? void 0 : newResults.length) {
                            onRecommendationImpression === null || onRecommendationImpression === void 0 ? void 0 : onRecommendationImpression(makeRecentHistoryCall || makeAltDestCall ? "" : term);
                            if (predictiveText && showPredictiveText) {
                                ;
                                predictiveValue = handlePredictiveTitle(termOrDefault, (_newResults_ = newResults[0]) === null || _newResults_ === void 0 ? void 0 : _newResults_.title);
                                setPredictiveTextValue(predictiveValue);
                            }
                            setResults(function() {
                                setIsLoading(false);
                                announceChangeOfResults(newResults, termOrDefault);
                                return newResults;
                            });
                            setCategorizedResults([]);
                        } else if (newCategorizedResults === null || newCategorizedResults === void 0 ? void 0 : newCategorizedResults.length) {
                            onRecommendationImpression === null || onRecommendationImpression === void 0 ? void 0 : onRecommendationImpression(makeRecentHistoryCall || makeAltDestCall ? "" : term);
                            setCategorizedResults(function() {
                                setIsLoading(false);
                                var allResults = newCategorizedResults.flatMap(function(result) {
                                    return result.typeaheadResults;
                                });
                                announceChangeOfResults(allResults, termOrDefault);
                                return newCategorizedResults;
                            });
                            setResults([]);
                        } else {
                            setIsLoading(false);
                            setResults([]);
                            setCategorizedResults([]);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateResults(term, makeRecentHistoryCall, makeAltDestCall) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateResultsDebounced = debounceRate && debounceRate > 0 ? debounce2(debounceRate, updateResults) : updateResults;
    var handleInputChange = function() {
        var _ref = _async_to_generator(function(event) {
            var newTerm;
            return _ts_generator(this, function(_state) {
                newTerm = event.target.value;
                setIsLoading(true);
                setSearchTerm(newTerm);
                setPredictiveTextValue("");
                updateResultsDebounced(newTerm);
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(newTerm);
                return [
                    2
                ];
            });
        });
        return function handleInputChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var close = function() {
        setPredictiveTextValue("");
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleResultItemSelect = function(term, data, items) {
        var _adapter_onItemSelection;
        (_adapter_onItemSelection = adapter.onItemSelection) === null || _adapter_onItemSelection === void 0 ? void 0 : _adapter_onItemSelection.call(adapter, data).then(function(result) {
            if (isMulti) {
                var searchLen = results && items ? getSizeOfTypeaheadResults2(items) - 1 : 0;
                liveAnnounce5("".concat(formatText("typeahead.announceResults.itemSelected", term), "\n             ").concat(formatText("typeahead.announceResults.showingResults", label, searchLen, searchTerm)));
                setActiveSuggestion(-1);
            } else {
                liveAnnounce5("".concat(formatText("typeahead.announceResults.itemSelected", term), " ").concat(formatText("typeahead.announceResults.menuClosed")));
                setSearchTerm(term);
            }
            onResultItemSelect(term, result, data);
        }).catch(function() {
            updateResults(term, true, term !== "");
            close();
        });
    };
    var removeRecentSearch = function(regionId) {
        return adapter.fetchDeleteRecentSearch(regionId);
    };
    var handleRemoveRecentSearch = function(data) {
        var regionId = data.regionId;
        handleRecentSearchRemoval === null || handleRecentSearchRemoval === void 0 ? void 0 : handleRecentSearchRemoval(data);
        removeRecentSearch(regionId !== null && regionId !== void 0 ? regionId : "").then(function() {
            var newResults = results.filter(function(result) {
                var newData = result.data;
                return (newData === null || newData === void 0 ? void 0 : newData.regionId) === regionId && (newData === null || newData === void 0 ? void 0 : newData.category) === "USERHISTORY" ? null : result;
            });
            var newCategorizedResults = categorizedResults.map(function(result) {
                return _object_spread_props(_object_spread({}, result), {
                    typeaheadResults: result.typeaheadResults.filter(function(typeaheadResult) {
                        var newData = typeaheadResult.data;
                        return (newData === null || newData === void 0 ? void 0 : newData.regionId) === regionId && (newData === null || newData === void 0 ? void 0 : newData.category) === "USERHISTORY" ? null : typeaheadResult;
                    })
                });
            });
            setResults(newResults);
            setCategorizedResults(newCategorizedResults);
        });
    };
    var handleDoneButtonClick = function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var onDismissToolbarButtonClick = function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var displayCategorizedResults = categorize || categorizedResults.length > 0;
    var resultsToDisplay = displayCategorizedResults ? {
        type: "categorized",
        items: categorizedResults
    } : {
        type: "uncategorized",
        items: results
    };
    var handleInputKeyDown = function(event) {
        switch(event.key){
            case "Tab" /* TAB */ :
                break;
            case "Escape" /* ESCAPE */ :
                close();
                break;
            case "Backspace" /* BACKSPACE */ :
                setShowPredictiveText(false);
                break;
            case "Enter" /* ENTER */ :
                {
                    event.preventDefault();
                    var selected = predictiveTextValue.length > 0 && activeSuggestion === -1 ? getSelectedResult(resultsToDisplay, 0) : getSelectedResult(resultsToDisplay, activeSuggestion);
                    if (selected) {
                        handleResultItemSelect(selected.value, selected.data);
                    } else {
                        handleResultItemSelect(searchTerm, void 0);
                    }
                    break;
                }
            case "ArrowUp" /* ARROW_UP */ :
                event.preventDefault();
                setActiveSuggestion(function(currentSuggestion) {
                    var isFirstSuggestion = currentSuggestion === 0;
                    var items = resultsToDisplay.items;
                    var lastSuggestion = allowExactMatch ? items.length : items.length - 1;
                    var aboveSuggestion = currentSuggestion - 1;
                    return isFirstSuggestion ? lastSuggestion : aboveSuggestion;
                });
                break;
            case "ArrowDown" /* ARROW_DOWN */ :
                event.preventDefault();
                setActiveSuggestion(function(currentSuggestion) {
                    var items = resultsToDisplay.items;
                    var isLastSuggestion = currentSuggestion >= (allowExactMatch ? items.length : items.length - 1);
                    var belowSuggestion = currentSuggestion + 1;
                    var firstSuggestion = 0;
                    return isLastSuggestion ? firstSuggestion : belowSuggestion;
                });
                break;
            default:
                setShowPredictiveText(true);
                break;
        }
    };
    React45.useEffect(function() {
        setTimeout(function() {
            var _inputRef_current;
            return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        }, 0);
    }, [
        inputRef
    ]);
    React45.useEffect(function() {
        updateResultsDebounced(searchTerm, false, searchTerm !== "");
    }, []);
    var input = /* @__PURE__ */ React45.createElement(TypeaheadCustomTextInput, {
        "data-stid": stid && "".concat(stid, "-input"),
        domRef: inputRef,
        hasClearButton: searchTerm.length > 0,
        hasFloatedLabel: false,
        hasVisibleLabel: false,
        id: stid,
        label: label,
        "aria-label": label,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        placeholder: placeholder,
        value: searchTerm,
        handleClear: handleClear,
        required: required,
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        type: "text",
        spellCheck: false,
        predictiveText: predictiveTextValue
    });
    return /* @__PURE__ */ React45.createElement(React45.Fragment, null, /* @__PURE__ */ React45.createElement(Viewport6, null, /* @__PURE__ */ React45.createElement(ViewSmall6, null, /* @__PURE__ */ React45.createElement(UitkToolbar2, {
        navigationContent: {
            navIconLabel: "Close the dialog",
            onClick: onDismissToolbarButtonClick,
            navButtonId: "".concat(stid, "-close")
        }
    }, /* @__PURE__ */ React45.createElement("div", {
        id: INPUT_ID
    }, input))), /* @__PURE__ */ React45.createElement(ViewLarge3, null, /* @__PURE__ */ React45.createElement(UitkLayoutPosition, {
        type: "sticky",
        position: {
            top: "zero",
            zindex: "layer1"
        }
    }, /* @__PURE__ */ React45.createElement("div", {
        id: INPUT_ID
    }, input)))), /* @__PURE__ */ React45.createElement(UitkScrollable, {
        direction: "vertical"
    }, /* @__PURE__ */ React45.createElement(UitkLayoutPosition, {
        style: {
            minHeight: "438px",
            maxHeight: isMulti ? "438px" : void 0
        }
    }, isLoading ? /* @__PURE__ */ React45.createElement(UitkSpacing12, {
        padding: {
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React45.createElement("div", null, /* @__PURE__ */ React45.createElement(SearchLocationResultsLoading, null))) : /* @__PURE__ */ React45.createElement(SearchLocationResultsList, {
        typeaheadLabel: label,
        allowExactMatch: allowExactMatch,
        onResultItemSelect: handleResultItemSelect,
        handleRemoveRecentSearch: handleRemoveRecentSearch,
        results: resultsToDisplay,
        searchTerm: searchTerm,
        stid: stid,
        listTitle: listTitle,
        activeSuggestion: activeSuggestion,
        emptyResultPlaceholder: emptyResultPlaceholder,
        isMulti: isMulti !== null && isMulti !== void 0 ? isMulti : false,
        dismissButtonText: dismissButtonText,
        selectedItemHeading: selectedItemHeading,
        clearAllText: clearAllText,
        onClearAll: onClearAll,
        onItemRemove: onItemRemove,
        value: value,
        domRef: resultsDomRef,
        historyDetail: historyDetail,
        boldingType: boldingType
    }))), isMulti && /* Requires viewport size customization due to SMALL viewport being displayed on a DIALOG and large using a MENU */ /* @__PURE__ */ React45.createElement(UitkLayoutPosition, {
        style: {
            zIndex: 100
        }
    }, /* @__PURE__ */ React45.createElement(Viewport6, null, /* @__PURE__ */ React45.createElement(ViewSmall6, null, /* @__PURE__ */ React45.createElement(UitkScrim, {
        type: UitkScrimType.BUTTON
    }, /* @__PURE__ */ React45.createElement(UitkFloatingFullWidthButton, {
        disabled: (value === null || value === void 0 ? void 0 : value.length) === 0,
        onClick: handleDoneButtonClick,
        isFullWidth: true
    }, dismissButtonText))), /* @__PURE__ */ React45.createElement(ViewLarge3, null, /* @__PURE__ */ React45.createElement(UitkSpacing12, {
        padding: "three",
        style: {
            borderTop: "1px solid #cccfdb"
        }
    }, /* @__PURE__ */ React45.createElement(UitkLayoutFlex5, {
        justifyContent: "end"
    }, /* @__PURE__ */ React45.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React45.createElement(UitkPrimaryButton2, {
        disabled: (value === null || value === void 0 ? void 0 : value.length) === 0,
        onClick: handleDoneButtonClick
    }, dismissButtonText))))))));
};
TypeaheadCustomResults.displayName = "TypeaheadCustomResults";
// ../internal/src/components/form/search-location/search-location-trigger.tsx
import React46 from "react";
import { UitkFakeInput, UitkTextInput } from "uitk-react-input";
var Trigger = function(props, ref) {
    var a11yLabel = props.a11yLabel, searchTerm = props.searchTerm, isExpanded = props.isExpanded, label = props.label, icon = props.icon, invalid = props.invalid, stid = props.stid, onClick = props.onClick, placeholder = props.placeholder, value = props.value, required = props.required, isMulti = props.isMulti, name = props.name;
    var handleClick = function() {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var _React46_useState = _sliced_to_array(React46.useState(false), 2), mounted = _React46_useState[0], setMounted = _React46_useState[1];
    React46.useEffect(function() {
        setMounted(true);
    }, []);
    var commonProps = {
        label: label,
        icon: icon,
        placeholder: placeholder,
        required: required,
        "aria-label": [
            a11yLabel,
            searchTerm
        ].filter(function(str) {
            return str && str.length > 0;
        }).join(" "),
        "aria-expanded": isExpanded,
        "aria-describedby": invalid && stid ? "".concat(stid, "-input-error") : void 0,
        "data-stid": "".concat(stid, "-trigger"),
        onClick: handleClick,
        value: isMulti ? value.join(", ") : value,
        invalid: invalid
    };
    return /* @__PURE__ */ React46.createElement(React46.Fragment, null, mounted && /* @__PURE__ */ React46.createElement(UitkFakeInput, _object_spread_props(_object_spread({}, commonProps), {
        domRef: ref
    })), /* @__PURE__ */ React46.createElement("div", {
        className: mounted ? "is-hidden" : void 0
    }, /* @__PURE__ */ React46.createElement(UitkTextInput, _object_spread_props(_object_spread({}, commonProps), {
        id: "".concat(name, "-input"),
        name: name,
        domRef: ref
    }))));
};
var SearchLocationTrigger = React46.forwardRef(Trigger);
SearchLocationTrigger.displayName = "SearchLocationTrigger";
// ../internal/src/components/form/search-location/search-location.tsx
var SearchLocationFragment = gql30(_templateObject30());
var MIN_WIDTH = 375;
var SearchLocation = function(props) {
    var _typeaheadInputTriggerRef_current, _typeaheadInputTriggerRef_current1, _typeaheadInputTriggerRef_current2;
    var accessibilityLabel = props.accessibilityLabel, adapter = props.adapter, label = props.label, typeaheadPlaceholder = props.typeaheadPlaceholder, typeaheadEmptyResultPlaceholder = props.typeaheadEmptyResultPlaceholder, dismissButtonText = props.dismissButtonText, isMulti = props.isMulti, onResultSelection = props.onResultSelection, onUpdate = props.onUpdate, handleClear = props.handleClear, value = props.value, id = props.id, onMountCB = props.onMountCB, onClick = props.onClick, onDismiss = props.onDismiss, onType = props.onType, resultItemImpressionTracker = props.resultItemImpressionTracker, onResultItemImpression = props.onResultItemImpression, predictiveText = props.predictiveText, boldingType = props.boldingType, onRemoveRecentSearch = props.onRemoveRecentSearch;
    var l10n = useLocalization9();
    var _useDialog = _sliced_to_array(useDialog("search-location-dialog-".concat(id)), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var formatText = useLocalization9().formatText;
    var _React47_useState = _sliced_to_array(React47.useState(typeof value === "string" ? value : ""), 2), searchTerm = _React47_useState[0], setSearchTerm = _React47_useState[1];
    var _React47_useState1 = _sliced_to_array(React47.useState(""), 2), searchTermForMultiSelection = _React47_useState1[0], setSearchTermForMultiSelection = _React47_useState1[1];
    var typeaheadInputTriggerRef = React47.useRef(null);
    var onTriggerClick = function() {
        dialogActions.openDialog({
            closeAllDialogs: true
        });
        var prefillText = searchTerm && searchTerm !== "" ? searchTerm : void 0;
        onClick === null || onClick === void 0 ? void 0 : onClick({
            prefillText: prefillText
        });
    };
    var handleResultItemSelect = function(term, data, selectionData) {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
            selection: {
                term: term,
                data: data
            },
            selectionData: selectionData
        });
        if (onResultSelection) {
            var event = new CustomEvent("change");
            var input = document.createElement("input");
            input.value = term;
            var _data_id;
            input.setAttribute("id", (_data_id = data === null || data === void 0 ? void 0 : data.id) !== null && _data_id !== void 0 ? _data_id : id);
            input.addEventListener("change", function(inputEvent) {
                onResultSelection(inputEvent);
            });
            input.dispatchEvent(event);
        }
        if (!isMulti) {
            setSearchTerm(term);
            dialogActions.closeDialog();
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        }
    };
    var handleRecentSearchRemoval = function(data) {
        onRemoveRecentSearch === null || onRemoveRecentSearch === void 0 ? void 0 : onRemoveRecentSearch(data);
    };
    var handleImpressionEvent = function(term) {
        onResultItemImpression === null || onResultItemImpression === void 0 ? void 0 : onResultItemImpression(term);
    };
    var getResults = function() {
        var _ref = _async_to_generator(function(term) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    adapter.fetchResults(term)
                ];
            });
        });
        return function getResults(term) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = function(term) {
        onType === null || onType === void 0 ? void 0 : onType(term);
        setSearchTermForMultiSelection(term);
        setSearchTerm(term);
    };
    var onClose = function() {
        setTimeout(function() {
            var _typeaheadInputTriggerRef_current;
            return (_typeaheadInputTriggerRef_current = typeaheadInputTriggerRef.current) === null || _typeaheadInputTriggerRef_current === void 0 ? void 0 : _typeaheadInputTriggerRef_current.focus();
        });
        handleInputChange("");
        dialogActions.closeDialog();
        setSearchTerm("");
        liveAnnounce6(formatText("typeahead.announceResults.menuClosed"));
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    var handlePredictiveClose = function() {
        if (searchTerm.length > 0) {
            getResults(searchTerm).then(function(typeaheadResults) {
                if (typeaheadResults[0] && "title" in typeaheadResults[0]) {
                    handleResultItemSelect(typeaheadResults[0].title, typeaheadResults[0]);
                }
            });
        }
        onClose();
    };
    var a11yLabel = accessibilityLabel || label;
    var typeaheadCustomTriggerProps = _object_spread_props(_object_spread({}, props), {
        label: label,
        onClick: onTriggerClick,
        value: value,
        isMulti: !!isMulti,
        a11yLabel: a11yLabel,
        searchTerm: searchTerm,
        isExpanded: isDialogOpen
    });
    var typeaheadCustomResultsWrapperProps = _object_spread_props(_object_spread({}, props), {
        onResultItemSelect: handleResultItemSelect,
        placeholder: typeaheadPlaceholder,
        emptyResultPlaceholder: typeaheadEmptyResultPlaceholder,
        onClearAll: handleClear,
        dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : formatText("typeahead.multiselect.dismiss"),
        historyDetail: adapter.isHistoryDetailEnabled(),
        isMulti: !!isMulti,
        initialSearchTerm: searchTerm,
        onClose: onClose,
        searchTermForMultiSelection: searchTermForMultiSelection,
        onInputChange: handleInputChange,
        boldingType: boldingType,
        handleRecentSearchRemoval: handleRecentSearchRemoval,
        onRecommendationImpression: handleImpressionEvent
    });
    React47.useEffect(function() {
        onMountCB === null || onMountCB === void 0 ? void 0 : onMountCB(typeaheadInputTriggerRef);
    }, []);
    React47.useEffect(function() {
        setSearchTerm(typeof value === "string" ? value : "");
    }, [
        value
    ]);
    React47.useEffect(function() {
        adapter.setL10n(l10n);
        adapter.setTypeaheadCategories();
    }, [
        adapter,
        l10n
    ]);
    var trigger = /* @__PURE__ */ React47.createElement(SearchLocationTrigger, _object_spread_props(_object_spread({}, typeaheadCustomTriggerProps), {
        ref: typeaheadInputTriggerRef
    }));
    var results = /* @__PURE__ */ React47.createElement(TypeaheadCustomResults, _object_spread({}, typeaheadCustomResultsWrapperProps));
    var memoizedResultItemImpressionTracker = React47.useMemo(function() {
        return {
            impressionWrapper: resultItemImpressionTracker
        };
    }, [
        resultItemImpressionTracker
    ]);
    return /* @__PURE__ */ React47.createElement(ResultItemImpressionTrackerContext.Provider, {
        value: memoizedResultItemImpressionTracker
    }, /* @__PURE__ */ React47.createElement(Viewport7, null, /* @__PURE__ */ React47.createElement(ViewSmall7, null, /* @__PURE__ */ React47.createElement(React47.Fragment, null, trigger, /* @__PURE__ */ React47.createElement(DialogComponent, null, /* @__PURE__ */ React47.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React47.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        type: "full",
        triggerRef: typeaheadInputTriggerRef
    }, results))))), /* @__PURE__ */ React47.createElement(ViewMedium4, null, /* @__PURE__ */ React47.createElement("div", null, trigger, /* @__PURE__ */ React47.createElement(DialogComponent, null, /* @__PURE__ */ React47.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React47.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        type: "centered",
        triggerRef: typeaheadInputTriggerRef,
        height: 860,
        centeredSheetSize: "medium"
    }, /* @__PURE__ */ React47.createElement(UitkSheetContent, {
        padded: false
    }, results)))))), /* @__PURE__ */ React47.createElement(ViewLarge4, null, /* @__PURE__ */ React47.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React47.createElement("div", null, trigger, /* @__PURE__ */ React47.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React47.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        showOverTrigger: true,
        disableArrowKeyHandler: true,
        type: "popover",
        triggerRef: typeaheadInputTriggerRef,
        width: ((_typeaheadInputTriggerRef_current = typeaheadInputTriggerRef.current) === null || _typeaheadInputTriggerRef_current === void 0 ? void 0 : _typeaheadInputTriggerRef_current.offsetWidth) && ((_typeaheadInputTriggerRef_current1 = typeaheadInputTriggerRef.current) === null || _typeaheadInputTriggerRef_current1 === void 0 ? void 0 : _typeaheadInputTriggerRef_current1.offsetWidth) > MIN_WIDTH ? (_typeaheadInputTriggerRef_current2 = typeaheadInputTriggerRef.current) === null || _typeaheadInputTriggerRef_current2 === void 0 ? void 0 : _typeaheadInputTriggerRef_current2.offsetWidth : MIN_WIDTH,
        onDismiss: predictiveText ? handlePredictiveClose : onClose,
        autoPosition: false
    }, /* @__PURE__ */ React47.createElement(UitkSheetContent, {
        padded: false
    }, results))))))));
};
SearchLocation.displayName = "SearchLocation";
// ../internal/src/components/form/egds-search-form-location-field/location-field.tsx
var DISPLAY_NAME8 = "EGDSSearchFormLocationField";
var LOCATION_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-Location");
var REGION_ID_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-RegionId");
var AIRPORT_CODE_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-AirportCode");
var LAT_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-Lat");
var LONG_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-Long");
var SELECTED_PREFIX = "".concat(DISPLAY_NAME8, "-Selected");
var AMENITIES_GROUP_PREFIX = "".concat(DISPLAY_NAME8, "-AmenitiesFacilitiesGroup");
var LOCATION_GROUP_PREFIX = "".concat(DISPLAY_NAME8, "-LocGroup");
var PROPERTIES_GOOD_FOR_GROUP_PREFIX = "".concat(DISPLAY_NAME8, "-PropertiesGoodForGroup");
var PROPERTY_TYPE_GROUP_PREFIX = "".concat(DISPLAY_NAME8, "-PropertyTypeGroup");
var DESTINATION_ID_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-DestinationId");
var PROPERTY_ID_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-PropertyId");
var PROPERTY_FILTER_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-PropertyFilter");
var LocationField = function(props) {
    var _currentSelection_data_regionNames, _currentSelection_data, _currentSelection_data_listing, _currentSelection_data1, _currentSelection_data2;
    var egdsElementId = props.egdsElementId, essAdapter = props.essAdapter, label = props.label, placeholder = props.placeholder, icon = props.icon, value = props.value, accessibility = props.accessibility, errorText = props.errorText, required = props.required, emptyResultsPlaceholder = props.emptyResultsPlaceholder, setFieldRefByTypename = props.setFieldRefByTypename, __typename = props.__typename, analyticsLinkName = props.analyticsLinkName, analyticsReferrerId = props.analyticsReferrerId, closeAnalyticsLinkName = props.closeAnalyticsLinkName, changeAnalyticsLinkName = props.changeAnalyticsLinkName, changeAnalyticsReferrerId = props.changeAnalyticsReferrerId, closeAnalyticsReferrerId = props.closeAnalyticsReferrerId, categorize = props.categorize, allowExactMatch = props.allowExactMatch, listTitle = props.listTitle, handleResultSelection = props.handleResultSelection, onSelection = props.onSelection, selection = props.selection, index = props.index, initialRegionId = props.regionId, skipQuery = props.skipQuery, valueFromQueryParam = props.valueFromQueryParam, initialSelected = props.pinnedPropertyId, alternativeLocationLabel = props.alternativeLocationLabel, propertyRefinements = props.propertyRefinements, isDestination = props.isDestination, skipReflection = props.skipReflection, onOpenLocationField = props.onOpenLocationField, _props_debounceRate = props.debounceRate, debounceRate = _props_debounceRate === void 0 ? 200 : _props_debounceRate, withoutCustomStyling = props.withoutCustomStyling, onDismissLocation = props.onDismissLocation, showCurrentLocation = props.showCurrentLocation, searchLocationAnalytics = props.searchLocationAnalytics, _props_isPopularFiltersPlaybackEnabled = props.isPopularFiltersPlaybackEnabled, isPopularFiltersPlaybackEnabled = _props_isPopularFiltersPlaybackEnabled === void 0 ? false : _props_isPopularFiltersPlaybackEnabled, onType = props.onType, predictiveText = props.predictiveText, eventTracker2 = props.eventTracker, boldingType = props.boldingType, onClearLocation = props.onClearLocation;
    var _useSearchFormReflectionContext3 = useSearchFormReflectionContext3(), state = _useSearchFormReflectionContext3.state, dispatch = _useSearchFormReflectionContext3.dispatch;
    var reflectionDestination = state.destination, reflectionOrigin = state.origin;
    var localizationContext = useLocalization10();
    var formatDateString = localizationContext.formatDateString;
    var systemEvents = useLoggerEvents(LOGGER_EVENTS);
    var resultsRequestDurationTimeCallback = function(duration, hasSearchTerm) {
        systemEvents.SEARCH_LOCATION_TYPEAHEAD_DURATION.log(jsonStringifyWithFormatForLogging({
            withSearchTerm: hasSearchTerm,
            siteId: essAdapter.config.siteId,
            duration: duration.toFixed(0),
            lob: essAdapter.config.lob
        }));
    };
    var defaultSelection = React48.useMemo(function() {
        var _essAdapter_config_lastSearchLatLong, _essAdapter_config;
        if (!skipReflection && isDestination && reflectionDestination) {
            return reflectionDestination;
        }
        if (!skipReflection && !isDestination && reflectionOrigin) {
            return reflectionOrigin;
        }
        var _ref = _sliced_to_array((essAdapter === null || essAdapter === void 0 ? void 0 : (_essAdapter_config = essAdapter.config) === null || _essAdapter_config === void 0 ? void 0 : (_essAdapter_config_lastSearchLatLong = _essAdapter_config.lastSearchLatLong) === null || _essAdapter_config_lastSearchLatLong === void 0 ? void 0 : _essAdapter_config_lastSearchLatLong.split(",")) || [
            "",
            ""
        ], 2), latitude = _ref[0], longitude = _ref[1];
        return {
            term: value,
            data: {
                type: void 0,
                regionId: initialRegionId,
                hierarchyInfo: {
                    airport: {
                        airportCode: "",
                        airportId: ""
                    }
                },
                location: {
                    lat: latitude,
                    long: longitude
                },
                selected: initialSelected !== null && initialSelected !== void 0 ? initialSelected : void 0,
                regionNames: {
                    fullName: value
                },
                cityId: ""
            }
        };
    }, [
        value,
        initialRegionId,
        initialSelected,
        isDestination
    ]);
    var _React48_useState = _sliced_to_array(React48.useState(defaultSelection), 2), currentSelection = _React48_useState[0], setCurrentSelection = _React48_useState[1];
    var _React48_useState1 = _sliced_to_array(React48.useState(currentSelection.term && alternativeLocationLabel ? alternativeLocationLabel : label), 2), displayLabel = _React48_useState1[0], setDisplayLabel = _React48_useState1[1];
    React48.useEffect(function() {
        if (defaultSelection.term != null && !skipQuery) {
            setCurrentSelection(defaultSelection);
        }
    }, [
        defaultSelection,
        skipQuery
    ]);
    React48.useEffect(function() {
        if (!skipReflection && !isDestination && reflectionOrigin) {
            setCurrentSelection(reflectionOrigin);
        }
        if (!skipReflection && isDestination && reflectionDestination) {
            setCurrentSelection(reflectionDestination);
        }
    }, [
        skipReflection,
        reflectionOrigin,
        reflectionDestination
    ]);
    React48.useEffect(function() {
        var _essAdapter_config = essAdapter.config, lob = _essAdapter_config.lob, subLob = _essAdapter_config.subLob;
        eventTracker2.initMetadata({
            lob: lob,
            subLob: subLob
        });
    }, [
        essAdapter.config
    ]);
    var track = useClickTracker12();
    var trackClickstream = useEgClickstream();
    var _ref = searchLocationAnalytics !== null && searchLocationAnalytics !== void 0 ? searchLocationAnalytics : {}, open = _ref.open, close = _ref.close, itemSelected = _ref.itemSelected, recommendationSelected = _ref.recommendationSelected, recommendationsPresented = _ref.recommendationsPresented;
    var handleClick = function(eventInfo) {
        if (onOpenLocationField) {
            var _essAdapter_config_subLob;
            onOpenLocationField({
                isDestination: isDestination,
                lineOfBusiness: essAdapter.config.lob,
                subLineOfBusiness: (_essAdapter_config_subLob = essAdapter.config.subLob) !== null && _essAdapter_config_subLob !== void 0 ? _essAdapter_config_subLob : ""
            });
        }
        if (analyticsReferrerId !== "" || analyticsLinkName !== "") {
            track(analyticsReferrerId, analyticsLinkName);
        }
        if (open) {
            setTimeout(function() {
                var openPayload = eventTracker2.getOpenEventPayload(eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.prefillText);
                trackClickstream({
                    serverPayload: open,
                    clientPayload: openPayload
                });
            });
        }
    };
    var handleRemoveRecentSearch = function(removed) {
        var removeRecentPayload = eventTracker2.getRemoveRecentEventPayload(removed);
        trackClickstream({
            clientPayload: removeRecentPayload
        });
    };
    var handleMountCB = React48.useCallback(function(ref) {
        return setFieldRefByTypename(__typename, ref);
    }, [
        setFieldRefByTypename,
        __typename
    ]);
    React48.useEffect(function() {
        if ((selection === null || selection === void 0 ? void 0 : selection.term) && selection.term !== currentSelection.term) {
            setCurrentSelection(selection);
        }
        if (valueFromQueryParam && valueFromQueryParam !== currentSelection.term) {
            setCurrentSelection(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    term: valueFromQueryParam
                });
            });
            if (onSelection) {
                onSelection({
                    data: currentSelection.data,
                    term: valueFromQueryParam
                });
            }
        }
    }, [
        selection,
        valueFromQueryParam
    ]);
    var _ref1 = currentSelection.data || defaultSelection.data, regionId = _ref1.regionId, location = _ref1.location, hierarchyInfo = _ref1.hierarchyInfo, _ref_selected = _ref1.selected, selected = _ref_selected === void 0 ? "" : _ref_selected, type = _ref1.type, cityId = _ref1.cityId;
    var _ref2 = location !== null && location !== void 0 ? location : {}, _ref_lat = _ref2.lat, lat = _ref_lat === void 0 ? "" : _ref_lat, _ref_long = _ref2.long, long = _ref_long === void 0 ? "" : _ref_long;
    var airport = (hierarchyInfo !== null && hierarchyInfo !== void 0 ? hierarchyInfo : {}).airport;
    var _ref3 = airport || {}, _ref_airportCode = _ref3.airportCode, airportCode = _ref_airportCode === void 0 ? "" : _ref_airportCode, _ref_airportId = _ref3.airportId, airportId = _ref_airportId === void 0 ? "" : _ref_airportId;
    var handleChange = function(eventInfo) {
        var _eventInfo_selection_data, _eventInfo_selection;
        var _eventInfo_selection_term;
        var term = (_eventInfo_selection_term = eventInfo.selection.term) !== null && _eventInfo_selection_term !== void 0 ? _eventInfo_selection_term : "";
        if (changeAnalyticsReferrerId && changeAnalyticsLinkName) {
            var _eventInfo_selection_data1;
            track("".concat(changeAnalyticsReferrerId, ".").concat(term), changeAnalyticsLinkName);
            var _eventInfo_selection_data_popularFilter;
            var popularFilters = (_eventInfo_selection_data_popularFilter = (_eventInfo_selection_data1 = eventInfo.selection.data) === null || _eventInfo_selection_data1 === void 0 ? void 0 : _eventInfo_selection_data1.popularFilter) !== null && _eventInfo_selection_data_popularFilter !== void 0 ? _eventInfo_selection_data_popularFilter : [];
            popularFilters.forEach(function(filter) {
                track("".concat(changeAnalyticsReferrerId, ".PopularFilter.Selected.").concat(term, "-").concat(filter === null || filter === void 0 ? void 0 : filter.externalId), "".concat(changeAnalyticsLinkName, " with popular filter"));
            });
        }
        setCurrentSelection(eventInfo.selection);
        setDisplayLabel(term && alternativeLocationLabel ? alternativeLocationLabel : label);
        if (onSelection) {
            onSelection(eventInfo.selection);
        }
        if (!term) {
            onClearLocation === null || onClearLocation === void 0 ? void 0 : onClearLocation();
        }
        if (!skipReflection) {
            var _eventInfo_selection_data2;
            dispatch({
                type: isDestination ? "UPDATE_DESTINATION" : "UPDATE_ORIGIN",
                location: eventInfo.selection.data ? eventInfo.selection : _object_spread_props(_object_spread({}, eventInfo.selection), {
                    data: {}
                })
            });
            if (essAdapter.config.historyDetail && ((_eventInfo_selection_data2 = eventInfo.selection.data) === null || _eventInfo_selection_data2 === void 0 ? void 0 : _eventInfo_selection_data2.searchDetail)) {
                var _eventInfo_selection_data_searchDetail;
                dispatch({
                    type: "UPDATE_DATES_AND_TRAVELERS",
                    travelers: (_eventInfo_selection_data_searchDetail = eventInfo.selection.data.searchDetail) !== null && _eventInfo_selection_data_searchDetail !== void 0 ? _eventInfo_selection_data_searchDetail : null
                });
            }
        }
        if (showCurrentLocation && (eventInfo === null || eventInfo === void 0 ? void 0 : (_eventInfo_selection = eventInfo.selection) === null || _eventInfo_selection === void 0 ? void 0 : (_eventInfo_selection_data = _eventInfo_selection.data) === null || _eventInfo_selection_data === void 0 ? void 0 : _eventInfo_selection_data.type) === TypeaheadLocationType.CURRENT_LOCATION) {
            var today5 = /* @__PURE__ */ new Date();
            var startDate5 = formatDateString(new Date(today5.getFullYear(), today5.getMonth(), today5.getDate()), {
                raw: "yyyy-MM-dd"
            });
            var endDate5 = formatDateString(new Date(today5.getFullYear(), today5.getMonth(), today5.getDate() + 1), {
                raw: "yyyy-MM-dd"
            });
            dispatch({
                type: "UPDATE_DATES",
                start: startDate5,
                end: endDate5
            });
        }
        var _eventTracker2_getSelectEventPayloads;
        var _ref = (_eventTracker2_getSelectEventPayloads = eventTracker2.getSelectEventPayloads(eventInfo.selectionData)) !== null && _eventTracker2_getSelectEventPayloads !== void 0 ? _eventTracker2_getSelectEventPayloads : {}, selectPayload = _ref.selectPayload, recommendationSelectPayload = _ref.recommendationSelectPayload;
        if (itemSelected && selectPayload) {
            trackClickstream({
                serverPayload: itemSelected,
                clientPayload: selectPayload
            });
        }
        if (recommendationSelected && recommendationSelectPayload) {
            trackClickstream({
                serverPayload: recommendationSelected,
                clientPayload: recommendationSelectPayload
            });
        }
    };
    var handleClear = function() {
        setCurrentSelection({
            term: "",
            data: {
                regionId: "",
                hierarchyInfo: {
                    airport: {
                        airportCode: "",
                        airportId: ""
                    }
                },
                location: {
                    lat: "",
                    long: ""
                },
                selected: void 0,
                regionNames: {},
                cityId: ""
            }
        });
        setDisplayLabel(label);
        onClearLocation === null || onClearLocation === void 0 ? void 0 : onClearLocation();
    };
    var handleOnDismiss = function() {
        if (onDismissLocation) {
            onDismissLocation(currentSelection);
        }
        var referrerId = closeAnalyticsReferrerId !== null && closeAnalyticsReferrerId !== void 0 ? closeAnalyticsReferrerId : "";
        var linkName = closeAnalyticsLinkName !== null && closeAnalyticsLinkName !== void 0 ? closeAnalyticsLinkName : "";
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
        if (close) {
            var closePayload = eventTracker2.getCloseEventPayload();
            trackClickstream({
                serverPayload: close,
                clientPayload: closePayload
            });
        }
    };
    var handleOnRecommendationImpression = function(term) {
        var recSeenPayload = eventTracker2.getRecommendationPresentedPayload(term);
        if (recommendationsPresented && recSeenPayload) {
            trackClickstream({
                serverPayload: recommendationsPresented,
                clientPayload: recSeenPayload
            });
        }
    };
    var handleLocationFieldUpdate = React48.useCallback(function(newSelection) {
        setCurrentSelection(function(prev) {
            var _prev_data_regionNames, _prev_data;
            if (((_prev_data = prev.data) === null || _prev_data === void 0 ? void 0 : (_prev_data_regionNames = _prev_data.regionNames) === null || _prev_data_regionNames === void 0 ? void 0 : _prev_data_regionNames.fullName) === newSelection.term) {
                return prev;
            }
            return newSelection;
        });
    }, []);
    useSignalSubscriber(locationFieldUpdateSubscriber(handleLocationFieldUpdate, isDestination));
    var hiddenInputNameSuffix = "".concat(egdsElementId).concat(Number.isInteger(index) ? "-".concat(index) : "");
    var currentLocation = ((_currentSelection_data = currentSelection.data) === null || _currentSelection_data === void 0 ? void 0 : (_currentSelection_data_regionNames = _currentSelection_data.regionNames) === null || _currentSelection_data_regionNames === void 0 ? void 0 : _currentSelection_data_regionNames.fullName) && !valueFromQueryParam && type !== TypeaheadLocationType.CURRENT_LOCATION ? currentSelection.data.regionNames.fullName : currentSelection.term;
    var currentRegionId = currentSelection.data ? regionId || cityId || airportId : "";
    var hiddenLocationValue = essAdapter.config.showCurrentLocation && type === TypeaheadLocationType.CURRENT_LOCATION ? "" : currentLocation;
    var destinationId = currentSelection.data ? cityId || regionId : "";
    var _currentSelection_data_listing_expediaId;
    var propertyId = (_currentSelection_data_listing_expediaId = (_currentSelection_data1 = currentSelection.data) === null || _currentSelection_data1 === void 0 ? void 0 : (_currentSelection_data_listing = _currentSelection_data1.listing) === null || _currentSelection_data_listing === void 0 ? void 0 : _currentSelection_data_listing.expediaId) !== null && _currentSelection_data_listing_expediaId !== void 0 ? _currentSelection_data_listing_expediaId : null;
    var _currentSelection_data_popularFilter;
    var filters = (_currentSelection_data_popularFilter = (_currentSelection_data2 = currentSelection.data) === null || _currentSelection_data2 === void 0 ? void 0 : _currentSelection_data2.popularFilter) !== null && _currentSelection_data_popularFilter !== void 0 ? _currentSelection_data_popularFilter : [];
    var LocationResultItemImpressionTracker = React48.memo(function(param) {
        var children = param.children, linkNameSuffix = param.linkNameSuffix, referrerIdSuffix = param.referrerIdSuffix;
        return /* @__PURE__ */ React48.createElement(IntersectionTracker2, {
            linkName: "Location result impression - ".concat(linkNameSuffix),
            referrerId: "".concat(analyticsReferrerId, ".").concat(referrerIdSuffix)
        }, children);
    });
    var SearchLocationField = withoutCustomStyling ? SearchLocation : TypeaheadCustom;
    return /* @__PURE__ */ React48.createElement(React48.Fragment, null, /* @__PURE__ */ React48.createElement("div", {
        "data-stid": "search-location"
    }, /* @__PURE__ */ React48.createElement(SearchLocationField, {
        onType: onType,
        id: "".concat(egdsElementId).concat(index !== null && index !== void 0 ? index : ""),
        name: egdsElementId,
        adapter: essAdapter,
        label: displayLabel,
        typeaheadPlaceholder: placeholder,
        icon: icon,
        value: currentLocation,
        onUpdate: handleChange,
        handleClear: handleClear,
        stid: egdsElementId,
        accessibilityLabel: accessibility,
        onClick: handleClick,
        onMountCB: handleMountCB,
        invalid: errorText,
        required: required,
        typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder,
        onResultSelection: handleResultSelection,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        onDismiss: handleOnDismiss,
        onRemoveRecentSearch: handleRemoveRecentSearch,
        debounceRate: debounceRate,
        resultItemImpressionTracker: LocationResultItemImpressionTracker,
        resultsRequestDurationTimeCallback: resultsRequestDurationTimeCallback,
        onResultItemImpression: handleOnRecommendationImpression,
        predictiveText: predictiveText,
        boldingType: boldingType
    })), /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_NAME_PREFIX,
        name: "".concat(LOCATION_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: hiddenLocationValue
    }), currentRegionId && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": REGION_ID_NAME_PREFIX,
        name: "".concat(REGION_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: currentRegionId
    }), /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": AIRPORT_CODE_NAME_PREFIX,
        name: "".concat(AIRPORT_CODE_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: airportCode
    }), /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": LAT_NAME_PREFIX,
        name: "".concat(LAT_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: lat
    }), /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": LONG_NAME_PREFIX,
        name: "".concat(LONG_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: long
    }), propertyId && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": PROPERTY_ID_NAME_PREFIX,
        name: "".concat(PROPERTY_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: propertyId
    }), /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": SELECTED_PREFIX,
        name: "".concat(SELECTED_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: propertyId !== null && propertyId !== void 0 ? propertyId : selected
    }), essAdapter.config.popularFilter && !isPopularFiltersPlaybackEnabled && filters.map(function(filterItem) {
        var _filterItem_refinementGroupSet;
        var hasLegacyId = !!(filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyId) && !!(filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyValue);
        var keySuffix = hasLegacyId ? filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyId : filterItem === null || filterItem === void 0 ? void 0 : filterItem.externalId;
        var _filterItem_refinementGroupSet_;
        var nameSuffix = hasLegacyId ? filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyId : (_filterItem_refinementGroupSet_ = filterItem === null || filterItem === void 0 ? void 0 : (_filterItem_refinementGroupSet = filterItem.refinementGroupSet) === null || _filterItem_refinementGroupSet === void 0 ? void 0 : _filterItem_refinementGroupSet[1]) !== null && _filterItem_refinementGroupSet_ !== void 0 ? _filterItem_refinementGroupSet_ : "";
        var _filterItem_externalId;
        var filterValue = hasLegacyId ? filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyValue : (_filterItem_externalId = filterItem === null || filterItem === void 0 ? void 0 : filterItem.externalId) !== null && _filterItem_externalId !== void 0 ? _filterItem_externalId : "";
        return /* @__PURE__ */ React48.createElement("input", {
            key: "search-location-popular-filter-".concat(keySuffix),
            type: "hidden",
            "data-stid": PROPERTY_FILTER_NAME_PREFIX,
            name: "".concat(PROPERTY_FILTER_NAME_PREFIX, "-").concat(nameSuffix),
            value: filterValue
        });
    }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.amenitiesFacilitiesGroup) && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": AMENITIES_GROUP_PREFIX,
        name: "".concat(AMENITIES_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.amenitiesFacilitiesGroup
    }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.locationGroup) && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_GROUP_PREFIX,
        name: "".concat(LOCATION_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.locationGroup
    }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertiesGoodForGroup) && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": PROPERTIES_GOOD_FOR_GROUP_PREFIX,
        name: "".concat(PROPERTIES_GOOD_FOR_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertiesGoodForGroup
    }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertyTypeGroup) && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": PROPERTY_TYPE_GROUP_PREFIX,
        name: "".concat(PROPERTY_TYPE_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertyTypeGroup
    }), destinationId && /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        "data-stid": DESTINATION_ID_NAME_PREFIX,
        name: "".concat(DESTINATION_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: destinationId
    }));
};
// ../internal/src/components/form/egds-search-form-location-field/multi-location-field.tsx
import React49 from "react";
import { TypeaheadCustom as TypeaheadCustom2 } from "@egds/react-search-experience";
import { useClickTracker as useClickTracker13, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var DISPLAY_NAME9 = "EGDSSearchFormLocationField";
var LOCATION_NAME_PREFIX2 = "".concat(DISPLAY_NAME9, "-Location");
var REGION_ID_NAME_PREFIX2 = "".concat(DISPLAY_NAME9, "-RegionId");
var AIRPORT_CODE_NAME_PREFIX2 = "".concat(DISPLAY_NAME9, "-AirportCode");
var LAT_NAME_PREFIX2 = "".concat(DISPLAY_NAME9, "-Lat");
var LONG_NAME_PREFIX2 = "".concat(DISPLAY_NAME9, "-Long");
var LOCATION_DEEP_LINK_PREFIX = "".concat(DISPLAY_NAME9, "-Values");
var getLocationFieldDataSelection = function(selection) {
    var defaultSelection = {
        data: {
            regionId: "",
            hierarchyInfo: {
                airport: {
                    airportCode: ""
                }
            },
            location: {
                lat: "",
                long: ""
            },
            value: ""
        }
    };
    var selectionsData = selection.map(function(item) {
        return item.data || defaultSelection.data;
    });
    return {
        term: selection.map(function(item) {
            return item.term;
        }).join(","),
        regionId: selectionsData.map(function(data) {
            return data.regionId;
        }).join(","),
        lat: selectionsData.map(function(data) {
            var _data_location;
            return (_data_location = data.location) === null || _data_location === void 0 ? void 0 : _data_location.lat;
        }).join(","),
        long: selectionsData.map(function(data) {
            var _data_location;
            return (_data_location = data.location) === null || _data_location === void 0 ? void 0 : _data_location.long;
        }).join(","),
        airportCode: selectionsData.map(function(data) {
            var _data_hierarchyInfo_airport, _data_hierarchyInfo;
            return (_data_hierarchyInfo = data.hierarchyInfo) === null || _data_hierarchyInfo === void 0 ? void 0 : (_data_hierarchyInfo_airport = _data_hierarchyInfo.airport) === null || _data_hierarchyInfo_airport === void 0 ? void 0 : _data_hierarchyInfo_airport.airportCode;
        }).join(","),
        locationValues: selectionsData.map(function(data) {
            return data.value;
        }).join(",")
    };
};
var MultiLocationField = function(props) {
    var egdsElementId = props.egdsElementId, essAdapter = props.essAdapter, label = props.label, placeholder = props.placeholder, icon = props.icon, multiLocations = props.multiLocations, errorText = props.errorText, required = props.required, emptyResultsPlaceholder = props.emptyResultsPlaceholder, setFieldRefByTypename = props.setFieldRefByTypename, __typename = props.__typename, analyticsLinkName = props.analyticsLinkName, analyticsReferrerId = props.analyticsReferrerId, categorize = props.categorize, allowExactMatch = props.allowExactMatch, listTitle = props.listTitle, selectedItemHeading = props.selectedItemHeading, clearAllText = props.clearAllText, dismissButtonText = props.dismissButtonText, handleResultSelection = props.handleResultSelection, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onMultiSelectClose = props.onMultiSelectClose, withoutCustomStyling = props.withoutCustomStyling, searchLocationAnalytics = props.searchLocationAnalytics, eventTracker2 = props.eventTracker;
    var defaultMultiSelection = multiLocations.map(function(item) {
        return {
            term: item.text,
            data: {
                regionId: "",
                hierarchyInfo: {
                    airport: {
                        airportCode: ""
                    }
                },
                location: {
                    lat: "",
                    long: ""
                },
                value: item.value
            }
        };
    });
    var _React49_useState = _sliced_to_array(React49.useState(defaultMultiSelection), 2), selection = _React49_useState[0], setSelection = _React49_useState[1];
    var _React49_useState1 = _sliced_to_array(React49.useState(false), 2), shouldFireChangeEvent = _React49_useState1[0], setShouldFireChangeEvent = _React49_useState1[1];
    React49.useEffect(function() {
        if (shouldFireChangeEvent) {
            setShouldFireChangeEvent(false);
            triggerInputChangeEvent(selection.map(function(value) {
                return value.term;
            }).join(", "), handleResultSelection);
        }
    }, [
        shouldFireChangeEvent,
        selection,
        handleResultSelection
    ]);
    var trackClick = useClickTracker13();
    var trackClickstream = useEgClickstream2();
    var _ref = searchLocationAnalytics !== null && searchLocationAnalytics !== void 0 ? searchLocationAnalytics : {}, open = _ref.open, close = _ref.close, itemSelected = _ref.itemSelected, recommendationSelected = _ref.recommendationSelected, recommendationsPresented = _ref.recommendationsPresented;
    var handleClick = function(eventInfo) {
        trackClick(analyticsReferrerId, analyticsLinkName);
        eventTracker2.initMetadata({
            lob: essAdapter.config.lob,
            subLob: essAdapter.config.subLob
        });
        if (open) {
            setTimeout(function() {
                var openPayload = eventTracker2.getOpenEventPayload(eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.prefillText);
                trackClickstream({
                    serverPayload: open,
                    clientPayload: openPayload
                });
            });
        }
    };
    var handleMountCB = React49.useCallback(function(ref) {
        return setFieldRefByTypename(__typename, ref);
    }, [
        setFieldRefByTypename,
        __typename
    ]);
    var _getLocationFieldDataSelection = getLocationFieldDataSelection(selection), term = _getLocationFieldDataSelection.term, regionId = _getLocationFieldDataSelection.regionId, lat = _getLocationFieldDataSelection.lat, long = _getLocationFieldDataSelection.long, airportCode = _getLocationFieldDataSelection.airportCode, locationValues = _getLocationFieldDataSelection.locationValues;
    var handleChange = function(eventInfo) {
        var isNewSelectionRepeated = selection.some(function(item) {
            return item === eventInfo.selection;
        });
        if (!isNewSelectionRepeated && eventInfo.selection.data) {
            setSelection(function(prevSelection) {
                return _to_consumable_array(prevSelection).concat([
                    eventInfo.selection
                ]);
            });
        }
        var _eventTracker2_getSelectEventPayloads;
        var _ref = (_eventTracker2_getSelectEventPayloads = eventTracker2.getSelectEventPayloads(eventInfo.selectionData)) !== null && _eventTracker2_getSelectEventPayloads !== void 0 ? _eventTracker2_getSelectEventPayloads : {}, selectPayload = _ref.selectPayload, recommendationSelectPayload = _ref.recommendationSelectPayload;
        if (itemSelected && selectPayload) {
            trackClickstream({
                serverPayload: itemSelected,
                clientPayload: selectPayload
            });
        }
        if (recommendationSelected && recommendationSelectPayload) {
            trackClickstream({
                serverPayload: recommendationSelected,
                clientPayload: recommendationSelectPayload
            });
        }
    };
    var handleClear = function() {
        setSelection([]);
        onMultiSelectClearAll === null || onMultiSelectClearAll === void 0 ? void 0 : onMultiSelectClearAll(egdsElementId);
    };
    var handleRemove = function(selectedIndex) {
        if ((selection === null || selection === void 0 ? void 0 : selection.length) > 0) {
            setSelection(function(prevSelection) {
                return prevSelection.filter(function(_, index) {
                    return index !== selectedIndex;
                });
            });
            onMultiSelectItemRemove === null || onMultiSelectItemRemove === void 0 ? void 0 : onMultiSelectItemRemove(selection[selectedIndex], egdsElementId);
        }
    };
    var handleDismiss = function(eventInfo) {
        if (eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.renderType) {
            onMultiSelectClose === null || onMultiSelectClose === void 0 ? void 0 : onMultiSelectClose(eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.renderType, egdsElementId);
            setShouldFireChangeEvent(true);
        }
        if (close) {
            var closePayload = eventTracker2.getCloseEventPayload();
            trackClickstream({
                serverPayload: close,
                clientPayload: closePayload
            });
        }
    };
    var handleOnRecommendationImpression = function(query) {
        var recSeenPayload = eventTracker2.getRecommendationPresentedPayload(query);
        if (recommendationsPresented && recSeenPayload) {
            trackClickstream({
                serverPayload: recommendationsPresented,
                clientPayload: recSeenPayload
            });
        }
    };
    var accessibilityLabel = label.concat(",").concat(term);
    var SearchLocationField = withoutCustomStyling ? SearchLocation : TypeaheadCustom2;
    return /* @__PURE__ */ React49.createElement(React49.Fragment, null, /* @__PURE__ */ React49.createElement("div", {
        "data-stid": "search-location"
    }, /* @__PURE__ */ React49.createElement(SearchLocationField, {
        id: egdsElementId,
        name: egdsElementId,
        adapter: essAdapter,
        label: label,
        typeaheadPlaceholder: placeholder,
        icon: icon,
        value: selection.map(function(item) {
            return item.term;
        }),
        onUpdate: handleChange,
        stid: egdsElementId,
        accessibilityLabel: accessibilityLabel,
        onClick: handleClick,
        onMountCB: handleMountCB,
        invalid: errorText,
        required: required,
        typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder,
        handleClear: handleClear,
        onItemRemove: handleRemove,
        onDismiss: handleDismiss,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        selectedItemHeading: selectedItemHeading,
        clearAllText: clearAllText,
        dismissButtonText: dismissButtonText,
        isMulti: true,
        withoutCustomStyling: withoutCustomStyling,
        onResultItemImpression: handleOnRecommendationImpression
    })), /* @__PURE__ */ React49.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_NAME_PREFIX2,
        name: "".concat(LOCATION_NAME_PREFIX2, "-").concat(egdsElementId),
        value: term
    }), /* @__PURE__ */ React49.createElement("input", {
        type: "hidden",
        "data-stid": REGION_ID_NAME_PREFIX2,
        name: "".concat(REGION_ID_NAME_PREFIX2, "-").concat(egdsElementId),
        value: regionId
    }), /* @__PURE__ */ React49.createElement("input", {
        type: "hidden",
        "data-stid": AIRPORT_CODE_NAME_PREFIX2,
        name: "".concat(AIRPORT_CODE_NAME_PREFIX2, "-").concat(egdsElementId),
        value: airportCode
    }), /* @__PURE__ */ React49.createElement("input", {
        type: "hidden",
        "data-stid": LAT_NAME_PREFIX2,
        name: "".concat(LAT_NAME_PREFIX2, "-").concat(egdsElementId),
        value: lat
    }), /* @__PURE__ */ React49.createElement("input", {
        type: "hidden",
        "data-stid": LONG_NAME_PREFIX2,
        name: "".concat(LONG_NAME_PREFIX2, "-").concat(egdsElementId),
        value: long
    }), /* @__PURE__ */ React49.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_DEEP_LINK_PREFIX,
        name: "".concat(LOCATION_DEEP_LINK_PREFIX, "-").concat(egdsElementId),
        value: locationValues
    }));
};
// ../internal/src/components/form/egds-search-form-location-field/egds-search-form-location-field.tsx
var __Fragment23 = gql31(_templateObject31());
var DISPLAY_NAME10 = "EGDSSearchFormLocationField";
var eventTracker = new SearchLocationEventTracker();
var EGDSSearchFormLocationField = function(props) {
    var _fieldError_validations, _validations2_find, _useGoogleMapsSdkVersion;
    var fieldError = props.fieldError, data = props.data, adapter = props.adapter, onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, locationsErrorText = props.locationsErrorText, additionalAdapterFields = props.additionalAdapterFields, pinnedPropertyId = props.pinnedPropertyId, alternativeLocationLabel = props.alternativeLocationLabel, propertyRefinements = props.propertyRefinements, skipReflection = props.skipReflection, onLocationsSelection = props.onLocationsSelection, showCurrentLocation = props.showCurrentLocation, onDismissLocation = props.onDismissLocation, categorizeResults = props.categorizeResults, enablePredictiveText = props.enablePredictiveText, isHistoryDetailFormatVariant = props.isHistoryDetailFormatVariant;
    var context = useBexApi4().context;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var __typename = data.__typename, label = data.label, action = data.action, placeholder = data.placeholder, leftIcon = data.leftIcon, egdsElementId = data.egdsElementId, value = data.value, errorMessage = data.errorMessage, required = data.required, multiLocations = data.multiLocations, closeAnalytics = data.closeAnalytics, changeAnalytics = data.changeAnalytics, regionId = data.regionId, debounceRate = data.debounceRate, validations2 = data.validations;
    var sameInputErrorText = (fieldError === null || fieldError === void 0 ? void 0 : (_fieldError_validations = fieldError.validations) === null || _fieldError_validations === void 0 ? void 0 : _fieldError_validations.sameLocationSelected) && validations2 && egdsElementId === "origin_select" ? (_validations2_find = validations2.find(function(field) {
        return field.__typename === "EGDSSameValueInputValidation";
    })) === null || _validations2_find === void 0 ? void 0 : _validations2_find.errorMessage : null;
    var _ref, _ref1;
    var errorTextToDisplay = (_ref1 = (_ref = sameInputErrorText !== null && sameInputErrorText !== void 0 ? sameInputErrorText : locationsErrorText) !== null && _ref !== void 0 ? _ref : errorMessage) !== null && _ref1 !== void 0 ? _ref1 : "";
    var handleResultSelection = useFormCallback5(egdsElementId, function(event) {
        return event;
    });
    var googleApiVersion = (_useGoogleMapsSdkVersion = useGoogleMapsSdkVersion()) === null || _useGoogleMapsSdkVersion === void 0 ? void 0 : _useGoogleMapsSdkVersion.version;
    var _useExperiment2 = useExperiment2("TypeaheadCustom_without_specific_CSS" /* TypeaheadCustom_without_specific_CSS */ ), typeaheadCustomWithoutSpecificCSSExposure = _useExperiment2.exposure, logTypeaheadCustomWithoutSpecificCSS = _useExperiment2.logExperiment;
    React50.useEffect(function() {
        try {
            logTypeaheadCustomWithoutSpecificCSS(typeaheadCustomWithoutSpecificCSSExposure);
        } catch (e) {}
    });
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "OpenTypeaheadAction") {
        return null;
    }
    var logRequest = function(query) {
        eventTracker.recordRequest(query);
    };
    var logResponse = function(response) {
        eventTracker.recordResponse(response);
    };
    var finalAdditionalAdapterFields = _object_spread_props(_object_spread({}, additionalAdapterFields), {
        alternate: (additionalAdapterFields === null || additionalAdapterFields === void 0 ? void 0 : additionalAdapterFields.lastSearchLatLong) ? additionalAdapterFields === null || additionalAdapterFields === void 0 ? void 0 : additionalAdapterFields.alternate : false,
        googleApiVersion: googleApiVersion
    });
    var analytics = action.analytics, accessibility = action.accessibility, emptyResultsPlaceholder = action.emptyResultsPlaceholder, allowExactMatch = action.allowExactMatch, categorize = action.categorize, listTitle = action.listTitle, selectedItemHeading = action.selectedItemHeading, clearAllText = action.clearAllText, dismissButtonText = action.dismissButtonText;
    var _action_info = action.info, client = _action_info.client, drivable = _action_info.drivable, isDestination = _action_info.isDestination, lineOfBusiness = _action_info.lineOfBusiness, maxNumberOfResults = _action_info.maxNumberOfResults, packageType = _action_info.packageType, personalize = _action_info.personalize, regionType = _action_info.regionType, typeaheadFeatures = _action_info.typeaheadFeatures, isMultiLocation = _action_info.isMultiLocation, domain = _action_info.domain, typeaheadRegionId = _action_info.regionId, subLob = _action_info.subLob, expUserId = _action_info.expUserId, trending = _action_info.trending;
    var _ref2 = identity || {}, guid = _ref2.duaid;
    var expuserid = Number(expUserId) || -1;
    var defaultMaxNumberOfResults = 10;
    var defaultRegionType = 2047;
    var defaultIcon = "place";
    var developmentHostNames2 = [
        "localhost",
        "shared-ui.expedia.biz"
    ];
    var isDevelopment = typeof window !== "undefined" ? developmentHostNames2.includes(window.location.hostname) : false;
    var essAdapter = adapter !== null && adapter !== void 0 ? adapter : new ESSAdapter(_object_spread_props(_object_spread({
        client: client !== null && client !== void 0 ? client : "",
        drivable: drivable,
        trending: trending,
        dest: isDestination,
        domain: isDevelopment ? "https://www.expedia.com/" : domain !== null && domain !== void 0 ? domain : "https://www.expedia.com/",
        expuserid: expuserid,
        features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
        guid: guid,
        lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
        locale: locale,
        maxResults: maxNumberOfResults !== null && maxNumberOfResults !== void 0 ? maxNumberOfResults : defaultMaxNumberOfResults,
        personalize: personalize,
        regionType: regionType !== null && regionType !== void 0 ? regionType : defaultRegionType,
        siteId: siteId,
        packageType: packageType !== null && packageType !== void 0 ? packageType : "",
        showCurrentLocation: showCurrentLocation !== null && showCurrentLocation !== void 0 ? showCurrentLocation : false,
        regionId: typeaheadRegionId !== null && typeaheadRegionId !== void 0 ? typeaheadRegionId : void 0,
        excludeRoomsLabelForRecentHistory: regionType === 10111
    }, finalAdditionalAdapterFields), {
        subLob: subLob !== null && subLob !== void 0 ? subLob : "",
        logRequest: logRequest,
        logResponse: logResponse,
        historyDetailFormatVariant: isHistoryDetailFormatVariant !== null && isHistoryDetailFormatVariant !== void 0 ? isHistoryDetailFormatVariant : false
    }));
    var _leftIcon_title;
    var commonProps = _object_spread_props(_object_spread({}, props), {
        egdsElementId: egdsElementId,
        essAdapter: essAdapter,
        predictiveText: enablePredictiveText,
        categorize: !!(categorize || categorizeResults),
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        handleResultSelection: handleResultSelection,
        label: label !== null && label !== void 0 ? label : "",
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        icon: (_leftIcon_title = leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.title) !== null && _leftIcon_title !== void 0 ? _leftIcon_title : defaultIcon,
        accessibility: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        errorText: fieldError ? errorTextToDisplay : "",
        required: required !== null && required !== void 0 ? required : false,
        emptyResultsPlaceholder: emptyResultsPlaceholder !== null && emptyResultsPlaceholder !== void 0 ? emptyResultsPlaceholder : "",
        analyticsLinkName: analytics.linkName,
        analyticsReferrerId: analytics.referrerId,
        closeAnalyticsLinkName: closeAnalytics === null || closeAnalytics === void 0 ? void 0 : closeAnalytics.linkName,
        closeAnalyticsReferrerId: closeAnalytics === null || closeAnalytics === void 0 ? void 0 : closeAnalytics.referrerId,
        changeAnalyticsLinkName: changeAnalytics === null || changeAnalytics === void 0 ? void 0 : changeAnalytics.linkName,
        changeAnalyticsReferrerId: changeAnalytics === null || changeAnalytics === void 0 ? void 0 : changeAnalytics.referrerId,
        selectedItemHeading: selectedItemHeading !== null && selectedItemHeading !== void 0 ? selectedItemHeading : "",
        dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : "",
        __typename: __typename,
        regionId: regionId,
        isDestination: isDestination,
        debounceRate: debounceRate !== null && debounceRate !== void 0 ? debounceRate : void 0,
        showCurrentLocation: showCurrentLocation !== null && showCurrentLocation !== void 0 ? showCurrentLocation : false,
        withoutCustomStyling: typeaheadCustomWithoutSpecificCSSExposure.bucket === 1
    });
    if (isMultiLocation) {
        return /* @__PURE__ */ React50.createElement(MultiLocationField, _object_spread_props(_object_spread({}, commonProps), {
            multiLocations: multiLocations !== null && multiLocations !== void 0 ? multiLocations : [],
            clearAllText: clearAllText !== null && clearAllText !== void 0 ? clearAllText : "",
            onMultiSelectClose: onMultiSelectClose,
            onMultiSelectItemRemove: onMultiSelectItemRemove,
            onMultiSelectClearAll: onMultiSelectClearAll,
            onLocationsSelection: onLocationsSelection,
            eventTracker: eventTracker
        }));
    }
    return /* @__PURE__ */ React50.createElement(LocationField, _object_spread_props(_object_spread({}, commonProps), {
        value: value !== null && value !== void 0 ? value : "",
        pinnedPropertyId: pinnedPropertyId !== null && pinnedPropertyId !== void 0 ? pinnedPropertyId : "",
        alternativeLocationLabel: alternativeLocationLabel,
        propertyRefinements: propertyRefinements,
        skipReflection: skipReflection,
        onDismissLocation: onDismissLocation,
        eventTracker: eventTracker
    }));
};
EGDSSearchFormLocationField.displayName = DISPLAY_NAME10;
EGDSSearchFormLocationField.fragment = _object_spread_props(_object_spread({}, __Fragment23), {
    __typename: DISPLAY_NAME10
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-search-form-travelers-field.tsx
import React68 from "react";
import { gql as gql45 } from "@apollo/client";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-basic-traveler-selector.tsx
import React61 from "react";
import { gql as gql40 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize4 } from "@egds/react-core/button";
import { ViewMedium as ViewMedium5, Viewport as Viewport8 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
// ../internal/src/components/common/button/egds-primary-button.tsx
import React51 from "react";
import { gql as gql32 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize3, UitkFloatingFullWidthButton as UitkFloatingFullWidthButton2, UitkPrimaryButton as UitkPrimaryButton3 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { UitkScrim as UitkScrim2 } from "uitk-react-scrim";
var __Fragment24 = gql32(_templateObject32(), EGDSButtonFragment);
var EGDSPrimaryButton = function(param) {
    var data = param.data, onClick = param.onClick, size = param.size, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth, _param_floating = param.floating, floating = _param_floating === void 0 ? false : _param_floating;
    var egdsElementId = data.egdsElementId, primary = data.primary, analytics = data.analytics;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
    var track = useClickTracker14();
    var handleClick = React51.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    var primaryButtonProps = {
        onClick: handleClick,
        id: id,
        isFullWidth: isFullWidth,
        size: size || UitkButtonSize3.LARGE
    };
    return floating ? /* @__PURE__ */ React51.createElement(UitkScrim2, {
        type: "fade-button"
    }, /* @__PURE__ */ React51.createElement(UitkFloatingFullWidthButton2, _object_spread({}, primaryButtonProps), primary)) : /* @__PURE__ */ React51.createElement(UitkPrimaryButton3, _object_spread({}, primaryButtonProps), primary);
};
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
EGDSPrimaryButton.fragment = __Fragment24;
// ../internal/src/components/common/button/egds-tertiary-button.tsx
import React52 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkTertiaryButton as UitkTertiaryButton3 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon6 } from "uitk-react-icons";
var __Fragment25 = gql33(_templateObject33(), EGDSButtonFragment);
var EGDSTertiaryButton = function(param) {
    var onClick = param.onClick, isFullWidth = param.isFullWidth, size = param.size, data = param.data, isDisabled = param.isDisabled, domRef = param.domRef;
    var egdsElementId = data.egdsElementId, primary = data.primary, disabled = data.disabled, accessibility = data.accessibility, analytics = data.analytics, icon = data.icon;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_tertiary_button";
    var track = useClickTracker15();
    var disableState = isDisabled || disabled;
    var handleClick = React52.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React52.createElement(UitkTertiaryButton3, {
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
        id: id,
        "data-test-id": id,
        onClick: handleClick,
        disabled: disableState,
        isFullWidth: isFullWidth,
        size: size,
        domRef: domRef
    }, icon && /* @__PURE__ */ React52.createElement(UitkIcon6, {
        name: icon.id
    }), primary);
};
EGDSTertiaryButton.displayName = "EGDSTertiaryButton";
EGDSTertiaryButton.fragment = __Fragment25;
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers.tsx
import React60 from "react";
import { gql as gql39 } from "@apollo/client";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-children.tsx
import React58 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-child-age-select.tsx
import React56 from "react";
import { gql as gql35 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { UitkSelect } from "uitk-react-input";
// ../internal/src/components/common/egds-basic-option.tsx
import React53 from "react";
import { gql as gql34 } from "@apollo/client";
var __Fragment26 = gql34(_templateObject34());
var EGDSBasicOption = function(param) {
    var data = param.data;
    var label = data.label, value = data.value, egdsElementId = data.egdsElementId;
    var key = "".concat(egdsElementId, "-").concat(value);
    return /* @__PURE__ */ React53.createElement("option", {
        key: key,
        value: value
    }, label);
};
EGDSBasicOption.displayName = "EGDSBasicOptionFragment";
EGDSBasicOption.fragment = __Fragment26;
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-provider.tsx
import React55 from "react";
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-provider.tsx
import React54 from "react";
var noAgeSelected = function(infantOrChild) {
    return infantOrChild.__typename === "EGDSTravelerChildAgeSelect" && infantOrChild.value === null;
};
var getChildCountWithoutAge = function(rooms) {
    return rooms.reduce(function(count, room) {
        var _room_infants;
        var childrenAges = room.children.__typename === "EGDSTravelerChildren" ? room.children.ages : [];
        var infantAges = ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" ? room.infants.ages : [];
        var _infantAges_filter_length;
        return count + childrenAges.filter(noAgeSelected).length + ((_infantAges_filter_length = infantAges.filter(noAgeSelected).length) !== null && _infantAges_filter_length !== void 0 ? _infantAges_filter_length : 0);
    }, 0);
};
var getChildren = function(childCount, childAges, room) {
    if (room.children.__typename === "EGDSTravelerChildren") {
        var children = room.children;
        var newChildren = _object_spread_props(_object_spread({}, children), {
            count: _object_spread_props(_object_spread({}, children.count), {
                value: childCount
            }),
            ages: childAges.length ? childAges.map(function(childAge) {
                return _object_spread_props(_object_spread({}, children.ageTemplate), {
                    value: childAge
                });
            }) : []
        });
        return _object_spread({}, newChildren);
    }
    return _object_spread({}, room.children);
};
var getTravelersError = function(currentError, rooms, validations2, currentInfantSelection) {
    if (!validations2) {
        return null;
    }
    var travelersCount = rooms.reduce(function(count, room) {
        var _room_infants;
        var _room_infants_count_value;
        return count + room.adults.value + room.children.count.value + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
    }, 0);
    var infantsOnLap = currentInfantSelection === "lap" ? rooms.reduce(function(count, room) {
        var _room_infants;
        var _room_infants_count_value;
        return count + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
    }, 0) : 0;
    var infantInSeat = currentInfantSelection === "seat" ? rooms.reduce(function(count, room) {
        var _room_infants;
        var _room_infants_count_value;
        return count + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
    }, 0) : 0;
    var adultCount = rooms.reduce(function(count, room) {
        var _room_adults_value;
        return count + ((_room_adults_value = room.adults.value) !== null && _room_adults_value !== void 0 ? _room_adults_value : 0);
    }, 0);
    var olderChildren = rooms.reduce(function(count, room) {
        var ages = room.children.__typename === "EGDSTravelerChildren" ? room.children.ages : [];
        var _ages_filter_length;
        return count + ((_ages_filter_length = ages.filter(function(age) {
            return age.__typename === "EGDSTravelerChildAgeSelect" && age.value && age.value >= 12;
        }).length) !== null && _ages_filter_length !== void 0 ? _ages_filter_length : 0);
    }, 0);
    var childWithoutAgeCount = getChildCountWithoutAge(rooms);
    var checkInfantsOnLap = olderChildren + adultCount < infantsOnLap;
    var errors = validations2.map(function(validation) {
        if (validation.__typename === "EGDSTravelersInputValidation") {
            var type = validation.type, message = validation.errorMessage, maxCount = validation.maxCount, errorSummary5 = validation.errorSummary, infantsInSeatPerAdult = validation.infantsInSeatPerAdult;
            var _obj;
            var validationErrors = (_obj = {}, _define_property(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */ , maxCount && travelersCount > maxCount ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: _object_spread_props(_object_spread({}, errorSummary5), {
                    heading: message
                })
            } : null), _define_property(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ , childWithoutAgeCount > 0 ? {
                message: message,
                type: type,
                displayConfirmation: false,
                errorCount: childWithoutAgeCount,
                errorSummary: errorSummary5
            } : null), _define_property(_obj, "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */ , checkInfantsOnLap ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary5
            } : null), _define_property(_obj, "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */ , infantsInSeatPerAdult && olderChildren + adultCount < infantInSeat / infantsInSeatPerAdult ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary5
            } : null), _obj);
            var _validationErrors_type;
            return (_validationErrors_type = validationErrors[type]) !== null && _validationErrors_type !== void 0 ? _validationErrors_type : null;
        }
        return null;
    }).filter(function(error) {
        return error !== null;
    });
    var sameErrorPresent = errors.find(function(error) {
        return currentError && currentError.type === error.type;
    });
    if (sameErrorPresent && (currentError === null || currentError === void 0 ? void 0 : currentError.displayConfirmation)) {
        return _object_spread_props(_object_spread({}, currentError), {
            errorCount: currentError.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  ? childWithoutAgeCount : 1
        });
    }
    var _errors_;
    return (_errors_ = errors[0]) !== null && _errors_ !== void 0 ? _errors_ : null;
};
var travelersReducer = function(state, action) {
    switch(action.type){
        case "ADD_ROOM":
            {
                var _state_rooms_ = state.rooms[0], adults = _state_rooms_.adults, label = _state_rooms_.label, removeRoomButton = _state_rooms_.removeRoomButton, removeRoomAnnouncement = _state_rooms_.removeRoomAnnouncement, children = _state_rooms_.children, infants = _state_rooms_.infants;
                if (adults.__typename === "EGDSTravelerStepInput" && children.__typename === "EGDSTravelerChildren" && children.ages) {
                    var _state_infantSeatSelection;
                    var defaultChildrenCount = _object_spread_props(_object_spread({}, children.count), {
                        value: 0
                    });
                    var defaultRoom = {
                        __typename: "EGDSTravelerSelectorRoom",
                        children: _object_spread_props(_object_spread({}, children), {
                            count: defaultChildrenCount,
                            ages: []
                        }),
                        adults: _object_spread_props(_object_spread({}, adults), {
                            value: 1
                        }),
                        label: label,
                        removeRoomButton: removeRoomButton,
                        removeRoomAnnouncement: removeRoomAnnouncement,
                        infants: (infants === null || infants === void 0 ? void 0 : infants.__typename) === "EGDSTravelerInfant" ? _object_spread_props(_object_spread({}, infants), {
                            count: _object_spread_props(_object_spread({}, infants.count), {
                                value: 0
                            }),
                            ages: []
                        }) : null
                    };
                    var rooms = state.rooms.concat(defaultRoom);
                    var _state_validations;
                    var error = getTravelersError(state.error ? state.error : null, rooms, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : [], (_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value);
                    return _object_spread_props(_object_spread({}, state), {
                        rooms: rooms,
                        error: error
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    rooms: []
                });
            }
        case "REMOVE_ROOM":
            {
                var _state_infantSeatSelection1;
                var roomIndex = action.roomIndex;
                var rooms1 = state.rooms.filter(function(_, index) {
                    return index !== roomIndex;
                });
                var _state_validations1;
                var error1 = getTravelersError(state.error ? state.error : null, rooms1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : [], (_state_infantSeatSelection1 = state.infantSeatSelection) === null || _state_infantSeatSelection1 === void 0 ? void 0 : _state_infantSeatSelection1.value);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: rooms1,
                    error: error1
                });
            }
        case "RESET_STATE":
            {
                return action.state;
            }
        case "RESET_ROOMS":
            {
                return _object_spread_props(_object_spread({}, state), {
                    rooms: action.state.rooms
                });
            }
        case "UPDATE_INFANT_SEAT_SELECTION":
            {
                var value = action.value;
                var _state_validations2;
                var error2 = getTravelersError(state.error ? state.error : null, state.rooms, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : [], value);
                return _object_spread_props(_object_spread({}, state), {
                    infantSeatSelection: {
                        value: action.value
                    },
                    error: error2
                });
            }
        case "UPDATE_TRAVELERS_COUNT":
            {
                var _state_infantSeatSelection2;
                var roomIndex1 = action.roomIndex, count = action.count, travelersType = action.travelersType;
                var rooms2 = state.rooms.map(function(room, index) {
                    if (index === roomIndex1) {
                        switch(travelersType){
                            case "adults" /* ADULTS */ :
                                {
                                    return _object_spread_props(_object_spread({}, room), {
                                        adults: _object_spread_props(_object_spread({}, room.adults), {
                                            value: count
                                        })
                                    });
                                }
                            case "children" /* CHILDREN */ :
                                {
                                    if (room.children.__typename === "EGDSTravelerChildren") {
                                        var _children_ages, _children_ages1;
                                        var children = room.children;
                                        var childrenAdded = count > children.count.value;
                                        var ageTemplateWithoutDefaultAge = children.ageTemplate.__typename === "EGDSTravelerChildAgeSelect" ? _object_spread_props(_object_spread({}, children.ageTemplate), {
                                            value: null
                                        }) : null;
                                        var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(ageTemplateWithoutDefaultAge !== null && ageTemplateWithoutDefaultAge !== void 0 ? ageTemplateWithoutDefaultAge : children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
                                        var newChildren = _object_spread_props(_object_spread({}, children), {
                                            count: _object_spread_props(_object_spread({}, children.count), {
                                                value: count
                                            }),
                                            ages: ages
                                        });
                                        return _object_spread_props(_object_spread({}, room), {
                                            children: newChildren
                                        });
                                    }
                                    return room;
                                }
                            case "infants" /* INFANTS */ :
                                {
                                    var _room_infants;
                                    if (((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant") {
                                        var infants = room.infants;
                                        var infantsAdded = count > infants.count.value;
                                        var ages1 = infantsAdded ? infants.ages.concat(infants.ageTemplate) : infants.ages.slice(0, -1);
                                        var newInfants = _object_spread_props(_object_spread({}, infants), {
                                            count: _object_spread_props(_object_spread({}, infants.count), {
                                                value: count
                                            }),
                                            ages: ages1
                                        });
                                        return _object_spread_props(_object_spread({}, room), {
                                            infants: newInfants
                                        });
                                    }
                                    return room;
                                }
                            default:
                                return room;
                        }
                    }
                    return room;
                });
                var _state_validations3;
                var error3 = getTravelersError(state.error ? state.error : null, rooms2, (_state_validations3 = state.validations) !== null && _state_validations3 !== void 0 ? _state_validations3 : [], (_state_infantSeatSelection2 = state.infantSeatSelection) === null || _state_infantSeatSelection2 === void 0 ? void 0 : _state_infantSeatSelection2.value);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: rooms2,
                    error: error3
                });
            }
        case "UPDATE_CHILD_AGE":
            {
                var _state_infantSeatSelection3;
                var roomIndex2 = action.roomIndex, childIndex = action.childIndex, childAge = action.childAge, isInfant = action.isInfant;
                var rooms3 = state.rooms.map(function(room, index) {
                    var _room_infants;
                    if (index === roomIndex2 && room.children.__typename === "EGDSTravelerChildren" && !isInfant) {
                        return _object_spread_props(_object_spread({}, room), {
                            children: _object_spread_props(_object_spread({}, room.children), {
                                ages: room.children.ages.map(function(child, ageIndex) {
                                    return child.__typename === "EGDSTravelerChildAgeSelect" && childIndex === ageIndex ? _object_spread_props(_object_spread({}, child), {
                                        value: childAge
                                    }) : _object_spread({}, child);
                                })
                            })
                        });
                    }
                    if (index === roomIndex2 && ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" && isInfant) {
                        return _object_spread_props(_object_spread({}, room), {
                            infants: _object_spread_props(_object_spread({}, room.infants), {
                                ages: room.infants.ages.map(function(infant, ageIndex) {
                                    return infant.__typename === "EGDSTravelerChildAgeSelect" && childIndex === ageIndex ? _object_spread_props(_object_spread({}, infant), {
                                        value: childAge
                                    }) : _object_spread({}, infant);
                                })
                            })
                        });
                    }
                    return room;
                });
                var _state_validations4;
                var error4 = getTravelersError(state.error ? state.error : null, rooms3, (_state_validations4 = state.validations) !== null && _state_validations4 !== void 0 ? _state_validations4 : [], (_state_infantSeatSelection3 = state.infantSeatSelection) === null || _state_infantSeatSelection3 === void 0 ? void 0 : _state_infantSeatSelection3.value);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: rooms3,
                    error: error4
                });
            }
        case "SHOW_ERROR":
            {
                if (state.error) {
                    var _state_error = state.error, message = _state_error.message, type = _state_error.type, errorCount = _state_error.errorCount, errorSummary5 = _state_error.errorSummary;
                    var newError = {
                        message: message,
                        type: type,
                        displayConfirmation: true,
                        errorCount: errorCount,
                        errorSummary: errorSummary5
                    };
                    return _object_spread_props(_object_spread({}, state), {
                        error: newError
                    });
                }
                return _object_spread({}, state);
            }
        case "SET_VALIDATIONS":
            {
                return _object_spread_props(_object_spread({}, state), {
                    validations: action.validations
                });
            }
        case "UPDATE_TRAVELERS_BULK":
            {
                var adultTravelerCounts = action.adultTravelerCounts, childTravelerCounts = action.childTravelerCounts, childrenAges = action.childrenAges;
                if (adultTravelerCounts === null || adultTravelerCounts === void 0 ? void 0 : adultTravelerCounts.length) {
                    var newRooms = adultTravelerCounts.map(function(adultCount, roomIndex) {
                        return _object_spread_props(_object_spread({}, state.rooms[roomIndex]), {
                            adults: _object_spread_props(_object_spread({}, state.rooms[roomIndex].adults), {
                                value: adultCount
                            }),
                            children: (childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) ? getChildren((childTravelerCounts === null || childTravelerCounts === void 0 ? void 0 : childTravelerCounts.length) ? childTravelerCounts[roomIndex] : 0, childrenAges[roomIndex], state.rooms[roomIndex]) : _object_spread_props(_object_spread({}, state.rooms[roomIndex].children), {
                                count: _object_spread_props(_object_spread({}, state.rooms[roomIndex].children.count), {
                                    value: 0
                                }),
                                ages: []
                            })
                        });
                    });
                    return _object_spread_props(_object_spread({}, state), {
                        rooms: newRooms
                    });
                }
                return _object_spread({}, state);
            }
        default:
            return state;
    }
};
var TravelersContext = React54.createContext({
    state: {}
});
var TravelersProvider = function(param) {
    var children = param.children, rooms = param.rooms, validations2 = param.validations, skipQuery = param.skipQuery, infantSeatSelection = param.infantSeatSelection;
    var _React54_useReducer = _sliced_to_array(React54.useReducer(travelersReducer, {
        rooms: rooms,
        validations: validations2,
        infantSeatSelection: infantSeatSelection ? {
            value: infantSeatSelection.selected
        } : null
    }), 2), state = _React54_useReducer[0], dispatch = _React54_useReducer[1];
    var _React54_useState = _sliced_to_array(React54.useState(state), 2), currentState = _React54_useState[0], setCurrentState = _React54_useState[1];
    React54.useEffect(function() {
        if (!skipQuery) {
            dispatch({
                type: "RESET_STATE",
                state: {
                    rooms: rooms,
                    validations: validations2,
                    infantSeatSelection: infantSeatSelection ? {
                        value: infantSeatSelection.selected
                    } : null
                }
            });
        }
    }, [
        skipQuery,
        infantSeatSelection,
        rooms
    ]);
    React54.useEffect(function() {
        if (state !== currentState) {
            setCurrentState(state);
        }
    }, [
        state,
        currentState
    ]);
    React54.useEffect(function() {
        dispatch({
            type: "SET_VALIDATIONS",
            validations: validations2
        });
    }, [
        validations2
    ]);
    var travelersContext = {
        state: currentState,
        dispatch: dispatch
    };
    return /* @__PURE__ */ React54.createElement(TravelersContext.Provider, {
        value: travelersContext
    }, children);
};
var useTravelersContext = function() {
    return React54.useContext(TravelersContext);
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-provider.tsx
var noAgeSelected2 = function(childrenAge) {
    return childrenAge.__typename === "EGDSTravelerChildAgeSelect" && childrenAge.value === null;
};
var noInfantsInSeatAgeSelected = function(infantsInSeatAge) {
    return infantsInSeatAge.__typename === "EGDSTravelerChildAgeSelect" && infantsInSeatAge.value === null;
};
var noInfantsOnLapAgeSelected = function(infantsOnLap) {
    return infantsOnLap.__typename === "EGDSTravelerChildAgeSelect" && infantsOnLap.value === null;
};
var getChildCountWithoutAge2 = function(children) {
    return (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" ? children.ages.filter(noAgeSelected2).length : 0;
};
var getInfantsInSeatCountWithoutAge = function(infantInSeat) {
    return (infantInSeat === null || infantInSeat === void 0 ? void 0 : infantInSeat.__typename) === "EGDSTravelerInfant" ? infantInSeat === null || infantInSeat === void 0 ? void 0 : infantInSeat.ages.filter(noInfantsInSeatAgeSelected).length : 0;
};
var getInfantsOnLapCountWithoutAge = function(infantOnLap) {
    return (infantOnLap === null || infantOnLap === void 0 ? void 0 : infantOnLap.__typename) === "EGDSTravelerInfant" ? infantOnLap === null || infantOnLap === void 0 ? void 0 : infantOnLap.ages.filter(noInfantsOnLapAgeSelected).length : 0;
};
var getTravelersError2 = function(currentError, travelers, validations2) {
    var _travelers_children, _travelers_infantsInSeat, _travelers_infantsOnLap, _travelers_children1, _travelers_children2;
    if (!validations2) {
        return null;
    }
    var _travelers_children_count_value;
    var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
    var _travelers_infantsInSeat_count_value;
    var infantInSeat = (_travelers_infantsInSeat_count_value = (_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.count.value) !== null && _travelers_infantsInSeat_count_value !== void 0 ? _travelers_infantsInSeat_count_value : 0;
    var _travelers_infantsOnLap_count_value;
    var infantsOnLap = (_travelers_infantsOnLap_count_value = (_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.count.value) !== null && _travelers_infantsOnLap_count_value !== void 0 ? _travelers_infantsOnLap_count_value : 0;
    var _travelers_adults_value;
    var adultCount = (_travelers_adults_value = travelers.adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
    var travelersCount = adultCount + childrenCount + infantInSeat + infantsOnLap;
    var childWithoutAgeCount = getChildCountWithoutAge2(travelers.children);
    var infantInSeatWithoutAgeCount = getInfantsInSeatCountWithoutAge(travelers.infantsInSeat);
    var infantsOnLapWithoutAgeCount = getInfantsOnLapCountWithoutAge(travelers.infantsOnLap);
    var kidsWithoutAgeCount = childWithoutAgeCount + infantInSeatWithoutAgeCount + infantsOnLapWithoutAgeCount;
    var olderChildren = ((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSTravelerChildren" ? (_travelers_children2 = travelers.children) === null || _travelers_children2 === void 0 ? void 0 : _travelers_children2.ages.filter(function(age) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && age.value && age.value >= 12;
    }).length : 0;
    var checkInfantsOnLap = olderChildren + adultCount < infantsOnLap;
    var errors = validations2.map(function(validation) {
        if (validation.__typename === "EGDSTravelersInputValidation") {
            var type = validation.type, message = validation.errorMessage, maxCount = validation.maxCount, errorSummary5 = validation.errorSummary, infantsInSeatPerAdult = validation.infantsInSeatPerAdult;
            var _obj;
            var validationErrors = (_obj = {}, _define_property(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */ , maxCount ? travelersCount > maxCount && {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary5
            } : null), _define_property(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ , kidsWithoutAgeCount > 0 ? {
                message: message,
                type: type,
                displayConfirmation: false,
                errorCount: kidsWithoutAgeCount,
                errorSummary: errorSummary5
            } : null), _define_property(_obj, "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */ , checkInfantsOnLap ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary5
            } : null), _define_property(_obj, "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */ , infantsInSeatPerAdult && olderChildren + adultCount < infantInSeat / infantsInSeatPerAdult ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary5
            } : null), _obj);
            return validationErrors[type];
        }
        return null;
    }).filter(function(error) {
        return !!error;
    });
    var sameErrorPresent = errors.find(function(error) {
        return currentError && currentError.type === (error === null || error === void 0 ? void 0 : error.type);
    });
    if (sameErrorPresent && (currentError === null || currentError === void 0 ? void 0 : currentError.displayConfirmation)) {
        return _object_spread_props(_object_spread({}, currentError), {
            errorCount: currentError.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  ? kidsWithoutAgeCount : 1
        });
    }
    return errors ? errors[0] : null;
};
var getTravelersWithPets = function(travelers, petCount) {
    var _travelers_pets;
    if (((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox") {
        var state = petCount > 0 ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
        return _object_spread_props(_object_spread({}, travelers), {
            pets: _object_spread_props(_object_spread({}, travelers.pets), {
                state: state
            })
        });
    }
    return travelers;
};
var getUpdatedTravelersBulk = function(adultCount, childCount, childrenAges, travelers) {
    var _travelers_children;
    if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
        var children = travelers.children;
        return _object_spread_props(_object_spread({}, travelers), {
            adults: _object_spread_props(_object_spread({}, travelers.adults), {
                value: adultCount
            }),
            children: _object_spread_props(_object_spread({}, travelers.children), {
                count: _object_spread_props(_object_spread({}, travelers.children.count), {
                    value: childCount
                }),
                ages: childrenAges.length ? childrenAges.map(function(childAge) {
                    return _object_spread_props(_object_spread({}, children === null || children === void 0 ? void 0 : children.ageTemplate), {
                        value: childAge
                    });
                }) : []
            })
        });
    }
    return travelers;
};
var getUpdatedTravelersCount = function(travelers, action) {
    switch(action.travelersType){
        case "adults" /* ADULTS */ :
            {
                return _object_spread_props(_object_spread({}, travelers), {
                    adults: _object_spread_props(_object_spread({}, travelers.adults), {
                        value: action.count
                    })
                });
            }
        case "children" /* CHILDREN */ :
            {
                var _travelers_children, _travelers_children1;
                if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
                    var _children_ages, _children_ages1;
                    var children = travelers.children;
                    var childrenAdded = action.count > children.count.value;
                    var ageTemplateWithoutDefaultAge = children.ageTemplate.__typename === "EGDSTravelerChildAgeSelect" ? _object_spread_props(_object_spread({}, children.ageTemplate), {
                        value: null
                    }) : null;
                    var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(ageTemplateWithoutDefaultAge !== null && ageTemplateWithoutDefaultAge !== void 0 ? ageTemplateWithoutDefaultAge : children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
                    var newChildren = _object_spread_props(_object_spread({}, children), {
                        count: _object_spread_props(_object_spread({}, children.count), {
                            value: action.count
                        }),
                        ages: ages
                    });
                    return _object_spread_props(_object_spread({}, travelers), {
                        children: newChildren
                    });
                }
                if (((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSBasicTraveler") {
                    var children1 = travelers.children;
                    return _object_spread_props(_object_spread({}, travelers), {
                        children: _object_spread_props(_object_spread({}, children1), {
                            count: _object_spread_props(_object_spread({}, children1.count), {
                                value: action.count
                            })
                        })
                    });
                }
                return travelers;
            }
        case "infants_in_seat" /* INFANTS_IN_SEAT */ :
            {
                var _travelers_infantsInSeat, _travelers_infantsOnLap, _travelers_infantsInSeat1;
                if (((_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.__typename) === "EGDSTravelerInfant" && ((_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.__typename) === "EGDSTravelerInfant") {
                    var _infantsInSeat_ages, _infantsInSeat_ages1;
                    var infantsInSeat = travelers.infantsInSeat, infantsOnLap = travelers.infantsOnLap;
                    var infantsInSeatAdded = action.count > infantsInSeat.count.value;
                    var ages1 = infantsInSeatAdded ? (_infantsInSeat_ages = infantsInSeat.ages) === null || _infantsInSeat_ages === void 0 ? void 0 : _infantsInSeat_ages.concat(infantsInSeat.ageTemplate) : (_infantsInSeat_ages1 = infantsInSeat.ages) === null || _infantsInSeat_ages1 === void 0 ? void 0 : _infantsInSeat_ages1.slice(0, -1);
                    var newInfantsInSeat = _object_spread_props(_object_spread({}, infantsInSeat), {
                        count: _object_spread_props(_object_spread({}, infantsInSeat.count), {
                            value: action.count
                        }),
                        ages: ages1
                    });
                    var maxAllowedInfantsOnLap = newInfantsInSeat.count.value > 0 ? 0 : newInfantsInSeat.count.max;
                    var newinfantsOnLap = _object_spread_props(_object_spread({}, infantsOnLap), {
                        count: _object_spread_props(_object_spread({}, infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.count), {
                            max: maxAllowedInfantsOnLap
                        })
                    });
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsInSeat: newInfantsInSeat,
                        infantsOnLap: newinfantsOnLap
                    });
                }
                if (((_travelers_infantsInSeat1 = travelers.infantsInSeat) === null || _travelers_infantsInSeat1 === void 0 ? void 0 : _travelers_infantsInSeat1.__typename) === "EGDSBasicTraveler") {
                    var infantsInSeat1 = travelers.infantsInSeat;
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsInSeat: _object_spread_props(_object_spread({}, infantsInSeat1), {
                            count: _object_spread_props(_object_spread({}, infantsInSeat1.count), {
                                value: action.count
                            })
                        })
                    });
                }
                return travelers;
            }
        case "infants_on_lap" /* INFANTS_ON_LAP */ :
            {
                var _travelers_infantsOnLap1, _travelers_infantsInSeat2, _travelers_infantsOnLap2;
                if (((_travelers_infantsOnLap1 = travelers.infantsOnLap) === null || _travelers_infantsOnLap1 === void 0 ? void 0 : _travelers_infantsOnLap1.__typename) === "EGDSTravelerInfant" && ((_travelers_infantsInSeat2 = travelers.infantsInSeat) === null || _travelers_infantsInSeat2 === void 0 ? void 0 : _travelers_infantsInSeat2.__typename) === "EGDSTravelerInfant") {
                    var _infantsOnLap_ages, _infantsOnLap_ages1;
                    var infantsOnLap1 = travelers.infantsOnLap, infantsInSeat2 = travelers.infantsInSeat;
                    var infantsOnLapAdded = action.count > infantsOnLap1.count.value;
                    var ages2 = infantsOnLapAdded ? (_infantsOnLap_ages = infantsOnLap1.ages) === null || _infantsOnLap_ages === void 0 ? void 0 : _infantsOnLap_ages.concat(infantsOnLap1.ageTemplate) : (_infantsOnLap_ages1 = infantsOnLap1.ages) === null || _infantsOnLap_ages1 === void 0 ? void 0 : _infantsOnLap_ages1.slice(0, -1);
                    var newInfantsOnLap = _object_spread_props(_object_spread({}, infantsOnLap1), {
                        count: _object_spread_props(_object_spread({}, infantsOnLap1.count), {
                            value: action.count
                        }),
                        ages: ages2
                    });
                    var maxAllowedInfantsInSeat = newInfantsOnLap.count.value > 0 ? 0 : newInfantsOnLap.count.max;
                    var newinfantsInSeat = _object_spread_props(_object_spread({}, infantsInSeat2), {
                        count: _object_spread_props(_object_spread({}, infantsInSeat2 === null || infantsInSeat2 === void 0 ? void 0 : infantsInSeat2.count), {
                            max: maxAllowedInfantsInSeat
                        })
                    });
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsOnLap: newInfantsOnLap,
                        infantsInSeat: newinfantsInSeat
                    });
                }
                if (((_travelers_infantsOnLap2 = travelers.infantsOnLap) === null || _travelers_infantsOnLap2 === void 0 ? void 0 : _travelers_infantsOnLap2.__typename) === "EGDSBasicTraveler") {
                    var infantsOnLap2 = travelers.infantsOnLap;
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsOnLap: _object_spread_props(_object_spread({}, infantsOnLap2), {
                            count: _object_spread_props(_object_spread({}, infantsOnLap2.count), {
                                value: action.count
                            })
                        })
                    });
                }
                return travelers;
            }
        default:
            return travelers;
    }
};
var getUpdatedChildAge = function(travelers, action) {
    var _travelers_children, _travelers_infantsInSeat, _travelers_infantsOnLap;
    if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren" && action.infantType === "") {
        return _object_spread_props(_object_spread({}, travelers), {
            children: _object_spread_props(_object_spread({}, travelers.children), {
                ages: travelers.children.ages.map(function(child, ageIndex) {
                    return child.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, child), {
                        value: action.childAge
                    }) : _object_spread({}, child);
                })
            })
        });
    }
    if (((_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.__typename) === "EGDSTravelerInfant" && action.infantType === "infants_in_seat" /* INFANTS_IN_SEAT */ ) {
        return _object_spread_props(_object_spread({}, travelers), {
            infantsInSeat: _object_spread_props(_object_spread({}, travelers.infantsInSeat), {
                ages: travelers.infantsInSeat.ages.map(function(infantInSeat, ageIndex) {
                    return infantInSeat.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, infantInSeat), {
                        value: action.childAge
                    }) : _object_spread({}, infantInSeat);
                })
            })
        });
    }
    if (((_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.__typename) === "EGDSTravelerInfant" && action.infantType === "infants_on_lap" /* INFANTS_ON_LAP */ ) {
        return _object_spread_props(_object_spread({}, travelers), {
            infantsOnLap: _object_spread_props(_object_spread({}, travelers.infantsOnLap), {
                ages: travelers.infantsOnLap.ages.map(function(infantsOnLap, ageIndex) {
                    return infantsOnLap.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, infantsOnLap), {
                        value: action.childAge
                    }) : _object_spread({}, infantsOnLap);
                })
            })
        });
    }
    return travelers;
};
var getUpdatedPetsFilter = function(travelers, action) {
    var _travelers_pets;
    if (((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox") {
        var state = action.checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
        return _object_spread_props(_object_spread({}, travelers), {
            pets: _object_spread_props(_object_spread({}, travelers.pets), {
                state: state
            })
        });
    }
    return travelers;
};
var travelersReducer2 = function(state, action) {
    switch(action.type){
        case "RESET_STATE":
            {
                return action.state;
            }
        case "UPDATE_TRAVELERS_COUNT":
            {
                var travelers = getUpdatedTravelersCount(state.travelers, action);
                var _state_validations;
                var error = getTravelersError2(state.error ? state.error : null, travelers, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelers,
                    error: error
                });
            }
        case "UPDATE_CHILD_AGE":
            {
                var travelers1 = getUpdatedChildAge(state.travelers, action);
                var _state_validations1;
                var error1 = getTravelersError2(state.error ? state.error : null, travelers1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelers1,
                    error: error1
                });
            }
        case "UPDATE_PETS_FILTER":
            {
                var travelers2 = getUpdatedPetsFilter(state.travelers, action);
                var _state_validations2;
                var error2 = getTravelersError2(state.error ? state.error : null, travelers2, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelers2,
                    error: error2
                });
            }
        case "SHOW_ERROR":
            {
                if (state.error) {
                    var _state_error = state.error, message = _state_error.message, type = _state_error.type, errorCount = _state_error.errorCount, errorSummary5 = _state_error.errorSummary;
                    var newError = {
                        message: message,
                        type: type,
                        displayConfirmation: true,
                        errorCount: errorCount,
                        errorSummary: errorSummary5
                    };
                    return _object_spread_props(_object_spread({}, state), {
                        error: newError
                    });
                }
                return _object_spread({}, state);
            }
        case "UPDATE_TRAVELERS_BULK":
            {
                var adultTravelerCounts = action.adultTravelerCounts, childTravelerCounts = action.childTravelerCounts, childrenAges = action.childrenAges, petCounts = action.petCounts;
                var travelers3 = getUpdatedTravelersBulk(adultTravelerCounts, childTravelerCounts, childrenAges, state.travelers);
                var travelersWithPets = getTravelersWithPets(travelers3, petCounts);
                var _state_validations3;
                var error3 = getTravelersError2(state.error ? state.error : null, travelers3, (_state_validations3 = state.validations) !== null && _state_validations3 !== void 0 ? _state_validations3 : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelersWithPets,
                    error: error3
                });
            }
        default:
            return state;
    }
};
var TravelersContext2 = React55.createContext({
    state: {}
});
var BasicTravelersProvider = function(param) {
    var children = param.children, travelers = param.travelers, validations2 = param.validations, skipQuery = param.skipQuery;
    var _React55_useReducer = _sliced_to_array(React55.useReducer(travelersReducer2, {
        travelers: travelers,
        validations: validations2
    }), 2), state = _React55_useReducer[0], dispatch = _React55_useReducer[1];
    React55.useEffect(function() {
        if (!skipQuery) {
            dispatch({
                type: "RESET_STATE",
                state: {
                    travelers: travelers,
                    validations: validations2
                }
            });
        }
    }, [
        skipQuery
    ]);
    var travelersContext = React55.useMemo(function() {
        return {
            state: state,
            dispatch: dispatch
        };
    }, [
        state,
        dispatch
    ]);
    return /* @__PURE__ */ React55.createElement(TravelersContext2.Provider, {
        value: travelersContext
    }, children);
};
var useBasicTravelersContext = function() {
    return React55.useContext(TravelersContext2);
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-child-age-select.tsx
var __Fragment27 = gql35(_templateObject35(), EGDSBasicOption.fragment);
var EGDSTravelerChildAgeSelect = function(param) {
    var childIndex = param.childIndex, roomIndex = param.roomIndex, isInfant = param.isInfant, infantType = param.infantType, childAgeRef = param.childAgeRef, data = param.data;
    var travelersContext = useTravelersContext();
    var basicTravelersContext = useBasicTravelersContext();
    var hasRooms = roomIndex !== void 0;
    var labelTemplate = data.labelTemplate, options = data.options, egdsElementId = data.egdsElementId, value = data.value;
    var track = useClickTracker16();
    var onChange = function(event) {
        var age = parseInt(event.target.value, 10);
        var currentOption = options.find(function(option) {
            return option.__typename === "EGDSBasicOption" && option.value === event.target.value;
        });
        if (currentOption && (currentOption === null || currentOption === void 0 ? void 0 : currentOption.__typename) === "EGDSBasicOption" && (currentOption === null || currentOption === void 0 ? void 0 : currentOption.changeAnalytics)) {
            var _currentOption_changeAnalytics = currentOption.changeAnalytics, referrerId = _currentOption_changeAnalytics.referrerId, linkName = _currentOption_changeAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (!Number.isNaN(age)) {
            if (hasRooms) {
                travelersContext.dispatch({
                    type: "UPDATE_CHILD_AGE",
                    roomIndex: roomIndex,
                    childIndex: childIndex,
                    childAge: age,
                    isInfant: isInfant,
                    infantType: infantType
                });
            } else {
                basicTravelersContext.dispatch({
                    type: "UPDATE_CHILD_AGE",
                    childIndex: childIndex,
                    childAge: age,
                    infantType: infantType
                });
            }
        }
    };
    var elementName = "child-".concat(egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "", "-").concat(childIndex);
    var elementId = "age-".concat(egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "", "-").concat(childIndex);
    var childNumber = childIndex + 1;
    var childAge = value !== null && value !== void 0 ? value : "";
    var hasValidChildAge = Number.isInteger(childAge);
    var error = (hasRooms ? travelersContext.state : basicTravelersContext.state).error;
    var hasError = (error === null || error === void 0 ? void 0 : error.type) === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  && error.displayConfirmation;
    var errorMessage = error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  && !hasValidChildAge && hasError ? error.message : "";
    var label = labelTemplate.__typename === "EGDSBasicLocalizedText" && labelTemplate.models.length === 1 ? formatLocalizedTokenString(labelTemplate.template, labelTemplate.models[0].key, childNumber.toString()) : "";
    return /* @__PURE__ */ React56.createElement(UitkSelect, {
        domRef: childAgeRef,
        invalid: errorMessage,
        label: label,
        id: elementId,
        name: elementName,
        onChange: onChange,
        value: childAge,
        emptyState: typeof childAge === "string",
        required: true
    }, options.map(function(option) {
        return option.__typename === "EGDSBasicOption" && /* @__PURE__ */ React56.createElement(EGDSBasicOption, {
            key: "".concat(elementName, "-").concat(option.value),
            data: option
        });
    }));
};
EGDSTravelerChildAgeSelect.displayName = "EGDSTravelerChildAgeSelectFragment";
EGDSTravelerChildAgeSelect.fragment = _object_spread_props(_object_spread({}, __Fragment27), {
    __typename: "EGDSTravelerChildAgeSelect"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-step-input.tsx
import React57 from "react";
import { gql as gql37 } from "@apollo/client";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkStepInput } from "uitk-react-step-input";
// ../internal/src/components/common/egds-text/egds-localized-text-fragments.ts
import { gql as gql36 } from "@apollo/client";
var TemplateModelFragment = gql36(_templateObject36());
var EGDSBasicLocalizedTextFragment = gql36(_templateObject37(), TemplateModelFragment);
var EGDSCardinalLocalizedTextFragment = gql36(_templateObject38(), TemplateModelFragment);
var EGDSCompositeLocalizedTextFragment = gql36(_templateObject39(), TemplateModelFragment);
var EGDSLocalizedTextFragment = gql36(_templateObject40(), EGDSBasicLocalizedTextFragment, EGDSCardinalLocalizedTextFragment, EGDSCompositeLocalizedTextFragment);
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-step-input.tsx
var __Fragment28 = gql37(_templateObject41(), EGDSBasicLocalizedTextFragment);
var getStepInputText = function(textTemplate, roomIndex) {
    if ((textTemplate === null || textTemplate === void 0 ? void 0 : textTemplate.__typename) === "EGDSBasicLocalizedText") {
        var roomNumber = (roomIndex + 1).toString();
        return formatLocalizedTokenString(textTemplate.template, textTemplate.models[0].key, roomNumber);
    }
    return "";
};
var EGDSTravelersStepInput = function(param) {
    var roomIndex = param.roomIndex, travelersType = param.travelersType, data = param.data;
    var label = data.label, max = data.max, min = data.min, subLabel = data.subLabel, value = data.value;
    var travelersContext = useTravelersContext();
    var basicTravelersContext = useBasicTravelersContext();
    var clickTracker = useClickTracker17();
    var hasRooms = roomIndex !== void 0;
    var stepInputTexts = data.__typename === "EGDSTravelerStepInput" && (hasRooms ? {
        incrementText: getStepInputText(data.increaseTextTemplate, roomIndex),
        decrementText: getStepInputText(data.decreaseTextTemplate, roomIndex)
    } : {
        incrementText: data.increaseText || "",
        decrementText: data.decreaseText || ""
    });
    var onChange = function(event) {
        var count = parseInt(event.target.value, 10);
        if (data.__typename === "EGDSTravelerStepInput") {
            var increaseAnalytics = data.increaseAnalytics, decreaseAnalytics = data.decreaseAnalytics;
            if (count > value && increaseAnalytics.referrerId && increaseAnalytics.linkName) {
                clickTracker(increaseAnalytics.referrerId, data.increaseAnalytics.linkName);
            } else if (decreaseAnalytics.referrerId && decreaseAnalytics.linkName) {
                clickTracker(decreaseAnalytics.referrerId, data.decreaseAnalytics.linkName);
            }
        }
        if (!Number.isNaN(count)) {
            if (hasRooms) {
                travelersContext.dispatch({
                    type: "UPDATE_TRAVELERS_COUNT",
                    travelersType: travelersType,
                    roomIndex: roomIndex,
                    count: count
                });
            } else {
                basicTravelersContext.dispatch({
                    type: "UPDATE_TRAVELERS_COUNT",
                    travelersType: travelersType,
                    count: count
                });
            }
        }
    };
    var travelerId = data.__typename === "EGDSTravelerStepInput" ? "".concat(data.egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "") : "";
    return /* @__PURE__ */ React57.createElement(UitkStepInput, _object_spread_props(_object_spread({}, stepInputTexts), {
        label: label,
        incrementId: "".concat(travelerId, "-increase"),
        decrementId: "".concat(travelerId, "-decrease"),
        min: min !== null && min !== void 0 ? min : 0,
        max: max !== null && max !== void 0 ? max : 0,
        onChange: onChange,
        value: value,
        description: subLabel !== null && subLabel !== void 0 ? subLabel : "",
        id: travelerId
    }));
};
EGDSTravelersStepInput.displayName = "EGDSTravelerStepInputFragment";
EGDSTravelersStepInput.fragment = _object_spread_props(_object_spread({}, __Fragment28), {
    __typename: "EGDSTravelerStepInput"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-children.tsx
var __Fragment29 = gql38(_templateObject42(), EGDSTravelersStepInput.fragment, EGDSTravelerChildAgeSelect.fragment);
var EGDSTravelersChildren = function(param) {
    var data = param.data, childAgeRef = param.childAgeRef, roomIndex = param.roomIndex, travelersType = param.travelersType;
    var _data_ages;
    var count = data.count, __typename = data.__typename;
    var isInfant = travelersType === "infants" /* INFANTS */  || travelersType === "infants_on_lap" /* INFANTS_ON_LAP */  || travelersType === "infants_in_seat" /* INFANTS_IN_SEAT */ ;
    var firstChildIndexWithNoAgeValue = ((data.__typename === "EGDSTravelerInfant" || data.__typename === "EGDSTravelerChildren") && data.ages ? data.ages : []).findIndex(function(age) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && age.value === null;
    });
    return /* @__PURE__ */ React58.createElement(React58.Fragment, null, count && count.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React58.createElement(EGDSTravelersStepInput, {
        travelersType: travelersType,
        roomIndex: roomIndex,
        data: count
    }), (__typename === "EGDSTravelerChildren" || __typename === "EGDSTravelerInfant") && /* @__PURE__ */ React58.createElement(UitkLayoutFlex6, {
        wrap: "wrap"
    }, (_data_ages = data.ages) === null || _data_ages === void 0 ? void 0 : _data_ages.map(function(age, childIndex) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && /* @__PURE__ */ React58.createElement(React58.Fragment, {
            key: childIndex
        }, /* @__PURE__ */ React58.createElement(UitkSpacing13, {
            padding: {
                blockstart: "two",
                inlineend: "two"
            }
        }, /* @__PURE__ */ React58.createElement(UitkLayoutFlexItem6, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(EGDSTravelerChildAgeSelect, {
            key: childIndex,
            childIndex: childIndex,
            roomIndex: roomIndex,
            isInfant: isInfant,
            infantType: isInfant ? travelersType : "",
            data: age,
            childAgeRef: firstChildIndexWithNoAgeValue === childIndex ? childAgeRef : void 0
        })))));
    })));
};
EGDSTravelersChildren.displayName = "EGDSTravelersChildren";
EGDSTravelersChildren.fragment = _object_spread_props(_object_spread({}, __Fragment29), {
    __typename: "EGDSTravelerChildren"
});
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-pets.tsx
import React59 from "react";
var TravelersPets = function(param) {
    var data = param.data;
    var _useBasicTravelersContext = useBasicTravelersContext(), state = _useBasicTravelersContext.state, dispatch = _useBasicTravelersContext.dispatch;
    var pets = state.travelers.pets;
    if ((pets === null || pets === void 0 ? void 0 : pets.__typename) !== "EGDSBasicCheckBox") {
        return null;
    }
    var checked = pets.state === "CHECKED" /* CHECKED */ ;
    var handleOnChange = function(event) {
        dispatch({
            type: "UPDATE_PETS_FILTER",
            checked: event.currentTarget.checked
        });
    };
    return /* @__PURE__ */ React59.createElement(EGDSBasicCheckBox, {
        data: data,
        checked: checked,
        onChange: handleOnChange
    });
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers.tsx
var __Fragment30 = gql39(_templateObject43(), EGDSBasicCheckBox.fragment, EGDSTravelersChildren.fragment, EGDSTravelersStepInput.fragment);
var EGDSTravelers = function(param) {
    var childAgeRef = param.childAgeRef, infantsOnLapRef = param.infantsOnLapRef, infantsInSeatRef = param.infantsInSeatRef, isTravelersExpanded = param.isTravelersExpanded, data = param.data;
    var adults = data.adults, children = data.children, pets = data.pets, infantsInSeat = data.infantsInSeat, infantsOnLap = data.infantsOnLap;
    var adultsLabelSpanRef = React60.useRef(null);
    React60.useEffect(function() {
        if (isTravelersExpanded) {
            var _adultsLabelSpanRef_current;
            (_adultsLabelSpanRef_current = adultsLabelSpanRef.current) === null || _adultsLabelSpanRef_current === void 0 ? void 0 : _adultsLabelSpanRef_current.focus();
        }
    }, [
        isTravelersExpanded
    ]);
    return /* @__PURE__ */ React60.createElement(React60.Fragment, null, adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React60.createElement(UitkSpacing14, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement("span", {
        className: "is-visually-hidden",
        tabIndex: -1,
        ref: adultsLabelSpanRef
    }, adults.label), /* @__PURE__ */ React60.createElement(EGDSTravelersStepInput, {
        travelersType: "adults" /* ADULTS */ ,
        data: adults
    }))), ((children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" || (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */ React60.createElement(UitkSpacing14, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(EGDSTravelersChildren, {
        travelersType: "children" /* CHILDREN */ ,
        childAgeRef: childAgeRef,
        data: children
    }))), ((infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSTravelerInfant" || (infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */ React60.createElement(UitkSpacing14, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(EGDSTravelersChildren, {
        travelersType: "infants_on_lap" /* INFANTS_ON_LAP */ ,
        childAgeRef: infantsOnLapRef,
        data: infantsOnLap
    }))), ((infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSTravelerInfant" || (infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */ React60.createElement(UitkSpacing14, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(EGDSTravelersChildren, {
        travelersType: "infants_in_seat" /* INFANTS_IN_SEAT */ ,
        childAgeRef: infantsInSeatRef,
        data: infantsInSeat
    }))), (pets === null || pets === void 0 ? void 0 : pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */ React60.createElement(UitkSpacing14, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(TravelersPets, {
        data: pets
    }))));
};
EGDSTravelers.displayName = "EGDSTravelersFragment";
EGDSTravelers.fragment = _object_spread_props(_object_spread({}, __Fragment30), {
    __typename: "EGDSTravelers"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-basic-traveler-selector.tsx
var __Fragment31 = gql40(_templateObject44(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSTravelers.fragment);
var EGDSBasicTravelerSelector = function(param) {
    var data = param.data, onSubmit = param.onSubmit, isTravelersExpanded = param.isTravelersExpanded;
    var doneButton = data.doneButton;
    var state = useBasicTravelersContext().state;
    var childAgeRef = React61.useRef(null);
    var infantsOnLap = React61.useRef(null);
    var infantsInSeat = React61.useRef(null);
    var travelers = state.travelers, error = state.error;
    var getChildrenRef = function() {
        if (childAgeRef.current) {
            return childAgeRef;
        }
        if (infantsOnLap.current) {
            return infantsOnLap;
        }
        return infantsInSeat;
    };
    var inputErrorRef = getChildrenRef();
    var handleSubmit = function() {
        if (onSubmit) {
            onSubmit("menu");
        }
    };
    return /* @__PURE__ */ React61.createElement(UitkLayoutFlex7, {
        direction: "column"
    }, (error === null || error === void 0 ? void 0 : error.displayConfirmation) && /* @__PURE__ */ React61.createElement(UitkSpacing15, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React61.createElement("div", null, /* @__PURE__ */ React61.createElement(EGDSErrorSummary, {
        data: error.errorSummary,
        inputErrorRef: inputErrorRef,
        errorCount: error.errorCount
    }))), /* @__PURE__ */ React61.createElement("section", null, /* @__PURE__ */ React61.createElement(EGDSTravelers, {
        data: travelers,
        childAgeRef: childAgeRef,
        infantsOnLapRef: infantsOnLap,
        infantsInSeatRef: infantsInSeat,
        isTravelersExpanded: isTravelersExpanded
    })), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React61.createElement(Viewport8, null, /* @__PURE__ */ React61.createElement(ViewMedium5, null, /* @__PURE__ */ React61.createElement(UitkSpacing15, {
        padding: {
            blockstart: "four",
            blockend: "three"
        }
    }, /* @__PURE__ */ React61.createElement(UitkLayoutFlex7, {
        justifyContent: "end"
    }, /* @__PURE__ */ React61.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React61.createElement(EGDSPrimaryButton, {
        isFullWidth: false,
        onClick: handleSubmit,
        data: doneButton,
        size: UitkButtonSize4.MEDIUM
    })))))));
};
EGDSBasicTravelerSelector.displayName = "EGDSBasicTravelerSelectorFragment";
EGDSBasicTravelerSelector.fragment = _object_spread_props(_object_spread({}, __Fragment31), {
    __typename: "EGDSBasicTravelerSelector"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-rooms-traveler-selector.tsx
import React65 from "react";
import { gql as gql44 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize5 } from "@egds/react-core/button";
import { ViewMedium as ViewMedium6, Viewport as Viewport9 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-traveler-infant-seat-select.tsx
import React63 from "react";
import { gql as gql42 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkRadioButton, UitkRadioButtonGroup } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkText as UitkText7 } from "uitk-react-text";
// ../internal/src/components/common/link/egds-standard-link.tsx
import React62 from "react";
import { gql as gql41 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon7 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText6 } from "uitk-react-text";
var fragment4 = gql41(_templateObject45());
var _obj2;
var UILinkTargetMap = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank" /* EXTERNAL */ ), _define_property(_obj2, "INTERNAL" /* INTERNAL */ , "_self" /* INTERNAL */ ), _obj2);
var EGDSStandardLink = function(param) {
    var _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, text = _param_data.text, icon = _param_data.icon, iconPosition = _param_data.iconPosition;
    var clickTracker = useClickTracker18();
    var onClick = React62.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React62.createElement(UitkLink, {
        onClickCapture: onClick,
        inline: true
    }, /* @__PURE__ */ React62.createElement("a", {
        target: UILinkTargetMap[target],
        href: resource.value
    }, icon && iconPosition !== "TRAILING" /* TRAILING */  && /* @__PURE__ */ React62.createElement(UitkIcon7, {
        name: icon.id
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React62.createElement(UitkIcon7, {
        name: icon.id
    }), accessibility && /* @__PURE__ */ React62.createElement(UitkText6, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment4;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-traveler-infant-seat-select.tsx
var __Fragment32 = gql42(_templateObject46(), EGDSStandardLink.fragment);
var EGDSTravelerInfantSeatSelect = function(param) {
    var data = param.data;
    var _state_infantSeatSelection;
    var _useTravelersContext = useTravelersContext(), state = _useTravelersContext.state, dispatch = _useTravelersContext.dispatch;
    var numberOfInfants = state.rooms.reduce(function(infants, room) {
        var _room_infants_count, _room_infants;
        var _room_infants_count_value;
        return infants + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : (_room_infants_count = _room_infants.count) === null || _room_infants_count === void 0 ? void 0 : _room_infants_count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
    }, 0);
    var infantSeatSelection = (_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value;
    if (data.labelTemplate.__typename !== "EGDSCardinalLocalizedText" || numberOfInfants === 0 || !infantSeatSelection) {
        return null;
    }
    var labelTemplate = data.labelTemplate, options = data.options, airlineAgeRule = data.airlineAgeRule, groupName = data.groupName;
    var infantsSeatingText = numberOfInfants === 1 ? labelTemplate.text : labelTemplate.templates[1].template;
    var handleOnChange = function(event) {
        dispatch({
            type: "UPDATE_INFANT_SEAT_SELECTION",
            value: event.currentTarget.value
        });
    };
    return /* @__PURE__ */ React63.createElement(UitkLayoutFlex8, {
        direction: "column"
    }, /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React63.createElement(UitkText7, null, infantsSeatingText)), /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React63.createElement(UitkRadioButtonGroup, {
        group: groupName,
        selected: infantSeatSelection,
        onChange: handleOnChange,
        defaultChecked: true
    }, options.map(function(option, index) {
        return /* @__PURE__ */ React63.createElement(UitkSpacing16, {
            key: "radioInfant".concat(index + 1),
            margin: index === 0 ? {
                blockstart: "three"
            } : void 0
        }, /* @__PURE__ */ React63.createElement("div", null, /* @__PURE__ */ React63.createElement(UitkRadioButton, {
            id: option.value,
            value: option.value
        }, option.label)));
    }))), /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React63.createElement(UitkSpacing16, {
        padding: {
            blockstart: "two",
            blockend: "six"
        }
    }, /* @__PURE__ */ React63.createElement("div", null, /* @__PURE__ */ React63.createElement(EGDSStandardLink, {
        data: airlineAgeRule
    })))));
};
EGDSTravelerInfantSeatSelect.displayName = "EGDSTravelerInfantSeatSelect";
EGDSTravelerInfantSeatSelect.fragment = _object_spread_props(_object_spread({}, __Fragment32), {
    __typename: "EGDSTravelerInfantSeatSelection"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-selector-room.tsx
import React64 from "react";
import { gql as gql43 } from "@apollo/client";
import { Level as Level3, liveAnnounce as liveAnnounce7 } from "@egds/react-core/utils";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var __Fragment33 = gql43(_templateObject47(), EGDSTravelersStepInput.fragment, EGDSTravelersChildren.fragment, EGDSTertiaryButton.fragment);
var EGDSTravelerSelectorRoom = function(param) {
    var roomIndex = param.roomIndex, childAgeRef = param.childAgeRef, data = param.data, isTravelersExpanded = param.isTravelersExpanded, focusAddRoomButton = param.focusAddRoomButton;
    var _children_ages;
    var adults = data.adults, children = data.children, infants = data.infants, label = data.label, removeRoomButton = data.removeRoomButton, removeRoomAnnouncement = data.removeRoomAnnouncement;
    var _useTravelersContext = useTravelersContext(), state = _useTravelersContext.state, dispatch = _useTravelersContext.dispatch;
    var roomLabelRef = React64.useRef();
    var roomsLenght = React64.useRef(state.rooms.length);
    React64.useEffect(function() {
        if (isTravelersExpanded && roomIndex === 0) {
            var _roomLabelRef_current;
            (_roomLabelRef_current = roomLabelRef.current) === null || _roomLabelRef_current === void 0 ? void 0 : _roomLabelRef_current.focus();
        }
    }, [
        isTravelersExpanded
    ]);
    React64.useEffect(function() {
        if (isTravelersExpanded && state.rooms.length >= roomsLenght.current && roomIndex === state.rooms.length - 1) {
            var _roomLabelRef_current;
            (_roomLabelRef_current = roomLabelRef.current) === null || _roomLabelRef_current === void 0 ? void 0 : _roomLabelRef_current.focus();
        }
        roomsLenght.current = state.rooms.length;
    }, [
        state.rooms.length
    ]);
    var onRemoveRoom = function() {
        if (removeRoomAnnouncement) {
            liveAnnounce7(removeRoomAnnouncement, Level3.ASSERTIVE);
        }
        if (focusAddRoomButton) {
            focusAddRoomButton();
        }
        dispatch({
            type: "REMOVE_ROOM",
            roomIndex: roomIndex
        });
    };
    var hasChildWithNoAge = children.__typename === "EGDSTravelerChildren" && ((_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.some(function(child) {
        return child.__typename === "EGDSTravelerChildAgeSelect" && child.value === null;
    }));
    var roomNumber = roomIndex + 1;
    return /* @__PURE__ */ React64.createElement(React64.Fragment, null, label.__typename === "EGDSBasicLocalizedText" && label.models.length === 1 && /* @__PURE__ */ React64.createElement(UitkHeading2, {
        size: 7,
        domRef: roomLabelRef,
        tabIndex: -1
    }, formatLocalizedTokenString(label.template, label.models[0].key, roomNumber.toString())), adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React64.createElement(UitkSpacing17, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React64.createElement("div", null, /* @__PURE__ */ React64.createElement(EGDSTravelersStepInput, {
        travelersType: "adults" /* ADULTS */ ,
        roomIndex: roomIndex,
        data: adults
    }))), children.__typename === "EGDSTravelerChildren" && /* @__PURE__ */ React64.createElement(UitkSpacing17, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React64.createElement("div", null, /* @__PURE__ */ React64.createElement(EGDSTravelersChildren, {
        travelersType: "children" /* CHILDREN */ ,
        roomIndex: roomIndex,
        childAgeRef: childAgeRef,
        data: children
    }))), (infants === null || infants === void 0 ? void 0 : infants.__typename) === "EGDSTravelerInfant" && /* @__PURE__ */ React64.createElement(UitkSpacing17, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React64.createElement("div", null, /* @__PURE__ */ React64.createElement(EGDSTravelersChildren, {
        travelersType: "infants" /* INFANTS */ ,
        roomIndex: roomIndex,
        childAgeRef: hasChildWithNoAge ? void 0 : childAgeRef,
        data: infants
    }))), state.rooms.length > 1 && removeRoomButton && removeRoomButton.__typename === "UITertiaryButton" && /* @__PURE__ */ React64.createElement(UitkSpacing17, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React64.createElement(UitkLayoutFlex9, {
        justifyContent: "end"
    }, /* @__PURE__ */ React64.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React64.createElement(EGDSTertiaryButton, {
        onClick: onRemoveRoom,
        data: removeRoomButton
    })))));
};
EGDSTravelerSelectorRoom.displayName = "EGDSTravelerSelectorRoomFragment";
EGDSTravelerSelectorRoom.fragment = _object_spread_props(_object_spread({}, __Fragment33), {
    __typename: "EGDSTravelerSelectorRoom"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-rooms-traveler-selector.tsx
var __Fragment34 = gql44(_templateObject48(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSTravelerSelectorRoom.fragment, EGDSTravelerInfantSeatSelect.fragment);
var EGDSRoomsTravelerSelector = function(param) {
    var data = param.data, onSubmit = param.onSubmit, isTravelersExpanded = param.isTravelersExpanded;
    var addAnotherRoomButton = data.addAnotherRoomButton, doneButton = data.doneButton, maxRoomCount = data.maxRoomCount, infantSeatSelection = data.infantSeatSelection;
    var _useTravelersContext = useTravelersContext(), state = _useTravelersContext.state, dispatch = _useTravelersContext.dispatch;
    var childAgeRef = React65.useRef(null);
    var addRoomRef = React65.useRef(null);
    var rooms = state.rooms, error = state.error;
    var _React65_useState = _sliced_to_array(React65.useState(rooms), 2), setRoom = _React65_useState[1];
    React65.useEffect(function() {
        setRoom(rooms);
    }, [
        rooms
    ]);
    if (rooms.length < 1) {
        return null;
    }
    var onAddRoom = function() {
        dispatch({
            type: "ADD_ROOM"
        });
    };
    var handleSubmit = function() {
        if (onSubmit) {
            onSubmit("menu");
        }
    };
    var focusAddRoomButton = function() {
        var _addRoomRef_current;
        (_addRoomRef_current = addRoomRef.current) === null || _addRoomRef_current === void 0 ? void 0 : _addRoomRef_current.focus();
    };
    var addNewRoomButton = _object_spread_props(_object_spread({}, addAnotherRoomButton), {
        disabled: maxRoomCount ? rooms.length >= maxRoomCount : false
    });
    var firstRoomIndexWithNoChildAgeValue = rooms.findIndex(function(room) {
        var _room_children, _room_children1, _room_infants, _room_infants1;
        var _ref;
        return room.children.__typename === "EGDSTravelerChildren" && ((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.ages) && ((_room_children1 = room.children) === null || _room_children1 === void 0 ? void 0 : _room_children1.ages.some(function(child) {
            return child.__typename === "EGDSTravelerChildAgeSelect" && child.value === null;
        })) || ((_ref = ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" && ((_room_infants1 = room.infants) === null || _room_infants1 === void 0 ? void 0 : _room_infants1.ages.some(function(infant) {
            return infant.__typename === "EGDSTravelerChildAgeSelect" && infant.value === null;
        }))) !== null && _ref !== void 0 ? _ref : false);
    });
    var actionButton = doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React65.createElement(UitkSpacing18, {
        padding: {
            blockstart: "four",
            blockend: "three"
        }
    }, /* @__PURE__ */ React65.createElement(UitkLayoutFlex10, {
        justifyContent: "end"
    }, /* @__PURE__ */ React65.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React65.createElement(EGDSPrimaryButton, {
        isFullWidth: false,
        onClick: handleSubmit,
        data: doneButton,
        size: UitkButtonSize5.MEDIUM
    }))));
    return /* @__PURE__ */ React65.createElement(UitkLayoutFlex10, {
        direction: "column"
    }, (error === null || error === void 0 ? void 0 : error.displayConfirmation) && /* @__PURE__ */ React65.createElement(EGDSErrorSummary, {
        data: error.errorSummary,
        inputErrorRef: childAgeRef,
        errorCount: error.errorCount
    }), /* @__PURE__ */ React65.createElement("section", null, rooms.map(function(room, roomIndex) {
        return /* @__PURE__ */ React65.createElement(UitkSpacing18, {
            padding: {
                blockstart: (error === null || error === void 0 ? void 0 : error.displayConfirmation) ? "two" : "unset"
            },
            key: roomIndex
        }, /* @__PURE__ */ React65.createElement("div", null, /* @__PURE__ */ React65.createElement(EGDSTravelerSelectorRoom, {
            roomIndex: roomIndex,
            data: room,
            childAgeRef: firstRoomIndexWithNoChildAgeValue === roomIndex ? childAgeRef : void 0,
            isTravelersExpanded: isTravelersExpanded,
            focusAddRoomButton: focusAddRoomButton
        })));
    }), addNewRoomButton.__typename === "UITertiaryButton" && /* @__PURE__ */ React65.createElement(UitkSpacing18, {
        padding: {
            small: {
                blockstart: "two",
                blockend: "sixteen"
            },
            medium: {
                blockend: "unset"
            }
        }
    }, /* @__PURE__ */ React65.createElement(UitkLayoutFlex10, {
        justifyContent: "end"
    }, /* @__PURE__ */ React65.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React65.createElement(EGDSTertiaryButton, {
        onClick: onAddRoom,
        data: addNewRoomButton,
        domRef: addRoomRef
    })))), infantSeatSelection && /* @__PURE__ */ React65.createElement(UitkSpacing18, {
        padding: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React65.createElement("div", null, /* @__PURE__ */ React65.createElement(EGDSTravelerInfantSeatSelect, {
        data: infantSeatSelection
    })))), /* @__PURE__ */ React65.createElement(Viewport9, null, /* @__PURE__ */ React65.createElement(ViewMedium6, null, /* @__PURE__ */ React65.createElement("div", null, actionButton))));
};
EGDSRoomsTravelerSelector.displayName = "EGDSTravelerSelectorFragment";
EGDSRoomsTravelerSelector.fragment = _object_spread_props(_object_spread({}, __Fragment34), {
    __typename: "EGDSRoomsTravelerSelector"
});
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-field-triggers.tsx
import React66 from "react";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "@egds/react-core/menu";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext4 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewLarge as ViewLarge5, ViewMedium as ViewMedium7, Viewport as Viewport10, ViewSizes, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
import { UitkForm, useFormCallback as useFormCallback6 } from "uitk-react-form";
import { UitkFakeInput as UitkFakeInput2 } from "uitk-react-input";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2, UitkSheetTransition as UitkSheetTransition2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
// ../internal/src/helper/object-comparator.ts
var isEqual = function(obj1, obj2) {
    var getType = function getType(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
    var areArraysEqual = function areArraysEqual() {
        if (obj1.length !== obj2.length) {
            return false;
        }
        for(var i = 0; i < obj1.length; i += 1){
            if (!isEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
        return true;
    };
    var areObjectsEqual = function areObjectsEqual() {
        var obj1Keys = Object.keys(obj1);
        if (obj1Keys.length !== Object.keys(obj2).length) {
            return false;
        }
        for(var i = 0; i < obj1Keys.length; i += 1){
            var key = obj1Keys[i];
            if (Object.prototype.hasOwnProperty.call(obj1, key)) {
                if (!isEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }
        }
        return true;
    };
    var areFunctionsEqual = function areFunctionsEqual() {
        return obj1.toString() === obj2.toString();
    };
    var arePrimativesEqual = function arePrimativesEqual() {
        return obj1 === obj2;
    };
    var type = getType(obj1);
    if (type !== getType(obj2)) {
        return false;
    }
    if (type === "array") {
        return areArraysEqual();
    }
    if (type === "object") {
        return areObjectsEqual();
    }
    if (type === "function") {
        return areFunctionsEqual();
    }
    return arePrimativesEqual();
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-summary.ts
var formatCardinalText2 = function(cardinalText, value) {
    var useSecondaryTemplates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var templateKey = useSecondaryTemplates ? "secondaryTemplates" : "templates";
    var cardinalTemplate = cardinalText[templateKey].find(function(template) {
        return template.category === getPluralCategory(value);
    });
    if (!cardinalTemplate) {
        return "";
    }
    return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
var formatCompositeText = function(compositeText) {
    for(var _len = arguments.length, keysToReplace = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keysToReplace[_key - 1] = arguments[_key];
    }
    var models = compositeText.models, template = compositeText.template;
    var formattedTexts = models.map(function(model, index) {
        return model.models.__typename === "EGDSCardinalLocalizedText" ? formatCardinalText2(model.models, keysToReplace[index]) : "";
    });
    return models.reduce(function(prev, model, index) {
        return formatLocalizedTokenString(prev, model.key, formattedTexts[index]);
    }, template);
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-field-triggers.tsx
var BASE_TRAVELERS_FIELD_PREFIX = "EGDSSearchFormTravelersField-";
var ADULT_COUNT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Adult");
var CHILDREN_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "ChildrenAge");
var INFANT_IN_SEAT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "InfantInSeatAge");
var INFANT_ON_LAP_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "InfantOnLapAge");
var PETS_STATE_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Pets");
var ChildrenHiddenInputs = function(param) {
    var ages = param.ages, prefix = param.prefix;
    return /* @__PURE__ */ React66.createElement(React66.Fragment, null, ages.map(function(age, index) {
        if (age.__typename === "EGDSTravelerChildAgeSelect") {
            var childNumber = index + 1;
            var name = "".concat(prefix, "-").concat(childNumber);
            var _age_value;
            return /* @__PURE__ */ React66.createElement("input", {
                key: index,
                type: "hidden",
                "data-stid": name,
                name: name,
                value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
            });
        }
        return null;
    }));
};
var BasicTravelersFieldTriggers = function(param) {
    var label = param.label, leftIcon = param.leftIcon, action = param.action, labelTemplate = param.labelTemplate, readOnly = param.readOnly, isAnyPetAllowed = param.isAnyPetAllowed, onOpenTravelerField = param.onOpenTravelerField, onCloseTravelerField = param.onCloseTravelerField;
    var analytics = action.analytics, travelerSelector2 = action.travelerSelector;
    var doneButton = travelerSelector2.doneButton;
    var track = useClickTracker19();
    var _useBasicTravelersContext = useBasicTravelersContext(), dispatch = _useBasicTravelersContext.dispatch, state = _useBasicTravelersContext.state;
    var _useSearchFormReflectionContext4 = useSearchFormReflectionContext4(), reflectionState = _useSearchFormReflectionContext4.state;
    var _useDialog2 = _sliced_to_array(useDialog2("travelerSelectorDialog"), 3), isOpen = _useDialog2[0], dialogActions = _useDialog2[1], TravelerSelectorDialogWrapper = _useDialog2[2];
    var triggerRef = React66.useRef(null);
    var _React66_useState = _sliced_to_array(React66.useState(false), 2), showMenu = _React66_useState[0], setShowMenu = _React66_useState[1];
    var _React66_useState1 = _sliced_to_array(React66.useState(state), 2), initialState = _React66_useState1[0], setInitialState = _React66_useState1[1];
    var _labelTemplate_text;
    var _React66_useState2 = _sliced_to_array(React66.useState((_labelTemplate_text = labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.text) !== null && _labelTemplate_text !== void 0 ? _labelTemplate_text : ""), 2), travelersSummary = _React66_useState2[0], setTravelersSummary = _React66_useState2[1];
    var error = state.error;
    var handleChange = useFormCallback6(travelerSelector2.__typename, function(event) {
        return event;
    });
    var formatTravelerSummary = function(travelers) {
        var _travelers_adults, _travelers_children_count, _travelers_children, _travelers_infantsInSeat_count, _travelers_infantsInSeat, _travelers_infantsOnLap_count, _travelers_infantsOnLap, _travelers_pets;
        var _travelers_adults_value;
        var adultCount = (_travelers_adults_value = (_travelers_adults = travelers.adults) === null || _travelers_adults === void 0 ? void 0 : _travelers_adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
        var _travelers_children_count_value;
        var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : (_travelers_children_count = _travelers_children.count) === null || _travelers_children_count === void 0 ? void 0 : _travelers_children_count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
        var _travelers_infantsInSeat_count_value;
        var infantsInSeatCount = (_travelers_infantsInSeat_count_value = (_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : (_travelers_infantsInSeat_count = _travelers_infantsInSeat.count) === null || _travelers_infantsInSeat_count === void 0 ? void 0 : _travelers_infantsInSeat_count.value) !== null && _travelers_infantsInSeat_count_value !== void 0 ? _travelers_infantsInSeat_count_value : 0;
        var _travelers_infantsOnLap_count_value;
        var infantsOnLapCount = (_travelers_infantsOnLap_count_value = (_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : (_travelers_infantsOnLap_count = _travelers_infantsOnLap.count) === null || _travelers_infantsOnLap_count === void 0 ? void 0 : _travelers_infantsOnLap_count.value) !== null && _travelers_infantsOnLap_count_value !== void 0 ? _travelers_infantsOnLap_count_value : 0;
        var travelersCount = adultCount + childrenCount + infantsInSeatCount + infantsOnLapCount;
        var isPetsChecked = (travelers === null || travelers === void 0 ? void 0 : (_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox" && travelers.pets.state === "CHECKED" /* CHECKED */ ;
        return formatCardinalText2(labelTemplate, travelersCount, isPetsChecked);
    };
    React66.useEffect(function() {
        var _initialState_travelers_pets;
        if (isAnyPetAllowed !== void 0) {
            dispatch({
                type: "UPDATE_PETS_FILTER",
                checked: isAnyPetAllowed
            });
        }
        if (((_initialState_travelers_pets = initialState.travelers.pets) === null || _initialState_travelers_pets === void 0 ? void 0 : _initialState_travelers_pets.__typename) === "EGDSBasicCheckBox") {
            var dataTravelersPetsState = isAnyPetAllowed ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
            var newState = _object_spread_props(_object_spread({}, initialState), {
                travelers: _object_spread_props(_object_spread({}, initialState.travelers), {
                    pets: _object_spread_props(_object_spread({}, initialState.travelers.pets), {
                        state: dataTravelersPetsState
                    })
                })
            });
            setInitialState(newState);
        }
    }, [
        isAnyPetAllowed
    ]);
    React66.useEffect(function() {
        setTravelersSummary(formatTravelerSummary(state.travelers));
    }, [
        state.travelers
    ]);
    React66.useEffect(function() {
        var _reflectionState_travelers_adultTravelerCounts, _reflectionState_travelers;
        if ((_reflectionState_travelers = reflectionState.travelers) === null || _reflectionState_travelers === void 0 ? void 0 : (_reflectionState_travelers_adultTravelerCounts = _reflectionState_travelers.adultTravelerCounts) === null || _reflectionState_travelers_adultTravelerCounts === void 0 ? void 0 : _reflectionState_travelers_adultTravelerCounts.length) {
            var _reflectionState_travelers_adultTravelerCounts1, _reflectionState_travelers1, _reflectionState_travelers2, _reflectionState_travelers_childTravelerCounts, _reflectionState_travelers3, _reflectionState_travelers4, _reflectionState_travelers_childrenAges, _reflectionState_travelers5, _reflectionState_travelers6, _reflectionState_travelers7, _reflectionState_travelers_petCounts, _reflectionState_travelers8, _reflectionState_travelers9;
            dispatch({
                type: "UPDATE_TRAVELERS_BULK",
                adultTravelerCounts: ((_reflectionState_travelers1 = reflectionState.travelers) === null || _reflectionState_travelers1 === void 0 ? void 0 : (_reflectionState_travelers_adultTravelerCounts1 = _reflectionState_travelers1.adultTravelerCounts) === null || _reflectionState_travelers_adultTravelerCounts1 === void 0 ? void 0 : _reflectionState_travelers_adultTravelerCounts1.length) ? (_reflectionState_travelers2 = reflectionState.travelers) === null || _reflectionState_travelers2 === void 0 ? void 0 : _reflectionState_travelers2.adultTravelerCounts[0] : 0,
                childTravelerCounts: ((_reflectionState_travelers3 = reflectionState.travelers) === null || _reflectionState_travelers3 === void 0 ? void 0 : (_reflectionState_travelers_childTravelerCounts = _reflectionState_travelers3.childTravelerCounts) === null || _reflectionState_travelers_childTravelerCounts === void 0 ? void 0 : _reflectionState_travelers_childTravelerCounts.length) ? (_reflectionState_travelers4 = reflectionState.travelers) === null || _reflectionState_travelers4 === void 0 ? void 0 : _reflectionState_travelers4.childTravelerCounts[0] : 0,
                childrenAges: ((_reflectionState_travelers5 = reflectionState.travelers) === null || _reflectionState_travelers5 === void 0 ? void 0 : (_reflectionState_travelers_childrenAges = _reflectionState_travelers5.childrenAges) === null || _reflectionState_travelers_childrenAges === void 0 ? void 0 : _reflectionState_travelers_childrenAges.length) && ((_reflectionState_travelers6 = reflectionState.travelers) === null || _reflectionState_travelers6 === void 0 ? void 0 : _reflectionState_travelers6.childrenAges[0].length) ? (_reflectionState_travelers7 = reflectionState.travelers) === null || _reflectionState_travelers7 === void 0 ? void 0 : _reflectionState_travelers7.childrenAges[0] : [],
                petCounts: ((_reflectionState_travelers8 = reflectionState.travelers) === null || _reflectionState_travelers8 === void 0 ? void 0 : (_reflectionState_travelers_petCounts = _reflectionState_travelers8.petCounts) === null || _reflectionState_travelers_petCounts === void 0 ? void 0 : _reflectionState_travelers_petCounts.length) ? (_reflectionState_travelers9 = reflectionState.travelers) === null || _reflectionState_travelers9 === void 0 ? void 0 : _reflectionState_travelers9.petCounts[0] : 0
            });
        }
    }, [
        reflectionState.travelers
    ]);
    if (travelerSelector2.__typename !== "EGDSBasicTravelerSelector") {
        return null;
    }
    var onTriggerClick = function() {
        if (onOpenTravelerField) {
            onOpenTravelerField();
        }
        setShowMenu(function(prevState) {
            return !prevState;
        });
        if (analytics.referrerId && analytics.linkName) {
            track(analytics.referrerId, analytics.linkName);
        }
    };
    var onDismissMenu = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.error) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch({
                                type: "SHOW_ERROR"
                            })
                        ];
                    case 1:
                        _state.sent();
                        setShowMenu(true);
                        _state.label = 2;
                    case 2:
                        if (!state.error && !isEqual(initialState, state)) {
                            setInitialState(state);
                            triggerInputChangeEvent("submit", handleChange);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onDismissMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        if (onOpenTravelerField) {
            onOpenTravelerField();
        }
        dialogActions.openDialog();
        if (analytics.referrerId && analytics.linkName) {
            track(analytics.referrerId, analytics.linkName);
        }
    };
    var onDismissDialog = function() {
        if (onCloseTravelerField) {
            onCloseTravelerField(ViewSizes.SMALL);
        }
        if ((travelerSelector2.closeButton.__typename === "UIPrimaryButton" || travelerSelector2.closeButton.__typename === "UITertiaryButton") && travelerSelector2.closeButton.analytics) {
            var _travelerSelector2_closeButton_analytics = travelerSelector2.closeButton.analytics, referrerId = _travelerSelector2_closeButton_analytics.referrerId, linkName = _travelerSelector2_closeButton_analytics.linkName;
            track(referrerId, !error ? "Travelers results updated" : linkName);
        }
        if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ) {
            var _error_errorSummary;
            dispatch({
                type: "SHOW_ERROR"
            });
            if ((_error_errorSummary = error.errorSummary) === null || _error_errorSummary === void 0 ? void 0 : _error_errorSummary.impressionAnalytics) {
                var referrerId1 = "".concat(error.errorSummary.impressionAnalytics.referrerId, ".For.NoChildAgeSubmit");
                var linkName1 = error.errorSummary.impressionAnalytics.linkName || "";
                track(referrerId1, linkName1);
            }
        }
        if (!error) {
            onSaveDialog(state);
        }
    };
    var updateTravelerSummary = function(travelers) {
        var travelersValue = formatTravelerSummary(travelers);
        triggerInputChangeEvent(travelersValue, handleChange);
        setTravelersSummary(travelersValue);
    };
    var onSaveMenu = function(newState) {
        var _triggerRef_current;
        if (!isEqual(initialState, newState)) {
            updateTravelerSummary(newState.travelers);
            setInitialState(newState);
        }
        setShowMenu(function(prevState) {
            return !prevState;
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    var onSaveDialog = function(newState) {
        var _triggerRef_current;
        if (!isEqual(initialState, newState)) {
            updateTravelerSummary(newState.travelers);
            setInitialState(newState);
        }
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        dialogActions.closeDialog();
    };
    var handleSubmit = function(triggerType) {
        if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ) {
            var _error_errorSummary;
            dispatch({
                type: "SHOW_ERROR"
            });
            if ((_error_errorSummary = error.errorSummary) === null || _error_errorSummary === void 0 ? void 0 : _error_errorSummary.impressionAnalytics) {
                var referrerId = "".concat(error.errorSummary.impressionAnalytics.referrerId, ".For.NoChildAgeSubmit");
                var linkName = error.errorSummary.impressionAnalytics.linkName || "";
                track(referrerId, linkName);
            }
        }
        if (!error) {
            if (triggerType === "menu") {
                onSaveMenu(state);
            } else {
                onSaveDialog(state);
            }
        }
    };
    var _state_travelers = state.travelers, adults = _state_travelers.adults, children = _state_travelers.children, pets = _state_travelers.pets, infantsInSeat = _state_travelers.infantsInSeat, infantsOnLap = _state_travelers.infantsOnLap;
    var isPetsCheckbox = (pets === null || pets === void 0 ? void 0 : pets.__typename) === "EGDSBasicCheckBox";
    var _travelerSelector2_closeButton_accessibility;
    return /* @__PURE__ */ React66.createElement(React66.Fragment, null, /* @__PURE__ */ React66.createElement(Viewport10, null, /* @__PURE__ */ React66.createElement(ViewLarge5, null, /* @__PURE__ */ React66.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React66.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React66.createElement(UitkFakeInput2, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef,
        className: "open-traveler-picker-observer-root"
    })), /* @__PURE__ */ React66.createElement(UitkMenuContainer, {
        autoPosition: true,
        maxHeight: 4e3,
        position: PositionType.RIGHT,
        width: 375,
        intersectionObserverRoot: ".open-traveler-picker-observer-root"
    }, /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React66.createElement("div", {
        "data-stid": "basic-traveler-selector-menu-container"
    }, /* @__PURE__ */ React66.createElement(EGDSBasicTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        isTravelersExpanded: showMenu
    })))))), /* @__PURE__ */ React66.createElement(ViewMedium7, null, /* @__PURE__ */ React66.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React66.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React66.createElement(UitkFakeInput2, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef,
        className: "open-traveler-picker-observer-root"
    })), /* @__PURE__ */ React66.createElement(UitkMenuContainer, {
        autoPosition: true,
        maxHeight: 4e3,
        position: PositionType.LEFT,
        width: isPetsCheckbox ? 275 : 375,
        intersectionObserverRoot: ".open-traveler-picker-observer-root"
    }, /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React66.createElement("div", {
        "data-stid": "basic-traveler-selector-menu-container"
    }, /* @__PURE__ */ React66.createElement(EGDSBasicTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        isTravelersExpanded: showMenu
    })))))), /* @__PURE__ */ React66.createElement(ViewSmall8, null, /* @__PURE__ */ React66.createElement(React66.Fragment, null, /* @__PURE__ */ React66.createElement(UitkFakeInput2, {
        label: label,
        value: travelersSummary,
        onClick: onClick,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef
    }), /* @__PURE__ */ React66.createElement(UitkSheetTransition2, {
        isVisible: isOpen
    }, /* @__PURE__ */ React66.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */ React66.createElement(UitkSheet2, {
        type: "full",
        triggerRef: triggerRef,
        isVisible: isOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React66.createElement(UitkToolbar3, {
        toolbarTitle: travelerSelector2.title,
        navigationContent: {
            navType: "close",
            navIconLabel: travelerSelector2.closeButton.__typename === "UIPrimaryButton" || travelerSelector2.closeButton.__typename === "UITertiaryButton" ? (_travelerSelector2_closeButton_accessibility = travelerSelector2.closeButton.accessibility) !== null && _travelerSelector2_closeButton_accessibility !== void 0 ? _travelerSelector2_closeButton_accessibility : "" : "",
            onClick: onDismissDialog
        }
    }), /* @__PURE__ */ React66.createElement(UitkSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        padding: {
            blockstart: "four",
            blockend: "sixteen",
            inline: "six"
        }
    }, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(UitkForm, {
        hasRequiredFieldIndicator: true
    }, /* @__PURE__ */ React66.createElement(EGDSBasicTravelerSelector, {
        data: travelerSelector2,
        isTravelersExpanded: isOpen
    }))))), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React66.createElement(EGDSPrimaryButton, {
        floating: true,
        onClick: handleSubmit,
        data: doneButton
    }))))))), /* @__PURE__ */ React66.createElement(React66.Fragment, null, /* @__PURE__ */ React66.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX),
        name: "".concat(ADULT_COUNT_NAME_PREFIX),
        value: adults.value
    }), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" && children.ages && /* @__PURE__ */ React66.createElement(ChildrenHiddenInputs, {
        ages: children.ages,
        prefix: CHILDREN_NAME_PREFIX
    }), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */ React66.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(CHILDREN_NAME_PREFIX),
        name: "".concat(CHILDREN_NAME_PREFIX),
        value: children.count.value
    }), (infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSTravelerInfant" && infantsInSeat.ages && /* @__PURE__ */ React66.createElement(ChildrenHiddenInputs, {
        ages: infantsInSeat.ages,
        prefix: INFANT_IN_SEAT_NAME_PREFIX
    }), (infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */ React66.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(INFANT_IN_SEAT_NAME_PREFIX),
        name: "".concat(INFANT_IN_SEAT_NAME_PREFIX),
        value: infantsInSeat.count.value
    }), (infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSTravelerInfant" && infantsOnLap.ages && /* @__PURE__ */ React66.createElement(ChildrenHiddenInputs, {
        ages: infantsOnLap.ages,
        prefix: INFANT_ON_LAP_NAME_PREFIX
    }), (infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */ React66.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(INFANT_ON_LAP_NAME_PREFIX),
        name: "".concat(INFANT_ON_LAP_NAME_PREFIX),
        value: infantsOnLap.count.value
    }), isPetsCheckbox && /* @__PURE__ */ React66.createElement("input", {
        type: "hidden",
        name: "".concat(PETS_STATE_NAME_PREFIX),
        value: pets.state
    })));
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-field-triggers.tsx
import React67 from "react";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "@egds/react-core/menu";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext5 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewLarge as ViewLarge6, ViewMedium as ViewMedium8, Viewport as Viewport11, ViewSizes as ViewSizes2, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm2, useFormCallback as useFormCallback7 } from "uitk-react-form";
import { UitkFakeInput as UitkFakeInput3 } from "uitk-react-input";
import { UitkSheet as UitkSheet3, UitkSheetContent as UitkSheetContent3, UitkSheetTransition as UitkSheetTransition3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar4 } from "uitk-react-toolbar";
var BASE_TRAVELERS_FIELD_PREFIX2 = "EGDSSearchFormTravelersField";
var ADULT_COUNT_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-Adult");
var CHILDREN_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-ChildrenAge");
var INFANT_IN_SEAT_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-InfantInSeatAge");
var INFANT_ON_LAP_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-InfantOnLapAge");
var TravelersFieldTriggers = function(param) {
    var label = param.label, leftIcon = param.leftIcon, action = param.action, labelTemplate = param.labelTemplate, readOnly = param.readOnly, onOpenTravelerField = param.onOpenTravelerField;
    var accessibility = action.accessibility, analytics = action.analytics, travelerSelector2 = action.travelerSelector;
    var doneButton = travelerSelector2.doneButton;
    var allyLabelDescritption = accessibility !== null && accessibility !== void 0 ? accessibility : "";
    var track = useClickTracker20();
    var _useTravelersContext = useTravelersContext(), dispatch = _useTravelersContext.dispatch, state = _useTravelersContext.state;
    var _useSearchFormReflectionContext5 = useSearchFormReflectionContext5(), reflectionState = _useSearchFormReflectionContext5.state;
    var error = state.error;
    var _useDialog3 = _sliced_to_array(useDialog3("travelerSelectorDialog"), 3), isOpen = _useDialog3[0], dialogActions = _useDialog3[1], TravelerSelectorDialogWrapper = _useDialog3[2];
    var triggerRef = React67.useRef(null);
    var _React67_useState = _sliced_to_array(React67.useState(false), 2), showMenu = _React67_useState[0], setShowMenu = _React67_useState[1];
    var _React67_useState1 = _sliced_to_array(React67.useState(state), 2), initialState = _React67_useState1[0], setInitialState = _React67_useState1[1];
    var _labelTemplate_text;
    var _React67_useState2 = _sliced_to_array(React67.useState((_labelTemplate_text = labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.text) !== null && _labelTemplate_text !== void 0 ? _labelTemplate_text : ""), 2), travelersSummary = _React67_useState2[0], setTravelersSummary = _React67_useState2[1];
    var handleChange = useFormCallback7(travelerSelector2.__typename, function(event) {
        return event;
    });
    var formatTravelerSummary = function(rooms) {
        var travelersCount = rooms.reduce(function(count, room) {
            var _room_adults, _room_children_count, _room_children, _room_infants_count, _room_infants;
            var _room_adults_value;
            var adultsCount = (_room_adults_value = (_room_adults = room.adults) === null || _room_adults === void 0 ? void 0 : _room_adults.value) !== null && _room_adults_value !== void 0 ? _room_adults_value : 0;
            var _room_children_count_value;
            var childrenCount = (_room_children_count_value = (_room_children = room.children) === null || _room_children === void 0 ? void 0 : (_room_children_count = _room_children.count) === null || _room_children_count === void 0 ? void 0 : _room_children_count.value) !== null && _room_children_count_value !== void 0 ? _room_children_count_value : 0;
            var _room_infants_count_value;
            var infantsCount = (_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : (_room_infants_count = _room_infants.count) === null || _room_infants_count === void 0 ? void 0 : _room_infants_count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0;
            return count + adultsCount + childrenCount + infantsCount;
        }, 0);
        return formatCompositeText(labelTemplate, rooms.length, travelersCount);
    };
    React67.useEffect(function() {
        setTravelersSummary(formatTravelerSummary(state.rooms));
        if (action.travelerSelector.__typename === "EGDSRoomsTravelerSelector") {
            if (action.travelerSelector.rooms[0].infants !== initialState.rooms[0].infants) {
                dispatch({
                    type: "RESET_ROOMS",
                    state: _object_spread_props(_object_spread({}, state), {
                        rooms: _to_consumable_array(action.travelerSelector.rooms)
                    })
                });
                setInitialState(_object_spread_props(_object_spread({}, state), {
                    rooms: _to_consumable_array(action.travelerSelector.rooms)
                }));
                setTravelersSummary(formatTravelerSummary(_to_consumable_array(action.travelerSelector.rooms)));
            }
        }
    }, [
        action.travelerSelector
    ]);
    React67.useEffect(function() {
        setTravelersSummary(formatTravelerSummary(state.rooms));
    }, [
        state.rooms
    ]);
    React67.useEffect(function() {
        var _reflectionState_travelers_adultTravelerCounts, _reflectionState_travelers;
        if ((action === null || action === void 0 ? void 0 : action.__typename) === "EGDSOpenTravelerSelectorAction" && (action === null || action === void 0 ? void 0 : action.travelerSelector.__typename) === "EGDSRoomsTravelerSelector" && (reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers = reflectionState.travelers) === null || _reflectionState_travelers === void 0 ? void 0 : (_reflectionState_travelers_adultTravelerCounts = _reflectionState_travelers.adultTravelerCounts) === null || _reflectionState_travelers_adultTravelerCounts === void 0 ? void 0 : _reflectionState_travelers_adultTravelerCounts.length)) {
            var _reflectionState_travelers1, _reflectionState_travelers2, _reflectionState_travelers3;
            var _reflectionState_travelers_adultTravelerCounts1, _reflectionState_travelers_childTravelerCounts, _reflectionState_travelers_childrenAges;
            dispatch({
                type: "UPDATE_TRAVELERS_BULK",
                state: initialState,
                adultTravelerCounts: (_reflectionState_travelers_adultTravelerCounts1 = reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers1 = reflectionState.travelers) === null || _reflectionState_travelers1 === void 0 ? void 0 : _reflectionState_travelers1.adultTravelerCounts) !== null && _reflectionState_travelers_adultTravelerCounts1 !== void 0 ? _reflectionState_travelers_adultTravelerCounts1 : [
                    0
                ],
                childTravelerCounts: (_reflectionState_travelers_childTravelerCounts = reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers2 = reflectionState.travelers) === null || _reflectionState_travelers2 === void 0 ? void 0 : _reflectionState_travelers2.childTravelerCounts) !== null && _reflectionState_travelers_childTravelerCounts !== void 0 ? _reflectionState_travelers_childTravelerCounts : [
                    0
                ],
                childrenAges: (_reflectionState_travelers_childrenAges = reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers3 = reflectionState.travelers) === null || _reflectionState_travelers3 === void 0 ? void 0 : _reflectionState_travelers3.childrenAges) !== null && _reflectionState_travelers_childrenAges !== void 0 ? _reflectionState_travelers_childrenAges : [
                    []
                ]
            });
        }
    }, [
        reflectionState.travelers
    ]);
    if (travelerSelector2.__typename !== "EGDSRoomsTravelerSelector") {
        return null;
    }
    var onTriggerClick = function() {
        setShowMenu(function(prevState) {
            return !prevState;
        });
        if (onOpenTravelerField) {
            onOpenTravelerField();
        }
        track(analytics.referrerId, analytics.linkName);
    };
    var onDismissMenu = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.error) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch({
                                type: "SHOW_ERROR"
                            })
                        ];
                    case 1:
                        _state.sent();
                        setShowMenu(true);
                        _state.label = 2;
                    case 2:
                        if (!state.error && !isEqual(initialState, state)) {
                            setInitialState(state);
                            triggerInputChangeEvent("submit", handleChange);
                        }
                        setTravelersSummary(formatTravelerSummary(state.rooms));
                        return [
                            2
                        ];
                }
            });
        });
        return function onDismissMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        dialogActions.openDialog();
        track(analytics.referrerId, analytics.linkName);
        if (onOpenTravelerField) {
            onOpenTravelerField(ViewSizes2.SMALL);
        }
    };
    var updateTravelerSummary = function(rooms) {
        var travelersValue = formatTravelerSummary(rooms);
        triggerInputChangeEvent(travelersValue, handleChange);
        setTravelersSummary(travelersValue);
    };
    var onSaveMenu = function(newState) {
        var _triggerRef_current;
        if (!isEqual(initialState, newState)) {
            updateTravelerSummary(newState.rooms);
            setInitialState(newState);
        }
        setShowMenu(function(prevState) {
            return !prevState;
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    var onSaveDialog = function(newState) {
        var _triggerRef_current;
        if (!isEqual(initialState, newState)) {
            updateTravelerSummary(newState.rooms);
            setInitialState(newState);
        }
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        dialogActions.closeDialog();
    };
    var validateSelector = function(event) {
        if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ) {
            if (event) {
                event.preventDefault();
            }
            dispatch({
                type: "SHOW_ERROR"
            });
        }
    };
    var onDismissDialog = function() {
        if ((travelerSelector2.closeButton.__typename === "UIPrimaryButton" || travelerSelector2.closeButton.__typename === "UITertiaryButton") && travelerSelector2.closeButton.analytics) {
            var _travelerSelector2_closeButton_analytics = travelerSelector2.closeButton.analytics, referrerId = _travelerSelector2_closeButton_analytics.referrerId, linkName = _travelerSelector2_closeButton_analytics.linkName;
            if (!error) {
                track(referrerId, linkName);
            }
        }
        validateSelector();
        if (!error) {
            onSaveDialog(state);
        }
    };
    var handleSubmit = function(triggerType) {
        validateSelector();
        if (!error) {
            if (triggerType === "menu") {
                onSaveMenu(state);
            } else {
                onSaveDialog(state);
            }
        }
    };
    var getActionButton = function(isFloating) {
        return doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React67.createElement(EGDSPrimaryButton, {
            onClick: handleSubmit,
            data: doneButton,
            floating: isFloating
        });
    };
    var _travelerSelector2_closeButton_accessibility;
    return /* @__PURE__ */ React67.createElement(React67.Fragment, null, /* @__PURE__ */ React67.createElement(Viewport11, null, /* @__PURE__ */ React67.createElement(ViewLarge6, null, /* @__PURE__ */ React67.createElement(UitkMenu2, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React67.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React67.createElement(UitkFakeInput3, {
        label: label,
        "aria-roledescription": allyLabelDescritption,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef,
        className: "open-room-picker-observer-root"
    })), /* @__PURE__ */ React67.createElement(UitkMenuContainer2, {
        maxHeight: 4e3,
        autoPosition: true,
        position: PositionType2.RIGHT,
        width: 375,
        intersectionObserverRoot: ".open-room-picker-observer-root"
    }, /* @__PURE__ */ React67.createElement(UitkSpacing20, {
        padding: {
            inline: "six",
            blockstart: "two"
        }
    }, /* @__PURE__ */ React67.createElement("div", {
        "data-stid": "rooms-traveler-selector-menu-container"
    }, /* @__PURE__ */ React67.createElement(EGDSRoomsTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        isTravelersExpanded: showMenu
    })))))), /* @__PURE__ */ React67.createElement(ViewMedium8, null, /* @__PURE__ */ React67.createElement(UitkMenu2, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React67.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React67.createElement(UitkFakeInput3, {
        label: label,
        "aria-roledescription": allyLabelDescritption,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef,
        className: "open-room-picker-observer-root"
    })), /* @__PURE__ */ React67.createElement(UitkMenuContainer2, {
        maxHeight: 4e3,
        autoPosition: true,
        position: PositionType2.RIGHT,
        width: 375,
        intersectionObserverRoot: ".open-room-picker-observer-root"
    }, /* @__PURE__ */ React67.createElement(UitkSpacing20, {
        padding: {
            inline: "six",
            blockstart: "two"
        }
    }, /* @__PURE__ */ React67.createElement("div", {
        "data-stid": "rooms-traveler-selector-menu-container"
    }, /* @__PURE__ */ React67.createElement(EGDSRoomsTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        isTravelersExpanded: showMenu
    })))))), /* @__PURE__ */ React67.createElement(ViewSmall9, null, /* @__PURE__ */ React67.createElement(React67.Fragment, null, /* @__PURE__ */ React67.createElement(UitkFakeInput3, {
        label: label,
        "aria-roledescription": allyLabelDescritption,
        value: travelersSummary,
        onClick: onClick,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef
    }), /* @__PURE__ */ React67.createElement(UitkSheetTransition3, {
        isVisible: isOpen
    }, /* @__PURE__ */ React67.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */ React67.createElement(UitkSheet3, {
        isVisible: isOpen,
        returnFocusOnClose: true,
        type: "full",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React67.createElement(UitkToolbar4, {
        toolbarTitle: travelerSelector2.title,
        navigationContent: {
            navType: "close",
            navIconLabel: travelerSelector2.closeButton.__typename === "UIPrimaryButton" || travelerSelector2.closeButton.__typename === "UITertiaryButton" ? (_travelerSelector2_closeButton_accessibility = travelerSelector2.closeButton.accessibility) !== null && _travelerSelector2_closeButton_accessibility !== void 0 ? _travelerSelector2_closeButton_accessibility : "" : "",
            onClick: onDismissDialog
        }
    }), /* @__PURE__ */ React67.createElement(UitkSheetContent3, null, /* @__PURE__ */ React67.createElement(UitkForm2, {
        hasRequiredFieldIndicator: true
    }, /* @__PURE__ */ React67.createElement(EGDSRoomsTravelerSelector, {
        data: travelerSelector2,
        isTravelersExpanded: isOpen
    }))), getActionButton(true))))))), state.rooms.map(function(room, roomIndex) {
        var _children_ages, _infants_ages;
        var adults = room.adults, children = room.children, infants = room.infants;
        var roomNumber = roomIndex + 1;
        return /* @__PURE__ */ React67.createElement(React67.Fragment, {
            key: roomIndex
        }, /* @__PURE__ */ React67.createElement("input", {
            type: "hidden",
            "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX2, "-").concat(roomNumber),
            name: "".concat(ADULT_COUNT_NAME_PREFIX2, "-Room").concat(roomNumber),
            value: adults.value
        }), children.__typename === "EGDSTravelerChildren" && ((_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.map(function(age, childIndex) {
            if (age.__typename === "EGDSTravelerChildAgeSelect") {
                var childNumber = childIndex + 1;
                var childName = "".concat(CHILDREN_NAME_PREFIX2, "-Room").concat(roomNumber, "-Child").concat(childNumber);
                var _age_value;
                return /* @__PURE__ */ React67.createElement("input", {
                    key: childIndex,
                    type: "hidden",
                    "data-stid": childName,
                    name: childName,
                    value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
                });
            }
            return null;
        })), (infants === null || infants === void 0 ? void 0 : infants.__typename) === "EGDSTravelerInfant" && ((_infants_ages = infants.ages) === null || _infants_ages === void 0 ? void 0 : _infants_ages.map(function(age, infantIndex) {
            if (age.__typename === "EGDSTravelerChildAgeSelect") {
                var _state_infantSeatSelection;
                var infantNumber = infantIndex + 1;
                var infantType = ((_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value) === "seat" ? INFANT_IN_SEAT_NAME_PREFIX2 : INFANT_ON_LAP_NAME_PREFIX2;
                var infantName = "".concat(infantType, "-Room").concat(roomNumber, "-Infant").concat(infantNumber);
                var _age_value;
                return /* @__PURE__ */ React67.createElement("input", {
                    key: infantIndex,
                    type: "hidden",
                    "data-stid": infantName,
                    name: infantName,
                    value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
                });
            }
            return null;
        })));
    }));
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-search-form-travelers-field.tsx
var __Fragment35 = gql45(_templateObject49(), EGDSBasicTravelerSelector.fragment, EGDSRoomsTravelerSelector.fragment);
var getTravelersData = function(travelers, isAnyPetAllowed) {
    if ((travelers === null || travelers === void 0 ? void 0 : travelers.pets) && travelers.pets.__typename === "EGDSBasicCheckBox") {
        return _object_spread_props(_object_spread({}, travelers), {
            pets: _object_spread_props(_object_spread({}, travelers.pets), {
                state: isAnyPetAllowed ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
            })
        });
    }
    return travelers;
};
var EGDSSearchFormTravelersField = function(param) {
    var data = param.data, skipQuery = param.skipQuery, isAnyPetAllowed = param.isAnyPetAllowed, onOpenTravelerField = param.onOpenTravelerField, onCloseTravelerField = param.onCloseTravelerField, maxBookableTravelers = param.maxBookableTravelers, maxTravelersErrorMessage = param.maxTravelersErrorMessage;
    var _React68_useState = _sliced_to_array(React68.useState(data), 2), state = _React68_useState[0], setState = _React68_useState[1];
    React68.useEffect(function() {
        var _data_action;
        if (((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename) === "EGDSOpenTravelerSelectorAction") {
            var _data_action_travelerSelector_validations;
            var _data_action_travelerSelector_validations_map;
            var validations2 = (_data_action_travelerSelector_validations_map = (_data_action_travelerSelector_validations = data.action.travelerSelector.validations) === null || _data_action_travelerSelector_validations === void 0 ? void 0 : _data_action_travelerSelector_validations.map(function(validation) {
                var isTravelerValidation = validation.__typename === "EGDSTravelersInputValidation" && validation.type === "MAX_TRAVELERS";
                var overrideTravelerMaxCount = isTravelerValidation && maxBookableTravelers;
                if (overrideTravelerMaxCount) {
                    return _object_spread_props(_object_spread({}, validation), {
                        maxCount: maxBookableTravelers,
                        errorMessage: maxTravelersErrorMessage !== null && maxTravelersErrorMessage !== void 0 ? maxTravelersErrorMessage : ""
                    });
                }
                return validation;
            })) !== null && _data_action_travelerSelector_validations_map !== void 0 ? _data_action_travelerSelector_validations_map : null;
            setState(_object_spread_props(_object_spread({}, data), {
                action: _object_spread_props(_object_spread({}, data.action), {
                    travelerSelector: _object_spread_props(_object_spread({}, data.action.travelerSelector), {
                        validations: validations2
                    })
                })
            }));
            return;
        }
        setState(data);
    }, [
        data,
        maxBookableTravelers,
        maxTravelersErrorMessage
    ]);
    var action = state.action, label = state.label, labelTemplate = state.labelTemplate, leftIcon = state.leftIcon, readOnly = state.readOnly;
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "EGDSOpenTravelerSelectorAction") {
        return null;
    }
    switch(action.travelerSelector.__typename){
        case "EGDSBasicTravelerSelector":
            {
                var _travelers_pets;
                var _action_travelerSelector = action.travelerSelector, travelers = _action_travelerSelector.travelers, validations2 = _action_travelerSelector.validations;
                var isPetsChecked = isAnyPetAllowed !== null && isAnyPetAllowed !== void 0 ? isAnyPetAllowed : (travelers === null || travelers === void 0 ? void 0 : (_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox" ? travelers.pets.state === "CHECKED" /* CHECKED */  : false;
                var initialTravelers = getTravelersData(travelers, isPetsChecked);
                if (!!initialTravelers && (labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) === "EGDSCardinalLocalizedText") {
                    return /* @__PURE__ */ React68.createElement(BasicTravelersProvider, _object_spread_props(_object_spread({}, {
                        travelers: initialTravelers,
                        validations: validations2
                    }), {
                        skipQuery: skipQuery
                    }), /* @__PURE__ */ React68.createElement(BasicTravelersFieldTriggers, {
                        label: label !== null && label !== void 0 ? label : "",
                        leftIcon: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id,
                        action: action,
                        labelTemplate: labelTemplate,
                        readOnly: readOnly,
                        isAnyPetAllowed: isAnyPetAllowed,
                        onOpenTravelerField: onOpenTravelerField,
                        onCloseTravelerField: onCloseTravelerField
                    }));
                }
                return null;
            }
        case "EGDSRoomsTravelerSelector":
            {
                if ((labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) === "EGDSCompositeLocalizedText") {
                    return /* @__PURE__ */ React68.createElement(TravelersProvider, _object_spread_props(_object_spread({}, action.travelerSelector), {
                        infantSeatSelection: action.travelerSelector.infantSeatSelection,
                        rooms: action.travelerSelector.rooms,
                        validations: action.travelerSelector.validations,
                        skipQuery: skipQuery
                    }), /* @__PURE__ */ React68.createElement(TravelersFieldTriggers, {
                        label: label !== null && label !== void 0 ? label : "",
                        leftIcon: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id,
                        action: action,
                        labelTemplate: labelTemplate,
                        readOnly: readOnly,
                        onOpenTravelerField: onOpenTravelerField
                    }));
                }
                return null;
            }
        default:
            return null;
    }
};
EGDSSearchFormTravelersField.displayName = "EGDSSearchFormTravelersField";
EGDSSearchFormTravelersField.fragment = __Fragment35;
// ../internal/src/components/form/egds-search-playback.tsx
import React69 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize6 } from "@egds/react-core/button";
import { UitkIcon as UitkIcon8, UitkIconSize as UitkIconSize4 } from "@egds/react-core/icons";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex11 } from "uitk-react-layout-flex";
import { MinMax, Repeat, UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading3, UitkText as UitkText8 } from "uitk-react-text";
var __Fragment36 = gql46(_templateObject50(), EGDSTertiaryButton.fragment);
var StickyWrapper = function(param) {
    var isSticky = param.isSticky, children = param.children;
    return isSticky ? /* @__PURE__ */ React69.createElement(StickySearchForm, null, children) : /* @__PURE__ */ React69.createElement("div", null, children);
};
var EGDSSearchPlayback = function(param) {
    var data = param.data, children = param.children, stickyPlayback = param.stickyPlayback, display = param.display, onDisplayToggle = param.onDisplayToggle;
    var primary = data.primary, secondaries = data.secondaries, showAction = data.showAction, hideButton = data.hideButton;
    var track = useClickTracker21();
    if (showAction.__typename !== "EGDSShowSearchFormAction" || hideButton.__typename !== "UITertiaryButton") {
        return null;
    }
    var accessibility = showAction.accessibility, analytics = showAction.analytics, icon = showAction.icon;
    var _icon_size;
    var iconSize = UitkIconSize4[(_icon_size = icon.size) !== null && _icon_size !== void 0 ? _icon_size : "SMALL"];
    var onPlaybackClick = function() {
        onDisplayToggle(false);
        track(analytics.referrerId, analytics.linkName);
    };
    var onCloseButtonClick = function() {
        onDisplayToggle(true);
        if (hideButton.analytics) {
            var _hideButton_analytics = hideButton.analytics, referrerId = _hideButton_analytics.referrerId, linkName = _hideButton_analytics.linkName;
            track(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React69.createElement(StickyWrapper, {
        isSticky: stickyPlayback
    }, display && /* @__PURE__ */ React69.createElement(UitkCard, {
        border: true,
        padded: true
    }, /* @__PURE__ */ React69.createElement(UitkLayoutGrid, {
        space: "three",
        columns: [
            MinMax("0x", "1fr"),
            "min-content"
        ],
        alignItems: "center"
    }, /* @__PURE__ */ React69.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React69.createElement("div", null, /* @__PURE__ */ React69.createElement(UitkHeading3, {
        size: 6,
        tag: "h2",
        overflow: "truncate"
    }, primary.text), /* @__PURE__ */ React69.createElement(UitkLayoutGrid, {
        columns: [
            Repeat(secondaries.length, "max-content")
        ],
        space: "six"
    }, secondaries.map(function(secondary, index) {
        return secondary && secondary.__typename === "EGDSBasicLocalizedText" || secondary && secondary.__typename === "EGDSCardinalLocalizedText" ? /* @__PURE__ */ React69.createElement(UitkLayoutGridItem, {
            key: "secondary-".concat(index)
        }, /* @__PURE__ */ React69.createElement(UitkText8, {
            size: 200,
            overflow: "truncate",
            "aria-label": secondary.__typename === "EGDSBasicLocalizedText" ? secondary.accessibilityTemplate : secondary.accessibilityText
        }, /* @__PURE__ */ React69.createElement("span", {
            "aria-hidden": "true"
        }, secondary.text))) : /* @__PURE__ */ React69.createElement(UitkLayoutGridItem, {
            key: "secondary-".concat(index)
        }, /* @__PURE__ */ React69.createElement(UitkText8, {
            size: 200,
            overflow: "truncate"
        }, secondary && secondary.__typename === "EGDSPlainText" ? secondary.text : ""));
    })))), /* @__PURE__ */ React69.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React69.createElement(UitkIcon8, {
        id: icon.id,
        name: icon.id,
        size: iconSize
    }))), /* @__PURE__ */ React69.createElement(UitkCardLink, null, /* @__PURE__ */ React69.createElement("button", {
        type: "button",
        onClick: onPlaybackClick,
        "aria-label": accessibility
    }))), /* @__PURE__ */ React69.createElement(UitkLayoutFlex11, {
        space: "three",
        direction: "column",
        "aria-hidden": display,
        className: display ? "is-visually-hidden is-hidden" : ""
    }, children, /* @__PURE__ */ React69.createElement(EGDSTertiaryButton, {
        onClick: onCloseButtonClick,
        isFullWidth: true,
        size: UitkButtonSize6.MEDIUM,
        data: hideButton
    })));
};
EGDSSearchPlayback.fragment = __Fragment36;
EGDSSearchPlayback.displayName = "EGDSSearchPlayback";
// ../internal/src/components/form/search-form-popular-filters.tsx
import React70 from "react";
import { gql as gql47 } from "@apollo/client";
var __Fragment37 = gql47(_templateObject51(), EGDSPill.fragment);
var SearchFormPopularFilters = function(props) {
    var data = props.data, onRemovePillClick = props.onRemovePillClick;
    var filters = data.filters;
    return /* @__PURE__ */ React70.createElement(React70.Fragment, null, filters === null || filters === void 0 ? void 0 : filters.map(function(filter) {
        return /* @__PURE__ */ React70.createElement(EGDSPill, {
            key: filter.id,
            data: filter,
            onClick: onRemovePillClick
        });
    }));
};
SearchFormPopularFilters.displayName = "SearchFormPopularFilters";
SearchFormPopularFilters.fragment = __Fragment37;
// ../internal/src/components/form/soft-packages/soft-packages.tsx
import React72 from "react";
import { gql as gql48 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
// ../internal/src/components/form/additional-field-with-layout.tsx
import React71 from "react";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
var AddtionalFieldWithLayout = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React71.createElement(UitkLayoutGrid2, {
        columns: {
            small: 2,
            medium: 12
        }
    }, /* @__PURE__ */ React71.createElement(UitkLayoutGridItem2, {
        colSpan: {
            small: 2,
            medium: 4
        }
    }, /* @__PURE__ */ React71.createElement("div", null, /* @__PURE__ */ React71.createElement(UitkSpacing21, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React71.createElement("div", null, children)))));
};
// ../internal/src/components/form/soft-packages/soft-packages.tsx
var getSelectedSoftPackage = function(products) {
    var currentProduct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "hotels";
    if (currentProduct === "hotels") {
        var flightAdded = products.flightAdded, carAdded = products.carAdded;
        if (flightAdded && carAdded) {
            return "fhc";
        }
        if (flightAdded) {
            return "fh";
        }
        if (carAdded) {
            return "hc";
        }
    } else if (currentProduct === "flights") {
        var hotelAdded = products.hotelAdded, carAdded1 = products.carAdded;
        if (hotelAdded && carAdded1) {
            return "fhc";
        }
        if (hotelAdded) {
            return "fh";
        }
        if (carAdded1) {
            return "fc";
        }
    }
    return "";
};
var _fragment = gql48(_templateObject52(), EGDSCheckBox.fragment, EGDSSearchFormLocationField.fragment);
var packageTypeParamName = "EGDSSoftPackagesPackageType";
var SoftPackages = function(props) {
    var data = props.data, onProductSelect = props.onProductSelect, setFieldRefByTypename = props.setFieldRefByTypename, fieldError = props.fieldError, currentSearchFormProduct = props.currentSearchFormProduct;
    var addCar = data.addCar, addFlight = data.addFlight, origin2 = data.origin, addHotel = data.addHotel, datesForHotelStay = data.datesForHotelStay;
    var handleCheckboxChange = function(event) {
        onProductSelect(event);
    };
    var handleFieldRef = function(typename, ref, refIndex) {
        setFieldRefByTypename("".concat(typename, "SoftPackages"), ref, refIndex);
    };
    var displayOriginField = origin2 && (addFlight === null || addFlight === void 0 ? void 0 : addFlight.__typename) === "EGDSBasicCheckBox" && addFlight.state === "CHECKED" /* CHECKED */ ;
    var originField = origin2 && /* @__PURE__ */ React72.createElement(AddtionalFieldWithLayout, null, /* @__PURE__ */ React72.createElement(EGDSSearchFormLocationField, {
        data: origin2,
        setFieldRefByTypename: setFieldRefByTypename,
        fieldError: fieldError
    }));
    var displayDatesForHotelStayField = datesForHotelStay && (addHotel === null || addHotel === void 0 ? void 0 : addHotel.__typename) === "EGDSBasicCheckBox" && addHotel.state === "CHECKED" /* CHECKED */ ;
    var datesForHotelStayStayField = datesForHotelStay && /* @__PURE__ */ React72.createElement(AddtionalFieldWithLayout, null, /* @__PURE__ */ React72.createElement(EGDSSearchFormDatePickerField, {
        data: datesForHotelStay,
        setFieldRefByTypename: handleFieldRef,
        fieldError: fieldError
    }));
    var isCheckBoxSelected = function(checkbox) {
        return (checkbox === null || checkbox === void 0 ? void 0 : checkbox.__typename) === "EGDSBasicCheckBox" && checkbox.state === "CHECKED" /* CHECKED */ ;
    };
    var selectedSoftPackage = getSelectedSoftPackage({
        flightAdded: isCheckBoxSelected(addFlight),
        carAdded: isCheckBoxSelected(addCar),
        hotelAdded: isCheckBoxSelected(addHotel)
    }, currentSearchFormProduct);
    var checkboxes = [
        addHotel,
        addFlight,
        addCar
    ];
    return /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement(UitkLayoutFlex12, {
        direction: "row",
        space: "three"
    }, checkboxes.map(function(checkbox) {
        return checkbox !== null ? /* @__PURE__ */ React72.createElement(UitkLayoutFlexItem11, {
            key: checkbox === null || checkbox === void 0 ? void 0 : checkbox.egdsElementId
        }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(EGDSCheckBox, {
            data: checkbox,
            onChange: handleCheckboxChange
        }))) : null;
    })), displayOriginField && originField, displayDatesForHotelStayField && datesForHotelStayStayField, /* @__PURE__ */ React72.createElement("input", {
        "data-stid": packageTypeParamName,
        type: "hidden",
        name: packageTypeParamName,
        value: selectedSoftPackage
    }));
};
SoftPackages.fragment = _fragment;
SoftPackages.displayName = "SoftPackages";
// ../internal/src/utils/error-validation.ts
var getDate = function(date) {
    var days = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return typeof date === "string" && date.includes("-") ? /* @__PURE__ */ new Date("".concat(date, "T00:00:00")) : new Date(new Date(date).setDate(new Date(date).getDate() + days));
};
var getFieldError = function(errorState, componentTypeName) {
    return errorState.fieldsWithErrors.find(function(field) {
        return field.__typename === componentTypeName;
    });
};
var getRefTypename = function(typename) {
    var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var typenames = {
        "origin_select-input": "".concat(typename, "Origin"),
        "destination_select-input": "".concat(typename, "Destination"),
        "pick_up_location-input": "".concat(typename, "PickUp"),
        "drop_off_location-input": "".concat(typename, "DropOff"),
        "airport_location-input": "".concat(typename, "Airport"),
        "hotel_location-input": "".concat(typename, "Hotel"),
        "partial_date-input": "".concat(typename, "PartialStay")
    };
    var _typenames_id;
    return (_typenames_id = typenames[id]) !== null && _typenames_id !== void 0 ? _typenames_id : typename;
};
var validateAgeInputField = function(age) {
    var _ref = age || {}, ageInput = _ref.ageInput, config = _ref.config;
    var _ageInput_value;
    var ageinputValue = (_ageInput_value = ageInput.value) !== null && _ageInput_value !== void 0 ? _ageInput_value : "";
    var isAgeinputValueEmpty = ageinputValue === "";
    var ageNumber = parseInt(ageinputValue, 10);
    var isAgeRangeValid = ageNumber && (config === null || config === void 0 ? void 0 : config.min) && (config === null || config === void 0 ? void 0 : config.max) ? ageNumber >= (config === null || config === void 0 ? void 0 : config.min) && ageNumber <= (config === null || config === void 0 ? void 0 : config.max) : true;
    var isAgeInputnValid = !isAgeinputValueEmpty && isAgeRangeValid;
    return {
        __typename: getRefTypename("EGDSNumberInputField", ageInput === null || ageInput === void 0 ? void 0 : ageInput.id),
        isValid: isAgeInputnValid,
        validations: {
            ageRange: isAgeinputValueEmpty ? false : !isAgeRangeValid
        }
    };
};
var validateDestinationLocationField = function(originLocation, destinationLocation) {
    var isSoftPackage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _destinationLocation_value;
    var destinationValue = (_destinationLocation_value = destinationLocation.value) !== null && _destinationLocation_value !== void 0 ? _destinationLocation_value : "";
    var isDestinationEmpty = destinationValue === "";
    var isLocationValid = !isDestinationEmpty;
    var hasSameValueAsOrigin = false;
    if (!isSoftPackage) {
        hasSameValueAsOrigin = originLocation ? !isDestinationEmpty && originLocation.value === destinationValue : false;
        isLocationValid = !isDestinationEmpty && !hasSameValueAsOrigin;
    }
    return {
        __typename: getRefTypename("EGDSSearchFormLocationField", destinationLocation === null || destinationLocation === void 0 ? void 0 : destinationLocation.id),
        isValid: isLocationValid,
        validations: {
            sameLocationSelected: hasSameValueAsOrigin
        }
    };
};
var validateOriginLocationField = function(origin2, softPackageDestination) {
    var _origin2_value;
    var originValue = (_origin2_value = origin2.value) !== null && _origin2_value !== void 0 ? _origin2_value : "";
    var isOriginEmpty = originValue === "";
    if (softPackageDestination && !isOriginEmpty) {
        var hasSameValueAsDestination = softPackageDestination.value === originValue;
        return {
            __typename: getRefTypename("EGDSSearchFormLocationField", origin2 === null || origin2 === void 0 ? void 0 : origin2.id),
            isValid: !hasSameValueAsDestination,
            validations: {
                sameLocationSelected: hasSameValueAsDestination
            }
        };
    }
    return {
        __typename: getRefTypename("EGDSSearchFormLocationField", origin2 === null || origin2 === void 0 ? void 0 : origin2.id),
        isValid: !isOriginEmpty
    };
};
var validateDateOutsideTripRange = function(dateField, compareToDateField) {
    var _dateField_startDate, _dateField_endDate, _compareToDateField_startDate, _compareToDateField_endDate;
    var _dateField_startDate_value;
    var dateFieldStartDate = getDate((_dateField_startDate_value = (_dateField_startDate = dateField.startDate) === null || _dateField_startDate === void 0 ? void 0 : _dateField_startDate.value) !== null && _dateField_startDate_value !== void 0 ? _dateField_startDate_value : "");
    var _dateField_endDate_value;
    var dateFieldEndDate = getDate((_dateField_endDate_value = (_dateField_endDate = dateField.endDate) === null || _dateField_endDate === void 0 ? void 0 : _dateField_endDate.value) !== null && _dateField_endDate_value !== void 0 ? _dateField_endDate_value : "");
    var _compareToDateField_startDate_value;
    var compareToDateFieldStartDate = getDate((_compareToDateField_startDate_value = (_compareToDateField_startDate = compareToDateField.startDate) === null || _compareToDateField_startDate === void 0 ? void 0 : _compareToDateField_startDate.value) !== null && _compareToDateField_startDate_value !== void 0 ? _compareToDateField_startDate_value : "");
    var _compareToDateField_endDate_value;
    var compareToDateFieldEndDate = getDate((_compareToDateField_endDate_value = (_compareToDateField_endDate = compareToDateField.endDate) === null || _compareToDateField_endDate === void 0 ? void 0 : _compareToDateField_endDate.value) !== null && _compareToDateField_endDate_value !== void 0 ? _compareToDateField_endDate_value : "");
    return dateFieldStartDate < compareToDateFieldStartDate || dateFieldEndDate > compareToDateFieldEndDate;
};
var validateDatePickerField = function(startDate5, endDate5, config, fieldId) {
    var _startDate5_value;
    var formattedStartDate = getDate((_startDate5_value = startDate5 === null || startDate5 === void 0 ? void 0 : startDate5.value) !== null && _startDate5_value !== void 0 ? _startDate5_value : "");
    var _endDate5_value;
    var formattedEndDate = getDate((_endDate5_value = endDate5 === null || endDate5 === void 0 ? void 0 : endDate5.value) !== null && _endDate5_value !== void 0 ? _endDate5_value : "");
    var overpassesMaxRange = config.maxNumberOfDaysSelected !== 0 ? formattedEndDate >= getDate(formattedStartDate, config.maxNumberOfDaysSelected) : false;
    var isSameDate = formattedStartDate === formattedEndDate;
    var endDateBeforeStartDate = formattedEndDate < formattedStartDate;
    var isDateValid = !overpassesMaxRange && !isSameDate && !endDateBeforeStartDate;
    return {
        __typename: getRefTypename("EGDSSearchFormDatePickerField", fieldId !== null && fieldId !== void 0 ? fieldId : startDate5 === null || startDate5 === void 0 ? void 0 : startDate5.id),
        isValid: isDateValid,
        validations: {
            maxDate: overpassesMaxRange,
            sameDate: isSameDate,
            endDateBeforeStartDate: endDateBeforeStartDate
        }
    };
};
var getParsedTimeValues = function(time) {
    var hours = parseInt(time.substr(0, 2), 10);
    var minutes = parseInt(time.substr(2, 2), 10);
    if (time.includes("PM") && hours !== 12) {
        hours += 12;
    }
    if (time.includes("AM") && hours === 12) {
        hours -= 12;
    }
    return {
        hours: hours,
        minutes: minutes
    };
};
var validatePickupTimeField = function(startTimeValue, startDate5) {
    var today5 = /* @__PURE__ */ new Date();
    if (today5.getDate() === startDate5.getDate() && today5.getMonth() === startDate5.getMonth() && today5.getFullYear() === startDate5.getFullYear()) {
        var parsedTime = getParsedTimeValues(startTimeValue);
        var startTimeFormat = /* @__PURE__ */ new Date();
        startTimeFormat.setHours(parsedTime.hours, parsedTime.minutes);
        var isValid = today5 < startTimeFormat;
        return {
            __typename: "EGDSBasicSelectPickUp",
            isValid: isValid
        };
    }
    return {
        __typename: "EGDSBasicSelectPickUp",
        isValid: true
    };
};
var validateDropoffTimeField = function(startTime, endTime, dates) {
    var startDateInput = dates.startDateInput, endDateInput = dates.endDateInput;
    var _startDateInput_value;
    var startDate5 = getDate((_startDateInput_value = startDateInput === null || startDateInput === void 0 ? void 0 : startDateInput.value) !== null && _startDateInput_value !== void 0 ? _startDateInput_value : "");
    var _endDateInput_value;
    var endDate5 = getDate((_endDateInput_value = endDateInput === null || endDateInput === void 0 ? void 0 : endDateInput.value) !== null && _endDateInput_value !== void 0 ? _endDateInput_value : "");
    var startTimeValue = startTime === null || startTime === void 0 ? void 0 : startTime.value;
    var endTimeValue = endTime === null || endTime === void 0 ? void 0 : endTime.value;
    if (!startTimeValue || !endTimeValue) {
        return {
            __typename: "EGDSBasicSelectDropOff",
            isValid: true
        };
    }
    var startParsedTime = getParsedTimeValues(startTimeValue);
    startDate5.setHours(startParsedTime.hours, startParsedTime.minutes);
    var endParsedTime = getParsedTimeValues(endTimeValue);
    endDate5.setHours(endParsedTime.hours, endParsedTime.minutes);
    var isEndTimeAfterStartTime = endDate5 > startDate5;
    startDate5.setTime(startDate5.getTime() + 2 * 60 * 60 * 1e3);
    var isTwoHoursDifference = endDate5 >= startDate5;
    var isValid = isEndTimeAfterStartTime && isTwoHoursDifference;
    return {
        __typename: "EGDSBasicSelectDropOff",
        isValid: isValid
    };
};
var getFormElementsWithErrors = function(formElements) {
    var softPackages = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var location = formElements.location, dates = formElements.dates, age = formElements.age, time = formElements.time;
    var startDateInput = dates.startDateInput, endDateInput = dates.endDateInput, partialStayStartDateInput = dates.partialStayStartDateInput, partialStayEndDateInput = dates.partialStayEndDateInput, softPackagesStartDateInput = dates.softPackagesStartDateInput, softPackageEndDateInput = dates.softPackageEndDateInput, config = dates.config;
    var _location_destination;
    var validations2 = location.origin ? [
        validateOriginLocationField(location.origin, softPackages ? (_location_destination = location.destination) !== null && _location_destination !== void 0 ? _location_destination : null : null),
        validateDatePickerField(startDateInput, endDateInput, config)
    ] : [
        validateDatePickerField(startDateInput, endDateInput, config)
    ];
    if (location.destination) {
        validations2.push(validateDestinationLocationField(location.origin, location.destination, softPackages));
    }
    if (age) {
        validations2.push(validateAgeInputField(age));
    }
    if (time) {
        var _time_pickup;
        var _dates_startDateInput_value;
        var startDate5 = getDate((_dates_startDateInput_value = dates.startDateInput.value) !== null && _dates_startDateInput_value !== void 0 ? _dates_startDateInput_value : "");
        var startTimeValue = time === null || time === void 0 ? void 0 : (_time_pickup = time.pickup) === null || _time_pickup === void 0 ? void 0 : _time_pickup.value;
        validations2.push(validatePickupTimeField(startTimeValue, startDate5), validateDropoffTimeField(time.pickup, time.dropOff, dates));
    }
    if (partialStayEndDateInput && partialStayStartDateInput) {
        var fieldDatesPartialId = "partial_date-input";
        var dateFieldGeneralValidation = validateDatePickerField(partialStayStartDateInput, partialStayEndDateInput, config, fieldDatesPartialId);
        var validateRange = validateDateOutsideTripRange({
            startDate: partialStayStartDateInput,
            endDate: partialStayEndDateInput
        }, {
            startDate: startDateInput,
            endDate: endDateInput
        });
        validations2.push(_object_spread_props(_object_spread({}, dateFieldGeneralValidation), {
            isValid: dateFieldGeneralValidation.isValid && !validateRange,
            validations: _object_spread_props(_object_spread({}, dateFieldGeneralValidation.validations), {
                dateOutsideTripRange: validateRange
            })
        }));
    }
    if (softPackagesStartDateInput && softPackageEndDateInput) {
        var softPackagesDatesId = "soft_packages_date_form_field";
        var _softPackagesStartDateInput_value, _startDateInput_value;
        var isStayBeforeFlight = getDate((_softPackagesStartDateInput_value = softPackagesStartDateInput === null || softPackagesStartDateInput === void 0 ? void 0 : softPackagesStartDateInput.value) !== null && _softPackagesStartDateInput_value !== void 0 ? _softPackagesStartDateInput_value : "") < getDate((_startDateInput_value = startDateInput === null || startDateInput === void 0 ? void 0 : startDateInput.value) !== null && _startDateInput_value !== void 0 ? _startDateInput_value : "");
        validations2.push({
            __typename: getRefTypename("EGDSSearchFormDatePickerFieldSoftPackages", softPackagesDatesId),
            isValid: !isStayBeforeFlight,
            validations: {
                dateOutsideTripRange: isStayBeforeFlight
            }
        });
    }
    return validations2.filter(function(element) {
        return !element.isValid;
    });
};
var validateMultiLocationField = function(locations) {
    return locations.map(function(location, index) {
        return {
            __typename: "".concat(getRefTypename("EGDSSearchFormLocationField", location === null || location === void 0 ? void 0 : location.id), "-leg").concat(index),
            isValid: (location === null || location === void 0 ? void 0 : location.value) !== ""
        };
    });
};
var validateDestinationLocationMultiField = function(originLocation, destinationLocation, index) {
    var _destinationLocation_value;
    var destinationValue = (_destinationLocation_value = destinationLocation.value) !== null && _destinationLocation_value !== void 0 ? _destinationLocation_value : "";
    var isDestinationEmpty = destinationValue === "";
    var hasSameValueAsOrigin = originLocation ? !isDestinationEmpty && originLocation.value === destinationValue : false;
    var isLocationValid = !isDestinationEmpty && !hasSameValueAsOrigin;
    return {
        __typename: "".concat(getRefTypename("EGDSSearchFormLocationField", destinationLocation === null || destinationLocation === void 0 ? void 0 : destinationLocation.id), "-leg").concat(index),
        isValid: isLocationValid,
        validations: {
            sameLocationSelected: hasSameValueAsOrigin
        }
    };
};
var getMultiFormElementsWithErrors = function(multiFormElements) {
    var location = multiFormElements.location, dates = multiFormElements.dates;
    var startDateInput = dates.startDateInput, endDateInput = dates.endDateInput, config = dates.config;
    var validations2 = [];
    if (location.origin) {
        var originValidations = validateMultiLocationField(location.origin);
        originValidations.forEach(function(validation) {
            return validations2.push(validation);
        });
    }
    if (location.destination) {
        var _location_origin;
        (_location_origin = location.origin) === null || _location_origin === void 0 ? void 0 : _location_origin.forEach(function(origin2, index) {
            var _location_destination;
            var destinationInput = (_location_destination = location.destination) === null || _location_destination === void 0 ? void 0 : _location_destination[index];
            validations2.push(validateDestinationLocationMultiField(origin2, destinationInput, index));
        });
    }
    if (dates) {
        validations2.push(validateDatePickerField(startDateInput, endDateInput, config));
    }
    return validations2.filter(function(element) {
        return !element.isValid;
    });
};
var findFieldByNameAttribute = function(name) {
    return function(element) {
        return element.getAttribute("name") === name;
    };
};
// ../internal/src/utils/query-params-mapper/fields/egds-search-form-location-field.ts
var fieldName = "EGDSSearchFormLocationField";
var locationPrefix = "".concat(fieldName, "-Location");
var regionIdPrefix = "".concat(fieldName, "-RegionId");
var latPrefix = "".concat(fieldName, "-Lat");
var longPrefix = "".concat(fieldName, "-Long");
var deeplinkPrefix = "".concat(fieldName, "-Values");
var selectedPrefix = "".concat(fieldName, "-Selected");
var amenitiesFacilitiesGroupPrefix = "".concat(fieldName, "-AmenitiesFacilitiesGroup");
var locationGroupPrefix = "".concat(fieldName, "-LocGroup");
var propertiesGoodForGroupPrefix = "".concat(fieldName, "-PropertiesGoodForGroup");
var propertyTypeGroupPrefix = "".concat(fieldName, "-PropertyTypeGroup");
var propertyIdPrefix = "".concat(fieldName, "-PropertyId");
var filterPrefix = "".concat(fieldName, "-PropertyFilter");
// ../internal/src/utils/query-params-mapper/fields/egds-search-form-travelers-field.ts
var fieldName2 = "EGDSSearchFormTravelersField";
var adultPrefix = "".concat(fieldName2, "-Adult-Room");
var childrenAgePrefix = "".concat(fieldName2, "-ChildrenAge-Room");
// ../internal/src/utils/query-params-mapper/fields/egds-basic-traveler-selector.ts
var fieldName3 = "EGDSSearchFormTravelersField";
var adultBasicPrefix = "".concat(fieldName3, "-Adult");
var childrenAgeBasicPrefix = "".concat(fieldName3, "-ChildrenAge");
var petsBasicPrefix = "".concat(fieldName3, "-Pets");
// ../internal/src/utils/query-params-mapper/fields/search-form-duration-span-field.ts
var fieldName4 = "SearchFormDurationSpanField";
var minDurationPrefix = "".concat(fieldName4, "-Min");
var maxDurationPrefix = "".concat(fieldName4, "-Max");
// ../internal/src/utils/query-params-mapper/fields/egds-basic-pill.ts
var egdsBasicPillPrefix = "EGDSBasicPill";
// ../internal/src/utils/query-params-mapper/strategies/activities-strategy.ts
var activitiesStrategy = function(inputs) {
    var queryParamsMap = inputs.reduce(function(prev, param) {
        var name = param.name, value = param.value;
        if (name.startsWith(locationPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                location: value
            });
        }
        if (name.startsWith(regionIdPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                rid: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                d1: value,
                startDate: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                d2: value,
                endDate: value
            });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
// ../internal/src/utils/query-params-mapper/strategies/cruise-strategy.ts
var cruiseStrategy = function(inputs) {
    var queryParamsMap = inputs.reduce(function(prev, param) {
        var name = param.name, value = param.value;
        if (name.startsWith(deeplinkPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                destination: value.replace(/,/g, "|")
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                "earliest-departure-date": value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                "latest-departure-date": value
            });
        }
        if (name.startsWith(minDurationPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                "min-length": value
            });
        }
        if (name.startsWith(maxDurationPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                "max-length": value
            });
        }
        if (name.startsWith(adultBasicPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                adultCount: value
            });
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            var prevChildren = prev.childAges;
            var childAges = prevChildren ? "".concat(prevChildren, ",").concat(value) : value;
            var childCount = childAges.split(",").length;
            return _object_spread_props(_object_spread({}, prev), {
                childCount: childCount,
                childAges: childAges
            });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
// ../internal/src/utils/query-params-mapper/fields/flights/index.ts
var flightTypeEgdsElementId = "flight_type_selector";
var cabinClassEgdsElementId = "cabin_class";
var destinationEgdsElementId = "destination_select";
var originEgdsElementId = "origin_select";
// ../internal/src/utils/query-params-mapper/strategies/flight-strategy.ts
var flightTypeMap = {
    ONE_WAY: "oneway",
    ROUND_TRIP: "roundtrip",
    MULTI_DESTINATION: "multi"
};
var flightStrategy = function(inputs) {
    var leg = {
        from: "",
        to: "",
        departureDate: ""
    };
    var passengers = {
        adults: 0,
        seniors: 0,
        childAges: []
    };
    var queryParamsMap = inputs.reduce(function(prev, param) {
        var name = param.name, value = param.value;
        if (name.includes(flightTypeEgdsElementId)) {
            return _object_spread_props(_object_spread({}, prev), {
                trip: flightTypeMap[value]
            });
        }
        if (name.includes(cabinClassEgdsElementId)) {
            return _object_spread_props(_object_spread({}, prev), {
                options: "cabinclass:".concat(value)
            });
        }
        if (name.startsWith(locationPrefix) && name.includes(originEgdsElementId)) {
            leg.from = value;
            return prev;
        }
        if (name.startsWith(locationPrefix) && name.includes(destinationEgdsElementId)) {
            leg.to = value;
            return prev;
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX)) {
            leg.departureDate = value;
            return _object_spread_props(_object_spread({}, prev), {
                fromDate: value
            });
        }
        if (name.startsWith(adultBasicPrefix)) {
            passengers.adults = +value;
            return prev;
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            passengers.childAges.push(value);
            return prev;
        }
        return prev;
    }, {
        "flight-type": "on",
        mode: "search"
    });
    var childCount = passengers.childAges.length || 0;
    var childAges = childCount ? "".concat(childCount, "[").concat(passengers.childAges.join(";"), "]") : childCount.toString();
    queryParamsMap.legs = [
        leg
    ];
    queryParamsMap.passengers = "children:".concat(childAges, ",adults:").concat(passengers.adults, ",seniors:0,infantinlap:Y");
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        if (key === "legs" && queryParamsMap.legs) {
            return queryParamsMap.legs.map(function(value, index) {
                return "leg".concat(index + 1, "=from:").concat(value.from, ",to:").concat(value.to, ",departure:").concat(value.departureDate, "TANYT");
            }).join("&");
        }
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
// ../internal/src/utils/query-params-mapper/strategies/lodging-strategy.ts
var lodgingStrategy = function(inputs) {
    var queryParamsMap = inputs.reduce(function(prev, input) {
        var name = input.name, value = input.value, checked = input.checked;
        if (name.startsWith("".concat(locationPrefix, "-destination"))) {
            return _object_spread_props(_object_spread({}, prev), {
                destination: value
            });
        }
        if (name.startsWith("".concat(regionIdPrefix, "-destination")) && value !== "null") {
            return _object_spread_props(_object_spread({}, prev), {
                regionId: value
            });
        }
        if (name.startsWith("".concat(latPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                latLong: value
            });
        }
        if (name.startsWith("".concat(longPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                latLong: "".concat(prev.latLong, ",").concat(value)
            });
        }
        if (name.startsWith("".concat(amenitiesFacilitiesGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                amenities_facilities_group: value
            });
        }
        if (name.startsWith("".concat(locationGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                location_group: value
            });
        }
        if (name.startsWith("".concat(propertiesGoodForGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                properties_good_for_group: value
            });
        }
        if (name.startsWith("".concat(propertyTypeGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                property_type_group: value
            });
        }
        if (name.startsWith(filterPrefix) && value) {
            var filterName = name.split("".concat(filterPrefix, "-")).pop();
            return _object_spread({}, prev, filterName ? _define_property({}, filterName, value) : {});
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                d1: value,
                startDate: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                d2: value,
                endDate: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.FLEXIBILITY_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                flexibility: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.FLEXIBILITY_NIGHTS_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                flexibility: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.FLEXIBILITY_WEEKEND_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                flexibleSearchRequirement: value
            });
        }
        if (name.startsWith(DATE_PICKER_PREFIX_MAP.FLEXIBILITY_MONTHS_PREFIX)) {
            return _object_spread_props(_object_spread({}, prev), {
                searchRange: value
            });
        }
        if (name.startsWith("".concat(propertyIdPrefix))) {
            return _object_spread_props(_object_spread({}, prev), {
                propertyId: value
            });
        }
        if (name.startsWith(adultPrefix)) {
            var prevAdults = prev.adults;
            var adults = prevAdults ? "".concat(prevAdults, ",").concat(value) : value;
            var rooms = adults.split(",").length;
            return _object_spread_props(_object_spread({}, prev), {
                adults: adults,
                rooms: rooms
            });
        }
        if (name.startsWith(childrenAgePrefix)) {
            var prevChildren = prev.children;
            var roomNumber = name.substr(childrenAgePrefix.length, 1);
            var formattedValue = "".concat(roomNumber, "_").concat(value);
            var children = prevChildren ? "".concat(prevChildren, ",").concat(formattedValue) : formattedValue;
            return _object_spread_props(_object_spread({}, prev), {
                children: children
            });
        }
        if (name.startsWith(adultBasicPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                adults: value
            });
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            var prevChildren1 = prev.children;
            var roomNumber1 = 1;
            var formattedValue1 = "".concat(roomNumber1, "_").concat(value);
            var children1 = prevChildren1 ? "".concat(prevChildren1, ",").concat(formattedValue1) : formattedValue1;
            return _object_spread_props(_object_spread({}, prev), {
                children: children1
            });
        }
        if (name.startsWith(petsBasicPrefix)) {
            return _object_spread({}, prev, value === "CHECKED" /* CHECKED */  && {
                house_rules_group: "pets_allowed"
            });
        }
        if (name.startsWith(selectedPrefix)) {
            return value ? _object_spread_props(_object_spread({}, prev), {
                selected: value
            }) : _object_spread({}, prev);
        }
        if (name.startsWith("".concat(locationPrefix, "-origin"))) {
            return _object_spread_props(_object_spread({}, prev), {
                origin: value
            });
        }
        if (name.startsWith("EGDSSoftPackagesPackageType") && value.length > 0) {
            return _object_spread_props(_object_spread({}, prev), {
                packageType: value
            });
        }
        if (name.startsWith("".concat(egdsBasicPillPrefix, "-add-flight")) || name.startsWith("add-flight-switch")) {
            return _object_spread({}, prev, checked ? {
                "add-flight-switch": checked
            } : {});
        }
        if (name.startsWith("".concat(egdsBasicPillPrefix, "-add-car")) || name.startsWith("add-car-switch")) {
            return _object_spread({}, prev, checked ? {
                "add-car-switch": checked
            } : {});
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        if (key.includes("flexibility")) {
            var flexibilityValues = queryParamsMap[key].split(",");
            return flexibilityValues.map(function(value) {
                return "".concat(key, "=").concat(value);
            }).join("&");
        }
        if (key.includes("searchRange")) {
            var searchRangeValues = queryParamsMap[key].split("/");
            return searchRangeValues.map(function(value) {
                return "".concat(key, "=").concat(value);
            }).join("&");
        }
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
var _obj3;
// ../internal/src/utils/query-params-mapper/strategies/map.ts
var queryParamsStrategiesMap = (_obj3 = {}, _define_property(_obj3, "LODGING" /* LODGING */ , lodgingStrategy), _define_property(_obj3, "CRUISES" /* CRUISES */ , cruiseStrategy), _define_property(_obj3, "FLIGHTS" /* FLIGHTS */ , flightStrategy), _define_property(_obj3, "ACTIVITIES" /* ACTIVITIES */ , activitiesStrategy), _obj3);
// ../internal/src/utils/query-params-mapper/query-params-mapper.ts
var getSearchToolsQueryParams = function(strategy, elements) {
    var searchToolsInputPrefix = "EGDS";
    var searchForm = "SearchForm";
    var softPackages = "add";
    var prefixes = [
        searchToolsInputPrefix,
        searchForm,
        softPackages
    ];
    var filteredInputs = elements.filter(function(param) {
        var name = param.name;
        return prefixes.find(function(prefix) {
            return name.startsWith(prefix);
        });
    });
    return queryParamsStrategiesMap[strategy](filteredInputs);
};
// ../internal/src/utils/uis-prime-utils.ts
var mapUisMicroMessage = function(uisPrimeMessages) {
    return uisPrimeMessages.map(function(uisPrimeMessage) {
        return {
            messageContent: JSON.parse(uisPrimeMessage.messageContent),
            schemaName: uisPrimeMessage.schemaName
        };
    });
};
// src/components/lodging/form/__private/lodging-search-form.tsx
import { useSignalPublisher, useSignalSubscriber as useSignalSubscriber2 } from "@shared-ui/signal-events-context";
import { defaultViewSizes as defaultViewSizes4, useMediaQueries as useMediaQueries4, ViewLarge as ViewLarge7, ViewMedium as ViewMedium9, Viewport as Viewport12, ViewSizes as ViewSizes3, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm3 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { FitContent, Repeat as Repeat2, UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
// src/components/lodging/utils/fields-map.ts
var FieldNameMap = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["DESTINATION"] = "destination_form_field";
    FieldNameMap8["TRAVEL_DATES"] = "EGDSDateRangePicker";
    FieldNameMap8["TRAVEL_DATES_FLEXIBLE"] = "EGDSDateRangePicker-Flexible";
    FieldNameMap8["TRAVELER_ROOM_SELECTOR"] = "EGDSRoomsTravelerSelector";
    FieldNameMap8["TRAVELER_BASIC_SELECTOR"] = "EGDSBasicTravelerSelector";
    return FieldNameMap8;
}(FieldNameMap || {});
// src/components/lodging/utils/query-params.ts
var ParamsKeys = /* @__PURE__ */ function(ParamsKeys2) {
    ParamsKeys2["DESTINATION"] = "destination";
    ParamsKeys2["REGION_ID"] = "regionId";
    ParamsKeys2["LAT_LONG"] = "latLong";
    ParamsKeys2["DATE_ONE"] = "d1";
    ParamsKeys2["DATE_TWO"] = "d2";
    ParamsKeys2["START_DATE"] = "startDate";
    ParamsKeys2["END_DATE"] = "endDate";
    ParamsKeys2["ADULTS"] = "adults";
    ParamsKeys2["CHILDREN"] = "children";
    ParamsKeys2["SELECTED"] = "selected";
    ParamsKeys2["FLEXIBILITY"] = "flexibility";
    ParamsKeys2["SEARCH_RANGE"] = "searchRange";
    ParamsKeys2["FLEXIBLE_SEARCH_REQUIREMENT"] = "flexibleSearchRequirement";
    ParamsKeys2["MAP_BOUNDS"] = "mapBounds";
    return ParamsKeys2;
}(ParamsKeys || {});
var SortAndFiltersParamsKeys = /* @__PURE__ */ function(SortAndFiltersParamsKeys2) {
    SortAndFiltersParamsKeys2["SORT"] = "sort";
    SortAndFiltersParamsKeys2["HOTEL_NAME"] = "hotelName";
    SortAndFiltersParamsKeys2["REWARDS"] = "rewards";
    SortAndFiltersParamsKeys2["STAR"] = "star";
    SortAndFiltersParamsKeys2["GUEST_RATING"] = "guestRating";
    SortAndFiltersParamsKeys2["CLEANING_AND_SAFETY"] = "cleaningAndSafetyPractices";
    SortAndFiltersParamsKeys2["LODGING"] = "lodging";
    SortAndFiltersParamsKeys2["MEAL_PLAN"] = "mealPlan";
    SortAndFiltersParamsKeys2["AMENITIES"] = "amenities";
    SortAndFiltersParamsKeys2["TRAVELER_TYPE"] = "travelerType";
    SortAndFiltersParamsKeys2["PAYMENT_TYPE"] = "paymentType";
    SortAndFiltersParamsKeys2["DEALS"] = "deals";
    SortAndFiltersParamsKeys2["PROPERTY_STYLE"] = "propertyStyle";
    SortAndFiltersParamsKeys2["BEDROOM_FILTER"] = "bedroomFilter";
    SortAndFiltersParamsKeys2["NEIGHBORHOOD"] = "neighborhood";
    SortAndFiltersParamsKeys2["STAY_TYPE"] = "stayType";
    SortAndFiltersParamsKeys2["ACCESSIBILITY"] = "accessibility";
    SortAndFiltersParamsKeys2["POI"] = "poi";
    SortAndFiltersParamsKeys2["MIN_BEDROOMS"] = "bedroom_count_gt";
    SortAndFiltersParamsKeys2["MIN_BATHROOMS"] = "us_bathroom_count_gt";
    SortAndFiltersParamsKeys2["PROPERTY_TYPE"] = "property_type_group";
    SortAndFiltersParamsKeys2["LOCATION"] = "location_group";
    SortAndFiltersParamsKeys2["ACCESSIBILITY_FEATURES"] = "accessibility_features_group";
    SortAndFiltersParamsKeys2["BOOKING_OPTIONS"] = "booking_options_group";
    SortAndFiltersParamsKeys2["DISCOUNTS_GROUP"] = "discounts_group";
    SortAndFiltersParamsKeys2["AMENITIES_FACILITIES"] = "amenities_facilities_group";
    SortAndFiltersParamsKeys2["FREE_CANCELLATION_GROUP"] = "free_cancellation_group";
    SortAndFiltersParamsKeys2["HOUSE_RULES"] = "house_rules_group";
    SortAndFiltersParamsKeys2["NEARBY_ACTIVITIES"] = "nearby_activities_group";
    SortAndFiltersParamsKeys2["NEIGHBORHOOD_GROUP"] = "neighborhood_group";
    SortAndFiltersParamsKeys2["PREMIER_HOST"] = "premier_host_group";
    SortAndFiltersParamsKeys2["PROPERTIES_GOOD"] = "properties_good_for_group";
    SortAndFiltersParamsKeys2["PROPERTY_REVIEWS"] = "property_reviews_group";
    SortAndFiltersParamsKeys2["ROOMS_SPACES"] = "rooms_spaces_group";
    SortAndFiltersParamsKeys2["SAFETY"] = "safety_group";
    SortAndFiltersParamsKeys2["VIRTUAL_TOUR_GROUP"] = "virtual_tour_group";
    SortAndFiltersParamsKeys2["PRICING_GROUP"] = "pricing_group";
    SortAndFiltersParamsKeys2["PROPERTY_NAME"] = "propertyName";
    SortAndFiltersParamsKeys2["AVAILABLE_FILTER"] = "availableFilter";
    SortAndFiltersParamsKeys2["AGENCY_BUSINESS_MODELS"] = "agencyBusinessModels";
    SortAndFiltersParamsKeys2["COMMISSION_TIERS"] = "commissionTiers";
    SortAndFiltersParamsKeys2["USE_REWARDS"] = "useRewards";
    SortAndFiltersParamsKeys2["BED_TYPE_GROUP"] = "bed_type_group";
    SortAndFiltersParamsKeys2["STAY_OPTIONS_GROUP"] = "stay_options_group";
    SortAndFiltersParamsKeys2["HOTEL_BRAND"] = "hotel_brand";
    SortAndFiltersParamsKeys2["MULTI_NEIGHBORHOOD_GROUP"] = "multi_neighborhood_group";
    SortAndFiltersParamsKeys2["SPECIAL_DISCOUNTS_GROUP"] = "special_discounts_group";
    SortAndFiltersParamsKeys2["HIGHLY_RATED_FOR_GROUP"] = "highly_rated_for_group";
    SortAndFiltersParamsKeys2["AI_SEARCH_QUERY"] = "ai_search_query";
    return SortAndFiltersParamsKeys2;
}(SortAndFiltersParamsKeys || {});
var SortAndFiltersRangeParamKey = /* @__PURE__ */ function(SortAndFiltersRangeParamKey2) {
    SortAndFiltersRangeParamKey2["PRICE"] = "price";
    SortAndFiltersRangeParamKey2["NIGHTLY_PRICE"] = "nightly_price";
    SortAndFiltersRangeParamKey2["TOTAL_PRICE"] = "total_price";
    return SortAndFiltersRangeParamKey2;
}(SortAndFiltersRangeParamKey || {});
var getDestination = function(param) {
    var destination4 = param.destination, regionId = param.regionId, latLong = param.latLong, selected = param.selected, mapBounds = param.mapBounds;
    var _ref = _sliced_to_array((latLong === null || latLong === void 0 ? void 0 : latLong.split(",").map(function(value) {
        return parseFloat(value);
    })) || [
        null,
        null
    ], 2), latitude = _ref[0], longitude = _ref[1];
    return _object_spread({
        regionName: destination4,
        regionId: regionId,
        coordinates: latitude && longitude ? {
            latitude: latitude,
            longitude: longitude
        } : null,
        mapBounds: mapBounds
    }, selected && {
        pinnedPropertyId: selected
    });
};
var getDate2 = function(date) {
    var _date_split = _sliced_to_array(date.split("-"), 3), year = _date_split[0], month = _date_split[1], day = _date_split[2];
    return {
        year: parseInt(year, 10),
        month: parseInt(month, 10),
        day: parseInt(day, 10)
    };
};
var formatDateInVariant = function(date) {
    var _date_split = _sliced_to_array(date.split("/"), 3), month = _date_split[0], day = _date_split[1], year = _date_split[2];
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var getDateRange = function(param) {
    var startDate5 = param.startDate, endDate5 = param.endDate;
    if (!startDate5 || !endDate5) {
        return null;
    }
    var defaultFormat = /^\d{4}-\d{2}-\d{2}$/;
    var formatVariant = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    var isStartDateValid = defaultFormat.test(startDate5) || formatVariant.test(startDate5);
    var isEndDateValid = defaultFormat.test(endDate5) || formatVariant.test(endDate5);
    if (!isStartDateValid || !isEndDateValid) {
        return null;
    }
    var formattedStartDate = defaultFormat.test(startDate5) ? startDate5 : formatDateInVariant(startDate5);
    var formattedEndDate = defaultFormat.test(endDate5) ? endDate5 : formatDateInVariant(endDate5);
    return {
        checkInDate: getDate2(formattedStartDate),
        checkOutDate: getDate2(formattedEndDate)
    };
};
var getPriceRange = function(param) {
    var queryParams = param.queryParams;
    var range = [];
    Object.values(SortAndFiltersRangeParamKey).forEach(function(i) {
        var price = queryParams.getAll(i);
        var updatedPrice = price.length === 1 ? price[0].split(",") : price;
        var pricesArr = updatedPrice.filter(function(value) {
            return value.length !== 0;
        }).map(Number).filter(function(value) {
            return !Number.isNaN(value);
        });
        if (pricesArr.length > 1) {
            var _Math, _Math1;
            range.push({
                id: i,
                min: (_Math = Math).min.apply(_Math, _to_consumable_array(pricesArr)),
                max: (_Math1 = Math).max.apply(_Math1, _to_consumable_array(pricesArr))
            });
        }
    });
    return range;
};
var getRooms = function(param) {
    var adultsValue = param.adults, children = param.children;
    var adults = (adultsValue === null || adultsValue === void 0 ? void 0 : adultsValue.split(",").map(function(count) {
        return parseInt(count, 10);
    })) || [];
    var childrenRoomsAndAges = (children === null || children === void 0 ? void 0 : children.split(",")) || [];
    return adults.map(function(count, index) {
        var roomNumber = index + 1;
        var childrenAgePosition = 1;
        return {
            adults: count,
            children: childrenRoomsAndAges.filter(function(roomAndAge) {
                return roomAndAge.startsWith(roomNumber.toString());
            }).map(function(value) {
                return {
                    age: parseInt(value.split("_")[childrenAgePosition], 10)
                };
            })
        };
    }).filter(function(room) {
        return !Number.isNaN(room.adults);
    });
};
var addSelectionIfIDNotPresent = function(selections2, newSelection) {
    return selections2.some(function(selection) {
        return selection.id === newSelection.id;
    }) ? selections2 : _to_consumable_array(selections2).concat([
        newSelection
    ]);
};
var getSelections = function(param) {
    var queryParams = param.queryParams, paramsToExclude = param.paramsToExclude, isPartnerPointsToggleEnabled = param.isPartnerPointsToggleEnabled;
    var selections2 = Object.values(SortAndFiltersParamsKeys).reduce(function(prev, element) {
        if (!isPartnerPointsToggleEnabled && queryParams.has("useRewards" /* USE_REWARDS */ )) {
            queryParams.delete("useRewards" /* USE_REWARDS */ );
        }
        var values = queryParams.getAll(element);
        if (values.length && values[0] !== "") {
            var selection = values.map(function(value) {
                var newValue = paramsToExclude.includes(element) ? [
                    value
                ] : value.split(",");
                return newValue.map(function(splitValue) {
                    if (isPartnerPointsToggleEnabled && element === "useRewards" /* USE_REWARDS */ ) {
                        return {
                            id: element,
                            value: splitValue === "true" ? "SHOP_WITH_POINTS" /* SHOP_WITH_POINTS */  : "SHOP_WITHOUT_POINTS" /* SHOP_WITHOUT_POINTS */ 
                        };
                    }
                    return {
                        id: element,
                        value: splitValue
                    };
                });
            });
            return _to_consumable_array(prev).concat(_to_consumable_array(selection));
        }
        return _to_consumable_array(prev);
    }, []).flat();
    return addSelectionIfIDNotPresent(selections2, {
        id: "sort" /* SORT */ ,
        value: "RECOMMENDED"
    });
};
var getFlexibility = function(queryParams) {
    var flexibilityParams = queryParams.getAll("flexibility" /* FLEXIBILITY */ );
    if (flexibilityParams.length === 0) {
        return null;
    }
    return flexibilityParams.reduce(function(acc, param) {
        var params = param.split("_");
        if (params.length > 1) {
            var length = parseInt(params[0], 10);
            var unit = DatePeriodUnit[params[1].toUpperCase()];
            var bound = params.length === 3 ? {
                bound: ClosedPeriodBounding[params[2].toUpperCase()]
            } : {};
            if (length && unit) {
                acc.push(_object_spread({
                    length: length,
                    unit: unit
                }, bound));
            }
        }
        return acc;
    }, []);
};
var getSearchRange = function(queryParams) {
    var searchRangeParams = queryParams.getAll("searchRange" /* SEARCH_RANGE */ );
    return searchRangeParams.reduce(function(acc, param) {
        var params = param.split("_");
        if (params.length === 2) {
            acc.push({
                start: getDate2(params[0]),
                end: getDate2(params[1])
            });
        }
        return acc;
    }, []);
};
var getFlexibleSearchRequirement = function(queryParams) {
    return queryParams.getAll("flexibleSearchRequirement" /* FLEXIBLE_SEARCH_REQUIREMENT */ ).filter(function(param) {
        return param;
    });
};
var getFlexibleCriteria = function(queryParams) {
    var flexibility = getFlexibility(queryParams);
    var searchRange = getSearchRange(queryParams);
    var flexibleSearchRequirement = getFlexibleSearchRequirement(queryParams);
    var result = _object_spread({}, (flexibility === null || flexibility === void 0 ? void 0 : flexibility.length) && {
        flexibility: flexibility
    }, (searchRange === null || searchRange === void 0 ? void 0 : searchRange.length) && {
        searchRange: searchRange
    }, (flexibleSearchRequirement === null || flexibleSearchRequirement === void 0 ? void 0 : flexibleSearchRequirement.length) && {
        flexibleSearchRequirement: flexibleSearchRequirement
    });
    return Object.getOwnPropertyNames(result).length ? result : null;
};
var getMapBounds = function(mapBounds) {
    var resolvedBounds = mapBounds.map(function(bounds) {
        return bounds.split(",");
    }).filter(function(param) {
        var _param = _sliced_to_array(param, 2), latitude = _param[0], longitude = _param[1];
        return latitude !== "" && longitude !== "";
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), latitude = _param[0], longitude = _param[1];
        return {
            latitude: Number(latitude),
            longitude: Number(longitude)
        };
    });
    return resolvedBounds.length === 2 ? resolvedBounds : [];
};
var URL_BOOLEAN_PARAM_MAPPER = [
    {
        URL_PARAM_ID: "packageRates" /* PACKAGE_RATES */ ,
        QUERY_BOOLEAN_ID: "showPackageRates"
    },
    {
        URL_PARAM_ID: "vacationRentalsOnly" /* VACATION_RENTALS_ONLY */ ,
        QUERY_BOOLEAN_ID: "showVacationRentalsOnly"
    },
    {
        URL_PARAM_ID: "dateSelectedByUser" /* DATE_SELECTED_BY_USER */ ,
        QUERY_BOOLEAN_ID: "isUserSelectedDates"
    }
];
var getBooleans = function(queryParams) {
    return URL_BOOLEAN_PARAM_MAPPER.flatMap(function(id) {
        return queryParams.get(id.URL_PARAM_ID) === "true" ? [
            {
                id: id.QUERY_BOOLEAN_ID,
                value: true
            }
        ] : [];
    });
};
var getPropertySearchCriteriaFromQueryParams = function(queryParams, isPartnerPointsToggleEnabled) {
    var _flexibleSearchCriteria_searchRange;
    var destination4 = getDestination({
        destination: queryParams.get("destination" /* DESTINATION */ ),
        regionId: queryParams.get("regionId" /* REGION_ID */ ) === "null" ? null : queryParams.get("regionId" /* REGION_ID */ ),
        latLong: queryParams.get("latLong" /* LAT_LONG */ ),
        selected: queryParams.get("selected" /* SELECTED */ ),
        mapBounds: getMapBounds(queryParams.getAll("mapBounds" /* MAP_BOUNDS */ ))
    });
    var dateRange = getDateRange({
        startDate: queryParams.get("startDate" /* START_DATE */ ),
        endDate: queryParams.get("endDate" /* END_DATE */ )
    });
    var rooms = getRooms({
        adults: queryParams.get("adults" /* ADULTS */ ),
        children: queryParams.get("children" /* CHILDREN */ )
    });
    var rangesFilters = getPriceRange({
        queryParams: queryParams
    });
    var paramsToExclude = [
        "hotelName" /* HOTEL_NAME */ ,
        "poi" /* POI */ 
    ];
    var selectionsFilters = getSelections({
        queryParams: queryParams,
        paramsToExclude: paramsToExclude,
        isPartnerPointsToggleEnabled: isPartnerPointsToggleEnabled
    });
    var flexibleSearchCriteria = getFlexibleCriteria(queryParams);
    var flexSearchCriteria = flexibleSearchCriteria ? {
        flexSearchCriteria: flexibleSearchCriteria
    } : {};
    var booleanFilters = getBooleans(queryParams);
    return {
        propertySearchCriteriaInput: {
            primary: _object_spread({
                destination: destination4,
                rooms: rooms,
                dateRange: !(flexibleSearchCriteria === null || flexibleSearchCriteria === void 0 ? void 0 : flexibleSearchCriteria.searchRange) || (flexibleSearchCriteria === null || flexibleSearchCriteria === void 0 ? void 0 : (_flexibleSearchCriteria_searchRange = flexibleSearchCriteria.searchRange) === null || _flexibleSearchCriteria_searchRange === void 0 ? void 0 : _flexibleSearchCriteria_searchRange.length) === 0 ? dateRange : null
            }, flexSearchCriteria),
            secondary: {
                ranges: rangesFilters,
                selections: selectionsFilters,
                booleans: booleanFilters
            }
        }
    };
};
// src/components/lodging/utils/signals-map.ts
var SignalsMap = /* @__PURE__ */ function(SignalsMap2) {
    SignalsMap2["NEXT_PAGE"] = "SEARCH_FORM_NEXT_PAGE";
    SignalsMap2[SignalsMap2["LOCATION_FIELD_UPDATE"] = LOCATION_FIELD_UPDATE_SIGNAL_TYPE] = "LOCATION_FIELD_UPDATE";
    return SignalsMap2;
}(SignalsMap || {});
// src/components/lodging/form/__private/adaptex-tracking-success-fragment.tsx
import { gql as gql50 } from "@apollo/client";
// ../internal/src/components/common/uis-micro-message.ts
import { gql as gql49 } from "@apollo/client";
var egUisMicroMessageFragment = gql49(_templateObject53());
// src/components/lodging/form/__private/adaptex-tracking-success-fragment.tsx
var adaptexTrackingSuccessFragment = gql50(_templateObject54(), egUisMicroMessageFragment);
// src/components/lodging/form/__private/lodging-search-form.tsx
var fieldComponents = [
    EGDSSearchFormLocationField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormTravelersField,
    EGDSSearchFormButton,
    SoftPackages,
    SearchFormPopularFilters
];
var _fragment2 = gql51(_templateObject55(), EGDSErrorSummary.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment, EGDSSearchFormButton.fragment, EGDSSearchPlayback.fragment, SoftPackages.fragment, adaptexTrackingSuccessFragment, SearchLocationFragment, SearchFormPopularFilters.fragment);
var getLocationParameter = function() {
    if (typeof window !== "undefined") {
        return new URLSearchParams(window.location.search).get("destination" /* DESTINATION */ );
    }
    return "";
};
var LodgingSearchForm = function(props) {
    var _datePickerField_action, _softPackages_addFlight, _softPackages_addCar;
    var data = props.data, onOpenLocationField = props.onOpenLocationField, onFieldChange = props.onFieldChange, onSubmit = props.onSubmit, onTogglePlayback = props.onTogglePlayback, autoOpenCalendar = props.autoOpenCalendar, autoOpenPlayback = props.autoOpenPlayback, sticky = props.sticky, stickyPlayback = props.stickyPlayback, skipQuery = props.skipQuery, autoSubmitOnFieldChange = props.autoSubmitOnFieldChange, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, additionalQueryParams = props.additionalQueryParams, dateFieldInitialFocus = props.dateFieldInitialFocus, layout = props.layout, _props_includeFlexibleCalendarContent = props.includeFlexibleCalendarContent, includeFlexibleCalendarContent = _props_includeFlexibleCalendarContent === void 0 ? false : _props_includeFlexibleCalendarContent, _props_includeFlexibleDatesContent = props.includeFlexibleDatesContent, includeFlexibleDatesContent = _props_includeFlexibleDatesContent === void 0 ? false : _props_includeFlexibleDatesContent, autoSubmitOnFieldChangeConfig = props.autoSubmitOnFieldChangeConfig, additionalAdapterFields = props.additionalAdapterFields, updateLatLongOnSelection = props.updateLatLongOnSelection, enableReflection = props.enableReflection, regionId = props.regionId, handleOnFlexibleTabSelection = props.handleOnFlexibleTabSelection, onOpenDatesField = props.onOpenDatesField;
    var localizationContext = useLocalization11();
    var _React73_useState = _sliced_to_array(React73.useState({
        EGDSSearchFormLocationField: null,
        EGDSSearchFormLocationFieldOrigin: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React73_useState[0], setFieldsRefs = _React73_useState[1];
    var initialErrorState2 = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var formRef = React73.useRef(null);
    var isSmallViewportSize = useMediaQueries4({
        viewSizes: defaultViewSizes4
    }) <= defaultViewSizes4.SMALL;
    var _React73_useState1 = _sliced_to_array(React73.useState(_object_spread({}, initialErrorState2)), 2), errorState = _React73_useState1[0], setErrorState = _React73_useState1[1];
    var egdsElementId = data.egdsElementId, elements = data.elements, search6 = data.search, actionURL = data.actionURL, errorSummary5 = data.errorSummary, playback = data.playback, initialSoftPackages = data.softPackages, adaptExSuccessEvent = data.adaptExSuccessEvent, searchLocation = data.searchLocation, popularFiltersData = data.popularFilters;
    var _React73_useState2 = _sliced_to_array(React73.useState(playback), 2), playbackData = _React73_useState2[0], setPlaybackData = _React73_useState2[1];
    var _React73_useState3 = _sliced_to_array(React73.useState(false), 2), showCategorizedResults = _React73_useState3[0], setShowCategorizedResults = _React73_useState3[1];
    var _React73_useState4 = _sliced_to_array(React73.useState(initialSoftPackages), 2), softPackages = _React73_useState4[0], setSoftPackages = _React73_useState4[1];
    var isPopularFiltersPlaybackEnabled = !!popularFiltersData;
    var _React73_useState5 = _sliced_to_array(React73.useState(isPopularFiltersPlaybackEnabled ? popularFiltersData.filters : []), 2), filters = _React73_useState5[0], setFilters = _React73_useState5[1];
    var _filters_length;
    var playbackPopularFilters = ((_filters_length = filters === null || filters === void 0 ? void 0 : filters.length) !== null && _filters_length !== void 0 ? _filters_length : 0) > 0;
    var locationField = elements.find(function(element) {
        return element.__typename === "EGDSSearchFormLocationField";
    });
    var locationFieldRegionId = (locationField === null || locationField === void 0 ? void 0 : locationField.__typename) === "EGDSSearchFormLocationField" ? locationField.regionId : "";
    var _React73_useState6 = _sliced_to_array(React73.useState(regionId && regionId !== "" ? regionId : locationFieldRegionId), 2), gaiaId = _React73_useState6[0], setGaiaId = _React73_useState6[1];
    var _React73_useState7 = _sliced_to_array(React73.useState(!autoOpenPlayback), 2), displayToggle = _React73_useState7[0], setDisplayToggle = _React73_useState7[1];
    var _useExperiment3 = useExperiment3("BEX_Group_by_Category_in_Typeahead_Lodging" /* BEX_Group_by_Category_in_Typeahead_Lodging */ ), groupByCategoryExposure = _useExperiment3.exposure, groupByCategoryLogger = _useExperiment3.logExperiment;
    var _useExperiment31 = useExperiment3("BEX_Auto_Completion_in_Typeahead_Lodging_Web" /* BEX_Auto_Completion_in_Typeahead_Lodging_Web */ ), autoCompleteExposure = _useExperiment31.exposure, autoCompleteLogger = _useExperiment31.logExperiment;
    var autoCompleteEnabled = autoCompleteExposure.bucket === 1;
    var _useExperiment32 = useExperiment3("Same_Day_Prefill_for_Current_Location_in_Typeahead_Lodging" /* Same_Day_Prefill_for_Current_Location_in_Typeahead_Lodging */ ), currentLocationSameDayExposure = _useExperiment32.exposure, currentLocationSameDayLogger = _useExperiment32.logExperiment;
    var _useExperiment33 = useExperiment3("Web_BEXG_Full_Detail_Recent_Search_Reformat_in_Typeahead_Lodging" /* Web_BEXG_Full_Detail_Recent_Search_Reformat_in_Typeahead_Lodging */ ), fullDetailRecentSearchReformatExposure = _useExperiment33.exposure, fullDetailRecentSearchReformatLogger = _useExperiment33.logExperiment;
    var _useExperiment34 = useExperiment3("Search_Form_Calendar_Size_Test" /* Search_Form_Calendar_Size_Test */ ), calendarSizeExposure = _useExperiment34.exposure, calendarSizeExperimentLogger = _useExperiment34.logExperiment;
    var _useExperiment35 = useExperiment3("Web_BEXG_Character_Bolding_in_Typeahead_Lodging" /* Web_BEXG_Character_Bolding_in_Typeahead_Lodging */ ), characterBoldinginTypeaheadLodgingExposure = _useExperiment35.exposure, characterBoldinginTypeaheadLodgingLogger = _useExperiment35.logExperiment;
    var popoverWidth = function() {
        switch(calendarSizeExposure.bucket){
            case 1:
                return 650;
            case 2:
                return 600;
            default:
                return void 0;
        }
    }();
    var propBoldingType = function() {
        switch(characterBoldinginTypeaheadLodgingExposure.bucket){
            case 1:
                return "match";
            case 2:
                return "non-match";
            default:
                return void 0;
        }
    }();
    var handleOpenDatesField = function() {
        calendarSizeExperimentLogger(calendarSizeExposure);
        onOpenDatesField === null || onOpenDatesField === void 0 ? void 0 : onOpenDatesField();
    };
    var isHistoryDetailFormatVariant = fullDetailRecentSearchReformatExposure.bucket === 1;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search-lodging-form";
    var fields = _to_consumable_array(elements).concat([
        popularFiltersData,
        softPackages,
        search6
    ]).filter(function(field) {
        return field !== null && field !== void 0;
    });
    var clickTracker = useClickTracker22();
    var track = useClickstreamAnalytics().track;
    var publishSignal = useSignalPublisher().publishSignal;
    React73.useEffect(function() {
        if (playback && !skipQuery) {
            setPlaybackData(playback);
        }
    }, [
        playback,
        skipQuery
    ]);
    var handlePlaybackToggle = function(open) {
        setDisplayToggle(open);
        onTogglePlayback === null || onTogglePlayback === void 0 ? void 0 : onTogglePlayback(!open);
    };
    useSignalSubscriber2({
        query: {
            type: "SEARCH_FORM_NEXT_PAGE" /* NEXT_PAGE */ 
        },
        onSignal: function() {
            if (adaptExSuccessEvent === null || adaptExSuccessEvent === void 0 ? void 0 : adaptExSuccessEvent.datePrefill) {
                track(ITrackType.EVENT, {
                    data: mapUisMicroMessage([
                        adaptExSuccessEvent.datePrefill
                    ])
                });
            }
        }
    });
    React73.useEffect(function() {
        if (dateFieldInitialFocus) {
            var _fieldsRefs_EGDSSearchFormDatePickerField_current, _fieldsRefs_EGDSSearchFormDatePickerField;
            (_fieldsRefs_EGDSSearchFormDatePickerField = fieldsRefs.EGDSSearchFormDatePickerField) === null || _fieldsRefs_EGDSSearchFormDatePickerField === void 0 ? void 0 : (_fieldsRefs_EGDSSearchFormDatePickerField_current = _fieldsRefs_EGDSSearchFormDatePickerField.current) === null || _fieldsRefs_EGDSSearchFormDatePickerField_current === void 0 ? void 0 : _fieldsRefs_EGDSSearchFormDatePickerField_current.focus();
        }
    }, [
        fieldsRefs.EGDSSearchFormDatePickerField
    ]);
    var setFieldRefByTypename = React73.useCallback(function(typename, ref) {
        var _ref_current;
        var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typenameRef, ref));
        });
    }, []);
    var datePickerField = elements.find(function(element) {
        return element.__typename === "EGDSSearchFormDatePickerField";
    });
    var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
    var maxNumberOfDaysSelected = (datePickerField === null || datePickerField === void 0 ? void 0 : datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
    var showCurrentLocation = currentLocationSameDayExposure.bucket === 1 && isSmallViewportSize;
    var onLocationFieldOpen = function() {
        if (onOpenLocationField) {
            onOpenLocationField();
        }
        try {
            fullDetailRecentSearchReformatLogger(fullDetailRecentSearchReformatExposure);
        } catch (e) {}
        if (isSmallViewportSize) {
            try {
                currentLocationSameDayLogger(currentLocationSameDayExposure);
            } catch (e) {}
        }
    };
    var handleOnType = function(term) {
        try {
            groupByCategoryLogger(groupByCategoryExposure);
            autoCompleteLogger(autoCompleteExposure);
            characterBoldinginTypeaheadLodgingLogger(characterBoldinginTypeaheadLodgingExposure);
        } catch (e) {}
        if (groupByCategoryExposure.bucket === 1 && term.length >= 1) {
            setShowCategorizedResults(true);
        } else {
            setShowCategorizedResults(false);
        }
    };
    var getUpdatedSecondaries = function(isDateRangePicker, isDateFieldWithFlexibility, isTravelerSelector, prevSecondaries, text) {
        var hasPrevDates = prevSecondaries.length > 1;
        var base = {
            __typename: "EGDSPlainText",
            accessibility: null,
            text: ""
        };
        if (hasPrevDates) {
            if (isDateRangePicker) {
                var dates = getFormattedDates(text, localizationContext);
                return [
                    _object_spread_props(_object_spread({}, base), {
                        text: dates
                    }),
                    prevSecondaries[1]
                ];
            }
            if (isTravelerSelector) {
                return [
                    prevSecondaries[0],
                    _object_spread_props(_object_spread({}, base), {
                        text: text
                    })
                ];
            }
            if (isDateFieldWithFlexibility) {
                return [
                    _object_spread_props(_object_spread({}, base), {
                        text: text
                    }),
                    prevSecondaries[1]
                ];
            }
        }
        if (isDateRangePicker) {
            var dates1 = getFormattedDates(text, localizationContext);
            return [
                _object_spread_props(_object_spread({}, base), {
                    text: dates1
                }),
                prevSecondaries[0]
            ];
        }
        if (isDateFieldWithFlexibility) {
            return [
                _object_spread_props(_object_spread({}, base), {
                    text: text
                }),
                prevSecondaries[0]
            ];
        }
        if (isTravelerSelector) {
            return [
                _object_spread_props(_object_spread({}, base), {
                    text: text
                })
            ];
        }
        return _to_consumable_array(prevSecondaries);
    };
    var handleFieldChange = function(field, event) {
        if (onFieldChange) {
            var _formRef_current;
            var formElements = formRef.current ? Array.from((_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.elements) : [];
            var queryParams = getSearchToolsQueryParams("LODGING" /* LODGING */ , formElements);
            onFieldChange(field, event, queryParams);
        }
        if (autoSubmitOnFieldChange) {
            var _formRef_current1;
            (_formRef_current1 = formRef.current) === null || _formRef_current1 === void 0 ? void 0 : _formRef_current1.dispatchEvent(new Event("submit", {
                cancelable: true,
                bubbles: true
            }));
        }
        if (field.name === "EGDSDateRangePicker" /* TRAVEL_DATES */  && (autoSubmitOnFieldChangeConfig === null || autoSubmitOnFieldChangeConfig === void 0 ? void 0 : autoSubmitOnFieldChangeConfig.onDateFieldChange) && !autoSubmitOnFieldChange) {
            var _formRef_current2;
            (_formRef_current2 = formRef.current) === null || _formRef_current2 === void 0 ? void 0 : _formRef_current2.dispatchEvent(new Event("submit", {
                cancelable: true,
                bubbles: true
            }));
        }
        setPlaybackData(function(prevPlaybackState) {
            var DESTINATION = FieldNameMap.DESTINATION, TRAVELER_ROOM_SELECTOR = FieldNameMap.TRAVELER_ROOM_SELECTOR, TRAVELER_BASIC_SELECTOR = FieldNameMap.TRAVELER_BASIC_SELECTOR, TRAVEL_DATES = FieldNameMap.TRAVEL_DATES, TRAVEL_DATES_FLEXIBLE = FieldNameMap.TRAVEL_DATES_FLEXIBLE;
            var name = field.name, text = field.value;
            var isDestination = name === DESTINATION;
            var isDateRangePicker = name === TRAVEL_DATES;
            var isDateFieldWithFlexibility = name === TRAVEL_DATES_FLEXIBLE;
            var isTravelerSelector = name === TRAVELER_ROOM_SELECTOR || name === TRAVELER_BASIC_SELECTOR;
            if (!prevPlaybackState) {
                return null;
            }
            if (!isDateRangePicker && !isTravelerSelector && !isDestination && !isDateFieldWithFlexibility) {
                return _object_spread({}, prevPlaybackState);
            }
            var prevSecondaries = prevPlaybackState.secondaries;
            var secondaries = getUpdatedSecondaries(isDateRangePicker, isDateFieldWithFlexibility, isTravelerSelector, prevSecondaries, text);
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                secondaries: secondaries
            });
        });
        setDisplayToggle(true);
    };
    var clearErrorState = function() {
        setErrorState(_object_spread({}, initialErrorState2));
    };
    var isSoftPackagesFlightSelected = (softPackages === null || softPackages === void 0 ? void 0 : (_softPackages_addFlight = softPackages.addFlight) === null || _softPackages_addFlight === void 0 ? void 0 : _softPackages_addFlight.__typename) === "EGDSBasicCheckBox" && softPackages.addFlight.state === "CHECKED" /* CHECKED */ ;
    var isSoftPackagesCarSelected = (softPackages === null || softPackages === void 0 ? void 0 : (_softPackages_addCar = softPackages.addCar) === null || _softPackages_addCar === void 0 ? void 0 : _softPackages_addCar.__typename) === "EGDSBasicCheckBox" && softPackages.addCar.state === "CHECKED" /* CHECKED */ ;
    var validateFormAndReturnResults = React73.useCallback(function(formElements) {
        var formElementsToValidate = {
            location: _object_spread_props(_object_spread({}, isSoftPackagesFlightSelected ? {
                origin: formElements.find(findFieldByNameAttribute("origin_select"))
            } : null), {
                destination: formElements.find(findFieldByNameAttribute("destination_form_field"))
            }),
            dates: {
                startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date_form_field")),
                endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date_form_field")),
                config: {
                    maxNumberOfDaysSelected: maxNumberOfDaysSelected
                }
            }
        };
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate, isSoftPackagesFlightSelected);
        var errorCount2 = fieldsWithErrors.length;
        var isFormValid = errorCount2 === 0;
        return {
            fieldsWithErrors: fieldsWithErrors,
            errorCount: errorCount2,
            isFormValid: isFormValid
        };
    }, [
        maxNumberOfDaysSelected,
        isSoftPackagesFlightSelected
    ]);
    var handleSubmit = function(event) {
        var _fieldsWithErrors_, _data_errorSummary;
        clearErrorState();
        var formElements = Array.from(event.currentTarget.elements);
        var _validateFormAndReturnResults = validateFormAndReturnResults(formElements), fieldsWithErrors = _validateFormAndReturnResults.fieldsWithErrors, errorCount2 = _validateFormAndReturnResults.errorCount, isFormValid = _validateFormAndReturnResults.isFormValid;
        if (fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename] && (data === null || data === void 0 ? void 0 : (_data_errorSummary = data.errorSummary) === null || _data_errorSummary === void 0 ? void 0 : _data_errorSummary.analytics)) {
            var referrerId = "".concat(data.errorSummary.analytics.referrerId, ".For.NoDestinationSubmit");
            clickTracker(referrerId, data.errorSummary.analytics.linkName);
        }
        if (!isFormValid) {
            var _fieldsWithErrors_1;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: errorCount2,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_1 = fieldsWithErrors[0]) === null || _fieldsWithErrors_1 === void 0 ? void 0 : _fieldsWithErrors_1.__typename]
            });
            event.preventDefault();
            return;
        }
        if (onSubmit || redirectToSearchResultOnSubmit) {
            var queryParams = getSearchToolsQueryParams("LODGING" /* LODGING */ , formElements);
            var newCriteria = getPropertySearchCriteriaFromQueryParams(new URLSearchParams(queryParams)) || void 0;
            if (onSubmit) {
                onSubmit(event, newCriteria);
            }
            if (redirectToSearchResultOnSubmit) {
                event.preventDefault();
                publishSignal({
                    payload: {},
                    type: "SEARCH_FORM_NEXT_PAGE" /* NEXT_PAGE */ 
                });
                window.location.href = "".concat(event.currentTarget.action).concat(queryParams).concat(additionalQueryParams ? "&".concat(additionalQueryParams) : "");
            }
        }
    };
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var showErrorSummary = errorSummary5 && displayErrorSummary;
    var handleProductSelect = function(event) {
        var _event_currentTarget = event.currentTarget, name = _event_currentTarget.name, checked = _event_currentTarget.checked;
        setSoftPackages(function(previous) {
            var _previous_addCar, _previous_addFlight;
            if ((previous === null || previous === void 0 ? void 0 : (_previous_addCar = previous.addCar) === null || _previous_addCar === void 0 ? void 0 : _previous_addCar.__typename) === "EGDSBasicCheckBox" && previous.addCar.name !== null && name.includes(previous.addCar.name)) {
                return _object_spread_props(_object_spread({}, previous), {
                    addCar: _object_spread_props(_object_spread({}, previous.addCar), {
                        state: checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
                    })
                });
            }
            if ((previous === null || previous === void 0 ? void 0 : (_previous_addFlight = previous.addFlight) === null || _previous_addFlight === void 0 ? void 0 : _previous_addFlight.__typename) === "EGDSBasicCheckBox" && previous.addFlight.name !== null && name.includes(previous.addFlight.name)) {
                return _object_spread_props(_object_spread({}, previous), {
                    addFlight: _object_spread_props(_object_spread({}, previous.addFlight), {
                        state: checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
                    })
                });
            }
            return previous;
        });
    };
    var getTravelersPlaybackText = function(travelersField2, selection) {
        var _travelersField2_action;
        if ((travelersField2 === null || travelersField2 === void 0 ? void 0 : (_travelersField2_action = travelersField2.action) === null || _travelersField2_action === void 0 ? void 0 : _travelersField2_action.__typename) === "EGDSOpenTravelerSelectorAction") {
            var _travelersField2_action_travelerSelector, _travelersField2_action1, _travelersField2_labelTemplate, _travelersField2_action_travelerSelector1, _travelersField2_action2, _travelersField2_labelTemplate1;
            if ((travelersField2 === null || travelersField2 === void 0 ? void 0 : (_travelersField2_action1 = travelersField2.action) === null || _travelersField2_action1 === void 0 ? void 0 : (_travelersField2_action_travelerSelector = _travelersField2_action1.travelerSelector) === null || _travelersField2_action_travelerSelector === void 0 ? void 0 : _travelersField2_action_travelerSelector.__typename) === "EGDSRoomsTravelerSelector" && (travelersField2 === null || travelersField2 === void 0 ? void 0 : (_travelersField2_labelTemplate = travelersField2.labelTemplate) === null || _travelersField2_labelTemplate === void 0 ? void 0 : _travelersField2_labelTemplate.__typename) === "EGDSCompositeLocalizedText") {
                var _selection_data_searchDetail, _selection_data, _selection_data_searchDetail1, _selection_data1;
                var _selection_data_searchDetail_roomCount;
                return formatCompositeText(travelersField2 === null || travelersField2 === void 0 ? void 0 : travelersField2.labelTemplate, (_selection_data_searchDetail_roomCount = selection === null || selection === void 0 ? void 0 : (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : (_selection_data_searchDetail = _selection_data.searchDetail) === null || _selection_data_searchDetail === void 0 ? void 0 : _selection_data_searchDetail.roomCount) !== null && _selection_data_searchDetail_roomCount !== void 0 ? _selection_data_searchDetail_roomCount : 0, selection === null || selection === void 0 ? void 0 : (_selection_data1 = selection.data) === null || _selection_data1 === void 0 ? void 0 : (_selection_data_searchDetail1 = _selection_data1.searchDetail) === null || _selection_data_searchDetail1 === void 0 ? void 0 : _selection_data_searchDetail1.totalTravelerCount);
            }
            if ((travelersField2 === null || travelersField2 === void 0 ? void 0 : (_travelersField2_action2 = travelersField2.action) === null || _travelersField2_action2 === void 0 ? void 0 : (_travelersField2_action_travelerSelector1 = _travelersField2_action2.travelerSelector) === null || _travelersField2_action_travelerSelector1 === void 0 ? void 0 : _travelersField2_action_travelerSelector1.__typename) === "EGDSBasicTravelerSelector" && (travelersField2 === null || travelersField2 === void 0 ? void 0 : (_travelersField2_labelTemplate1 = travelersField2.labelTemplate) === null || _travelersField2_labelTemplate1 === void 0 ? void 0 : _travelersField2_labelTemplate1.__typename) === "EGDSCardinalLocalizedText") {
                var _selection_data_searchDetail2, _selection_data2;
                return formatCardinalText2(travelersField2 === null || travelersField2 === void 0 ? void 0 : travelersField2.labelTemplate, selection === null || selection === void 0 ? void 0 : (_selection_data2 = selection.data) === null || _selection_data2 === void 0 ? void 0 : (_selection_data_searchDetail2 = _selection_data2.searchDetail) === null || _selection_data_searchDetail2 === void 0 ? void 0 : _selection_data_searchDetail2.totalTravelerCount);
            }
        }
        return null;
    };
    var adaptPlaybackSecondariesFromSearchDetail = function(selection, prevSecondaries) {
        var _selection_data_searchDetail, _selection_data, _selection_data_searchDetail1, _selection_data1, _selection_data_searchDetail2, _selection_data2, _selection_data_searchDetail3, _selection_data3;
        var base = {
            __typename: "EGDSPlainText",
            accessibility: null,
            text: ""
        };
        var travelersField2 = elements.find(function(element) {
            return element.__typename === "EGDSSearchFormTravelersField";
        });
        var formattedTravelers = getTravelersPlaybackText(travelersField2, selection);
        var fallbackDateText = prevSecondaries[0].__typename === "EGDSPlainText" ? prevSecondaries[0].text : "";
        return [
            _object_spread_props(_object_spread({}, base), {
                text: (selection === null || selection === void 0 ? void 0 : (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : (_selection_data_searchDetail = _selection_data.searchDetail) === null || _selection_data_searchDetail === void 0 ? void 0 : _selection_data_searchDetail.startDate) && (selection === null || selection === void 0 ? void 0 : (_selection_data1 = selection.data) === null || _selection_data1 === void 0 ? void 0 : (_selection_data_searchDetail1 = _selection_data1.searchDetail) === null || _selection_data_searchDetail1 === void 0 ? void 0 : _selection_data_searchDetail1.endDate) ? getFormattedDates("".concat(new Date(selection === null || selection === void 0 ? void 0 : (_selection_data2 = selection.data) === null || _selection_data2 === void 0 ? void 0 : (_selection_data_searchDetail2 = _selection_data2.searchDetail) === null || _selection_data_searchDetail2 === void 0 ? void 0 : _selection_data_searchDetail2.startDate).toISOString().split("T")[0], " - ").concat(new Date(selection === null || selection === void 0 ? void 0 : (_selection_data3 = selection.data) === null || _selection_data3 === void 0 ? void 0 : (_selection_data_searchDetail3 = _selection_data3.searchDetail) === null || _selection_data_searchDetail3 === void 0 ? void 0 : _selection_data_searchDetail3.endDate).toISOString().split("T")[0]), localizationContext) : fallbackDateText
            }),
            _object_spread_props(_object_spread({}, base), {
                text: formattedTravelers !== null && formattedTravelers !== void 0 ? formattedTravelers : ""
            })
        ];
    };
    var _additionalAdapterFields_lastSearchLatLong;
    var _React73_useState8 = _sliced_to_array(React73.useState((_additionalAdapterFields_lastSearchLatLong = additionalAdapterFields === null || additionalAdapterFields === void 0 ? void 0 : additionalAdapterFields.lastSearchLatLong) !== null && _additionalAdapterFields_lastSearchLatLong !== void 0 ? _additionalAdapterFields_lastSearchLatLong : ""), 2), lastSearchLatLong = _React73_useState8[0], setLastSearchLatLong = _React73_useState8[1];
    var adapterFields = _object_spread_props(_object_spread({}, additionalAdapterFields), {
        lastSearchLatLong: lastSearchLatLong
    });
    var handleOnSearchLocationClear = function() {
        setGaiaId("");
    };
    var updateGaiaId = function(selection) {
        var _selection_data, _selection_data1, _selection_data2, _selection_data3;
        var isSelectionHotelOrAirport = ((_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : _selection_data.type) === "AIRPORT" || ((_selection_data1 = selection.data) === null || _selection_data1 === void 0 ? void 0 : _selection_data1.type) === "HOTEL";
        setGaiaId((selection === null || selection === void 0 ? void 0 : (_selection_data2 = selection.data) === null || _selection_data2 === void 0 ? void 0 : _selection_data2.regionId) && !isSelectionHotelOrAirport ? selection === null || selection === void 0 ? void 0 : (_selection_data3 = selection.data) === null || _selection_data3 === void 0 ? void 0 : _selection_data3.regionId : "");
    };
    var handleOnTypeaheadSelection = function(selection) {
        var _selection_data_popularFilter, _selection_data;
        if (updateLatLongOnSelection) {
            var _selection_data_location, _selection_data1, _selection_data_location1, _selection_data2, _selection_data_location2, _selection_data3, _selection_data_location3, _selection_data4;
            setLastSearchLatLong((selection === null || selection === void 0 ? void 0 : (_selection_data1 = selection.data) === null || _selection_data1 === void 0 ? void 0 : (_selection_data_location = _selection_data1.location) === null || _selection_data_location === void 0 ? void 0 : _selection_data_location.lat) && (selection === null || selection === void 0 ? void 0 : (_selection_data2 = selection.data) === null || _selection_data2 === void 0 ? void 0 : (_selection_data_location1 = _selection_data2.location) === null || _selection_data_location1 === void 0 ? void 0 : _selection_data_location1.long) ? "".concat(selection === null || selection === void 0 ? void 0 : (_selection_data3 = selection.data) === null || _selection_data3 === void 0 ? void 0 : (_selection_data_location2 = _selection_data3.location) === null || _selection_data_location2 === void 0 ? void 0 : _selection_data_location2.lat, ",").concat(selection === null || selection === void 0 ? void 0 : (_selection_data4 = selection.data) === null || _selection_data4 === void 0 ? void 0 : (_selection_data_location3 = _selection_data4.location) === null || _selection_data_location3 === void 0 ? void 0 : _selection_data_location3.long) : "");
        }
        updateGaiaId(selection);
        setPlaybackData(function(prevPlaybackState) {
            var _selection_data;
            if (!prevPlaybackState) {
                return null;
            }
            var primary = prevPlaybackState.primary, secondaries = prevPlaybackState.secondaries;
            var newPrimary = _object_spread_props(_object_spread({}, primary), {
                text: selection.term
            });
            var newSecondaries = enableReflection && adapterFields.historyDetail && (selection === null || selection === void 0 ? void 0 : (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : _selection_data.searchDetail) ? adaptPlaybackSecondariesFromSearchDetail(selection, secondaries) : secondaries;
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary,
                secondaries: newSecondaries
            });
        });
        if (isPopularFiltersPlaybackEnabled && (selection === null || selection === void 0 ? void 0 : (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : (_selection_data_popularFilter = _selection_data.popularFilter) === null || _selection_data_popularFilter === void 0 ? void 0 : _selection_data_popularFilter.length) > 0) {
            var _popularFiltersData_template;
            var filter = selection.data.popularFilter[0];
            var accessibility = (_popularFiltersData_template = popularFiltersData.template) === null || _popularFiltersData_template === void 0 ? void 0 : _popularFiltersData_template.template.replace("${filterName}", filter.displayName);
            var filterValue = (filter === null || filter === void 0 ? void 0 : filter.legacyValue) || (filter === null || filter === void 0 ? void 0 : filter.externalId);
            var filterName = (filter === null || filter === void 0 ? void 0 : filter.legacyId) || (filter === null || filter === void 0 ? void 0 : filter.refinementGroupSet[1]) || "";
            var name = "EGDSSearchFormLocationField-PropertyFilter-".concat(filterName);
            var primary = filter === null || filter === void 0 ? void 0 : filter.displayName;
            var filterExternalId = filter === null || filter === void 0 ? void 0 : filter.externalId;
            var referrerId = "Web.Hotels.PopularFilter.Removed.".concat(selection === null || selection === void 0 ? void 0 : selection.term, "-").concat(filterExternalId);
            setFilters([
                {
                    __typename: "EGDSBasicRemovablePill",
                    accessibility: accessibility,
                    id: filterValue,
                    name: name,
                    primary: primary,
                    value: filterValue,
                    removeAnalytics: {
                        __typename: "ClientSideAnalytics",
                        linkName: "Filter removed",
                        referrerId: referrerId
                    }
                }
            ]);
        } else {
            setFilters([]);
        }
    };
    var isSoftPackages = isSoftPackagesCarSelected || isSoftPackagesFlightSelected;
    var action = isSoftPackages && softPackages.actionURL ? softPackages.actionURL : actionURL;
    var handleRemovePillClick = function(payload) {
        var _payload_id;
        var pillToRemoveId = (_payload_id = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _payload_id !== void 0 ? _payload_id : "";
        setFilters(function(prev) {
            var _prev_filter;
            return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(filter) {
                return filter.id !== pillToRemoveId;
            })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
        });
    };
    var includePopularFiltersAndSoftPackagesContent = popularFiltersData && playbackPopularFilters;
    var popularFiltersAndSoftPackagesContent = (includePopularFiltersAndSoftPackagesContent || softPackages) && /* @__PURE__ */ React73.createElement(UitkLayoutFlex13, {
        space: "three",
        direction: layout === "IN_LINE" /* IN_LINE */  ? "row" : "column"
    }, includePopularFiltersAndSoftPackagesContent && /* @__PURE__ */ React73.createElement(UitkLayoutFlexItem12, {
        grow: 0
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(SearchFormPopularFilters, {
        data: _object_spread_props(_object_spread({}, popularFiltersData), {
            filters: filters
        }),
        onRemovePillClick: handleRemovePillClick
    }))), softPackages && /* @__PURE__ */ React73.createElement(UitkLayoutFlexItem12, {
        grow: 1
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(SoftPackages, {
        data: softPackages,
        onProductSelect: handleProductSelect,
        setFieldRefByTypename: setFieldRefByTypename,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormLocationFieldOrigin";
        })
    }))));
    var getSearchFormColumns = function(viewSize) {
        return viewSize === ViewSizes3.SMALL || layout === "STACKED" /* STACKED */  ? [
            "1fr"
        ] : [
            Repeat2(3, "1fr"),
            "max-content"
        ];
    };
    var getStackedRows = function() {
        var rows = [
            Repeat2(3, "max-content")
        ];
        if (playbackPopularFilters || softPackages) {
            rows.splice(3, 0, FitContent("1x"));
        }
        return rows;
    };
    var popularFiltersAndSoftPackagesArea = "PopularFiltersAndSoftPackagesArea";
    var getStackedAreas = function() {
        var areas = [
            "EGDSSearchFormLocationField",
            "EGDSSearchFormDatePickerField",
            "EGDSSearchFormTravelersField",
            "EGDSSearchFormButton"
        ];
        if (playbackPopularFilters || softPackages) {
            areas.splice(3, 0, popularFiltersAndSoftPackagesArea);
        }
        return areas;
    };
    var getInLineViewRows = function() {
        var rows = [
            "1fr"
        ];
        if (playbackPopularFilters || softPackages) {
            return _to_consumable_array(rows).concat([
                FitContent("1x")
            ]);
        }
        return rows;
    };
    var getInLineViewAreas = function() {
        var areas = [
            "EGDSSearchFormLocationField EGDSSearchFormDatePickerField EGDSSearchFormTravelersField EGDSSearchFormButton"
        ];
        if (playbackPopularFilters || softPackages) {
            return _to_consumable_array(areas).concat([
                "".concat(popularFiltersAndSoftPackagesArea, " ").concat(popularFiltersAndSoftPackagesArea, " ").concat(popularFiltersAndSoftPackagesArea, " ").concat(popularFiltersAndSoftPackagesArea)
            ]);
        }
        return areas;
    };
    var getSearchForm = function(viewSize) {
        var columns = getSearchFormColumns(viewSize);
        var rows = viewSize === ViewSizes3.SMALL || layout === "STACKED" /* STACKED */  ? getStackedRows() : getInLineViewRows();
        var areas = viewSize === ViewSizes3.SMALL || layout === "STACKED" /* STACKED */  ? getStackedAreas() : getInLineViewAreas();
        var isCurrentLocationEnable = function() {
            var _location_action;
            var location = _to_consumable_array(fields).find(function(element) {
                return element.__typename === "EGDSSearchFormLocationField";
            });
            if ((location === null || location === void 0 ? void 0 : location.__typename) === "EGDSSearchFormLocationField" && (location === null || location === void 0 ? void 0 : (_location_action = location.action) === null || _location_action === void 0 ? void 0 : _location_action.__typename) === "OpenTypeaheadAction") {
                var _location_action_info_showCurrentLocation;
                return (_location_action_info_showCurrentLocation = location === null || location === void 0 ? void 0 : location.action.info.showCurrentLocation) !== null && _location_action_info_showCurrentLocation !== void 0 ? _location_action_info_showCurrentLocation : false;
            }
            return false;
        };
        var locationQueryParameter = getLocationParameter();
        return /* @__PURE__ */ React73.createElement(UitkLayoutGrid3, {
            columns: columns,
            rows: rows,
            space: "three",
            areas: areas
        }, fields.map(function(element, index) {
            var __typename = element.__typename;
            var FieldComponent = fieldComponents.find(function(param) {
                var displayName = param.displayName;
                return displayName === __typename;
            });
            if (!FieldComponent) {
                return null;
            }
            var fieldError = errorState.fieldsWithErrors.find(function(field) {
                var isSoftPackagesAndOriginFieldHasError = __typename === "SoftPackages" && field.__typename === "EGDSSearchFormLocationFieldOrigin";
                return field.__typename === __typename || isSoftPackagesAndOriginFieldHasError;
            });
            var valueFromQueryParam = isCurrentLocationEnable() && locationQueryParameter ? locationQueryParameter : "";
            var fieldProps = _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, props), {
                additionalAdapterFields: adapterFields,
                setFieldRefByTypename: setFieldRefByTypename,
                fieldError: fieldError,
                autoOpen: autoOpenCalendar,
                onClearLocation: handleOnSearchLocationClear,
                onProductSelect: handleProductSelect,
                onType: handleOnType,
                valueFromQueryParam: valueFromQueryParam,
                onSelection: handleOnTypeaheadSelection,
                flexibleContentConfig: {
                    includeFlexibleCalendarContent: includeFlexibleCalendarContent,
                    includeFlexibleDatesContent: includeFlexibleDatesContent
                },
                popoverWidth: popoverWidth,
                onOpenDatesField: handleOpenDatesField
            }), isSoftPackages ? softPackages : {}), {
                showCurrentLocation: showCurrentLocation !== null && showCurrentLocation !== void 0 ? showCurrentLocation : false,
                onOpenLocationField: onLocationFieldOpen,
                categorizeResults: showCategorizedResults,
                searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics,
                isPopularFiltersPlaybackEnabled: isPopularFiltersPlaybackEnabled,
                enablePredictiveText: autoCompleteEnabled,
                isHistoryDetailFormatVariant: isHistoryDetailFormatVariant,
                gaiaId: gaiaId,
                onFlexibleTabSelection: handleOnFlexibleTabSelection,
                boldingType: propBoldingType
            });
            var setContentForPopularFiltersAndSoftPackages = __typename === "SoftPackages" || __typename === "SearchFormPopularFilters" && !softPackages;
            var content = setContentForPopularFiltersAndSoftPackages ? popularFiltersAndSoftPackagesContent : /* @__PURE__ */ React73.createElement(FieldComponent, _object_spread_props(_object_spread({}, fieldProps), {
                data: element
            }));
            var area = setContentForPopularFiltersAndSoftPackages ? popularFiltersAndSoftPackagesArea : __typename;
            if (area === "SearchFormPopularFilters") {
                return null;
            }
            return /* @__PURE__ */ React73.createElement(UitkLayoutGridItem3, {
                area: area,
                key: "field_".concat(area, "_").concat(index)
            }, /* @__PURE__ */ React73.createElement(UitkLayoutGrid3, {
                autoRows: [
                    "max-content"
                ]
            }, content));
        }));
    };
    return /* @__PURE__ */ React73.createElement(UitkForm3, {
        ref: formRef,
        id: id,
        name: id,
        method: "GET",
        action: action,
        onFieldChange: handleFieldChange,
        onSubmit: handleSubmit,
        hasRequiredFieldIndicator: true
    }, showErrorSummary && /* @__PURE__ */ React73.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }), /* @__PURE__ */ React73.createElement(UitkSpacing22, {
        margin: {
            blockstart: showErrorSummary ? "two" : void 0
        }
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(Viewport12, null, /* @__PURE__ */ React73.createElement(ViewSmall10, null, playbackData ? /* @__PURE__ */ React73.createElement(EGDSSearchPlayback, {
        data: playbackData,
        stickyPlayback: stickyPlayback,
        display: displayToggle,
        onDisplayToggle: handlePlaybackToggle
    }, getSearchForm(ViewSizes3.SMALL)) : getSearchForm(ViewSizes3.SMALL)), /* @__PURE__ */ React73.createElement(ViewMedium9, null, sticky ? /* @__PURE__ */ React73.createElement(StickySearchForm, null, getSearchForm(ViewSizes3.MEDIUM)) : getSearchForm(ViewSizes3.MEDIUM)), /* @__PURE__ */ React73.createElement(ViewLarge7, null, sticky ? /* @__PURE__ */ React73.createElement(StickySearchForm, null, getSearchForm(ViewSizes3.LARGE)) : getSearchForm(ViewSizes3.LARGE))))));
};
LodgingSearchForm.fragment = _fragment2;
LodgingSearchForm.displayName = "LodgingSearchForm";
// src/components/lodging/form/client-events.ts
import { SystemEvent as SystemEvent3, SystemEventLevel as SystemEventLevel3 } from "@shared-ui/logger-context";
var CLIENT_EVENTS = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_LODGING_SEARCH_FORM_QUERY_FAILURE: new SystemEvent3(SystemEventLevel3.ERROR, "SEARCH_TOOLS_LODGING_SEARCH_FORM_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_LODGING_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Lodging Search Form Fallback Presented",
        referrerId: "Web.Lodging.Search.Form.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_LODGING_SEARCH_FORM_IMPRESSION: {
        linkName: "Lodging Search Form Presented",
        referrerId: "Web.Hotels.Search.Form.Presented"
    }
};
// src/components/lodging/form/search-form.tsx
var __Query = gql52(_templateObject56(), LodgingSearchForm.fragment);
var LodgingSearchFormFeatures = /* @__PURE__ */ function(LodgingSearchFormFeatures2) {
    LodgingSearchFormFeatures2["PREFILL_PROPERTY_NAME"] = "PREFILL_PROPERTY_NAME";
    LodgingSearchFormFeatures2["ADDITIONAL_FLEX_NIGHTS_OPTIONS"] = "ADDITIONAL_FLEX_NIGHTS_OPTIONS";
    return LodgingSearchFormFeatures2;
}(LodgingSearchFormFeatures || {});
var LodgingSearchForm2 = function(props) {
    var _inputs_propertySearchCriteriaInput, _inputs_propertySearchCriteriaInput_primary_destination, _inputs_propertySearchCriteriaInput_primary, _inputs_propertySearchCriteriaInput1, _secondary_selections_find, _secondary_selections, _secondary_selections_find1, _secondary_selections1, _secondary_selections_find2, _secondary_selections2, _secondary_selections_find3, _secondary_selections3, _inputs_propertySearchCriteriaInput2;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, fetchPolicy = props.fetchPolicy, batchKey = props.batchKey, features = props.features, includePlayback = props.includePlayback, _props_layout = props.layout, layout = _props_layout === void 0 ? "IN_LINE" /* IN_LINE */  : _props_layout, enableReflection = props.enableReflection;
    var context = useBexApi5().context;
    var systemEvents = useLoggerEvents2(CLIENT_EVENTS);
    var _React74_useState = _sliced_to_array(React74.useState(skipQuery), 2), skip = _React74_useState[0], setSkip = _React74_useState[1];
    var _useExperiment4 = useExperiment4("Flex_Dates_M2_with_1_month_duration_on_Vrbo" /* Flex_Dates_M2_with_1_month_duration_on_Vrbo */ ), oneMonthNightDurationVrboFlex = _useExperiment4.exposure, logExperiment = _useExperiment4.logExperiment;
    var incomingFeatures = features ? _to_consumable_array(features) : [];
    var localFeatures = oneMonthNightDurationVrboFlex.bucket === 1 ? _to_consumable_array(incomingFeatures).concat([
        "ADDITIONAL_FLEX_NIGHTS_OPTIONS" /* ADDITIONAL_FLEX_NIGHTS_OPTIONS */ 
    ]) : _to_consumable_array(incomingFeatures);
    var finalFeatures = localFeatures.length > 0 ? localFeatures : void 0;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: !!includePlayback,
        features: finalFeatures
    });
    var _useQuery = useQuery(__Query, _object_spread({
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skip
    }, fetchPolicy ? {
        fetchPolicy: fetchPolicy
    } : {})), currentData = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, previousData = _useQuery.previousData;
    var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
    React74.useEffect(function() {
        setSkip(skipQuery && !loading);
    }, [
        loading,
        skipQuery
    ]);
    if (loading && !data) {
        return /* @__PURE__ */ React74.createElement(Viewport13, null, /* @__PURE__ */ React74.createElement(ViewSmall11, null, /* @__PURE__ */ React74.createElement(FormSkeleton, {
            rows: [
                {
                    type: "primary"
                },
                {
                    type: "primary"
                },
                {
                    type: "primary"
                }
            ]
        })), /* @__PURE__ */ React74.createElement(ViewMedium10, null, /* @__PURE__ */ React74.createElement(FormSkeleton, {
            rows: [
                {
                    type: "primary"
                }
            ]
        })));
    }
    var secondary = (_inputs_propertySearchCriteriaInput = inputs.propertySearchCriteriaInput) === null || _inputs_propertySearchCriteriaInput === void 0 ? void 0 : _inputs_propertySearchCriteriaInput.secondary;
    var _inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId;
    var pinnedPropertyId = (_inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId = (_inputs_propertySearchCriteriaInput1 = inputs.propertySearchCriteriaInput) === null || _inputs_propertySearchCriteriaInput1 === void 0 ? void 0 : (_inputs_propertySearchCriteriaInput_primary = _inputs_propertySearchCriteriaInput1.primary) === null || _inputs_propertySearchCriteriaInput_primary === void 0 ? void 0 : (_inputs_propertySearchCriteriaInput_primary_destination = _inputs_propertySearchCriteriaInput_primary.destination) === null || _inputs_propertySearchCriteriaInput_primary_destination === void 0 ? void 0 : _inputs_propertySearchCriteriaInput_primary_destination.pinnedPropertyId) !== null && _inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId !== void 0 ? _inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId : void 0;
    var propertyRefinements = secondary ? {
        amenitiesFacilitiesGroup: secondary === null || secondary === void 0 ? void 0 : (_secondary_selections = secondary.selections) === null || _secondary_selections === void 0 ? void 0 : (_secondary_selections_find = _secondary_selections.find(function(i) {
            return i.id === "amenities_facilities_group";
        })) === null || _secondary_selections_find === void 0 ? void 0 : _secondary_selections_find.value,
        locationGroup: secondary === null || secondary === void 0 ? void 0 : (_secondary_selections1 = secondary.selections) === null || _secondary_selections1 === void 0 ? void 0 : (_secondary_selections_find1 = _secondary_selections1.find(function(i) {
            return i.id === "location_group";
        })) === null || _secondary_selections_find1 === void 0 ? void 0 : _secondary_selections_find1.value,
        propertiesGoodForGroup: secondary === null || secondary === void 0 ? void 0 : (_secondary_selections2 = secondary.selections) === null || _secondary_selections2 === void 0 ? void 0 : (_secondary_selections_find2 = _secondary_selections2.find(function(i) {
            return i.id === "properties_good_for_group";
        })) === null || _secondary_selections_find2 === void 0 ? void 0 : _secondary_selections_find2.value,
        propertyTypeGroup: secondary === null || secondary === void 0 ? void 0 : (_secondary_selections3 = secondary.selections) === null || _secondary_selections3 === void 0 ? void 0 : (_secondary_selections_find3 = _secondary_selections3.find(function(i) {
            return i.id === "property_type_group";
        })) === null || _secondary_selections_find3 === void 0 ? void 0 : _secondary_selections_find3.value
    } : void 0;
    var handleOnFlexibleTabSelection = function() {
        logExperiment(oneMonthNightDurationVrboFlex);
    };
    var _inputs_propertySearchCriteriaInput_primary_destination_regionId;
    var lodgingSearchFormProps = _object_spread_props(_object_spread({}, props), {
        regionId: (_inputs_propertySearchCriteriaInput_primary_destination_regionId = (_inputs_propertySearchCriteriaInput2 = inputs.propertySearchCriteriaInput) === null || _inputs_propertySearchCriteriaInput2 === void 0 ? void 0 : _inputs_propertySearchCriteriaInput2.primary.destination.regionId) !== null && _inputs_propertySearchCriteriaInput_primary_destination_regionId !== void 0 ? _inputs_propertySearchCriteriaInput_primary_destination_regionId : "",
        handleOnFlexibleTabSelection: handleOnFlexibleTabSelection,
        propertyRefinements: propertyRefinements,
        pinnedPropertyId: (features === null || features === void 0 ? void 0 : features.includes("PREFILL_PROPERTY_NAME" /* PREFILL_PROPERTY_NAME */ )) ? pinnedPropertyId : void 0,
        skipQuery: skip,
        layout: layout
    });
    if (error || !data || data.searchForm.lodging.__typename !== "LodgingSearchForm") {
        var fallback = getFallbackFormData();
        systemEvents.SEARCH_TOOLS_LODGING_SEARCH_FORM_QUERY_FAILURE.log({
            name: error === null || error === void 0 ? void 0 : error.name,
            error: new Error(error === null || error === void 0 ? void 0 : error.message)
        });
        return /* @__PURE__ */ React74.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React74.createElement(IntersectionTracker3, _object_spread({}, CLIENT_TRACKING_EVENTS.SEARCH_TOOLS_LODGING_SEARCH_FORM_FALLBACK_IMPRESSION), enableReflection ? /* @__PURE__ */ React74.createElement(SearchFormReflectionProvider, null, /* @__PURE__ */ React74.createElement(LodgingSearchForm, _object_spread_props(_object_spread({}, lodgingSearchFormProps), {
            data: fallback
        }))) : /* @__PURE__ */ React74.createElement(LodgingSearchForm, _object_spread_props(_object_spread({}, lodgingSearchFormProps), {
            data: fallback
        }))));
    }
    return /* @__PURE__ */ React74.createElement(IntersectionTracker3, _object_spread({}, CLIENT_TRACKING_EVENTS.SEARCH_TOOLS_LODGING_SEARCH_FORM_IMPRESSION), enableReflection ? /* @__PURE__ */ React74.createElement(SearchFormReflectionProvider, null, /* @__PURE__ */ React74.createElement(LodgingSearchForm, _object_spread_props(_object_spread({}, lodgingSearchFormProps), {
        data: data.searchForm.lodging,
        skipQuery: skip
    }))) : /* @__PURE__ */ React74.createElement(LodgingSearchForm, _object_spread_props(_object_spread({}, lodgingSearchFormProps), {
        data: data.searchForm.lodging,
        skipQuery: skip
    })));
};
LodgingSearchForm2.displayName = "sharedui-LodgingSearchForm";
// src/components/lodging/providers/lodging-query-params-provider.tsx
import React75 from "react";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
var LodgingQueryParamsContext = React75.createContext(null);
var LodgingQueryParamsProvider = function(param) {
    var children = param.children, urlSearchParams = param.urlSearchParams;
    var exposure = useExperiment5("ETS_POINTS_TOGGLE").exposure;
    var inputs = getPropertySearchCriteriaFromQueryParams(urlSearchParams, exposure.bucket === 1);
    return /* @__PURE__ */ React75.createElement(LodgingQueryParamsContext.Provider, {
        value: inputs
    }, children);
};
var useLodgingURLParamsToQueryInputs = function() {
    return React75.useContext(LodgingQueryParamsContext);
};
// src/components/multi-item/form/multi-item-search-form.tsx
import React91 from "react";
import { SearchFormReflectionProvider as SearchFormReflectionProvider2 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewMedium as ViewMedium17, Viewport as Viewport20, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
// src/components/multi-item/form/package-options.tsx
import React79 from "react";
import { gql as gql56, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field.tsx
import React77 from "react";
import { gql as gql54 } from "@apollo/client";
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field-with-selection.tsx
import React76 from "react";
import { gql as gql53 } from "@apollo/client";
import { PositionType as PositionType3, UitkMenu as UitkMenu3, UitkMenuContainer as UitkMenuContainer3, UitkMenuList, UitkMenuTrigger as UitkMenuTrigger3 } from "@egds/react-core/menu";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback8 } from "uitk-react-form";
import { UitkSelect as UitkSelect2 } from "uitk-react-input";
import { UitkPill as UitkPill3 } from "uitk-react-pill";
var __Fragment38 = gql53(_templateObject57());
var DISPLAY_NAME11 = "EGDSSearchFormInputFieldWithSelection";
var INPUT_FIELD__WITH_SELECTION_PREFIX = "".concat(DISPLAY_NAME11);
var EGDSSearchFormInputFieldWithSelection = function(param) {
    var data = param.data, trigger = param.trigger, triggerType = param.triggerType;
    var egdsElementId = trigger.egdsElementId, leftIcon = trigger.leftIcon, label = trigger.label;
    var analytics = data.analytics, options = data.options;
    var track = useClickTracker23();
    var _React76_useState = _sliced_to_array(React76.useState(false), 2), isOpen = _React76_useState[0], displayToggle = _React76_useState[1];
    var _React76_useState1 = _sliced_to_array(React76.useState(options.findIndex(function(option) {
        return option.selected;
    })), 2), selectedOptionIndex = _React76_useState1[0], setSelectedOptionIndex = _React76_useState1[1];
    var _options_find;
    var _ref = (_options_find = options.find(function(_, index) {
        return index === selectedOptionIndex;
    })) !== null && _options_find !== void 0 ? _options_find : trigger, currentDisplayValue = _ref.label, currentValue = _ref.value;
    var _React76_useState2 = _sliced_to_array(React76.useState(currentValue !== null && currentValue !== void 0 ? currentValue : ""), 2), selectValue = _React76_useState2[0], onSelectValueChange = _React76_useState2[1];
    var fakeInputRef = React76.createRef();
    var selectInputRef = React76.createRef();
    var pillButtonRef = React76.createRef();
    var defaultMenuItemAttributes = {
        attributes: {
            role: "menuitemradio",
            tabindex: 0
        },
        className: "uitk-list-item"
    };
    var INPUT_NAME = "".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-").concat(egdsElementId);
    var inputFieldWithSelectionFormCallback = useFormCallback8(INPUT_NAME, function(event) {
        return event;
    });
    var handleTriggerClick = React76.useCallback(function(isMenu) {
        if (isMenu) {
            displayToggle(function(prevState) {
                return !prevState;
            });
        }
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
    }, [
        analytics,
        track
    ]);
    var handleMenuDismiss = function() {
        displayToggle(false);
    };
    var handleSelectChange = useFormCallback8(INPUT_NAME, function(event) {
        onSelectValueChange(event.target.value);
        return event;
    });
    var handleMenuItemSelect = function(newIndex, event) {
        var _fakeInputRef_current, _pillButtonRef_current;
        setSelectedOptionIndex(newIndex);
        displayToggle(false);
        triggerInputChangeEvent(options[newIndex].value, inputFieldWithSelectionFormCallback);
        fakeInputRef === null || fakeInputRef === void 0 ? void 0 : (_fakeInputRef_current = fakeInputRef.current) === null || _fakeInputRef_current === void 0 ? void 0 : _fakeInputRef_current.focus();
        (_pillButtonRef_current = pillButtonRef.current) === null || _pillButtonRef_current === void 0 ? void 0 : _pillButtonRef_current.focus();
        event.preventDefault();
    };
    var menuItems = options.map(function(option, index) {
        var optionLabel = option.label, value = option.value;
        return _object_spread_props(_object_spread({}, defaultMenuItemAttributes), {
            label: optionLabel,
            id: value,
            onClick: function(event) {
                return handleMenuItemSelect(index, event);
            },
            selected: selectedOptionIndex === index
        });
    });
    var _leftIcon_id;
    var selectorTrigger = /* @__PURE__ */ React76.createElement(UitkSelect2, {
        name: INPUT_NAME,
        label: label !== null && label !== void 0 ? label : "",
        icon: (_leftIcon_id = leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id) !== null && _leftIcon_id !== void 0 ? _leftIcon_id : "",
        domRef: selectInputRef,
        onChange: handleSelectChange,
        "aria-label": label !== null && label !== void 0 ? label : ""
    }, options.map(function(param) {
        var optionLabel = param.label, value = param.value;
        return /* @__PURE__ */ React76.createElement("option", {
            key: value,
            label: optionLabel,
            value: value
        }, value);
    }));
    var _ref1;
    var pillTrigger = /* @__PURE__ */ React76.createElement(UitkPill3, {
        name: INPUT_NAME,
        id: egdsElementId,
        triggerPill: true,
        selected: true,
        toggleState: isOpen,
        onClick: function() {
            return handleTriggerClick(true);
        },
        domRef: pillButtonRef
    }, (_ref1 = currentDisplayValue !== label ? currentDisplayValue : currentValue) !== null && _ref1 !== void 0 ? _ref1 : "");
    return /* @__PURE__ */ React76.createElement(React76.Fragment, null, triggerType === "pill" /* PILL */  && /* @__PURE__ */ React76.createElement(UitkMenu3, {
        id: "".concat(egdsElementId, "_menu"),
        isOpen: isOpen,
        onDismiss: handleMenuDismiss,
        disableBodyClickHandler: false
    }, /* @__PURE__ */ React76.createElement(UitkMenuTrigger3, null, pillTrigger), /* @__PURE__ */ React76.createElement(UitkMenuContainer3, {
        position: PositionType3.LEFT
    }, /* @__PURE__ */ React76.createElement(UitkMenuList, {
        items: menuItems
    }))), triggerType === "selector" /* SELECTOR */  && selectorTrigger, /* @__PURE__ */ React76.createElement("input", {
        type: "hidden",
        "data-testid": INPUT_NAME,
        name: INPUT_NAME,
        value: triggerType === "selector" /* SELECTOR */  ? selectValue : currentValue !== null && currentValue !== void 0 ? currentValue : ""
    }));
};
EGDSSearchFormInputFieldWithSelection.displayName = DISPLAY_NAME11;
EGDSSearchFormInputFieldWithSelection.fragment = __Fragment38;
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field.tsx
var __Fragment39 = gql54(_templateObject58(), Icon.fragment, EGDSSearchFormInputFieldWithSelection.fragment);
var EGDSSearchFormInputField = function(param) {
    var data = param.data, triggerType = param.triggerType;
    var _data_action;
    switch((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename){
        case "EGDSSearchFormSelectAction":
            if (triggerType) {
                return /* @__PURE__ */ React77.createElement(EGDSSearchFormInputFieldWithSelection, {
                    data: data.action,
                    trigger: data,
                    triggerType: triggerType
                });
            }
            return null;
        default:
            return null;
    }
};
EGDSSearchFormInputField.displayName = "EGDSSearchFormInputField";
EGDSSearchFormInputField.fragment = __Fragment39;
// src/components/multi-item/form/package-options.tsx
import { UitkForm as UitkForm4 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton4 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
// src/components/multi-item/util/fallback-options-data.ts
var cabin = {
    egdsElementId: "cabin_class",
    value: "COACH",
    label: "Cabin class",
    placeholder: "Economy",
    leftIcon: {
        id: "airline_seat_recline_extra",
        title: null,
        token: "icon__airline_seat_recline_extra",
        description: "airline_seat_recline_extra",
        size: null,
        __typename: "Icon"
    },
    action: {
        analytics: {
            linkName: "Open Cabin Class Selector",
            referrerId: "Web.package.cabin.class.selector.open",
            __typename: "ClientSideAnalytics"
        },
        options: [
            {
                label: "Economy",
                selected: true,
                value: "COACH",
                __typename: "EGDSBasicOption"
            },
            {
                label: "Premium economy",
                selected: false,
                value: "ECONOMY_PREMIUM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "Business class",
                selected: false,
                value: "BUSINESS",
                __typename: "EGDSBasicOption"
            },
            {
                label: "First class",
                selected: false,
                value: "FIRST_CLASS",
                __typename: "EGDSBasicOption"
            }
        ],
        __typename: "EGDSSearchFormSelectAction"
    },
    __typename: "EGDSSearchFormInputField"
};
var car = function(selected) {
    return {
        __typename: "EGDSBasicPill",
        accessibility: null,
        disabled: false,
        name: "package-type-selector-car",
        primary: "Car",
        selected: selected,
        selectedText: "Car added",
        value: null,
        icon: null,
        selectAnalytics: {
            linkName: "Packages - Pill selected or deselected",
            referrerId: "Web.package.selection.car.selected",
            __typename: "ClientSideAnalytics"
        },
        deselectAnalytics: {
            linkName: "Packages - Pill selected or deselected",
            referrerId: "Web.package.selection.car.deselected",
            __typename: "ClientSideAnalytics"
        }
    };
};
var flight = function(selected) {
    return {
        __typename: "EGDSBasicPill",
        accessibility: null,
        disabled: false,
        name: "package-type-selector-flight",
        primary: "Flight",
        selected: selected,
        selectedText: "Flight added",
        value: null,
        icon: null,
        selectAnalytics: {
            linkName: "Packages - Pill selected or deselected",
            referrerId: "Web.package.selection.flight.selected",
            __typename: "ClientSideAnalytics"
        },
        deselectAnalytics: {
            linkName: "Packages - Pill selected or deselected",
            referrerId: "Web.package.selection.flight.deselected",
            __typename: "ClientSideAnalytics"
        }
    };
};
var stay = function(selected) {
    return {
        __typename: "EGDSBasicPill",
        accessibility: null,
        disabled: false,
        name: "package-type-selector-stay",
        primary: "Stay",
        selected: selected,
        selectedText: "Stay added",
        value: null,
        icon: null,
        selectAnalytics: {
            linkName: "Packages - Pill selected or deselected",
            referrerId: "Web.package.selection.stay.selected",
            __typename: "ClientSideAnalytics"
        },
        deselectAnalytics: {
            linkName: "Packages - Pill selected or deselected",
            referrerId: "Web.package.selection.stay.deselected",
            __typename: "ClientSideAnalytics"
        }
    };
};
var defaultElements = [
    {
        __typename: "EGDSSearchFormLocationsField"
    },
    {
        __typename: "EGDSSearchFormDatePickerField"
    },
    {
        __typename: "EGDSSearchFormTravelersField"
    }
];
var packageSelectionMap = /* @__PURE__ */ new Map([
    [
        "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ ,
        {
            car: car(false),
            flight: flight(true),
            stay: stay(true),
            __typename: "PackagesSearchFormSelection"
        }
    ],
    [
        "FLIGHT_CAR" /* FLIGHT_CAR */ ,
        {
            car: car(true),
            flight: flight(true),
            stay: stay(false),
            __typename: "PackagesSearchFormSelection"
        }
    ],
    [
        "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ ,
        {
            car: car(true),
            flight: flight(true),
            stay: stay(true),
            __typename: "PackagesSearchFormSelection"
        }
    ],
    [
        "HOTEL_CAR" /* HOTEL_CAR */ ,
        {
            car: car(true),
            flight: flight(false),
            stay: stay(true),
            __typename: "PackagesSearchFormSelection"
        }
    ]
]);
var getFallbackOptionsData = function(packageType, includePackageSelection) {
    var packageSelection2 = null;
    var elements = _to_consumable_array(defaultElements);
    if (includePackageSelection && packageType) {
        packageSelection2 = packageSelectionMap.get(packageType) || null;
    }
    if (packageType && packageType !== "HOTEL_CAR" /* HOTEL_CAR */ ) {
        elements = _to_consumable_array(defaultElements).concat([
            cabin
        ]);
    }
    return {
        searchForm: {
            packages: {
                __typename: "PackagesSearchForm",
                packageSelection: packageSelection2,
                elements: elements,
                directFlightsOnly: null
            },
            __typename: "SearchFormResults"
        }
    };
};
// src/components/multi-item/form/__private/package-selection.tsx
import React78 from "react";
import { gql as gql55 } from "@apollo/client";
var listOfLineOfBusiness = [
    "stay",
    "flight",
    "car"
];
var packages = [
    {
        stay: true,
        flight: true,
        car: true,
        type: "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ 
    },
    {
        stay: true,
        flight: true,
        car: false,
        type: "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ 
    },
    {
        stay: false,
        flight: true,
        car: true,
        type: "FLIGHT_CAR" /* FLIGHT_CAR */ 
    },
    {
        stay: true,
        flight: false,
        car: true,
        type: "HOTEL_CAR" /* HOTEL_CAR */ 
    }
];
var __Fragment40 = gql55(_templateObject59(), EGDSPill.fragment);
var PackagesSearchFormSelection = function(props) {
    var _packages_find;
    var data = props.data, onPackageTypeChange = props.onPackageTypeChange;
    var car2 = data.car, flight2 = data.flight, stay2 = data.stay;
    var initialState = {
        stay: !!(stay2 === null || stay2 === void 0 ? void 0 : stay2.selected),
        flight: !!(flight2 === null || flight2 === void 0 ? void 0 : flight2.selected),
        car: !!(car2 === null || car2 === void 0 ? void 0 : car2.selected)
    };
    var _packages_find_type;
    var _React78_useState = _sliced_to_array(React78.useState(_object_spread_props(_object_spread({}, initialState), {
        type: (_packages_find_type = (_packages_find = packages.find(function(pkg) {
            return listOfLineOfBusiness.every(function(lob) {
                return pkg[lob] === initialState[lob];
            });
        })) === null || _packages_find === void 0 ? void 0 : _packages_find.type) !== null && _packages_find_type !== void 0 ? _packages_find_type : null
    })), 2), setCurrentPackage = _React78_useState[1];
    var handlePillChange = function(event) {
        var _event_target = event.target, name = _event_target.name, checked = _event_target.checked;
        var pillNamePrefix = "package-type-selector-";
        var key = name.split(pillNamePrefix)[1];
        setCurrentPackage(function(prev) {
            var _packages_find;
            var newPackage = _object_spread_props(_object_spread({}, prev), _define_property({}, key, checked));
            var _packages_find_type;
            var type = (_packages_find_type = (_packages_find = packages.find(function(pkg) {
                return listOfLineOfBusiness.every(function(lob) {
                    return pkg[lob] === newPackage[lob];
                });
            })) === null || _packages_find === void 0 ? void 0 : _packages_find.type) !== null && _packages_find_type !== void 0 ? _packages_find_type : null;
            onPackageTypeChange === null || onPackageTypeChange === void 0 ? void 0 : onPackageTypeChange(type);
            return _object_spread_props(_object_spread({}, newPackage), {
                type: type
            });
        });
    };
    if (!stay2 || !flight2) {
        return null;
    }
    var pills = car2 ? [
        stay2,
        flight2,
        car2
    ] : [
        stay2,
        flight2
    ];
    return /* @__PURE__ */ React78.createElement(React78.Fragment, null, pills.map(function(pill) {
        return /* @__PURE__ */ React78.createElement(EGDSPill, {
            key: pill.name,
            data: pill,
            onChange: handlePillChange
        });
    }));
};
PackagesSearchFormSelection.displayName = "PackagesSearchFormSelection";
PackagesSearchFormSelection.fragment = __Fragment40;
// src/components/multi-item/form/package-options.tsx
var __Query2 = gql56(_templateObject60(), PackagesSearchFormSelection.fragment, EGDSSearchFormInputField.fragment, EGDSPill.fragment);
var PackagesOptions = function(props) {
    var _data_searchForm;
    var inputs = props.inputs, skipSsr = props.skipSsr, batchKey = props.batchKey, onFieldChange = props.onFieldChange, onCabinClassSelect = props.onCabinClassSelect, onPackageTypeChange = props.onPackageTypeChange, handleDirectFlightsOnlySwitch = props.handleDirectFlightsOnlySwitch, showCabinClass = props.showCabinClass, showDirectFlightsOnly = props.showDirectFlightsOnly, skipQuery = props.skipQuery;
    var includePackageType = inputs.includePackageType, packageType = inputs.packageType;
    var context = useBexApi6().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery
    }), currentData = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading, previousData = _useQuery2.previousData;
    var data = previousData || currentData;
    React79.useEffect(function() {
        if (onCabinClassSelect) {
            var _cabinClassField_action;
            var cabinClassField = (data === null || data === void 0 ? void 0 : data.searchForm.packages.__typename) === "PackagesSearchForm" ? data.searchForm.packages.elements.find(function(element) {
                var _element_action;
                return element.__typename === "EGDSSearchFormInputField" && ((_element_action = element.action) === null || _element_action === void 0 ? void 0 : _element_action.__typename) === "EGDSSearchFormSelectAction";
            }) : null;
            if ((cabinClassField === null || cabinClassField === void 0 ? void 0 : cabinClassField.__typename) === "EGDSSearchFormInputField" && ((_cabinClassField_action = cabinClassField.action) === null || _cabinClassField_action === void 0 ? void 0 : _cabinClassField_action.__typename) === "EGDSSearchFormSelectAction") {
                var cabinClassFieldName = "".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-").concat(cabinClassField.egdsElementId);
                var selectedOption = cabinClassField.action.options.find(function(option) {
                    return option.selected;
                });
                var _selectedOption_value;
                onCabinClassSelect({
                    name: cabinClassFieldName,
                    value: (_selectedOption_value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== null && _selectedOption_value !== void 0 ? _selectedOption_value : ""
                });
            }
        }
    }, [
        data === null || data === void 0 ? void 0 : data.searchForm,
        onCabinClassSelect
    ]);
    React79.useEffect(function() {
        var _data_searchForm;
        var _ref = (_data_searchForm = data === null || data === void 0 ? void 0 : data.searchForm) !== null && _data_searchForm !== void 0 ? _data_searchForm : {}, packages2 = _ref.packages;
        if ((packages2 === null || packages2 === void 0 ? void 0 : packages2.__typename) === "PackagesSearchForm" && packages2.directFlightsOnly && handleDirectFlightsOnlySwitch) {
            handleDirectFlightsOnlySwitch(packages2.directFlightsOnly.selected);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.searchForm,
        handleDirectFlightsOnlySwitch
    ]);
    if (loading && !data) {
        return /* @__PURE__ */ React79.createElement(UitkSpacing23, {
            padding: {
                blockstart: "three",
                blockend: "three"
            }
        }, /* @__PURE__ */ React79.createElement("div", null, /* @__PURE__ */ React79.createElement(UitkLineSkeleton4, {
            animation: true,
            type: "secondary"
        })));
    }
    if (error || !data) {
        data = getFallbackOptionsData(packageType, includePackageType);
    }
    if ((data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : _data_searchForm.packages.__typename) !== "PackagesSearchForm") {
        return null;
    }
    var elements = data.searchForm.packages.elements;
    var handleCabinClassChange = function(field) {
        onCabinClassSelect === null || onCabinClassSelect === void 0 ? void 0 : onCabinClassSelect(field);
    };
    var handleFieldChange = function(field, event) {
        onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
    };
    var onChangeDirectFlightsOnly = function(event) {
        handleDirectFlightsOnlySwitch === null || handleDirectFlightsOnlySwitch === void 0 ? void 0 : handleDirectFlightsOnlySwitch(event.target.checked);
    };
    var directFlightsOnly = data.searchForm.packages.directFlightsOnly;
    return /* @__PURE__ */ React79.createElement(UitkSpacing23, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React79.createElement(UitkLayoutFlex14, {
        space: "two",
        wrap: "wrap"
    }, includePackageType && data.searchForm.packages.packageSelection && /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React79.createElement(UitkForm4, {
        onFieldChange: handleFieldChange,
        "data-stid": "package-type-selector"
    }, /* @__PURE__ */ React79.createElement(PackagesSearchFormSelection, _object_spread_props(_object_spread({}, props), {
        data: data.searchForm.packages.packageSelection,
        onPackageTypeChange: onPackageTypeChange
    })))), showCabinClass && /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React79.createElement("div", null, /* @__PURE__ */ React79.createElement(UitkForm4, {
        onFieldChange: handleCabinClassChange
    }, elements.map(function(element, index) {
        return element.__typename === "EGDSSearchFormInputField" && /* @__PURE__ */ React79.createElement(EGDSSearchFormInputField, {
            key: index,
            data: element,
            triggerType: "pill" /* PILL */ 
        });
    })))), directFlightsOnly && showDirectFlightsOnly && /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React79.createElement("div", null, /* @__PURE__ */ React79.createElement(EGDSPill, {
        data: directFlightsOnly,
        onChange: onChangeDirectFlightsOnly
    })))));
};
PackagesOptions.displayName = "sharedui-PackagesOptions";
// src/components/multi-item/form/packages-search-form.tsx
import React90 from "react";
import { gql as gql66, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
import { ViewMedium as ViewMedium16, Viewport as Viewport19, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
// src/components/multi-item/util/fallback-form-data.ts
var templateError = [
    {
        category: "ZERO" /* ZERO */ ,
        template: "Please correct the ${errorCount} errors to continue",
        __typename: "CardinalTemplate"
    },
    {
        category: "ONE" /* ONE */ ,
        template: "Please correct the error to continue",
        __typename: "CardinalTemplate"
    },
    {
        category: "TWO" /* TWO */ ,
        template: "Please correct the ${errorCount} errors to continue",
        __typename: "CardinalTemplate"
    },
    {
        category: "FEW" /* FEW */ ,
        template: "Please correct the ${errorCount} errors to continue",
        __typename: "CardinalTemplate"
    },
    {
        category: "MANY" /* MANY */ ,
        template: "Please correct the ${errorCount} errors to continue",
        __typename: "CardinalTemplate"
    },
    {
        category: "OTHER" /* OTHER */ ,
        template: "Please correct the ${errorCount} errors to continue",
        __typename: "CardinalTemplate"
    }
];
var templateTravelers = [
    {
        category: "ZERO" /* ZERO */ ,
        template: "${travelerCount} travelers",
        __typename: "CardinalTemplate"
    },
    {
        category: "ONE" /* ONE */ ,
        template: "${travelerCount} traveler",
        __typename: "CardinalTemplate"
    },
    {
        category: "TWO" /* TWO */ ,
        template: "${travelerCount} travelers",
        __typename: "CardinalTemplate"
    },
    {
        category: "FEW" /* FEW */ ,
        template: "${travelerCount} travelers",
        __typename: "CardinalTemplate"
    },
    {
        category: "MANY" /* MANY */ ,
        template: "${travelerCount} travelers",
        __typename: "CardinalTemplate"
    },
    {
        category: "OTHER" /* OTHER */ ,
        template: "${travelerCount} travelers",
        __typename: "CardinalTemplate"
    }
];
var templateRooms = [
    {
        category: "ZERO" /* ZERO */ ,
        template: "${roomCount} rooms",
        __typename: "CardinalTemplate"
    },
    {
        category: "ONE" /* ONE */ ,
        template: "${roomCount} room",
        __typename: "CardinalTemplate"
    },
    {
        category: "TWO" /* TWO */ ,
        template: "${roomCount} rooms",
        __typename: "CardinalTemplate"
    },
    {
        category: "FEW" /* FEW */ ,
        template: "${roomCount} rooms",
        __typename: "CardinalTemplate"
    },
    {
        category: "MANY" /* MANY */ ,
        template: "${roomCount} rooms",
        __typename: "CardinalTemplate"
    },
    {
        category: "OTHER" /* OTHER */ ,
        template: "${roomCount} rooms",
        __typename: "CardinalTemplate"
    }
];
var errorSummary2 = {
    egdsElementId: "search_form_error_summary",
    goToErrorLinkText: "Go to error",
    goToFirstErrorLinkText: "Go to first error",
    heading: "",
    body: null,
    analytics: {
        linkName: "Error summary link clicked",
        referrerId: "Web.Packages.Search.Error.Summary",
        __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
        linkName: "Error summary displayed",
        referrerId: "Web.Packages.Search.Error.Summary.Displayed",
        __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
        models: [
            {
                key: "errorCount",
                source: "errorCount",
                __typename: "TemplateModel"
            }
        ],
        templates: templateError,
        __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
};
var search2 = {
    egdsElementId: "search_button",
    primary: "Search",
    disabled: false,
    accessibility: "Search",
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.Packages.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var packageSelection = {
    noSelectionMessage: {
        body: "To start building your trip, choose two or more items",
        heading: "Please select two or more items",
        icon: {
            id: "search",
            title: null,
            token: "icon__search",
            description: "search",
            size: null,
            __typename: "Icon"
        },
        __typename: "UIEmptyState"
    },
    __typename: "PackagesSearchFormSelection"
};
var packageTypeSelector = /* @__PURE__ */ new Map([
    [
        "FLIGHT_CAR" /* FLIGHT_CAR */ ,
        "fc"
    ],
    [
        "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ ,
        "fhc"
    ],
    [
        "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ ,
        "fh"
    ],
    [
        "HOTEL_CAR" /* HOTEL_CAR */ ,
        "hc"
    ]
]);
var destinationLocationField = function() {
    var packageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "HOTEL_CAR" /* HOTEL_CAR */ ;
    return {
        __typename: "EGDSSearchFormLocationField",
        egdsElementId: "destination_select",
        label: "Going to",
        placeholder: "Going to",
        value: null,
        errorMessage: "Please select a destination",
        validations: [
            {
                errorMessage: "Please select a destination",
                __typename: "EGDSRequiredInputValidation"
            }
        ],
        required: false,
        leftIcon: {
            title: null,
            __typename: "Icon"
        },
        action: {
            accessibility: null,
            analytics: {
                linkName: "Destination Selection",
                referrerId: "Web.package.destination.location.change",
                __typename: "ClientSideAnalytics"
            },
            info: {
                client: "Packages.Search",
                drivable: false,
                isDestination: true,
                lineOfBusiness: "PACKAGES",
                maxNumberOfResults: 8,
                packageType: packageTypeSelector[packageType] || "hc",
                personalize: true,
                regionType: 863,
                typeaheadFeatures: "ta_hierarchy|postal_code|google|consistent_display",
                isMultiLocation: null,
                domain: null,
                regionId: null,
                showCurrentLocation: null,
                __typename: "TypeaheadInfo",
                subLob: packageTypeSelector[packageType] || "hc",
                expUserId: "-1",
                trending: false
            },
            emptyResultsPlaceholder: "Search by city or airport",
            categorize: false,
            allowExactMatch: true,
            listTitle: false,
            selectedItemHeading: null,
            clearAllText: null,
            dismissButtonText: null,
            __typename: "OpenTypeaheadAction"
        },
        closeAnalytics: {
            linkName: "Destination Selection",
            referrerId: "Web.package.destination.location.close",
            __typename: "ClientSideAnalytics"
        },
        changeAnalytics: {
            linkName: "Destination change",
            referrerId: "Web.package.destination.location.change",
            __typename: "ClientSideAnalytics"
        },
        multiLocations: null,
        regionId: null,
        debounceRate: null
    };
};
var searchLocationsFields = function(packageType) {
    return {
        __typename: "EGDSSearchFormLocationsField",
        egdsElementId: "locations",
        origin: {
            __typename: "EGDSSearchFormLocationField",
            egdsElementId: "origin_select",
            label: "Leaving from",
            placeholder: "Leaving from",
            value: null,
            errorMessage: "Please select an origin",
            validations: [
                {
                    errorMessage: "Please select an origin",
                    __typename: "EGDSRequiredInputValidation"
                }
            ],
            required: false,
            leftIcon: {
                title: null,
                __typename: "Icon"
            },
            action: {
                accessibility: null,
                analytics: {
                    linkName: "Origin Selection",
                    referrerId: "Web.package.origin.location.open",
                    __typename: "ClientSideAnalytics"
                },
                info: {
                    client: "Packages.Search",
                    drivable: false,
                    isDestination: false,
                    lineOfBusiness: "PACKAGES",
                    maxNumberOfResults: 8,
                    packageType: packageTypeSelector.get(packageType) || "hc",
                    personalize: true,
                    regionType: 863,
                    typeaheadFeatures: "ta_hierarchy|postal_code|google|consistent_display",
                    isMultiLocation: null,
                    domain: null,
                    regionId: null,
                    showCurrentLocation: null,
                    __typename: "TypeaheadInfo",
                    subLob: packageTypeSelector.get(packageType) || "hc",
                    expUserId: "-1",
                    trending: false
                },
                emptyResultsPlaceholder: "Search by city or airport",
                categorize: false,
                allowExactMatch: true,
                listTitle: false,
                selectedItemHeading: null,
                clearAllText: null,
                dismissButtonText: null,
                __typename: "OpenTypeaheadAction"
            },
            closeAnalytics: {
                linkName: "Origin Selection",
                referrerId: "Web.package.origin.location.close",
                __typename: "ClientSideAnalytics"
            },
            changeAnalytics: {
                linkName: "Origin change",
                referrerId: "Web.package.origin.location.change",
                __typename: "ClientSideAnalytics"
            },
            multiLocations: null,
            regionId: null,
            debounceRate: null
        },
        destination: destinationLocationField(packageType),
        horizontalSwapper: {
            egdsElementId: "location_swapper",
            primary: "",
            disabled: false,
            accessibility: "Swap origin and destination values",
            icon: {
                id: "",
                description: "swap_horiz",
                token: "",
                title: null,
                __typename: "Icon"
            },
            analytics: {
                linkName: "Swapper button clicked",
                referrerId: "package.locations.swapper.button.click",
                __typename: "ClientSideAnalytics"
            },
            action: null,
            __typename: "UISecondaryButton"
        },
        verticalSwapper: {
            egdsElementId: "location_swapper",
            primary: "",
            disabled: false,
            accessibility: "Swap origin and destination values",
            icon: {
                id: "",
                description: "swap_vert",
                token: "",
                title: null,
                __typename: "Icon"
            },
            analytics: {
                linkName: "Swapper button clicked",
                referrerId: "package.locations.swapper.button.click",
                __typename: "ClientSideAnalytics"
            },
            action: null,
            __typename: "UISecondaryButton"
        },
        validations: [
            {
                errorMessage: "Please make sure your departure and arrival cities are different",
                __typename: "EGDSSameValueInputValidation"
            }
        ]
    };
};
var today2 = /* @__PURE__ */ new Date();
var startDate2 = new Date(today2.getFullYear(), today2.getMonth(), today2.getDate() + 14);
var endDate2 = new Date(startDate2.getFullYear(), startDate2.getMonth(), startDate2.getDate() + 1);
var validDaysUpperInclusive = new Date(today2.getFullYear(), today2.getMonth(), today2.getDate() + 332);
var validDaysLowerBoundInclusive = new Date(today2.getFullYear(), today2.getMonth(), today2.getDate() + 2);
var startDatePickerMonthValue2 = startDate2.getMonth() + 1;
var endDatePickerMonthValue2 = endDate2.getMonth() + 1;
var datePicker2 = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date-range-select",
    label: "Dates",
    placeholder: "Dates",
    errorMessage: null,
    validations: [
        {
            errorMessage: "Dates must be no more than 29 days apart",
            __typename: "EGDSMaxLengthInputValidation"
        }
    ],
    action: {
        accessibility: null,
        analytics: {
            linkName: "Packages - Calendar Selection",
            referrerId: "Web.packages.calendar.selection",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            flexibleDateContent: null,
            buttonText: "Done",
            buttonTextTemplate: null,
            clearButtonText: null,
            firstDayOfWeek: "SUN" /* SUN */ ,
            maxNumberOfDaysSelected: 29,
            sameDaySelectionAllowed: false,
            selectedStartDate: {
                day: startDate2.getDate(),
                month: startDatePickerMonthValue2,
                year: startDate2.getFullYear(),
                __typename: "Date"
            },
            startDatePlaceholderText: "Check-in",
            selectedEndDate: {
                day: endDate2.getDate(),
                month: endDatePickerMonthValue2,
                year: endDate2.getFullYear(),
                __typename: "Date"
            },
            endDatePlaceholderText: "Check-out",
            validDaysLowerBoundInclusive: {
                day: validDaysLowerBoundInclusive.getDate(),
                month: validDaysLowerBoundInclusive.getMonth(),
                year: validDaysLowerBoundInclusive.getFullYear(),
                __typename: "Date"
            },
            validDaysUpperBoundInclusive: {
                day: validDaysUpperInclusive.getDate(),
                month: validDaysUpperInclusive.getMonth(),
                year: validDaysUpperInclusive.getFullYear(),
                __typename: "Date"
            },
            submitButtonAnalytics: {
                linkName: "Packages - Calendar Submit",
                referrerId: "Web.packages.calendar.submit",
                __typename: "ClientSideAnalytics"
            },
            nextButtonAnalytics: {
                linkName: "Calendar next",
                referrerId: "Web.Packages.Calendar.Next.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            previousButtonAnalytics: {
                linkName: "Calendar previous",
                referrerId: "Web.Packages.Calendar.Previous.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            startDateButtonAnalytics: {
                linkName: "Packages - Calendar Start Date",
                referrerId: "Web.packages.calendar.start.date.click",
                __typename: "ClientSideAnalytics"
            },
            endDateButtonAnalytics: {
                linkName: "Packages - Calendar End Date",
                referrerId: "Web.packages.calendar.end.date.click",
                __typename: "ClientSideAnalytics"
            },
            clearDatesButtonAnalytics: null,
            showClearDatesButton: false,
            __typename: "EGDSDateRangePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var cabinFormInput = {
    __typename: "EGDSSearchFormInputField",
    egdsElementId: "cabin_class",
    value: "COACH",
    label: "Cabin class",
    placeholder: "Economy",
    leftIcon: {
        id: "airline_seat_recline_extra",
        title: null,
        token: "icon__airline_seat_recline_extra",
        description: "airline_seat_recline_extra",
        size: null,
        __typename: "Icon"
    },
    action: {
        analytics: {
            linkName: "Open Cabin Class Selector",
            referrerId: "Web.package.cabin.class.selector.open",
            __typename: "ClientSideAnalytics"
        },
        options: [
            {
                label: "Economy",
                selected: true,
                value: "COACH",
                __typename: "EGDSBasicOption"
            },
            {
                label: "Premium economy",
                selected: false,
                value: "ECONOMY_PREMIUM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "Business class",
                selected: false,
                value: "BUSINESS",
                __typename: "EGDSBasicOption"
            },
            {
                label: "First class",
                selected: false,
                value: "FIRST_CLASS",
                __typename: "EGDSBasicOption"
            }
        ],
        __typename: "EGDSSearchFormSelectAction"
    }
};
var infantValidations = [
    {
        errorMessage: "We allow up to 6 travelers per booking.",
        maxCount: 6,
        type: "MAX_TRAVELERS" /* MAX_TRAVELERS */ ,
        infantsInSeatPerAdult: null,
        errorSummary: {
            egdsElementId: "traveler_selector_error_summary",
            goToErrorLinkText: null,
            goToFirstErrorLinkText: null,
            heading: "We allow up to 6 travelers per booking.",
            body: null,
            analytics: null,
            impressionAnalytics: {
                linkName: "Error summary displayed",
                referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
                __typename: "ClientSideImpressionEventAnalytics"
            },
            headingTemplate: null,
            __typename: "EGDSErrorSummary"
        },
        __typename: "EGDSTravelersInputValidation"
    },
    {
        errorMessage: "There must be at least 1 traveler (age 12+) for each infant in a lap.",
        maxCount: null,
        type: "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */ ,
        infantsInSeatPerAdult: 2,
        errorSummary: {
            egdsElementId: "traveler_selector_error_summary",
            goToErrorLinkText: null,
            goToFirstErrorLinkText: null,
            heading: "There must be at least 1 traveler (age 12+) for each infant in a lap.",
            body: null,
            analytics: null,
            impressionAnalytics: {
                linkName: "Error summary displayed",
                referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
                __typename: "ClientSideImpressionEventAnalytics"
            },
            headingTemplate: null,
            __typename: "EGDSErrorSummary"
        },
        __typename: "EGDSTravelersInputValidation"
    },
    {
        errorMessage: "Provide the age of the child.",
        maxCount: null,
        type: "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ,
        infantsInSeatPerAdult: null,
        errorSummary: {
            egdsElementId: "traveler_selector_error_summary",
            goToErrorLinkText: "Go to error",
            goToFirstErrorLinkText: "Go to first error",
            heading: "",
            body: null,
            analytics: {
                linkName: "Error summary link clicked",
                referrerId: "Web.Packages.Traveler.Error.Summary",
                __typename: "ClientSideAnalytics"
            },
            impressionAnalytics: {
                linkName: "Error summary displayed",
                referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
                __typename: "ClientSideImpressionEventAnalytics"
            },
            headingTemplate: {
                models: [
                    {
                        key: "errorCount",
                        source: "errorCount",
                        __typename: "TemplateModel"
                    }
                ],
                templates: templateError,
                __typename: "EGDSCardinalLocalizedText"
            },
            __typename: "EGDSErrorSummary"
        },
        __typename: "EGDSTravelersInputValidation"
    },
    {
        errorMessage: "There must be at least 1 traveler (age 12+) for every 2 infants in a seat.",
        maxCount: null,
        type: "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */ ,
        infantsInSeatPerAdult: 2,
        errorSummary: {
            egdsElementId: "traveler_selector_error_summary",
            goToErrorLinkText: null,
            goToFirstErrorLinkText: null,
            heading: "There must be at least 1 traveler (age 12+) for every 2 infants in a seat.",
            body: null,
            analytics: null,
            impressionAnalytics: {
                linkName: "Error summary displayed",
                referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
                __typename: "ClientSideImpressionEventAnalytics"
            },
            headingTemplate: null,
            __typename: "EGDSErrorSummary"
        },
        __typename: "EGDSTravelersInputValidation"
    }
];
var ageOptions = function(value, label) {
    var labelOption = label || value;
    return {
        label: labelOption,
        value: value,
        egdsElementId: null,
        changeAnalytics: {
            linkName: "Travelers age update",
            referrerId: "Web.Packages.Traveler.Child.Update.Age.".concat(value),
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSBasicOption"
    };
};
var flightHotelCarTravelSelector = {
    __typename: "EGDSSearchFormTravelersField",
    action: {
        analytics: {
            linkName: "Packages - Travelers Selection",
            referrerId: "Web.packages.travelers.selection",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            addAnotherRoomButton: {
                egdsElementId: null,
                primary: "Add another room",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers add room",
                    referrerId: "Web.Packages.Traveler.Add.Room",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UITertiaryButton"
            },
            closeButton: {
                egdsElementId: null,
                primary: null,
                disabled: false,
                accessibility: null,
                icon: {
                    id: "close",
                    description: "",
                    token: "icon__close",
                    title: null,
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Travelers results not updated",
                    referrerId: "Web.Packages.Traveler.Close",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UITertiaryButton"
            },
            doneButton: {
                egdsElementId: null,
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers results updated",
                    referrerId: "Web.Packages.Traveler.Done",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            infantSeatSelection: {
                airlineAgeRule: {
                    text: "Airline age rules",
                    action: {
                        accessibility: null,
                        target: "INTERNAL" /* INTERNAL */ ,
                        resource: {
                            value: "https://www.expedia.com/p/info-main/h_fw_default%3Frhtx=HTX_FLTSRCH_RT%23travs",
                            __typename: "HttpURI"
                        },
                        analytics: {
                            linkName: "Packages - Airline Age Rules",
                            referrerId: "Web.packages.airline.age.rules",
                            __typename: "ClientSideAnalytics"
                        },
                        __typename: "UILinkAction"
                    },
                    icon: null,
                    iconPosition: null,
                    __typename: "EGDSStandardLink",
                    egdsElementId: null
                },
                groupName: "InfantSeating",
                labelTemplate: {
                    text: "Where will the infants sit?",
                    models: [
                        {
                            key: "infantCount",
                            source: "infantCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: [
                        {
                            category: "ONE" /* ONE */ ,
                            template: "Where will the infant sit?",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "OTHER" /* OTHER */ ,
                            template: "Where will the infants sit?",
                            __typename: "CardinalTemplate"
                        }
                    ],
                    __typename: "EGDSCardinalLocalizedText"
                },
                options: [
                    {
                        label: "On lap",
                        value: "lap",
                        __typename: "EGDSInfantSeatRadioButton"
                    },
                    {
                        label: "In seat",
                        value: "seat",
                        __typename: "EGDSInfantSeatRadioButton"
                    }
                ],
                selected: "lap",
                __typename: "EGDSTravelerInfantSeatSelection"
            },
            maxRoomCount: 6,
            rooms: [
                {
                    label: {
                        models: [
                            {
                                key: "roomNumber",
                                source: "roomNumber",
                                __typename: "TemplateModel"
                            }
                        ],
                        template: "Room ${roomNumber}",
                        __typename: "EGDSBasicLocalizedText"
                    },
                    adults: {
                        decreaseAnalytics: {
                            linkName: "Packages - Step input decrease",
                            referrerId: "Web.packages.step.input.decrease",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Packages - Step input increase",
                            referrerId: "Web.packages.step.input.increase",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of adults in this room",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of adults in this room",
                        increaseTextTemplate: null,
                        egdsElementId: null,
                        __typename: "EGDSTravelerStepInput",
                        label: "Adults",
                        max: 6,
                        min: 1,
                        step: 1,
                        subLabel: null,
                        value: 2
                    },
                    children: {
                        count: {
                            decreaseAnalytics: {
                                linkName: "Packages - Step input decrease",
                                referrerId: "Web.packages.step.input.decrease",
                                __typename: "ClientSideAnalytics"
                            },
                            increaseAnalytics: {
                                linkName: "Packages - Step input increase",
                                referrerId: "Web.packages.step.input.increase",
                                __typename: "ClientSideAnalytics"
                            },
                            decreaseText: "Decrease the number of children in this room",
                            decreaseTextTemplate: null,
                            increaseText: "Increase the number of children in this room",
                            increaseTextTemplate: null,
                            egdsElementId: null,
                            __typename: "EGDSTravelerStepInput",
                            label: "Children",
                            max: 5,
                            min: 0,
                            step: 1,
                            subLabel: "Ages 2 to 17",
                            value: 0
                        },
                        ages: [],
                        ageTemplate: {
                            labelTemplate: {
                                models: [
                                    {
                                        key: "childNumber",
                                        source: "childNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Child ${childNumber} age",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            options: [
                                ageOptions("2"),
                                ageOptions("3"),
                                ageOptions("4"),
                                ageOptions("5"),
                                ageOptions("6"),
                                ageOptions("7"),
                                ageOptions("8"),
                                ageOptions("9"),
                                ageOptions("10"),
                                ageOptions("11"),
                                ageOptions("12"),
                                ageOptions("13"),
                                ageOptions("14"),
                                ageOptions("15"),
                                ageOptions("16"),
                                ageOptions("17")
                            ],
                            egdsElementId: null,
                            value: null,
                            __typename: "EGDSTravelerChildAgeSelect"
                        },
                        __typename: "EGDSTravelerChildren"
                    },
                    infants: {
                        count: {
                            decreaseAnalytics: {
                                linkName: "Packages - Step input decrease",
                                referrerId: "Web.packages.step.input.decrease",
                                __typename: "ClientSideAnalytics"
                            },
                            increaseAnalytics: {
                                linkName: "Packages - Step input increase",
                                referrerId: "Web.packages.step.input.increase",
                                __typename: "ClientSideAnalytics"
                            },
                            decreaseText: "Decrease the number of infants in this room",
                            decreaseTextTemplate: null,
                            increaseText: "Increase the number of infants in this room",
                            increaseTextTemplate: null,
                            egdsElementId: null,
                            __typename: "EGDSTravelerStepInput",
                            label: "Infants",
                            max: 5,
                            min: 0,
                            step: 1,
                            subLabel: "Younger than 2",
                            value: 0
                        },
                        ages: [],
                        ageTemplate: {
                            labelTemplate: {
                                models: [
                                    {
                                        key: "infantNumber",
                                        source: "infantNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Infant ${infantNumber} age",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            options: [
                                {
                                    label: "Under 1",
                                    value: "0",
                                    egdsElementId: null,
                                    changeAnalytics: null,
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    label: "1",
                                    value: "1",
                                    egdsElementId: null,
                                    changeAnalytics: null,
                                    __typename: "EGDSBasicOption"
                                }
                            ],
                            egdsElementId: null,
                            value: null,
                            __typename: "EGDSTravelerChildAgeSelect"
                        },
                        __typename: "EGDSTravelerInfant"
                    },
                    removeRoomButton: {
                        egdsElementId: null,
                        primary: "Remove room",
                        disabled: false,
                        accessibility: null,
                        icon: null,
                        analytics: {
                            linkName: "Packages.Traveler.Remove.Room",
                            referrerId: "Web.Travelers remove room",
                            __typename: "ClientSideAnalytics"
                        },
                        action: null,
                        __typename: "UITertiaryButton"
                    },
                    removeRoomAnnouncement: "Room removed",
                    __typename: "EGDSTravelerSelectorRoom"
                }
            ],
            title: "Travelers",
            validations: infantValidations,
            __typename: "EGDSRoomsTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "rooms",
                models: {
                    models: [
                        {
                            key: "roomCount",
                            source: "roomCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: templateRooms,
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            },
            {
                key: "travelers",
                models: {
                    models: [
                        {
                            key: "travelerCount",
                            source: "travelerCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: templateTravelers,
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            }
        ],
        template: "${travelers}, ${rooms}",
        text: "2 travelers, 1 room",
        __typename: "EGDSCompositeLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    },
    readOnly: false
};
var flightCarTravelSelector = {
    __typename: "EGDSSearchFormTravelersField",
    action: {
        analytics: {
            linkName: "Packages - Travelers Selection",
            referrerId: "Web.packages.travelers.selection",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            closeButton: {
                egdsElementId: null,
                primary: null,
                disabled: false,
                accessibility: null,
                icon: {
                    id: "close",
                    description: "",
                    token: "icon__close",
                    title: null,
                    __typename: "Icon"
                },
                analytics: null,
                action: null,
                __typename: "UITertiaryButton"
            },
            doneButton: {
                egdsElementId: null,
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: null,
                action: null,
                __typename: "UIPrimaryButton"
            },
            title: "Travelers",
            travelers: {
                adults: {
                    decreaseAnalytics: {
                        linkName: "Packages - Step input decrease",
                        referrerId: "Web.packages.step.input.decrease",
                        __typename: "ClientSideAnalytics"
                    },
                    increaseAnalytics: {
                        linkName: "Packages - Step input increase",
                        referrerId: "Web.packages.step.input.increase",
                        __typename: "ClientSideAnalytics"
                    },
                    decreaseText: "Decrease the number of adults",
                    decreaseTextTemplate: null,
                    increaseText: "Increase the number of adults",
                    increaseTextTemplate: null,
                    egdsElementId: null,
                    __typename: "EGDSTravelerStepInput",
                    label: "Adults",
                    max: 6,
                    min: 1,
                    step: 1,
                    subLabel: null,
                    value: 2
                },
                children: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Packages - Step input decrease",
                            referrerId: "Web.packages.step.input.decrease",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Packages - Step input increase",
                            referrerId: "Web.packages.step.input.increase",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of children",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of children",
                        increaseTextTemplate: null,
                        egdsElementId: null,
                        __typename: "EGDSTravelerStepInput",
                        label: "Children",
                        max: 5,
                        min: 0,
                        step: 1,
                        subLabel: "Ages 2 to 17",
                        value: 0
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "childNumber",
                                    source: "childNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Child ${childNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            ageOptions("2"),
                            ageOptions("3"),
                            ageOptions("4"),
                            ageOptions("5"),
                            ageOptions("6"),
                            ageOptions("7"),
                            ageOptions("8"),
                            ageOptions("9"),
                            ageOptions("10"),
                            ageOptions("11"),
                            ageOptions("12"),
                            ageOptions("13"),
                            ageOptions("14"),
                            ageOptions("15"),
                            ageOptions("16"),
                            ageOptions("17")
                        ],
                        egdsElementId: null,
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerChildren"
                },
                infantsInSeat: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Packages - Step input decrease",
                            referrerId: "Web.packages.step.input.decrease",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Packages - Step input increase",
                            referrerId: "Web.packages.step.input.increase",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of infants",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of infants",
                        increaseTextTemplate: null,
                        egdsElementId: null,
                        __typename: "EGDSTravelerStepInput",
                        label: "Infants in seat",
                        max: 4,
                        min: 0,
                        step: 1,
                        subLabel: "Younger than 2",
                        value: 0
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "infantNumber",
                                    source: "infantNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Infant ${infantNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            {
                                label: "Under 1",
                                value: "0",
                                egdsElementId: null,
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "1",
                                value: "1",
                                egdsElementId: null,
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        egdsElementId: null,
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerInfant"
                },
                infantsOnLap: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Packages - Step input decrease",
                            referrerId: "Web.packages.step.input.decrease",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Packages - Step input increase",
                            referrerId: "Web.packages.step.input.increase",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of infants",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of infants",
                        increaseTextTemplate: null,
                        egdsElementId: null,
                        __typename: "EGDSTravelerStepInput",
                        label: "Infants on lap",
                        max: 3,
                        min: 0,
                        step: 1,
                        subLabel: "Younger than 2",
                        value: 0
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "infantNumber",
                                    source: "infantNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Infant ${infantNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            {
                                label: "Under 1",
                                value: "0",
                                egdsElementId: null,
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "1",
                                value: "1",
                                egdsElementId: null,
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        egdsElementId: null,
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerInfant"
                },
                pets: null,
                __typename: "EGDSTravelers"
            },
            validations: infantValidations,
            __typename: "EGDSBasicTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "travelerCount",
                source: "travelerCount",
                __typename: "TemplateModel"
            }
        ],
        templates: templateTravelers,
        secondaryTemplates: null,
        text: "2 travelers",
        __typename: "EGDSCardinalLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    },
    readOnly: false
};
var hotelCarTravelSelector = {
    __typename: "EGDSSearchFormTravelersField",
    action: {
        analytics: {
            linkName: "Packages - Travelers Selection",
            referrerId: "Web.packages.travelers.selection",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            addAnotherRoomButton: {
                egdsElementId: null,
                primary: "Add another room",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers add room",
                    referrerId: "Web.Packages.Traveler.Add.Room",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UITertiaryButton"
            },
            closeButton: {
                egdsElementId: null,
                primary: null,
                disabled: false,
                accessibility: null,
                icon: {
                    id: "close",
                    description: "",
                    token: "icon__close",
                    title: null,
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Travelers results not updated",
                    referrerId: "Web.Packages.Traveler.Close",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UITertiaryButton"
            },
            doneButton: {
                egdsElementId: null,
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers results updated",
                    referrerId: "Web.Packages.Traveler.Done",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            infantSeatSelection: {
                airlineAgeRule: {
                    text: "Airline age rules",
                    action: {
                        accessibility: null,
                        target: "INTERNAL" /* INTERNAL */ ,
                        resource: {
                            value: "https://www.expedia.com/p/info-main/h_fw_default%3Frhtx=HTX_FLTSRCH_RT%23travs",
                            __typename: "HttpURI"
                        },
                        analytics: {
                            linkName: "Packages - Airline Age Rules",
                            referrerId: "Web.packages.airline.age.rules",
                            __typename: "ClientSideAnalytics"
                        },
                        __typename: "UILinkAction"
                    },
                    icon: null,
                    iconPosition: null,
                    __typename: "EGDSStandardLink",
                    egdsElementId: null
                },
                groupName: "InfantSeating",
                labelTemplate: {
                    text: "Where will the infants sit?",
                    models: [
                        {
                            key: "infantCount",
                            source: "infantCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: [
                        {
                            category: "ONE" /* ONE */ ,
                            template: "Where will the infant sit?",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "OTHER" /* OTHER */ ,
                            template: "Where will the infants sit?",
                            __typename: "CardinalTemplate"
                        }
                    ],
                    __typename: "EGDSCardinalLocalizedText"
                },
                options: [
                    {
                        label: "On lap",
                        value: "lap",
                        __typename: "EGDSInfantSeatRadioButton"
                    },
                    {
                        label: "In seat",
                        value: "seat",
                        __typename: "EGDSInfantSeatRadioButton"
                    }
                ],
                selected: "lap",
                __typename: "EGDSTravelerInfantSeatSelection"
            },
            maxRoomCount: 6,
            rooms: [
                {
                    label: {
                        models: [
                            {
                                key: "roomNumber",
                                source: "roomNumber",
                                __typename: "TemplateModel"
                            }
                        ],
                        template: "Room ${roomNumber}",
                        __typename: "EGDSBasicLocalizedText"
                    },
                    adults: {
                        decreaseAnalytics: {
                            linkName: "Packages - Step input decrease",
                            referrerId: "Web.packages.step.input.decrease",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Packages - Step input increase",
                            referrerId: "Web.packages.step.input.increase",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of adults in this room",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of adults in this room",
                        increaseTextTemplate: null,
                        egdsElementId: null,
                        __typename: "EGDSTravelerStepInput",
                        label: "Adults",
                        max: 6,
                        min: 1,
                        step: 1,
                        subLabel: null,
                        value: 2
                    },
                    children: {
                        count: {
                            decreaseAnalytics: {
                                linkName: "Packages - Step input decrease",
                                referrerId: "Web.packages.step.input.decrease",
                                __typename: "ClientSideAnalytics"
                            },
                            increaseAnalytics: {
                                linkName: "Packages - Step input increase",
                                referrerId: "Web.packages.step.input.increase",
                                __typename: "ClientSideAnalytics"
                            },
                            decreaseText: "Decrease the number of children in this room",
                            decreaseTextTemplate: null,
                            increaseText: "Increase the number of children in this room",
                            increaseTextTemplate: null,
                            egdsElementId: null,
                            __typename: "EGDSTravelerStepInput",
                            label: "Children",
                            max: 5,
                            min: 0,
                            step: 1,
                            subLabel: "Ages 0 to 17",
                            value: 0
                        },
                        ages: [],
                        ageTemplate: {
                            labelTemplate: {
                                models: [
                                    {
                                        key: "childNumber",
                                        source: "childNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Child ${childNumber} age",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            options: [
                                ageOptions("0", "Under 1"),
                                ageOptions("1"),
                                ageOptions("2"),
                                ageOptions("3"),
                                ageOptions("4"),
                                ageOptions("5"),
                                ageOptions("6"),
                                ageOptions("7"),
                                ageOptions("8"),
                                ageOptions("9"),
                                ageOptions("10"),
                                ageOptions("11"),
                                ageOptions("12"),
                                ageOptions("13"),
                                ageOptions("14"),
                                ageOptions("15"),
                                ageOptions("16"),
                                ageOptions("17")
                            ],
                            egdsElementId: null,
                            value: null,
                            __typename: "EGDSTravelerChildAgeSelect"
                        },
                        __typename: "EGDSTravelerChildren"
                    },
                    infants: null,
                    removeRoomButton: {
                        egdsElementId: null,
                        primary: "Remove room",
                        disabled: false,
                        accessibility: null,
                        icon: null,
                        analytics: {
                            linkName: "Packages.Traveler.Remove.Room",
                            referrerId: "Web.Travelers remove room",
                            __typename: "ClientSideAnalytics"
                        },
                        action: null,
                        __typename: "UITertiaryButton"
                    },
                    removeRoomAnnouncement: "Room removed",
                    __typename: "EGDSTravelerSelectorRoom"
                }
            ],
            title: "Travelers",
            validations: infantValidations,
            __typename: "EGDSRoomsTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "rooms",
                models: {
                    models: [
                        {
                            key: "roomCount",
                            source: "roomCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: templateRooms,
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            },
            {
                key: "travelers",
                models: {
                    models: [
                        {
                            key: "travelerCount",
                            source: "travelerCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: templateTravelers,
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            }
        ],
        template: "${travelers}, ${rooms}",
        text: "2 travelers, 1 room",
        __typename: "EGDSCompositeLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    },
    readOnly: false
};
var getFallbackData = function(packageType) {
    var elements = [];
    switch(packageType){
        case "HOTEL_CAR" /* HOTEL_CAR */ :
            elements = [
                destinationLocationField(),
                datePicker2,
                hotelCarTravelSelector
            ];
            break;
        case "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ :
        case "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ :
            elements = [
                searchLocationsFields(packageType),
                datePicker2,
                flightHotelCarTravelSelector,
                cabinFormInput
            ];
            break;
        case "FLIGHT_CAR" /* FLIGHT_CAR */ :
            elements = [
                searchLocationsFields(packageType),
                datePicker2,
                flightCarTravelSelector,
                cabinFormInput
            ];
            break;
        default:
            break;
    }
    return {
        searchForm: {
            packages: {
                errorSummary: errorSummary2,
                search: search2,
                elements: elements,
                __typename: "PackagesSearchForm",
                actionURL: "/flexibleshopping",
                packageSelection: packageSelection,
                searchLocation: searchLocationFallback
            },
            __typename: "SearchFormResults"
        }
    };
};
// src/components/multi-item/form/__private/multi-packages-search-form.tsx
import React87 from "react";
import { gql as gql63 } from "@apollo/client";
import { useLocalization as useLocalization12 } from "@shared-ui/localization-context";
// ../internal/src/components/form/egds-search-form-locations-field/egds-search-form-locations-field.tsx
import React81 from "react";
import { gql as gql58 } from "@apollo/client";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext6 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewMedium as ViewMedium11, Viewport as Viewport14, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
import { UitkInputSwapper } from "uitk-react-input";
// ../internal/src/components/common/button/egds-secondary-button.tsx
import React80 from "react";
import { gql as gql57 } from "@apollo/client";
import { UitkSecondaryButton } from "@egds/react-core/button";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
var __Fragment41 = gql57(_templateObject61(), EGDSButtonFragment);
var EGDSSecondaryButton = function(param) {
    var onClick = param.onClick, data = param.data;
    var egdsElementId = data.egdsElementId, primary = data.primary, analytics = data.analytics;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_secondary_button";
    var track = useClickTracker24();
    var handleClick = React80.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React80.createElement(UitkSecondaryButton, {
        id: id,
        onClick: handleClick
    }, primary);
};
EGDSSecondaryButton.displayName = "EGDSSecondaryButton";
EGDSSecondaryButton.fragment = __Fragment41;
// ../internal/src/components/form/egds-search-form-locations-field/egds-search-form-locations-field.tsx
var __Fragment42 = gql58(_templateObject62(), EGDSSecondaryButton.fragment, EGDSSearchFormLocationField.fragment);
var DISPLAY_NAME12 = "EGDSSearchFormLocationsField";
var getAccessibilityInputSwapperLabel = function(data) {
    var _data_horizontalSwapper, _data_verticalSwapper;
    if (((_data_horizontalSwapper = data.horizontalSwapper) === null || _data_horizontalSwapper === void 0 ? void 0 : _data_horizontalSwapper.__typename) === "UISecondaryButton" && data.horizontalSwapper.accessibility) {
        return data.horizontalSwapper.accessibility;
    }
    if (((_data_verticalSwapper = data.verticalSwapper) === null || _data_verticalSwapper === void 0 ? void 0 : _data_verticalSwapper.__typename) === "UISecondaryButton" && data.verticalSwapper.accessibility) {
        return data.verticalSwapper.accessibility;
    }
};
var EGDSSearchFormLocationsField = function(props) {
    var _validations2_find, _destinationFieldError_validations;
    var originRef = props.originRef, destinationRef = props.destinationRef, data = props.data, adapter = props.adapter, index = props.index, skipReflection = props.skipReflection, onOpenLocationField = props.onOpenLocationField, onLocationsSelection = props.onLocationsSelection, additionalAdapterFields = props.additionalAdapterFields, searchLocationAnalytics = props.searchLocationAnalytics;
    var trackClick = useClickTracker25();
    var _useSearchFormReflectionContext6 = useSearchFormReflectionContext6(), state = _useSearchFormReflectionContext6.state, dispatch = _useSearchFormReflectionContext6.dispatch;
    var origin2 = data.origin, destination4 = data.destination, validations2 = data.validations;
    var originFieldError = originRef.originFieldError, setFieldRefByTypenameOrigin = originRef.setFieldRefByTypename;
    var destinationFieldError = destinationRef.destinationFieldError, setFieldRefByTypenameDestination = destinationRef.setFieldRefByTypename;
    var reflectionDestination = state.destination, reflectionOrigin = state.origin;
    var _origin2_value;
    var _React81_useState = _sliced_to_array(React81.useState(!skipReflection && reflectionOrigin ? reflectionOrigin : {
        term: (_origin2_value = origin2.value) !== null && _origin2_value !== void 0 ? _origin2_value : "",
        data: {
            regionId: "",
            regionNames: {
                shortName: ""
            },
            hierarchyInfo: {
                airport: {
                    airportCode: ""
                }
            },
            location: {
                lat: "",
                long: ""
            }
        }
    }), 2), originSelection = _React81_useState[0], setOriginSelection = _React81_useState[1];
    var _destination4_value;
    var _React81_useState1 = _sliced_to_array(React81.useState(!skipReflection && reflectionDestination ? reflectionDestination : {
        term: (_destination4_value = destination4.value) !== null && _destination4_value !== void 0 ? _destination4_value : "",
        data: {
            regionId: "",
            regionNames: {
                shortName: ""
            },
            hierarchyInfo: {
                airport: {
                    airportCode: ""
                }
            },
            location: {
                lat: "",
                long: ""
            }
        }
    }), 2), destinationSelection = _React81_useState1[0], setDestinationSelection = _React81_useState1[1];
    var trackOnSwapClick = function(isHorizontalSwapper) {
        var _data_horizontalSwapper, _data_verticalSwapper;
        if (isHorizontalSwapper && (data === null || data === void 0 ? void 0 : (_data_horizontalSwapper = data.horizontalSwapper) === null || _data_horizontalSwapper === void 0 ? void 0 : _data_horizontalSwapper.__typename) === "UISecondaryButton" && data.horizontalSwapper.analytics) {
            trackClick(data.horizontalSwapper.analytics.referrerId, data.horizontalSwapper.analytics.linkName);
        } else if (!isHorizontalSwapper && (data === null || data === void 0 ? void 0 : (_data_verticalSwapper = data.verticalSwapper) === null || _data_verticalSwapper === void 0 ? void 0 : _data_verticalSwapper.__typename) === "UISecondaryButton" && data.verticalSwapper.analytics) {
            trackClick(data.verticalSwapper.analytics.referrerId, data.verticalSwapper.analytics.linkName);
        }
    };
    var onLocationSwap = function() {
        if (!skipReflection) {
            dispatch({
                type: "UPDATE_DESTINATION",
                location: originSelection.data ? originSelection : _object_spread_props(_object_spread({}, originSelection), {
                    data: {}
                })
            });
            dispatch({
                type: "UPDATE_ORIGIN",
                location: destinationSelection.data ? destinationSelection : _object_spread_props(_object_spread({}, destinationSelection), {
                    data: {}
                })
            });
        }
        setOriginSelection(_object_spread({}, destinationSelection));
        setDestinationSelection(_object_spread({}, originSelection));
    };
    var onLocationSwapHorizontal = function() {
        onLocationSwap();
        trackOnSwapClick(true);
    };
    var onLocationSwapVertical = function() {
        onLocationSwap();
        trackOnSwapClick(false);
    };
    var getOriginLocationValue = function(selection) {
        setOriginSelection(selection);
        if (onLocationsSelection) {
            onLocationsSelection({
                term: selection.term,
                data: _object_spread_props(_object_spread({}, selection.data), {
                    origin: selection.data ? selection.data.regionNames.shortName : selection.term,
                    destination: destinationSelection.term,
                    index: index
                })
            });
        }
    };
    var getDestinationLocationValue = function(selection) {
        setDestinationSelection(selection);
        if (onLocationsSelection) {
            onLocationsSelection({
                term: selection.term,
                data: _object_spread_props(_object_spread({}, selection.data), {
                    origin: originSelection.term,
                    destination: selection.data ? selection.data.regionNames.shortName : selection.term,
                    index: index
                })
            });
        }
    };
    var defaultLocationFieldProps = {
        adapter: adapter,
        index: index,
        onOpenLocationField: onOpenLocationField,
        additionalAdapterFields: additionalAdapterFields,
        skipReflection: skipReflection,
        searchLocationAnalytics: searchLocationAnalytics
    };
    var _validations2_find_errorMessage;
    var errorMessageTest = (_validations2_find_errorMessage = validations2 === null || validations2 === void 0 ? void 0 : (_validations2_find = validations2.find(function(validation) {
        return validation.__typename === "EGDSSameValueInputValidation";
    })) === null || _validations2_find === void 0 ? void 0 : _validations2_find.errorMessage) !== null && _validations2_find_errorMessage !== void 0 ? _validations2_find_errorMessage : "";
    var originLocation = /* @__PURE__ */ React81.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, defaultLocationFieldProps), {
        additionalAdapterFields: _object_spread_props(_object_spread({}, additionalAdapterFields), {
            trending: false
        }),
        setFieldRefByTypename: setFieldRefByTypenameOrigin,
        fieldError: originFieldError,
        data: origin2,
        onSelection: getOriginLocationValue,
        selection: originSelection,
        onLocationsSelection: getOriginLocationValue,
        searchLocationAnalytics: searchLocationAnalytics
    }));
    var locationsErrorText = (destinationFieldError === null || destinationFieldError === void 0 ? void 0 : (_destinationFieldError_validations = destinationFieldError.validations) === null || _destinationFieldError_validations === void 0 ? void 0 : _destinationFieldError_validations.sameLocationSelected) ? errorMessageTest : void 0;
    var destinationLocation = /* @__PURE__ */ React81.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, defaultLocationFieldProps), {
        setFieldRefByTypename: setFieldRefByTypenameDestination,
        fieldError: destinationFieldError,
        locationsErrorText: locationsErrorText,
        data: destination4,
        onSelection: getDestinationLocationValue,
        selection: destinationSelection,
        onLocationsSelection: getDestinationLocationValue,
        searchLocationAnalytics: searchLocationAnalytics
    }));
    var accessibilityLabel = getAccessibilityInputSwapperLabel(data);
    return /* @__PURE__ */ React81.createElement(Viewport14, null, /* @__PURE__ */ React81.createElement(ViewSmall12, null, /* @__PURE__ */ React81.createElement(UitkInputSwapper, {
        startInput: originLocation,
        isHorizontalSwapper: false,
        onSwapButtonClick: onLocationSwapVertical,
        endInput: destinationLocation,
        a11ySwapButtonLabel: accessibilityLabel
    })), /* @__PURE__ */ React81.createElement(ViewMedium11, null, /* @__PURE__ */ React81.createElement(UitkInputSwapper, {
        startInput: originLocation,
        onSwapButtonClick: onLocationSwapHorizontal,
        endInput: destinationLocation,
        a11ySwapButtonLabel: accessibilityLabel
    })));
};
EGDSSearchFormLocationsField.displayName = DISPLAY_NAME12;
EGDSSearchFormLocationsField.fragment = _object_spread_props(_object_spread({}, __Fragment42), {
    __typename: DISPLAY_NAME12
});
// ../internal/src/components/form/search-form-messaging/search-form-messaging.tsx
import React85 from "react";
import { gql as gql61 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
import { ViewMedium as ViewMedium13, Viewport as Viewport16, ViewSizes as ViewSizes4, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-card.tsx
import React84 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
// ../internal/src/components/form/search-form-messaging/layout-field-config.ts
var FLEX_ITEM_FIELDS = {
    LEFT_ICON: "LeftIconFlexItem",
    DEFAULT: "default"
};
var flexItemLayoutProps = {
    SMALL: {
        LeftIconFlexItem: {
            alignSelf: void 0
        },
        default: {
            alignSelf: "center"
        }
    },
    MEDIUM: {
        LeftIconFlexItem: {
            alignSelf: "center"
        },
        default: {}
    },
    LARGE: {
        default: {}
    },
    EXTRA_LARGE: {
        default: {}
    }
};
var getFlexItemPropsByFieldName = function(fieldName5, viewportSize) {
    var componentPropsMappingByViewport = flexItemLayoutProps[viewportSize];
    var _componentPropsMappingByViewport_fieldName5;
    return (_componentPropsMappingByViewport_fieldName5 = componentPropsMappingByViewport[fieldName5]) !== null && _componentPropsMappingByViewport_fieldName5 !== void 0 ? _componentPropsMappingByViewport_fieldName5 : componentPropsMappingByViewport.default;
};
var flexLayoutProps = {
    SMALL: {
        space: "one",
        justifyContent: "center",
        alignItems: "center"
    },
    MEDIUM: {
        alignItems: void 0
    },
    LARGE: {},
    EXTRA_LARGE: {}
};
var getFlexLayoutProps = function(viewportSize) {
    return flexLayoutProps[viewportSize];
};
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-info-trigger.tsx
import React83 from "react";
import { gql as gql60 } from "@apollo/client";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-sheet.tsx
import React82 from "react";
import { gql as gql59 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSSheet, EGDSSheetCloseButton, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium12, Viewport as Viewport15, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
var _fragment3 = gql59(_templateObject63());
var EGDSSheetType = {
    POPOVER: "popover" /* POPOVER */ ,
    BOTTOM: "bottom" /* BOTTOM */ ,
    CENTERED: "centered" /* CENTERED */ ,
    FULL: "full" /* FULL */ ,
    SIDE: "side" /* SIDE */ 
};
var SearchFormMessagingSheet = function(props) {
    var _sheetTypes_find_sheetType, _sheetTypes_find, _sheetTypes_find_sheetType1, _sheetTypes_find1;
    var toggleVisibility = props.toggleVisibility, children = props.children, isVisible = props.isVisible, data = props.data;
    var track = useClickTracker26();
    var closeAccessibility = data.closeAccessibility, sheetTypes = data.sheetTypes, closeAnalytics = data.closeAnalytics;
    var _sheetTypes_find_sheetType_toString;
    var mobileSheetType = EGDSSheetType[(_sheetTypes_find_sheetType_toString = sheetTypes === null || sheetTypes === void 0 ? void 0 : (_sheetTypes_find = sheetTypes.find(function(sheet) {
        return sheet.viewSize === "SMALL" /* SMALL */ ;
    })) === null || _sheetTypes_find === void 0 ? void 0 : (_sheetTypes_find_sheetType = _sheetTypes_find.sheetType) === null || _sheetTypes_find_sheetType === void 0 ? void 0 : _sheetTypes_find_sheetType.toString()) !== null && _sheetTypes_find_sheetType_toString !== void 0 ? _sheetTypes_find_sheetType_toString : "BOTTOM"];
    var _sheetTypes_find_sheetType_toString1;
    var desktopSheetType = EGDSSheetType[(_sheetTypes_find_sheetType_toString1 = sheetTypes === null || sheetTypes === void 0 ? void 0 : (_sheetTypes_find1 = sheetTypes.find(function(sheet) {
        return sheet.viewSize === "LARGE" /* LARGE */ ;
    })) === null || _sheetTypes_find1 === void 0 ? void 0 : (_sheetTypes_find_sheetType1 = _sheetTypes_find1.sheetType) === null || _sheetTypes_find_sheetType1 === void 0 ? void 0 : _sheetTypes_find_sheetType1.toString()) !== null && _sheetTypes_find_sheetType_toString1 !== void 0 ? _sheetTypes_find_sheetType_toString1 : "POPOVER"];
    var handleOnDismiss = function() {
        var linkName = closeAnalytics.linkName, referrerId = closeAnalytics.referrerId;
        track(referrerId, linkName);
        if (toggleVisibility) {
            toggleVisibility();
        }
    };
    var closeButton = /* @__PURE__ */ React82.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */ React82.createElement(EGDSTertiaryButton2, {
        type: "button",
        onClick: handleOnDismiss
    }, /* @__PURE__ */ React82.createElement(EGDSIcon3, {
        name: "close",
        title: closeAccessibility !== null && closeAccessibility !== void 0 ? closeAccessibility : "",
        id: "sheet-close-button"
    })));
    var commonSheetContent = /* @__PURE__ */ React82.createElement(EGDSSheetContent, {
        padded: true
    }, children);
    return /* @__PURE__ */ React82.createElement(EGDSSheetTransition, {
        isVisible: isVisible
    }, /* @__PURE__ */ React82.createElement(Viewport15, null, /* @__PURE__ */ React82.createElement(ViewSmall13, null, /* @__PURE__ */ React82.createElement(EGDSSheet, {
        isVisible: isVisible,
        type: mobileSheetType,
        triggerRef: null,
        onDismiss: handleOnDismiss
    }, closeButton, commonSheetContent)), /* @__PURE__ */ React82.createElement(ViewMedium12, null, /* @__PURE__ */ React82.createElement(EGDSSheet, {
        position: {
            inline: "leading",
            block: "trailing"
        },
        isVisible: isVisible,
        type: desktopSheetType,
        triggerRef: null,
        onDismiss: handleOnDismiss,
        width: 360,
        applyBlockStartMargin: true
    }, closeButton, commonSheetContent))));
};
SearchFormMessagingSheet.fragment = _fragment3;
SearchFormMessagingSheet.displayName = "SearchFormMessagingSheet";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-info-trigger.tsx
var _fragment4 = gql60(_templateObject64(), Icon.fragment, SearchFormMessagingSheet.fragment);
var MoreInfoTrigger = React83.forwardRef(function(param, ref) {
    var data = param.data, children = param.children, onHandleClick = param.onHandleClick;
    var icon = data.icon, text = data.text, analytics = data.triggerAction.analytics;
    var track = useClickTracker27();
    var triggerIcon = _object_spread_props(_object_spread({}, icon), {
        size: "SMALL" /* SMALL */ ,
        description: ""
    });
    var handleOnClick = function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        if (onHandleClick) {
            onHandleClick();
        }
    };
    return /* @__PURE__ */ React83.createElement(EGDSMoreInfoTrigger, {
        theme: "default"
    }, /* @__PURE__ */ React83.createElement("button", {
        type: "button",
        onClick: handleOnClick,
        ref: ref
    }, children !== null && children !== void 0 ? children : /* @__PURE__ */ React83.createElement(EGDSText3, null, text), /* @__PURE__ */ React83.createElement(Icon, {
        data: triggerIcon
    })));
});
MoreInfoTrigger.fragment = _fragment4;
MoreInfoTrigger.displayName = "EGDSMoreInfoTrigger";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-card.tsx
var MessagingCardText = function(param) {
    var mainText = param.mainText, replacementTexts = param.replacementTexts;
    var priceText = mainText.split(/\${|\}/g);
    var children = priceText.map(function(text, index) {
        var price = replacementTexts[text];
        if (price) {
            return /* @__PURE__ */ React84.createElement(EGDSText4, {
                key: index,
                inline: "strong"
            }, price);
        }
        return /* @__PURE__ */ React84.createElement(React84.Fragment, null, text);
    });
    return /* @__PURE__ */ React84.createElement(EGDSText4, null, children);
};
var SearchFormMessagingCard = function(param) {
    var viewSize = param.viewSize, toggleVisibility = param.toggleVisibility, triggerRef = param.triggerRef, data = param.data;
    var icon = data.icon, moreInfoTrigger = data.moreInfoTrigger, text = data.text;
    var _text_template, _text_replacementTexts;
    return /* @__PURE__ */ React84.createElement(EGDSCard, {
        padded: true,
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React84.createElement(EGDSLayoutFlex2, _object_spread({}, getFlexLayoutProps(viewSize)), icon && /* @__PURE__ */ React84.createElement(EGDSLayoutFlexItem2, _object_spread({}, getFlexItemPropsByFieldName(FLEX_ITEM_FIELDS.LEFT_ICON, viewSize)), /* @__PURE__ */ React84.createElement(Icon, {
        data: _object_spread_props(_object_spread({}, icon), {
            size: "SMALL" /* SMALL */ 
        })
    })), moreInfoTrigger && /* @__PURE__ */ React84.createElement(EGDSLayoutFlexItem2, _object_spread({}, getFlexItemPropsByFieldName(FLEX_ITEM_FIELDS.DEFAULT, viewSize)), /* @__PURE__ */ React84.createElement(EGDSSpacing4, {
        margin: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React84.createElement("div", null, /* @__PURE__ */ React84.createElement(MoreInfoTrigger, {
        data: moreInfoTrigger,
        onHandleClick: toggleVisibility,
        ref: triggerRef
    }, /* @__PURE__ */ React84.createElement(MessagingCardText, {
        mainText: (_text_template = text === null || text === void 0 ? void 0 : text.template) !== null && _text_template !== void 0 ? _text_template : "",
        replacementTexts: (_text_replacementTexts = text === null || text === void 0 ? void 0 : text.replacementTexts) !== null && _text_replacementTexts !== void 0 ? _text_replacementTexts : []
    })))))));
};
// ../internal/src/components/form/search-form-messaging/search-form-messaging.tsx
var _fragment5 = gql61(_templateObject65(), Icon.fragment, MoreInfoTrigger.fragment);
var SearchFormMessaging = function(props) {
    var data = props.data;
    var moreInfoTrigger = data.moreInfoTrigger;
    var _React85_useState = _sliced_to_array(React85.useState(false), 2), isSheetVisible = _React85_useState[0], setSheetVisibility = _React85_useState[1];
    var triggerRef = React85.useRef(null);
    var toggleVisibility = function() {
        setSheetVisibility(function(prevState) {
            if (prevState) {
                var _triggerRef_current;
                (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
            }
            return !prevState;
        });
    };
    var searchFormMessagingCardProps = {
        data: data,
        toggleVisibility: toggleVisibility,
        triggerRef: triggerRef,
        viewSize: ViewSizes4.SMALL
    };
    return /* @__PURE__ */ React85.createElement(React85.Fragment, null, /* @__PURE__ */ React85.createElement(Viewport16, null, /* @__PURE__ */ React85.createElement(ViewSmall14, null, /* @__PURE__ */ React85.createElement(SearchFormMessagingCard, _object_spread({}, searchFormMessagingCardProps))), /* @__PURE__ */ React85.createElement(ViewMedium13, null, /* @__PURE__ */ React85.createElement(SearchFormMessagingCard, _object_spread_props(_object_spread({}, searchFormMessagingCardProps), {
        viewSize: ViewSizes4.MEDIUM
    })))), moreInfoTrigger && /* @__PURE__ */ React85.createElement(SearchFormMessagingSheet, {
        isVisible: isSheetVisible,
        data: moreInfoTrigger.triggerAction.sheet,
        toggleVisibility: toggleVisibility
    }, /* @__PURE__ */ React85.createElement(EGDSParagraph, {
        size: 2
    }, moreInfoTrigger.triggerAction.text)));
};
SearchFormMessaging.fragment = _fragment5;
SearchFormMessaging.displayName = "SearchFormMessaging";
// ../internal/src/components/form/search-form-partial-stay.tsx
import React86 from "react";
import { gql as gql62 } from "@apollo/client";
var __Fragment43 = gql62(_templateObject66(), EGDSSearchFormDatePickerField.fragment, EGDSSearchFormDatePickerField.fragment);
var SearchFormPartialStay = function(param) {
    var data = param.data, setFieldRefByTypename = param.setFieldRefByTypename, fieldError = param.fieldError;
    var addPartialStay = data.addPartialStay, dates = data.dates, errorMessage = data.errorMessage;
    var _addPartialStay_state;
    var _React86_useState = _sliced_to_array(React86.useState((_addPartialStay_state = addPartialStay === null || addPartialStay === void 0 ? void 0 : addPartialStay.state) !== null && _addPartialStay_state !== void 0 ? _addPartialStay_state : "UNCHECKED" /* UNCHECKED */ ), 2), checked = _React86_useState[0], setChecked = _React86_useState[1];
    var handleCheckboxChange = function(event) {
        setChecked(event.target.checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ );
    };
    var handleFieldRef = function(typename, ref, refIndex) {
        setFieldRefByTypename("".concat(typename, "PartialStay"), ref, refIndex);
    };
    var datesField = dates && /* @__PURE__ */ React86.createElement("div", {
        "data-stid": "partial-stay-date-field"
    }, /* @__PURE__ */ React86.createElement(AddtionalFieldWithLayout, null, /* @__PURE__ */ React86.createElement(EGDSSearchFormDatePickerField, {
        skipReflection: true,
        data: dates,
        fieldError: fieldError,
        setFieldRefByTypename: handleFieldRef,
        overrideErrorMessage: errorMessage
    })));
    return /* @__PURE__ */ React86.createElement(React86.Fragment, null, addPartialStay && /* @__PURE__ */ React86.createElement(EGDSCheckBox, {
        onChange: handleCheckboxChange,
        data: addPartialStay
    }), checked === "CHECKED" /* CHECKED */  && datesField);
};
SearchFormPartialStay.displayName = "SearchFormPartialStay";
SearchFormPartialStay.fragment = __Fragment43;
// src/components/multi-item/form/__private/multi-packages-search-form.tsx
import { ViewLarge as ViewLarge8, ViewMedium as ViewMedium14, Viewport as Viewport17, ViewSizes as ViewSizes6, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm5 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
// src/components/multi-item/util/fields-map.ts
var FieldNameMap2 = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["ORIGIN"] = "origin_select";
    FieldNameMap8["DESTINATION"] = "destination_select";
    FieldNameMap8["TRAVEL_DATES"] = "EGDSDateRangePicker";
    FieldNameMap8["TRAVELER_SELECTOR"] = "EGDSRoomsTravelerSelector";
    FieldNameMap8["CABIN_CLASS"] = "EGDSSearchFormInputFieldWithSelection-cabin_class";
    return FieldNameMap8;
}(FieldNameMap2 || {});
// src/components/multi-item/util/layout-field-config.ts
import { ViewSizes as ViewSizes5 } from "@shared-ui/viewport-context";
var FLIGHT_LAYOUT = {
    SMALL: {
        default: {}
    },
    MEDIUM: {
        default: {
            grow: 1
        },
        EGDSSearchFormLocationsField: {
            minWidth: "full_width"
        },
        EGDSSearchFormButton: {}
    },
    LARGE: {
        default: {
            grow: 1
        },
        EGDSSearchFormLocationsField: {
            minWidth: 500,
            grow: 1
        },
        EGDSSearchFormButton: {}
    },
    EXTRA_LARGE: {
        default: {}
    }
};
var _obj4;
var layoutFieldConfigViewportMapping = {
    prebundles: (_obj4 = {}, _define_property(_obj4, ViewSizes5.SMALL, {
        default: {}
    }), _define_property(_obj4, ViewSizes5.MEDIUM, {
        EGDSSearchFormLocationField: {
            minWidth: "full_width"
        },
        EGDSSearchFormButton: {},
        default: {
            grow: 1
        }
    }), _define_property(_obj4, ViewSizes5.LARGE, {
        EGDSSearchFormButton: {},
        EGDSSearchFormTravelersField: {
            maxWidth: 400,
            grow: 1
        },
        EGDSSearchFormDatePickerField: {
            maxWidth: 400,
            grow: 1
        },
        default: {
            minWidth: "third_width",
            grow: 1
        }
    }), _define_property(_obj4, ViewSizes5.EXTRA_LARGE, {
        default: {}
    }), _obj4),
    FLIGHT_CAR: FLIGHT_LAYOUT,
    FLIGHT_HOTEL: FLIGHT_LAYOUT,
    FLIGHT_HOTEL_CAR: FLIGHT_LAYOUT,
    HOTEL_CAR: {
        SMALL: {
            default: {}
        },
        MEDIUM: {
            default: {
                grow: 1,
                minWidth: 400
            },
            EGDSSearchFormTravelersField: {
                minWidth: 500,
                grow: 1
            },
            EGDSSearchFormButton: {}
        },
        LARGE: {
            EGDSSearchFormButton: {},
            EGDSSearchFormTravelersField: {
                maxWidth: 300,
                grow: 1
            },
            EGDSSearchFormDatePickerField: {
                maxWidth: 300,
                grow: 1
            },
            default: {
                grow: 1
            }
        },
        EXTRA_LARGE: {
            default: {}
        }
    }
};
var getFlexItemPropsByFieldType = function(typename, viewportSize) {
    var packageType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "prebundles";
    var componentPropsMappingByViewport = layoutFieldConfigViewportMapping[packageType][viewportSize];
    var _componentPropsMappingByViewport_typename;
    return (_componentPropsMappingByViewport_typename = componentPropsMappingByViewport[typename]) !== null && _componentPropsMappingByViewport_typename !== void 0 ? _componentPropsMappingByViewport_typename : componentPropsMappingByViewport.default;
};
var _obj5;
// src/components/multi-item/util/query-params.ts
var packageTypeMap = (_obj5 = {}, _define_property(_obj5, "FLIGHT_CAR" /* FLIGHT_CAR */ , "fc"), _define_property(_obj5, "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ , "fh"), _define_property(_obj5, "HOTEL_CAR" /* HOTEL_CAR */ , "hc"), _define_property(_obj5, "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ , "fhc"), _define_property(_obj5, "HOTEL_ACTIVITY" /* HOTEL_ACTIVITY */ , "ha"), _obj5);
var cabinClassTypeMap = {
    BUSINESS: "b",
    FIRST: "f",
    PREMIUM_ECONOMY: "p",
    COACH: "e"
};
var getQueryParamDateVariant = function(key, date) {
    var day = date.day, month = date.month, year = date.year;
    return "&".concat(key, "=").concat(year, "-").concat(month, "-").concat(day);
};
var getURLQueryParamsFromCriteria = function(criteria, packageType, directFlightsOnlySwitch) {
    var _criteria_secondary_selections, _criteria_secondary;
    var _criteria_primary = criteria.primary, cabinClass = _criteria_primary.cabinClass, dateRange = _criteria_primary.dateRange, destination4 = _criteria_primary.destination, origin2 = _criteria_primary.origin, travelerOccupancyGroups = _criteria_primary.travelerOccupancyGroups, partialStayDateRange = _criteria_primary.partialStayDateRange;
    var numberOfRomms = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function(travelers) {
        return travelers.travelers;
    }).length;
    var numberOfRommsQueryString = "&numberOfRooms=".concat(numberOfRomms);
    var _travelerOccupancyGroups_map;
    var infantInSeat = (_travelerOccupancyGroups_map = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function(travelersRoom) {
        return travelersRoom.travelers.filter(function(traveler) {
            return traveler.type === "INFANT_IN_SEAT";
        });
    })) !== null && _travelerOccupancyGroups_map !== void 0 ? _travelerOccupancyGroups_map : [];
    var checkInfantsInRoom = infantInSeat.filter(function(infants) {
        return infants.length > 0;
    });
    var infantInSeatQueryString = "&infantsInSeats=".concat(checkInfantsInRoom.length > 0 ? 1 : 0);
    var _travelerOccupancyGroups_map1;
    var infantOnLap = (_travelerOccupancyGroups_map1 = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function(travelersRoom) {
        return travelersRoom.travelers.filter(function(traveler) {
            return traveler.type === "INFANT_IN_LAP";
        });
    })) !== null && _travelerOccupancyGroups_map1 !== void 0 ? _travelerOccupancyGroups_map1 : [];
    var checkInfantsOnLap = infantOnLap.filter(function(infants) {
        return infants.length > 0;
    });
    var infantOnLapQueryString = "&infantsOnLap=".concat(checkInfantsOnLap.length > 0 ? 1 : 0);
    var _travelerOccupancyGroups_map2;
    var children = (_travelerOccupancyGroups_map2 = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function(travelersRoom) {
        return travelersRoom.travelers.filter(function(traveler) {
            return traveler.type === "CHILD" || traveler.type === "INFANT_IN_LAP" || traveler.type === "INFANT_IN_SEAT";
        });
    })) !== null && _travelerOccupancyGroups_map2 !== void 0 ? _travelerOccupancyGroups_map2 : [];
    var childAgesQueryString = children.length > 0 ? children.map(function(childrenRoom, roomIndex) {
        return childrenRoom.map(function(child, childIndex) {
            return "&childAges[".concat(roomIndex + 1, "][").concat(childIndex, "]=").concat(child.age);
        }).join("");
    }).join("") : "";
    var childrenPerRoomQueryString = children.length > 0 ? "".concat(children.map(function(childrenRoom, childIndex) {
        return "&childrenPerRoom[".concat(childIndex + 1, "]=").concat(childrenRoom.length);
    }).join("")) : "";
    var _travelerOccupancyGroups_map3;
    var adults = (_travelerOccupancyGroups_map3 = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function(travelersRoom) {
        return travelersRoom.travelers.filter(function(traveler) {
            return traveler.type === "ADULT";
        });
    })) !== null && _travelerOccupancyGroups_map3 !== void 0 ? _travelerOccupancyGroups_map3 : [];
    var adultsPerRoomQueryString = adults.length > 0 ? adults.map(function(adultRoom, index) {
        return "&adultsPerRoom[".concat(index + 1, "]=").concat(adultRoom.length);
    }).join("") : "";
    var hasInfantsOnLap = infantOnLap.length > 0;
    var hasInfantsInSeat = infantInSeat.length > 0;
    var infantsType = hasInfantsOnLap ? "lap" : "seat";
    var infantsTypeQueryString = hasInfantsOnLap || hasInfantsInSeat ? "&InfantSeating=".concat(infantsType) : "";
    var travelersQueryString = "".concat(numberOfRommsQueryString).concat(adultsPerRoomQueryString).concat(childAgesQueryString).concat(childrenPerRoomQueryString).concat(infantOnLapQueryString).concat(infantInSeatQueryString).concat(infantsTypeQueryString);
    var originQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */  ? "origin=".concat(origin2 === null || origin2 === void 0 ? void 0 : origin2.regionName) : "";
    var destinationQueryString = "&destination=".concat(destination4 === null || destination4 === void 0 ? void 0 : destination4.regionName);
    var destinationIdQueryString = (destination4 === null || destination4 === void 0 ? void 0 : destination4.regionId) ? "&destinationId=".concat(destination4 === null || destination4 === void 0 ? void 0 : destination4.regionId) : "";
    var destinationTtlaQueryString = (destination4 === null || destination4 === void 0 ? void 0 : destination4.airportCode) ? "&ttla=".concat(destination4 === null || destination4 === void 0 ? void 0 : destination4.airportCode) : "";
    var locationQueryString = "".concat(originQueryString).concat(destinationQueryString).concat(destinationIdQueryString).concat(destinationTtlaQueryString);
    var datesQueryString = dateRange ? "".concat(getQueryParamDateVariant("fromDate", dateRange.start)).concat(dateRange.end ? getQueryParamDateVariant("toDate", dateRange.end) : "").concat(getQueryParamDateVariant("d1", dateRange.start)).concat(dateRange.end ? getQueryParamDateVariant("d2", dateRange.end) : "") : "";
    var isPartialStayProduct = packageType === "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */  || packageType === "FLIGHT_HOTEL" /* FLIGHT_HOTEL */  || packageType === "HOTEL_CAR" /* HOTEL_CAR */ ;
    var partialStayDatesQueryString = partialStayDateRange ? "".concat(getQueryParamDateVariant("checkInDate", partialStayDateRange.start)).concat(getQueryParamDateVariant("checkOutDate", partialStayDateRange.end), "&isPartialStay=1\n  &partialStayCheckbox=true") : "&isPartialStay=0";
    var finalPartialStayDatesQueryString = isPartialStayProduct ? partialStayDatesQueryString : "";
    var packageTypeQueryString = "&packageType=".concat(packageTypeMap[packageType]);
    var cabinClassQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */  && cabinClass ? "&cabinClass=".concat(cabinClassTypeMap[cabinClass]) : "";
    var originIdQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */  && (origin2 === null || origin2 === void 0 ? void 0 : origin2.regionId) ? "&originId=".concat(origin2.regionId) : "";
    var ftlaQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */  && (origin2 === null || origin2 === void 0 ? void 0 : origin2.airportCode) ? "&ftla=".concat(origin2.airportCode) : "";
    var tripTypeQueryString = packageType === "FLIGHT_HOTEL" /* FLIGHT_HOTEL */  ? "&tripType=ROUND_TRIP" : "";
    var hotelIdSelection = packageType !== "FLIGHT_CAR" /* FLIGHT_CAR */  ? (_criteria_secondary = criteria.secondary) === null || _criteria_secondary === void 0 ? void 0 : (_criteria_secondary_selections = _criteria_secondary.selections) === null || _criteria_secondary_selections === void 0 ? void 0 : _criteria_secondary_selections.find(function(selection) {
        return selection.id === "hotelId";
    }) : void 0;
    var hotelIdQueryString = (hotelIdSelection === null || hotelIdSelection === void 0 ? void 0 : hotelIdSelection.value) ? "&hotelId=".concat(hotelIdSelection.value) : "";
    var directFlightsEnabled = directFlightsOnlySwitch && packageType !== "HOTEL_CAR" /* HOTEL_CAR */  ? "&isDirectFlight=true" : "";
    return "?".concat(locationQueryString).concat(travelersQueryString).concat(datesQueryString).concat(packageTypeQueryString).concat(cabinClassQueryString).concat(originIdQueryString).concat(ftlaQueryString).concat(tripTypeQueryString).concat(finalPartialStayDatesQueryString).concat(hotelIdQueryString).concat(directFlightsEnabled);
};
// src/components/multi-item/util/search-criteria.ts
var EGDS_PREFIX = "EGDS";
var _obj6;
var TravelersTypeMap = (_obj6 = {}, _define_property(_obj6, ADULT_COUNT_NAME_PREFIX, "ADULT" /* ADULT */ ), _define_property(_obj6, CHILDREN_NAME_PREFIX, "CHILD" /* CHILD */ ), _define_property(_obj6, INFANT_ON_LAP_NAME_PREFIX, "INFANT_IN_LAP" /* INFANT_IN_LAP */ ), _define_property(_obj6, INFANT_IN_SEAT_NAME_PREFIX, "INFANT_IN_SEAT" /* INFANT_IN_SEAT */ ), _obj6);
var CabinClassMap = {
    COACH: "COACH" /* COACH */ ,
    ECONOMY_PREMIUM: "PREMIUM_ECONOMY" /* PREMIUM_ECONOMY */ ,
    BUSINESS: "BUSINESS" /* BUSINESS */ ,
    FIRST_CLASS: "FIRST" /* FIRST */ 
};
var packagesCriteriaReducer = function(criteria, param) {
    var name = param.name, value = param.value;
    if (name.startsWith("".concat(INPUT_FIELD__WITH_SELECTION_PREFIX))) {
        var primary = _object_spread_props(_object_spread({}, criteria.primary), {
            cabinClass: CabinClassMap[value]
        });
        return _object_spread_props(_object_spread({}, criteria), {
            primary: primary
        });
    }
    if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
        var isAdult = name.startsWith(ADULT_COUNT_NAME_PREFIX);
        var childKeys = name.split("-");
        var key = isAdult ? ADULT_COUNT_NAME_PREFIX : childKeys.slice(0, 2).join("-");
        var numericValue = Number.parseInt(value, 10);
        var travelers = isAdult ? Array.from(Array(numericValue).keys()).map(function() {
            return {
                type: TravelersTypeMap[key],
                age: null
            };
        }) : [
            {
                type: TravelersTypeMap[key],
                age: value ? numericValue : null
            }
        ];
        var defaultRoomNumber = 1;
        var _name_split_;
        var roomString = (_name_split_ = name.split("".concat(key, "-Room"))[1]) !== null && _name_split_ !== void 0 ? _name_split_ : "1";
        var _parseInt;
        var roomNumber = (_parseInt = parseInt(roomString, 10)) !== null && _parseInt !== void 0 ? _parseInt : defaultRoomNumber;
        var _criteria_primary_travelerOccupancyGroups;
        var travelerOccupancyGroups = _to_consumable_array((_criteria_primary_travelerOccupancyGroups = criteria.primary.travelerOccupancyGroups) !== null && _criteria_primary_travelerOccupancyGroups !== void 0 ? _criteria_primary_travelerOccupancyGroups : []);
        travelerOccupancyGroups[roomNumber - 1] = {
            travelers: _to_consumable_array(travelerOccupancyGroups[roomNumber - 1] ? travelerOccupancyGroups[roomNumber - 1].travelers : []).concat(_to_consumable_array(travelers))
        };
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                travelerOccupancyGroups: travelerOccupancyGroups
            })
        });
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-origin"))) {
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                origin: {
                    airportCode: "",
                    regionName: value
                }
            })
        });
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination"))) {
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                destination: {
                    airportCode: "",
                    regionName: value
                }
            })
        });
    }
    var isStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX);
    var isEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX);
    if (isStartDate || isEndDate) {
        var _criteria_primary_dateRange, _criteria_primary_dateRange1;
        var _value_split_map = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var defaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var newDate = {
            day: day,
            month: month,
            year: year
        };
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                dateRange: {
                    start: isStartDate ? newDate : ((_criteria_primary_dateRange = criteria.primary.dateRange) === null || _criteria_primary_dateRange === void 0 ? void 0 : _criteria_primary_dateRange.start) || defaultDate,
                    end: isEndDate ? newDate : ((_criteria_primary_dateRange1 = criteria.primary.dateRange) === null || _criteria_primary_dateRange1 === void 0 ? void 0 : _criteria_primary_dateRange1.end) || defaultDate
                }
            })
        });
    }
    if (name.startsWith("".concat(AIRPORT_CODE_NAME_PREFIX, "-origin"))) {
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                origin: _object_spread_props(_object_spread({}, criteria.primary.origin), {
                    airportCode: value
                })
            })
        });
    }
    if (name.startsWith("".concat(AIRPORT_CODE_NAME_PREFIX, "-destination"))) {
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                destination: _object_spread_props(_object_spread({}, criteria.primary.destination), {
                    airportCode: value
                })
            })
        });
    }
    if (name.startsWith("".concat(DESTINATION_ID_NAME_PREFIX, "-destination"))) {
        var _criteria_primary_destination;
        var _criteria_primary_destination_airportCode;
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                destination: _object_spread_props(_object_spread({}, criteria.primary.destination), {
                    airportCode: (_criteria_primary_destination_airportCode = (_criteria_primary_destination = criteria.primary.destination) === null || _criteria_primary_destination === void 0 ? void 0 : _criteria_primary_destination.airportCode) !== null && _criteria_primary_destination_airportCode !== void 0 ? _criteria_primary_destination_airportCode : "",
                    regionId: value
                })
            })
        });
    }
    if (name.startsWith("".concat(REGION_ID_NAME_PREFIX, "-origin"))) {
        var _criteria_primary_destination1;
        var _criteria_primary_destination_airportCode1;
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                origin: _object_spread_props(_object_spread({}, criteria.primary.origin), {
                    airportCode: (_criteria_primary_destination_airportCode1 = (_criteria_primary_destination1 = criteria.primary.destination) === null || _criteria_primary_destination1 === void 0 ? void 0 : _criteria_primary_destination1.airportCode) !== null && _criteria_primary_destination_airportCode1 !== void 0 ? _criteria_primary_destination_airportCode1 : "",
                    regionId: value
                })
            })
        });
    }
    if (name.startsWith("".concat(SELECTED_PREFIX, "-destination")) && value) {
        var selectedDestinationId = "hotelId";
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread({}, criteria.primary),
            secondary: {
                selections: [
                    {
                        id: selectedDestinationId,
                        value: value
                    }
                ]
            }
        });
    }
    var isPartialStayStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.PARTIAL_STAY_START_DATE_NAME_PREFIX);
    var isPartialStayEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.PARTIAL_STAY_END_DATE_NAME_PREFIX);
    if (isPartialStayStartDate || isPartialStayEndDate) {
        var _criteria_primary_partialStayDateRange, _criteria_primary_partialStayDateRange1;
        var _value_split_map1 = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year1 = _value_split_map1[0], month1 = _value_split_map1[1], day1 = _value_split_map1[2];
        var partialDefaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var partialNewDate = {
            day: day1,
            month: month1,
            year: year1
        };
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                partialStayDateRange: {
                    start: isPartialStayStartDate ? partialNewDate : ((_criteria_primary_partialStayDateRange = criteria.primary.partialStayDateRange) === null || _criteria_primary_partialStayDateRange === void 0 ? void 0 : _criteria_primary_partialStayDateRange.start) || partialDefaultDate,
                    end: isPartialStayEndDate ? partialNewDate : ((_criteria_primary_partialStayDateRange1 = criteria.primary.partialStayDateRange) === null || _criteria_primary_partialStayDateRange1 === void 0 ? void 0 : _criteria_primary_partialStayDateRange1.end) || partialDefaultDate
                }
            })
        });
    }
    return _object_spread({}, criteria);
};
var shoppingCriteriaReducerFlightHotel = function(criteria, param) {
    var name = param.name, value = param.value;
    if (name.startsWith("".concat(INPUT_FIELD__WITH_SELECTION_PREFIX)) && criteria.primarySearchCriteria.flight) {
        var _criteria_primarySearchCriteria_flight;
        var primarySearchCriteria = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
            flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                searchPreferences: _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight = criteria.primarySearchCriteria.flight) === null || _criteria_primarySearchCriteria_flight === void 0 ? void 0 : _criteria_primarySearchCriteria_flight.searchPreferences), {
                    cabinClass: CabinClassMap[value]
                })
            })
        });
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: primarySearchCriteria
        });
    }
    if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
        var isAdult = name.startsWith(ADULT_COUNT_NAME_PREFIX);
        var childKeys = name.split("-");
        var key = isAdult ? ADULT_COUNT_NAME_PREFIX : childKeys.slice(0, 2).join("-");
        var numericValue = Number.parseInt(value, 10);
        var travelers = isAdult ? Array.from(Array(numericValue).keys()).map(function() {
            return {
                type: TravelersTypeMap[key]
            };
        }) : [
            {
                type: TravelersTypeMap[key],
                age: value ? numericValue : null
            }
        ];
        var defaultRoomNumber = 1;
        var _name_split_;
        var roomString = (_name_split_ = name.split("".concat(key, "-Room"))[1]) !== null && _name_split_ !== void 0 ? _name_split_ : "1";
        var _parseInt;
        var roomNumber = (_parseInt = parseInt(roomString, 10)) !== null && _parseInt !== void 0 ? _parseInt : defaultRoomNumber;
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.property) {
            var _rooms_;
            var rooms = _to_consumable_array(criteria.primarySearchCriteria.property.rooms);
            var children = travelers.filter(function(traveler) {
                return traveler.type !== "ADULT" /* ADULT */ ;
            }).map(function(child) {
                return {
                    age: child.age || 0
                };
            });
            rooms[roomNumber - 1] = {
                adults: rooms[roomNumber - 1] ? rooms[roomNumber - 1].adults + travelers.filter(function(traveler) {
                    return traveler.type === "ADULT" /* ADULT */ ;
                }).length : travelers.filter(function(traveler) {
                    return traveler.type === "ADULT" /* ADULT */ ;
                }).length,
                children: _to_consumable_array(((_rooms_ = rooms[roomNumber - 1]) === null || _rooms_ === void 0 ? void 0 : _rooms_.children) || []).concat(_to_consumable_array(children))
            };
            var primarySearchCriteria1 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    travelers: _to_consumable_array(criteria.primarySearchCriteria.flight.travelers).concat(_to_consumable_array(travelers))
                }),
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    rooms: _to_consumable_array(rooms)
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria1
            });
        }
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-origin"))) {
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.property) {
            var _criteria_primarySearchCriteria_flight_journeyCriterias, _criteria_primarySearchCriteria_flight_journeyCriterias1;
            var primarySearchCriteria2 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    journeyCriterias: [
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias[0]), {
                            origin: value
                        }),
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias1 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias1 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias1[1]), {
                            destination: value
                        })
                    ]
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria2
            });
        }
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.property) {
            var _criteria_primarySearchCriteria_flight_journeyCriterias2, _criteria_primarySearchCriteria_flight_journeyCriterias3;
            var primarySearchCriteria3 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    journeyCriterias: [
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias2 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias2 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias2[0]), {
                            destination: value
                        }),
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias3 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias3 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias3[1]), {
                            origin: value
                        })
                    ]
                }),
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    destination: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property.destination), {
                        regionName: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria3
            });
        }
    }
    var isStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX);
    var isEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX);
    if (isStartDate || isEndDate) {
        var _value_split_map = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var defaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var newDate = {
            day: day,
            month: month,
            year: year
        };
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.property) {
            var _criteria_primarySearchCriteria_flight_journeyCriterias4, _criteria_primarySearchCriteria_flight_journeyCriterias5, _criteria_primarySearchCriteria_flight_journeyCriterias6, _criteria_primarySearchCriteria_flight_journeyCriterias7, _criteria_primarySearchCriteria_property_dateRange, _criteria_primarySearchCriteria_property_dateRange1;
            var primarySearchCriteria4 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    journeyCriterias: [
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias4 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias4 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias4[0]), {
                            departureDate: isStartDate ? newDate : ((_criteria_primarySearchCriteria_flight_journeyCriterias5 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias5 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias5[0].departureDate) || defaultDate
                        }),
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias6 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias6 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias6[1]), {
                            departureDate: isEndDate ? newDate : ((_criteria_primarySearchCriteria_flight_journeyCriterias7 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias7 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias7[1].departureDate) || defaultDate
                        })
                    ]
                }),
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    dateRange: {
                        checkInDate: isStartDate ? newDate : ((_criteria_primarySearchCriteria_property_dateRange = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange.checkInDate) || defaultDate,
                        checkOutDate: isEndDate ? newDate : ((_criteria_primarySearchCriteria_property_dateRange1 = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange1 === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange1.checkOutDate) || defaultDate
                    }
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria4
            });
        }
    }
    if (name.startsWith("".concat(REGION_ID_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.property) {
            var primarySearchCriteria5 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    destination: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property.destination), {
                        regionId: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria5
            });
        }
    }
    var isPartialStayStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.PARTIAL_STAY_START_DATE_NAME_PREFIX);
    var isPartialStayEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.PARTIAL_STAY_END_DATE_NAME_PREFIX);
    if (isPartialStayStartDate || isPartialStayEndDate) {
        var _value_split_map1 = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year1 = _value_split_map1[0], month1 = _value_split_map1[1], day1 = _value_split_map1[2];
        var partialDefaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var partialNewDate = {
            day: day1,
            month: month1,
            year: year1
        };
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.property) {
            var _criteria_primarySearchCriteria_property_dateRange2, _criteria_primarySearchCriteria_property_dateRange3;
            var primarySearchCriteria6 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    dateRange: {
                        checkInDate: isPartialStayStartDate ? partialNewDate : ((_criteria_primarySearchCriteria_property_dateRange2 = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange2 === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange2.checkInDate) || partialDefaultDate,
                        checkOutDate: isPartialStayEndDate ? partialNewDate : ((_criteria_primarySearchCriteria_property_dateRange3 = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange3 === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange3.checkOutDate) || partialDefaultDate
                    }
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria6
            });
        }
    }
    return _object_spread({}, criteria);
};
var shoppingCriteriaReducerFlightCar = function(criteria, param) {
    var name = param.name, value = param.value;
    if (name.startsWith("".concat(INPUT_FIELD__WITH_SELECTION_PREFIX)) && criteria.primarySearchCriteria.flight) {
        var _criteria_primarySearchCriteria_flight;
        var primarySearchCriteria = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
            flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                searchPreferences: _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight = criteria.primarySearchCriteria.flight) === null || _criteria_primarySearchCriteria_flight === void 0 ? void 0 : _criteria_primarySearchCriteria_flight.searchPreferences), {
                    cabinClass: CabinClassMap[value]
                })
            })
        });
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: primarySearchCriteria
        });
    }
    if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
        var isAdult = name.startsWith(ADULT_COUNT_NAME_PREFIX);
        var childKeys = name.split("-");
        var key = isAdult ? ADULT_COUNT_NAME_PREFIX : childKeys.slice(0, 2).join("-");
        var numericValue = Number.parseInt(value, 10);
        var travelers = isAdult ? Array.from(Array(numericValue).keys()).map(function() {
            return {
                type: TravelersTypeMap[key]
            };
        }) : [
            {
                type: TravelersTypeMap[key],
                age: value ? numericValue : null
            }
        ];
        if (criteria.primarySearchCriteria.flight) {
            var primarySearchCriteria1 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    travelers: _to_consumable_array(criteria.primarySearchCriteria.flight.travelers).concat(_to_consumable_array(travelers))
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria1
            });
        }
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-origin"))) {
        if (criteria.primarySearchCriteria.flight) {
            var _criteria_primarySearchCriteria_flight_journeyCriterias, _criteria_primarySearchCriteria_flight_journeyCriterias1;
            var primarySearchCriteria2 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    journeyCriterias: [
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias[0]), {
                            origin: value
                        }),
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias1 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias1 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias1[1]), {
                            destination: value
                        })
                    ]
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria2
            });
        }
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.car) {
            var _criteria_primarySearchCriteria_flight_journeyCriterias2, _criteria_primarySearchCriteria_flight_journeyCriterias3;
            var primarySearchCriteria3 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    journeyCriterias: [
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias2 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias2 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias2[0]), {
                            destination: value
                        }),
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias3 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias3 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias3[1]), {
                            origin: value
                        })
                    ]
                }),
                car: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car), {
                    pickUpLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.pickUpLocation), {
                        searchTerm: value
                    }),
                    dropOffLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.dropOffLocation), {
                        searchTerm: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria3
            });
        }
    }
    var isStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX);
    var isEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX);
    if (isStartDate || isEndDate) {
        var _value_split_map = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var defaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var newDate = {
            day: day,
            month: month,
            year: year
        };
        var newDateTime = _object_spread_props(_object_spread({}, newDate), {
            hour: 0,
            minute: 0,
            second: 0
        });
        if (criteria.primarySearchCriteria.flight && criteria.primarySearchCriteria.car) {
            var _criteria_primarySearchCriteria_flight_journeyCriterias4, _criteria_primarySearchCriteria_flight_journeyCriterias5, _criteria_primarySearchCriteria_flight_journeyCriterias6, _criteria_primarySearchCriteria_flight_journeyCriterias7;
            var primarySearchCriteria4 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                flight: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.flight), {
                    journeyCriterias: [
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias4 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias4 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias4[0]), {
                            departureDate: isStartDate ? newDate : ((_criteria_primarySearchCriteria_flight_journeyCriterias5 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias5 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias5[0].departureDate) || defaultDate
                        }),
                        _object_spread_props(_object_spread({}, (_criteria_primarySearchCriteria_flight_journeyCriterias6 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias6 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias6[1]), {
                            departureDate: isEndDate ? newDate : ((_criteria_primarySearchCriteria_flight_journeyCriterias7 = criteria.primarySearchCriteria.flight.journeyCriterias) === null || _criteria_primarySearchCriteria_flight_journeyCriterias7 === void 0 ? void 0 : _criteria_primarySearchCriteria_flight_journeyCriterias7[1].departureDate) || defaultDate
                        })
                    ]
                }),
                car: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car), {
                    pickUpDateTime: isStartDate ? newDateTime : criteria.primarySearchCriteria.car.pickUpDateTime,
                    dropOffDateTime: isEndDate ? newDateTime : criteria.primarySearchCriteria.car.dropOffDateTime
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria4
            });
        }
    }
    if (name.startsWith("".concat(REGION_ID_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.car) {
            var primarySearchCriteria5 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                car: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car), {
                    pickUpLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.pickUpLocation), {
                        regionId: value
                    }),
                    dropOffLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.dropOffLocation), {
                        regionId: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria5
            });
        }
    }
    return _object_spread({}, criteria);
};
var shoppingCriteriaReducerHotelCar = function(criteria, param) {
    var name = param.name, value = param.value;
    if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
        var isAdult = name.startsWith(ADULT_COUNT_NAME_PREFIX);
        var childKeys = name.split("-");
        var key = isAdult ? ADULT_COUNT_NAME_PREFIX : childKeys.slice(0, 2).join("-");
        var numericValue = Number.parseInt(value, 10);
        var travelers = isAdult ? Array.from(Array(numericValue).keys()).map(function() {
            return {
                type: TravelersTypeMap[key]
            };
        }) : [
            {
                type: TravelersTypeMap[key],
                age: value ? numericValue : null
            }
        ];
        var defaultRoomNumber = 1;
        var _name_split_;
        var roomString = (_name_split_ = name.split("".concat(key, "-Room"))[1]) !== null && _name_split_ !== void 0 ? _name_split_ : "1";
        var _parseInt;
        var roomNumber = (_parseInt = parseInt(roomString, 10)) !== null && _parseInt !== void 0 ? _parseInt : defaultRoomNumber;
        if (criteria.primarySearchCriteria.property) {
            var _rooms_;
            var rooms = _to_consumable_array(criteria.primarySearchCriteria.property.rooms);
            var children = travelers.filter(function(traveler) {
                return traveler.type !== "ADULT" /* ADULT */ ;
            }).map(function(child) {
                return {
                    age: child.age || 0
                };
            });
            rooms[roomNumber - 1] = {
                adults: rooms[roomNumber - 1] ? rooms[roomNumber - 1].adults + travelers.filter(function(traveler) {
                    return traveler.type === "ADULT" /* ADULT */ ;
                }).length : travelers.filter(function(traveler) {
                    return traveler.type === "ADULT" /* ADULT */ ;
                }).length,
                children: _to_consumable_array(((_rooms_ = rooms[roomNumber - 1]) === null || _rooms_ === void 0 ? void 0 : _rooms_.children) || []).concat(_to_consumable_array(children))
            };
            var primarySearchCriteria = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    rooms: _to_consumable_array(rooms)
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria
            });
        }
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.car && criteria.primarySearchCriteria.property) {
            var primarySearchCriteria1 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    destination: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property.destination), {
                        regionName: value
                    })
                }),
                car: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car), {
                    pickUpLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.pickUpLocation), {
                        searchTerm: value
                    }),
                    dropOffLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.dropOffLocation), {
                        searchTerm: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria1
            });
        }
    }
    var isStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX);
    var isEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX);
    if (isStartDate || isEndDate) {
        var _value_split_map = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var defaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var newDate = {
            day: day,
            month: month,
            year: year
        };
        var newDateTime = _object_spread_props(_object_spread({}, newDate), {
            hour: 0,
            minute: 0,
            second: 0
        });
        if (criteria.primarySearchCriteria.car && criteria.primarySearchCriteria.property) {
            var _criteria_primarySearchCriteria_property_dateRange, _criteria_primarySearchCriteria_property_dateRange1;
            var primarySearchCriteria2 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    dateRange: {
                        checkInDate: isStartDate ? newDate : ((_criteria_primarySearchCriteria_property_dateRange = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange.checkInDate) || defaultDate,
                        checkOutDate: isEndDate ? newDate : ((_criteria_primarySearchCriteria_property_dateRange1 = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange1 === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange1.checkOutDate) || defaultDate
                    }
                }),
                car: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car), {
                    pickUpDateTime: isStartDate ? newDateTime : criteria.primarySearchCriteria.car.pickUpDateTime,
                    dropOffDateTime: isEndDate ? newDateTime : criteria.primarySearchCriteria.car.dropOffDateTime
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria2
            });
        }
    }
    if (name.startsWith("".concat(REGION_ID_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.property) {
            var primarySearchCriteria3 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    destination: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property.destination), {
                        regionId: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria3
            });
        }
    }
    if (name.startsWith("".concat(AIRPORT_CODE_NAME_PREFIX, "-destination"))) {
        if (criteria.primarySearchCriteria.car) {
            var primarySearchCriteria4 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                car: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car), {
                    pickUpLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.pickUpLocation), {
                        airportCode: value
                    }),
                    dropOffLocation: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.car.dropOffLocation), {
                        airportCode: value
                    })
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria4
            });
        }
    }
    var isPartialStayStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.PARTIAL_STAY_START_DATE_NAME_PREFIX);
    var isPartialStayEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.PARTIAL_STAY_END_DATE_NAME_PREFIX);
    if (isPartialStayStartDate || isPartialStayEndDate) {
        var _value_split_map1 = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year1 = _value_split_map1[0], month1 = _value_split_map1[1], day1 = _value_split_map1[2];
        var partialDefaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var partialNewDate = {
            day: day1,
            month: month1,
            year: year1
        };
        if (criteria.primarySearchCriteria.car && criteria.primarySearchCriteria.property) {
            var _criteria_primarySearchCriteria_property_dateRange2, _criteria_primarySearchCriteria_property_dateRange3;
            var primarySearchCriteria5 = _object_spread_props(_object_spread({}, criteria.primarySearchCriteria), {
                property: _object_spread_props(_object_spread({}, criteria.primarySearchCriteria.property), {
                    dateRange: {
                        checkInDate: isPartialStayStartDate ? partialNewDate : ((_criteria_primarySearchCriteria_property_dateRange2 = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange2 === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange2.checkInDate) || partialDefaultDate,
                        checkOutDate: isPartialStayEndDate ? partialNewDate : ((_criteria_primarySearchCriteria_property_dateRange3 = criteria.primarySearchCriteria.property.dateRange) === null || _criteria_primarySearchCriteria_property_dateRange3 === void 0 ? void 0 : _criteria_primarySearchCriteria_property_dateRange3.checkOutDate) || partialDefaultDate
                    }
                })
            });
            return _object_spread_props(_object_spread({}, criteria), {
                primarySearchCriteria: primarySearchCriteria5
            });
        }
    }
    return _object_spread({}, criteria);
};
var getSearchCriteriaFromHiddenInputs = function(elements) {
    var inputs = elements.filter(function(element) {
        return element.name.startsWith(EGDS_PREFIX);
    });
    var criteria = {
        primary: {},
        secondary: {}
    };
    return inputs.reduce(packagesCriteriaReducer, criteria);
};
var getPackageShoppingCriteriaFromHiddenInputs = function(elements, packageType, isDirectFlights) {
    var inputs = elements.filter(function(element) {
        return element.name.startsWith(EGDS_PREFIX);
    });
    var initialCriteria = getInitialShoppingCriteria(packageType, isDirectFlights);
    switch(packageType){
        case "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ , "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ :
            return inputs.reduce(shoppingCriteriaReducerFlightHotel, initialCriteria);
        case "FLIGHT_CAR" /* FLIGHT_CAR */ :
            return inputs.reduce(shoppingCriteriaReducerFlightCar, initialCriteria);
        case "HOTEL_CAR" /* HOTEL_CAR */ :
            return inputs.reduce(shoppingCriteriaReducerHotelCar, initialCriteria);
        default:
            return inputs.reduce(shoppingCriteriaReducerFlightHotel, initialCriteria);
    }
};
var createFlightObject = function(isDirectFlights) {
    return {
        tripType: "ROUND_TRIP" /* ROUND_TRIP */ ,
        journeyCriterias: [],
        travelers: [],
        searchPreferences: {
            advancedFilters: isDirectFlights ? [
                "NONSTOP" /* NONSTOP */ 
            ] : [],
            cabinClass: "COACH" /* COACH */ 
        }
    };
};
var createPropertyObject = function() {
    return {
        rooms: [],
        destination: {
            regionId: ""
        }
    };
};
var createCarObject = function() {
    return {
        dropOffDateTime: {
            day: 0,
            month: 0,
            year: 0,
            hour: 0,
            minute: 0,
            second: 0
        },
        pickUpDateTime: {
            day: 0,
            month: 0,
            year: 0,
            hour: 0,
            minute: 0,
            second: 0
        },
        pickUpLocation: {}
    };
};
var getInitialShoppingCriteria = function(packageType, isDirectFlights) {
    var primarySearchCriteria = {};
    switch(packageType){
        case "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ :
            primarySearchCriteria = {
                flight: createFlightObject(isDirectFlights),
                property: createPropertyObject()
            };
            break;
        case "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ :
            primarySearchCriteria = {
                flight: createFlightObject(isDirectFlights),
                property: createPropertyObject(),
                car: createCarObject()
            };
            break;
        case "FLIGHT_CAR" /* FLIGHT_CAR */ :
            primarySearchCriteria = {
                flight: createFlightObject(isDirectFlights),
                car: createCarObject()
            };
            break;
        case "HOTEL_CAR" /* HOTEL_CAR */ :
            primarySearchCriteria = {
                property: createPropertyObject(),
                car: createCarObject()
            };
            break;
        default:
            break;
    }
    return {
        primarySearchCriteria: primarySearchCriteria,
        secondaryCriteria: {}
    };
};
// src/components/multi-item/form/__private/multi-packages-search-form.tsx
var fieldComponents2 = [
    EGDSSearchFormLocationField,
    EGDSSearchFormLocationsField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormTravelersField,
    EGDSSearchFormInputField,
    SearchFormPartialStay,
    SearchFormMessaging,
    EGDSSearchFormButton
];
var __Fragment44 = gql63(_templateObject67(), EGDSErrorSummary.fragment, EGDSSearchFormButton.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormLocationsField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment, EGDSSearchFormInputField.fragment, EGDSSearchPlayback.fragment, SearchFormMessaging.fragment, SearchFormPartialStay.fragment, EGDSPill.fragment, SearchLocationFragment);
var FormFields = function(props) {
    var viewportSize = props.viewportSize, packageType = props.packageType, defaultValidationProps = props.defaultValidationProps, renderableElements = props.renderableElements, errorState = props.errorState, autoOpenCalendar = props.autoOpenCalendar, additionalAdapterFields = props.additionalAdapterFields, onOpenLocationField = props.onOpenLocationField, searchLocationAnalytics = props.searchLocationAnalytics;
    return /* @__PURE__ */ React87.createElement(React87.Fragment, null, renderableElements.map(function(element, index) {
        var __typename = element.__typename;
        var FieldComponent = fieldComponents2.find(function(param) {
            var displayName = param.displayName;
            return displayName === __typename && __typename !== "EGDSSearchFormInputField";
        });
        if (!FieldComponent) {
            return null;
        }
        var flexItemProps = getFlexItemPropsByFieldType(__typename, viewportSize, packageType);
        var propsByField = _object_spread(_object_spread_props(_object_spread({}, defaultValidationProps), {
            fieldError: getFieldError(errorState, __typename === "SearchFormPartialStay" ? "EGDSSearchFormDatePickerFieldPartialStay" : __typename)
        }), __typename === "EGDSSearchFormLocationsField" && {
            originFieldError: getFieldError(errorState, "".concat(element.origin.__typename, "Origin")),
            destinationFieldError: getFieldError(errorState, "".concat(element.destination.__typename, "Destination")),
            additionalAdapterFields: additionalAdapterFields,
            onOpenLocationField: onOpenLocationField,
            searchLocationAnalytics: searchLocationAnalytics
        }, __typename === "EGDSSearchFormLocationField" && {
            additionalAdapterFields: additionalAdapterFields,
            onOpenLocationField: onOpenLocationField,
            searchLocationAnalytics: searchLocationAnalytics
        }, __typename === "EGDSSearchFormDatePickerField" && {
            autoOpen: autoOpenCalendar
        });
        var propsByLocationFieldType = {
            originRef: __typename === "EGDSSearchFormLocationsField" ? propsByField : null,
            destinationRef: __typename === "EGDSSearchFormLocationsField" ? propsByField : null
        };
        return /* @__PURE__ */ React87.createElement(UitkLayoutFlexItem14, _object_spread({
            key: "field_".concat(__typename, "_").concat(index)
        }, flexItemProps), /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(FieldComponent, _object_spread_props(_object_spread({}, propsByField, propsByLocationFieldType), {
            data: element
        }))));
    }));
};
var ValuePropMessage = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React87.createElement(UitkLayoutFlex15, null, /* @__PURE__ */ React87.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React87.createElement(UitkSpacing24, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(SearchFormMessaging, {
        data: data
    })))));
};
var MultiPackagesSearchForm = function(props) {
    var _datePickerField_action;
    var data = props.data, onSubmit = props.onSubmit, onFieldChange = props.onFieldChange, autoOpenCalendar = props.autoOpenCalendar, packageType = props.packageType, cabinClass = props.cabinClass, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, autoOpenPlayback = props.autoOpenPlayback, stickyPlayback = props.stickyPlayback, additionalAdapterFields = props.additionalAdapterFields, directFlightsOnlySwitch = props.directFlightsOnlySwitch, onOpenLocationField = props.onOpenLocationField, handleDirectFlightsOnlySwitch = props.handleDirectFlightsOnlySwitch, showDirectFlightsOnly = props.showDirectFlightsOnly;
    var localizationContext = useLocalization12();
    var _React87_useState = _sliced_to_array(React87.useState({
        EGDSSearchFormLocationFieldOrigin: null,
        EGDSSearchFormLocationFieldDestination: null,
        EGDSSearchFormDatePickerField: null,
        EGDSSearchFormInputField: null,
        EGDSSearchFormDatePickerFieldPartialStay: null
    }), 2), fieldsRefs = _React87_useState[0], setFieldsRefs = _React87_useState[1];
    var initialErrorState2 = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var _React87_useState1 = _sliced_to_array(React87.useState(initialErrorState2), 2), errorState = _React87_useState1[0], setErrorState = _React87_useState1[1];
    var _React87_useState2 = _sliced_to_array(React87.useState(!autoOpenPlayback), 2), displayToggle = _React87_useState2[0], setDisplayToggle = _React87_useState2[1];
    React87.useEffect(function() {
        var directFlightsOnly2 = data === null || data === void 0 ? void 0 : data.directFlightsOnly;
        if (directFlightsOnly2 && handleDirectFlightsOnlySwitch) {
            handleDirectFlightsOnlySwitch(directFlightsOnly2.selected);
        }
    }, [
        data,
        handleDirectFlightsOnlySwitch
    ]);
    var setFieldRefByTypename = React87.useCallback(function(typename, ref) {
        var _ref_current;
        var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typenameRef, ref));
        });
    }, []);
    var elements = data.elements, errorSummary5 = data.errorSummary, search6 = data.search, actionURL = data.actionURL, initialPlayback = data.playback, valuePropMessage = data.valuePropMessage, searchLocation = data.searchLocation, partialStay = data.partialStay, directFlightsOnly = data.directFlightsOnly;
    var _React87_useState3 = _sliced_to_array(React87.useState(initialPlayback), 2), playback = _React87_useState3[0], setPlayback = _React87_useState3[1];
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var handlePlaybackToggle = function(open) {
        setDisplayToggle(open);
    };
    if (!search6) {
        return null;
    }
    var defaultElements2 = _to_consumable_array(elements).concat([
        search6
    ]);
    var renderableElements = _to_consumable_array(elements).concat([
        partialStay,
        valuePropMessage,
        search6
    ]).filter(Boolean);
    var datePickerField = elements.find(function(element) {
        return element.__typename === "EGDSSearchFormDatePickerField";
    });
    var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
    var maxNumberOfDaysSelected = (datePickerField === null || datePickerField === void 0 ? void 0 : datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" && packageType !== "FLIGHT_CAR" /* FLIGHT_CAR */  ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
    var defaultValidationProps = {
        setFieldRefByTypename: setFieldRefByTypename
    };
    var defaultLayoutFlexProps2 = {
        space: "three",
        direction: "row"
    };
    var formFieldsProps = {
        packageType: packageType,
        viewportSize: ViewSizes6.SMALL,
        renderableElements: renderableElements,
        defaultValidationProps: defaultValidationProps,
        errorState: errorState,
        autoOpenCalendar: autoOpenCalendar,
        additionalAdapterFields: additionalAdapterFields,
        onOpenLocationField: onOpenLocationField,
        searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
    };
    var formFieldsPropsDesktop = _object_spread_props(_object_spread({}, formFieldsProps), {
        renderableElements: defaultElements2
    });
    var handleFieldChange = function(field, event) {
        onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
        setPlayback(function(playbackPrev) {
            if (!playbackPrev) {
                return null;
            }
            var DESTINATION = FieldNameMap2.DESTINATION, TRAVELER_SELECTOR = FieldNameMap2.TRAVELER_SELECTOR, TRAVEL_DATES = FieldNameMap2.TRAVEL_DATES;
            var primary = playbackPrev.primary, secondaries = playbackPrev.secondaries;
            var text = field.value;
            var newPrimary = field.name === DESTINATION ? _object_spread_props(_object_spread({}, primary), {
                text: text
            }) : primary;
            var _secondaries = _sliced_to_array(secondaries, 2), dates = _secondaries[0], travelers = _secondaries[1];
            var isDateRangePicker = field.name === TRAVEL_DATES;
            var secondaryDates = isDateRangePicker && dates.__typename === "EGDSPlainText" ? _object_spread_props(_object_spread({}, dates), {
                text: getFormattedDates(text, localizationContext)
            }) : dates;
            var secondaryTravelers = field.name === TRAVELER_SELECTOR ? _object_spread_props(_object_spread({}, travelers), {
                text: text
            }) : travelers;
            return _object_spread_props(_object_spread({}, playbackPrev), {
                primary: newPrimary,
                secondaries: [
                    secondaryDates,
                    secondaryTravelers
                ]
            });
        });
    };
    var handleSubmit = function(event) {
        setErrorState(initialErrorState2);
        var formElements = Array.from(event.currentTarget.elements);
        var formElementsToValidate = {
            location: {
                origin: formElements.find(findFieldByNameAttribute("origin_select")),
                destination: formElements.find(findFieldByNameAttribute("destination_select")),
                config: {
                    sameLocationSelected: true
                }
            },
            dates: {
                startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date-range-select")),
                endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date-range-select")),
                partialStayStartDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePartialStay-StartDate-partial-stay-date-range-select")),
                partialStayEndDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePartialStay-EndDate-partial-stay-date-range-select")),
                config: {
                    maxNumberOfDaysSelected: maxNumberOfDaysSelected
                }
            }
        };
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
        var isFormValid = fieldsWithErrors.length === 0;
        if (!isFormValid) {
            var _fieldsWithErrors_;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: fieldsWithErrors.length,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
            });
            event.preventDefault();
            return;
        }
        if (onSubmit || redirectToSearchResultOnSubmit) {
            var elementsOnSubmit = Array.from(event.currentTarget.elements);
            var packageSearchCriteria = getSearchCriteriaFromHiddenInputs(elementsOnSubmit);
            var packageShoppingCriteria = getPackageShoppingCriteriaFromHiddenInputs(elementsOnSubmit, packageType, directFlightsOnlySwitch);
            if (onSubmit) {
                onSubmit(event, {
                    packageSearchCriteria: packageSearchCriteria,
                    packageType: packageType,
                    packageShoppingCriteria: packageShoppingCriteria
                });
            }
            if (redirectToSearchResultOnSubmit) {
                event.preventDefault();
                var action = event.currentTarget.action;
                var queryParams = getURLQueryParamsFromCriteria(packageSearchCriteria, packageType, directFlightsOnlySwitch);
                window.location.href = "".concat(action).concat(queryParams);
            }
        }
    };
    var hiddenCabinClassFieldElement = packageType !== "HOTEL_CAR" /* HOTEL_CAR */  ? /* @__PURE__ */ React87.createElement("input", {
        type: "hidden",
        name: cabinClass === null || cabinClass === void 0 ? void 0 : cabinClass.name,
        value: cabinClass === null || cabinClass === void 0 ? void 0 : cabinClass.value
    }) : null;
    var isHotelPackage = packageType !== "FLIGHT_CAR" /* FLIGHT_CAR */ ;
    var onChangeDirectFlightsPill = function(event) {
        handleDirectFlightsOnlySwitch === null || handleDirectFlightsOnlySwitch === void 0 ? void 0 : handleDirectFlightsOnlySwitch(event.target.checked);
    };
    var directFlightsOnlyPill = directFlightsOnly && /* @__PURE__ */ React87.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(EGDSPill, {
        data: directFlightsOnly,
        onChange: onChangeDirectFlightsPill
    })));
    var cabinClassPillElement = renderableElements.find(function(element) {
        return element.__typename === "EGDSSearchFormInputField";
    });
    var CabinClassComponent = cabinClassPillElement ? /* @__PURE__ */ React87.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(EGDSSearchFormInputField, _object_spread_props(_object_spread({}, defaultValidationProps), {
        triggerType: "pill" /* PILL */ ,
        data: cabinClassPillElement
    })))) : null;
    return /* @__PURE__ */ React87.createElement(UitkForm5, {
        id: "package-search-form",
        name: "packages-search-form-".concat(packageType),
        action: actionURL,
        onSubmit: handleSubmit,
        onFieldChange: handleFieldChange,
        hasRequiredFieldIndicator: true
    }, displayErrorSummary && errorSummary5 && /* @__PURE__ */ React87.createElement(UitkSpacing24, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }))), /* @__PURE__ */ React87.createElement(Viewport17, null, /* @__PURE__ */ React87.createElement(ViewSmall15, null, /* @__PURE__ */ React87.createElement(React87.Fragment, null, playback ? /* @__PURE__ */ React87.createElement(EGDSSearchPlayback, {
        data: playback,
        stickyPlayback: stickyPlayback,
        display: displayToggle,
        onDisplayToggle: handlePlaybackToggle
    }, showDirectFlightsOnly && (CabinClassComponent || directFlightsOnlyPill) && /* @__PURE__ */ React87.createElement(UitkLayoutFlex15, {
        space: "two",
        wrap: "wrap"
    }, CabinClassComponent, directFlightsOnlyPill), /* @__PURE__ */ React87.createElement(UitkLayoutFlex15, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
        direction: "column"
    }), /* @__PURE__ */ React87.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsProps), {
        viewportSize: ViewSizes6.SMALL,
        includeCabinClassField: true
    })))) : /* @__PURE__ */ React87.createElement(UitkLayoutFlex15, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
        direction: "column"
    }), /* @__PURE__ */ React87.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsProps), {
        viewportSize: ViewSizes6.SMALL
    })), hiddenCabinClassFieldElement))), /* @__PURE__ */ React87.createElement(ViewMedium14, null, /* @__PURE__ */ React87.createElement(React87.Fragment, null, /* @__PURE__ */ React87.createElement(UitkLayoutFlex15, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
        wrap: "wrap"
    }), /* @__PURE__ */ React87.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsPropsDesktop), {
        viewportSize: ViewSizes6.MEDIUM
    })), hiddenCabinClassFieldElement), isHotelPackage && partialStay && /* @__PURE__ */ React87.createElement(UitkSpacing24, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(SearchFormPartialStay, {
        data: partialStay,
        setFieldRefByTypename: setFieldRefByTypename,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormDatePickerFieldPartialStay";
        })
    }))), valuePropMessage && /* @__PURE__ */ React87.createElement(ValuePropMessage, {
        data: valuePropMessage
    }))), /* @__PURE__ */ React87.createElement(ViewLarge8, null, /* @__PURE__ */ React87.createElement(React87.Fragment, null, /* @__PURE__ */ React87.createElement(UitkLayoutFlex15, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
        wrap: "wrap"
    }), /* @__PURE__ */ React87.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsPropsDesktop), {
        viewportSize: ViewSizes6.LARGE
    })), hiddenCabinClassFieldElement), isHotelPackage && partialStay && /* @__PURE__ */ React87.createElement(UitkSpacing24, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(SearchFormPartialStay, {
        data: partialStay,
        setFieldRefByTypename: setFieldRefByTypename,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormDatePickerFieldPartialStay";
        })
    }))), valuePropMessage && /* @__PURE__ */ React87.createElement(ValuePropMessage, {
        data: valuePropMessage
    })))));
};
MultiPackagesSearchForm.fragment = __Fragment44;
MultiPackagesSearchForm.displayName = "MultiPackagesSearchForm";
// src/components/multi-item/form/__private/no-selection-message.tsx
import React88 from "react";
import { gql as gql64 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkParagraph } from "uitk-react-text";
var __Fragment45 = gql64(_templateObject68(), Icon.fragment);
var NoSelectionMessage = function(props) {
    var data = props.data;
    var icon = data.icon, heading = data.heading, body = data.body;
    return /* @__PURE__ */ React88.createElement(UitkSpacing25, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(UitkLayoutFlex16, {
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React88.createElement(UitkLayoutFlexItem15, null, icon && /* @__PURE__ */ React88.createElement(Icon, {
        data: icon
    })), /* @__PURE__ */ React88.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React88.createElement(UitkHeading4, null, heading)), /* @__PURE__ */ React88.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React88.createElement(UitkParagraph, null, body)))));
};
NoSelectionMessage.displayName = "NoSelectionMessage";
NoSelectionMessage.fragment = __Fragment45;
// src/components/multi-item/form/__private/prebundles-search-form.tsx
import React89 from "react";
import { gql as gql65 } from "@apollo/client";
import { ViewLarge as ViewLarge9, ViewMedium as ViewMedium15, Viewport as Viewport18, ViewSizes as ViewSizes7, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm6 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
var fieldComponents3 = [
    EGDSSearchFormLocationField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormTravelersField,
    EGDSSearchFormButton
];
var __Fragment46 = gql65(_templateObject69(), EGDSErrorSummary.fragment, EGDSSearchPlayback.fragment, EGDSSearchFormButton.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment);
var defaultLayoutFlexProps = {
    space: "three",
    direction: "row"
};
var PrebundlesSearchForm = function(param) {
    var data = param.data, onFieldChange = param.onFieldChange, onSubmit = param.onSubmit;
    var _datePickerField_action;
    var _React89_useState = _sliced_to_array(React89.useState({
        EGDSSearchFormLocationField: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React89_useState[0], setFieldsRefs = _React89_useState[1];
    var _React89_useState1 = _sliced_to_array(React89.useState({
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    }), 2), errorState = _React89_useState1[0], setErrorState = _React89_useState1[1];
    var _React89_useState2 = _sliced_to_array(React89.useState(true), 2), displayToggle = _React89_useState2[0], setDisplayToggle = _React89_useState2[1];
    var handlePlaybackToggle = function(open) {
        setDisplayToggle(open);
    };
    var setFieldRefByTypename = React89.useCallback(function(typename, ref) {
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typename, ref));
        });
    }, []);
    var elements = data.elements, errorSummary5 = data.errorSummary, playback = data.playback, search6 = data.search;
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    if (!search6) {
        return null;
    }
    var renderableElements = _to_consumable_array(elements).concat([
        search6
    ]);
    var defaultValidationProps = {
        setFieldRefByTypename: setFieldRefByTypename
    };
    var datePickerField = elements.find(function(element) {
        return element.__typename === "EGDSSearchFormDatePickerField";
    });
    var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
    var maxNumberOfDaysSelected = (datePickerField === null || datePickerField === void 0 ? void 0 : datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
    var handleFieldChange = function(field, event) {
        onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
    };
    var handleSubmit = function(event) {
        event.preventDefault();
        var formElements = Array.from(event.currentTarget.elements);
        var formElementsToValidate = {
            location: {
                origin: formElements.find(findFieldByNameAttribute("origin-select"))
            },
            dates: {
                startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date-range-select")),
                endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date-range-select")),
                config: {
                    maxNumberOfDaysSelected: maxNumberOfDaysSelected
                }
            }
        };
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
        var isFormValid = fieldsWithErrors.length === 0;
        if (!isFormValid) {
            var _fieldsWithErrors_;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: fieldsWithErrors.length,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
            });
        } else {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
        }
    };
    var searchFormElements = function(viewportSize) {
        return renderableElements.map(function(element, index) {
            var __typename = element.__typename;
            var FieldComponent = fieldComponents3.find(function(param) {
                var displayName = param.displayName;
                return displayName === __typename;
            });
            if (!FieldComponent) {
                return null;
            }
            var flexItemProps = getFlexItemPropsByFieldType(__typename, viewportSize);
            var fieldError = errorState.fieldsWithErrors.find(function(field) {
                return field.__typename === __typename;
            });
            var validationProps = _object_spread_props(_object_spread({}, defaultValidationProps), {
                fieldError: fieldError
            });
            return /* @__PURE__ */ React89.createElement(UitkLayoutFlexItem16, _object_spread({
                key: "field_".concat(__typename, "_").concat(index)
            }, flexItemProps), /* @__PURE__ */ React89.createElement("div", null, /* @__PURE__ */ React89.createElement(FieldComponent, _object_spread({
                data: element
            }, validationProps))));
        });
    };
    return /* @__PURE__ */ React89.createElement(UitkForm6, {
        id: "package-search-form",
        name: "package-search-form",
        onFieldChange: handleFieldChange,
        onSubmit: handleSubmit,
        hasRequiredFieldIndicator: true
    }, displayErrorSummary && errorSummary5 && /* @__PURE__ */ React89.createElement(UitkSpacing26, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React89.createElement("div", null, /* @__PURE__ */ React89.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }))), /* @__PURE__ */ React89.createElement(Viewport18, null, /* @__PURE__ */ React89.createElement(ViewSmall16, null, playback ? /* @__PURE__ */ React89.createElement(EGDSSearchPlayback, {
        data: playback,
        display: displayToggle,
        onDisplayToggle: handlePlaybackToggle
    }, /* @__PURE__ */ React89.createElement(UitkLayoutFlex17, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
        direction: "column"
    }), searchFormElements(ViewSizes7.SMALL))) : /* @__PURE__ */ React89.createElement(UitkLayoutFlex17, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
        direction: "column"
    }), searchFormElements(ViewSizes7.SMALL))), /* @__PURE__ */ React89.createElement(ViewMedium15, null, /* @__PURE__ */ React89.createElement(UitkLayoutFlex17, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
        wrap: "wrap"
    }), searchFormElements(ViewSizes7.MEDIUM))), /* @__PURE__ */ React89.createElement(ViewLarge9, null, /* @__PURE__ */ React89.createElement(UitkLayoutFlex17, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
        wrap: "wrap"
    }), searchFormElements(ViewSizes7.LARGE)))));
};
PrebundlesSearchForm.fragment = __Fragment46;
PrebundlesSearchForm.displayName = "PrebundlesSearchForm";
// src/components/multi-item/form/client-events.ts
import { SystemEvent as SystemEvent4, SystemEventLevel as SystemEventLevel4 } from "@shared-ui/logger-context";
var CLIENT_EVENTS2 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_PACKAGES_SEARCH_FORM_QUERY_FAILURE: new SystemEvent4(SystemEventLevel4.ERROR, "SEARCH_TOOLS_PACKAGES_SEARCH_FORM_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS2 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_PACKAGES_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Packages Search Form Fallback Presented",
        referrerId: "Web.Packages.Search.Form.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_PACKAGES_SEARCH_FORM_IMPRESSION: {
        linkName: "Packages Search Form Presented",
        referrerId: "Web.Packages.Search.Form.Presented"
    }
};
// src/components/multi-item/form/packages-search-form.tsx
var __Query3 = gql66(_templateObject70(), PrebundlesSearchForm.fragment, MultiPackagesSearchForm.fragment, NoSelectionMessage.fragment);
var smallViewportFormSkeletonProps = {
    rows: [
        {
            type: "primary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        }
    ]
};
var mediumViewportFormSkeletonProps = {
    rows: [
        {
            type: "primary"
        }
    ]
};
var PackagesSearchForm = function(props) {
    var _data_searchForm, _data_searchForm1, _data_searchForm_packages_packageSelection;
    var inputs = props.inputs, skipSsr = props.skipSsr, includePlayback = props.includePlayback, batchKey = props.batchKey, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery;
    var packageType = inputs.packageType;
    var context = useBexApi7().context;
    var systemEvents = useLoggerEvents3(CLIENT_EVENTS2);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: Boolean(includePlayback)
    });
    var _useQuery3 = useQuery3(__Query3, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery
    }), currentData = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading, previousData = _useQuery3.previousData;
    var data = currentData || previousData;
    if (loading) {
        return /* @__PURE__ */ React90.createElement(Viewport19, null, /* @__PURE__ */ React90.createElement(ViewSmall17, null, /* @__PURE__ */ React90.createElement(FormSkeleton, _object_spread({}, smallViewportFormSkeletonProps))), /* @__PURE__ */ React90.createElement(ViewMedium16, null, /* @__PURE__ */ React90.createElement(FormSkeleton, _object_spread({}, mediumViewportFormSkeletonProps))));
    }
    if (error || !data || !(data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : _data_searchForm.packages)) {
        var _fallback_searchForm, _fallback_searchForm_packages_packageSelection;
        systemEvents.SEARCH_TOOLS_PACKAGES_SEARCH_FORM_QUERY_FAILURE.log({
            name: error === null || error === void 0 ? void 0 : error.name,
            error: new Error(error === null || error === void 0 ? void 0 : error.message)
        });
        var fallback = getFallbackData(packageType);
        if (!(fallback === null || fallback === void 0 ? void 0 : (_fallback_searchForm = fallback.searchForm) === null || _fallback_searchForm === void 0 ? void 0 : _fallback_searchForm.packages) || fallback.searchForm.packages.__typename !== "PackagesSearchForm" || ((_fallback_searchForm_packages_packageSelection = fallback.searchForm.packages.packageSelection) === null || _fallback_searchForm_packages_packageSelection === void 0 ? void 0 : _fallback_searchForm_packages_packageSelection.__typename) !== "PackagesSearchFormSelection") {
            return null;
        }
        if (packageType === null) {
            return /* @__PURE__ */ React90.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React90.createElement(NoSelectionMessage, {
                data: fallback.searchForm.packages.packageSelection.noSelectionMessage
            }));
        }
        return /* @__PURE__ */ React90.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React90.createElement(IntersectionTracker4, _object_spread({}, CLIENT_TRACKING_EVENTS2.SEARCH_TOOLS_PACKAGES_SEARCH_FORM_FALLBACK_IMPRESSION), packageType ? /* @__PURE__ */ React90.createElement(MultiPackagesSearchForm, _object_spread_props(_object_spread({}, props), {
            packageType: packageType,
            data: fallback.searchForm.packages,
            includeCabinClassField: Boolean(includePlayback)
        })) : /* @__PURE__ */ React90.createElement(PrebundlesSearchForm, _object_spread_props(_object_spread({}, props), {
            data: fallback.searchForm.packages
        }))));
    }
    if (!(data === null || data === void 0 ? void 0 : (_data_searchForm1 = data.searchForm) === null || _data_searchForm1 === void 0 ? void 0 : _data_searchForm1.packages) || data.searchForm.packages.__typename !== "PackagesSearchForm" || ((_data_searchForm_packages_packageSelection = data.searchForm.packages.packageSelection) === null || _data_searchForm_packages_packageSelection === void 0 ? void 0 : _data_searchForm_packages_packageSelection.__typename) !== "PackagesSearchFormSelection") {
        return null;
    }
    if (packageType === null) {
        return /* @__PURE__ */ React90.createElement(NoSelectionMessage, {
            data: data.searchForm.packages.packageSelection.noSelectionMessage
        });
    }
    return /* @__PURE__ */ React90.createElement(IntersectionTracker4, _object_spread({}, CLIENT_TRACKING_EVENTS2.SEARCH_TOOLS_PACKAGES_SEARCH_FORM_IMPRESSION), packageType ? /* @__PURE__ */ React90.createElement(MultiPackagesSearchForm, _object_spread_props(_object_spread({}, props), {
        packageType: packageType,
        data: data.searchForm.packages,
        includeCabinClassField: Boolean(includePlayback)
    })) : /* @__PURE__ */ React90.createElement(PrebundlesSearchForm, _object_spread_props(_object_spread({}, props), {
        data: data.searchForm.packages
    })));
};
PackagesSearchForm.displayName = "sharedui-PackagesSearchForm";
// src/components/multi-item/form/multi-item-search-form.tsx
var MultiItemSearchForm = function(props) {
    var inputs = props.inputs, onPackageTypeChange = props.onPackageTypeChange, includePlayback = props.includePlayback, enableReflection = props.enableReflection, isSticky = props.sticky;
    var _React91_useState = _sliced_to_array(React91.useState(inputs.packageType), 2), packageType = _React91_useState[0], setPackageType = _React91_useState[1];
    var _React91_useState1 = _sliced_to_array(React91.useState({
        name: "",
        value: ""
    }), 2), cabinClass = _React91_useState1[0], setCabinClass = _React91_useState1[1];
    var _React91_useState2 = _sliced_to_array(React91.useState(true), 2), showCabinClass = _React91_useState2[0], setShowCabinClass = _React91_useState2[1];
    var _React91_useState3 = _sliced_to_array(React91.useState(true), 2), showDirectFlightsOnlyPill = _React91_useState3[0], setShowDirectFlightsOnlyPill = _React91_useState3[1];
    var _React91_useState4 = _sliced_to_array(React91.useState(false), 2), skipPackagesOptionsQuery = _React91_useState4[0], setSkipPackagesOptionsQuery = _React91_useState4[1];
    var _React91_useState5 = _sliced_to_array(React91.useState(false), 2), directFlightsOnlySwitch = _React91_useState5[0], setDirectFlightsOnlySwitch = _React91_useState5[1];
    var ContentContainer = isSticky ? StickySearchForm : React91.Fragment;
    var handlePackageTypeSelect = React91.useCallback(function(selectedPackageType) {
        setPackageType(selectedPackageType);
        onPackageTypeChange === null || onPackageTypeChange === void 0 ? void 0 : onPackageTypeChange(selectedPackageType);
        var isHotelCarCombination = selectedPackageType === "HOTEL_CAR" /* HOTEL_CAR */ ;
        setShowCabinClass(!isHotelCarCombination && selectedPackageType !== null);
        setShowDirectFlightsOnlyPill(!isHotelCarCombination && selectedPackageType !== null);
    }, [
        setPackageType,
        onPackageTypeChange
    ]);
    var handleCabinClassSelect = React91.useCallback(function(field) {
        setCabinClass(field);
        setSkipPackagesOptionsQuery(true);
    }, [
        setCabinClass
    ]);
    var handleDirectFlightsOnlySwitch = React91.useCallback(function(selected) {
        setDirectFlightsOnlySwitch(selected);
    }, [
        setDirectFlightsOnlySwitch
    ]);
    var packagesOptions = /* @__PURE__ */ React91.createElement(PackagesOptions, _object_spread_props(_object_spread({}, props), {
        onPackageTypeChange: handlePackageTypeSelect,
        onCabinClassSelect: handleCabinClassSelect,
        inputs: _object_spread({}, inputs),
        showCabinClass: showCabinClass,
        showDirectFlightsOnly: showDirectFlightsOnlyPill,
        skipQuery: skipPackagesOptionsQuery,
        handleDirectFlightsOnlySwitch: handleDirectFlightsOnlySwitch
    }));
    var packagesSearchForm = /* @__PURE__ */ React91.createElement(PackagesSearchForm, _object_spread_props(_object_spread({}, props), {
        inputs: _object_spread_props(_object_spread({}, inputs), {
            packageType: packageType
        }),
        cabinClass: cabinClass,
        directFlightsOnlySwitch: directFlightsOnlySwitch,
        showDirectFlightsOnly: showDirectFlightsOnlyPill,
        handleDirectFlightsOnlySwitch: handleDirectFlightsOnlySwitch
    }));
    var content = /* @__PURE__ */ React91.createElement(Viewport20, null, /* @__PURE__ */ React91.createElement(ViewSmall18, null, /* @__PURE__ */ React91.createElement(React91.Fragment, null, !includePlayback && packagesOptions, packagesSearchForm)), /* @__PURE__ */ React91.createElement(ViewMedium17, null, /* @__PURE__ */ React91.createElement(ContentContainer, null, packagesOptions, packagesSearchForm)));
    if (enableReflection) {
        return /* @__PURE__ */ React91.createElement(SearchFormReflectionProvider2, null, /* @__PURE__ */ React91.createElement("div", {
            "data-stid": "search-form-with-reflection"
        }, content));
    }
    return content;
};
// src/components/product-selector/product-selector.tsx
import React93 from "react";
import { gql as gql68, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents4 } from "@shared-ui/logger-context";
// src/components/product-selector/__private/search-form-product-selector.tsx
import React92 from "react";
import { gql as gql67 } from "@apollo/client";
import { UitkTab as UitkTab2, UitkTabs as UitkTabs2, UitkTabsType as UitkTabsType3 } from "@egds/react-core/tabs";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium18, Viewport as Viewport21, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
var __Fragment47 = gql67(_templateObject71());
var SearchFormProductSelector = function(props) {
    var data = props.data, initialSelectedProduct = props.initialSelectedProduct, onProductTypeSelection = props.onProductTypeSelection;
    var products = data.products;
    var track = useClickTracker28();
    var initialTabIndex = products.findIndex(function(param) {
        var type = param.type;
        return type === initialSelectedProduct;
    });
    var _React92_useState = _sliced_to_array(React92.useState(initialTabIndex !== -1 ? initialTabIndex : 0), 2), selectedTabIndex = _React92_useState[0], setSelectedTabIndex = _React92_useState[1];
    var handleTabSelect = function(selectedTab) {
        var _products_selectedTab = products[selectedTab], clickAnalytics = _products_selectedTab.clickAnalytics, type = _products_selectedTab.type;
        if (clickAnalytics) {
            var linkName = clickAnalytics.linkName, referrerId = clickAnalytics.referrerId;
            track(referrerId, linkName);
        }
        setSelectedTabIndex(selectedTab);
        onProductTypeSelection(type);
    };
    var tabsProps = {
        selectedTab: selectedTabIndex,
        onTabSelect: handleTabSelect,
        tabsType: UitkTabsType3.NATURAL,
        targetURI: ""
    };
    var tabs = products.map(function(product, idx) {
        var id = product.id, label = product.label, targetURI = product.targetURI;
        return /* @__PURE__ */ React92.createElement(UitkTab2, {
            key: idx,
            id: id !== null && id !== void 0 ? id : void 0,
            name: label,
            targetURI: targetURI !== null && targetURI !== void 0 ? targetURI : ""
        });
    });
    return /* @__PURE__ */ React92.createElement(Viewport21, null, /* @__PURE__ */ React92.createElement(ViewSmall19, null, /* @__PURE__ */ React92.createElement(UitkTabs2, _object_spread({}, tabsProps), tabs)), /* @__PURE__ */ React92.createElement(ViewMedium18, null, /* @__PURE__ */ React92.createElement(UitkTabs2, _object_spread_props(_object_spread({
        className: "uitk-card-roundcorner-top-left uitk-card-roundcorner-top-right"
    }, tabsProps), {
        centerAlign: true
    }), tabs)));
};
SearchFormProductSelector.displayName = "SearchFormProductSelector";
SearchFormProductSelector.fragment = __Fragment47;
// src/components/product-selector/client-events.ts
import { SystemEvent as SystemEvent5, SystemEventLevel as SystemEventLevel5 } from "@shared-ui/logger-context";
var CLIENT_EVENTS3 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_PRODUCT_SELECTOR_QUERY_FAILURE: new SystemEvent5(SystemEventLevel5.ERROR, "SEARCH_TOOLS_PRODUCT_SELECTOR_QUERY_FAILURE"),
    SEARCH_TOOLS_PRODUCT_SELECTOR_SINGLE_PRODUCT_RENDER: new SystemEvent5(SystemEventLevel5.INFO, "SEARCH_TOOLS_PRODUCT_SELECTOR_SINGLE_PRODUCT_RENDER")
};
// src/components/product-selector/fallback.ts
var productSelectorFallback = {
    __typename: "SearchFormProductSelector",
    products: [
        {
            clickAnalytics: {
                linkName: "Lodging search form selected",
                referrerId: "Web.SearchForm.Product.Selector.Lodging.Click",
                __typename: "ClientSideAnalytics"
            },
            id: "search_form_product_selector_lodging",
            label: "Stays",
            selected: true,
            targetURI: "/Hotels",
            type: "LODGING" /* LODGING */ ,
            __typename: "SearchFormProduct"
        },
        {
            clickAnalytics: {
                linkName: "Flights search form selected",
                referrerId: "Web.SearchForm.Product.Selector.Flights.Click",
                __typename: "ClientSideAnalytics"
            },
            id: "search_form_product_selector_product_flights",
            label: "Flights",
            selected: false,
            targetURI: "/Flights",
            type: "FLIGHTS" /* FLIGHTS */ ,
            __typename: "SearchFormProduct"
        },
        {
            clickAnalytics: {
                linkName: "Cars search form selected",
                referrerId: "WebSearchForm.Product.Selector.Cars.Click",
                __typename: "ClientSideAnalytics"
            },
            id: "search_form_product_selector_product_cars",
            label: "Cars",
            selected: false,
            targetURI: "/Cars",
            type: "CARS" /* CARS */ ,
            __typename: "SearchFormProduct"
        },
        {
            clickAnalytics: {
                linkName: "Packages search form selected",
                referrerId: "Web.SearchForm.Product.Selector.Packages.Click",
                __typename: "ClientSideAnalytics"
            },
            id: "search_form_product_selector_product_packages",
            label: "Packages",
            selected: false,
            targetURI: "/Vacation-Packages",
            type: "PACKAGES" /* PACKAGES */ ,
            __typename: "SearchFormProduct"
        },
        {
            clickAnalytics: {
                linkName: "Activities search form selected",
                referrerId: "Web.SearchForm.Product.Selector.Activities.Click",
                __typename: "ClientSideAnalytics"
            },
            id: "search_form_product_selector_product_activities",
            label: "Things to do",
            selected: false,
            targetURI: "/Activities",
            type: "ACTIVITIES" /* ACTIVITIES */ ,
            __typename: "SearchFormProduct"
        },
        {
            clickAnalytics: {
                linkName: "Cruises search form selected",
                referrerId: "Web.SearchForm.Product.Selector.Cruises.Click",
                __typename: "ClientSideAnalytics"
            },
            id: "search_form_product_selector_product_cruises",
            label: "Cruises",
            selected: false,
            targetURI: "/Cruises",
            type: "CRUISES" /* CRUISES */ ,
            __typename: "SearchFormProduct"
        }
    ]
};
// src/components/product-selector/product-selector.tsx
var __Query4 = gql68(_templateObject72(), SearchFormProductSelector.fragment);
var ProductSelector = function(props) {
    var _data_searchForm_productSelector, _data_searchForm;
    var inputs = props.inputs, skipSsr = props.skipSsr, skipQuery = props.skipQuery, batchKey = props.batchKey;
    var context = useBexApi8().context;
    var systemEvents = useLoggerEvents4(CLIENT_EVENTS3);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(__Query4, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: !!skipQuery
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading) {
        return null;
    }
    if (error) {
        systemEvents.SEARCH_TOOLS_PRODUCT_SELECTOR_QUERY_FAILURE.log({
            name: error.name,
            error: new Error(error.message)
        });
        return /* @__PURE__ */ React93.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React93.createElement(SearchFormProductSelector, _object_spread_props(_object_spread({}, props), {
            data: productSelectorFallback
        })));
    }
    var _data_searchForm_productSelector_products;
    var products = (_data_searchForm_productSelector_products = data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : (_data_searchForm_productSelector = _data_searchForm.productSelector) === null || _data_searchForm_productSelector === void 0 ? void 0 : _data_searchForm_productSelector.products) !== null && _data_searchForm_productSelector_products !== void 0 ? _data_searchForm_productSelector_products : [];
    if (!data || products.length <= 1) {
        var isSingleProduct = products.length === 1;
        if (isSingleProduct) {
            systemEvents.SEARCH_TOOLS_PRODUCT_SELECTOR_SINGLE_PRODUCT_RENDER.log({
                name: "A single product is rendered"
            });
        }
        return null;
    }
    return /* @__PURE__ */ React93.createElement(SearchFormProductSelector, _object_spread_props(_object_spread({}, props), {
        data: data.searchForm.productSelector
    }));
};
ProductSelector.displayName = "sharedui-ProductSelector";
// src/components/multi-product-search-form/multi-product-search-form.tsx
var MultiProductSearchForm = function(props) {
    var _searchFormOptionsByLob_packages_inputs_packageSearchCriteria, _searchFormOptionsByLob_packages_inputs, _searchFormOptionsByLob_packages;
    var batchKey = props.batchKey, initialSelectedProduct = props.initialSelectedProduct, onProductTypeSelection = props.onProductTypeSelection, searchFormOptionsByLob = props.searchFormOptionsByLob, sticky = props.sticky;
    var _React94_useState = _sliced_to_array(React94.useState(initialSelectedProduct), 2), product = _React94_useState[0], setProduct = _React94_useState[1];
    var handleProductSelection = function(newProduct) {
        setProduct(newProduct);
        onProductTypeSelection === null || onProductTypeSelection === void 0 ? void 0 : onProductTypeSelection(newProduct);
    };
    var commonProps = {
        batchKey: batchKey,
        /* istanbul ignore next */ onFieldChange: function() {},
        redirectToSearchResultOnSubmit: true
    };
    var forms = {
        LODGING: /* @__PURE__ */ React94.createElement(LodgingSearchForm2, _object_spread_props(_object_spread({}, commonProps, searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : searchFormOptionsByLob.lodging), {
            inputs: {}
        })),
        FLIGHTS: /* @__PURE__ */ React94.createElement(FlightsSearchForm, _object_spread_props(_object_spread({}, commonProps, searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : searchFormOptionsByLob.flights), {
            inputs: {
                includeFlightType: true,
                flightSearchCriteria: {
                    primary: {
                        journeyCriterias: [],
                        travelers: [],
                        tripType: "ROUND_TRIP" /* ROUND_TRIP */ 
                    }
                },
                fixedTravelers: false,
                disabledCabins: null
            }
        })),
        CARS: /* @__PURE__ */ React94.createElement(CarsSearchForm, _object_spread_props(_object_spread({}, commonProps, searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : searchFormOptionsByLob.cars), {
            inputs: {
                carSearchCriteria: null
            }
        })),
        PACKAGES: /* @__PURE__ */ React94.createElement(MultiItemSearchForm, _object_spread_props(_object_spread({}, commonProps, searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : searchFormOptionsByLob.packages), {
            inputs: {
                packageSearchCriteria: {
                    primary: (searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : (_searchFormOptionsByLob_packages = searchFormOptionsByLob.packages) === null || _searchFormOptionsByLob_packages === void 0 ? void 0 : (_searchFormOptionsByLob_packages_inputs = _searchFormOptionsByLob_packages.inputs) === null || _searchFormOptionsByLob_packages_inputs === void 0 ? void 0 : (_searchFormOptionsByLob_packages_inputs_packageSearchCriteria = _searchFormOptionsByLob_packages_inputs.packageSearchCriteria) === null || _searchFormOptionsByLob_packages_inputs_packageSearchCriteria === void 0 ? void 0 : _searchFormOptionsByLob_packages_inputs_packageSearchCriteria.primary) || {}
                },
                packageType: "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ ,
                includePackageType: true
            }
        })),
        ACTIVITIES: /* @__PURE__ */ React94.createElement(ActivitySearchForm, _object_spread_props(_object_spread({}, commonProps, searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : searchFormOptionsByLob.activities), {
            inputs: {
                activitySearchCriteria: null
            }
        })),
        CRUISES: /* @__PURE__ */ React94.createElement(CruiseSearchForm, _object_spread_props(_object_spread({}, commonProps, searchFormOptionsByLob === null || searchFormOptionsByLob === void 0 ? void 0 : searchFormOptionsByLob.cruises), {
            inputs: {
                cruiseSearchCriteriaInput: null
            }
        }))
    };
    var form = /* @__PURE__ */ React94.createElement("div", {
        id: "search_form_product_selector_".concat(product.toLowerCase())
    }, forms[product]);
    var productSelector = /* @__PURE__ */ React94.createElement(ProductSelector, {
        batchKey: batchKey,
        inputs: {},
        onProductTypeSelection: handleProductSelection,
        initialSelectedProduct: initialSelectedProduct
    });
    var productCard = /* @__PURE__ */ React94.createElement(UitkCard2, {
        border: true,
        overflow: true
    }, /* @__PURE__ */ React94.createElement("div", null, productSelector, /* @__PURE__ */ React94.createElement(UitkSpacing27, {
        padding: "six"
    }, form)));
    var content = /* @__PURE__ */ React94.createElement(Viewport22, null, /* @__PURE__ */ React94.createElement(ViewSmall20, null, /* @__PURE__ */ React94.createElement(React94.Fragment, null, productSelector, /* @__PURE__ */ React94.createElement(UitkSpacing27, {
        margin: {
            blockstart: "six"
        }
    }, form))), /* @__PURE__ */ React94.createElement(ViewMedium19, null, /* @__PURE__ */ React94.createElement(React94.Fragment, null, sticky ? /* @__PURE__ */ React94.createElement(StickySearchForm, null, productCard) : /* @__PURE__ */ React94.createElement("div", null, productCard))));
    return /* @__PURE__ */ React94.createElement("div", {
        "data-stid": "search-form-sticky"
    }, /* @__PURE__ */ React94.createElement(SearchFormReflectionProvider3, null, content));
};
// src/components/search-form-with-background-image/search-form-with-background-image.tsx
import React96 from "react";
import { gql as gql69, useQuery as useQuery5 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "@egds/react-core/images";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium20, Viewport as Viewport23, ViewSmall as ViewSmall21 } from "@shared-ui/viewport-context";
import { UitkLayoutGrid as UitkLayoutGrid4 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
// src/components/search-form-with-background-image/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "@egds/react-core/images";
var _obj7;
var aspectRatioMapper = (_obj7 = {}, _define_property(_obj7, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj7, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj7, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj7, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj7, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj7, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj7, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj7);
// src/components/search-form-with-background-image/components/search-form.tsx
import React95 from "react";
import { UitkCard as UitkCard3, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex18, UitkLayoutFlexItem as UitkLayoutFlexItem17 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing28 } from "uitk-react-spacing";
var SearchForm = function(param) {
    var batchKey = param.batchKey, initialSelectedProduct = param.initialSelectedProduct;
    return /* @__PURE__ */ React95.createElement(UitkLayoutFlex18, {
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React95.createElement(UitkLayoutFlexItem17, {
        minWidth: "full_width",
        maxWidth: "full_width"
    }, /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(UitkSpacing28, {
        margin: {
            blockstart: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React95.createElement("section", {
        "data-testid": "multi-product-search-form-with-background-image"
    }, /* @__PURE__ */ React95.createElement(UitkCard3, {
        border: true
    }, /* @__PURE__ */ React95.createElement(UitkCardContentSection, null, /* @__PURE__ */ React95.createElement(MultiProductSearchForm, {
        batchKey: batchKey,
        initialSelectedProduct: initialSelectedProduct
    }))))))));
};
// src/components/search-form-with-background-image/search-form-with-background-image.tsx
var __Query5 = gql69(_templateObject73());
var SearchFormWithBackgroundImage = function(props) {
    var _content_items, _content_items_;
    var batchKey = props.batchKey, initialSelectedProduct = props.initialSelectedProduct, inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi9().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery5 = useQuery5(__Query5, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    if (loading || error || !data || !data.travelExperienceManagerContent.editorialComponent || !data.travelExperienceManagerContent.editorialComponent.content) {
        return /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(SearchForm, {
            batchKey: batchKey,
            initialSelectedProduct: initialSelectedProduct
        }));
    }
    var content = data.travelExperienceManagerContent.editorialComponent.content;
    if (content.__typename !== "EMMediaComponents" || ((_content_items = content.items) === null || _content_items === void 0 ? void 0 : _content_items.length) !== 1 || ((_content_items_ = content.items[0]) === null || _content_items_ === void 0 ? void 0 : _content_items_.mediaType.__typename) !== "Image") {
        return /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(SearchForm, {
            batchKey: batchKey,
            initialSelectedProduct: initialSelectedProduct
        }));
    }
    var _content_items__mediaType = content.items[0].mediaType, aspectRatio = _content_items__mediaType.aspectRatio, description = _content_items__mediaType.description, src = _content_items__mediaType.src;
    return /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(UitkLayoutGrid4, null, /* @__PURE__ */ React96.createElement(Viewport23, null, /* @__PURE__ */ React96.createElement(ViewSmall21, null, /* @__PURE__ */ React96.createElement(SearchForm, {
        batchKey: batchKey,
        initialSelectedProduct: initialSelectedProduct
    })), /* @__PURE__ */ React96.createElement(ViewMedium20, null, /* @__PURE__ */ React96.createElement(UitkLayoutPosition3, {
        type: "relative"
    }, /* @__PURE__ */ React96.createElement(UitkFigure, {
        ratio: aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R4_1
    }, /* @__PURE__ */ React96.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: src
    })), /* @__PURE__ */ React96.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            top: "center",
            right: "four",
            left: "four"
        }
    }, /* @__PURE__ */ React96.createElement(SearchForm, {
        batchKey: batchKey,
        initialSelectedProduct: initialSelectedProduct
    })))))));
};
SearchFormWithBackgroundImage.displayName = "sharedui-SearchFormWithBackgroundImage";
// src/components/cars/form/cars-search-form.tsx
import React111, { useState as useState2 } from "react";
import { gql as gql83, useQuery as useQuery7 } from "@apollo/client";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents6 } from "@shared-ui/logger-context";
import { ViewMedium as ViewMedium25, Viewport as Viewport28, ViewSmall as ViewSmall26 } from "@shared-ui/viewport-context";
// src/components/cars/utils/fallback-data-dates.ts
var TODAY = /* @__PURE__ */ new Date();
var START_DATE = /* @__PURE__ */ new Date();
START_DATE.setDate(START_DATE.getDate() + 14);
var DAY_AFTER_START_DATE = /* @__PURE__ */ new Date();
DAY_AFTER_START_DATE.setDate(DAY_AFTER_START_DATE.getDate() + 15);
var NEXT_TEN_MONTHS = /* @__PURE__ */ new Date();
NEXT_TEN_MONTHS.setMonth(NEXT_TEN_MONTHS.getMonth() + 10);
NEXT_TEN_MONTHS.setDate(NEXT_TEN_MONTHS.getDate() - 5);
function createDate(date) {
    return {
        __typename: "Date",
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
}
// src/components/cars/utils/fallback-data.ts
var fallbackData = {
    __typename: "CarSearchForm",
    egdsElementId: "car_search_form",
    actionURL: "/carsearch",
    errorSummary: {
        egdsElementId: "search_form_error_summary",
        goToErrorLinkText: "Go to error",
        goToFirstErrorLinkText: "Go to first error",
        heading: "",
        body: null,
        analytics: {
            linkName: "Error summary link clicked",
            referrerId: "Web.Car.Search.Error.Summary",
            __typename: "ClientSideAnalytics"
        },
        impressionAnalytics: {
            linkName: "Error summary displayed",
            referrerId: "Web.Car.Search.Error.Summary.Displayed",
            __typename: "ClientSideImpressionEventAnalytics"
        },
        headingTemplate: {
            models: [
                {
                    key: "errorCount",
                    source: "errorCount",
                    __typename: "TemplateModel"
                }
            ],
            templates: [
                {
                    category: "ZERO" /* ZERO */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "ONE" /* ONE */ ,
                    template: "Please correct the error to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "TWO" /* TWO */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "FEW" /* FEW */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "MANY" /* MANY */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "OTHER" /* OTHER */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                }
            ],
            __typename: "EGDSCardinalLocalizedText"
        },
        __typename: "EGDSErrorSummary"
    },
    pickUpLocation: {
        __typename: "EGDSSearchFormLocationField",
        egdsElementId: "pick_up_location",
        label: "Pick-up",
        placeholder: "Pick-up",
        value: null,
        errorMessage: "Please select where you're picking up the vehicle",
        required: false,
        leftIcon: {
            title: null,
            __typename: "Icon"
        },
        action: {
            accessibility: null,
            analytics: {
                linkName: "Location selection",
                referrerId: "Web.Car.Location.Origin.Open",
                __typename: "ClientSideAnalytics"
            },
            info: {
                client: "Homepage",
                drivable: false,
                isDestination: true,
                lineOfBusiness: "CARS",
                maxNumberOfResults: 8,
                packageType: null,
                personalize: true,
                regionType: 1583,
                typeaheadFeatures: "postal_code|consistent_display|cars_rental|carsclickpopularity",
                isMultiLocation: null,
                domain: null,
                regionId: null,
                showCurrentLocation: null,
                __typename: "TypeaheadInfo",
                subLob: null,
                expUserId: "-1",
                trending: false
            },
            emptyResultsPlaceholder: "Search by city, airport, or address",
            categorize: false,
            allowExactMatch: true,
            listTitle: false,
            selectedItemHeading: null,
            clearAllText: null,
            dismissButtonText: null,
            __typename: "OpenTypeaheadAction"
        },
        closeAnalytics: {
            linkName: "Location close",
            referrerId: "Web.Car.Location.Origin.Close",
            __typename: "ClientSideAnalytics"
        },
        changeAnalytics: {
            linkName: "Location change",
            referrerId: "Web.Car.Location.Origin.Change",
            __typename: "ClientSideAnalytics"
        },
        multiLocations: null,
        validations: [
            {
                errorMessage: "Please select where you're picking up the vehicle",
                __typename: "EGDSRequiredInputValidation"
            }
        ],
        regionId: null,
        debounceRate: null
    },
    dropOffLocation: {
        __typename: "EGDSSearchFormLocationField",
        egdsElementId: "drop_off_location",
        label: "Same as pick-up",
        placeholder: "Drop-off",
        value: null,
        errorMessage: "Please select where you're dropping off the vehicle",
        required: false,
        leftIcon: {
            title: null,
            __typename: "Icon"
        },
        action: {
            accessibility: null,
            analytics: {
                linkName: "Location selection",
                referrerId: "Web.Car.Location.Open",
                __typename: "ClientSideAnalytics"
            },
            info: {
                client: "Homepage",
                drivable: false,
                isDestination: true,
                lineOfBusiness: "CARS",
                maxNumberOfResults: 8,
                packageType: null,
                personalize: true,
                regionType: 1583,
                typeaheadFeatures: "postal_code|consistent_display|cars_rental|carsclickpopularity",
                isMultiLocation: null,
                domain: null,
                regionId: null,
                showCurrentLocation: null,
                __typename: "TypeaheadInfo",
                subLob: null,
                expUserId: "-1",
                trending: false
            },
            emptyResultsPlaceholder: "Search by city, airport, or address",
            categorize: false,
            allowExactMatch: true,
            listTitle: false,
            selectedItemHeading: null,
            clearAllText: null,
            dismissButtonText: null,
            __typename: "OpenTypeaheadAction"
        },
        closeAnalytics: {
            linkName: "Location close",
            referrerId: "Web.Car.Location.Close",
            __typename: "ClientSideAnalytics"
        },
        changeAnalytics: {
            linkName: "Location change",
            referrerId: "Web.Car.Location.Change",
            __typename: "ClientSideAnalytics"
        },
        multiLocations: null,
        validations: [
            {
                errorMessage: "Please select where you're dropping off the vehicle",
                __typename: "EGDSRequiredInputValidation"
            }
        ],
        regionId: null,
        debounceRate: null
    },
    alternativeDropOffLocationLabel: "Drop-off",
    dates: {
        egdsElementId: "dates",
        label: "Dates",
        placeholder: "Dates",
        errorMessage: null,
        validations: null,
        action: {
            accessibility: null,
            analytics: {
                linkName: "car date open",
                referrerId: "Web.Car.Calendar.Open",
                __typename: "ClientSideAnalytics"
            },
            datePicker: {
                flexibleDateContent: null,
                buttonText: "Done",
                buttonTextTemplate: null,
                clearButtonText: null,
                firstDayOfWeek: "SUN" /* SUN */ ,
                maxNumberOfDaysSelected: null,
                sameDaySelectionAllowed: true,
                selectedStartDate: _object_spread({}, createDate(START_DATE)),
                startDatePlaceholderText: "",
                selectedEndDate: _object_spread({}, createDate(DAY_AFTER_START_DATE)),
                endDatePlaceholderText: "",
                validDaysLowerBoundInclusive: _object_spread({}, createDate(TODAY)),
                validDaysUpperBoundInclusive: _object_spread({}, createDate(NEXT_TEN_MONTHS)),
                submitButtonAnalytics: {
                    linkName: "car date submit",
                    referrerId: "Web.Car.Calendar.Submit",
                    __typename: "ClientSideAnalytics"
                },
                nextButtonAnalytics: {
                    linkName: "car date next",
                    referrerId: "Web.Car.Calendar.Next.Month.Click",
                    __typename: "ClientSideAnalytics"
                },
                previousButtonAnalytics: {
                    linkName: "car date previous",
                    referrerId: "Web.Car.Calendar.Previous.Month.Click",
                    __typename: "ClientSideAnalytics"
                },
                startDateButtonAnalytics: {
                    linkName: "car date start",
                    referrerId: "Web.Car.Calendar.Start.Date.Click",
                    __typename: "ClientSideAnalytics"
                },
                endDateButtonAnalytics: {
                    linkName: "car date end",
                    referrerId: "Web.Car.Calendar.End.Date.Click",
                    __typename: "ClientSideAnalytics"
                },
                clearDatesButtonAnalytics: {
                    linkName: "car dates clear",
                    referrerId: "Web.Car.Calendar.ClearDates.Submit",
                    __typename: "ClientSideAnalytics"
                },
                showClearDatesButton: false,
                __typename: "EGDSDateRangePicker"
            },
            __typename: "EGDSOpenDatePickerAction"
        },
        __typename: "EGDSSearchFormDatePickerField"
    },
    pickUpTime: {
        __typename: "EGDSBasicSelect",
        egdsElementId: "pick_up_time",
        clickAnalytics: {
            linkName: "car time open",
            referrerId: "Web.Car.Pick_up.Time.Open",
            __typename: "ClientSideAnalytics"
        },
        icon: null,
        label: "Pick-up time",
        options: [
            {
                label: "12:00 AM",
                selected: false,
                value: "1200AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:15 AM",
                selected: false,
                value: "1215AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:30 AM",
                selected: false,
                value: "1230AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:45 AM",
                selected: false,
                value: "1245AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:00 AM",
                selected: false,
                value: "0100AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:15 AM",
                selected: false,
                value: "0115AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:30 AM",
                selected: false,
                value: "0130AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:45 AM",
                selected: false,
                value: "0145AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:00 AM",
                selected: false,
                value: "0200AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:15 AM",
                selected: false,
                value: "0215AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:30 AM",
                selected: false,
                value: "0230AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:45 AM",
                selected: false,
                value: "0245AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:00 AM",
                selected: false,
                value: "0300AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:15 AM",
                selected: false,
                value: "0315AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:30 AM",
                selected: false,
                value: "0330AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:45 AM",
                selected: false,
                value: "0345AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:00 AM",
                selected: false,
                value: "0400AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:15 AM",
                selected: false,
                value: "0415AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:30 AM",
                selected: false,
                value: "0430AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:45 AM",
                selected: false,
                value: "0445AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:00 AM",
                selected: false,
                value: "0500AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:15 AM",
                selected: false,
                value: "0515AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:30 AM",
                selected: false,
                value: "0530AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:45 AM",
                selected: false,
                value: "0545AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:00 AM",
                selected: false,
                value: "0600AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:15 AM",
                selected: false,
                value: "0615AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:30 AM",
                selected: false,
                value: "0630AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:45 AM",
                selected: false,
                value: "0645AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:00 AM",
                selected: false,
                value: "0700AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:15 AM",
                selected: false,
                value: "0715AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:30 AM",
                selected: false,
                value: "0730AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:45 AM",
                selected: false,
                value: "0745AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:00 AM",
                selected: false,
                value: "0800AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:15 AM",
                selected: false,
                value: "0815AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:30 AM",
                selected: false,
                value: "0830AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:45 AM",
                selected: false,
                value: "0845AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:00 AM",
                selected: false,
                value: "0900AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:15 AM",
                selected: false,
                value: "0915AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:30 AM",
                selected: false,
                value: "0930AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:45 AM",
                selected: false,
                value: "0945AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:00 AM",
                selected: false,
                value: "1000AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:15 AM",
                selected: false,
                value: "1015AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:30 AM",
                selected: true,
                value: "1030AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:45 AM",
                selected: false,
                value: "1045AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:00 AM",
                selected: false,
                value: "1100AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:15 AM",
                selected: false,
                value: "1115AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:30 AM",
                selected: false,
                value: "1130AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:45 AM",
                selected: false,
                value: "1145AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:00 PM",
                selected: false,
                value: "1200PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:15 PM",
                selected: false,
                value: "1215PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:30 PM",
                selected: false,
                value: "1230PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:45 PM",
                selected: false,
                value: "1245PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:00 PM",
                selected: false,
                value: "0100PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:15 PM",
                selected: false,
                value: "0115PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:30 PM",
                selected: false,
                value: "0130PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:45 PM",
                selected: false,
                value: "0145PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:00 PM",
                selected: false,
                value: "0200PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:15 PM",
                selected: false,
                value: "0215PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:30 PM",
                selected: false,
                value: "0230PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:45 PM",
                selected: false,
                value: "0245PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:00 PM",
                selected: false,
                value: "0300PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:15 PM",
                selected: false,
                value: "0315PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:30 PM",
                selected: false,
                value: "0330PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:45 PM",
                selected: false,
                value: "0345PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:00 PM",
                selected: false,
                value: "0400PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:15 PM",
                selected: false,
                value: "0415PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:30 PM",
                selected: false,
                value: "0430PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:45 PM",
                selected: false,
                value: "0445PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:00 PM",
                selected: false,
                value: "0500PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:15 PM",
                selected: false,
                value: "0515PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:30 PM",
                selected: false,
                value: "0530PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:45 PM",
                selected: false,
                value: "0545PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:00 PM",
                selected: false,
                value: "0600PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:15 PM",
                selected: false,
                value: "0615PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:30 PM",
                selected: false,
                value: "0630PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:45 PM",
                selected: false,
                value: "0645PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:00 PM",
                selected: false,
                value: "0700PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:15 PM",
                selected: false,
                value: "0715PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:30 PM",
                selected: false,
                value: "0730PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:45 PM",
                selected: false,
                value: "0745PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:00 PM",
                selected: false,
                value: "0800PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:15 PM",
                selected: false,
                value: "0815PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:30 PM",
                selected: false,
                value: "0830PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:45 PM",
                selected: false,
                value: "0845PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:00 PM",
                selected: false,
                value: "0900PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:15 PM",
                selected: false,
                value: "0915PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:30 PM",
                selected: false,
                value: "0930PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:45 PM",
                selected: false,
                value: "0945PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:00 PM",
                selected: false,
                value: "1000PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:15 PM",
                selected: false,
                value: "1015PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:30 PM",
                selected: false,
                value: "1030PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:45 PM",
                selected: false,
                value: "1045PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:00 PM",
                selected: false,
                value: "1100PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:15 PM",
                selected: false,
                value: "1115PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:30 PM",
                selected: false,
                value: "1130PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:45 PM",
                selected: false,
                value: "1145PM",
                __typename: "EGDSBasicOption"
            }
        ],
        disabled: false,
        errorMessage: "Your pick-up time must be in the future",
        readOnly: false,
        value: null
    },
    dropOffTime: {
        __typename: "EGDSBasicSelect",
        egdsElementId: "drop_off_time",
        clickAnalytics: {
            linkName: "car time open",
            referrerId: "Web.Car.Drop_off.Time.Open",
            __typename: "ClientSideAnalytics"
        },
        icon: null,
        label: "Drop-off time",
        options: [
            {
                label: "12:00 AM",
                selected: false,
                value: "1200AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:15 AM",
                selected: false,
                value: "1215AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:30 AM",
                selected: false,
                value: "1230AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:45 AM",
                selected: false,
                value: "1245AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:00 AM",
                selected: false,
                value: "0100AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:15 AM",
                selected: false,
                value: "0115AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:30 AM",
                selected: false,
                value: "0130AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:45 AM",
                selected: false,
                value: "0145AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:00 AM",
                selected: false,
                value: "0200AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:15 AM",
                selected: false,
                value: "0215AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:30 AM",
                selected: false,
                value: "0230AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:45 AM",
                selected: false,
                value: "0245AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:00 AM",
                selected: false,
                value: "0300AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:15 AM",
                selected: false,
                value: "0315AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:30 AM",
                selected: false,
                value: "0330AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:45 AM",
                selected: false,
                value: "0345AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:00 AM",
                selected: false,
                value: "0400AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:15 AM",
                selected: false,
                value: "0415AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:30 AM",
                selected: false,
                value: "0430AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:45 AM",
                selected: false,
                value: "0445AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:00 AM",
                selected: false,
                value: "0500AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:15 AM",
                selected: false,
                value: "0515AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:30 AM",
                selected: false,
                value: "0530AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:45 AM",
                selected: false,
                value: "0545AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:00 AM",
                selected: false,
                value: "0600AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:15 AM",
                selected: false,
                value: "0615AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:30 AM",
                selected: false,
                value: "0630AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:45 AM",
                selected: false,
                value: "0645AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:00 AM",
                selected: false,
                value: "0700AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:15 AM",
                selected: false,
                value: "0715AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:30 AM",
                selected: false,
                value: "0730AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:45 AM",
                selected: false,
                value: "0745AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:00 AM",
                selected: false,
                value: "0800AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:15 AM",
                selected: false,
                value: "0815AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:30 AM",
                selected: false,
                value: "0830AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:45 AM",
                selected: false,
                value: "0845AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:00 AM",
                selected: false,
                value: "0900AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:15 AM",
                selected: false,
                value: "0915AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:30 AM",
                selected: false,
                value: "0930AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:45 AM",
                selected: false,
                value: "0945AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:00 AM",
                selected: false,
                value: "1000AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:15 AM",
                selected: false,
                value: "1015AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:30 AM",
                selected: true,
                value: "1030AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:45 AM",
                selected: false,
                value: "1045AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:00 AM",
                selected: false,
                value: "1100AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:15 AM",
                selected: false,
                value: "1115AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:30 AM",
                selected: false,
                value: "1130AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:45 AM",
                selected: false,
                value: "1145AM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:00 PM",
                selected: false,
                value: "1200PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:15 PM",
                selected: false,
                value: "1215PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:30 PM",
                selected: false,
                value: "1230PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "12:45 PM",
                selected: false,
                value: "1245PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:00 PM",
                selected: false,
                value: "0100PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:15 PM",
                selected: false,
                value: "0115PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:30 PM",
                selected: false,
                value: "0130PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "01:45 PM",
                selected: false,
                value: "0145PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:00 PM",
                selected: false,
                value: "0200PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:15 PM",
                selected: false,
                value: "0215PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:30 PM",
                selected: false,
                value: "0230PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "02:45 PM",
                selected: false,
                value: "0245PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:00 PM",
                selected: false,
                value: "0300PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:15 PM",
                selected: false,
                value: "0315PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:30 PM",
                selected: false,
                value: "0330PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "03:45 PM",
                selected: false,
                value: "0345PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:00 PM",
                selected: false,
                value: "0400PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:15 PM",
                selected: false,
                value: "0415PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:30 PM",
                selected: false,
                value: "0430PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "04:45 PM",
                selected: false,
                value: "0445PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:00 PM",
                selected: false,
                value: "0500PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:15 PM",
                selected: false,
                value: "0515PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:30 PM",
                selected: false,
                value: "0530PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "05:45 PM",
                selected: false,
                value: "0545PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:00 PM",
                selected: false,
                value: "0600PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:15 PM",
                selected: false,
                value: "0615PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:30 PM",
                selected: false,
                value: "0630PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "06:45 PM",
                selected: false,
                value: "0645PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:00 PM",
                selected: false,
                value: "0700PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:15 PM",
                selected: false,
                value: "0715PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:30 PM",
                selected: false,
                value: "0730PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "07:45 PM",
                selected: false,
                value: "0745PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:00 PM",
                selected: false,
                value: "0800PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:15 PM",
                selected: false,
                value: "0815PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:30 PM",
                selected: false,
                value: "0830PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "08:45 PM",
                selected: false,
                value: "0845PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:00 PM",
                selected: false,
                value: "0900PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:15 PM",
                selected: false,
                value: "0915PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:30 PM",
                selected: false,
                value: "0930PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "09:45 PM",
                selected: false,
                value: "0945PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:00 PM",
                selected: false,
                value: "1000PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:15 PM",
                selected: false,
                value: "1015PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:30 PM",
                selected: false,
                value: "1030PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "10:45 PM",
                selected: false,
                value: "1045PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:00 PM",
                selected: false,
                value: "1100PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:15 PM",
                selected: false,
                value: "1115PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:30 PM",
                selected: false,
                value: "1130PM",
                __typename: "EGDSBasicOption"
            },
            {
                label: "11:45 PM",
                selected: false,
                value: "1145PM",
                __typename: "EGDSBasicOption"
            }
        ],
        disabled: false,
        errorMessage: "Your drop-off time must be at least 2 hours after pick-up",
        readOnly: false,
        value: null
    },
    driverAgeCheck: null,
    specialRates: {
        label: "Special rates",
        discountCode: {
            __typename: "CarSearchFormDiscountCode",
            discountCode: {
                __typename: "EGDSBasicTriggerPill",
                id: "discount_codes",
                disabled: false,
                primary: "Discount codes",
                selected: false,
                icon: null,
                selectAnalytics: {
                    linkName: "discount code selected",
                    referrerId: "Web.Car.Discount.Code.Selected",
                    __typename: "ClientSideAnalytics"
                },
                deselectAnalytics: {
                    linkName: "discount code unselected",
                    referrerId: "Web.Car.Discount.Code.Unselected",
                    __typename: "ClientSideAnalytics"
                },
                accessibility: null
            },
            action: {
                discountType: {
                    __typename: "EGDSBasicSelect",
                    egdsElementId: null,
                    clickAnalytics: null,
                    icon: null,
                    label: "Discount type",
                    options: [],
                    disabled: false,
                    errorMessage: null,
                    readOnly: false,
                    value: null
                },
                discountTypeOptions: [
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount #",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "AC" /* AC */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "FASTSTART Org ID",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "AD" /* AD */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "AL" /* AL */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-2",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Alamo Insiders #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Alamo Insiders #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 3,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "AWD #",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZI" /* ZI */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-2",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Wizard #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Wizard #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 3,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "BCD #",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZD" /* ZD */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Fast Break #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Fast Break #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZR" /* ZR */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-2",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Dollar Express #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Dollar Express #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 3,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "EY" /* EY */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 1,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Customer #",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ET" /* ET */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Enterprise Plus #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Enterprise Plus #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Contract #",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "EP" /* EP */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-2",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Privilege #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Privilege #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 3,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "FX" /* FX */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "CDP",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZE" /* ZE */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 1,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "National Contract ID",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZL" /* ZL */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Emerald Club ID",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Emerald Club ID",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate account",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "NU" /* NU */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZA" /* ZA */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-2",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Payless Perks #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Payless Perks #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 3,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "SX" /* SX */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "ZT" /* ZT */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-2",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Blue Chip #",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Blue Chip #",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 3,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: null,
                        preferredBrand: "SV" /* SV */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    },
                    {
                        __typename: "CarSearchFormDiscountTypeOption",
                        corporateOrContractedOption: {
                            discountCode: {
                                egdsElementId: "coupon-code-0",
                                errorMessage: null,
                                instructions: null,
                                label: "Corporate discount code",
                                placeholder: null,
                                readOnly: false,
                                required: true,
                                validations: [
                                    {
                                        errorMessage: "Please enter a valid discount code",
                                        __typename: "EGDSRequiredInputValidation"
                                    }
                                ],
                                value: null,
                                __typename: "EGDSTextInputField"
                            },
                            optionLabel: "Corporate or contracted",
                            __typename: "CarSearchFormCorporateOrContractedOption"
                        },
                        preferredBrand: "SC" /* SC */ ,
                        specialOrAdvertisedOption: {
                            __typename: "CarSearchFormSpecialOrAdvertisedOption",
                            addAnotherDiscountCode: {
                                egdsElementId: null,
                                primary: "Add another code",
                                disabled: false,
                                accessibility: null,
                                icon: null,
                                analytics: {
                                    linkName: "add more discount",
                                    referrerId: "Web.Car.Discount.Code.Close",
                                    __typename: "ClientSideAnalytics"
                                },
                                action: null,
                                __typename: "UITertiaryButton"
                            },
                            discountCodeType: {
                                label: "Code type",
                                __typename: "EGDSBasicSelect"
                            },
                            discountCodeOptions: [
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-0",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount rate code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount rate code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                },
                                {
                                    discountCodeInput: {
                                        egdsElementId: "coupon-code-1",
                                        errorMessage: null,
                                        instructions: null,
                                        label: "Discount coupon code",
                                        placeholder: null,
                                        readOnly: false,
                                        required: true,
                                        validations: [
                                            {
                                                errorMessage: "Please enter a valid discount code",
                                                __typename: "EGDSRequiredInputValidation"
                                            }
                                        ],
                                        value: null,
                                        __typename: "EGDSTextInputField"
                                    },
                                    discountCodeTypeOption: "Discount coupon code",
                                    __typename: "CarSearchFormSpecialOrAdvertisedDiscountCodeOption"
                                }
                            ],
                            maxDiscountCode: 2,
                            optionLabel: "Special or advertised"
                        }
                    }
                ],
                preferredBrand: {
                    __typename: "EGDSBasicSelect",
                    egdsElementId: null,
                    clickAnalytics: null,
                    icon: null,
                    label: "Preferred brand",
                    options: [
                        {
                            label: "Ace Rent A Car",
                            selected: false,
                            value: "AC",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Advantage Rent-A-Car",
                            selected: false,
                            value: "AD",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Alamo Rent A Car",
                            selected: false,
                            value: "AL",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Avis",
                            selected: false,
                            value: "ZI",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Budget",
                            selected: false,
                            value: "ZD",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Dollar Rent A Car",
                            selected: false,
                            value: "ZR",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Economy Rent a Car",
                            selected: false,
                            value: "EY",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Enterprise",
                            selected: false,
                            value: "ET",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Europcar",
                            selected: false,
                            value: "EP",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Fox Rent a Car",
                            selected: false,
                            value: "FX",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Hertz",
                            selected: false,
                            value: "ZE",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Midway Car Rental",
                            selected: false,
                            value: "MW",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "National Car Rental",
                            selected: false,
                            value: "ZL",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Nu Car",
                            selected: false,
                            value: "NU",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Payless",
                            selected: false,
                            value: "ZA",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Routes Car Rental",
                            selected: false,
                            value: "RO",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Sixt",
                            selected: false,
                            value: "SX",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Thrifty Car Rental",
                            selected: false,
                            value: "ZT",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "U-Save",
                            selected: false,
                            value: "SV",
                            __typename: "EGDSBasicOption"
                        },
                        {
                            label: "Silvercar",
                            selected: false,
                            value: "SC",
                            __typename: "EGDSBasicOption"
                        }
                    ],
                    disabled: false,
                    errorMessage: null,
                    readOnly: false,
                    value: null
                },
                errorSummary: {
                    egdsElementId: "discount_code_error_summary",
                    goToErrorLinkText: "Go to error",
                    goToFirstErrorLinkText: "Go to first error",
                    heading: "",
                    body: null,
                    analytics: {
                        linkName: "Error summary link clicked",
                        referrerId: "Web.Car.Discount_Code.Error.Summary",
                        __typename: "ClientSideAnalytics"
                    },
                    impressionAnalytics: {
                        linkName: "Error summary displayed",
                        referrerId: "Web.Car.Discount_Code.Error.Summary.Displayed",
                        __typename: "ClientSideImpressionEventAnalytics"
                    },
                    headingTemplate: {
                        models: [
                            {
                                key: "errorCount",
                                source: "errorCount",
                                __typename: "TemplateModel"
                            }
                        ],
                        templates: [
                            {
                                category: "ZERO" /* ZERO */ ,
                                template: "Please correct the ${errorCount} errors to continue",
                                __typename: "CardinalTemplate"
                            },
                            {
                                category: "ONE" /* ONE */ ,
                                template: "Please correct the error to continue",
                                __typename: "CardinalTemplate"
                            },
                            {
                                category: "TWO" /* TWO */ ,
                                template: "Please correct the ${errorCount} errors to continue",
                                __typename: "CardinalTemplate"
                            },
                            {
                                category: "FEW" /* FEW */ ,
                                template: "Please correct the ${errorCount} errors to continue",
                                __typename: "CardinalTemplate"
                            },
                            {
                                category: "MANY" /* MANY */ ,
                                template: "Please correct the ${errorCount} errors to continue",
                                __typename: "CardinalTemplate"
                            },
                            {
                                category: "OTHER" /* OTHER */ ,
                                template: "Please correct the ${errorCount} errors to continue",
                                __typename: "CardinalTemplate"
                            }
                        ],
                        __typename: "EGDSCardinalLocalizedText"
                    },
                    __typename: "EGDSErrorSummary"
                },
                toolbar: {
                    primary: "Discount code",
                    actions: {
                        primary: {
                            egdsElementId: null,
                            primary: "Clear",
                            disabled: false,
                            accessibility: null,
                            icon: null,
                            analytics: null,
                            action: null,
                            __typename: "UITertiaryButton"
                        },
                        secondaries: [
                            {
                                icon: {
                                    description: "close",
                                    __typename: "Icon"
                                },
                                __typename: "UITertiaryButton"
                            }
                        ],
                        __typename: "UIToolbarActions"
                    },
                    __typename: "UIToolbar"
                },
                done: {
                    egdsElementId: null,
                    primary: "Done",
                    disabled: false,
                    accessibility: null,
                    icon: null,
                    analytics: null,
                    action: null,
                    __typename: "UIPrimaryButton"
                },
                __typename: "CarSearchFormDiscountCodeAction"
            }
        },
        showAarpRate: {
            __typename: "EGDSBasicPill",
            accessibility: null,
            disabled: false,
            name: "aarp_rates",
            primary: "Show AARP rates",
            selected: false,
            selectedText: null,
            value: null,
            icon: null,
            selectAnalytics: {
                linkName: "AARP rate selected",
                referrerId: "Web.Car.AARP.Rate.Selected",
                __typename: "ClientSideAnalytics"
            },
            deselectAnalytics: {
                linkName: "AARP rate unselected",
                referrerId: "Web.Car.AARP.Rate.Unselected",
                __typename: "ClientSideAnalytics"
            }
        },
        __typename: "CarSearchFormSpecialRates"
    },
    search: {
        egdsElementId: "search_button",
        primary: "Search",
        disabled: false,
        accessibility: "Search",
        icon: null,
        analytics: null,
        action: null,
        __typename: "EGDSSearchFormButton",
        onClick: {
            analytics: {
                linkName: "Search button clicked",
                referrerId: "Web.Car.Search.Button.Clicked",
                __typename: "ClientSideAnalytics"
            },
            __typename: "EGDSSubmitSearchFormAction"
        }
    },
    rentalTypes: null,
    localDateFormat: "M/d/yyyy",
    playback: null,
    searchLocation: searchLocationFallback
};
// src/components/ground-transportation/form/gt-search-form.tsx
import React101 from "react";
import { gql as gql74, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents5 } from "@shared-ui/logger-context";
// src/components/ground-transportation/utils/fallback-data-dates.ts
var TODAY2 = /* @__PURE__ */ new Date();
var START_DATE2 = /* @__PURE__ */ new Date();
START_DATE2.setDate(START_DATE2.getDate() + 14);
var DAY_AFTER_START_DATE2 = /* @__PURE__ */ new Date();
DAY_AFTER_START_DATE2.setDate(DAY_AFTER_START_DATE2.getDate() + 15);
var VALID_UPPPER = /* @__PURE__ */ new Date();
VALID_UPPPER.setDate(VALID_UPPPER.getDate() + 328);
function createDate2(date) {
    return {
        __typename: "Date",
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
}
// src/components/ground-transportation/utils/ground-transportation-fallback-data.ts
var AirportLocation = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "airport_location",
    label: "Airport",
    placeholder: "Airport",
    value: null,
    errorMessage: "Please select an airport",
    validations: [
        {
            errorMessage: "Please select an airport",
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Location selection",
            referrerId: "Web.GT.Location.Open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "SearchForm",
            drivable: false,
            isDestination: true,
            lineOfBusiness: "FLIGHTS",
            maxNumberOfResults: 7,
            packageType: null,
            personalize: true,
            regionType: 1,
            typeaheadFeatures: "proximity|nearby_airport|ta_hierarchy|consistent_display",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: null,
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
        linkName: "Location close",
        referrerId: "Web.GT.Location.Close",
        __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
        linkName: "Location change",
        referrerId: "Web.GT.Location.Change",
        __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
};
var HotelLocation = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "hotel_location",
    label: "Hotel",
    placeholder: "Hotel",
    value: null,
    errorMessage: "Please select a hotel",
    validations: [
        {
            errorMessage: "Please select a hotel",
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: "lob_hotels",
        __typename: "Icon"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Location selection",
            referrerId: "Web.GT.Location.Origin.Open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "SearchForm",
            drivable: false,
            isDestination: false,
            lineOfBusiness: "HOTELS",
            maxNumberOfResults: 7,
            packageType: null,
            personalize: true,
            regionType: 128,
            typeaheadFeatures: "proximity|consistent_display|google",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: null,
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
        linkName: "Location close",
        referrerId: "Web.GT.Location.Origin.Close",
        __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
        linkName: "Location change",
        referrerId: "Web.GT.Location.Origin.Change",
        __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
};
var Travelers2 = {
    action: {
        analytics: {
            linkName: "Travelers selector displayed",
            referrerId: "Travelers selector updated",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            closeButton: {
                egdsElementId: "travelers_selector_close_button",
                primary: "Close",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers Selector Close button",
                    referrerId: "Web.Gt.Search.Traveler.Selector.Close.Button.Clicked",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            doneButton: {
                egdsElementId: "travelers_selector_done_button",
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers Selector Done button",
                    referrerId: "Web.Gt.Search.Traveler.Selector.Done.Button.Clicked",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            title: "Travelers",
            travelers: {
                adults: {
                    decreaseAnalytics: {
                        linkName: "Adult traveler removed",
                        referrerId: "Web.Gt.Traveler.Remove.Adult",
                        __typename: "ClientSideAnalytics"
                    },
                    increaseAnalytics: {
                        linkName: "Adult traveler added",
                        referrerId: "Web.Gt.Traveler.Add.Adult",
                        __typename: "ClientSideAnalytics"
                    },
                    decreaseText: "Decrease the number of adults",
                    decreaseTextTemplate: null,
                    increaseText: "Increase the number of adults",
                    increaseTextTemplate: null,
                    egdsElementId: "traveler_selector_adult_step_input",
                    __typename: "EGDSTravelerStepInput",
                    label: "Adults",
                    max: 6,
                    min: 1,
                    step: 1,
                    subLabel: null,
                    value: 1
                },
                children: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Children traveler removed",
                            referrerId: "Web.Gt.Traveler.Remove.Children",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Children traveler added",
                            referrerId: "Web.Gt.Traveler.Add.Children",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of children",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of children",
                        increaseTextTemplate: null,
                        egdsElementId: "traveler_selector_children_step_input",
                        __typename: "EGDSTravelerStepInput",
                        label: "Children",
                        max: 5,
                        min: 0,
                        step: 1,
                        subLabel: "Age 2 to 17",
                        value: 0
                    },
                    type: null,
                    __typename: "EGDSBasicTraveler"
                },
                infantsInSeat: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Infant traveler removed",
                            referrerId: "Web.Gt.Traveler.Remove.InfantsInSeat",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Infant traveler added",
                            referrerId: "Web.Gt.Traveler.Add.InfantsInSeat",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of infants",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of infants",
                        increaseTextTemplate: null,
                        egdsElementId: "traveler_selector_infants_in_seat_step_input",
                        __typename: "EGDSTravelerStepInput",
                        label: "Infants",
                        max: 8,
                        min: 0,
                        step: 1,
                        subLabel: "Younger than 2",
                        value: 0
                    },
                    type: null,
                    __typename: "EGDSBasicTraveler"
                },
                infantsOnLap: null,
                pets: null,
                __typename: "EGDSTravelers"
            },
            validations: [
                {
                    errorMessage: "We allow up to 6 travelers per booking",
                    maxCount: 6,
                    type: "MAX_TRAVELERS" /* MAX_TRAVELERS */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "We allow up to 6 travelers per booking.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed",
                            referrerId: "Web.GT.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                }
            ],
            __typename: "EGDSBasicTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "travelerCount",
                source: "travelerCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "${travelerCount} traveler",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            }
        ],
        secondaryTemplates: null,
        text: "1 traveler",
        __typename: "EGDSCardinalLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    },
    readOnly: false,
    __typename: "EGDSSearchFormTravelersField"
};
var Search = {
    egdsElementId: "search_button",
    primary: "Search",
    disabled: false,
    accessibility: "Search",
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.GT.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var PickupTime = {
    __typename: "EGDSBasicSelect",
    egdsElementId: "pick_up_time",
    clickAnalytics: {
        linkName: "ground transportation time open",
        referrerId: "Web.Gt.pick_up_time.Open",
        __typename: "ClientSideAnalytics"
    },
    icon: null,
    label: "Flight arrival time",
    options: [
        {
            label: "12:00am",
            selected: false,
            value: "1200AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:15am",
            selected: false,
            value: "1215AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:30am",
            selected: false,
            value: "1230AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:45am",
            selected: false,
            value: "1245AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:00am",
            selected: false,
            value: "0100AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:15am",
            selected: false,
            value: "0115AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:30am",
            selected: false,
            value: "0130AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:45am",
            selected: false,
            value: "0145AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:00am",
            selected: false,
            value: "0200AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:15am",
            selected: false,
            value: "0215AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:30am",
            selected: false,
            value: "0230AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:45am",
            selected: false,
            value: "0245AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:00am",
            selected: false,
            value: "0300AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:15am",
            selected: false,
            value: "0315AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:30am",
            selected: false,
            value: "0330AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:45am",
            selected: false,
            value: "0345AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:00am",
            selected: false,
            value: "0400AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:15am",
            selected: false,
            value: "0415AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:30am",
            selected: false,
            value: "0430AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:45am",
            selected: false,
            value: "0445AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:00am",
            selected: false,
            value: "0500AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:15am",
            selected: false,
            value: "0515AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:30am",
            selected: false,
            value: "0530AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:45am",
            selected: false,
            value: "0545AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:00am",
            selected: false,
            value: "0600AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:15am",
            selected: false,
            value: "0615AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:30am",
            selected: false,
            value: "0630AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:45am",
            selected: false,
            value: "0645AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:00am",
            selected: false,
            value: "0700AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:15am",
            selected: false,
            value: "0715AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:30am",
            selected: false,
            value: "0730AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:45am",
            selected: false,
            value: "0745AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:00am",
            selected: false,
            value: "0800AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:15am",
            selected: false,
            value: "0815AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:30am",
            selected: false,
            value: "0830AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:45am",
            selected: false,
            value: "0845AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:00am",
            selected: false,
            value: "0900AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:15am",
            selected: false,
            value: "0915AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:30am",
            selected: false,
            value: "0930AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:45am",
            selected: false,
            value: "0945AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:00am",
            selected: false,
            value: "1000AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:15am",
            selected: false,
            value: "1015AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:30am",
            selected: true,
            value: "1030AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:45am",
            selected: false,
            value: "1045AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:00am",
            selected: false,
            value: "1100AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:15am",
            selected: false,
            value: "1115AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:30am",
            selected: false,
            value: "1130AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:45am",
            selected: false,
            value: "1145AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:00pm",
            selected: false,
            value: "1200PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:15pm",
            selected: false,
            value: "1215PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:30pm",
            selected: false,
            value: "1230PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:45pm",
            selected: false,
            value: "1245PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:00pm",
            selected: false,
            value: "0100PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:15pm",
            selected: false,
            value: "0115PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:30pm",
            selected: false,
            value: "0130PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:45pm",
            selected: false,
            value: "0145PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:00pm",
            selected: false,
            value: "0200PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:15pm",
            selected: false,
            value: "0215PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:30pm",
            selected: false,
            value: "0230PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:45pm",
            selected: false,
            value: "0245PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:00pm",
            selected: false,
            value: "0300PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:15pm",
            selected: false,
            value: "0315PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:30pm",
            selected: false,
            value: "0330PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:45pm",
            selected: false,
            value: "0345PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:00pm",
            selected: false,
            value: "0400PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:15pm",
            selected: false,
            value: "0415PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:30pm",
            selected: false,
            value: "0430PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:45pm",
            selected: false,
            value: "0445PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:00pm",
            selected: false,
            value: "0500PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:15pm",
            selected: false,
            value: "0515PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:30pm",
            selected: false,
            value: "0530PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:45pm",
            selected: false,
            value: "0545PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:00pm",
            selected: false,
            value: "0600PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:15pm",
            selected: false,
            value: "0615PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:30pm",
            selected: false,
            value: "0630PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:45pm",
            selected: false,
            value: "0645PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:00pm",
            selected: false,
            value: "0700PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:15pm",
            selected: false,
            value: "0715PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:30pm",
            selected: false,
            value: "0730PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:45pm",
            selected: false,
            value: "0745PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:00pm",
            selected: false,
            value: "0800PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:15pm",
            selected: false,
            value: "0815PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:30pm",
            selected: false,
            value: "0830PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:45pm",
            selected: false,
            value: "0845PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:00pm",
            selected: false,
            value: "0900PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:15pm",
            selected: false,
            value: "0915PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:30pm",
            selected: false,
            value: "0930PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:45pm",
            selected: false,
            value: "0945PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:00pm",
            selected: false,
            value: "1000PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:15pm",
            selected: false,
            value: "1015PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:30pm",
            selected: false,
            value: "1030PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:45pm",
            selected: false,
            value: "1045PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:00pm",
            selected: false,
            value: "1100PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:15pm",
            selected: false,
            value: "1115PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:30pm",
            selected: false,
            value: "1130PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:45pm",
            selected: false,
            value: "1145PM",
            __typename: "EGDSBasicOption"
        }
    ],
    disabled: false,
    errorMessage: "",
    readOnly: false,
    value: null
};
var DropoffTime = {
    __typename: "EGDSBasicSelect",
    egdsElementId: "drop_off_time",
    clickAnalytics: {
        linkName: "ground transportation time open",
        referrerId: "Web.Gt.drop_off_time.Open",
        __typename: "ClientSideAnalytics"
    },
    icon: null,
    label: "Flight departure time",
    options: [
        {
            label: "12:00am",
            selected: false,
            value: "1200AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:15am",
            selected: false,
            value: "1215AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:30am",
            selected: false,
            value: "1230AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:45am",
            selected: false,
            value: "1245AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:00am",
            selected: false,
            value: "0100AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:15am",
            selected: false,
            value: "0115AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:30am",
            selected: false,
            value: "0130AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:45am",
            selected: false,
            value: "0145AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:00am",
            selected: false,
            value: "0200AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:15am",
            selected: false,
            value: "0215AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:30am",
            selected: false,
            value: "0230AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:45am",
            selected: false,
            value: "0245AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:00am",
            selected: false,
            value: "0300AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:15am",
            selected: false,
            value: "0315AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:30am",
            selected: false,
            value: "0330AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:45am",
            selected: false,
            value: "0345AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:00am",
            selected: false,
            value: "0400AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:15am",
            selected: false,
            value: "0415AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:30am",
            selected: false,
            value: "0430AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:45am",
            selected: false,
            value: "0445AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:00am",
            selected: false,
            value: "0500AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:15am",
            selected: false,
            value: "0515AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:30am",
            selected: false,
            value: "0530AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:45am",
            selected: false,
            value: "0545AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:00am",
            selected: false,
            value: "0600AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:15am",
            selected: false,
            value: "0615AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:30am",
            selected: false,
            value: "0630AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:45am",
            selected: false,
            value: "0645AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:00am",
            selected: false,
            value: "0700AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:15am",
            selected: false,
            value: "0715AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:30am",
            selected: false,
            value: "0730AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:45am",
            selected: false,
            value: "0745AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:00am",
            selected: false,
            value: "0800AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:15am",
            selected: false,
            value: "0815AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:30am",
            selected: false,
            value: "0830AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:45am",
            selected: false,
            value: "0845AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:00am",
            selected: false,
            value: "0900AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:15am",
            selected: false,
            value: "0915AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:30am",
            selected: false,
            value: "0930AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:45am",
            selected: false,
            value: "0945AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:00am",
            selected: false,
            value: "1000AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:15am",
            selected: false,
            value: "1015AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:30am",
            selected: true,
            value: "1030AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:45am",
            selected: false,
            value: "1045AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:00am",
            selected: false,
            value: "1100AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:15am",
            selected: false,
            value: "1115AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:30am",
            selected: false,
            value: "1130AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:45am",
            selected: false,
            value: "1145AM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:00pm",
            selected: false,
            value: "1200PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:15pm",
            selected: false,
            value: "1215PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:30pm",
            selected: false,
            value: "1230PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "12:45pm",
            selected: false,
            value: "1245PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:00pm",
            selected: false,
            value: "0100PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:15pm",
            selected: false,
            value: "0115PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:30pm",
            selected: false,
            value: "0130PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "1:45pm",
            selected: false,
            value: "0145PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:00pm",
            selected: false,
            value: "0200PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:15pm",
            selected: false,
            value: "0215PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:30pm",
            selected: false,
            value: "0230PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "2:45pm",
            selected: false,
            value: "0245PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:00pm",
            selected: false,
            value: "0300PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:15pm",
            selected: false,
            value: "0315PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:30pm",
            selected: false,
            value: "0330PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "3:45pm",
            selected: false,
            value: "0345PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:00pm",
            selected: false,
            value: "0400PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:15pm",
            selected: false,
            value: "0415PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:30pm",
            selected: false,
            value: "0430PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "4:45pm",
            selected: false,
            value: "0445PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:00pm",
            selected: false,
            value: "0500PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:15pm",
            selected: false,
            value: "0515PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:30pm",
            selected: false,
            value: "0530PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "5:45pm",
            selected: false,
            value: "0545PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:00pm",
            selected: false,
            value: "0600PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:15pm",
            selected: false,
            value: "0615PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:30pm",
            selected: false,
            value: "0630PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "6:45pm",
            selected: false,
            value: "0645PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:00pm",
            selected: false,
            value: "0700PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:15pm",
            selected: false,
            value: "0715PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:30pm",
            selected: false,
            value: "0730PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "7:45pm",
            selected: false,
            value: "0745PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:00pm",
            selected: false,
            value: "0800PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:15pm",
            selected: false,
            value: "0815PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:30pm",
            selected: false,
            value: "0830PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "8:45pm",
            selected: false,
            value: "0845PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:00pm",
            selected: false,
            value: "0900PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:15pm",
            selected: false,
            value: "0915PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:30pm",
            selected: false,
            value: "0930PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "9:45pm",
            selected: false,
            value: "0945PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:00pm",
            selected: false,
            value: "1000PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:15pm",
            selected: false,
            value: "1015PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:30pm",
            selected: false,
            value: "1030PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "10:45pm",
            selected: false,
            value: "1045PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:00pm",
            selected: false,
            value: "1100PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:15pm",
            selected: false,
            value: "1115PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:30pm",
            selected: false,
            value: "1130PM",
            __typename: "EGDSBasicOption"
        },
        {
            label: "11:45pm",
            selected: false,
            value: "1145PM",
            __typename: "EGDSBasicOption"
        }
    ],
    disabled: false,
    errorMessage: "The departing flight must occur at least 2 hours after the arriving flight.",
    readOnly: false,
    value: null
};
var ErrorSummary = {
    egdsElementId: "search_form_error_summary",
    goToErrorLinkText: "Go to error",
    goToFirstErrorLinkText: "Go to first error",
    heading: "",
    body: null,
    analytics: {
        linkName: "Error summary link clicked",
        referrerId: "Web.GT.Search.Error.Summary",
        __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
        linkName: "Error summary displayed",
        referrerId: "Web.GT.Search.Error.Summary.Displayed",
        __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
        models: [
            {
                key: "errorCount",
                source: "errorCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "Please correct the error to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            }
        ],
        __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
};
var defaultGroundTransportationResponse = {
    searchForm: {
        __typename: "SearchFormResults",
        groundTransportation: {
            __typename: "GroundTransportationSearchForm",
            egdsElementId: "ground_transportation_search_form",
            actionURL: "/ground-transfers/",
            errorSummary: ErrorSummary,
            dates: {
                egdsElementId: "date_form_field",
                label: "Flight arrival date",
                placeholder: "Flight arrival date",
                errorMessage: "",
                validations: null,
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "ground transportation calendar selection",
                        referrerId: "Web.GT.Calendar.Open",
                        __typename: "ClientSideAnalytics"
                    },
                    datePicker: {
                        buttonText: "Done",
                        selectedStartDate: _object_spread({}, createDate2(START_DATE2)),
                        validDaysLowerBoundInclusive: _object_spread({}, createDate2(TODAY2)),
                        validDaysUpperBoundInclusive: _object_spread({}, createDate2(VALID_UPPPER)),
                        submitButtonAnalytics: {
                            linkName: "ground transportation dates submit button",
                            referrerId: "Web.GT.Calendar.Dates.Submit",
                            __typename: "ClientSideAnalytics"
                        },
                        startDateButtonAnalytics: {
                            linkName: "ground transportation dates Dates start date button",
                            referrerId: "Web.GT.Calendar.Start.Dates.Click",
                            __typename: "ClientSideAnalytics"
                        },
                        firstDayOfWeek: "SUN" /* SUN */ ,
                        __typename: "EGDSSingleDatePicker"
                    },
                    __typename: "EGDSOpenDatePickerAction"
                },
                __typename: "EGDSSearchFormDatePickerField"
            },
            hotelLocation: HotelLocation,
            airportLocation: AirportLocation,
            travelers: Travelers2,
            pickupTime: PickupTime,
            dropoffTime: null,
            elements: [],
            playback: null,
            search: Search,
            groundTransportationSelection: {
                __typename: "GroundTransportationSearchFormSelection",
                airportToHotel: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_from_airport",
                    primary: "Airport to hotel",
                    accessibility: null,
                    disabled: false,
                    selected: true,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                },
                hotelToAirport: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_to_airport",
                    primary: "Hotel to airport",
                    accessibility: null,
                    disabled: false,
                    selected: false,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                },
                roundTrip: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_round_trip",
                    primary: "Roundtrip",
                    accessibility: null,
                    disabled: false,
                    selected: false,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                }
            },
            searchLocation: searchLocationFallback
        }
    }
};
var toAirportGroundTransportationResponse = {
    searchForm: {
        __typename: "SearchFormResults",
        groundTransportation: {
            __typename: "GroundTransportationSearchForm",
            egdsElementId: "ground_transportation_search_form",
            actionURL: "/ground-transfers/",
            errorSummary: ErrorSummary,
            dates: {
                egdsElementId: "date_form_field",
                label: "Flight departure date",
                placeholder: "Flight departure date",
                errorMessage: "",
                validations: null,
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "ground transportation calendar selection",
                        referrerId: "Web.GT.Calendar.Open",
                        __typename: "ClientSideAnalytics"
                    },
                    datePicker: {
                        buttonText: "Done",
                        selectedStartDate: _object_spread({}, createDate2(START_DATE2)),
                        validDaysLowerBoundInclusive: _object_spread({}, createDate2(TODAY2)),
                        validDaysUpperBoundInclusive: _object_spread({}, createDate2(VALID_UPPPER)),
                        submitButtonAnalytics: {
                            linkName: "ground transportation dates submit button",
                            referrerId: "Web.GT.Calendar.Dates.Submit",
                            __typename: "ClientSideAnalytics"
                        },
                        startDateButtonAnalytics: {
                            linkName: "ground transportation dates Dates start date button",
                            referrerId: "Web.GT.Calendar.Start.Dates.Click",
                            __typename: "ClientSideAnalytics"
                        },
                        firstDayOfWeek: "SUN" /* SUN */ ,
                        __typename: "EGDSSingleDatePicker"
                    },
                    __typename: "EGDSOpenDatePickerAction"
                },
                __typename: "EGDSSearchFormDatePickerField"
            },
            hotelLocation: HotelLocation,
            airportLocation: AirportLocation,
            travelers: Travelers2,
            pickupTime: null,
            dropoffTime: DropoffTime,
            elements: [],
            playback: null,
            search: Search,
            groundTransportationSelection: {
                __typename: "GroundTransportationSearchFormSelection",
                airportToHotel: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_from_airport",
                    primary: "Airport to hotel",
                    accessibility: null,
                    disabled: false,
                    selected: false,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                },
                hotelToAirport: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_to_airport",
                    primary: "Hotel to airport",
                    accessibility: null,
                    disabled: false,
                    selected: true,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                },
                roundTrip: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_round_trip",
                    primary: "Roundtrip",
                    accessibility: null,
                    disabled: false,
                    selected: false,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                }
            },
            searchLocation: searchLocationFallback
        }
    }
};
var roundTripGroundTransportationResponse = {
    searchForm: {
        __typename: "SearchFormResults",
        groundTransportation: {
            __typename: "GroundTransportationSearchForm",
            egdsElementId: "ground_transportation_search_form",
            actionURL: "/ground-transfers/search",
            errorSummary: ErrorSummary,
            dates: {
                egdsElementId: "date_form_field",
                label: "Flight dates",
                placeholder: "Flight dates",
                errorMessage: "",
                validations: null,
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "ground transportation calendar selection",
                        referrerId: "Web.GT.Calendar.Open",
                        __typename: "ClientSideAnalytics"
                    },
                    datePicker: {
                        buttonText: "Done",
                        buttonTextTemplate: null,
                        clearButtonText: null,
                        firstDayOfWeek: "SUN" /* SUN */ ,
                        maxNumberOfDaysSelected: null,
                        sameDaySelectionAllowed: true,
                        selectedStartDate: _object_spread({}, createDate2(START_DATE2)),
                        startDatePlaceholderText: "",
                        selectedEndDate: _object_spread({}, createDate2(DAY_AFTER_START_DATE2)),
                        endDatePlaceholderText: "",
                        validDaysLowerBoundInclusive: _object_spread({}, createDate2(TODAY2)),
                        validDaysUpperBoundInclusive: _object_spread({}, createDate2(VALID_UPPPER)),
                        flexibleDateContent: null,
                        submitButtonAnalytics: {
                            linkName: "ground transportation dates submit button",
                            referrerId: "Web.GT.Calendar.Dates.Submit",
                            __typename: "ClientSideAnalytics"
                        },
                        nextButtonAnalytics: {
                            linkName: "ground transportation dates Dates next date button",
                            referrerId: "Web.GT.Calendar.Next.Dates.Click",
                            __typename: "ClientSideAnalytics"
                        },
                        previousButtonAnalytics: {
                            linkName: "ground transportation dates Dates previous date button",
                            referrerId: "Web.GT.Calendar.Previous.Dates.Click",
                            __typename: "ClientSideAnalytics"
                        },
                        startDateButtonAnalytics: {
                            linkName: "ground transportation dates Dates start date button",
                            referrerId: "Web.GT.Calendar.Start.Dates.Click",
                            __typename: "ClientSideAnalytics"
                        },
                        endDateButtonAnalytics: {
                            linkName: "ground transportation dates Dates end date button",
                            referrerId: "Web.GT.Calendar.End.Dates.Click",
                            __typename: "ClientSideAnalytics"
                        },
                        clearDatesButtonAnalytics: {
                            linkName: "ground transportation dates Dates clear button",
                            referrerId: "Web.GT.Calendar.Clear.Dates.Submit",
                            __typename: "ClientSideAnalytics"
                        },
                        showClearDatesButton: false,
                        __typename: "EGDSDateRangePicker"
                    },
                    __typename: "EGDSOpenDatePickerAction"
                },
                __typename: "EGDSSearchFormDatePickerField"
            },
            hotelLocation: HotelLocation,
            airportLocation: AirportLocation,
            travelers: Travelers2,
            pickupTime: PickupTime,
            dropoffTime: DropoffTime,
            elements: [],
            playback: null,
            search: Search,
            groundTransportationSelection: {
                __typename: "GroundTransportationSearchFormSelection",
                airportToHotel: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_from_airport",
                    primary: "Airport to hotel",
                    accessibility: null,
                    disabled: false,
                    selected: false,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                },
                hotelToAirport: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_to_airport",
                    primary: "Hotel to airport",
                    accessibility: null,
                    disabled: false,
                    selected: false,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                },
                roundTrip: {
                    __typename: "EGDSBasicPill",
                    name: "trip_direction_round_trip",
                    primary: "Roundtrip",
                    accessibility: null,
                    disabled: false,
                    selected: true,
                    selectedText: "",
                    value: null,
                    deselectAnalytics: null,
                    selectAnalytics: null,
                    icon: null
                }
            },
            searchLocation: searchLocationFallback
        }
    }
};
var getFallbackData2 = function(tripDirection) {
    switch(tripDirection){
        case "TO_AIRPORT" /* TO_AIRPORT */ :
            {
                return toAirportGroundTransportationResponse;
            }
        case "ROUNDTRIP" /* ROUNDTRIP */ :
            {
                return roundTripGroundTransportationResponse;
            }
        default:
            {
                return defaultGroundTransportationResponse;
            }
    }
};
// src/components/ground-transportation/form/__private/__fragments/ground-transportation-search-form.tsx
import React100 from "react";
import { gql as gql73 } from "@apollo/client";
import { useLocalization as useLocalization13 } from "@shared-ui/localization-context";
// ../internal/src/components/common/egds-select/egds-select.tsx
import React98 from "react";
import { gql as gql71 } from "@apollo/client";
// ../internal/src/components/common/egds-select/egds-basic-select.tsx
import React97 from "react";
import { gql as gql70 } from "@apollo/client";
import { useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback9 } from "uitk-react-form";
import { UitkSelect as UitkSelect3 } from "uitk-react-input";
var EGDS_BASIC_SELECT_NAME_PREFIX = "EGDSBasicSelect";
var __Fragment48 = gql70(_templateObject74());
var EGDSBasicSelect = function(param) {
    var onChange = param.onChange, selectValue = param.selectValue, emptyState = param.emptyState, data = param.data, errorMessage = param.errorMessage, setInputRef = param.setInputRef;
    var track = useClickTracker29();
    var egdsElementId = data.egdsElementId, label = data.label, icon = data.icon, options = data.options, clickAnalytics = data.clickAnalytics, readOnly = data.readOnly, disabled = data.disabled;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_basic_select";
    var selectRef = React97.useRef(null);
    var handleClick = React97.useCallback(function() {
        if (clickAnalytics && clickAnalytics.__typename === "ClientSideAnalytics") {
            var referrerId = clickAnalytics.referrerId, linkName = clickAnalytics.linkName;
            track(referrerId, linkName);
        }
    }, [
        clickAnalytics,
        track
    ]);
    var handleOnChange = useFormCallback9(id, function(event) {
        if (onChange) {
            onChange(event);
        }
        return event;
    });
    React97.useEffect(function() {
        if (setInputRef) {
            setInputRef(selectRef);
        }
    }, []);
    if ((options === null || options === void 0 ? void 0 : options.length) > 0) {
        return /* @__PURE__ */ React97.createElement(UitkSelect3, {
            readOnly: readOnly,
            disabled: disabled,
            id: id,
            name: "".concat(EGDS_BASIC_SELECT_NAME_PREFIX, "-").concat(id),
            label: label,
            icon: icon === null || icon === void 0 ? void 0 : icon.id,
            onClick: handleClick,
            "aria-label": label !== null && label !== void 0 ? label : "",
            onChange: handleOnChange,
            emptyState: emptyState,
            value: selectValue,
            placeholder: emptyState ? label : void 0,
            invalid: errorMessage,
            domRef: selectRef
        }, options.map(function(param) {
            var optionLabel = param.label, value = param.value, selected = param.selected;
            return /* @__PURE__ */ React97.createElement("option", {
                key: value,
                label: optionLabel,
                value: value,
                selected: selected !== null && selected !== void 0 ? selected : false
            }, optionLabel);
        }));
    }
    return null;
};
EGDSBasicSelect.displayName = "EGDSBasicSelect";
EGDSBasicSelect.fragment = __Fragment48;
// ../internal/src/components/common/egds-select/egds-select.tsx
var __Fragment49 = gql71(_templateObject75(), EGDSBasicSelect.fragment);
var EGDSSelect = function(props) {
    var data = props.data, fieldError = props.fieldError;
    var getErrorMessage = function(element) {
        if (data.__typename === "EGDSBasicSelect") {
            var _data_errorMessage;
            return (element === null || element === void 0 ? void 0 : element.isValid) ? "" : (_data_errorMessage = data.errorMessage) !== null && _data_errorMessage !== void 0 ? _data_errorMessage : "";
        }
        return "";
    };
    var errorText = fieldError ? getErrorMessage(fieldError) : "";
    var selectProps = _object_spread({
        errorMessage: errorText
    }, props);
    switch(data.__typename){
        case "EGDSBasicSelect":
            return /* @__PURE__ */ React98.createElement(EGDSBasicSelect, _object_spread_props(_object_spread({}, selectProps), {
                data: data
            }));
        default:
            return null;
    }
};
EGDSSelect.displayName = "EGDSSelect";
EGDSSelect.fragment = __Fragment49;
// src/components/ground-transportation/form/__private/__fragments/ground-transportation-search-form.tsx
import { ViewMedium as ViewMedium21, Viewport as Viewport24, ViewSmall as ViewSmall22 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm7 } from "uitk-react-form";
import { UitkLayoutGrid as UitkLayoutGrid5, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing29 } from "uitk-react-spacing";
// src/components/ground-transportation/utils/fields-map.ts
var FieldNameMap3 = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["AIRPORT"] = "airport_location";
    FieldNameMap8["HOTEL"] = "hotel_location";
    FieldNameMap8["SINGLE_DATE_PICKER_START_DATE"] = "EGDSSingleDatePicker-StartDate";
    FieldNameMap8["DATE_RANGE_PICKER"] = "EGDSDateRangePicker";
    FieldNameMap8["BASIC_TRAVELER_SELECTOR"] = "EGDSBasicTravelerSelector";
    return FieldNameMap8;
}(FieldNameMap3 || {});
// src/components/ground-transportation/utils/query-params.ts
var getFormattedDate = function(param) {
    var day = param.day, month = param.month, year = param.year;
    var formattedDay = day < 10 ? "0".concat(day) : day;
    var formattedMonth = month < 10 ? "0".concat(month) : month;
    return "".concat(year, "-").concat(formattedMonth, "-").concat(formattedDay);
};
var getFormattedTime = function(param) {
    var hour = param.hour, minute = param.minute;
    return "".concat(hour < 10 ? "0" : "").concat(hour, ":").concat(minute < 10 ? "0" : "").concat(minute);
};
var getURLQueryParamsFromGroundTransportationCriteria = function(criteria) {
    var _journeyCriteria_, _journeyCriteria_1;
    if (criteria.primarySearchCriteria == null || criteria.primarySearchCriteria.groundTransportation == null) {
        return "";
    }
    var regionId = criteria.regionId;
    var _criteria_primarySearchCriteria_groundTransportation = criteria.primarySearchCriteria.groundTransportation, travelerDetails = _criteria_primarySearchCriteria_groundTransportation.travelerDetails, direction = _criteria_primarySearchCriteria_groundTransportation.direction, journeyCriteria = _criteria_primarySearchCriteria_groundTransportation.journeyCriteria;
    var directionParam = "direction=".concat(direction, "&roundTrip=").concat(direction === "ROUNDTRIP" /* ROUNDTRIP */ );
    var _getLocationsFromJourneyCriteria = getLocationsFromJourneyCriteria(journeyCriteria), hotel = _getLocationsFromJourneyCriteria.hotel, airport = _getLocationsFromJourneyCriteria.airport;
    var _airport_name;
    var airportLocationParam = "&airportCode=".concat(airport === null || airport === void 0 ? void 0 : airport.id, "&location=").concat(encodeURIComponent((_airport_name = airport === null || airport === void 0 ? void 0 : airport.name) !== null && _airport_name !== void 0 ? _airport_name : ""), "&regionId=").concat(regionId);
    var _hotel_name;
    var hotelLocationParam = "&hotelId=".concat(hotel === null || hotel === void 0 ? void 0 : hotel.id, "&hotelName=").concat(encodeURIComponent((_hotel_name = hotel === null || hotel === void 0 ? void 0 : hotel.name) !== null && _hotel_name !== void 0 ? _hotel_name : ""));
    var firstJourneyDateTime = journeyCriteria === null || journeyCriteria === void 0 ? void 0 : (_journeyCriteria_ = journeyCriteria[0]) === null || _journeyCriteria_ === void 0 ? void 0 : _journeyCriteria_.dateTime;
    var secondJourneyDateTime = journeyCriteria === null || journeyCriteria === void 0 ? void 0 : (_journeyCriteria_1 = journeyCriteria[1]) === null || _journeyCriteria_1 === void 0 ? void 0 : _journeyCriteria_1.dateTime;
    var pickUpTimeParam = "&pickUpDate=".concat(firstJourneyDateTime && getFormattedDate(firstJourneyDateTime), "&pickUpTime=").concat(firstJourneyDateTime && getFormattedTime(firstJourneyDateTime));
    var dropOffTimeParam = direction === "ROUNDTRIP" /* ROUNDTRIP */  ? "&dropOffDate=".concat(secondJourneyDateTime && getFormattedDate(secondJourneyDateTime), "&dropOffTime=").concat(secondJourneyDateTime && getFormattedTime(secondJourneyDateTime)) : "";
    var adults = travelerDetails.find(function(traveler) {
        return traveler.type === "ADULT" /* ADULT */ ;
    });
    var children = travelerDetails.find(function(traveler) {
        return traveler.type === "CHILD" /* CHILD */ ;
    });
    var infants = travelerDetails.find(function(traveler) {
        return traveler.type === "INFANT" /* INFANT */ ;
    });
    var adultsParam = adults ? "&adults=".concat(adults.count) : "";
    var childrenParam = children ? "&children=".concat(children.count) : "";
    var infantsParam = infants ? "&infants=".concat(infants.count) : "";
    var travelParam = "".concat(adultsParam).concat(childrenParam).concat(infantsParam);
    return "?".concat(directionParam).concat(airportLocationParam).concat(hotelLocationParam).concat(pickUpTimeParam).concat(dropOffTimeParam).concat(travelParam);
};
var getLocationsFromJourneyCriteria = function(journeyCriteria) {
    var _firstJourney_destination;
    if (!journeyCriteria) {
        return {};
    }
    var hotel;
    var airport;
    var firstJourney = journeyCriteria[0];
    if ((firstJourney === null || firstJourney === void 0 ? void 0 : (_firstJourney_destination = firstJourney.destination) === null || _firstJourney_destination === void 0 ? void 0 : _firstJourney_destination.type) === "AIRPORT" /* AIRPORT */ ) {
        airport = firstJourney === null || firstJourney === void 0 ? void 0 : firstJourney.destination;
        hotel = firstJourney === null || firstJourney === void 0 ? void 0 : firstJourney.origin;
    } else {
        airport = firstJourney === null || firstJourney === void 0 ? void 0 : firstJourney.origin;
        hotel = firstJourney === null || firstJourney === void 0 ? void 0 : firstJourney.destination;
    }
    return {
        airport: airport,
        hotel: hotel
    };
};
// src/components/ground-transportation/utils/search-criteria.ts
var HOTEL_LOCATION_NAME_SUFFIX = "hotel_location";
var AIRPORT_LOCATION_NAME_SUFFIX = "airport_location";
var PICKUP_TIME_SUFFIX = "pick_up_time";
var assignValuesToJourneyCriteriaLocation = function(currentJourneyCriteria, journeyCriteriaArrayPosition, locationKey, locationFieldKey, locationFieldValue, locationType) {
    var _updatedJourneyCriteria_journeyCriteriaArrayPosition;
    var updatedJourneyCriteria = _to_consumable_array(currentJourneyCriteria);
    var _updatedJourneyCriteria_journeyCriteriaArrayPosition1, _updatedJourneyCriteria_journeyCriteriaArrayPosition_locationKey;
    var _obj;
    updatedJourneyCriteria[journeyCriteriaArrayPosition] = _object_spread_props(_object_spread({}, (_updatedJourneyCriteria_journeyCriteriaArrayPosition1 = updatedJourneyCriteria[journeyCriteriaArrayPosition]) !== null && _updatedJourneyCriteria_journeyCriteriaArrayPosition1 !== void 0 ? _updatedJourneyCriteria_journeyCriteriaArrayPosition1 : {}), _define_property({}, locationKey, _object_spread_props(_object_spread({}, (_updatedJourneyCriteria_journeyCriteriaArrayPosition_locationKey = (_updatedJourneyCriteria_journeyCriteriaArrayPosition = updatedJourneyCriteria[journeyCriteriaArrayPosition]) === null || _updatedJourneyCriteria_journeyCriteriaArrayPosition === void 0 ? void 0 : _updatedJourneyCriteria_journeyCriteriaArrayPosition[locationKey]) !== null && _updatedJourneyCriteria_journeyCriteriaArrayPosition_locationKey !== void 0 ? _updatedJourneyCriteria_journeyCriteriaArrayPosition_locationKey : {}), (_obj = {}, _define_property(_obj, locationFieldKey, locationFieldValue), _define_property(_obj, "type", locationType), _obj))));
    return updatedJourneyCriteria;
};
var setLocationAirportCodeToGtCriteria = function(groundTransportation, value) {
    var _groundTransportation_locations;
    var currentlocations = _to_consumable_array((_groundTransportation_locations = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.locations) !== null && _groundTransportation_locations !== void 0 ? _groundTransportation_locations : []);
    currentlocations[0] = _object_spread_props(_object_spread({}, currentlocations[0]), {
        id: value
    });
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var locationTypeKey = (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "TO_AIRPORT" /* TO_AIRPORT */  ? "destination" : "origin";
    var roundTripsecondLocationTypeKey = "destination";
    var locationFieldKey = "id";
    currentJourneyCriteria = assignValuesToJourneyCriteriaLocation(currentJourneyCriteria, 0, locationTypeKey, locationFieldKey, value, "AIRPORT" /* AIRPORT */ );
    if ((groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "ROUNDTRIP" /* ROUNDTRIP */ ) {
        currentJourneyCriteria = assignValuesToJourneyCriteriaLocation(currentJourneyCriteria, 1, roundTripsecondLocationTypeKey, locationFieldKey, value, "AIRPORT" /* AIRPORT */ );
    }
    return _object_spread_props(_object_spread({}, groundTransportation), {
        locations: currentlocations,
        journeyCriteria: currentJourneyCriteria
    });
};
var setLocationHotelIdToGtCriteria = function(groundTransportation, value) {
    var _groundTransportation_locations;
    var currentlocations = _to_consumable_array((_groundTransportation_locations = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.locations) !== null && _groundTransportation_locations !== void 0 ? _groundTransportation_locations : []);
    currentlocations[1] = _object_spread_props(_object_spread({}, currentlocations[1]), {
        id: value
    });
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var locationTypeKey = (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "TO_AIRPORT" /* TO_AIRPORT */  ? "origin" : "destination";
    var roundTripsecondLocationTypeKey = "origin";
    currentJourneyCriteria = assignValuesToJourneyCriteriaLocation(currentJourneyCriteria, 0, locationTypeKey, "id", value, "PROPERTY" /* PROPERTY */ );
    if ((groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "ROUNDTRIP" /* ROUNDTRIP */ ) {
        currentJourneyCriteria = assignValuesToJourneyCriteriaLocation(currentJourneyCriteria, 1, roundTripsecondLocationTypeKey, "id", value, "PROPERTY" /* PROPERTY */ );
    }
    return _object_spread_props(_object_spread({}, groundTransportation), {
        locations: currentlocations,
        journeyCriteria: currentJourneyCriteria
    });
};
var setLocationNameGtCriteria = function(groundTransportation, value, name) {
    var _groundTransportation_locations;
    var currentlocations = _to_consumable_array((_groundTransportation_locations = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.locations) !== null && _groundTransportation_locations !== void 0 ? _groundTransportation_locations : []);
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var locationTypeKey;
    var roundTripsecondLocationTypeKey;
    var locationGeoTypeValue;
    if (name.includes(AIRPORT_LOCATION_NAME_SUFFIX)) {
        currentlocations[0] = _object_spread_props(_object_spread({}, currentlocations[0]), {
            name: value
        });
        locationTypeKey = (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "TO_AIRPORT" /* TO_AIRPORT */  ? "destination" : "origin";
        roundTripsecondLocationTypeKey = "destination";
        locationGeoTypeValue = "AIRPORT" /* AIRPORT */ ;
    }
    if (name.includes(HOTEL_LOCATION_NAME_SUFFIX)) {
        currentlocations[1] = _object_spread_props(_object_spread({}, currentlocations[1]), {
            name: value
        });
        locationTypeKey = (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "TO_AIRPORT" /* TO_AIRPORT */  ? "origin" : "destination";
        roundTripsecondLocationTypeKey = "origin";
        locationGeoTypeValue = "PROPERTY" /* PROPERTY */ ;
    }
    if (locationTypeKey && roundTripsecondLocationTypeKey && locationGeoTypeValue && currentlocations) {
        currentJourneyCriteria = assignValuesToJourneyCriteriaLocation(currentJourneyCriteria, 0, locationTypeKey, "name", value, locationGeoTypeValue);
        if ((groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "ROUNDTRIP" /* ROUNDTRIP */ ) {
            currentJourneyCriteria = assignValuesToJourneyCriteriaLocation(currentJourneyCriteria, 1, roundTripsecondLocationTypeKey, "name", value, locationGeoTypeValue);
        }
    }
    return _object_spread_props(_object_spread({}, groundTransportation), {
        locations: currentlocations,
        journeyCriteria: currentJourneyCriteria
    });
};
var setLocationCoordinatesGtCriteria = function(groundTransportation, value, name) {
    var _currentlocations_locationKey_coordinates, _currentlocations_locationKey, _currentlocations_locationKey_coordinates1, _currentlocations_locationKey1, _currentJourneyCriteria_, _currentJourneyCriteria__locationTypeKey, _currentJourneyCriteria_1;
    var isHotel = name.includes(HOTEL_LOCATION_NAME_SUFFIX);
    var locationKey = isHotel ? 1 : 0;
    var isLat = name.startsWith("".concat(LAT_NAME_PREFIX));
    var _groundTransportation_locations;
    var currentlocations = _to_consumable_array((_groundTransportation_locations = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.locations) !== null && _groundTransportation_locations !== void 0 ? _groundTransportation_locations : []);
    var _currentlocations_locationKey_coordinates_latitude;
    var latitude = isLat ? Number(value) : (_currentlocations_locationKey_coordinates_latitude = (_currentlocations_locationKey = currentlocations[locationKey]) === null || _currentlocations_locationKey === void 0 ? void 0 : (_currentlocations_locationKey_coordinates = _currentlocations_locationKey.coordinates) === null || _currentlocations_locationKey_coordinates === void 0 ? void 0 : _currentlocations_locationKey_coordinates.latitude) !== null && _currentlocations_locationKey_coordinates_latitude !== void 0 ? _currentlocations_locationKey_coordinates_latitude : 200;
    var _currentlocations_locationKey_coordinates_longitude;
    var longitude = !isLat ? Number(value) : (_currentlocations_locationKey_coordinates_longitude = (_currentlocations_locationKey1 = currentlocations[locationKey]) === null || _currentlocations_locationKey1 === void 0 ? void 0 : (_currentlocations_locationKey_coordinates1 = _currentlocations_locationKey1.coordinates) === null || _currentlocations_locationKey_coordinates1 === void 0 ? void 0 : _currentlocations_locationKey_coordinates1.longitude) !== null && _currentlocations_locationKey_coordinates_longitude !== void 0 ? _currentlocations_locationKey_coordinates_longitude : 200;
    currentlocations[locationKey] = _object_spread_props(_object_spread({}, currentlocations[locationKey]), {
        coordinates: {
            latitude: latitude,
            longitude: longitude
        }
    });
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var locationTypeKey = isHotel && (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) !== "TO_AIRPORT" /* TO_AIRPORT */  || !isHotel && (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "TO_AIRPORT" /* TO_AIRPORT */  ? "destination" : "origin";
    var roundTripsecondLocationTypeKey = locationTypeKey === "origin" ? "destination" : "origin";
    var locationFieldKey = "coordinates";
    var coordinatesFieldKey = isLat ? "latitude" : "longitude";
    var _currentJourneyCriteria_2, _currentJourneyCriteria__locationTypeKey1, _currentJourneyCriteria__locationTypeKey_locationFieldKey;
    currentJourneyCriteria[0] = _object_spread_props(_object_spread({}, (_currentJourneyCriteria_2 = currentJourneyCriteria[0]) !== null && _currentJourneyCriteria_2 !== void 0 ? _currentJourneyCriteria_2 : {}), _define_property({}, locationTypeKey, _object_spread_props(_object_spread({}, (_currentJourneyCriteria__locationTypeKey1 = (_currentJourneyCriteria_ = currentJourneyCriteria[0]) === null || _currentJourneyCriteria_ === void 0 ? void 0 : _currentJourneyCriteria_[locationTypeKey]) !== null && _currentJourneyCriteria__locationTypeKey1 !== void 0 ? _currentJourneyCriteria__locationTypeKey1 : {}), _define_property({}, locationFieldKey, _object_spread_props(_object_spread({}, (_currentJourneyCriteria__locationTypeKey_locationFieldKey = (_currentJourneyCriteria_1 = currentJourneyCriteria[0]) === null || _currentJourneyCriteria_1 === void 0 ? void 0 : (_currentJourneyCriteria__locationTypeKey = _currentJourneyCriteria_1[locationTypeKey]) === null || _currentJourneyCriteria__locationTypeKey === void 0 ? void 0 : _currentJourneyCriteria__locationTypeKey[locationFieldKey]) !== null && _currentJourneyCriteria__locationTypeKey_locationFieldKey !== void 0 ? _currentJourneyCriteria__locationTypeKey_locationFieldKey : {}), _define_property({}, coordinatesFieldKey, Number(value)))))));
    if ((groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "ROUNDTRIP" /* ROUNDTRIP */ ) {
        var _currentJourneyCriteria_3, _currentJourneyCriteria__roundTripsecondLocationTypeKey, _currentJourneyCriteria_4;
        var _currentJourneyCriteria_5, _currentJourneyCriteria__roundTripsecondLocationTypeKey1, _currentJourneyCriteria__roundTripsecondLocationTypeKey_locationFieldKey;
        currentJourneyCriteria[1] = _object_spread_props(_object_spread({}, (_currentJourneyCriteria_5 = currentJourneyCriteria[1]) !== null && _currentJourneyCriteria_5 !== void 0 ? _currentJourneyCriteria_5 : {}), _define_property({}, roundTripsecondLocationTypeKey, _object_spread_props(_object_spread({}, (_currentJourneyCriteria__roundTripsecondLocationTypeKey1 = (_currentJourneyCriteria_3 = currentJourneyCriteria[1]) === null || _currentJourneyCriteria_3 === void 0 ? void 0 : _currentJourneyCriteria_3[roundTripsecondLocationTypeKey]) !== null && _currentJourneyCriteria__roundTripsecondLocationTypeKey1 !== void 0 ? _currentJourneyCriteria__roundTripsecondLocationTypeKey1 : {}), _define_property({}, locationFieldKey, _object_spread_props(_object_spread({}, (_currentJourneyCriteria__roundTripsecondLocationTypeKey_locationFieldKey = (_currentJourneyCriteria_4 = currentJourneyCriteria[1]) === null || _currentJourneyCriteria_4 === void 0 ? void 0 : (_currentJourneyCriteria__roundTripsecondLocationTypeKey = _currentJourneyCriteria_4[roundTripsecondLocationTypeKey]) === null || _currentJourneyCriteria__roundTripsecondLocationTypeKey === void 0 ? void 0 : _currentJourneyCriteria__roundTripsecondLocationTypeKey[locationFieldKey]) !== null && _currentJourneyCriteria__roundTripsecondLocationTypeKey_locationFieldKey !== void 0 ? _currentJourneyCriteria__roundTripsecondLocationTypeKey_locationFieldKey : {}), _define_property({}, coordinatesFieldKey, Number(value)))))));
    }
    return _object_spread_props(_object_spread({}, groundTransportation), {
        locations: currentlocations,
        journeyCriteria: currentJourneyCriteria
    });
};
var setDateSingleDirectionToGtCriteria = function(groundTransportation, value) {
    var _currentJourneyCriteria_journeyCriteriaArrayPosition;
    var _value_split_map = _sliced_to_array(value.split("-").map(function(item) {
        return Number(item);
    }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
    var currentDates = _object_spread({}, groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.dateRange);
    if (currentDates.start === null || currentDates.start === void 0) {
        currentDates.start = {
            day: day,
            month: month,
            year: year,
            hour: 10,
            minute: 30,
            second: 0
        };
    } else {
        currentDates.start = _object_spread_props(_object_spread({}, currentDates.start), {
            day: day,
            month: month,
            year: year
        });
    }
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var journeyCriteriaArrayPosition = 0;
    var _currentJourneyCriteria_journeyCriteriaArrayPosition1, _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime;
    currentJourneyCriteria[journeyCriteriaArrayPosition] = _object_spread_props(_object_spread({}, (_currentJourneyCriteria_journeyCriteriaArrayPosition1 = currentJourneyCriteria[journeyCriteriaArrayPosition]) !== null && _currentJourneyCriteria_journeyCriteriaArrayPosition1 !== void 0 ? _currentJourneyCriteria_journeyCriteriaArrayPosition1 : {}), {
        dateTime: _object_spread_props(_object_spread({}, (_currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime = (_currentJourneyCriteria_journeyCriteriaArrayPosition = currentJourneyCriteria[journeyCriteriaArrayPosition]) === null || _currentJourneyCriteria_journeyCriteriaArrayPosition === void 0 ? void 0 : _currentJourneyCriteria_journeyCriteriaArrayPosition.dateTime) !== null && _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime !== void 0 ? _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime : {}), {
            day: day,
            month: month,
            year: year
        })
    });
    return _object_spread_props(_object_spread({}, groundTransportation), {
        dateRange: currentDates,
        journeyCriteria: currentJourneyCriteria
    });
};
var setDatesRoundTripDirectionToGtCriteria = function(groundTransportation, value, name) {
    var _currentJourneyCriteria_journeyCriteriaArrayPosition;
    var dateKey = name.includes(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX) ? "start" : "end";
    var _value_split_map = _sliced_to_array(value.split("-").map(function(item) {
        return Number(item);
    }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
    var currentDates = _object_spread({}, groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.dateRange);
    if (currentDates.start === null || currentDates[dateKey] === void 0) {
        currentDates[dateKey] = {
            day: day,
            month: month,
            year: year,
            hour: 10,
            minute: 30,
            second: 0
        };
    } else {
        currentDates[dateKey].day = day;
        currentDates[dateKey].month = month;
        currentDates[dateKey].year = year;
    }
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var journeyCriteriaArrayPosition = name.includes(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX) ? 0 : 1;
    var _currentJourneyCriteria_journeyCriteriaArrayPosition1, _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime;
    currentJourneyCriteria[journeyCriteriaArrayPosition] = _object_spread_props(_object_spread({}, (_currentJourneyCriteria_journeyCriteriaArrayPosition1 = currentJourneyCriteria[journeyCriteriaArrayPosition]) !== null && _currentJourneyCriteria_journeyCriteriaArrayPosition1 !== void 0 ? _currentJourneyCriteria_journeyCriteriaArrayPosition1 : {}), {
        dateTime: _object_spread_props(_object_spread({}, (_currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime = (_currentJourneyCriteria_journeyCriteriaArrayPosition = currentJourneyCriteria[journeyCriteriaArrayPosition]) === null || _currentJourneyCriteria_journeyCriteriaArrayPosition === void 0 ? void 0 : _currentJourneyCriteria_journeyCriteriaArrayPosition.dateTime) !== null && _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime !== void 0 ? _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime : {}), {
            day: day,
            month: month,
            year: year
        })
    });
    return _object_spread_props(_object_spread({}, groundTransportation), {
        dateRange: currentDates,
        journeyCriteria: currentJourneyCriteria
    });
};
var setTimesToGtCriteria = function(groundTransportation, value, name) {
    var _currentJourneyCriteria_journeyCriteriaArrayPosition;
    var TWELVE_AM = 12;
    var isPickUpTime = name.includes(PICKUP_TIME_SUFFIX);
    var key = isPickUpTime ? "start" : "end";
    var timeIndication = value.substring(4, 6);
    var isAM = timeIndication === "AM";
    var hourInAMPM = Number(value.substring(0, 2));
    var adaptedHour = hourInAMPM === TWELVE_AM ? 0 : hourInAMPM;
    var hour = isAM ? adaptedHour : adaptedHour + 12;
    var minute = Number(value.substring(2, 4));
    var currentDates = _object_spread({}, groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.dateRange);
    if (currentDates[key] === null || currentDates[key] === void 0) {
        currentDates[key] = {
            day: 1,
            month: 1,
            year: 1,
            hour: hour,
            minute: minute,
            second: 0
        };
    } else {
        currentDates[key].hour = hour;
        currentDates[key].minute = minute;
        currentDates[key].second = 0;
    }
    var _groundTransportation_journeyCriteria;
    var currentJourneyCriteria = _to_consumable_array((_groundTransportation_journeyCriteria = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.journeyCriteria) !== null && _groundTransportation_journeyCriteria !== void 0 ? _groundTransportation_journeyCriteria : []);
    var journeyCriteriaArrayPosition = !isPickUpTime && (groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.direction) === "ROUNDTRIP" /* ROUNDTRIP */  ? 1 : 0;
    var _currentJourneyCriteria_journeyCriteriaArrayPosition1, _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime;
    currentJourneyCriteria[journeyCriteriaArrayPosition] = _object_spread_props(_object_spread({}, (_currentJourneyCriteria_journeyCriteriaArrayPosition1 = currentJourneyCriteria[journeyCriteriaArrayPosition]) !== null && _currentJourneyCriteria_journeyCriteriaArrayPosition1 !== void 0 ? _currentJourneyCriteria_journeyCriteriaArrayPosition1 : {}), {
        dateTime: _object_spread_props(_object_spread({}, (_currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime = (_currentJourneyCriteria_journeyCriteriaArrayPosition = currentJourneyCriteria[journeyCriteriaArrayPosition]) === null || _currentJourneyCriteria_journeyCriteriaArrayPosition === void 0 ? void 0 : _currentJourneyCriteria_journeyCriteriaArrayPosition.dateTime) !== null && _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime !== void 0 ? _currentJourneyCriteria_journeyCriteriaArrayPosition_dateTime : {}), {
            hour: hour,
            minute: minute,
            second: 0
        })
    });
    return _object_spread_props(_object_spread({}, groundTransportation), {
        dateRange: currentDates,
        journeyCriteria: currentJourneyCriteria
    });
};
var setTravelersToGtCriteria = function(groundTransportation, value, name) {
    if (Number(value) === 0) {
        return groundTransportation;
    }
    var updatedTravelerDetails = groundTransportation === null || groundTransportation === void 0 ? void 0 : groundTransportation.travelerDetails;
    if (name.includes("Adult")) {
        updatedTravelerDetails = _to_consumable_array(updatedTravelerDetails).concat([
            {
                type: "ADULT" /* ADULT */ ,
                count: Number(value)
            }
        ]);
    }
    if (name.includes("Children")) {
        updatedTravelerDetails = _to_consumable_array(updatedTravelerDetails).concat([
            {
                type: "CHILD" /* CHILD */ ,
                count: Number(value)
            }
        ]);
    }
    if (name.includes("Infant")) {
        updatedTravelerDetails = _to_consumable_array(updatedTravelerDetails).concat([
            {
                type: "INFANT" /* INFANT */ ,
                count: Number(value)
            }
        ]);
    }
    return _object_spread_props(_object_spread({}, groundTransportation), {
        travelerDetails: updatedTravelerDetails
    });
};
var groundTransportationSearchCriteriaReducer = function(criteria, param) {
    var name = param.name, value = param.value;
    var primarySearchCriteria = criteria.primarySearchCriteria, secondaryCriteria = criteria.secondaryCriteria;
    var _primarySearchCriteria_groundTransportation;
    var groundTransportation = (_primarySearchCriteria_groundTransportation = primarySearchCriteria.groundTransportation) !== null && _primarySearchCriteria_groundTransportation !== void 0 ? _primarySearchCriteria_groundTransportation : {
        dateRange: {},
        locations: [
            {
                type: "AIRPORT" /* AIRPORT */ 
            },
            {
                type: "PROPERTY" /* PROPERTY */ 
            }
        ],
        direction: "FROM_AIRPORT" /* FROM_AIRPORT */ ,
        travelerDetails: [],
        journeyCriteria: []
    };
    if (name.startsWith(AIRPORT_CODE_NAME_PREFIX) && name.includes(AIRPORT_LOCATION_NAME_SUFFIX)) {
        var updatedGroundTransportation = setLocationAirportCodeToGtCriteria(groundTransportation, value);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation
            })
        });
    }
    if (name.startsWith(REGION_ID_NAME_PREFIX) && name.includes(AIRPORT_LOCATION_NAME_SUFFIX)) {
        return _object_spread_props(_object_spread({}, criteria), {
            regionId: value
        });
    }
    if (name.startsWith(SELECTED_PREFIX) && name.includes(HOTEL_LOCATION_NAME_SUFFIX)) {
        var updatedGroundTransportation1 = setLocationHotelIdToGtCriteria(groundTransportation, value);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation1
            })
        });
    }
    if (name.startsWith(LOCATION_NAME_PREFIX) && (name.includes(AIRPORT_LOCATION_NAME_SUFFIX) || name.includes(HOTEL_LOCATION_NAME_SUFFIX))) {
        var updatedGroundTransportation2 = setLocationNameGtCriteria(groundTransportation, value, name);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation2
            })
        });
    }
    if (name.startsWith(LAT_NAME_PREFIX) || name.startsWith(LONG_NAME_PREFIX)) {
        var updatedGroundTransportation3 = setLocationCoordinatesGtCriteria(groundTransportation, value, name);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation3
            })
        });
    }
    if (name.startsWith(DATE_NAME_PREFIX)) {
        var updatedGroundTransportation4 = setDateSingleDirectionToGtCriteria(groundTransportation, value);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation4
            })
        });
    }
    if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX) || name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX)) {
        var updatedGroundTransportation5 = setDatesRoundTripDirectionToGtCriteria(groundTransportation, value, name);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation5
            })
        });
    }
    if (name.startsWith(EGDS_BASIC_SELECT_NAME_PREFIX) && name.includes("time")) {
        var updatedGroundTransportation6 = setTimesToGtCriteria(groundTransportation, value, name);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation6
            })
        });
    }
    if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
        var updatedGroundTransportation7 = setTravelersToGtCriteria(groundTransportation, value, name);
        return _object_spread_props(_object_spread({}, criteria), {
            primarySearchCriteria: _object_spread_props(_object_spread({}, primarySearchCriteria), {
                groundTransportation: updatedGroundTransportation7
            })
        });
    }
    return criteria;
};
var getGroundTransportationSearchCriteria = function(elements, tripDirection) {
    var EGDS_PREFIX2 = "EGDS";
    var GT_PREFIX = "GroundTransportation";
    var inputs = elements.filter(function(element) {
        return element.name.startsWith(EGDS_PREFIX2) || element.name.startsWith(GT_PREFIX);
    });
    var initialCriteria = {
        primarySearchCriteria: {
            groundTransportation: {
                dateRange: {},
                locations: [
                    {
                        type: "AIRPORT" /* AIRPORT */ 
                    },
                    {
                        type: "PROPERTY" /* PROPERTY */ 
                    }
                ],
                direction: tripDirection,
                travelerDetails: [],
                journeyCriteria: []
            }
        },
        regionId: null
    };
    var criteria = inputs.reduce(groundTransportationSearchCriteriaReducer, initialCriteria);
    return criteria;
};
// src/components/ground-transportation/form/__private/__fragments/ground-transportation-search-form-selection.tsx
import React99 from "react";
import { gql as gql72 } from "@apollo/client";
import { SingleSelectPillWrapper as SingleSelectPillWrapper3 } from "@egds/react-search-experience";
import { useSearchFormReflectionContext as useSearchFormReflectionContext7 } from "@shared-ui/retail-search-tools-reflection-provider";
var __Fragment50 = gql72(_templateObject76(), EGDSPill.fragment);
var listOftripType = [
    "FROM_AIRPORT" /* FROM_AIRPORT */ ,
    "TO_AIRPORT" /* TO_AIRPORT */ ,
    "ROUNDTRIP" /* ROUNDTRIP */ 
];
var selections = [
    {
        FROM_AIRPORT: true,
        TO_AIRPORT: false,
        ROUNDTRIP: false,
        type: "FROM_AIRPORT" /* FROM_AIRPORT */ ,
        value: "Airport to hotel"
    },
    {
        FROM_AIRPORT: false,
        TO_AIRPORT: true,
        ROUNDTRIP: false,
        type: "TO_AIRPORT" /* TO_AIRPORT */ ,
        value: "Hotel to airport"
    },
    {
        FROM_AIRPORT: false,
        TO_AIRPORT: false,
        ROUNDTRIP: true,
        type: "ROUNDTRIP" /* ROUNDTRIP */ ,
        value: "Roundtrip"
    }
];
var GroundTransportationSearchFormSelection = function(param) {
    var data = param.data, onTripDirectionSelection = param.onTripDirectionSelection;
    var airportToHotel = data.airportToHotel, hotelToAirport = data.hotelToAirport, roundTrip = data.roundTrip;
    var _useSearchFormReflectionContext7 = useSearchFormReflectionContext7(), state = _useSearchFormReflectionContext7.state, dispatch = _useSearchFormReflectionContext7.dispatch;
    var reflectionDestination = state.destination, reflectionOrigin = state.origin;
    var _React99_useState = _sliced_to_array(React99.useState(function() {
        if (airportToHotel.selected === false && hotelToAirport.selected === true && roundTrip.selected === false) {
            return selections[1];
        }
        if (airportToHotel.selected === false && hotelToAirport.selected === false && roundTrip.selected === true) {
            return selections[2];
        }
        return selections[0];
    }), 2), currentSelection = _React99_useState[0], setCurrentSelection = _React99_useState[1];
    var handleSelectedPill = function(selectedPillValue) {
        onTripDirectionSelection(selectedPillValue);
        var _selections_find;
        var tripDirectionSelection = (_selections_find = selections.find(function(selection) {
            return selection.type === selectedPillValue;
        })) !== null && _selections_find !== void 0 ? _selections_find : selections[0];
        if (currentSelection.type !== tripDirectionSelection.type) {
            if (currentSelection.type === "TO_AIRPORT" /* TO_AIRPORT */  || tripDirectionSelection.type === "TO_AIRPORT" /* TO_AIRPORT */ ) {
                var _reflectionOrigin_data, _reflectionOrigin_term;
                var reflectionOriginSafe = _object_spread_props(_object_spread({}, reflectionOrigin), {
                    data: (_reflectionOrigin_data = reflectionOrigin === null || reflectionOrigin === void 0 ? void 0 : reflectionOrigin.data) !== null && _reflectionOrigin_data !== void 0 ? _reflectionOrigin_data : {},
                    term: (_reflectionOrigin_term = reflectionOrigin === null || reflectionOrigin === void 0 ? void 0 : reflectionOrigin.term) !== null && _reflectionOrigin_term !== void 0 ? _reflectionOrigin_term : ""
                });
                var _reflectionDestination_data, _reflectionDestination_term;
                var reflectionDestinationSafe = _object_spread_props(_object_spread({}, reflectionDestination), {
                    data: (_reflectionDestination_data = reflectionDestination === null || reflectionDestination === void 0 ? void 0 : reflectionDestination.data) !== null && _reflectionDestination_data !== void 0 ? _reflectionDestination_data : {},
                    term: (_reflectionDestination_term = reflectionDestination === null || reflectionDestination === void 0 ? void 0 : reflectionDestination.term) !== null && _reflectionDestination_term !== void 0 ? _reflectionDestination_term : ""
                });
                dispatch({
                    type: "UPDATE_DESTINATION",
                    location: reflectionOriginSafe
                });
                dispatch({
                    type: "UPDATE_ORIGIN",
                    location: reflectionDestinationSafe
                });
            }
            setCurrentSelection(tripDirectionSelection);
        }
    };
    var _airportToHotel_primary, _airportToHotel_value, _airportToHotel_value1, _airportToHotel_accessibility, _hotelToAirport_primary, _hotelToAirport_value, _hotelToAirport_value1, _hotelToAirport_accessibility, _roundTrip_primary, _roundTrip_value, _roundTrip_value1, _roundTrip_accessibility;
    var singleSelectOptions = [
        {
            name: "GroundTransportationSearchFormSelection",
            selected: currentSelection["FROM_AIRPORT" /* FROM_AIRPORT */ ],
            checked: currentSelection["FROM_AIRPORT" /* FROM_AIRPORT */ ],
            text: (_airportToHotel_primary = airportToHotel.primary) !== null && _airportToHotel_primary !== void 0 ? _airportToHotel_primary : "",
            disabled: airportToHotel.disabled,
            value: (_airportToHotel_value = airportToHotel.value) !== null && _airportToHotel_value !== void 0 ? _airportToHotel_value : "FROM_AIRPORT",
            id: (_airportToHotel_value1 = airportToHotel.value) !== null && _airportToHotel_value1 !== void 0 ? _airportToHotel_value1 : "FROM_AIRPORT",
            altText: (_airportToHotel_accessibility = airportToHotel.accessibility) !== null && _airportToHotel_accessibility !== void 0 ? _airportToHotel_accessibility : void 0
        },
        {
            name: "GroundTransportationSearchFormSelection",
            selected: currentSelection["TO_AIRPORT" /* TO_AIRPORT */ ],
            checked: currentSelection["TO_AIRPORT" /* TO_AIRPORT */ ],
            text: (_hotelToAirport_primary = hotelToAirport.primary) !== null && _hotelToAirport_primary !== void 0 ? _hotelToAirport_primary : "",
            disabled: hotelToAirport.disabled,
            value: (_hotelToAirport_value = hotelToAirport.value) !== null && _hotelToAirport_value !== void 0 ? _hotelToAirport_value : "TO_AIRPORT",
            id: (_hotelToAirport_value1 = hotelToAirport.value) !== null && _hotelToAirport_value1 !== void 0 ? _hotelToAirport_value1 : "TO_AIRPORT",
            altText: (_hotelToAirport_accessibility = hotelToAirport.accessibility) !== null && _hotelToAirport_accessibility !== void 0 ? _hotelToAirport_accessibility : void 0
        },
        {
            name: "GroundTransportationSearchFormSelection",
            selected: currentSelection["ROUNDTRIP" /* ROUNDTRIP */ ],
            checked: currentSelection["ROUNDTRIP" /* ROUNDTRIP */ ],
            text: (_roundTrip_primary = roundTrip.primary) !== null && _roundTrip_primary !== void 0 ? _roundTrip_primary : "",
            disabled: roundTrip.disabled,
            value: (_roundTrip_value = roundTrip.value) !== null && _roundTrip_value !== void 0 ? _roundTrip_value : "ROUNDTRIP",
            id: (_roundTrip_value1 = roundTrip.value) !== null && _roundTrip_value1 !== void 0 ? _roundTrip_value1 : "ROUNDTRIP",
            altText: (_roundTrip_accessibility = roundTrip.accessibility) !== null && _roundTrip_accessibility !== void 0 ? _roundTrip_accessibility : void 0
        }
    ];
    return /* @__PURE__ */ React99.createElement(SingleSelectPillWrapper3, {
        data: singleSelectOptions,
        handleSelectedPill: handleSelectedPill
    });
};
GroundTransportationSearchFormSelection.fragment = __Fragment50;
GroundTransportationSearchFormSelection.displayName = "GroundTransportationSearchFormSelection";
// src/components/ground-transportation/form/__private/__fragments/ground-transportation-search-form.tsx
var __fragment = gql73(_templateObject77(), EGDSErrorSummary.fragment, EGDSSearchFormButton.fragment, EGDSSearchPlayback.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment, EGDSSelect.fragment, GroundTransportationSearchFormSelection.fragment, SearchLocationFragment);
var GroundTransportationSearchForm = function(props) {
    var data = props.data, tripDirection = props.tripDirection, onTripDirectionSelection = props.onTripDirectionSelection, onFieldChange = props.onFieldChange, onSubmit = props.onSubmit, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, autoOpenPlayback = props.autoOpenPlayback, stickyPlayback = props.stickyPlayback, additionalAdapterFields = props.additionalAdapterFields;
    var egdsElementId = data.egdsElementId, actionURL = data.actionURL, airportLocation = data.airportLocation, hotelLocation = data.hotelLocation, pickupTime = data.pickupTime, dropoffTime = data.dropoffTime, dates = data.dates, travelers = data.travelers, search6 = data.search, errorSummary5 = data.errorSummary, groundTransportationSelection = data.groundTransportationSelection, playback = data.playback, searchLocation = data.searchLocation;
    var localizationContext = useLocalization13();
    var _React100_useState = _sliced_to_array(React100.useState(playback), 2), playbackData = _React100_useState[0], setPlaybackData = _React100_useState[1];
    var _React100_useState1 = _sliced_to_array(React100.useState(!autoOpenPlayback), 2), displayPlayback = _React100_useState1[0], setDisplayPlayback = _React100_useState1[1];
    var handlePlaybackToggle = function(open) {
        setDisplayPlayback(open);
    };
    React100.useEffect(function() {
        setPlaybackData(playback);
    }, [
        playback
    ]);
    var _React100_useState2 = _sliced_to_array(React100.useState({
        EGDSSearchFormLocationsField: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React100_useState2[0], setFieldsRefs = _React100_useState2[1];
    var _React100_useState3 = _sliced_to_array(React100.useState(hotelLocation), 2), hotelLocationWithRegionId = _React100_useState3[0], setHotelLocationWithRegionId = _React100_useState3[1];
    React100.useEffect(function() {
        setHotelLocationWithRegionId(hotelLocation);
    }, [
        hotelLocation
    ]);
    var initialErrorState2 = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var _React100_useState4 = _sliced_to_array(React100.useState(initialErrorState2), 2), errorState = _React100_useState4[0], setErrorState = _React100_useState4[1];
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search-ground-transportation-form";
    var action = actionURL !== null && actionURL !== void 0 ? actionURL : "/ground-transfers/search";
    var setFieldRefByTypename = React100.useCallback(function(typename, ref) {
        var _ref_current;
        var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typenameRef, ref));
        });
    }, []);
    var refProps = {
        setFieldRefByTypename: setFieldRefByTypename
    };
    var getUpdatedPrimaryPlayback = function(prevPrimary, primaryTemplate, originText, destinationText) {
        if (!(primaryTemplate === null || primaryTemplate === void 0 ? void 0 : primaryTemplate.text)) {
            return prevPrimary;
        }
        var connectorString = primaryTemplate.text.trim().replace("${origin}", "").replace("${destination}", "");
        var _prevPrimary_text_split = _sliced_to_array(prevPrimary.text.split(connectorString), 2), originPrimary = _prevPrimary_text_split[0], destinationPrimary = _prevPrimary_text_split[1];
        var newPrimaryText = primaryTemplate.text.replace("${origin}", originText !== null && originText !== void 0 ? originText : originPrimary).replace("${destination}", destinationText !== null && destinationText !== void 0 ? destinationText : destinationPrimary);
        return _object_spread_props(_object_spread({}, prevPrimary), {
            text: newPrimaryText
        });
    };
    var handleFieldChange = function(field, event) {
        if (onFieldChange) {
            onFieldChange(field, event);
        }
        setPlaybackData(function(prevPlaybackState) {
            var SINGLE_DATE_PICKER_START_DATE = FieldNameMap3.SINGLE_DATE_PICKER_START_DATE, DATE_RANGE_PICKER2 = FieldNameMap3.DATE_RANGE_PICKER, BASIC_TRAVELER_SELECTOR = FieldNameMap3.BASIC_TRAVELER_SELECTOR;
            var name = field.name, text = field.value;
            var isSingleDatePicker = name === SINGLE_DATE_PICKER_START_DATE;
            var isDateRangePicker = name === DATE_RANGE_PICKER2;
            var isTravelerSelector = name === BASIC_TRAVELER_SELECTOR;
            if (!prevPlaybackState) {
                return null;
            }
            var secondaries = prevPlaybackState.secondaries;
            var _secondaries = _sliced_to_array(secondaries, 2), datesSecondary = _secondaries[0], travelersSecondary = _secondaries[1];
            var newSecondaryDates = datesSecondary;
            if (isSingleDatePicker && datesSecondary.__typename === "EGDSPlainText") {
                newSecondaryDates = _object_spread_props(_object_spread({}, datesSecondary), {
                    text: localizationContext.formatDateString(new Date(text), {
                        skeleton: "MMMd"
                    })
                });
            }
            if (isDateRangePicker && datesSecondary.__typename === "EGDSPlainText") {
                newSecondaryDates = _object_spread_props(_object_spread({}, datesSecondary), {
                    text: getFormattedDates(text, localizationContext)
                });
            }
            var newSsecondaryTravelers = isTravelerSelector ? _object_spread_props(_object_spread({}, travelersSecondary), {
                text: text
            }) : travelersSecondary;
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                secondaries: [
                    newSecondaryDates,
                    newSsecondaryTravelers
                ]
            });
        });
    };
    var handleSubmit = function(event) {
        var formElements = Array.from(event.currentTarget.elements);
        var formElementsToValidate;
        if (tripDirection === "TO_AIRPORT" /* TO_AIRPORT */ ) {
            formElementsToValidate = {
                location: {
                    origin: formElements.find(findFieldByNameAttribute("airport_location")),
                    destination: formElements.find(findFieldByNameAttribute("hotel_location"))
                },
                dates: {
                    startDateInput: formElements.find(findFieldByNameAttribute("EGDSSingleDatePicker-Date-date_form_field")),
                    endDateInput: void 0,
                    config: {
                        maxNumberOfDaysSelected: 0
                    }
                },
                time: {
                    dropOff: formElements.find(findFieldByNameAttribute("EGDSBasicSelect-drop_off_time")),
                    pickup: void 0
                }
            };
        } else if (tripDirection === "ROUNDTRIP" /* ROUNDTRIP */ ) {
            formElementsToValidate = {
                location: {
                    origin: formElements.find(findFieldByNameAttribute("airport_location")),
                    destination: formElements.find(findFieldByNameAttribute("hotel_location"))
                },
                dates: {
                    startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date_form_field")),
                    endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date_form_field")),
                    config: {
                        maxNumberOfDaysSelected: 0
                    }
                },
                time: {
                    dropOff: formElements.find(findFieldByNameAttribute("EGDSBasicSelect-drop_off_time")),
                    pickup: formElements.find(findFieldByNameAttribute("EGDSBasicSelect-pick_up_time"))
                }
            };
        } else {
            formElementsToValidate = {
                location: {
                    origin: formElements.find(findFieldByNameAttribute("airport_location")),
                    destination: formElements.find(findFieldByNameAttribute("hotel_location"))
                },
                dates: {
                    startDateInput: formElements.find(findFieldByNameAttribute("EGDSSingleDatePicker-Date-date_form_field")),
                    endDateInput: void 0,
                    config: {
                        maxNumberOfDaysSelected: 0
                    }
                },
                time: {
                    dropOff: void 0,
                    pickup: formElements.find(findFieldByNameAttribute("EGDSBasicSelect-pick_up_time"))
                }
            };
        }
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
        var errorCount2 = fieldsWithErrors.length;
        var isFormValid = errorCount2 === 0;
        if (!isFormValid) {
            var _fieldsWithErrors_;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: errorCount2,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
            });
            event.preventDefault();
            return;
        }
        setErrorState(initialErrorState2);
        if (onSubmit || redirectToSearchResultOnSubmit) {
            var elementsOnSubmit = Array.from(event.currentTarget.elements);
            var groundTransportationSearchCriteria = getGroundTransportationSearchCriteria(elementsOnSubmit, tripDirection);
            if (onSubmit) {
                onSubmit(event, {
                    groundTransportationSearchCriteria: groundTransportationSearchCriteria
                });
            }
            if (redirectToSearchResultOnSubmit) {
                event.preventDefault();
                var queryParams = getURLQueryParamsFromGroundTransportationCriteria(groundTransportationSearchCriteria);
                window.location.href = "".concat(event.currentTarget.action).concat(queryParams);
            }
        }
    };
    var onAirportTypeaheadSelection = function(typeaheadSelectionData) {
        var hotelAction = hotelLocationWithRegionId === null || hotelLocationWithRegionId === void 0 ? void 0 : hotelLocationWithRegionId.action;
        if (hotelLocation) {
            var combinedLocation = _object_spread_props(_object_spread({}, hotelLocation), {
                __typename: hotelLocation.__typename,
                action: _object_spread_props(_object_spread({}, hotelAction), {
                    info: _object_spread_props(_object_spread({}, hotelAction.info), {
                        regionId: typeaheadSelectionData.data.regionId
                    })
                })
            });
            setHotelLocationWithRegionId(combinedLocation);
        }
        setPlaybackData(function(prevPlaybackState) {
            var _typeaheadSelectionData_data_hierarchyInfo_airport, _typeaheadSelectionData_data_hierarchyInfo, _typeaheadSelectionData_data, _typeaheadSelectionData_data1;
            if (!prevPlaybackState) {
                return null;
            }
            var primary = prevPlaybackState.primary, primaryTemplate = prevPlaybackState.primaryTemplate;
            var airportCode = (_typeaheadSelectionData_data = typeaheadSelectionData.data) === null || _typeaheadSelectionData_data === void 0 ? void 0 : (_typeaheadSelectionData_data_hierarchyInfo = _typeaheadSelectionData_data.hierarchyInfo) === null || _typeaheadSelectionData_data_hierarchyInfo === void 0 ? void 0 : (_typeaheadSelectionData_data_hierarchyInfo_airport = _typeaheadSelectionData_data_hierarchyInfo.airport) === null || _typeaheadSelectionData_data_hierarchyInfo_airport === void 0 ? void 0 : _typeaheadSelectionData_data_hierarchyInfo_airport.airportCode;
            var dest = typeaheadSelectionData === null || typeaheadSelectionData === void 0 ? void 0 : (_typeaheadSelectionData_data1 = typeaheadSelectionData.data) === null || _typeaheadSelectionData_data1 === void 0 ? void 0 : _typeaheadSelectionData_data1.dest;
            var originText = dest ? airportCode : null;
            var destinationText = dest ? null : airportCode;
            var newPrimary = getUpdatedPrimaryPlayback(primary, primaryTemplate, originText, destinationText);
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary
            });
        });
    };
    var onHotelTypeaheadSelection = function(typeaheadSelectionData) {
        setPlaybackData(function(prevPlaybackState) {
            if (!prevPlaybackState) {
                return null;
            }
            var primary = prevPlaybackState.primary, primaryTemplate = prevPlaybackState.primaryTemplate;
            var dest = typeaheadSelectionData.data.dest;
            var originText = dest ? typeaheadSelectionData.term : null;
            var destinationText = dest ? null : typeaheadSelectionData.term;
            var newPrimary = getUpdatedPrimaryPlayback(primary, primaryTemplate, originText, destinationText);
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary
            });
        });
    };
    var locationFieldProps = {
        additionalAdapterFields: additionalAdapterFields,
        searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
    };
    var airportLocationField = airportLocation && /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, refProps, locationFieldProps), {
        onSelection: onAirportTypeaheadSelection,
        data: airportLocation,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormLocationFieldAirport";
        }),
        key: "field_".concat(airportLocation === null || airportLocation === void 0 ? void 0 : airportLocation.__typename, "_airportLocation")
    })));
    var hotelLocationField = hotelLocationWithRegionId && /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, refProps, locationFieldProps), {
        onSelection: onHotelTypeaheadSelection,
        data: hotelLocationWithRegionId,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormLocationFieldHotel";
        }),
        key: "field_".concat(hotelLocationWithRegionId === null || hotelLocationWithRegionId === void 0 ? void 0 : hotelLocationWithRegionId.__typename, "_hotelLocation")
    })));
    var travelersField2 = travelers && /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSearchFormTravelersField, {
        data: travelers
    }));
    var datesField = dates && /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSearchFormDatePickerField, _object_spread_props(_object_spread({}, refProps), {
        data: dates
    })));
    var pickupTimeField = pickupTime && /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSelect, {
        data: pickupTime,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSBasicSelectPickUp";
        })
    }));
    var dropoffTimeField = dropoffTime && /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSelect, {
        data: dropoffTime,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSBasicSelectDropOff";
        })
    }));
    var searchField = (search6 === null || search6 === void 0 ? void 0 : search6.__typename) === "EGDSSearchFormButton" && /* @__PURE__ */ React100.createElement(UitkSpacing29, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSearchFormButton, {
        data: search6
    })));
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var errorSummaryField = displayErrorSummary && errorSummary5 && /* @__PURE__ */ React100.createElement(UitkSpacing29, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    })));
    var groundTransportationSelectionField = groundTransportationSelection && /* @__PURE__ */ React100.createElement(GroundTransportationSearchFormSelection, _object_spread_props(_object_spread({}, props), {
        data: groundTransportationSelection,
        onTripDirectionSelection: onTripDirectionSelection
    }));
    var getSearchForm = function() {
        if (tripDirection === "TO_AIRPORT" /* TO_AIRPORT */ ) {
            return /* @__PURE__ */ React100.createElement(React100.Fragment, null, groundTransportationSelectionField, /* @__PURE__ */ React100.createElement(UitkForm7, {
                onFieldChange: handleFieldChange,
                onSubmit: handleSubmit,
                id: id,
                name: id,
                method: "GET",
                action: action,
                hasRequiredFieldIndicator: true
            }, errorSummaryField, /* @__PURE__ */ React100.createElement(UitkSpacing29, {
                padding: {
                    blockstart: "six"
                }
            }, /* @__PURE__ */ React100.createElement(UitkLayoutGrid5, {
                columns: {
                    small: 1,
                    medium: 6
                },
                space: "three"
            }, /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
                colSpan: {
                    small: 1,
                    medium: 2,
                    large: 3
                }
            }, hotelLocationField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
                colSpan: {
                    small: 1,
                    medium: 2,
                    large: 3
                }
            }, airportLocationField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
                colSpan: {
                    small: 1,
                    medium: 2,
                    large: 2
                }
            }, travelersField2), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
                colSpan: {
                    small: 1,
                    medium: 3,
                    large: 2
                }
            }, datesField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
                colSpan: {
                    small: 1,
                    medium: 3,
                    large: 2
                }
            }, dropoffTimeField))), searchField));
        }
        if (tripDirection === "ROUNDTRIP" /* ROUNDTRIP */ ) {
            return /* @__PURE__ */ React100.createElement(React100.Fragment, null, groundTransportationSelectionField, /* @__PURE__ */ React100.createElement(UitkForm7, {
                onFieldChange: handleFieldChange,
                onSubmit: handleSubmit,
                id: id,
                name: id,
                method: "GET",
                action: action,
                hasRequiredFieldIndicator: true
            }, errorSummaryField, /* @__PURE__ */ React100.createElement(UitkSpacing29, {
                padding: {
                    blockstart: "six"
                }
            }, /* @__PURE__ */ React100.createElement(UitkLayoutGrid5, {
                columns: {
                    small: 1,
                    medium: 2
                },
                space: "three"
            }, /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, null, airportLocationField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, null, hotelLocationField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, null, travelersField2), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, null, datesField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, null, pickupTimeField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, null, dropoffTimeField))), searchField));
        }
        return /* @__PURE__ */ React100.createElement(React100.Fragment, null, groundTransportationSelectionField, /* @__PURE__ */ React100.createElement(UitkForm7, {
            onFieldChange: handleFieldChange,
            onSubmit: handleSubmit,
            id: id,
            name: id,
            method: "GET",
            action: action,
            hasRequiredFieldIndicator: true
        }, errorSummaryField, /* @__PURE__ */ React100.createElement(UitkSpacing29, {
            padding: {
                blockstart: "six"
            }
        }, /* @__PURE__ */ React100.createElement(UitkLayoutGrid5, {
            columns: {
                small: 1,
                medium: 6,
                large: 6
            },
            space: "three"
        }, /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
            colSpan: {
                small: 1,
                medium: 2,
                large: 3
            }
        }, airportLocationField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
            colSpan: {
                small: 1,
                medium: 2,
                large: 3
            }
        }, hotelLocationField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
            colSpan: {
                small: 1,
                medium: 2,
                large: 2
            }
        }, travelersField2), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
            colSpan: {
                small: 1,
                medium: 3,
                large: 2
            }
        }, datesField), /* @__PURE__ */ React100.createElement(UitkLayoutGridItem4, {
            colSpan: {
                small: 1,
                medium: 3,
                large: 2
            }
        }, pickupTimeField))), searchField));
    };
    return /* @__PURE__ */ React100.createElement(Viewport24, null, /* @__PURE__ */ React100.createElement(ViewSmall22, null, playbackData ? /* @__PURE__ */ React100.createElement(EGDSSearchPlayback, {
        data: playbackData,
        stickyPlayback: stickyPlayback,
        display: displayPlayback,
        onDisplayToggle: handlePlaybackToggle
    }, getSearchForm()) : getSearchForm()), /* @__PURE__ */ React100.createElement(ViewMedium21, null, getSearchForm()));
};
GroundTransportationSearchForm.fragment = __fragment;
GroundTransportationSearchForm.displayName = "GroundTransportationSearchForm";
// src/components/ground-transportation/form/client-events.ts
import { SystemEvent as SystemEvent6, SystemEventLevel as SystemEventLevel6 } from "@shared-ui/logger-context";
var CLIENT_EVENTS4 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_QUERY_FAILURE: new SystemEvent6(SystemEventLevel6.ERROR, "SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_QUERY_FAILURE"),
    SEARCH_TOOLS_GROUND_TRANSPORTATION_OPTIONS_QUERY_FAILURE: new SystemEvent6(SystemEventLevel6.ERROR, "SEARCH_TOOLS_GROUND_TRANSPORTATION_OPTIONS_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS3 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Ground Transportation Search Form Fallback Presented",
        referrerId: "Web.GroundTransportation.Search.Form.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_IMPRESSION: {
        linkName: "Ground Transportation Search Form Presented",
        referrerId: "Web.GroundTransportation.Search.Form.Presented"
    }
};
// src/components/ground-transportation/form/gt-search-form.tsx
var __Query6 = gql74(_templateObject78(), GroundTransportationSearchForm.fragment);
var formSkeletonProps = {
    rows: [
        {
            type: "secondary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        }
    ]
};
var GroundTransportationSearchForm2 = function(props) {
    var _inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation, _inputs_groundTransportationSearchCriteria, _data_searchForm_groundTransportation, _data_searchForm;
    var inputs = props.inputs, skipSsr = props.skipSsr, batchKey = props.batchKey, includePlayback = props.includePlayback;
    var context = useBexApi10().context;
    var systemEvents = useLoggerEvents5(CLIENT_EVENTS4);
    var _inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation_direction;
    var _React101_useState = _sliced_to_array(React101.useState((_inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation_direction = (_inputs_groundTransportationSearchCriteria = inputs.groundTransportationSearchCriteria) === null || _inputs_groundTransportationSearchCriteria === void 0 ? void 0 : (_inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation = _inputs_groundTransportationSearchCriteria.primarySearchCriteria.groundTransportation) === null || _inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation === void 0 ? void 0 : _inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation.direction) !== null && _inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation_direction !== void 0 ? _inputs_groundTransportationSearchCriteria_primarySearchCriteria_groundTransportation_direction : "FROM_AIRPORT" /* FROM_AIRPORT */ ), 2), tripDirection = _React101_useState[0], setTripDirection = _React101_useState[1];
    var _React101_useState1 = _sliced_to_array(React101.useState(inputs), 2), inputVariables = _React101_useState1[0], setInputVariables = _React101_useState1[1];
    var handleTripDirectionSelection = function(newTripDirection) {
        if (Object.values(GroundTransfersDirection).includes(newTripDirection) && newTripDirection !== "FROM_AIRPORT" /* FROM_AIRPORT */ ) {
            setTripDirection(newTripDirection);
            setInputVariables({
                groundTransportationSearchCriteria: {
                    primarySearchCriteria: {
                        groundTransportation: {
                            dateRange: {},
                            locations: [],
                            journeyCriteria: [],
                            direction: newTripDirection,
                            travelerDetails: []
                        }
                    }
                }
            });
        } else {
            setTripDirection("FROM_AIRPORT" /* FROM_AIRPORT */ );
            setInputVariables({
                groundTransportationSearchCriteria: null
            });
        }
    };
    var variables = _object_spread_props(_object_spread({}, inputVariables), {
        context: context,
        includePlayback: !!includePlayback
    });
    var _useQuery6 = useQuery6(__Query6, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery6.data, error = _useQuery6.error, loading = _useQuery6.loading;
    if (loading) {
        return /* @__PURE__ */ React101.createElement(FormSkeleton, _object_spread({}, formSkeletonProps));
    }
    if (error || (data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : (_data_searchForm_groundTransportation = _data_searchForm.groundTransportation) === null || _data_searchForm_groundTransportation === void 0 ? void 0 : _data_searchForm_groundTransportation.__typename) !== "GroundTransportationSearchForm" || !data.searchForm.groundTransportation.groundTransportationSelection) {
        var _fallbackData2_searchForm_groundTransportation, _fallbackData2_searchForm;
        var fallbackData2 = getFallbackData2(tripDirection);
        systemEvents.SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_QUERY_FAILURE.log({
            name: error === null || error === void 0 ? void 0 : error.name,
            error: new Error(error === null || error === void 0 ? void 0 : error.message)
        });
        if ((fallbackData2 === null || fallbackData2 === void 0 ? void 0 : (_fallbackData2_searchForm = fallbackData2.searchForm) === null || _fallbackData2_searchForm === void 0 ? void 0 : (_fallbackData2_searchForm_groundTransportation = _fallbackData2_searchForm.groundTransportation) === null || _fallbackData2_searchForm_groundTransportation === void 0 ? void 0 : _fallbackData2_searchForm_groundTransportation.__typename) !== "GroundTransportationSearchForm") {
            return null;
        }
        return /* @__PURE__ */ React101.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React101.createElement(IntersectionTracker5, _object_spread({}, CLIENT_TRACKING_EVENTS3.SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_FALLBACK_IMPRESSION), /* @__PURE__ */ React101.createElement(GroundTransportationSearchForm, _object_spread_props(_object_spread({}, props), {
            data: fallbackData2.searchForm.groundTransportation,
            tripDirection: tripDirection,
            onTripDirectionSelection: handleTripDirectionSelection
        }))));
    }
    return /* @__PURE__ */ React101.createElement(IntersectionTracker5, _object_spread({}, CLIENT_TRACKING_EVENTS3.SEARCH_TOOLS_GROUND_TRANSPORTATION_SEARCH_FORM_IMPRESSION), /* @__PURE__ */ React101.createElement(GroundTransportationSearchForm, _object_spread_props(_object_spread({}, props), {
        data: data.searchForm.groundTransportation,
        tripDirection: tripDirection,
        onTripDirectionSelection: handleTripDirectionSelection
    })));
};
GroundTransportationSearchForm2.displayName = "sharedui-GroundTransportationSearchForm";
// src/components/cars/form/__private/__fragments/cars-search-form.tsx
import React110 from "react";
import { gql as gql82 } from "@apollo/client";
import { useLocalization as useLocalization14 } from "@shared-ui/localization-context";
import { ViewMedium as ViewMedium24, Viewport as Viewport27, ViewSmall as ViewSmall25 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm8 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex22, UitkLayoutFlexItem as UitkLayoutFlexItem19 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing34 } from "uitk-react-spacing";
// src/components/cars/utils/field-map.ts
var FieldNameMap4 = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["PICKUP_LOCATION"] = "airport_location";
    FieldNameMap8["DROPOFF_LOCATION"] = "hotel_location";
    FieldNameMap8["PICKUP_TIME"] = "pick_up_time";
    FieldNameMap8["DROPOFF_TIME"] = "drop_off_time";
    FieldNameMap8["DATE_RANGE_PICKER"] = "EGDSDateRangePicker";
    return FieldNameMap8;
}(FieldNameMap4 || {});
// src/components/cars/utils/query-params.ts
var secondaryCriteriaSelectables = [
    "age"
];
var getDate3 = function(param, dateFormatHelper) {
    var day = param.day, month = param.month, year = param.year;
    var formattedDay = day < 10 ? "0".concat(day) : day;
    var formattedMonth = month < 10 ? "0".concat(month) : month;
    return dateFormatHelper.formatDateString("".concat(year, "-").concat(formattedMonth, "-").concat(formattedDay), {
        raw: dateFormatHelper.localDateFormat
    });
};
var formatDateVariant = function(param) {
    var day = param.day, month = param.month, year = param.year;
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var formatTime = function(param) {
    var hour = param.hour, minute = param.minute;
    var isAM = hour < 12;
    var timeIndication = isAM ? "AM" : "PM";
    var formattedHour = hour % 12 || 12;
    return "".concat(formattedHour < 10 ? "0" : "").concat(formattedHour).concat(minute < 10 ? "0" : "").concat(minute).concat(timeIndication);
};
var appendQueryParamsToUrl = function(originalUrl, params) {
    var url = new URL(originalUrl);
    params.forEach(function(extraParam) {
        var param = extraParam.param, value = extraParam.value;
        url.searchParams.append(param, value);
    });
    return url.toString();
};
var padZero = function(number) {
    return number.toString().padStart(2, "0");
};
var formatDateTimeVariant = function(param) {
    var year = param.year, month = param.month, day = param.day;
    return "".concat(year, "-").concat(padZero(month), "-").concat(padZero(day));
};
var formatDateTime = function(param) {
    var year = param.year, month = param.month, day = param.day, hour = param.hour, minute = param.minute;
    return "".concat(year, "-").concat(padZero(month), "-").concat(padZero(day), "T").concat(padZero(hour), ":").concat(padZero(minute));
};
var getURLQueryParamsFromCarsCriteria = function(criteria, dateFormatHelper) {
    var _pickUpLocation_coordinates, _pickUpLocation_coordinates1, _dropOffLocation_coordinates, _dropOffLocation_coordinates1, _criteria_secondary_booleans, _criteria_secondary, _criteria_secondary_selections, _criteria_secondary1;
    var _criteria_primary = criteria.primary, pickUpLocation = _criteria_primary.pickUpLocation, pickUpDateTime = _criteria_primary.pickUpDateTime, dropOffLocation = _criteria_primary.dropOffLocation, dropOffDateTime = _criteria_primary.dropOffDateTime;
    var d1 = encodeURIComponent(formatDateVariant(pickUpDateTime));
    var d2 = encodeURIComponent(formatDateVariant(dropOffDateTime));
    var pickUpDate = getDate3(pickUpDateTime, dateFormatHelper) || d1;
    var dropOffDate = getDate3(dropOffDateTime, dateFormatHelper) || d2;
    var pickUpTime = formatTime(pickUpDateTime);
    var dropOffTime = formatTime(dropOffDateTime);
    var _pickUpLocation_searchTerm, _pickUpLocation_airportCode, _pickUpLocation_coordinates_latitude, _pickUpLocation_coordinates_longitude, _pickUpLocation_regionId;
    var pickUp = "locn=".concat(encodeURIComponent((_pickUpLocation_searchTerm = pickUpLocation.searchTerm) !== null && _pickUpLocation_searchTerm !== void 0 ? _pickUpLocation_searchTerm : ""), "&pickupIATACode=").concat((_pickUpLocation_airportCode = pickUpLocation.airportCode) !== null && _pickUpLocation_airportCode !== void 0 ? _pickUpLocation_airportCode : "", "&olat=").concat((_pickUpLocation_coordinates_latitude = (_pickUpLocation_coordinates = pickUpLocation.coordinates) === null || _pickUpLocation_coordinates === void 0 ? void 0 : _pickUpLocation_coordinates.latitude) !== null && _pickUpLocation_coordinates_latitude !== void 0 ? _pickUpLocation_coordinates_latitude : "", "&olon=").concat((_pickUpLocation_coordinates_longitude = (_pickUpLocation_coordinates1 = pickUpLocation.coordinates) === null || _pickUpLocation_coordinates1 === void 0 ? void 0 : _pickUpLocation_coordinates1.longitude) !== null && _pickUpLocation_coordinates_longitude !== void 0 ? _pickUpLocation_coordinates_longitude : "", "&dpln=").concat((_pickUpLocation_regionId = pickUpLocation.regionId) !== null && _pickUpLocation_regionId !== void 0 ? _pickUpLocation_regionId : "");
    var _dropOffLocation_searchTerm, _dropOffLocation_airportCode, _dropOffLocation_coordinates_latitude, _dropOffLocation_coordinates_longitude, _dropOffLocation_regionId;
    var dropOff = dropOffLocation ? "loc2=".concat(encodeURIComponent((_dropOffLocation_searchTerm = dropOffLocation.searchTerm) !== null && _dropOffLocation_searchTerm !== void 0 ? _dropOffLocation_searchTerm : ""), "&returnIATACode=").concat((_dropOffLocation_airportCode = dropOffLocation.airportCode) !== null && _dropOffLocation_airportCode !== void 0 ? _dropOffLocation_airportCode : "", "&dlat=").concat((_dropOffLocation_coordinates_latitude = (_dropOffLocation_coordinates = dropOffLocation.coordinates) === null || _dropOffLocation_coordinates === void 0 ? void 0 : _dropOffLocation_coordinates.latitude) !== null && _dropOffLocation_coordinates_latitude !== void 0 ? _dropOffLocation_coordinates_latitude : "", "&dlon=").concat((_dropOffLocation_coordinates_longitude = (_dropOffLocation_coordinates1 = dropOffLocation.coordinates) === null || _dropOffLocation_coordinates1 === void 0 ? void 0 : _dropOffLocation_coordinates1.longitude) !== null && _dropOffLocation_coordinates_longitude !== void 0 ? _dropOffLocation_coordinates_longitude : "", "&drid1=").concat((_dropOffLocation_regionId = dropOffLocation.regionId) !== null && _dropOffLocation_regionId !== void 0 ? _dropOffLocation_regionId : "") : "";
    var dates = "d1=".concat(d1, "&d2=").concat(d2, "&date1=").concat(pickUpDate, "&date2=").concat(dropOffDate);
    var times = "time1=".concat(pickUpTime, "&time2=").concat(dropOffTime);
    var _criteria_secondary_booleans_filter_reduce;
    var aarp = (_criteria_secondary_booleans_filter_reduce = (_criteria_secondary = criteria.secondary) === null || _criteria_secondary === void 0 ? void 0 : (_criteria_secondary_booleans = _criteria_secondary.booleans) === null || _criteria_secondary_booleans === void 0 ? void 0 : _criteria_secondary_booleans.filter(function(bool) {
        return bool.id === "aarpcr";
    }).reduce(function(current, param) {
        var id = param.id, value = param.value;
        return "".concat(current).concat(id, "=").concat(value ? "on" : "off");
    }, "")) !== null && _criteria_secondary_booleans_filter_reduce !== void 0 ? _criteria_secondary_booleans_filter_reduce : "";
    var _criteria_secondary_selections_reduce;
    var selectables = (_criteria_secondary_selections_reduce = (_criteria_secondary1 = criteria.secondary) === null || _criteria_secondary1 === void 0 ? void 0 : (_criteria_secondary_selections = _criteria_secondary1.selections) === null || _criteria_secondary_selections === void 0 ? void 0 : _criteria_secondary_selections.reduce(function(current, param) {
        var id = param.id, value = param.value;
        return "".concat(current, "&").concat(id, "=").concat(value);
    }, "")) !== null && _criteria_secondary_selections_reduce !== void 0 ? _criteria_secondary_selections_reduce : "";
    var carSearchUrl = "".concat(pickUp, "&").concat(dropOff, "&").concat(dates, "&").concat(times);
    if (aarp) {
        carSearchUrl += "&".concat(aarp);
    }
    if (selectables) {
        carSearchUrl += "".concat(selectables);
    }
    return carSearchUrl;
};
var buildURLWithParamsFor3rdPartyCarSites = function(actionURl, criteria, pickUpParamName, dropOffParamName) {
    var _criteria_secondary_selections_filter, _criteria_secondary_selections, _criteria_secondary;
    var _criteria_primary = criteria.primary, pickUpLocation = _criteria_primary.pickUpLocation, pickUpDateTime = _criteria_primary.pickUpDateTime, dropOffLocation = _criteria_primary.dropOffLocation, dropOffDateTime = _criteria_primary.dropOffDateTime;
    var _pickUpLocation_searchTerm;
    var pickupNameParam = {
        param: pickUpParamName,
        value: (_pickUpLocation_searchTerm = pickUpLocation.searchTerm) !== null && _pickUpLocation_searchTerm !== void 0 ? _pickUpLocation_searchTerm : ""
    };
    var _pickUpLocation_airportCode;
    var pickupIATACode = {
        param: "pickupIATACode",
        value: (_pickUpLocation_airportCode = pickUpLocation.airportCode) !== null && _pickUpLocation_airportCode !== void 0 ? _pickUpLocation_airportCode : ""
    };
    var _dropOffLocation_searchTerm;
    var returnName = {
        param: dropOffParamName,
        value: (_dropOffLocation_searchTerm = dropOffLocation === null || dropOffLocation === void 0 ? void 0 : dropOffLocation.searchTerm) !== null && _dropOffLocation_searchTerm !== void 0 ? _dropOffLocation_searchTerm : ""
    };
    var _dropOffLocation_airportCode;
    var returnIATACode = {
        param: "returnIATACode",
        value: (_dropOffLocation_airportCode = dropOffLocation === null || dropOffLocation === void 0 ? void 0 : dropOffLocation.airportCode) !== null && _dropOffLocation_airportCode !== void 0 ? _dropOffLocation_airportCode : ""
    };
    var d1 = {
        param: "d1",
        value: formatDateTimeVariant(pickUpDateTime)
    };
    var d2 = {
        param: "d2",
        value: formatDateTimeVariant(dropOffDateTime)
    };
    var pickupDateTime = {
        param: "pickupDateTime",
        value: formatDateTime(pickUpDateTime)
    };
    var returnDateTime = {
        param: "returnDateTime",
        value: formatDateTime(dropOffDateTime)
    };
    var selectables = (_criteria_secondary = criteria.secondary) === null || _criteria_secondary === void 0 ? void 0 : (_criteria_secondary_selections = _criteria_secondary.selections) === null || _criteria_secondary_selections === void 0 ? void 0 : (_criteria_secondary_selections_filter = _criteria_secondary_selections.filter(function(sel) {
        return secondaryCriteriaSelectables.indexOf(sel.id) > -1;
    })) === null || _criteria_secondary_selections_filter === void 0 ? void 0 : _criteria_secondary_selections_filter.map(function(param) {
        var id = param.id, value = param.value;
        return {
            param: id,
            value: value
        };
    });
    var extraParams = [
        pickupNameParam,
        pickupIATACode,
        returnName,
        returnIATACode,
        d1,
        d2,
        pickupDateTime,
        returnDateTime
    ];
    var extraParamsWithSelectables = selectables && selectables.length > 0 ? _to_consumable_array(extraParams).concat(_to_consumable_array(selectables)) : extraParams;
    return appendQueryParamsToUrl(actionURl, extraParamsWithSelectables);
};
var getURLWithParamsForCarRent = function(actionURl, criteria) {
    return buildURLWithParamsFor3rdPartyCarSites(actionURl, criteria, "pickupName", "returnName");
};
var getURLWithParamsForRentACar = function(actionURl, criteria) {
    return buildURLWithParamsFor3rdPartyCarSites(actionURl, criteria, "locn", "loc2");
};
// src/components/cars/utils/search-criteria.ts
var PICK_UP_LOCATION_NAME_SUFFIX = "pick_up_location";
var PICK_UP_TIME_NAME_SUFFIX = "pick_up_time";
var AARP_RATES_NAME_SUFFIX = "aarp_rates";
var DRIVER_AGE_NAME_SUFIX = "driver_age";
var selectionsNames = [
    "vend",
    "cpcd",
    "odcd",
    "cdnu"
];
var carsSearchCriteriaReducer = function(criteria, param) {
    var name = param.name, value = param.value, checked = param.checked, disabled = param.disabled;
    var primary = criteria.primary, secondary = criteria.secondary;
    if (name.startsWith(AIRPORT_CODE_NAME_PREFIX)) {
        var isPickUp = name.includes(PICK_UP_LOCATION_NAME_SUFFIX);
        var location = isPickUp ? primary.pickUpLocation : primary.dropOffLocation;
        var locationKey = isPickUp ? "pickUpLocation" : "dropOffLocation";
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, primary), _define_property({}, locationKey, location || value ? _object_spread_props(_object_spread({}, location), {
                airportCode: value
            }) : null))
        });
    }
    if (name.startsWith(LOCATION_NAME_PREFIX)) {
        var isPickUp1 = name.includes(PICK_UP_LOCATION_NAME_SUFFIX);
        var location1 = isPickUp1 ? primary.pickUpLocation : primary.dropOffLocation;
        var locationKey1 = isPickUp1 ? "pickUpLocation" : "dropOffLocation";
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, primary), _define_property({}, locationKey1, location1 || value ? _object_spread_props(_object_spread({}, location1), {
                searchTerm: value
            }) : null))
        });
    }
    if (name.startsWith(LAT_NAME_PREFIX) || name.startsWith(LONG_NAME_PREFIX)) {
        var _location_coordinates, _location_coordinates1;
        var isPickUp2 = name.includes(PICK_UP_LOCATION_NAME_SUFFIX);
        var location2 = isPickUp2 ? primary.pickUpLocation : primary.dropOffLocation;
        var locationKey2 = isPickUp2 ? "pickUpLocation" : "dropOffLocation";
        var isLat = name.startsWith("".concat(LAT_NAME_PREFIX, "-"));
        var valueNumber = value ? Number(value) : null;
        var _location_coordinates_latitude;
        var latitude = isLat ? valueNumber : (_location_coordinates_latitude = location2 === null || location2 === void 0 ? void 0 : (_location_coordinates = location2.coordinates) === null || _location_coordinates === void 0 ? void 0 : _location_coordinates.latitude) !== null && _location_coordinates_latitude !== void 0 ? _location_coordinates_latitude : null;
        var _location_coordinates_longitude;
        var longitude = !isLat ? valueNumber : (_location_coordinates_longitude = location2 === null || location2 === void 0 ? void 0 : (_location_coordinates1 = location2.coordinates) === null || _location_coordinates1 === void 0 ? void 0 : _location_coordinates1.longitude) !== null && _location_coordinates_longitude !== void 0 ? _location_coordinates_longitude : null;
        var coordinates = latitude || longitude ? {
            latitude: latitude,
            longitude: longitude
        } : null;
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, primary), _define_property({}, locationKey2, location2 || coordinates ? _object_spread_props(_object_spread({}, location2), {
                coordinates: coordinates
            }) : null))
        });
    }
    if (name.startsWith(REGION_ID_NAME_PREFIX)) {
        var isPickUp3 = name.includes(PICK_UP_LOCATION_NAME_SUFFIX);
        var location3 = isPickUp3 ? primary.pickUpLocation : primary.dropOffLocation;
        var locationKey3 = isPickUp3 ? "pickUpLocation" : "dropOffLocation";
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, primary), _define_property({}, locationKey3, location3 || value ? _object_spread_props(_object_spread({}, location3), {
                regionId: value
            }) : null))
        });
    }
    if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX) || name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX)) {
        var isPickUpDate = name.includes(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX);
        var dateKey = isPickUpDate ? "pickUpDateTime" : "dropOffDateTime";
        var _value_split_map = _sliced_to_array(value.split("-").map(function(item) {
            return Number(item);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var newCriteria = _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, primary), _define_property({}, dateKey, _object_spread_props(_object_spread({}, isPickUpDate ? primary.pickUpDateTime : primary.dropOffDateTime), {
                day: day,
                month: month,
                year: year
            })))
        });
        return newCriteria;
    }
    if (name.startsWith(EGDS_BASIC_SELECT_NAME_PREFIX) && name.includes("time")) {
        var TWELVE_AM = 12;
        var isPickUpTime = name.includes(PICK_UP_TIME_NAME_SUFFIX);
        var key = isPickUpTime ? "pickUpDateTime" : "dropOffDateTime";
        var timeIndication = value.substring(4, 6);
        var isAM = timeIndication === "AM";
        var hourInAMPM = Number(value.substring(0, 2));
        var adaptedHour = hourInAMPM === TWELVE_AM ? 0 : hourInAMPM;
        var hour = isAM ? adaptedHour : hourInAMPM + 12;
        var minute = Number(value.substring(2, 4));
        return _object_spread_props(_object_spread({}, criteria), {
            primary: _object_spread_props(_object_spread({}, primary), _define_property({}, key, _object_spread_props(_object_spread({}, isPickUpTime ? primary.pickUpDateTime : primary.dropOffDateTime), {
                hour: hour,
                minute: minute
            })))
        });
    }
    if (name.startsWith(EGDS_BASIC_PILL_PREFIX) && name.includes(AARP_RATES_NAME_SUFFIX)) {
        var _secondary_booleans;
        var newCriteria1 = _object_spread_props(_object_spread({}, criteria), {
            secondary: _object_spread_props(_object_spread({}, secondary), {
                booleans: _to_consumable_array((_secondary_booleans = secondary === null || secondary === void 0 ? void 0 : secondary.booleans) !== null && _secondary_booleans !== void 0 ? _secondary_booleans : []).concat([
                    {
                        id: "aarpcr",
                        value: checked
                    }
                ])
            })
        });
        return newCriteria1;
    }
    if (selectionsNames.find(function(selection) {
        return selection === name;
    })) {
        var _secondary_selections;
        var newCriteria2 = _object_spread_props(_object_spread({}, criteria), {
            secondary: _object_spread_props(_object_spread({}, secondary), {
                selections: _to_consumable_array((_secondary_selections = secondary === null || secondary === void 0 ? void 0 : secondary.selections) !== null && _secondary_selections !== void 0 ? _secondary_selections : []).concat([
                    {
                        id: name,
                        value: value
                    }
                ])
            })
        });
        return newCriteria2;
    }
    if (name.includes(DRIVER_AGE_NAME_SUFIX) && !disabled && value) {
        var _secondary_selections1;
        var newCriteria3 = _object_spread_props(_object_spread({}, criteria), {
            secondary: _object_spread_props(_object_spread({}, secondary), {
                selections: _to_consumable_array((_secondary_selections1 = secondary === null || secondary === void 0 ? void 0 : secondary.selections) !== null && _secondary_selections1 !== void 0 ? _secondary_selections1 : []).concat([
                    {
                        id: "age",
                        value: value
                    }
                ])
            })
        });
        return newCriteria3;
    }
    return criteria;
};
var getCarSearchCriteria = function(event) {
    var EGDS_PREFIX2 = "EGDS";
    var CARS_PREFIX = "Cars";
    var elements = Array.from(event.currentTarget.elements);
    var inputs = elements.filter(function(element) {
        return element.name.startsWith(EGDS_PREFIX2) || element.name.startsWith(CARS_PREFIX) || selectionsNames.includes(element.name);
    });
    var defaultDateTime = {
        day: 0,
        hour: 0,
        minute: 0,
        month: 0,
        second: 0,
        year: 0
    };
    var initialCriteria = {
        primary: {
            pickUpLocation: {},
            pickUpDateTime: defaultDateTime,
            dropOffDateTime: defaultDateTime
        },
        secondary: {}
    };
    var criteria = inputs.reduce(carsSearchCriteriaReducer, initialCriteria);
    return criteria;
};
// src/components/cars/form/__private/discount-code/car-search-form-discount-code.tsx
import React106 from "react";
import { gql as gql78 } from "@apollo/client";
import { PositionType as PositionType4, UitkMenu as UitkMenu4, UitkMenuContainer as UitkMenuContainer4, UitkMenuTrigger as UitkMenuTrigger4 } from "@egds/react-core/menu";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium22, Viewport as Viewport25, ViewSmall as ViewSmall23 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex20 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet4, UitkSheetContent as UitkSheetContent4, UitkSheetTransition as UitkSheetTransition4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing32 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar5 } from "uitk-react-toolbar";
// src/components/cars/form/__private/discount-code/car-search-form-discount-type-option.tsx
import React104 from "react";
import { gql as gql77 } from "@apollo/client";
// ../internal/src/components/common/egds-text-input.tsx
import React102 from "react";
import { gql as gql75 } from "@apollo/client";
import { UitkTextInput as UitkTextInput2 } from "uitk-react-input";
var __Fragment51 = gql75(_templateObject79());
var EGDSTextInputField = function(param) {
    var data = param.data, onChange = param.onChange, invalid = param.invalid, setInputRef = param.setInputRef, customValue = param.customValue;
    var label = data.label, value = data.value, egdsElementId = data.egdsElementId, placeholder = data.placeholder;
    var defaultValue = customValue || value;
    var _React102_useState = _sliced_to_array(React102.useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ""), 2), inputValue = _React102_useState[0], setInputValue = _React102_useState[1];
    var inputRef = React102.createRef();
    var handleChange = function(event) {
        if (onChange) {
            onChange(event);
        }
        setInputValue(event.target.value);
    };
    React102.useEffect(function() {
        if (setInputRef) {
            setInputRef(inputRef);
        }
    }, []);
    return /* @__PURE__ */ React102.createElement(UitkTextInput2, {
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        label: label,
        name: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        value: inputValue,
        onChange: handleChange,
        invalid: invalid !== null && invalid !== void 0 ? invalid : "",
        domRef: inputRef
    });
};
EGDSTextInputField.displayName = "EGDSTextInputField";
EGDSTextInputField.fragment = __Fragment51;
// src/components/cars/form/__private/discount-code/car-search-form-discount-type-option.tsx
import { UitkSelect as UitkSelect5 } from "uitk-react-input";
import { UitkLayoutFlex as UitkLayoutFlex19 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing31 } from "uitk-react-spacing";
// src/components/cars/form/__private/discount-code/car-search-form-special-or-advertised-option.tsx
import React103 from "react";
import { gql as gql76 } from "@apollo/client";
import { UitkSelect as UitkSelect4 } from "uitk-react-input";
import { UitkSpacing as UitkSpacing30 } from "uitk-react-spacing";
var __Fragment52 = gql76(_templateObject80(), EGDSTertiaryButton.fragment, EGDSTextInputField.fragment);
var CarSearchFormSpecialOrAdvertisedOption = function(param) {
    var data = param.data, errorState = param.errorState, handleErrorState = param.handleErrorState, index = param.index, setFieldRefByTypename = param.setFieldRefByTypename, setSelectedCouponType = param.setSelectedCouponType, disabledSelectIndex = param.disabledSelectIndex, setSpecialOrAdvertisedDiscountCode = param.setSpecialOrAdvertisedDiscountCode, codeValue = param.codeValue, codeTypeSelected = param.codeTypeSelected, discountTypes = param.discountTypes;
    var _discountCodeOptions_, _discountCodeOptions_1, _currentDiscountCodeOptions_find;
    var discountCodeOptions = data.discountCodeOptions, discountCodeType = data.discountCodeType;
    var _React103_useState = _sliced_to_array(React103.useState(discountCodeOptions), 2), currentDiscountCodeOptions = _React103_useState[0], setDiscountCodeOptions = _React103_useState[1];
    var _React103_useState1 = _sliced_to_array(React103.useState(codeTypeSelected), 2), selectCodeTypeValue = _React103_useState1[0], setSelectCodeTypeValue = _React103_useState1[1];
    var _React103_useState2 = _sliced_to_array(React103.useState(codeValue), 2), currentDiscountCodeValue = _React103_useState2[0], setCurrentDiscountCodeValue = _React103_useState2[1];
    var _discountCodeOptions__discountCodeTypeOption, _discountCodeOptions__discountCodeTypeOption1;
    var DiscountCodeOptionsMap = {
        DISCOUNT_RATE: (_discountCodeOptions__discountCodeTypeOption = (_discountCodeOptions_ = discountCodeOptions[0]) === null || _discountCodeOptions_ === void 0 ? void 0 : _discountCodeOptions_.discountCodeTypeOption) !== null && _discountCodeOptions__discountCodeTypeOption !== void 0 ? _discountCodeOptions__discountCodeTypeOption : "",
        DISCOUNT_COUPON: (_discountCodeOptions__discountCodeTypeOption1 = (_discountCodeOptions_1 = discountCodeOptions[1]) === null || _discountCodeOptions_1 === void 0 ? void 0 : _discountCodeOptions_1.discountCodeTypeOption) !== null && _discountCodeOptions__discountCodeTypeOption1 !== void 0 ? _discountCodeOptions__discountCodeTypeOption1 : ""
    };
    var handleSelectCodeTypeChange = function(event) {
        setSelectCodeTypeValue(event.target.value);
        handleErrorState(discountTypes.SPECIAL_OR_ADVERTISED, true, "", index.toString());
        var _event_target_value;
        setSpecialOrAdvertisedDiscountCode({
            data: data,
            value: currentDiscountCodeValue !== null && currentDiscountCodeValue !== void 0 ? currentDiscountCodeValue : "",
            index: index,
            codeTypeSelected: (_event_target_value = event.target.value) !== null && _event_target_value !== void 0 ? _event_target_value : ""
        });
        if (setSelectedCouponType) {
            setSelectedCouponType(event.target.value, index);
        }
    };
    var currentDiscountCode = (_currentDiscountCodeOptions_find = currentDiscountCodeOptions.find(function(param) {
        var discountCodeTypeOption = param.discountCodeTypeOption;
        return discountCodeTypeOption === selectCodeTypeValue;
    })) === null || _currentDiscountCodeOptions_find === void 0 ? void 0 : _currentDiscountCodeOptions_find.discountCodeInput;
    var invalidText = (currentDiscountCode === null || currentDiscountCode === void 0 ? void 0 : currentDiscountCode.validations) && currentDiscountCode.validations[0].__typename === "EGDSRequiredInputValidation" ? currentDiscountCode.validations[0].errorMessage : "";
    var currentInvalidText = errorState.inputsWithErrors.includes("special-advertised-coupon-".concat(index)) ? invalidText : "";
    var discountCodeTypeSelectRef = React103.createRef();
    React103.useEffect(function() {
        var _discountCodeTypeSelectRef_current;
        if (currentDiscountCodeOptions !== discountCodeOptions) {
            setSelectCodeTypeValue(discountCodeOptions[0].discountCodeTypeOption);
            setDiscountCodeOptions(discountCodeOptions);
        }
        (_discountCodeTypeSelectRef_current = discountCodeTypeSelectRef.current) === null || _discountCodeTypeSelectRef_current === void 0 ? void 0 : _discountCodeTypeSelectRef_current.focus();
    }, [
        currentDiscountCodeOptions,
        discountCodeOptions
    ]);
    var handleCurrentDiscountCodeChange = function(event) {
        handleErrorState(discountTypes.SPECIAL_OR_ADVERTISED, true, event.target.value, index.toString());
        setCurrentDiscountCodeValue(event.target.value);
        setSpecialOrAdvertisedDiscountCode({
            data: data,
            value: event.target.value,
            index: index,
            codeTypeSelected: selectCodeTypeValue !== null && selectCodeTypeValue !== void 0 ? selectCodeTypeValue : ""
        });
    };
    var getCodeInputRef = function(ref) {
        if (setFieldRefByTypename) {
            setFieldRefByTypename("special-advertised-coupon-".concat(index), ref);
        }
    };
    return /* @__PURE__ */ React103.createElement("div", null, /* @__PURE__ */ React103.createElement(UitkSpacing30, {
        padding: {
            block: selectCodeTypeValue ? "three" : "two"
        }
    }, /* @__PURE__ */ React103.createElement("div", null, /* @__PURE__ */ React103.createElement(UitkSelect4, {
        label: discountCodeType.label,
        onChange: handleSelectCodeTypeChange,
        "aria-label": discountCodeType.label,
        emptyState: true,
        value: selectCodeTypeValue,
        disabled: disabledSelectIndex === null || disabledSelectIndex === void 0 ? void 0 : disabledSelectIndex.includes(index),
        domRef: discountCodeTypeSelectRef
    }, currentDiscountCodeOptions.map(function(option, i) {
        return /* @__PURE__ */ React103.createElement("option", {
            key: i,
            value: option.discountCodeTypeOption
        }, option.discountCodeTypeOption);
    })))), selectCodeTypeValue && currentDiscountCode && /* @__PURE__ */ React103.createElement(React103.Fragment, null, /* @__PURE__ */ React103.createElement(UitkSpacing30, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React103.createElement(EGDSTextInputField, {
        data: currentDiscountCode,
        onChange: handleCurrentDiscountCodeChange,
        invalid: currentInvalidText,
        setInputRef: getCodeInputRef,
        customValue: currentDiscountCodeValue
    })), currentDiscountCodeValue && selectCodeTypeValue === DiscountCodeOptionsMap.DISCOUNT_COUPON && /* @__PURE__ */ React103.createElement("input", {
        type: "hidden",
        "aria-label": "vend",
        "data-stid": "vend",
        name: "vend",
        value: currentDiscountCodeValue
    }), currentDiscountCodeValue && selectCodeTypeValue === DiscountCodeOptionsMap.DISCOUNT_RATE && /* @__PURE__ */ React103.createElement("input", {
        type: "hidden",
        "aria-label": "cpcd",
        "data-stid": "cpcd",
        name: "cpcd",
        value: currentDiscountCodeValue
    }), currentDiscountCodeValue && selectCodeTypeValue !== DiscountCodeOptionsMap.DISCOUNT_RATE && selectCodeTypeValue !== DiscountCodeOptionsMap.DISCOUNT_COUPON && /* @__PURE__ */ React103.createElement("input", {
        type: "hidden",
        "aria-label": "odcd",
        "data-stid": "odcd",
        name: "odcd",
        value: currentDiscountCodeValue
    })));
};
CarSearchFormSpecialOrAdvertisedOption.fragment = __Fragment52;
CarSearchFormSpecialOrAdvertisedOption.displayName = "CarSearchFormSpecialOrAdvertisedOption";
// src/components/cars/form/__private/discount-code/car-search-form-discount-type-option.tsx
var __Fragment53 = gql77(_templateObject81(), CarSearchFormSpecialOrAdvertisedOption.fragment, EGDSTextInputField.fragment);
var CarSearchFormDiscountTypeOption = function(props) {
    var _errorState_inputsWithErrors;
    var data = props.data, readOnly = props.readOnly, disabled = props.disabled, egdsElementId = props.egdsElementId, label = props.label, icon = props.icon, handleErrorState = props.handleErrorState, errorState = props.errorState, setFieldRefByTypename = props.setFieldRefByTypename, isDisabled = props.isDisabled, clearDiscountTypeOptionsState = props.clearDiscountTypeOptionsState, selectedDiscountType = props.selectedDiscountType, handleDiscountType = props.handleDiscountType, corporateOrContractedCodeValue = props.corporateOrContractedCodeValue, handleCorporateOrContractedCodeValue = props.handleCorporateOrContractedCodeValue, handleSpecialOrAdvertisedCouponsData = props.handleSpecialOrAdvertisedCouponsData, specialOrAdvertisedCouponsData = props.specialOrAdvertisedCouponsData, handleDisabledDiscountCodeTypes = props.handleDisabledDiscountCodeTypes, disabledCouponTypeIndexes = props.disabledCouponTypeIndexes, handleClearDiscountTypeOptionsState = props.handleClearDiscountTypeOptionsState, discountTypes = props.discountTypes;
    var corporateOrContractedOption = data.corporateOrContractedOption, specialOrAdvertisedOption = data.specialOrAdvertisedOption;
    var corporateOrContractedLabel = corporateOrContractedOption === null || corporateOrContractedOption === void 0 ? void 0 : corporateOrContractedOption.optionLabel;
    var specialOrAdvertisedLabel = specialOrAdvertisedOption === null || specialOrAdvertisedOption === void 0 ? void 0 : specialOrAdvertisedOption.optionLabel;
    var _React104_useState = _sliced_to_array(React104.useState(specialOrAdvertisedOption), 2), currentSpecialOrAdvertisedOption = _React104_useState[0], setCurrentSpecialOrAdvertisedOption = _React104_useState[1];
    var _React104_useState1 = _sliced_to_array(React104.useState(specialOrAdvertisedCouponsData), 2), specialOrAdvertisedOptionsData = _React104_useState1[0], setSpecialOrAdvertisedOptionsData = _React104_useState1[1];
    var _React104_useState2 = _sliced_to_array(React104.useState([]), 2), seletedDiscountCodeTypes = _React104_useState2[0], setSelectedDicountCodeTypes = _React104_useState2[1];
    var allowToAddSpecialOrAdvertisedOption = currentSpecialOrAdvertisedOption.maxDiscountCode > specialOrAdvertisedOptionsData.length && specialOrAdvertisedOptionsData.length === seletedDiscountCodeTypes.length;
    var handleSelectedDiscountCodeTypes = function(seletedCodeType, index) {
        var filterCurrentDiscountType = seletedDiscountCodeTypes.filter(function(code) {
            return code.index !== index;
        });
        setSelectedDicountCodeTypes(_to_consumable_array(filterCurrentDiscountType).concat([
            {
                selectedDiscountType: seletedCodeType,
                index: index
            }
        ]));
        var filterDisabledCodeTypeIndex = disabledCouponTypeIndexes.filter(function(coupon) {
            return coupon !== index - 1;
        });
        handleDisabledDiscountCodeTypes(_to_consumable_array(filterDisabledCodeTypeIndex).concat([
            index - 1
        ]));
    };
    var handleDiscountOptionChange = function(event) {
        if (handleDiscountType) {
            handleDiscountType(event.target.value);
        }
        if (event.target.value === discountTypes.CORPORATE_OR_CONTRACTED) {
            handleErrorState(discountTypes.CORPORATE_OR_CONTRACTED, true, "");
        }
    };
    var handleAddAnotherSpecialOrAdvertisedOptionClick = function() {
        var selectedDiscountTypes = seletedDiscountCodeTypes.map(function(code) {
            return code.selectedDiscountType;
        });
        var filteredCurrentSpecialOrAdvertisedOptions = currentSpecialOrAdvertisedOption.discountCodeOptions.filter(function(option) {
            var isCodeTypeSelected = selectedDiscountTypes.includes(option.discountCodeTypeOption);
            return !isCodeTypeSelected && option;
        });
        var currentSpecialOrAdvertisedOptionFilteredData = _object_spread_props(_object_spread({}, currentSpecialOrAdvertisedOption), {
            discountCodeOptions: filteredCurrentSpecialOrAdvertisedOptions
        });
        var nextIndex = disabledCouponTypeIndexes.length - 1;
        if (seletedDiscountCodeTypes[nextIndex]) {
            handleDisabledDiscountCodeTypes(_to_consumable_array(disabledCouponTypeIndexes).concat([
                nextIndex
            ]));
        }
        var newSpecialOrAdvertisedOptionsData = {
            data: currentSpecialOrAdvertisedOptionFilteredData,
            value: "",
            index: null,
            codeTypeSelected: ""
        };
        setSpecialOrAdvertisedOptionsData(_to_consumable_array(specialOrAdvertisedOptionsData).concat([
            newSpecialOrAdvertisedOptionsData
        ]));
    };
    var handleCorporateOrContractedCodeChange = function(event) {
        if (handleCorporateOrContractedCodeValue) {
            handleCorporateOrContractedCodeValue(event.target.value);
        }
        if (selectedDiscountType === discountTypes.CORPORATE_OR_CONTRACTED) {
            handleErrorState(discountTypes.CORPORATE_OR_CONTRACTED, true, event.target.value);
        }
    };
    var defaultDisocuntCodeType = {
        data: specialOrAdvertisedOption,
        value: "",
        index: null,
        codeTypeSelected: ""
    };
    React104.useEffect(function() {
        if (specialOrAdvertisedOption !== currentSpecialOrAdvertisedOption) {
            setSpecialOrAdvertisedOptionsData([
                defaultDisocuntCodeType
            ]);
            setCurrentSpecialOrAdvertisedOption(specialOrAdvertisedOption);
        }
        if (clearDiscountTypeOptionsState) {
            setSelectedDicountCodeTypes([]);
            setSpecialOrAdvertisedOptionsData([
                {
                    data: specialOrAdvertisedOption,
                    value: "",
                    index: 0,
                    codeTypeSelected: ""
                }
            ]);
            handleClearDiscountTypeOptionsState();
        }
    }, [
        currentSpecialOrAdvertisedOption,
        specialOrAdvertisedOption,
        clearDiscountTypeOptionsState
    ]);
    var isCorporateOrContractInputInvalid = (_errorState_inputsWithErrors = errorState.inputsWithErrors) === null || _errorState_inputsWithErrors === void 0 ? void 0 : _errorState_inputsWithErrors.includes("corporate-or-contracted-option");
    var validationText = (corporateOrContractedOption === null || corporateOrContractedOption === void 0 ? void 0 : corporateOrContractedOption.discountCode.validations) && (corporateOrContractedOption === null || corporateOrContractedOption === void 0 ? void 0 : corporateOrContractedOption.discountCode.validations[0].__typename) === "EGDSRequiredInputValidation" ? corporateOrContractedOption === null || corporateOrContractedOption === void 0 ? void 0 : corporateOrContractedOption.discountCode.validations[0].errorMessage : "";
    var invalidMessageCorporateOrContractedOption = isCorporateOrContractInputInvalid ? validationText : "";
    var getCodeInputRef = function(ref) {
        if (setFieldRefByTypename) {
            setFieldRefByTypename("corporate-or-contracted-option", ref);
        }
    };
    return /* @__PURE__ */ React104.createElement("div", null, /* @__PURE__ */ React104.createElement(UitkSpacing31, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React104.createElement("div", null, /* @__PURE__ */ React104.createElement(UitkSelect5, {
        readOnly: readOnly,
        disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled,
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        label: label,
        icon: icon === null || icon === void 0 ? void 0 : icon.id,
        "aria-label": label !== null && label !== void 0 ? label : "",
        onChange: handleDiscountOptionChange,
        value: selectedDiscountType,
        emptyState: true
    }, corporateOrContractedOption && /* @__PURE__ */ React104.createElement("option", {
        key: corporateOrContractedLabel,
        label: corporateOrContractedLabel,
        value: corporateOrContractedLabel
    }, corporateOrContractedLabel), specialOrAdvertisedOption && /* @__PURE__ */ React104.createElement("option", {
        key: specialOrAdvertisedLabel,
        label: specialOrAdvertisedLabel,
        value: specialOrAdvertisedLabel
    }, specialOrAdvertisedLabel)))), corporateOrContractedOption && selectedDiscountType === discountTypes.CORPORATE_OR_CONTRACTED && !isDisabled && /* @__PURE__ */ React104.createElement(EGDSTextInputField, {
        data: corporateOrContractedOption.discountCode,
        invalid: invalidMessageCorporateOrContractedOption,
        onChange: handleCorporateOrContractedCodeChange,
        setInputRef: getCodeInputRef,
        customValue: corporateOrContractedCodeValue
    }), specialOrAdvertisedOption && selectedDiscountType === discountTypes.SPECIAL_OR_ADVERTISED && !isDisabled && /* @__PURE__ */ React104.createElement(React104.Fragment, null, specialOrAdvertisedOptionsData.map(function(optionData, index) {
        return /* @__PURE__ */ React104.createElement(CarSearchFormSpecialOrAdvertisedOption, {
            key: index,
            data: optionData.data,
            index: index,
            errorState: errorState,
            handleErrorState: handleErrorState,
            setFieldRefByTypename: setFieldRefByTypename,
            setSelectedCouponType: handleSelectedDiscountCodeTypes,
            disabledSelectIndex: disabledCouponTypeIndexes,
            setSpecialOrAdvertisedDiscountCode: handleSpecialOrAdvertisedCouponsData,
            codeValue: optionData.value,
            codeTypeSelected: optionData.codeTypeSelected,
            discountTypes: discountTypes
        });
    }), specialOrAdvertisedOption.addAnotherDiscountCode.__typename === "UITertiaryButton" && /* @__PURE__ */ React104.createElement(UitkLayoutFlex19, {
        justifyContent: "end"
    }, /* @__PURE__ */ React104.createElement("div", null, /* @__PURE__ */ React104.createElement(EGDSTertiaryButton, {
        data: specialOrAdvertisedOption.addAnotherDiscountCode,
        onClick: handleAddAnotherSpecialOrAdvertisedOptionClick,
        isDisabled: !allowToAddSpecialOrAdvertisedOption
    })))), corporateOrContractedCodeValue && /* @__PURE__ */ React104.createElement("input", {
        type: "hidden",
        "aria-label": "cdnu",
        "data-stid": "cdnu",
        name: "cdnu",
        value: corporateOrContractedCodeValue
    }));
};
CarSearchFormDiscountTypeOption.fragment = __Fragment53;
CarSearchFormDiscountTypeOption.displayName = "CarSearchFormDiscountTypeOption";
// src/components/cars/form/__private/discount-code/hooks/use-focus-input-ref.tsx
import React105 from "react";
var useFocusInputRef = function(fieldsRefs) {
    var initialIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _React105_useState = _sliced_to_array(React105.useState(initialIdentifier), 2), focusInput = _React105_useState[0], setFocusInput = _React105_useState[1];
    React105.useEffect(function() {
        var _fieldsRefs_find_reference_current, _fieldsRefs_find;
        (_fieldsRefs_find = fieldsRefs.find(function(ref) {
            return ref.name === focusInput;
        })) === null || _fieldsRefs_find === void 0 ? void 0 : (_fieldsRefs_find_reference_current = _fieldsRefs_find.reference.current) === null || _fieldsRefs_find_reference_current === void 0 ? void 0 : _fieldsRefs_find_reference_current.focus();
    }, [
        focusInput
    ]);
    return {
        setFocusInput: setFocusInput
    };
};
// src/components/cars/form/__private/discount-code/car-search-form-discount-code.tsx
var __Fragment54 = gql78(_templateObject82(), CarSearchFormDiscountTypeOption.fragment, EGDSPill.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSErrorSummary.fragment, EGDSSelect.fragment);
var initialValidationState = {
    corporateOrContracted: {
        selected: false,
        value: ""
    },
    specialOrAdvertised: {
        selected: false,
        coupons: []
    }
};
var initialErrorState = {
    displayErrorSummary: false,
    errorCount: 0,
    errorLinkReference: null,
    inputsWithErrors: []
};
var CarSearchFormDiscountCode = function(param) {
    var data = param.data;
    var _discountTypeOptions__corporateOrContractedOption, _discountTypeOptions__specialOrAdvertisedOption, _discountType_icon, _find_icon, _find;
    var discountCode = data.discountCode, action = data.action;
    var discountType = action.discountType, preferredBrand = action.preferredBrand, discountTypeOptions = action.discountTypeOptions, done = action.done, toolbar = action.toolbar, errorSummary5 = action.errorSummary;
    var discountTypes = {
        CORPORATE_OR_CONTRACTED: (_discountTypeOptions__corporateOrContractedOption = discountTypeOptions[0].corporateOrContractedOption) === null || _discountTypeOptions__corporateOrContractedOption === void 0 ? void 0 : _discountTypeOptions__corporateOrContractedOption.optionLabel,
        SPECIAL_OR_ADVERTISED: (_discountTypeOptions__specialOrAdvertisedOption = discountTypeOptions[0].specialOrAdvertisedOption) === null || _discountTypeOptions__specialOrAdvertisedOption === void 0 ? void 0 : _discountTypeOptions__specialOrAdvertisedOption.optionLabel
    };
    var _React106_useState = _sliced_to_array(React106.useState(false), 2), menuState = _React106_useState[0], setMenuState = _React106_useState[1];
    var _React106_useState1 = _sliced_to_array(React106.useState(discountTypeOptions[0]), 2), currentDiscountTypeOption = _React106_useState1[0], setCurrentDiscountTypeOption = _React106_useState1[1];
    var triggerRef = React106.createRef();
    var pillTriggerRef = React106.createRef();
    var _React106_useState2 = _sliced_to_array(React106.useState(), 2), currentDiscountBrand = _React106_useState2[0], setCurrentDiscountBrand = _React106_useState2[1];
    var _React106_useState3 = _sliced_to_array(React106.useState(""), 2), selectedDiscountType = _React106_useState3[0], setSelectedDiscountType = _React106_useState3[1];
    var _React106_useState4 = _sliced_to_array(React106.useState(""), 2), corporateOrContractedCodeValue = _React106_useState4[0], setCorporateOrContractedCodeValue = _React106_useState4[1];
    var _React106_useState5 = _sliced_to_array(React106.useState([]), 2), disabledCouponTypeIndexes = _React106_useState5[0], setDisabledCouponTypeIndexes = _React106_useState5[1];
    var _React106_useState6 = _sliced_to_array(React106.useState(false), 2), clearDiscountTypeOptionsState = _React106_useState6[0], setClearDiscountTypeOptionsState = _React106_useState6[1];
    var _React106_useState7 = _sliced_to_array(React106.useState([
        {
            data: discountTypeOptions[0].specialOrAdvertisedOption,
            value: "",
            index: 0,
            codeTypeSelected: ""
        }
    ]), 2), specialOrAdvertisedCouponsData = _React106_useState7[0], setSpecialOrAdvertisedCouponsData = _React106_useState7[1];
    var _React106_useState8 = _sliced_to_array(React106.useState(initialValidationState), 2), validationState = _React106_useState8[0], setValidationState = _React106_useState8[1];
    var _React106_useState9 = _sliced_to_array(React106.useState([]), 2), fieldsRefs = _React106_useState9[0], setFieldsRefs = _React106_useState9[1];
    var _React106_useState10 = _sliced_to_array(React106.useState(_object_spread({}, initialErrorState)), 2), errorState = _React106_useState10[0], setErrorState = _React106_useState10[1];
    var _useFocusInputRef = useFocusInputRef(fieldsRefs), setFocusInputAfterError = _useFocusInputRef.setFocusInput;
    var handleErrorsClearStates = function() {
        setErrorState(initialErrorState);
        setFieldsRefs([]);
        setValidationState(initialValidationState);
    };
    var handleErrorsClearStatesOnCorporateDiscountType = function() {
        handleErrorsClearStates();
        setCorporateOrContractedCodeValue("");
    };
    var handleErrorsClearStatesOnSpecialDiscountType = function() {
        handleErrorsClearStates();
        setDisabledCouponTypeIndexes([]);
        setClearDiscountTypeOptionsState(true);
        setSpecialOrAdvertisedCouponsData([]);
    };
    var handleErrorClearStateForSpecialOrAdvertisedCoupons = function(discount) {
        var couponIdentifier = "special-advertised-coupon-".concat(discount.index);
        if (errorState.inputsWithErrors.includes(couponIdentifier)) {
            var specialOrAdvertised = validationState.specialOrAdvertised;
            var errors = specialOrAdvertised.coupons.filter(function(coupon) {
                return coupon.value === "";
            });
            var nextInputErrorId = errors.map(function(error) {
                return "special-advertised-coupon-".concat(error.id);
            }).filter(function(x) {
                return x !== couponIdentifier;
            });
            setErrorState(function(prevState) {
                if (prevState.errorCount > 0) {
                    var _fieldsRefs_find;
                    var errorCount2 = prevState.errorCount - 1;
                    var inputsWithErrors = prevState.inputsWithErrors.filter(function(error) {
                        return !error.includes(couponIdentifier);
                    });
                    var nextRef = (_fieldsRefs_find = fieldsRefs.find(function(ref) {
                        return ref.name === nextInputErrorId[0];
                    })) === null || _fieldsRefs_find === void 0 ? void 0 : _fieldsRefs_find.reference;
                    return {
                        displayErrorSummary: errorCount2 > 0,
                        errorCount: errorCount2,
                        errorLinkReference: nextRef !== null && nextRef !== void 0 ? nextRef : null,
                        inputsWithErrors: inputsWithErrors
                    };
                }
                return prevState;
            });
            setFocusInputAfterError(couponIdentifier);
        }
    };
    var handleSpecialOrAdvertisedCouponsData = function(discountCoupon) {
        var filterCurrentCouponsData = specialOrAdvertisedCouponsData.filter(function(coupon) {
            return coupon.index !== discountCoupon.index;
        });
        setSpecialOrAdvertisedCouponsData(_to_consumable_array(filterCurrentCouponsData).concat([
            discountCoupon
        ]));
        if (discountCoupon.value) {
            handleErrorClearStateForSpecialOrAdvertisedCoupons(discountCoupon);
        }
    };
    var handleDiscountType = function(selectedDiscountTypeValue) {
        setSelectedDiscountType(selectedDiscountTypeValue);
        if (selectedDiscountTypeValue === discountTypes.CORPORATE_OR_CONTRACTED) {
            handleErrorsClearStatesOnCorporateDiscountType();
        }
        if (selectedDiscountTypeValue === discountTypes.SPECIAL_OR_ADVERTISED) {
            handleErrorsClearStatesOnSpecialDiscountType();
        }
    };
    var handleCorporateOrContractedCodeValue = function(currentCorporateOrContracted) {
        setCorporateOrContractedCodeValue(currentCorporateOrContracted);
        if (currentCorporateOrContracted) {
            setErrorState(initialErrorState);
        }
    };
    var handleDisabledDiscountCodeTypes = function(disabledIndexes) {
        setDisabledCouponTypeIndexes(disabledIndexes);
    };
    var handleClearDiscountTypeOptionsState = function() {
        setClearDiscountTypeOptionsState(false);
    };
    var selectsValuesProps = {
        selectedDiscountType: selectedDiscountType,
        handleDiscountType: handleDiscountType,
        corporateOrContractedCodeValue: corporateOrContractedCodeValue,
        handleCorporateOrContractedCodeValue: handleCorporateOrContractedCodeValue,
        handleSpecialOrAdvertisedCouponsData: handleSpecialOrAdvertisedCouponsData,
        specialOrAdvertisedCouponsData: specialOrAdvertisedCouponsData,
        handleDisabledDiscountCodeTypes: handleDisabledDiscountCodeTypes,
        disabledCouponTypeIndexes: disabledCouponTypeIndexes,
        handleClearDiscountTypeOptionsState: handleClearDiscountTypeOptionsState
    };
    var _useDialog4 = _sliced_to_array(useDialog4("discount-codes-dialog"), 3), isDialogOpen = _useDialog4[0], dialogActions = _useDialog4[1], DialogComponent = _useDialog4[2];
    var discountTypeProps = discountType.__typename === "EGDSBasicSelect" ? _object_spread_props(_object_spread({}, discountType), {
        icon: {
            id: (_discountType_icon = discountType.icon) === null || _discountType_icon === void 0 ? void 0 : _discountType_icon.id
        }
    }) : void 0;
    var handleCommonClearStates = function() {
        setSelectedDiscountType("");
        setCorporateOrContractedCodeValue("");
        setErrorState(initialErrorState);
        setDisabledCouponTypeIndexes([]);
        setSpecialOrAdvertisedCouponsData([]);
        setClearDiscountTypeOptionsState(true);
        setValidationState(initialValidationState);
        setFieldsRefs([]);
    };
    var handleOnChange = function(event) {
        var selectedDiscountBrand = discountTypeOptions.filter(function(type) {
            return type.preferredBrand === event.target.value;
        })[0];
        setCurrentDiscountTypeOption(selectedDiscountBrand);
        setCurrentDiscountBrand(event.target.value);
        handleCommonClearStates();
    };
    var handleChangeValueForValidation = function(codeType, selected, value, identifier) {
        if (codeType === discountTypes.CORPORATE_OR_CONTRACTED) {
            setValidationState({
                specialOrAdvertised: {
                    selected: false,
                    coupons: []
                },
                corporateOrContracted: {
                    selected: selected !== null && selected !== void 0 ? selected : false,
                    value: value !== null && value !== void 0 ? value : ""
                }
            });
        }
        if (codeType === discountTypes.SPECIAL_OR_ADVERTISED) {
            var newCoupon = {
                id: identifier !== null && identifier !== void 0 ? identifier : "",
                value: value !== null && value !== void 0 ? value : ""
            };
            var cleanCoupons = validationState.specialOrAdvertised.coupons.filter(function(coupon) {
                return coupon.id !== identifier;
            });
            setValidationState({
                corporateOrContracted: {
                    selected: false,
                    value: ""
                },
                specialOrAdvertised: _object_spread_props(_object_spread({}, validationState.specialOrAdvertised), {
                    selected: selected !== null && selected !== void 0 ? selected : false,
                    coupons: _to_consumable_array(cleanCoupons).concat([
                        newCoupon
                    ])
                })
            });
        }
    };
    var handleOnClear = function() {
        handleCommonClearStates();
        setCurrentDiscountBrand("");
    };
    var handleMenuOnClick = function() {
        setMenuState(function(prevState) {
            return !prevState;
        });
    };
    var isCorporateOrContractedCouponValid = function() {
        var corporateOrContracted = validationState.corporateOrContracted;
        var isValid = !!corporateOrContracted.value;
        if (!isValid && corporateOrContracted.selected) {
            var _fieldsRefs_;
            setErrorState({
                displayErrorSummary: true,
                errorCount: 1,
                errorLinkReference: (_fieldsRefs_ = fieldsRefs[0]) === null || _fieldsRefs_ === void 0 ? void 0 : _fieldsRefs_.reference,
                inputsWithErrors: [
                    "corporate-or-contracted-option"
                ]
            });
            return false;
        }
        return true;
    };
    var isSpecialOrAdvertisedCouponsValid = function() {
        var specialOrAdvertised = validationState.specialOrAdvertised;
        if (specialOrAdvertised.selected) {
            var errors = specialOrAdvertised.coupons.filter(function(coupon) {
                return coupon.value === "";
            });
            if (errors.length > 0) {
                var _fieldsRefs_find;
                var inputsErrorId = errors.map(function(error) {
                    return "special-advertised-coupon-".concat(error.id);
                });
                var errorRef = (_fieldsRefs_find = fieldsRefs.find(function(ref) {
                    return ref.name === inputsErrorId[0];
                })) === null || _fieldsRefs_find === void 0 ? void 0 : _fieldsRefs_find.reference;
                setErrorState({
                    displayErrorSummary: errors.length > 0,
                    errorCount: errors.length,
                    errorLinkReference: errorRef !== null && errorRef !== void 0 ? errorRef : null,
                    inputsWithErrors: _to_consumable_array(inputsErrorId)
                });
                return false;
            }
            return true;
        }
        return true;
    };
    var handleMenuSubmit = function() {
        var isCouponCodesValid = isCorporateOrContractedCouponValid() && isSpecialOrAdvertisedCouponsValid();
        if (isCouponCodesValid) {
            var _pillTriggerRef_current;
            setMenuState(false);
            (_pillTriggerRef_current = pillTriggerRef.current) === null || _pillTriggerRef_current === void 0 ? void 0 : _pillTriggerRef_current.focus();
        }
    };
    var handleOnDismissMenu = function() {
        handleCommonClearStates();
        setCurrentDiscountBrand("");
    };
    var onSubmitDialog = function() {
        var isCouponCodesValid = isCorporateOrContractedCouponValid() && isSpecialOrAdvertisedCouponsValid();
        if (isCouponCodesValid) {
            var _pillTriggerRef_current;
            setErrorState(initialErrorState);
            dialogActions.closeDialog();
            (_pillTriggerRef_current = pillTriggerRef.current) === null || _pillTriggerRef_current === void 0 ? void 0 : _pillTriggerRef_current.focus();
        }
    };
    var onOpenDialog = function() {
        dialogActions.openDialog();
    };
    var onCloseDialog = function() {
        var _pillTriggerRef_current;
        handleCommonClearStates();
        setCurrentDiscountBrand("");
        dialogActions.closeDialog();
        (_pillTriggerRef_current = pillTriggerRef.current) === null || _pillTriggerRef_current === void 0 ? void 0 : _pillTriggerRef_current.focus();
    };
    var discountTypeDisableState = !currentDiscountBrand;
    var setFieldRefByTypename = React106.useCallback(function(name, ref) {
        var newRef = {
            name: name,
            reference: ref
        };
        setFieldsRefs(function(prevState) {
            return _to_consumable_array(prevState).concat([
                newRef
            ]);
        });
    }, []);
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var showErrorSummary = errorSummary5 && displayErrorSummary;
    var discountCodeContent = /* @__PURE__ */ React106.createElement(React106.Fragment, null, showErrorSummary && /* @__PURE__ */ React106.createElement(UitkSpacing32, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React106.createElement("div", null, /* @__PURE__ */ React106.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }))), /* @__PURE__ */ React106.createElement(UitkSpacing32, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React106.createElement("div", null, /* @__PURE__ */ React106.createElement(EGDSSelect, {
        data: preferredBrand,
        onChange: handleOnChange,
        emptyState: true,
        selectValue: currentDiscountBrand
    }))), currentDiscountTypeOption && discountTypeProps && /* @__PURE__ */ React106.createElement(UitkSpacing32, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React106.createElement("div", null, /* @__PURE__ */ React106.createElement(CarSearchFormDiscountTypeOption, _object_spread_props(_object_spread({
        data: currentDiscountTypeOption
    }, discountTypeProps, selectsValuesProps), {
        handleErrorState: handleChangeValueForValidation,
        errorState: errorState,
        setFieldRefByTypename: setFieldRefByTypename,
        isDisabled: discountTypeDisableState,
        clearDiscountTypeOptionsState: clearDiscountTypeOptionsState,
        discountTypes: discountTypes
    })))));
    var _toolbar_actions_secondaries, _find_icon_description;
    var navIconLabel = (_find_icon_description = (_find = ((_toolbar_actions_secondaries = toolbar.actions.secondaries) !== null && _toolbar_actions_secondaries !== void 0 ? _toolbar_actions_secondaries : []).find(function(secondary) {
        return secondary.icon;
    })) === null || _find === void 0 ? void 0 : (_find_icon = _find.icon) === null || _find_icon === void 0 ? void 0 : _find_icon.description) !== null && _find_icon_description !== void 0 ? _find_icon_description : "";
    var _toolbar_primary;
    return /* @__PURE__ */ React106.createElement("div", null, /* @__PURE__ */ React106.createElement(Viewport25, null, /* @__PURE__ */ React106.createElement(ViewSmall23, null, /* @__PURE__ */ React106.createElement(React106.Fragment, null, /* @__PURE__ */ React106.createElement(UitkSheetTransition4, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React106.createElement(DialogComponent, null, /* @__PURE__ */ React106.createElement(UitkSheet4, {
        isVisible: isDialogOpen,
        type: "full",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React106.createElement(UitkToolbar5, {
        toolbarTitle: (_toolbar_primary = toolbar.primary) !== null && _toolbar_primary !== void 0 ? _toolbar_primary : "",
        navigationContent: {
            navType: "close",
            onClick: onCloseDialog,
            navIconLabel: navIconLabel
        },
        toolbarActionContent: /* @__PURE__ */ React106.createElement(EGDSTertiaryButton, {
            data: toolbar.actions.primary,
            onClick: handleOnClear
        })
    }), /* @__PURE__ */ React106.createElement(UitkSheetContent4, null, /* @__PURE__ */ React106.createElement(UitkSpacing32, {
        padding: {
            inline: "three",
            blockstart: "three"
        }
    }, /* @__PURE__ */ React106.createElement("div", null, discountCodeContent, done.__typename === "UIPrimaryButton" && /* @__PURE__ */ React106.createElement(EGDSPrimaryButton, {
        data: done,
        onClick: onSubmitDialog
    }))))))), /* @__PURE__ */ React106.createElement(EGDSPill, {
        data: discountCode,
        triggerPill: true,
        onClick: onOpenDialog,
        domRef: pillTriggerRef
    }))), /* @__PURE__ */ React106.createElement(ViewMedium22, null, /* @__PURE__ */ React106.createElement(UitkMenu4, {
        isOpen: menuState,
        onTriggerClick: handleMenuOnClick,
        onDismiss: handleOnDismissMenu
    }, /* @__PURE__ */ React106.createElement(UitkMenuTrigger4, null, /* @__PURE__ */ React106.createElement("div", null, /* @__PURE__ */ React106.createElement(EGDSPill, {
        data: discountCode,
        triggerPill: true,
        domRef: pillTriggerRef
    }))), /* @__PURE__ */ React106.createElement(UitkMenuContainer4, {
        position: PositionType4.LEFT,
        showOverTrigger: true,
        width: 500
    }, /* @__PURE__ */ React106.createElement(UitkSpacing32, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React106.createElement("div", null, /* @__PURE__ */ React106.createElement(UitkLayoutFlex20, {
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React106.createElement(UitkHeading5, null, toolbar.primary), /* @__PURE__ */ React106.createElement(EGDSTertiaryButton, {
        data: toolbar.actions.primary,
        onClick: handleOnClear
    })), /* @__PURE__ */ React106.createElement(UitkSpacing32, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React106.createElement("div", null, discountCodeContent)), done.__typename === "UIPrimaryButton" && /* @__PURE__ */ React106.createElement(EGDSPrimaryButton, {
        data: done,
        onClick: handleMenuSubmit
    }))))))), currentDiscountBrand && /* @__PURE__ */ React106.createElement("input", {
        type: "hidden",
        "aria-label": "vend",
        "data-stid": "vend",
        name: "vend",
        value: currentDiscountBrand
    }));
};
CarSearchFormDiscountCode.fragment = __Fragment54;
CarSearchFormDiscountCode.displayName = "CarSearchFormDiscountCode";
// src/components/cars/form/__private/layout.tsx
var Field2 = /* @__PURE__ */ function(Field4) {
    Field4["pickUpLocation"] = "pickUpLocation";
    Field4["dropOffLocation"] = "dropOffLocation";
    Field4["dates"] = "dates";
    Field4["pickUpTime"] = "pickUpTime";
    Field4["dropOffTime"] = "dropOffTime";
    Field4["driverAgeCheck"] = "driverAgeCheck";
    Field4["specialRatesHeading"] = "specialRatesHeading";
    Field4["aarpRatesAndDiscountCodes"] = "aarpRatesAndDiscountCodes";
    Field4["search"] = "search";
    return Field4;
}(Field2 || {});
var repeat = function(value, times) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
    return Array.from(Array(times)).map(function(i) {
        return value;
    }).join(separator);
};
var getGridPropsByLayout = function(criteria) {
    var includesDriverAgeCheck = criteria.includesDriverAgeCheck, includeAarpRates = criteria.includeAarpRates, includeDiscountCodes = criteria.includeDiscountCodes;
    var pickUpLocation = Field2.pickUpLocation, dropOffLocation = Field2.dropOffLocation, dates = Field2.dates, pickUpTime = Field2.pickUpTime, dropOffTime = Field2.dropOffTime, driverAgeCheck = Field2.driverAgeCheck, aarpRatesAndDiscountCodes = Field2.aarpRatesAndDiscountCodes, search6 = Field2.search;
    var props = {
        space: "three"
    };
    var aarpRatesAndDiscountCodesArea = includeAarpRates || includeDiscountCodes ? aarpRatesAndDiscountCodes : ".";
    var driverAgeCheckArea = includesDriverAgeCheck ? driverAgeCheck : ".";
    return _object_spread_props(_object_spread({}, props), {
        areas: {
            small: [
                "".concat(repeat(pickUpLocation, 8)),
                "".concat(repeat(dropOffLocation, 8)),
                "".concat(repeat(dates, 8)),
                "".concat(repeat(pickUpTime, 4), " ").concat(repeat(dropOffTime, 4)),
                "".concat(repeat(driverAgeCheckArea, 8)),
                "".concat(repeat(aarpRatesAndDiscountCodesArea, 6), " ").concat(repeat(".", 2)),
                "".concat(repeat(search6, 8))
            ],
            medium: [
                "".concat(repeat(pickUpLocation, 3), " ").concat(repeat(dropOffLocation, 3)),
                "".concat(repeat(dates, 2), " ").concat(repeat(pickUpTime, 2), " ").concat(repeat(dropOffTime, 2)),
                "".concat(repeat(driverAgeCheckArea, 2), " ").concat(repeat(".", 4)),
                "".concat(aarpRatesAndDiscountCodesArea, " ").concat(repeat(".", 5)),
                "".concat(repeat(search6, 2), " ").concat(repeat(".", 4))
            ],
            large: [
                "".concat(repeat(pickUpLocation, 4), " ").concat(repeat(dropOffLocation, 4), " ").concat(repeat(dates, 4), " ").concat(repeat(pickUpTime, 3), " ").concat(repeat(dropOffTime, 3), " ").concat(repeat(search6, 2)),
                "".concat(repeat(driverAgeCheckArea, 3), " ").concat(repeat(".", 17)),
                "".concat(repeat(aarpRatesAndDiscountCodesArea, 4), " ").concat(repeat(".", 16))
            ]
        }
    });
};
var getFieldsGridItemPropsByLayout = function() {
    var pickUpLocation = Field2.pickUpLocation, dropOffLocation = Field2.dropOffLocation, dates = Field2.dates, pickUpTime = Field2.pickUpTime, dropOffTime = Field2.dropOffTime, driverAgeCheck = Field2.driverAgeCheck, specialRatesHeading = Field2.specialRatesHeading, aarpRatesAndDiscountCodes = Field2.aarpRatesAndDiscountCodes, search6 = Field2.search;
    return {
        pickUpLocation: {
            area: pickUpLocation
        },
        dropOffLocation: {
            area: dropOffLocation
        },
        dates: {
            area: dates
        },
        pickUpTime: {
            area: pickUpTime
        },
        dropOffTime: {
            area: dropOffTime
        },
        driverAgeCheck: {
            area: driverAgeCheck
        },
        search: {
            area: search6
        },
        specialRatesHeading: {
            area: specialRatesHeading
        },
        aarpRatesAndDiscountCodes: {
            area: aarpRatesAndDiscountCodes
        }
    };
};
// src/components/cars/form/__private/__fragments/driver-age-component.tsx
import React108 from "react";
import { gql as gql80 } from "@apollo/client";
// ../internal/src/components/common/egds-number-input.tsx
import React107 from "react";
import { gql as gql79 } from "@apollo/client";
import { UitkNumberInput } from "uitk-react-input";
var __Fragment55 = gql79(_templateObject83());
var EGDSNumberInputField = function(param) {
    var disabled = param.disabled, data = param.data, errorMessage = param.errorMessage, setFieldRefByTypename = param.setFieldRefByTypename;
    var label = data.label, value = data.value, egdsElementId = data.egdsElementId, placeholder = data.placeholder, step = data.step, max = data.max, min = data.min, __typename = data.__typename;
    var defaultValue = value === null ? void 0 : Number(value);
    var _React107_useState = _sliced_to_array(React107.useState(defaultValue), 2), numberInputValue = _React107_useState[0], setnumberInputValue = _React107_useState[1];
    var egdsNumberInputRef = React107.createRef();
    React107.useEffect(function() {
        if (setFieldRefByTypename && egdsNumberInputRef) {
            setFieldRefByTypename(__typename, egdsNumberInputRef);
        }
    }, []);
    var handleChange = function(event) {
        var newValue = event.target.value === "" ? void 0 : Number(event.target.value);
        setnumberInputValue(newValue);
    };
    return /* @__PURE__ */ React107.createElement(UitkNumberInput, {
        label: label !== null && label !== void 0 ? label : "",
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        name: egdsElementId ? "EGDSNumberInput-".concat(egdsElementId) : "",
        value: numberInputValue,
        step: step !== null && step !== void 0 ? step : void 0,
        max: max !== null && max !== void 0 ? max : void 0,
        min: min !== null && min !== void 0 ? min : void 0,
        onChange: handleChange,
        disabled: disabled,
        invalid: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "",
        domRef: egdsNumberInputRef
    });
};
EGDSNumberInputField.displayName = "EGDSNumberInputField";
EGDSNumberInputField.fragment = __Fragment55;
// src/components/cars/form/__private/__fragments/driver-age-component.tsx
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
var __Fragment56 = gql80(_templateObject84(), EGDSCheckBox.fragment, EGDSNumberInputField.fragment);
var CarSearchFormDriverAgeCheck = function(param) {
    var data = param.data, errorState = param.errorState, setFieldRefByTypename = param.setFieldRefByTypename, getCheckboxState = param.getCheckboxState;
    var label = data.label, driverAge = data.driverAge, driverAgeRequired = data.driverAgeRequired;
    var _React108_useState = _sliced_to_array(React108.useState(driverAgeRequired.state === "CHECKED" /* CHECKED */ ), 2), isChecked = _React108_useState[0], setIsChecked = _React108_useState[1];
    var handleCheckboxChange = function(event) {
        setIsChecked(event.target.checked);
        getCheckboxState(event.target.checked);
    };
    var validations2 = driverAge.validations, driverAgeTypename = driverAge.__typename;
    var driverAgeInputFieldError = getFieldError(errorState, driverAgeTypename);
    var getEGDSNumberInputFieldErrorMessage = function(element) {
        var ageInputValidations = element === null || element === void 0 ? void 0 : element.validations;
        if (driverAgeInputFieldError) {
            if (ageInputValidations === null || ageInputValidations === void 0 ? void 0 : ageInputValidations.ageRange) {
                var _validations2_find;
                var _validations2_find_errorMessage;
                return (_validations2_find_errorMessage = validations2 === null || validations2 === void 0 ? void 0 : (_validations2_find = validations2.find(function(validation) {
                    return validation.__typename === "EGDSRangeInputValidation";
                })) === null || _validations2_find === void 0 ? void 0 : _validations2_find.errorMessage) !== null && _validations2_find_errorMessage !== void 0 ? _validations2_find_errorMessage : "";
            }
            if (!(ageInputValidations === null || ageInputValidations === void 0 ? void 0 : ageInputValidations.ageRange)) {
                var _validations2_find1;
                var _validations2_find_errorMessage1;
                return (_validations2_find_errorMessage1 = validations2 === null || validations2 === void 0 ? void 0 : (_validations2_find1 = validations2.find(function(validation) {
                    return validation.__typename === "EGDSRequiredInputValidation";
                })) === null || _validations2_find1 === void 0 ? void 0 : _validations2_find1.errorMessage) !== null && _validations2_find_errorMessage1 !== void 0 ? _validations2_find_errorMessage1 : "";
            }
        }
        return "";
    };
    var errorText = isChecked ? getEGDSNumberInputFieldErrorMessage(driverAgeInputFieldError) : "";
    return /* @__PURE__ */ React108.createElement(React108.Fragment, null, /* @__PURE__ */ React108.createElement(UitkHeading6, {
        size: 7
    }, label), /* @__PURE__ */ React108.createElement(UitkLayoutGrid6, {
        columns: {
            small: 1,
            medium: [
                "max-content",
                "24x"
            ]
        },
        space: "three"
    }, /* @__PURE__ */ React108.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React108.createElement(EGDSCheckBox, {
        onChange: handleCheckboxChange,
        data: driverAgeRequired
    })), /* @__PURE__ */ React108.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React108.createElement("div", null, /* @__PURE__ */ React108.createElement(EGDSNumberInputField, {
        data: driverAge,
        errorMessage: errorText,
        disabled: !isChecked,
        setFieldRefByTypename: setFieldRefByTypename
    })))));
};
CarSearchFormDriverAgeCheck.fragment = __Fragment56;
CarSearchFormDriverAgeCheck.displayName = "CarSearchFormDriverAgeCheck";
// src/components/cars/form/__private/__fragments/rental-types-selector.tsx
import React109 from "react";
import { gql as gql81 } from "@apollo/client";
import { defaultViewSizes as defaultViewSizes5, useMediaQueries as useMediaQueries5 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex21, UitkLayoutFlexItem as UitkLayoutFlexItem18 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing33 } from "uitk-react-spacing";
var __Fragment57 = gql81(_templateObject85(), EGDSBasicTabs.fragment);
var RentalTypesSelector = function(props) {
    var viewportSize = useMediaQueries5({
        viewSizes: defaultViewSizes5
    });
    var isSmallViewportSize = viewportSize <= defaultViewSizes5.SMALL;
    return /* @__PURE__ */ React109.createElement(UitkSpacing33, {
        margin: {
            blockend: isSmallViewportSize ? "three" : "six"
        }
    }, /* @__PURE__ */ React109.createElement(UitkLayoutFlex21, {
        space: "three",
        alignItems: "start",
        wrap: "wrap"
    }, /* @__PURE__ */ React109.createElement(UitkLayoutFlexItem18, {
        minWidth: isSmallViewportSize ? "full_width" : void 0
    }, /* @__PURE__ */ React109.createElement("div", {
        "data-stid": "SearchFormRentalTypesSelector"
    }, /* @__PURE__ */ React109.createElement(EGDSBasicTabs, _object_spread({}, props))))));
};
RentalTypesSelector.fragment = __Fragment57;
RentalTypesSelector.displayName = "RentalTypesSelector";
// src/components/cars/form/__private/__fragments/cars-search-form.tsx
var __Fragment58 = gql82(_templateObject86(), CarSearchFormDriverAgeCheck.fragment, EGDSErrorSummary.fragment, CarSearchFormDiscountCode.fragment, EGDSSearchFormButton.fragment, EGDSPill.fragment, EGDSSearchPlayback.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSelect.fragment, RentalTypesSelector.fragment, SearchLocationFragment);
var DATE_RANGE_PICKER = FieldNameMap4.DATE_RANGE_PICKER, PICKUP_TIME = FieldNameMap4.PICKUP_TIME, DROPOFF_TIME = FieldNameMap4.DROPOFF_TIME;
var dateToString = function(date) {
    return date ? "".concat(date.year, "-").concat(date.month, "-").concat(date.day) : "";
};
var CarsSearchForm2 = function(props) {
    var _pickUpTime_options_find, _dropOffTime_options_find, _dates_action, _driverAgeCheck_driverAge_validations, _driverAgeCheck_driverAge;
    var onSubmit = props.onSubmit, onFieldChange = props.onFieldChange, onOpenLocationField = props.onOpenLocationField, data = props.data, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, autoOpenPlayback = props.autoOpenPlayback, autoSubmitOnFieldChange = props.autoSubmitOnFieldChange, stickyPlayback = props.stickyPlayback, criteria = props.criteria, hideDiscountCodes = props.hideDiscountCodes, additionalAdapterFields = props.additionalAdapterFields;
    var localizationContext = useLocalization14();
    var formatDateString = localizationContext.formatDateString;
    var egdsElementId = data.egdsElementId, actionURL = data.actionURL, search6 = data.search, driverAgeCheck = data.driverAgeCheck, errorSummary5 = data.errorSummary, specialRates = data.specialRates, localDateFormat = data.localDateFormat, playback = data.playback, pickUpLocation = data.pickUpLocation, dropOffLocation = data.dropOffLocation, alternativeDropOffLocationLabel = data.alternativeDropOffLocationLabel, dates = data.dates, pickUpTime = data.pickUpTime, dropOffTime = data.dropOffTime, searchLocation = data.searchLocation;
    var _React110_useState = _sliced_to_array(React110.useState(playback), 2), playbackData = _React110_useState[0], setPlaybackData = _React110_useState[1];
    var _React110_useState1 = _sliced_to_array(React110.useState({
        origin: pickUpLocation === null || pickUpLocation === void 0 ? void 0 : pickUpLocation.value,
        destination: dropOffLocation === null || dropOffLocation === void 0 ? void 0 : dropOffLocation.value
    }), 2), locationsData = _React110_useState1[0], setLocationsData = _React110_useState1[1];
    var _pickUpTime_options_find_label, _dropOffTime_options_find_label;
    var _React110_useState2 = _sliced_to_array(React110.useState({
        start: (_pickUpTime_options_find_label = (_pickUpTime_options_find = pickUpTime.options.find(function(time) {
            return time.selected;
        })) === null || _pickUpTime_options_find === void 0 ? void 0 : _pickUpTime_options_find.label) !== null && _pickUpTime_options_find_label !== void 0 ? _pickUpTime_options_find_label : void 0,
        end: (_dropOffTime_options_find_label = (_dropOffTime_options_find = dropOffTime.options.find(function(time) {
            return time.selected;
        })) === null || _dropOffTime_options_find === void 0 ? void 0 : _dropOffTime_options_find.label) !== null && _dropOffTime_options_find_label !== void 0 ? _dropOffTime_options_find_label : void 0
    }), 2), dateTimesData = _React110_useState2[0], setDateTimesData = _React110_useState2[1];
    var _React110_useState3 = _sliced_to_array(React110.useState((dates === null || dates === void 0 ? void 0 : (_dates_action = dates.action) === null || _dates_action === void 0 ? void 0 : _dates_action.__typename) === "EGDSOpenDatePickerAction" && dates.action.datePicker.__typename === "EGDSDateRangePicker" ? "".concat(dateToString(dates.action.datePicker.selectedStartDate), " - ").concat(dateToString(dates.action.datePicker.selectedEndDate)) : ""), 2), datesData = _React110_useState3[0], setDatesData = _React110_useState3[1];
    var _React110_useState4 = _sliced_to_array(React110.useState(false), 2), specialRatesSelected = _React110_useState4[0], setSpecialRatesSelected = _React110_useState4[1];
    var formRef = React110.useRef(null);
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search-car-form";
    var _React110_useState5 = _sliced_to_array(React110.useState({
        EGDSSearchFormLocationsField: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React110_useState5[0], setFieldsRefs = _React110_useState5[1];
    var initialErrorState2 = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var _React110_useState6 = _sliced_to_array(React110.useState(initialErrorState2), 2), errorState = _React110_useState6[0], setErrorState = _React110_useState6[1];
    var _React110_useState7 = _sliced_to_array(React110.useState(false), 2), driverAgeCheckboxState = _React110_useState7[0], setDriverAgeCheckboxState = _React110_useState7[1];
    var driverAgeRangeInputValidation = driverAgeCheck === null || driverAgeCheck === void 0 ? void 0 : (_driverAgeCheck_driverAge = driverAgeCheck.driverAge) === null || _driverAgeCheck_driverAge === void 0 ? void 0 : (_driverAgeCheck_driverAge_validations = _driverAgeCheck_driverAge.validations) === null || _driverAgeCheck_driverAge_validations === void 0 ? void 0 : _driverAgeCheck_driverAge_validations.find(function(element) {
        return element.__typename === "EGDSRangeInputValidation";
    });
    var minDriverAgeRange = (driverAgeRangeInputValidation === null || driverAgeRangeInputValidation === void 0 ? void 0 : driverAgeRangeInputValidation.__typename) === "EGDSRangeInputValidation" ? driverAgeRangeInputValidation.min : void 0;
    var maxDriverAgeRange = (driverAgeRangeInputValidation === null || driverAgeRangeInputValidation === void 0 ? void 0 : driverAgeRangeInputValidation.__typename) === "EGDSRangeInputValidation" ? driverAgeRangeInputValidation.max : void 0;
    var _React110_useState8 = _sliced_to_array(React110.useState(!autoOpenPlayback), 2), displayPlayback = _React110_useState8[0], setDisplayPlayback = _React110_useState8[1];
    var setFieldRefByTypename = React110.useCallback(function(typename, ref) {
        var _ref_current;
        var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typenameRef, ref));
        });
    }, []);
    var handlePlaybackToggle = function(open) {
        setDisplayPlayback(open);
    };
    var handleSpecialRatesChange = function() {
        setSpecialRatesSelected(!specialRatesSelected);
    };
    var handleRedirect = function(action, carSearchCriteria) {
        if (action.includes("car-rental" /* CAR_RENTAL */ ) || action.includes("cars.cartrawler" /* CAR_TRAWLER */ )) {
            window.location.href = getURLWithParamsForCarRent(action, carSearchCriteria);
            return;
        }
        if (action.includes("rent-a-car" /* RENT_A_CAR */ )) {
            window.location.href = getURLWithParamsForRentACar(action, carSearchCriteria);
            return;
        }
        var queryParams = getURLQueryParamsFromCarsCriteria(carSearchCriteria, {
            localDateFormat: localDateFormat,
            formatDateString: formatDateString
        });
        window.location.href = "".concat(action, "?").concat(queryParams);
    };
    var handleSubmit = function(event) {
        var formElements = Array.from(event.currentTarget.elements);
        var formElementsToValidate = {
            location: {
                origin: formElements.find(findFieldByNameAttribute("pick_up_location"))
            },
            dates: {
                startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-dates")),
                endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-dates")),
                config: {
                    maxNumberOfDaysSelected: 0
                }
            },
            time: {
                dropOff: formElements.find(findFieldByNameAttribute("EGDSBasicSelect-drop_off_time")),
                pickup: formElements.find(findFieldByNameAttribute("EGDSBasicSelect-pick_up_time"))
            },
            age: driverAgeCheckboxState ? {
                ageInput: formElements.find(findFieldByNameAttribute("EGDSNumberInput-driver_age")),
                config: {
                    min: minDriverAgeRange,
                    max: maxDriverAgeRange
                }
            } : void 0
        };
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
        var errorCount2 = fieldsWithErrors.length;
        var isFormValid = errorCount2 === 0;
        if (!isFormValid) {
            var _fieldsWithErrors_;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: errorCount2,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
            });
            event.preventDefault();
            return;
        }
        setErrorState(initialErrorState2);
        if (onSubmit || redirectToSearchResultOnSubmit) {
            var newCriteria = getCarSearchCriteria(event);
            var carSearchCriteria = _object_spread_props(_object_spread({}, newCriteria), {
                secondary: newCriteria.secondary && Object.keys(newCriteria.secondary).length > 0 ? newCriteria.secondary : _object_spread({}, criteria === null || criteria === void 0 ? void 0 : criteria.secondary)
            });
            if (onSubmit) {
                onSubmit(event, {
                    carSearchCriteria: carSearchCriteria
                });
            }
            if (redirectToSearchResultOnSubmit) {
                event.preventDefault();
                var action = event.currentTarget.action;
                handleRedirect(action, carSearchCriteria);
            }
        }
    };
    var getCheckboxState = function(checkState) {
        setDriverAgeCheckboxState(checkState);
    };
    var handleOnTypeaheadSelection = function(selection, isOrigin) {
        var _selection_data_regionNames, _selection_data;
        var fieldToUpdate = isOrigin ? "origin" : "destination";
        var _selection_data_regionNames_shortName;
        var fieldValue = (_selection_data_regionNames_shortName = (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : (_selection_data_regionNames = _selection_data.regionNames) === null || _selection_data_regionNames === void 0 ? void 0 : _selection_data_regionNames.shortName) !== null && _selection_data_regionNames_shortName !== void 0 ? _selection_data_regionNames_shortName : selection.term;
        var newLocationsData = _object_spread_props(_object_spread({}, locationsData), _define_property({}, fieldToUpdate, fieldValue));
        setLocationsData(newLocationsData);
        setPlaybackData(function(prevPlaybackState) {
            var _newLocationsData_origin, _newLocationsData_origin1, _newLocationsData_origin2, _newLocationsData_destination, _newLocationsData_destination1, _newLocationsData_destination2;
            if (!prevPlaybackState) {
                return null;
            }
            var primary = prevPlaybackState.primary, primaryTemplate = prevPlaybackState.primaryTemplate;
            var _newLocationsData_origin_trim;
            var playbackOrigin = ((_newLocationsData_origin = newLocationsData.origin) === null || _newLocationsData_origin === void 0 ? void 0 : _newLocationsData_origin.includes("(")) ? (_newLocationsData_origin1 = newLocationsData.origin) === null || _newLocationsData_origin1 === void 0 ? void 0 : _newLocationsData_origin1.split("(")[0].trim() : (_newLocationsData_origin_trim = (_newLocationsData_origin2 = newLocationsData.origin) === null || _newLocationsData_origin2 === void 0 ? void 0 : _newLocationsData_origin2.trim()) !== null && _newLocationsData_origin_trim !== void 0 ? _newLocationsData_origin_trim : "";
            var playbackDestination = ((_newLocationsData_destination = newLocationsData.destination) === null || _newLocationsData_destination === void 0 ? void 0 : _newLocationsData_destination.includes("(")) ? (_newLocationsData_destination1 = newLocationsData.destination) === null || _newLocationsData_destination1 === void 0 ? void 0 : _newLocationsData_destination1.split("(")[0].trim() : (_newLocationsData_destination2 = newLocationsData.destination) === null || _newLocationsData_destination2 === void 0 ? void 0 : _newLocationsData_destination2.trim();
            if (!playbackDestination) {
                return _object_spread_props(_object_spread({}, prevPlaybackState), {
                    primary: _object_spread_props(_object_spread({}, primary), {
                        text: playbackOrigin
                    })
                });
            }
            var originTemplateModel = "origin";
            var destinationTemplateModel = "destination";
            var locationsTemplate = primaryTemplate === null || primaryTemplate === void 0 ? void 0 : primaryTemplate.text;
            var originFilledTemplate = formatLocalizedTokenString(locationsTemplate, originTemplateModel, playbackOrigin);
            var newPrimary = _object_spread_props(_object_spread({}, primary), {
                text: formatLocalizedTokenString(originFilledTemplate, destinationTemplateModel, playbackDestination)
            });
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary
            });
        });
    };
    var handleFieldChange = function(field, event) {
        var name = field.name, text = field.value;
        if (onFieldChange) {
            onFieldChange(field, event);
        }
        if (autoSubmitOnFieldChange) {
            var _formRef_current;
            (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.dispatchEvent(new Event("submit", {
                cancelable: true,
                bubbles: true
            }));
        }
        var isDateRangePicker = name === DATE_RANGE_PICKER;
        var isPickUpTime = name === PICKUP_TIME;
        var isDropOffTime = name === DROPOFF_TIME;
        if (isDateRangePicker || isPickUpTime || isDropOffTime) {
            var newDatesData = isDateRangePicker ? text : datesData;
            var newDateTimesData = _object_spread({}, dateTimesData);
            if (isDateRangePicker) {
                setDatesData(newDatesData);
            } else {
                if (isPickUpTime && (pickUpTime === null || pickUpTime === void 0 ? void 0 : pickUpTime.__typename) === "EGDSBasicSelect") {
                    var _pickUpTime_options_find;
                    newDateTimesData.start = (_pickUpTime_options_find = pickUpTime.options.find(function(time) {
                        return time.value === text;
                    })) === null || _pickUpTime_options_find === void 0 ? void 0 : _pickUpTime_options_find.label;
                } else if (isDropOffTime && (dropOffTime === null || dropOffTime === void 0 ? void 0 : dropOffTime.__typename) === "EGDSBasicSelect") {
                    var _dropOffTime_options_find;
                    newDateTimesData.end = (_dropOffTime_options_find = dropOffTime.options.find(function(time) {
                        return time.value === text;
                    })) === null || _dropOffTime_options_find === void 0 ? void 0 : _dropOffTime_options_find.label;
                }
                setDateTimesData(newDateTimesData);
            }
            setPlaybackData(function(prevPlaybackState) {
                if (!prevPlaybackState) {
                    return null;
                }
                var _prevPlaybackState_secondaries = _sliced_to_array(prevPlaybackState.secondaries, 1), datesSecondary = _prevPlaybackState_secondaries[0];
                if (datesSecondary.__typename === "EGDSPlainText") {
                    var newSecondaryDates = _object_spread_props(_object_spread({}, datesSecondary), {
                        text: getFormattedDates(newDatesData, localizationContext, newDateTimesData)
                    });
                    return _object_spread_props(_object_spread({}, prevPlaybackState), {
                        secondaries: [
                            newSecondaryDates
                        ]
                    });
                }
                return prevPlaybackState;
            });
        }
        setDisplayPlayback(true);
    };
    var refProps = {
        setFieldRefByTypename: setFieldRefByTypename
    };
    var locationFieldCommonProps = _object_spread_props(_object_spread({}, refProps), {
        additionalAdapterFields: additionalAdapterFields,
        onOpenLocationField: onOpenLocationField,
        searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
    });
    var pickUpLocationField = pickUpLocation && /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, locationFieldCommonProps), {
        data: pickUpLocation,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormLocationFieldPickUp";
        }),
        onSelection: function(selection) {
            return handleOnTypeaheadSelection(selection, true);
        }
    })));
    var dropOffLocationField = dropOffLocation && /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, locationFieldCommonProps), {
        data: dropOffLocation,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormLocationFieldDropOff";
        }),
        alternativeLocationLabel: alternativeDropOffLocationLabel,
        onSelection: function(selection) {
            return handleOnTypeaheadSelection(selection, false);
        },
        onDismissLocation: function(selection) {
            return handleOnTypeaheadSelection(selection, false);
        },
        skipReflection: true
    })));
    var datesField = dates && /* @__PURE__ */ React110.createElement(EGDSSearchFormDatePickerField, _object_spread_props(_object_spread({}, refProps), {
        data: dates
    }));
    var pickUpTimeField = pickUpTime && /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(EGDSSelect, _object_spread_props(_object_spread({
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSBasicSelectPickUp";
        })
    }, refProps), {
        data: pickUpTime
    })));
    var dropOffTimeField = dropOffTime && /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(EGDSSelect, _object_spread_props(_object_spread({
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSBasicSelectDropOff";
        })
    }, refProps), {
        data: dropOffTime
    })));
    var searchButton = (search6 === null || search6 === void 0 ? void 0 : search6.__typename) === "EGDSSearchFormButton" && /* @__PURE__ */ React110.createElement(UitkLayoutGrid7, {
        autoRows: [
            "max-content"
        ]
    }, /* @__PURE__ */ React110.createElement(EGDSSearchFormButton, {
        data: search6
    }));
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var includesDriverAgeCheck = !!driverAgeCheck;
    var includeAarpRates = !!(specialRates === null || specialRates === void 0 ? void 0 : specialRates.showAarpRate) && !hideDiscountCodes;
    var includeDiscountCodes = !!(specialRates === null || specialRates === void 0 ? void 0 : specialRates.discountCode) && !hideDiscountCodes;
    var gridProps = getGridPropsByLayout({
        includeAarpRates: includeAarpRates,
        includeDiscountCodes: includeDiscountCodes,
        includesDriverAgeCheck: includesDriverAgeCheck
    });
    var fieldsGridItemProps = getFieldsGridItemPropsByLayout();
    var form = /* @__PURE__ */ React110.createElement(UitkForm8, {
        ref: formRef,
        id: id,
        name: id,
        method: "GET",
        action: actionURL,
        onFieldChange: handleFieldChange,
        hasRequiredFieldIndicator: true,
        onSubmit: handleSubmit
    }, displayErrorSummary && errorSummary5 && /* @__PURE__ */ React110.createElement(UitkSpacing34, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }))), /* @__PURE__ */ React110.createElement(UitkLayoutGrid7, _object_spread({}, gridProps), /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.pickUpLocation), pickUpLocationField), /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.dropOffLocation), dropOffLocationField), /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.dates), /* @__PURE__ */ React110.createElement("div", null, datesField)), /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.pickUpTime), /* @__PURE__ */ React110.createElement("div", null, pickUpTimeField)), /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.dropOffTime), /* @__PURE__ */ React110.createElement("div", null, dropOffTimeField)), includesDriverAgeCheck && /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.driverAgeCheck), /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(CarSearchFormDriverAgeCheck, {
        data: driverAgeCheck,
        setFieldRefByTypename: setFieldRefByTypename,
        errorState: errorState,
        getCheckboxState: getCheckboxState
    }))), !hideDiscountCodes && /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.aarpRatesAndDiscountCodes), /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(UitkLayoutFlex22, {
        space: "three"
    }, (specialRates === null || specialRates === void 0 ? void 0 : specialRates.showAarpRate) && !hideDiscountCodes && /* @__PURE__ */ React110.createElement(UitkLayoutFlexItem19, null, /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(EGDSPill, {
        data: specialRates.showAarpRate,
        active: specialRatesSelected,
        onChange: handleSpecialRatesChange
    }))), (specialRates === null || specialRates === void 0 ? void 0 : specialRates.discountCode) && !hideDiscountCodes && /* @__PURE__ */ React110.createElement(UitkLayoutFlexItem19, null, /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(CarSearchFormDiscountCode, {
        data: specialRates.discountCode
    })))))), searchButton && /* @__PURE__ */ React110.createElement(UitkLayoutGridItem6, _object_spread({}, fieldsGridItemProps.search), /* @__PURE__ */ React110.createElement("div", null, searchButton))));
    return /* @__PURE__ */ React110.createElement(Viewport27, null, /* @__PURE__ */ React110.createElement(ViewSmall25, null, playbackData ? /* @__PURE__ */ React110.createElement(EGDSSearchPlayback, {
        data: playbackData,
        stickyPlayback: stickyPlayback,
        display: displayPlayback,
        onDisplayToggle: handlePlaybackToggle
    }, form) : form), /* @__PURE__ */ React110.createElement(ViewMedium24, null, form));
};
CarsSearchForm2.fragment = __Fragment58;
CarsSearchForm2.displayName = "CarsSearchForm";
// src/components/cars/form/client-events.ts
import { SystemEvent as SystemEvent7, SystemEventLevel as SystemEventLevel7 } from "@shared-ui/logger-context";
var CLIENT_EVENTS5 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_CARS_SEARCH_FORM_QUERY_FAILURE: new SystemEvent7(SystemEventLevel7.ERROR, "SEARCH_TOOLS_CARS_SEARCH_FORM_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS4 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_CARS_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Cars Search Form Fallback Presented",
        referrerId: "Web.Cars.Search.Form.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_CARS_SEARCH_FORM_IMPRESSION: {
        linkName: "Cars Search Form Presented",
        referrerId: "Web.Cars.Search.Form.Presented"
    }
};
// src/components/cars/form/cars-search-form.tsx
var __Query7 = gql83(_templateObject87(), CarsSearchForm2.fragment);
var smallViewportFormSkeletonProps2 = {
    rows: [
        {
            type: "secondary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        }
    ]
};
var mediumViewportFormSkeletonProps2 = {
    rows: [
        {
            type: "secondary"
        },
        {
            type: "primary"
        }
    ]
};
var CarsSearchForm = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, batchKey = props.batchKey, includePlayback = props.includePlayback, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, sticky = props.sticky;
    var context = useBexApi11().context;
    var systemEvents = useLoggerEvents6(CLIENT_EVENTS5);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: Boolean(includePlayback)
    });
    var _useQuery7 = useQuery7(__Query7, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery
    }), currentData = _useQuery7.data, error = _useQuery7.error, loading = _useQuery7.loading, previousData = _useQuery7.previousData;
    var _useState2 = _sliced_to_array(useState2("car_search_form_rental_types_option_car" /* CAR */ ), 2), rentalTypeSelected = _useState2[0], setRentalType = _useState2[1];
    if (loading && !previousData) {
        return /* @__PURE__ */ React111.createElement(Viewport28, null, /* @__PURE__ */ React111.createElement(ViewSmall26, null, /* @__PURE__ */ React111.createElement(FormSkeleton, _object_spread({}, smallViewportFormSkeletonProps2))), /* @__PURE__ */ React111.createElement(ViewMedium25, null, /* @__PURE__ */ React111.createElement(FormSkeleton, _object_spread({}, mediumViewportFormSkeletonProps2))));
    }
    var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
    if (error || !data || (data === null || data === void 0 ? void 0 : data.searchForm.car.__typename) !== "CarSearchForm") {
        systemEvents.SEARCH_TOOLS_CARS_SEARCH_FORM_QUERY_FAILURE.log({
            name: error === null || error === void 0 ? void 0 : error.name,
            error: new Error(error === null || error === void 0 ? void 0 : error.message)
        });
        return /* @__PURE__ */ React111.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React111.createElement(IntersectionTracker6, _object_spread({}, CLIENT_TRACKING_EVENTS4.SEARCH_TOOLS_CARS_SEARCH_FORM_FALLBACK_IMPRESSION), /* @__PURE__ */ React111.createElement(CarsSearchForm2, _object_spread_props(_object_spread({}, props), {
            data: fallbackData,
            criteria: inputs.carSearchCriteria
        }))));
    }
    var onTabSelected = function(tabId) {
        setRentalType(tabId === "car_search_form_rental_types_option_gt" /* GROUND_TRANSPORTATION */  ? "car_search_form_rental_types_option_gt" /* GROUND_TRANSPORTATION */  : "car_search_form_rental_types_option_car" /* CAR */ );
    };
    var baseForm = /* @__PURE__ */ React111.createElement(React111.Fragment, null, (data === null || data === void 0 ? void 0 : data.searchForm.car.__typename) === "CarSearchForm" && data.searchForm.car.rentalTypes && /* @__PURE__ */ React111.createElement(RentalTypesSelector, {
        onTabSelected: onTabSelected,
        data: data.searchForm.car.rentalTypes
    }), rentalTypeSelected === "car_search_form_rental_types_option_car" /* CAR */  ? /* @__PURE__ */ React111.createElement(IntersectionTracker6, _object_spread({}, CLIENT_TRACKING_EVENTS4.SEARCH_TOOLS_CARS_SEARCH_FORM_IMPRESSION), /* @__PURE__ */ React111.createElement(CarsSearchForm2, _object_spread_props(_object_spread({}, props), {
        data: data === null || data === void 0 ? void 0 : data.searchForm.car,
        criteria: inputs.carSearchCriteria
    }))) : /* @__PURE__ */ React111.createElement(GroundTransportationSearchForm2, {
        inputs: {
            groundTransportationSearchCriteria: null
        },
        redirectToSearchResultOnSubmit: true
    }));
    return sticky ? /* @__PURE__ */ React111.createElement("div", {
        "data-stid": "search-form-sticky"
    }, /* @__PURE__ */ React111.createElement(Viewport28, null, /* @__PURE__ */ React111.createElement(ViewSmall26, null, /* @__PURE__ */ React111.createElement("div", null, baseForm)), /* @__PURE__ */ React111.createElement(ViewMedium25, null, /* @__PURE__ */ React111.createElement(StickySearchForm, null, baseForm)))) : baseForm;
};
CarsSearchForm.displayName = "sharedui-CarsSearchForm";
// src/components/activity/form/activity-search-form.tsx
import React116 from "react";
import { gql as gql88, useQuery as useQuery8 } from "@apollo/client";
import { useBexApi as useBexApi12 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents7 } from "@shared-ui/logger-context";
import { ViewMedium as ViewMedium27, Viewport as Viewport30, ViewSmall as ViewSmall28 } from "@shared-ui/viewport-context";
// src/components/activity/utils/fallback-form-data.ts
var errorSummary3 = {
    egdsElementId: "search_form_error_summary",
    goToErrorLinkText: "Go to error",
    goToFirstErrorLinkText: "Go to first error",
    heading: "",
    body: null,
    analytics: {
        linkName: "Error summary link clicked",
        referrerId: "Web.Activity.Search.Error.Summary",
        __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
        linkName: "Error summary displayed",
        referrerId: "Web.Activity.Search.Error.Summary.Displayed",
        __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
        models: [
            {
                key: "errorCount",
                source: "errorCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "Please correct the error to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            }
        ],
        __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
};
var search3 = {
    egdsElementId: "search_button",
    primary: "Search",
    disabled: false,
    accessibility: "Search",
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.Activity.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var destination2 = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "destination_form_field",
    label: "Going to",
    placeholder: "Going to",
    value: null,
    errorMessage: "Please select a destination",
    validations: [
        {
            errorMessage: "Please select a destination",
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Location selection",
            referrerId: "Web.Activity.Location.Open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "Homepage",
            drivable: false,
            isDestination: true,
            lineOfBusiness: "ACTIVITIES",
            maxNumberOfResults: 10,
            packageType: null,
            personalize: true,
            regionType: 286,
            typeaheadFeatures: "consistent_display|lxcategory",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: null,
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "Search by destination",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
        linkName: "Location close",
        referrerId: "Web.Activity.Location.Close",
        __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
        linkName: "Location change",
        referrerId: "Web.Activity.Location.Change",
        __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
};
var today3 = /* @__PURE__ */ new Date();
var startDate3 = new Date(today3.getFullYear(), today3.getMonth(), today3.getDate() + 14);
var endDate3 = new Date(startDate3.getFullYear(), startDate3.getMonth(), startDate3.getDate() + 1);
var validDaysUpperInclusive2 = new Date(today3.getFullYear(), today3.getMonth(), today3.getDate() + 328);
var startDatePickerMonthValue3 = startDate3.getMonth() + 1;
var endDatePickerMonthValue3 = endDate3.getMonth() + 1;
var datePicker3 = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date_form_field",
    label: "Dates",
    placeholder: "Dates",
    errorMessage: "End date must be after start date",
    validations: [
        {
            errorMessage: "Dates must be no more than 14 days apart",
            __typename: "EGDSMaxLengthInputValidation"
        },
        {
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    action: {
        accessibility: null,
        analytics: {
            linkName: "Calendar selection",
            referrerId: "Web.Activity.Calendar.Open",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            flexibleDateContent: null,
            buttonText: "Done",
            buttonTextTemplate: null,
            clearButtonText: null,
            firstDayOfWeek: "SUN" /* SUN */ ,
            maxNumberOfDaysSelected: 14,
            sameDaySelectionAllowed: true,
            selectedStartDate: {
                day: startDate3.getDate(),
                month: startDatePickerMonthValue3,
                year: startDate3.getFullYear(),
                __typename: "Date"
            },
            startDatePlaceholderText: "Check-in",
            selectedEndDate: {
                day: endDate3.getDate(),
                month: endDatePickerMonthValue3,
                year: endDate3.getFullYear(),
                __typename: "Date"
            },
            endDatePlaceholderText: "Check-out",
            validDaysLowerBoundInclusive: {
                day: today3.getDate(),
                month: today3.getMonth(),
                year: today3.getFullYear(),
                __typename: "Date"
            },
            validDaysUpperBoundInclusive: {
                day: validDaysUpperInclusive2.getDate(),
                month: validDaysUpperInclusive2.getMonth(),
                year: validDaysUpperInclusive2.getFullYear(),
                __typename: "Date"
            },
            submitButtonAnalytics: {
                linkName: "Calendar submit",
                referrerId: "Web.Activity.Calendar.Submit",
                __typename: "ClientSideAnalytics"
            },
            nextButtonAnalytics: {
                linkName: "Calendar next",
                referrerId: "Web.Activity.Calendar.Next.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            previousButtonAnalytics: {
                linkName: "Calendar previous",
                referrerId: "Web.Activity.Calendar.Previous.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            startDateButtonAnalytics: {
                linkName: "Calendar start",
                referrerId: "Web.Activity.Calendar.Start.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            endDateButtonAnalytics: {
                linkName: "Calendar end",
                referrerId: "Web.Activity.Calendar.End.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            clearDatesButtonAnalytics: null,
            showClearDatesButton: false,
            __typename: "EGDSDateRangePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var getFallbackData3 = function() {
    return {
        __typename: "ActivitySearchForm",
        egdsElementId: "activity-search-form",
        actionURL: "/things-to-do/search",
        errorSummary: errorSummary3,
        elements: [
            destination2,
            datePicker3
        ],
        search: search3,
        playback: null,
        subTitle: null,
        searchLocation: searchLocationFallback
    };
};
// src/components/activity/form/__private/activity-search-form.tsx
import React115 from "react";
import { gql as gql87 } from "@apollo/client";
import { useLocalization as useLocalization15 } from "@shared-ui/localization-context";
// ../internal/src/components/common/egds-text/egds-spannable-text.tsx
import React114, { Fragment as Fragment2 } from "react";
import { gql as gql86 } from "@apollo/client";
// ../internal/src/components/common/egds-text/egds-plain-text.tsx
import React112 from "react";
import { gql as gql84 } from "@apollo/client";
import { UitkText as UitkText9 } from "uitk-react-text";
var fragment5 = gql84(_templateObject88());
var EGDSPlainText = function(param) {
    var data = param.data, inline = param.inline, size = param.size;
    return /* @__PURE__ */ React112.createElement(UitkText9, {
        inline: inline,
        size: size
    }, data.text);
};
EGDSPlainText.fragment = fragment5;
EGDSPlainText.displayName = "EGDSParagraph";
// ../internal/src/components/common/egds-text/egds-spannable-text-inline-content.tsx
import React113 from "react";
import { gql as gql85 } from "@apollo/client";
var __Fragment59 = gql85(_templateObject89(), EGDSPlainText.fragment, EGDSStandardLink.fragment);
var EGDSSpannableTextInlineContent = function(param) {
    var data = param.data, inline = param.inline;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React113.createElement(EGDSPlainText, {
                data: data,
                inline: true
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React113.createElement(EGDSStandardLink, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextInlineContent.fragment = __Fragment59;
EGDSSpannableTextInlineContent.displayName = "EGDSSpannableTextInlineContent";
// ../internal/src/components/common/egds-text/egds-spannable-text.tsx
var __Fragment60 = gql86(_templateObject90(), EGDSPlainText.fragment, EGDSStandardLink.fragment);
var EGDSSpannableText = function(param) {
    var data = param.data;
    var _data_inlineContent;
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
        var _data_inlineContent1;
        return /* @__PURE__ */ React114.createElement("div", {
            "data-stid": "egds-spannable-text"
        }, data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.map(function(item, index) {
            return /* @__PURE__ */ React114.createElement(Fragment2, {
                key: "inline-content-".concat(index)
            }, /* @__PURE__ */ React114.createElement(EGDSSpannableTextInlineContent, {
                data: item
            }), " ");
        }));
    }
    return null;
};
EGDSSpannableText.displayName = "EGDSSpannableTextFragment";
EGDSSpannableText.fragment = _object_spread_props(_object_spread({}, __Fragment60), {
    __typename: "EGDSSpannableText"
});
// src/components/activity/form/__private/activity-search-form.tsx
import { ViewLarge as ViewLarge10, ViewMedium as ViewMedium26, Viewport as Viewport29, ViewSizes as ViewSizes9, ViewSmall as ViewSmall27 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm9 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex23, UitkLayoutFlexItem as UitkLayoutFlexItem20 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing35 } from "uitk-react-spacing";
import { UitkSubheading } from "uitk-react-text";
// src/components/activity/utils/fields-map.ts
var FieldNameMap5 = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["DESTINATION"] = "destination_form_field";
    FieldNameMap8["TRAVEL_DATES"] = "EGDSDateRangePicker";
    return FieldNameMap8;
}(FieldNameMap5 || {});
// src/components/activity/utils/search-criteria.ts
var activityCriteriaReducer = function(criteria, param) {
    var name = param.name, value = param.value;
    var primary = criteria.primary;
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination"))) {
        return {
            primary: _object_spread_props(_object_spread({}, primary), {
                destination: _object_spread_props(_object_spread({}, primary.destination), {
                    regionName: value
                })
            })
        };
    }
    if (name.startsWith(REGION_ID_NAME_PREFIX)) {
        return {
            primary: _object_spread_props(_object_spread({}, primary), {
                destination: _object_spread_props(_object_spread({}, primary.destination), {
                    regionId: value
                })
            })
        };
    }
    if (name.startsWith(LAT_NAME_PREFIX) || name.startsWith(LONG_NAME_PREFIX)) {
        var isLat = name.startsWith("".concat(LAT_NAME_PREFIX));
        var latitude = isLat ? Number(value) : null;
        var longitude = !isLat ? Number(value) : null;
        var coordinates = latitude && longitude ? {
            latitude: latitude,
            longitude: longitude
        } : null;
        return {
            primary: _object_spread_props(_object_spread({}, primary), {
                destination: _object_spread_props(_object_spread({}, primary.destination), {
                    coordinates: coordinates
                })
            })
        };
    }
    var isStartDate = name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX);
    var isEndDate = name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX);
    if (isStartDate || isEndDate) {
        var _criteria_primary_dateRange, _criteria_primary_dateRange1;
        var _value_split_map = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var defaultDate = {
            day: 0,
            month: 0,
            year: 0
        };
        var newDate = {
            day: day,
            month: month,
            year: year
        };
        return {
            primary: _object_spread_props(_object_spread({}, criteria.primary), {
                dateRange: {
                    startDate: isStartDate ? newDate : ((_criteria_primary_dateRange = criteria.primary.dateRange) === null || _criteria_primary_dateRange === void 0 ? void 0 : _criteria_primary_dateRange.startDate) || defaultDate,
                    endDate: isEndDate ? newDate : ((_criteria_primary_dateRange1 = criteria.primary.dateRange) === null || _criteria_primary_dateRange1 === void 0 ? void 0 : _criteria_primary_dateRange1.endDate) || defaultDate
                }
            })
        };
    }
    return _object_spread({}, criteria);
};
var getActivitySearchCriteriaFromInputs = function(elements) {
    var EGDS_PREFIX2 = "EGDS";
    var inputs = elements.filter(function(element) {
        return element.name.startsWith(EGDS_PREFIX2);
    });
    var criteria = {
        primary: {},
        secondary: {}
    };
    return inputs.reduce(activityCriteriaReducer, criteria);
};
// src/components/activity/form/__private/layout-field-config.ts
import { ViewSizes as ViewSizes8 } from "@shared-ui/viewport-context";
var defaultFieldConfig = {
    grow: 1,
    minWidth: "zero",
    maxWidth: "full_width"
};
var defaultViewportConfig = {
    EGDSSearchFormLocationField: defaultFieldConfig,
    EGDSSearchFormDatePickerField: defaultFieldConfig,
    EGDSSearchFormButton: {
        grow: 0
    },
    default: defaultFieldConfig
};
var _obj8;
var layoutFieldConfigViewportMapping2 = (_obj8 = {}, _define_property(_obj8, ViewSizes8.SMALL, _object_spread_props(_object_spread({}, defaultViewportConfig), {
    EGDSSearchFormLocationField: _object_spread_props(_object_spread({}, defaultFieldConfig), {
        minWidth: "full_width"
    }),
    EGDSSearchFormDatePickerField: {
        minWidth: "full_width"
    },
    EGDSSearchFormButton: {
        grow: 1
    }
})), _define_property(_obj8, ViewSizes8.MEDIUM, _object_spread_props(_object_spread({}, defaultViewportConfig), {
    EGDSSearchFormLocationField: _object_spread_props(_object_spread({}, defaultFieldConfig), {
        minWidth: "third_width"
    }),
    EGDSSearchFormDatePickerField: {
        grow: 1,
        minWidth: "third_width"
    }
})), _define_property(_obj8, ViewSizes8.LARGE, defaultViewportConfig), _define_property(_obj8, ViewSizes8.EXTRA_LARGE, defaultViewportConfig), _obj8);
var getFlexItemPropsByFieldType2 = function(fieldTypename, viewportSize) {
    var componentPropsMappingByViewport = layoutFieldConfigViewportMapping2[viewportSize];
    var _componentPropsMappingByViewport_fieldTypename;
    return (_componentPropsMappingByViewport_fieldTypename = componentPropsMappingByViewport[fieldTypename]) !== null && _componentPropsMappingByViewport_fieldTypename !== void 0 ? _componentPropsMappingByViewport_fieldTypename : componentPropsMappingByViewport.default;
};
// src/components/activity/form/__private/activity-search-form.tsx
var fieldComponents4 = [
    EGDSSearchFormLocationField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormButton
];
var __Fragment61 = gql87(_templateObject91(), EGDSErrorSummary.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormButton.fragment, EGDSSearchPlayback.fragment, EGDSSpannableText.fragment, SearchLocationFragment);
var FormFieldsLayout = function(props) {
    var viewSize = props.viewSize, fields = props.fields, errorState = props.errorState, defaultValidationProps = props.defaultValidationProps;
    return /* @__PURE__ */ React115.createElement(UitkLayoutFlex23, {
        alignContent: "end",
        alignItems: "start",
        justifyContent: "center",
        wrap: "wrap",
        space: "three"
    }, fields.map(function(element, index) {
        var __typename = element.__typename;
        var FieldComponent = fieldComponents4.find(function(param) {
            var displayName = param.displayName;
            return displayName === __typename;
        });
        if (!FieldComponent) {
            return null;
        }
        var flexItemProps = getFlexItemPropsByFieldType2(__typename, viewSize);
        var fieldError = errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === __typename;
        });
        var validationProps = _object_spread_props(_object_spread({}, defaultValidationProps), {
            fieldError: fieldError
        });
        var fieldComponentProps = _object_spread({}, props, validationProps);
        return /* @__PURE__ */ React115.createElement(UitkLayoutFlexItem20, _object_spread({
            key: "field_".concat(__typename, "_").concat(index)
        }, flexItemProps), /* @__PURE__ */ React115.createElement("div", null, /* @__PURE__ */ React115.createElement(FieldComponent, _object_spread_props(_object_spread({}, fieldComponentProps), {
            data: element
        }))));
    }));
};
var ActivitySearchForm2 = function(props) {
    var _datePickerField_action;
    var data = props.data, onFieldChange = props.onFieldChange, onSubmit = props.onSubmit, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, autoOpenPlayback = props.autoOpenPlayback, stickyPlayback = props.stickyPlayback, autoSubmitOnFieldChange = props.autoSubmitOnFieldChange, skipQuery = props.skipQuery;
    var localizationContext = useLocalization15();
    var _React115_useState = _sliced_to_array(React115.useState({
        EGDSSearchFormLocationField: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React115_useState[0], setFieldsRefs = _React115_useState[1];
    var formRef = React115.useRef(null);
    var defaultErrorState2 = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var _React115_useState1 = _sliced_to_array(React115.useState(defaultErrorState2), 2), errorState = _React115_useState1[0], setErrorState = _React115_useState1[1];
    var egdsElementId = data.egdsElementId, elements = data.elements, search6 = data.search, actionURL = data.actionURL, errorSummary5 = data.errorSummary, playback = data.playback, subTitle = data.subTitle, searchLocation = data.searchLocation;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search-activity-form";
    var renderableElements = search6 ? _to_consumable_array(elements).concat([
        search6
    ]) : elements;
    var _React115_useState2 = _sliced_to_array(React115.useState(!autoOpenPlayback), 2), displayPlayback = _React115_useState2[0], setDisplayPlayback = _React115_useState2[1];
    var _React115_useState3 = _sliced_to_array(React115.useState(playback), 2), playbackData = _React115_useState3[0], setPlaybackData = _React115_useState3[1];
    React115.useEffect(function() {
        if (playback && !skipQuery) {
            setPlaybackData(playback);
        }
    }, [
        playback,
        skipQuery
    ]);
    var handlePlaybackToggle = function(open) {
        setDisplayPlayback(open);
    };
    var setFieldRefByTypename = React115.useCallback(function(typename, ref) {
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typename, ref));
        });
    }, []);
    var defaultValidationProps = {
        setFieldRefByTypename: setFieldRefByTypename
    };
    var datePickerField = elements.find(function(element) {
        return element.__typename === "EGDSSearchFormDatePickerField";
    });
    var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
    var maxNumberOfDaysSelected = (datePickerField === null || datePickerField === void 0 ? void 0 : datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
    var getUpdatedSecondaries = function(isDateRangePicker, prevSecondaries, text) {
        var hasPrevDates = prevSecondaries.length > 1;
        var defaultDate = {
            __typename: "EGDSPlainText",
            accessibility: null,
            text: ""
        };
        if (isDateRangePicker) {
            var dates = getFormattedDates(text, localizationContext);
            if (hasPrevDates) {
                return [
                    _object_spread_props(_object_spread({}, defaultDate), {
                        text: dates
                    }),
                    prevSecondaries[1]
                ];
            }
            return [
                _object_spread_props(_object_spread({}, defaultDate), {
                    text: dates
                })
            ];
        }
        return _to_consumable_array(prevSecondaries);
    };
    var handleFieldChange = function(field, event) {
        if (onFieldChange) {
            onFieldChange(field, event);
        }
        if (autoSubmitOnFieldChange) {
            var _formRef_current;
            (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.dispatchEvent(new Event("submit", {
                cancelable: true,
                bubbles: true
            }));
        }
        setPlaybackData(function(prevPlaybackState) {
            var DESTINATION = FieldNameMap5.DESTINATION, TRAVEL_DATES = FieldNameMap5.TRAVEL_DATES;
            var name = field.name, text = field.value;
            var isDestination = name === DESTINATION;
            var isDateRangePicker = name === TRAVEL_DATES;
            if (!prevPlaybackState) {
                return null;
            }
            if (!isDateRangePicker && !isDestination) {
                return _object_spread({}, prevPlaybackState);
            }
            var primary = prevPlaybackState.primary, prevSecondaries = prevPlaybackState.secondaries;
            var newPrimary = isDestination ? _object_spread_props(_object_spread({}, primary), {
                text: text
            }) : primary;
            var secondaries = getUpdatedSecondaries(isDateRangePicker, prevSecondaries, text);
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary,
                secondaries: secondaries
            });
        });
        setDisplayPlayback(true);
    };
    var handleSubmit = function(event) {
        setErrorState(defaultErrorState2);
        var formElements = Array.from(event.currentTarget.elements);
        var formElementsToValidate = {
            location: {
                destination: formElements.find(findFieldByNameAttribute("destination_form_field"))
            },
            dates: {
                startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date_form_field")),
                endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date_form_field")),
                config: {
                    maxNumberOfDaysSelected: maxNumberOfDaysSelected
                }
            }
        };
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
        var errorCount2 = fieldsWithErrors.length;
        var isFormValid = errorCount2 === 0;
        if (!isFormValid) {
            var _fieldsWithErrors_;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: errorCount2,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
            });
            event.preventDefault();
            return;
        }
        var elementsOnSubmit = Array.from(event.currentTarget.elements);
        var activitySearchCriteria = getActivitySearchCriteriaFromInputs(elementsOnSubmit);
        if (onSubmit) {
            onSubmit(event, {
                activitySearchCriteria: activitySearchCriteria
            });
        }
        if (redirectToSearchResultOnSubmit) {
            event.preventDefault();
            var queryParams = getSearchToolsQueryParams("ACTIVITIES" /* ACTIVITIES */ , elementsOnSubmit);
            window.location.href = "".concat(event.currentTarget.action).concat(queryParams);
        }
    };
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var showErrorSummary = errorSummary5 && displayErrorSummary;
    var fieldsProps = _object_spread_props(_object_spread({}, props), {
        viewSize: ViewSizes9.SMALL,
        fields: renderableElements,
        errorState: errorState,
        defaultValidationProps: defaultValidationProps,
        searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
    });
    return /* @__PURE__ */ React115.createElement(UitkForm9, {
        ref: formRef,
        id: id,
        name: id,
        method: "GET",
        action: actionURL,
        onFieldChange: handleFieldChange,
        onSubmit: handleSubmit,
        hasRequiredFieldIndicator: true
    }, subTitle && /* @__PURE__ */ React115.createElement(UitkSpacing35, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React115.createElement(UitkSubheading, {
        tag: "p"
    }, subTitle ? /* @__PURE__ */ React115.createElement(EGDSSpannableText, {
        data: subTitle
    }) : "")), showErrorSummary && /* @__PURE__ */ React115.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }), /* @__PURE__ */ React115.createElement(UitkSpacing35, {
        margin: {
            blockstart: showErrorSummary ? "two" : void 0
        }
    }, /* @__PURE__ */ React115.createElement("div", null, /* @__PURE__ */ React115.createElement(Viewport29, null, /* @__PURE__ */ React115.createElement(ViewSmall27, null, playbackData ? /* @__PURE__ */ React115.createElement(EGDSSearchPlayback, {
        data: playbackData,
        stickyPlayback: stickyPlayback,
        display: displayPlayback,
        onDisplayToggle: handlePlaybackToggle
    }, /* @__PURE__ */ React115.createElement(FormFieldsLayout, _object_spread({}, fieldsProps))) : /* @__PURE__ */ React115.createElement(FormFieldsLayout, _object_spread({}, fieldsProps))), /* @__PURE__ */ React115.createElement(ViewMedium26, null, /* @__PURE__ */ React115.createElement(FormFieldsLayout, _object_spread_props(_object_spread({}, fieldsProps), {
        viewSize: ViewSizes9.MEDIUM
    }))), /* @__PURE__ */ React115.createElement(ViewLarge10, null, /* @__PURE__ */ React115.createElement(FormFieldsLayout, _object_spread_props(_object_spread({}, fieldsProps), {
        viewSize: ViewSizes9.LARGE
    })))))));
};
ActivitySearchForm2.fragment = __Fragment61;
ActivitySearchForm2.displayName = "ActivitySearchForm";
// src/components/activity/form/client-events.ts
import { SystemEvent as SystemEvent8, SystemEventLevel as SystemEventLevel8 } from "@shared-ui/logger-context";
var CLIENT_EVENTS6 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_QUERY_FAILURE: new SystemEvent8(SystemEventLevel8.ERROR, "SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS5 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Activity Search Form Fallback Presented",
        referrerId: "Web.Activity.Search.Form.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_IMPRESSION: {
        linkName: "Activity Search Form Presented",
        referrerId: "Web.Activity.Search.Form.Presented"
    }
};
// src/components/activity/form/activity-search-form.tsx
var __Query8 = gql88(_templateObject92(), ActivitySearchForm2.fragment);
var smallViewportFormSkeletonProps3 = {
    rows: [
        {
            type: "primary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        }
    ]
};
var mediumViewportFormSkeletonProps3 = {
    rows: [
        {
            type: "primary"
        }
    ]
};
var ActivitySearchForm = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, batchKey = props.batchKey, includePlayback = props.includePlayback, autoSubmitOnFieldChange = props.autoSubmitOnFieldChange;
    var context = useBexApi12().context;
    var systemEvents = useLoggerEvents7(CLIENT_EVENTS6);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: !!includePlayback
    });
    var _useQuery8 = useQuery8(__Query8, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery
    }), currentData = _useQuery8.data, error = _useQuery8.error, loading = _useQuery8.loading, previousData = _useQuery8.previousData;
    var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
    if (loading && !data) {
        return /* @__PURE__ */ React116.createElement(Viewport30, null, /* @__PURE__ */ React116.createElement(ViewSmall28, null, /* @__PURE__ */ React116.createElement(FormSkeleton, _object_spread({}, smallViewportFormSkeletonProps3))), /* @__PURE__ */ React116.createElement(ViewMedium27, null, /* @__PURE__ */ React116.createElement(FormSkeleton, _object_spread({}, mediumViewportFormSkeletonProps3))));
    }
    if (error) {
        systemEvents.SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_QUERY_FAILURE.log({
            name: error.name,
            error: new Error(error.message)
        });
    }
    if (error || !data) {
        var fallbackData2 = getFallbackData3();
        if (fallbackData2.__typename === "ActivitySearchForm") {
            return /* @__PURE__ */ React116.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React116.createElement(IntersectionTracker7, _object_spread({}, CLIENT_TRACKING_EVENTS5.SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_FALLBACK_IMPRESSION), /* @__PURE__ */ React116.createElement(ActivitySearchForm2, _object_spread_props(_object_spread({}, props), {
                data: fallbackData2
            }))));
        }
    }
    if (!data || data.searchForm.activity.__typename !== "ActivitySearchForm") {
        return null;
    }
    return /* @__PURE__ */ React116.createElement(IntersectionTracker7, _object_spread({}, CLIENT_TRACKING_EVENTS5.SEARCH_TOOLS_ACTIVITY_SEARCH_FORM_IMPRESSION), /* @__PURE__ */ React116.createElement(ActivitySearchForm2, _object_spread_props(_object_spread({}, props), {
        autoSubmitOnFieldChange: autoSubmitOnFieldChange,
        data: data.searchForm.activity
    })));
};
ActivitySearchForm.displayName = "sharedui-ActivitySearchForm";
// src/components/cruises/form/cruises-search-form.tsx
import React123 from "react";
import { gql as gql92, useQuery as useQuery9 } from "@apollo/client";
import { useBexApi as useBexApi14 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents8 } from "@shared-ui/logger-context";
import { ViewMedium as ViewMedium31, Viewport as Viewport34, ViewSmall as ViewSmall32 } from "@shared-ui/viewport-context";
// src/components/cruises/utils/fallback-form-data.ts
var cruisesErrorSummary = function(egdsElementId) {
    return {
        egdsElementId: egdsElementId,
        goToErrorLinkText: "Go to error",
        goToFirstErrorLinkText: "Go to first error",
        heading: "",
        body: null,
        analytics: {
            linkName: "Error summary link clicked",
            referrerId: "Web.Cruises.Search.Error.Summary",
            __typename: "ClientSideAnalytics"
        },
        impressionAnalytics: {
            linkName: "Error summary displayed",
            referrerId: "Web.Cruises.Search.Error.Summary.Displayed",
            __typename: "ClientSideImpressionEventAnalytics"
        },
        headingTemplate: {
            models: [
                {
                    key: "errorCount",
                    source: "errorCount",
                    __typename: "TemplateModel"
                }
            ],
            templates: [
                {
                    category: "ZERO" /* ZERO */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "ONE" /* ONE */ ,
                    template: "Please correct the error to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "TWO" /* TWO */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "FEW" /* FEW */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "MANY" /* MANY */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                },
                {
                    category: "OTHER" /* OTHER */ ,
                    template: "Please correct the ${errorCount} errors to continue",
                    __typename: "CardinalTemplate"
                }
            ],
            __typename: "EGDSCardinalLocalizedText"
        },
        __typename: "EGDSErrorSummary"
    };
};
var searchErrorSummary = cruisesErrorSummary("search_form_error_summary");
var isProduction = process.env.NODE_ENV === "production";
var searchFromLocation = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "destination_form_field",
    label: "Going to",
    placeholder: "Going to",
    value: null,
    errorMessage: "Please select a destination",
    validations: [
        {
            errorMessage: "Please select a destination",
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Location open",
            referrerId: "Web.Cruises.Destinations.Open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "Homepage",
            drivable: false,
            isDestination: true,
            lineOfBusiness: "CRUISES",
            maxNumberOfResults: 25,
            packageType: null,
            personalize: false,
            regionType: null,
            typeaheadFeatures: null,
            isMultiLocation: true,
            domain: isProduction ? "https://www.expedia.com" : "https://wwwexpediacom.integration.sb.karmalab.net",
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: null,
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "",
        categorize: true,
        allowExactMatch: false,
        listTitle: true,
        selectedItemHeading: "Selected destinations",
        clearAllText: "Clear all",
        dismissButtonText: "Done",
        __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
        linkName: "Location close",
        referrerId: "Web.Cruises.Destinations.Close",
        __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
        linkName: "Location change",
        referrerId: "Web.Cruises.Destinations.Change",
        __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
};
var today4 = /* @__PURE__ */ new Date();
var startDate4 = new Date(today4.getFullYear(), today4.getMonth(), today4.getDate() + 2);
var endDate4 = new Date(startDate4.getFullYear(), startDate4.getMonth(), startDate4.getDate() + 1);
var validDaysUpperInclusive3 = new Date(startDate4.getFullYear(), startDate4.getMonth(), startDate4.getDate() + 1e3);
var datePicker4 = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date_form_field",
    label: "Departing between",
    placeholder: "Departing between",
    errorMessage: null,
    validations: null,
    action: {
        accessibility: null,
        analytics: {
            linkName: "cruise date open",
            referrerId: "Web.Cruises.Calendar.Open",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            flexibleDateContent: null,
            buttonText: "Done",
            buttonTextTemplate: null,
            clearButtonText: null,
            firstDayOfWeek: "SUN" /* SUN */ ,
            maxNumberOfDaysSelected: null,
            sameDaySelectionAllowed: false,
            selectedStartDate: {
                day: startDate4.getDate(),
                month: startDate4.getMonth() + 1,
                year: startDate4.getFullYear(),
                __typename: "Date"
            },
            startDatePlaceholderText: "Check In",
            selectedEndDate: {
                day: endDate4.getDate(),
                month: endDate4.getMonth() + 1,
                year: endDate4.getFullYear(),
                __typename: "Date"
            },
            endDatePlaceholderText: "Check Out",
            validDaysLowerBoundInclusive: {
                day: startDate4.getDate(),
                month: startDate4.getMonth(),
                year: startDate4.getFullYear(),
                __typename: "Date"
            },
            validDaysUpperBoundInclusive: {
                day: validDaysUpperInclusive3.getDate(),
                month: validDaysUpperInclusive3.getMonth(),
                year: validDaysUpperInclusive3.getFullYear(),
                __typename: "Date"
            },
            submitButtonAnalytics: {
                linkName: "cruise date submit",
                referrerId: "Web.Cruises.Calendar.Submit",
                __typename: "ClientSideAnalytics"
            },
            nextButtonAnalytics: {
                linkName: "Calendar next",
                referrerId: "Web.Cruises.Calendar.Next.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            previousButtonAnalytics: {
                linkName: "Calendar previous",
                referrerId: "Web.Cruises.Calendar.Previous.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            startDateButtonAnalytics: {
                linkName: "cruise date start date click",
                referrerId: "Web.Cruises.Calendar.Start.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            endDateButtonAnalytics: {
                linkName: "cruise date end date click",
                referrerId: "Web.Cruises.Calendar.End.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            clearDatesButtonAnalytics: null,
            showClearDatesButton: false,
            __typename: "EGDSDateRangePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var durationSpanSelectorErrorSummary = cruisesErrorSummary("duration_span_selector_error_summary");
var durationSpanField = {
    __typename: "SearchFormDurationSpanField",
    egdsElementId: "duration_span_form_field",
    label: "Duration",
    labelTemplate: {
        __typename: "EGDSBasicLocalizedText",
        egdsElementId: "duration_span_form_field_label",
        models: [
            {
                key: "minNights",
                source: "minNights",
                __typename: "TemplateModel"
            },
            {
                key: "maxNights",
                source: "maxNights",
                __typename: "TemplateModel"
            }
        ],
        template: "${minNights} \u2013 ${maxNights} nights",
        text: "3 \u2013 9 nights"
    },
    leftIcon: {
        id: "access_time",
        __typename: "Icon"
    },
    action: {
        __typename: "OpenDurationSpanAction",
        analytics: {
            __typename: "ClientSideAnalytics",
            linkName: "Search form",
            referrerId: "Web.Cruises.Duration.Open"
        },
        durationSpan: {
            __typename: "DurationSpanSelector",
            egdsElementId: "duration_span_selector",
            title: "Duration",
            doneButton: {
                __typename: "UIPrimaryButton",
                egdsElementId: "duration_span_selector_done_button",
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Search form",
                    referrerId: "Web.Cruises.Duration.Done",
                    __typename: "ClientSideAnalytics"
                },
                action: null
            },
            closeButton: {
                __typename: "UITertiaryButton",
                egdsElementId: "duration_span_selector_close_button",
                primary: null,
                disabled: false,
                accessibility: "Close duration dialog",
                icon: null,
                analytics: {
                    linkName: "Search form",
                    referrerId: "Web.Cruises.Duration.Close",
                    __typename: "ClientSideAnalytics"
                },
                action: null
            },
            minDurationSpanLimit: {
                __typename: "EGDSNumberInputField",
                egdsElementId: "duration_span_selector_min_input",
                label: "Min nights",
                value: "3",
                placeholder: "Enter a number",
                errorMessage: "Change min nights",
                step: 1,
                min: 1,
                max: 300
            },
            maxDurationSpanLimit: {
                __typename: "EGDSNumberInputField",
                egdsElementId: "duration_span_selector_max_input",
                label: "Max nights",
                value: "9",
                placeholder: "Enter a number",
                errorMessage: "Change max nights",
                step: 1,
                min: 1,
                max: 300
            },
            validations: [
                {
                    __typename: "DurationSpanInputValidation",
                    errorMessage: "",
                    type: "REQUIRED_VALUE" /* REQUIRED_VALUE */ ,
                    errorSummary: durationSpanSelectorErrorSummary
                },
                {
                    __typename: "DurationSpanInputValidation",
                    errorMessage: "",
                    type: "MINIMUM_VALUE" /* MINIMUM_VALUE */ ,
                    errorSummary: durationSpanSelectorErrorSummary
                },
                {
                    __typename: "DurationSpanInputValidation",
                    errorMessage: "",
                    type: "MAXIMUM_VALUE" /* MAXIMUM_VALUE */ ,
                    errorSummary: durationSpanSelectorErrorSummary
                },
                {
                    __typename: "DurationSpanInputValidation",
                    errorMessage: "",
                    type: "MINIMUM_LESS_THAN_MAXIMUM" /* MINIMUM_LESS_THAN_MAXIMUM */ ,
                    errorSummary: durationSpanSelectorErrorSummary
                },
                {
                    __typename: "DurationSpanInputValidation",
                    errorMessage: "",
                    type: "MAXIMUM_GREATER_THAN_MINIMUM" /* MAXIMUM_GREATER_THAN_MINIMUM */ ,
                    errorSummary: durationSpanSelectorErrorSummary
                }
            ]
        },
        accessibility: "Duration selector opened"
    }
};
var travelErrorSummary = cruisesErrorSummary("traveler_selector_error_summary");
var travelSelector = {
    __typename: "EGDSSearchFormTravelersField",
    action: {
        analytics: {
            linkName: "Search form",
            referrerId: "Web.Cruises.Travelers.Open",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            closeButton: {
                egdsElementId: "traveler_selector_close_button",
                primary: null,
                disabled: false,
                accessibility: "Close travelers dialog",
                icon: {
                    id: "close",
                    description: "close",
                    token: "icon__close",
                    title: "",
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Traveler selector",
                    referrerId: "Web.Cruises.Travelers.Cancel",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            doneButton: {
                egdsElementId: "traveler_selector_done_button",
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Traveler selector",
                    referrerId: "Web.Cruises.Travelers.Done",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            title: "Travelers",
            travelers: {
                adults: {
                    decreaseAnalytics: {
                        linkName: "Traveler selector",
                        referrerId: "Web.Cruises.Travelers.Remove.Adult",
                        __typename: "ClientSideAnalytics"
                    },
                    increaseAnalytics: {
                        linkName: "Traveler selector",
                        referrerId: "Web.Cruises.Travelers.Add.Adult",
                        __typename: "ClientSideAnalytics"
                    },
                    decreaseText: "Decrease the number of adults",
                    decreaseTextTemplate: null,
                    increaseText: "Increase the number of adults",
                    increaseTextTemplate: null,
                    egdsElementId: "traveler_selector_adult_step_input",
                    __typename: "EGDSTravelerStepInput",
                    label: "Adults",
                    max: 5,
                    min: 1,
                    step: 1,
                    subLabel: null,
                    value: 2
                },
                children: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Traveler selector",
                            referrerId: "Web.Cruises.Travelers.Remove.Child",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Traveler selector",
                            referrerId: "Web.Cruises.Travelers.Add.Child",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of children",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of children",
                        increaseTextTemplate: null,
                        egdsElementId: "traveler_selector_children_step_input",
                        __typename: "EGDSTravelerStepInput",
                        label: "Children",
                        max: 5,
                        min: 0,
                        step: 1,
                        subLabel: "Ages 0 to 17",
                        value: 0
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "childNumber",
                                    source: "childNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Child ${childNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            {
                                label: "Under 1",
                                value: "0",
                                egdsElementId: "children_age_option_0",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "1",
                                value: "1",
                                egdsElementId: "children_age_option_1",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "2",
                                value: "2",
                                egdsElementId: "children_age_option_2",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "3",
                                value: "3",
                                egdsElementId: "children_age_option_3",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "4",
                                value: "4",
                                egdsElementId: "children_age_option_4",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "5",
                                value: "5",
                                egdsElementId: "children_age_option_5",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "6",
                                value: "6",
                                egdsElementId: "children_age_option_6",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "7",
                                value: "7",
                                egdsElementId: "children_age_option_7",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "8",
                                value: "8",
                                egdsElementId: "children_age_option_8",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "9",
                                value: "9",
                                egdsElementId: "children_age_option_9",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "10",
                                value: "10",
                                egdsElementId: "children_age_option_10",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "11",
                                value: "11",
                                egdsElementId: "children_age_option_11",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "12",
                                value: "12",
                                egdsElementId: "children_age_option_12",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "13",
                                value: "13",
                                egdsElementId: "children_age_option_13",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "14",
                                value: "14",
                                egdsElementId: "children_age_option_14",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "15",
                                value: "15",
                                egdsElementId: "children_age_option_15",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "16",
                                value: "16",
                                egdsElementId: "children_age_option_16",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "17",
                                value: "17",
                                egdsElementId: "children_age_option_17",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        egdsElementId: "traveler_selector_children_age_selector",
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerChildren"
                },
                infantsInSeat: null,
                infantsOnLap: null,
                pets: null,
                __typename: "EGDSTravelers"
            },
            validations: [
                {
                    errorMessage: "We are only able to book up to 5 travelers. Please adjust the number of travelers for your search.",
                    maxCount: 5,
                    type: "MAX_TRAVELERS" /* MAX_TRAVELERS */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "We are only able to book up to 5 travelers. Please adjust the number of travelers for your search.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed",
                            referrerId: "Web.Cruises.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                },
                {
                    errorMessage: "Please provide the ages of children.",
                    maxCount: null,
                    type: "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: travelErrorSummary,
                    __typename: "EGDSTravelersInputValidation"
                }
            ],
            __typename: "EGDSBasicTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "travelerCount",
                source: "travelerCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "${travelerCount} travelers, 1 cabin",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "${travelerCount} traveler, 1 cabin",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "${travelerCount} travelers, 1 cabin",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "${travelerCount} travelers, 1 cabin",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "${travelerCount} travelers, 1 cabin",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "${travelerCount} travelers, 1 cabin",
                __typename: "CardinalTemplate"
            }
        ],
        secondaryTemplates: null,
        text: "2 travelers, 1 cabin",
        __typename: "EGDSCardinalLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    },
    readOnly: false
};
var search4 = {
    egdsElementId: "search_button",
    primary: "Search",
    disabled: false,
    accessibility: "Search",
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.Cruises.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var typeaheadAdapterDetails = {
    domainId: "CRUISE_DESTINATION",
    adapterRequest: {
        includeMetadata: [
            "type"
        ],
        __typename: "TypeaheadAdapterRequest"
    },
    categoryDetails: [
        {
            key: "POPULAR_DESTINATION",
            value: "Popular destinations",
            __typename: "TypeaheadCategoryDetails"
        },
        {
            key: "OTHER_DESTINATION",
            value: "Other destinations",
            __typename: "TypeaheadCategoryDetails"
        }
    ],
    __typename: "TypeaheadAdapterDetails"
};
var getFallbackData4 = function() {
    return {
        __typename: "CruiseSearchForm",
        egdsElementId: "cruise_search_form",
        actionURL: "/Cruise-Search",
        typeaheadAdapterDetails: typeaheadAdapterDetails,
        errorSummary: searchErrorSummary,
        elements: [
            searchFromLocation,
            datePicker4,
            durationSpanField,
            travelSelector
        ],
        search: search4,
        playback: null,
        expertAdviceInfo: "For expert cruise advice, call 1-800-916-8586.",
        searchLocation: searchLocationFallback
    };
};
// src/components/cruises/form/__private/cruise-search-form.tsx
import React122 from "react";
import { gql as gql91 } from "@apollo/client";
import { useBexApi as useBexApi13 } from "@shared-ui/bex-api-context";
import { useLocalization as useLocalization16 } from "@shared-ui/localization-context";
// ../internal/src/components/form/search-form-duration-span-field/components/search-form-duration-span-field.tsx
import React121 from "react";
import { gql as gql90 } from "@apollo/client";
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-input.tsx
import React120 from "react";
import { PositionType as PositionType5, UitkMenu as UitkMenu5, UitkMenuContainer as UitkMenuContainer5, UitkMenuTrigger as UitkMenuTrigger5 } from "@egds/react-core/menu";
import { useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium29, Viewport as Viewport32, ViewSmall as ViewSmall30 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm10, useFormCallback as useFormCallback10 } from "uitk-react-form";
import { UitkFakeInput as UitkFakeInput4 } from "uitk-react-input";
import { UitkSheet as UitkSheet5, UitkSheetContent as UitkSheetContent5, UitkSheetTransition as UitkSheetTransition5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing38 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar6 } from "uitk-react-toolbar";
// ../internal/src/components/form/search-form-duration-span-field/utils/summary.tsx
var formatBasicLocalizedTemplate = function(template, models, values) {
    return models.reduce(function(prev, model) {
        var modelTokenKey = model.key;
        var token = "${".concat(modelTokenKey, "}");
        var replacement = Number(values[modelTokenKey]).toString();
        return prev.replace(token, replacement);
    }, template);
};
var createDurationSummary = function(summaryTemplate, durationSpanLimits) {
    var min = durationSpanLimits.min, max = durationSpanLimits.max;
    if ((summaryTemplate === null || summaryTemplate === void 0 ? void 0 : summaryTemplate.__typename) === "EGDSBasicLocalizedText") {
        var template = summaryTemplate.template, models = summaryTemplate.models;
        var _obj;
        var replacementValues = (_obj = {}, _define_property(_obj, models[0].key, min), _define_property(_obj, models[1].key, max), _obj);
        return formatBasicLocalizedTemplate(template, models, replacementValues);
    }
    return "";
};
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-provider.tsx
import React117 from "react";
// ../internal/src/components/form/search-form-duration-span-field/utils/validation.tsx
var performDurationSpanFieldValidation = function(param) {
    var minDurationInput = param.minDurationInput, maxDurationInput = param.maxDurationInput, errorMessage = param.errorMessage, errorSummary5 = param.errorSummary, validationType = param.validationType, fieldUpdated = param.fieldUpdated;
    var unparsedMinDurationInputValue = minDurationInput.value, minDurationInputLowerLimit = minDurationInput.min, minDurationInputUpperLimit = minDurationInput.max;
    var unparsedMaxDurationInputValue = maxDurationInput.value, maxDurationInputLowerLimit = maxDurationInput.min, maxDurationInputUpperLimit = maxDurationInput.max;
    if (unparsedMinDurationInputValue === null || minDurationInputLowerLimit === null || minDurationInputUpperLimit === null || unparsedMaxDurationInputValue === null || maxDurationInputLowerLimit === null || maxDurationInputUpperLimit === null) {
        return null;
    }
    var minDurationInputValue = parseFloat(unparsedMinDurationInputValue);
    var maxDurationInputValue = parseFloat(unparsedMaxDurationInputValue);
    var baseDurationSpanError = {
        displayError: false,
        message: errorMessage,
        validationType: validationType,
        errorType: "No Duration Input" /* NO_INPUT */ ,
        errorCount: 0,
        errorSummary: errorSummary5
    };
    var getMinimumLessThanMaxOrMaxGreaterThanMin = function(errorType) {
        var isMinInputValueGreaterThanMaxInputValue = minDurationInputValue > maxDurationInputValue;
        return isMinInputValueGreaterThanMaxInputValue ? _object_spread_props(_object_spread({}, baseDurationSpanError), {
            errorType: errorType,
            errorCount: 1
        }) : null;
    };
    switch(validationType){
        case "REQUIRED_VALUE" /* REQUIRED_VALUE */ :
            {
                var isMinInputValueEmpty = Number.isNaN(minDurationInputValue);
                var isMaxInputValueEmpty = Number.isNaN(maxDurationInputValue);
                var errorCount = Number(isMinInputValueEmpty) + Number(isMaxInputValueEmpty);
                var errorType = "No Duration Input" /* NO_INPUT */ ;
                if (!errorCount) {
                    return null;
                }
                if (isMinInputValueEmpty && isMaxInputValueEmpty) {
                    errorType = "Both Duration Inputs" /* BOTH_DURATION_INPUTS */ ;
                }
                if (isMinInputValueEmpty && !isMaxInputValueEmpty) {
                    errorType = "Minimum Duration Input" /* MIN_DURATION_INPUT */ ;
                }
                if (!isMinInputValueEmpty && isMaxInputValueEmpty) {
                    errorType = "Maximum Duration Input" /* MAX_DURATION_INPUT */ ;
                }
                return _object_spread_props(_object_spread({}, baseDurationSpanError), {
                    errorType: errorType,
                    errorCount: errorCount
                });
            }
        case "MINIMUM_VALUE" /* MINIMUM_VALUE */ :
            {
                var isMinInputValueLowerThanLowerLimit = minDurationInputValue < minDurationInputLowerLimit;
                var isMaxInputValueLowerThanLowerLimit = maxDurationInputValue < maxDurationInputLowerLimit;
                var errorCount1 = Number(isMinInputValueLowerThanLowerLimit) + Number(isMaxInputValueLowerThanLowerLimit);
                var errorType1 = "No Duration Input" /* NO_INPUT */ ;
                if (!errorCount1) {
                    return null;
                }
                if (isMinInputValueLowerThanLowerLimit && isMaxInputValueLowerThanLowerLimit) {
                    errorType1 = "Both Duration Inputs" /* BOTH_DURATION_INPUTS */ ;
                }
                if (isMinInputValueLowerThanLowerLimit && !isMaxInputValueLowerThanLowerLimit) {
                    errorType1 = "Minimum Duration Input" /* MIN_DURATION_INPUT */ ;
                }
                if (!isMinInputValueLowerThanLowerLimit && isMaxInputValueLowerThanLowerLimit) {
                    errorType1 = "Maximum Duration Input" /* MAX_DURATION_INPUT */ ;
                }
                return _object_spread_props(_object_spread({}, baseDurationSpanError), {
                    errorType: errorType1,
                    errorCount: errorCount1
                });
            }
        case "MAXIMUM_VALUE" /* MAXIMUM_VALUE */ :
            {
                var isMinInputValueGreaterThanUpperLimit = minDurationInputValue > minDurationInputUpperLimit;
                var isMaxInputValueGreaterThanUpperLimit = maxDurationInputValue > maxDurationInputUpperLimit;
                var errorCount2 = Number(isMinInputValueGreaterThanUpperLimit) + Number(isMaxInputValueGreaterThanUpperLimit);
                var errorType2 = "No Duration Input" /* NO_INPUT */ ;
                if (!errorCount2) {
                    return null;
                }
                if (isMinInputValueGreaterThanUpperLimit && isMaxInputValueGreaterThanUpperLimit) {
                    errorType2 = "Both Duration Inputs" /* BOTH_DURATION_INPUTS */ ;
                }
                if (isMinInputValueGreaterThanUpperLimit && !isMaxInputValueGreaterThanUpperLimit) {
                    errorType2 = "Minimum Duration Input" /* MIN_DURATION_INPUT */ ;
                }
                if (!isMinInputValueGreaterThanUpperLimit && isMaxInputValueGreaterThanUpperLimit) {
                    errorType2 = "Maximum Duration Input" /* MAX_DURATION_INPUT */ ;
                }
                return _object_spread_props(_object_spread({}, baseDurationSpanError), {
                    errorType: errorType2,
                    errorCount: errorCount2
                });
            }
        case "MINIMUM_LESS_THAN_MAXIMUM" /* MINIMUM_LESS_THAN_MAXIMUM */ :
            return fieldUpdated === "MIN" /* MIN */  ? getMinimumLessThanMaxOrMaxGreaterThanMin("Minimum Duration Input" /* MIN_DURATION_INPUT */ ) : null;
        case "MAXIMUM_GREATER_THAN_MINIMUM" /* MAXIMUM_GREATER_THAN_MINIMUM */ :
            {
                return fieldUpdated === "MAX" /* MAX */  ? getMinimumLessThanMaxOrMaxGreaterThanMin("Maximum Duration Input" /* MAX_DURATION_INPUT */ ) : null;
            }
        default:
            return null;
    }
};
var getDurationSpanError = function(param) {
    var minDurationInput = param.minDurationInput, maxDurationInput = param.maxDurationInput, validations2 = param.validations, currentError = param.currentError, fieldUpdated = param.fieldUpdated;
    if (!validations2.length) {
        return null;
    }
    var error = null;
    for(var i = 0; i < validations2.length; i += 1){
        var validation = validations2[i];
        if (validation.__typename === "DurationSpanInputValidation" && (validation === null || validation === void 0 ? void 0 : validation.errorSummary)) {
            var errorMessage = validation.errorMessage, validationType = validation.type, errorSummary5 = validation.errorSummary;
            error = performDurationSpanFieldValidation({
                minDurationInput: minDurationInput,
                maxDurationInput: maxDurationInput,
                errorMessage: errorMessage,
                errorSummary: errorSummary5,
                validationType: validationType,
                fieldUpdated: fieldUpdated
            });
            if (error) {
                break;
            }
        }
    }
    if (!error) {
        return null;
    }
    var isSameError = (currentError === null || currentError === void 0 ? void 0 : currentError.validationType) === (error === null || error === void 0 ? void 0 : error.validationType);
    if (isSameError && (currentError === null || currentError === void 0 ? void 0 : currentError.displayError)) {
        var errorType = error.errorType, errorCount = error.errorCount;
        return _object_spread_props(_object_spread({}, currentError), {
            errorType: errorType,
            errorCount: errorCount
        });
    }
    if (!isSameError && (currentError === null || currentError === void 0 ? void 0 : currentError.displayError)) {
        return _object_spread_props(_object_spread({}, error), {
            displayError: true
        });
    }
    return error;
};
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-provider.tsx
var DurationSpanContext = React117.createContext({
    state: {}
});
var durationSpanReducer = function(state, action) {
    switch(action.type){
        case "Update Minimum Value" /* UPDATE_MIN */ :
            {
                var min = action.min;
                var minDurationInput = state.minDurationInput, maxDurationInput = state.maxDurationInput, validations2 = state.validations, currentError = state.error;
                var newMinDurationInput = _object_spread_props(_object_spread({}, minDurationInput), {
                    value: min
                });
                var newError = getDurationSpanError({
                    minDurationInput: newMinDurationInput,
                    maxDurationInput: maxDurationInput,
                    currentError: currentError,
                    validations: validations2 !== null && validations2 !== void 0 ? validations2 : [],
                    fieldUpdated: "MIN" /* MIN */ 
                });
                return _object_spread_props(_object_spread({}, state), {
                    error: newError,
                    minDurationInput: newMinDurationInput
                });
            }
        case "Update Maximum Value" /* UPDATE_MAX */ :
            {
                var max = action.max;
                var minDurationInput1 = state.minDurationInput, maxDurationInput1 = state.maxDurationInput, validations21 = state.validations, currentError1 = state.error;
                var newMaxDurationInput = _object_spread_props(_object_spread({}, maxDurationInput1), {
                    value: max
                });
                var newError1 = getDurationSpanError({
                    minDurationInput: minDurationInput1,
                    maxDurationInput: newMaxDurationInput,
                    currentError: currentError1,
                    validations: validations21 !== null && validations21 !== void 0 ? validations21 : [],
                    fieldUpdated: "MAX" /* MAX */ 
                });
                return _object_spread_props(_object_spread({}, state), {
                    error: newError1,
                    maxDurationInput: newMaxDurationInput
                });
            }
        case "Show Error Message" /* SHOW_ERROR */ :
            {
                if (state.error) {
                    var newError2 = _object_spread_props(_object_spread({}, state.error), {
                        displayError: true
                    });
                    return _object_spread_props(_object_spread({}, state), {
                        error: newError2
                    });
                }
                return state;
            }
        case "Reset Duration Span State" /* RESET_STATE */ :
            {
                return action.state;
            }
        default:
            return state;
    }
};
var DurationSpanProvider = function(param) {
    var children = param.children, durationSpan = param.durationSpan;
    var _React117_useReducer = _sliced_to_array(React117.useReducer(durationSpanReducer, durationSpan, function(initArg) {
        var minDurationSpanLimit = initArg.minDurationSpanLimit, maxDurationSpanLimit = initArg.maxDurationSpanLimit, validations2 = initArg.validations;
        return {
            minDurationInput: minDurationSpanLimit,
            maxDurationInput: maxDurationSpanLimit,
            validations: validations2 !== null && validations2 !== void 0 ? validations2 : [],
            error: null
        };
    }), 2), state = _React117_useReducer[0], dispatch = _React117_useReducer[1];
    var DurationSpanContextProvider = React117.useMemo(function() {
        return /* @__PURE__ */ React117.createElement(DurationSpanContext.Provider, {
            value: {
                state: state,
                dispatch: dispatch
            }
        }, children);
    }, [
        state,
        dispatch
    ]);
    return DurationSpanContextProvider;
};
var useDurationSpanContext = function() {
    return React117.useContext(DurationSpanContext);
};
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-selector.tsx
import React119 from "react";
import { gql as gql89 } from "@apollo/client";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge11, ViewMedium as ViewMedium28, Viewport as Viewport31, ViewSmall as ViewSmall29 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex25, UitkLayoutFlexItem as UitkLayoutFlexItem22 } from "uitk-react-layout-flex";
import { UitkScrim as UitkScrim3, UitkScrimColorType, UitkScrimType as UitkScrimType2 } from "uitk-react-scrim";
import { UitkSpacing as UitkSpacing37 } from "uitk-react-spacing";
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-limit-inputs.tsx
import React118 from "react";
import { UitkInput } from "uitk-react-input";
import { UitkLayoutFlex as UitkLayoutFlex24, UitkLayoutFlexItem as UitkLayoutFlexItem21 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing36 } from "uitk-react-spacing";
var DurationSpanLimitInputs = function(param) {
    var minDurationSpanLimit = param.minDurationSpanLimit, maxDurationSpanLimit = param.maxDurationSpanLimit, durationSpanLimits = param.durationSpanLimits, error = param.error, handleErrorInputRefUpdate = param.handleErrorInputRefUpdate, handleChange = param.handleChange;
    var _error_errorType;
    var errorType = (_error_errorType = error === null || error === void 0 ? void 0 : error.errorType) !== null && _error_errorType !== void 0 ? _error_errorType : "No Duration Input" /* NO_INPUT */ ;
    var shouldDisplayMinInvalidState = errorType === "Minimum Duration Input" /* MIN_DURATION_INPUT */  || errorType === "Both Duration Inputs" /* BOTH_DURATION_INPUTS */ ;
    var shouldDisplayMaxInvalidState = errorType === "Maximum Duration Input" /* MAX_DURATION_INPUT */  || errorType === "Both Duration Inputs" /* BOTH_DURATION_INPUTS */ ;
    var validationType = error === null || error === void 0 ? void 0 : error.validationType;
    var getInvalidMessage = function(durationSpanLimit) {
        if (!durationSpanLimit.errorMessage) {
            return error === null || error === void 0 ? void 0 : error.message;
        }
        var validSpanValidation = validationType === "MINIMUM_VALUE" /* MINIMUM_VALUE */  || validationType === "MAXIMUM_VALUE" /* MAXIMUM_VALUE */  || validationType === "REQUIRED_VALUE" /* REQUIRED_VALUE */ ;
        if (validSpanValidation) {
            return durationSpanLimit.errorMessage;
        }
        return error === null || error === void 0 ? void 0 : error.message;
    };
    var minInputValue = parseFloat(durationSpanLimits.min);
    var maxInputValue = parseFloat(durationSpanLimits.max);
    var minInputRef = React118.useRef(null);
    var maxInputRef = React118.useRef(null);
    var _minDurationSpanLimit_egdsElementId, _minDurationSpanLimit_label, _minDurationSpanLimit_min, _minDurationSpanLimit_max, _minDurationSpanLimit_placeholder, _minDurationSpanLimit_step;
    var minLimitInputProps = {
        id: (_minDurationSpanLimit_egdsElementId = minDurationSpanLimit.egdsElementId) !== null && _minDurationSpanLimit_egdsElementId !== void 0 ? _minDurationSpanLimit_egdsElementId : "duration_span_field_min_input",
        label: (_minDurationSpanLimit_label = minDurationSpanLimit.label) !== null && _minDurationSpanLimit_label !== void 0 ? _minDurationSpanLimit_label : "",
        min: (_minDurationSpanLimit_min = minDurationSpanLimit.min) !== null && _minDurationSpanLimit_min !== void 0 ? _minDurationSpanLimit_min : void 0,
        max: (_minDurationSpanLimit_max = minDurationSpanLimit.max) !== null && _minDurationSpanLimit_max !== void 0 ? _minDurationSpanLimit_max : void 0,
        placeholder: (_minDurationSpanLimit_placeholder = minDurationSpanLimit.placeholder) !== null && _minDurationSpanLimit_placeholder !== void 0 ? _minDurationSpanLimit_placeholder : void 0,
        step: (_minDurationSpanLimit_step = minDurationSpanLimit.step) !== null && _minDurationSpanLimit_step !== void 0 ? _minDurationSpanLimit_step : void 0,
        value: Number.isNaN(minInputValue) ? void 0 : minInputValue,
        invalid: shouldDisplayMinInvalidState ? getInvalidMessage(minDurationSpanLimit) : void 0,
        domRef: minInputRef
    };
    var _maxDurationSpanLimit_egdsElementId, _maxDurationSpanLimit_label, _maxDurationSpanLimit_min, _maxDurationSpanLimit_max, _maxDurationSpanLimit_placeholder, _maxDurationSpanLimit_step;
    var maxLimitInputProps = {
        id: (_maxDurationSpanLimit_egdsElementId = maxDurationSpanLimit.egdsElementId) !== null && _maxDurationSpanLimit_egdsElementId !== void 0 ? _maxDurationSpanLimit_egdsElementId : "duration_span_field_max_input",
        label: (_maxDurationSpanLimit_label = maxDurationSpanLimit.label) !== null && _maxDurationSpanLimit_label !== void 0 ? _maxDurationSpanLimit_label : "",
        min: (_maxDurationSpanLimit_min = maxDurationSpanLimit.min) !== null && _maxDurationSpanLimit_min !== void 0 ? _maxDurationSpanLimit_min : void 0,
        max: (_maxDurationSpanLimit_max = maxDurationSpanLimit.max) !== null && _maxDurationSpanLimit_max !== void 0 ? _maxDurationSpanLimit_max : void 0,
        placeholder: (_maxDurationSpanLimit_placeholder = maxDurationSpanLimit.placeholder) !== null && _maxDurationSpanLimit_placeholder !== void 0 ? _maxDurationSpanLimit_placeholder : void 0,
        step: (_maxDurationSpanLimit_step = maxDurationSpanLimit.step) !== null && _maxDurationSpanLimit_step !== void 0 ? _maxDurationSpanLimit_step : void 0,
        value: Number.isNaN(maxInputValue) ? void 0 : maxInputValue,
        invalid: shouldDisplayMaxInvalidState ? getInvalidMessage(maxDurationSpanLimit) : void 0,
        domRef: maxInputRef
    };
    if (shouldDisplayMinInvalidState) {
        handleErrorInputRefUpdate(minInputRef);
    }
    if (!shouldDisplayMinInvalidState && shouldDisplayMaxInvalidState) {
        handleErrorInputRefUpdate(maxInputRef);
    }
    return /* @__PURE__ */ React118.createElement("section", null, /* @__PURE__ */ React118.createElement(UitkSpacing36, {
        padding: {
            blockstart: "four",
            inline: "four"
        }
    }, /* @__PURE__ */ React118.createElement(UitkLayoutFlex24, {
        wrap: "wrap"
    }, /* @__PURE__ */ React118.createElement(UitkSpacing36, {
        padding: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React118.createElement(UitkLayoutFlexItem21, {
        minWidth: "half_width"
    }, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(UitkInput, _object_spread_props(_object_spread({
        name: "min",
        hasBorder: true,
        hasVisibleLabel: true,
        onChange: handleChange
    }, minLimitInputProps), {
        type: "number"
    }))))), /* @__PURE__ */ React118.createElement(UitkSpacing36, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React118.createElement(UitkLayoutFlexItem21, {
        minWidth: "half_width"
    }, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(UitkInput, _object_spread_props(_object_spread({
        name: "max",
        hasBorder: true,
        hasVisibleLabel: true,
        onChange: handleChange
    }, maxLimitInputProps), {
        type: "number"
    }))))))));
};
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-selector.tsx
var __Fragment62 = gql89(_templateObject93(), EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSErrorSummary.fragment);
var DurationSpanSelector = function(param) {
    var onSave = param.onSave, data = param.data;
    var doneButton = data.doneButton, minDurationSpanLimit = data.minDurationSpanLimit, maxDurationSpanLimit = data.maxDurationSpanLimit;
    var clickTracker = useClickTracker30();
    var _useDurationSpanContext = useDurationSpanContext(), state = _useDurationSpanContext.state, dispatch = _useDurationSpanContext.dispatch;
    var minDurationInput = state.minDurationInput, maxDurationInput = state.maxDurationInput, error = state.error;
    var _React119_useState = _sliced_to_array(React119.useState(React119.createRef()), 2), inputErrorRef = _React119_useState[0], setInputErrorRef = _React119_useState[1];
    var _minDurationInput_value, _maxDurationInput_value;
    var _React119_useState1 = _sliced_to_array(React119.useState({
        min: (_minDurationInput_value = minDurationInput.value) !== null && _minDurationInput_value !== void 0 ? _minDurationInput_value : "",
        max: (_maxDurationInput_value = maxDurationInput.value) !== null && _maxDurationInput_value !== void 0 ? _maxDurationInput_value : ""
    }), 2), durationSpanLimits = _React119_useState1[0], setDurationSpanLimits = _React119_useState1[1];
    React119.useEffect(function() {
        var _minDurationInput_value, _maxDurationInput_value;
        setDurationSpanLimits({
            min: (_minDurationInput_value = minDurationInput.value) !== null && _minDurationInput_value !== void 0 ? _minDurationInput_value : "",
            max: (_maxDurationInput_value = maxDurationInput.value) !== null && _maxDurationInput_value !== void 0 ? _maxDurationInput_value : ""
        });
    }, [
        minDurationInput,
        maxDurationInput
    ]);
    var handleDurationSpanLimitChange = function(e) {
        var _e_target = e.target, name = _e_target.name, value = _e_target.value;
        setDurationSpanLimits(_object_spread_props(_object_spread({}, durationSpanLimits), _define_property({}, name, value)));
        if (name === "min") {
            dispatch({
                type: "Update Minimum Value" /* UPDATE_MIN */ ,
                min: value
            });
            return;
        }
        if (name === "max") {
            dispatch({
                type: "Update Maximum Value" /* UPDATE_MAX */ ,
                max: value
            });
        }
    };
    var handleSubmit = function() {
        if (error) {
            dispatch({
                type: "Show Error Message" /* SHOW_ERROR */ 
            });
            return;
        }
        if (doneButton.__typename === "UIPrimaryButton" && doneButton.analytics) {
            var _doneButton_analytics = doneButton.analytics, referrerId = _doneButton_analytics.referrerId, linkName = _doneButton_analytics.linkName;
            clickTracker(referrerId, linkName);
        }
        if (!error) {
            onSave(state);
        }
    };
    var handleErrorInputRefUpdate = function(ref) {
        setInputErrorRef(ref);
    };
    return /* @__PURE__ */ React119.createElement(React119.Fragment, null, (error === null || error === void 0 ? void 0 : error.displayError) && /* @__PURE__ */ React119.createElement(UitkSpacing37, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React119.createElement("div", null, /* @__PURE__ */ React119.createElement(EGDSErrorSummary, {
        data: error.errorSummary,
        errorCount: error.errorCount,
        inputErrorRef: inputErrorRef
    }))), /* @__PURE__ */ React119.createElement(DurationSpanLimitInputs, {
        minDurationSpanLimit: minDurationSpanLimit,
        maxDurationSpanLimit: maxDurationSpanLimit,
        durationSpanLimits: durationSpanLimits,
        error: error,
        handleErrorInputRefUpdate: handleErrorInputRefUpdate,
        handleChange: handleDurationSpanLimitChange
    }), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React119.createElement(Viewport31, null, /* @__PURE__ */ React119.createElement(ViewSmall29, null, /* @__PURE__ */ React119.createElement(UitkScrim3, {
        tag: "div",
        type: UitkScrimType2.BUTTON,
        color: UitkScrimColorType.SECONDARY
    }, /* @__PURE__ */ React119.createElement(EGDSPrimaryButton, {
        isFullWidth: true,
        onClick: handleSubmit,
        data: doneButton
    }))), /* @__PURE__ */ React119.createElement(ViewMedium28, null, /* @__PURE__ */ React119.createElement(UitkSpacing37, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React119.createElement("div", null, /* @__PURE__ */ React119.createElement(EGDSPrimaryButton, {
        isFullWidth: true,
        onClick: handleSubmit,
        data: doneButton
    })))), /* @__PURE__ */ React119.createElement(ViewLarge11, null, /* @__PURE__ */ React119.createElement(UitkSpacing37, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React119.createElement(UitkLayoutFlex25, {
        justifyContent: "end"
    }, /* @__PURE__ */ React119.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React119.createElement(EGDSPrimaryButton, {
        isFullWidth: false,
        onClick: handleSubmit,
        data: doneButton
    })))))));
};
DurationSpanSelector.displayName = "DurationSpanSelector";
DurationSpanSelector.fragment = __Fragment62;
// ../internal/src/components/form/search-form-duration-span-field/components/duration-span-input.tsx
var BASE_PREFIX = "SearchFormDurationSpanField";
var MAX_DURATION_NAME_PREFIX = "".concat(BASE_PREFIX, "-Max");
var MIN_DURATION_NAME_PREFIX = "".concat(BASE_PREFIX, "-Min");
var DurationSpanInput = function(param) {
    var action = param.action, labelTemplate = param.labelTemplate, _param_egdsElementId = param.egdsElementId, egdsElementId = _param_egdsElementId === void 0 ? "duration_form_field" : _param_egdsElementId, _param_label = param.label, label = _param_label === void 0 ? "" : _param_label, _param_leftIconId = param.leftIconId, leftIconId = _param_leftIconId === void 0 ? "access_time" : _param_leftIconId;
    var _durationState_maxDurationInput, _durationState_minDurationInput;
    var analytics = action.analytics, durationSpan = action.durationSpan;
    var closeButton = durationSpan.closeButton, title = durationSpan.title;
    var _useDurationSpanContext = useDurationSpanContext(), state = _useDurationSpanContext.state, dispatch = _useDurationSpanContext.dispatch;
    var _useDialog5 = _sliced_to_array(useDialog5("duration-span-dialog"), 3), isOpen = _useDialog5[0], dialogActions = _useDialog5[1], DurationSpanDialog = _useDialog5[2];
    var clickTracker = useClickTracker31();
    var triggerRef = React120.useRef(null);
    var _React120_useState = _sliced_to_array(React120.useState(false), 2), showMenu = _React120_useState[0], setShowMenu = _React120_useState[1];
    var _React120_useState1 = _sliced_to_array(React120.useState(_object_spread_props(_object_spread({}, state), {
        durationSummary: labelTemplate.text,
        shouldFireChangeEvent: false
    })), 2), durationState = _React120_useState1[0], setDurationState = _React120_useState1[1];
    var handleDurationSpanFieldChange = useFormCallback10(durationSpan.__typename, function(event) {
        return event;
    });
    var durationSummary = durationState.durationSummary, shouldFireChangeEvent = durationState.shouldFireChangeEvent;
    React120.useEffect(function() {
        if (shouldFireChangeEvent) {
            setDurationState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    shouldFireChangeEvent: false
                });
            });
            triggerInputChangeEvent(durationSummary, handleDurationSpanFieldChange);
        }
    }, [
        durationSummary,
        shouldFireChangeEvent,
        handleDurationSpanFieldChange
    ]);
    var updateDurationSummary = function(newState, durationSpanLimits) {
        var duration = createDurationSummary(labelTemplate, durationSpanLimits);
        setDurationState(_object_spread_props(_object_spread({}, newState), {
            durationSummary: duration,
            shouldFireChangeEvent: true
        }));
    };
    var handleDialogInputClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        clickTracker(referrerId, linkName);
        dialogActions.openDialog();
    };
    var handleDialogDismiss = function() {
        var _triggerRef_current;
        if (closeButton.__typename === "UITertiaryButton" && closeButton.analytics) {
            var _closeButton_analytics = closeButton.analytics, referrerId = _closeButton_analytics.referrerId, linkName = _closeButton_analytics.linkName;
            clickTracker(referrerId, linkName);
        }
        if (state.error) {
            dispatch({
                type: "Show Error Message" /* SHOW_ERROR */ 
            });
            return;
        }
        var minDurationInput = state.minDurationInput, maxDurationInput = state.maxDurationInput;
        var _minDurationInput_value, _maxDurationInput_value;
        updateDurationSummary(state, {
            min: (_minDurationInput_value = minDurationInput.value) !== null && _minDurationInput_value !== void 0 ? _minDurationInput_value : "",
            max: (_maxDurationInput_value = maxDurationInput.value) !== null && _maxDurationInput_value !== void 0 ? _maxDurationInput_value : ""
        });
        dispatch({
            type: "Reset Duration Span State" /* RESET_STATE */ ,
            state: state
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        dialogActions.closeDialog();
    };
    var handleDialogSave = function(newState) {
        var _triggerRef_current;
        var minDurationInput = newState.minDurationInput, maxDurationInput = newState.maxDurationInput;
        var _minDurationInput_value, _maxDurationInput_value;
        updateDurationSummary(newState, {
            min: (_minDurationInput_value = minDurationInput === null || minDurationInput === void 0 ? void 0 : minDurationInput.value) !== null && _minDurationInput_value !== void 0 ? _minDurationInput_value : "",
            max: (_maxDurationInput_value = maxDurationInput === null || maxDurationInput === void 0 ? void 0 : maxDurationInput.value) !== null && _maxDurationInput_value !== void 0 ? _maxDurationInput_value : ""
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        dialogActions.closeDialog();
    };
    var handleMenuTriggerClick = function() {
        setShowMenu(function(prevState) {
            return !prevState;
        });
    };
    var handleMenuInputClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        clickTracker(referrerId, linkName);
    };
    var handleMenuDismiss = function() {
        var _triggerRef_current;
        if (state.error) {
            setShowMenu(function(prevState) {
                return !prevState;
            });
            dispatch({
                type: "Show Error Message" /* SHOW_ERROR */ 
            });
            return;
        }
        var minDurationInput = state.minDurationInput, maxDurationInput = state.maxDurationInput;
        var _minDurationInput_value, _maxDurationInput_value;
        updateDurationSummary(state, {
            min: (_minDurationInput_value = minDurationInput.value) !== null && _minDurationInput_value !== void 0 ? _minDurationInput_value : "",
            max: (_maxDurationInput_value = maxDurationInput.value) !== null && _maxDurationInput_value !== void 0 ? _maxDurationInput_value : ""
        });
        dispatch({
            type: "Reset Duration Span State" /* RESET_STATE */ ,
            state: state
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    var handleMenuSave = function(newState) {
        var _triggerRef_current;
        var minDurationInput = newState.minDurationInput, maxDurationInput = newState.maxDurationInput;
        var _minDurationInput_value, _maxDurationInput_value;
        updateDurationSummary(newState, {
            min: (_minDurationInput_value = minDurationInput.value) !== null && _minDurationInput_value !== void 0 ? _minDurationInput_value : "",
            max: (_maxDurationInput_value = maxDurationInput.value) !== null && _maxDurationInput_value !== void 0 ? _maxDurationInput_value : ""
        });
        setShowMenu(function(prevState) {
            return !prevState;
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    if (closeButton.__typename !== "UITertiaryButton") {
        return null;
    }
    var _closeButton_accessibility, _durationState_maxDurationInput_value, _durationState_minDurationInput_value;
    return /* @__PURE__ */ React120.createElement(React120.Fragment, null, /* @__PURE__ */ React120.createElement(Viewport32, null, /* @__PURE__ */ React120.createElement(ViewSmall30, null, /* @__PURE__ */ React120.createElement(React120.Fragment, null, /* @__PURE__ */ React120.createElement(UitkFakeInput4, {
        id: "".concat(egdsElementId, "_input"),
        name: "".concat(egdsElementId, "_input"),
        label: label,
        value: durationSummary,
        icon: leftIconId,
        onClick: handleDialogInputClick,
        domRef: triggerRef
    }), /* @__PURE__ */ React120.createElement(UitkSheetTransition5, {
        isVisible: isOpen
    }, /* @__PURE__ */ React120.createElement(DurationSpanDialog, null, /* @__PURE__ */ React120.createElement(UitkSheet5, {
        type: "full",
        triggerRef: triggerRef,
        autoFocus: true,
        isVisible: true,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React120.createElement(UitkToolbar6, {
        id: "".concat(egdsElementId, "_dialog_toolbar"),
        toolbarType: "standard",
        toolbarTitle: title,
        toolbarTitleTag: "h2",
        navigationContent: {
            onClick: handleDialogDismiss,
            navIconLabel: (_closeButton_accessibility = closeButton === null || closeButton === void 0 ? void 0 : closeButton.accessibility) !== null && _closeButton_accessibility !== void 0 ? _closeButton_accessibility : void 0,
            navType: "close"
        }
    }), /* @__PURE__ */ React120.createElement(UitkSheetContent5, {
        padded: false
    }, /* @__PURE__ */ React120.createElement(UitkForm10, {
        hasRequiredFieldIndicator: true
    }, /* @__PURE__ */ React120.createElement(DurationSpanSelector, {
        onSave: handleDialogSave,
        data: durationSpan
    })))))))), /* @__PURE__ */ React120.createElement(ViewMedium29, null, /* @__PURE__ */ React120.createElement(UitkMenu5, {
        isOpen: showMenu,
        onDismiss: handleMenuDismiss,
        onTriggerClick: handleMenuTriggerClick
    }, /* @__PURE__ */ React120.createElement(UitkMenuTrigger5, null, /* @__PURE__ */ React120.createElement(UitkFakeInput4, {
        id: "".concat(egdsElementId, "_input"),
        name: "".concat(egdsElementId, "_input"),
        label: label,
        value: durationSummary,
        icon: leftIconId,
        onClick: handleMenuInputClick,
        domRef: triggerRef
    })), /* @__PURE__ */ React120.createElement(UitkMenuContainer5, {
        autoPosition: true,
        position: PositionType5.RIGHT,
        width: 375
    }, /* @__PURE__ */ React120.createElement(UitkSpacing38, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React120.createElement("div", {
        "data-stid": "duration-span-menu"
    }, /* @__PURE__ */ React120.createElement(UitkSpacing38, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React120.createElement(UitkHeading7, {
        size: 5,
        tag: "h5"
    }, title)), /* @__PURE__ */ React120.createElement(DurationSpanSelector, {
        onSave: handleMenuSave,
        data: durationSpan
    }))))))), /* @__PURE__ */ React120.createElement("input", {
        type: "hidden",
        "data-stid": MAX_DURATION_NAME_PREFIX,
        name: "".concat(MAX_DURATION_NAME_PREFIX, "-").concat(egdsElementId),
        value: (_durationState_maxDurationInput_value = (_durationState_maxDurationInput = durationState.maxDurationInput) === null || _durationState_maxDurationInput === void 0 ? void 0 : _durationState_maxDurationInput.value) !== null && _durationState_maxDurationInput_value !== void 0 ? _durationState_maxDurationInput_value : ""
    }), /* @__PURE__ */ React120.createElement("input", {
        type: "hidden",
        "data-stid": MIN_DURATION_NAME_PREFIX,
        name: "".concat(MIN_DURATION_NAME_PREFIX, "-").concat(egdsElementId),
        value: (_durationState_minDurationInput_value = (_durationState_minDurationInput = durationState.minDurationInput) === null || _durationState_minDurationInput === void 0 ? void 0 : _durationState_minDurationInput.value) !== null && _durationState_minDurationInput_value !== void 0 ? _durationState_minDurationInput_value : ""
    }));
};
// ../internal/src/components/form/search-form-duration-span-field/components/search-form-duration-span-field.tsx
var __Fragment63 = gql90(_templateObject94(), DurationSpanSelector.fragment);
var SearchFormDurationSpanField = function(param) {
    var data = param.data;
    var egdsElementId = data.egdsElementId, label = data.label, labelTemplate = data.labelTemplate, leftIcon = data.leftIcon, action = data.action;
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "OpenDurationSpanAction" || (labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) !== "EGDSBasicLocalizedText") {
        return null;
    }
    return /* @__PURE__ */ React121.createElement(DurationSpanProvider, {
        durationSpan: action.durationSpan
    }, /* @__PURE__ */ React121.createElement(DurationSpanInput, {
        egdsElementId: egdsElementId,
        label: label !== null && label !== void 0 ? label : "",
        labelTemplate: labelTemplate,
        leftIconId: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id,
        action: action
    }));
};
SearchFormDurationSpanField.displayName = "SearchFormDurationSpanField";
SearchFormDurationSpanField.fragment = __Fragment63;
// src/components/cruises/form/__private/cruise-search-form.tsx
import { ViewLarge as ViewLarge12, ViewMedium as ViewMedium30, Viewport as Viewport33, ViewSizes as ViewSizes11, ViewSmall as ViewSmall31 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm11 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex26, UitkLayoutFlexItem as UitkLayoutFlexItem23 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing39 } from "uitk-react-spacing";
import { UitkSubheading as UitkSubheading2 } from "uitk-react-text";
// src/components/cruises/utils/fields-map.ts
var FieldNameMap6 = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["DESTINATION"] = "destination_form_field";
    FieldNameMap8["DATES"] = "EGDSDateRangePicker";
    FieldNameMap8["DURATION"] = "DurationSpanSelector";
    return FieldNameMap8;
}(FieldNameMap6 || {});
// src/components/cruises/utils/format-localized-string.ts
var formatLocalizedString = function(template, models, value) {
    var _value_split = _sliced_to_array(value.split("-"), 2), start = _value_split[0], end = _value_split[1];
    var _obj;
    var mapValues = (_obj = {}, _define_property(_obj, models[0].key, start), _define_property(_obj, models[1].key, end), _obj);
    return models.reduce(function(prev, model) {
        var modelTokenKey = model.key;
        var token = "${".concat(modelTokenKey, "}");
        return prev.replace(token, mapValues[modelTokenKey]);
    }, template);
};
var formatDurationLocalizedString = function(templates, models, value) {
    var _value_split = _sliced_to_array(value.split("\u2013"), 2), min = _value_split[0], max = _value_split[1];
    var templateToUse = Number(max) === 1 ? templates[Number(max)].template : templates[4].template;
    var formattedText = "".concat(min, " - ").concat(max);
    return formatLocalizedString(templateToUse, models, formattedText);
};
// src/components/cruises/utils/search-criteria.ts
import { getCruiseSearchCriteriaFromQueryParams } from "@shared-ui/shopping-search-criteria-providers";
var getCruiseSearchCriteria = function(urlSearchParams) {
    var cruiseSearchCriteriaInput = getCruiseSearchCriteriaFromQueryParams(urlSearchParams);
    if (!cruiseSearchCriteriaInput.primarySearchCriteria.cruise) {
        return void 0;
    }
    return {
        primary: cruiseSearchCriteriaInput.primarySearchCriteria.cruise,
        secondary: cruiseSearchCriteriaInput.secondaryCriteria
    };
};
// src/components/cruises/utils/cruise-ess-adapter.ts
import { ESSAdapter as ESSAdapter2 } from "@egds/react-search-experience";
var MAX_RESULTS_SHIP_EMPTY_TERM = 25;
var MAX_RESULTS_PORT_EMPTY_TERM = 25;
var NUM_TOP_POPULAR_DEPARTURE_PORTS = 25;
var getIcon = function(domainId) {
    switch(domainId){
        case "CRUISE_SHIP" /* CRUISE_SHIP */ :
            return "lob_cruise";
        default:
            return "place";
    }
};
var getDeeplink = function(result) {
    switch(result.domainId){
        case "CRUISE_PORT" /* CRUISE_PORT */ :
            return result.metadata ? result.metadata.portDeepLink : "";
        default:
            return result.ids.id;
    }
};
var getSubtext = function(result) {
    switch(result.domainId){
        case "CRUISE_SHIP" /* CRUISE_SHIP */ :
            var _result_metadata;
            return ((_result_metadata = result.metadata) === null || _result_metadata === void 0 ? void 0 : _result_metadata.cruiseLineName) || "";
        case "CRUISE_PORT" /* CRUISE_PORT */ :
            return result.names.secondaryDisplayName || "";
        default:
            return "";
    }
};
var generateNewResults = function(newResults, result) {
    var _result_metadata;
    var primaryText = result.domainId === "CRUISE_PORT" /* CRUISE_PORT */  ? result.names.primaryDisplayName : result.names.displayName;
    var subtext = getSubtext(result);
    var deeplink = getDeeplink(result);
    var newResult = {
        data: {
            type: (_result_metadata = result.metadata) === null || _result_metadata === void 0 ? void 0 : _result_metadata.type,
            value: deeplink
        },
        icon: getIcon(result.domainId),
        name: primaryText,
        subtext: subtext,
        title: primaryText,
        value: primaryText
    };
    newResults.push(newResult);
    if (newResults.length === NUM_TOP_POPULAR_DEPARTURE_PORTS && result.domainId === "CRUISE_PORT" /* CRUISE_PORT */ ) {
        newResults.forEach(function(res) {
            res.data.type = "TOP_POPULAR_DEPARTURE_PORTS";
        });
    }
    return newResults;
};
var CruiseESSAdapter = /*#__PURE__*/ function(ESSAdapter2) {
    "use strict";
    _inherits(CruiseESSAdapter, ESSAdapter2);
    var _super = _create_super(CruiseESSAdapter);
    function CruiseESSAdapter(config) {
        _class_call_check(this, CruiseESSAdapter);
        var _this;
        _this = _super.call(this, config);
        __publicField(_assert_this_initialized(_this), "config");
        __publicField(_assert_this_initialized(_this), "ESSCategories");
        /**
     * Used to set typeahead categories for categorization of results
     */ __publicField(_assert_this_initialized(_this), "setTypeaheadCategories", function() {
            var _this_config_essCategories;
            _this.ESSCategories = {};
            (_this_config_essCategories = _this.config.essCategories) === null || _this_config_essCategories === void 0 ? void 0 : _this_config_essCategories.forEach(function(category) {
                _this.ESSCategories[category.key] = category.value;
            });
        });
        /**
     * Constructs URL for typeahead suggest service
     * @param query
     */ __publicField(_assert_this_initialized(_this), "constructURL", function(query) {
            var baseURL = "".concat(_this.config.domain, "/api/v2/suggest");
            var _$config = {
                domainId: _this.config.domainId,
                lob: _this.config.lob,
                maxResults: _this.getMaxResults(query),
                siteid: _this.config.siteId,
                locale: _this.config.locale
            };
            var URLParams = function(params) {
                return Object.entries(params).map(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], val = _param[1];
                    return "".concat(key, "=").concat(encodeURIComponent(val));
                }).join("&");
            };
            return "".concat(baseURL, "?query=").concat(query, "&").concat(URLParams(_$config));
        });
        /**
     * Used to fetch the typeahead results from the suggest service
     * @param term
     */ __publicField(_assert_this_initialized(_this), "fetchResponse", function(term) {
            return fetch(_this.constructURL(term), {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_this.config.requestBody)
            }).then(function(response) {
                return response.json();
            });
        });
        /**
     * Returns maximum results for the typeahead component
     * @param query
     */ __publicField(_assert_this_initialized(_this), "getMaxResults", function(query) {
            if (!query) {
                if (_this.config.domainId === "CRUISE_SHIP" /* CRUISE_SHIP */ ) {
                    return MAX_RESULTS_SHIP_EMPTY_TERM;
                }
                if (_this.config.domainId === "CRUISE_PORT" /* CRUISE_PORT */ ) {
                    return MAX_RESULTS_PORT_EMPTY_TERM;
                }
            }
            return _this.config.maxResults;
        });
        /**
     * Accepts the suggest api response and adapts it to typeahead results
     * @param results
     */ // eslint-disable-next-line class-methods-use-this
        __publicField(_assert_this_initialized(_this), "adaptResponseToTypeaheadResults", function(results) {
            var adapt = function(json) {
                var _json_suggestions_reduce, _json_suggestions;
                return (_json_suggestions = json.suggestions) === null || _json_suggestions === void 0 ? void 0 : (_json_suggestions_reduce = _json_suggestions.reduce) === null || _json_suggestions_reduce === void 0 ? void 0 : _json_suggestions_reduce.call(_json_suggestions, generateNewResults, []);
            };
            return adapt(results);
        });
        _this.config = config;
        return _this;
    }
    return CruiseESSAdapter;
}(ESSAdapter2);
// src/components/cruises/utils/destination-adapter-request-mapper.ts
var DEFAULT_MAX_NUMBER_OF_RESULTS = 25;
var DEFAULT_REGION_TYPE = 2047;
var DEFAULT_LINE_OF_BUSINESS = "CRUISES";
var defaultCruiseESSAdapterConfig = {
    client: "",
    dest: false,
    expuserid: -1,
    features: "",
    guid: "",
    locale: "",
    maxResults: DEFAULT_MAX_NUMBER_OF_RESULTS,
    personalize: false,
    regionType: DEFAULT_REGION_TYPE,
    siteId: 1,
    lob: DEFAULT_LINE_OF_BUSINESS,
    domain: "",
    domainId: "",
    requestBody: null,
    essCategories: void 0
};
var getCruiseESSAdapter = function(data, locale, guid, siteId) {
    var _locationField_action;
    var typeaheadAdapterDetails2 = data.typeaheadAdapterDetails;
    var locationField = data.elements.find(function(element) {
        return element.__typename === "EGDSSearchFormLocationField";
    });
    if ((locationField === null || locationField === void 0 ? void 0 : locationField.__typename) === "EGDSSearchFormLocationField" && ((_locationField_action = locationField.action) === null || _locationField_action === void 0 ? void 0 : _locationField_action.__typename) === "OpenTypeaheadAction") {
        var info = locationField.action.info;
        var expuserid = Number(info.expUserId) || -1;
        var config = _object_spread_props(_object_spread({}, defaultCruiseESSAdapterConfig), {
            expuserid: expuserid,
            locale: locale,
            guid: guid,
            siteId: siteId
        });
        var _info_client, _info_isDestination, _info_typeaheadFeatures, _info_maxNumberOfResults, _info_personalize, _info_regionType, _info_lineOfBusiness, _info_domain, _typeaheadAdapterDetails2_domainId, _typeaheadAdapterDetails2_adapterRequest, _typeaheadAdapterDetails2_categoryDetails;
        return new CruiseESSAdapter(_object_spread_props(_object_spread({}, config), {
            client: (_info_client = info.client) !== null && _info_client !== void 0 ? _info_client : "",
            dest: (_info_isDestination = info.isDestination) !== null && _info_isDestination !== void 0 ? _info_isDestination : false,
            features: (_info_typeaheadFeatures = info.typeaheadFeatures) !== null && _info_typeaheadFeatures !== void 0 ? _info_typeaheadFeatures : "",
            maxResults: (_info_maxNumberOfResults = info.maxNumberOfResults) !== null && _info_maxNumberOfResults !== void 0 ? _info_maxNumberOfResults : DEFAULT_MAX_NUMBER_OF_RESULTS,
            personalize: (_info_personalize = info.personalize) !== null && _info_personalize !== void 0 ? _info_personalize : false,
            regionType: (_info_regionType = info.regionType) !== null && _info_regionType !== void 0 ? _info_regionType : DEFAULT_REGION_TYPE,
            lob: (_info_lineOfBusiness = info.lineOfBusiness) !== null && _info_lineOfBusiness !== void 0 ? _info_lineOfBusiness : DEFAULT_LINE_OF_BUSINESS,
            domain: (_info_domain = info.domain) !== null && _info_domain !== void 0 ? _info_domain : "",
            domainId: (_typeaheadAdapterDetails2_domainId = typeaheadAdapterDetails2 === null || typeaheadAdapterDetails2 === void 0 ? void 0 : typeaheadAdapterDetails2.domainId) !== null && _typeaheadAdapterDetails2_domainId !== void 0 ? _typeaheadAdapterDetails2_domainId : "",
            requestBody: (_typeaheadAdapterDetails2_adapterRequest = typeaheadAdapterDetails2 === null || typeaheadAdapterDetails2 === void 0 ? void 0 : typeaheadAdapterDetails2.adapterRequest) !== null && _typeaheadAdapterDetails2_adapterRequest !== void 0 ? _typeaheadAdapterDetails2_adapterRequest : null,
            essCategories: (_typeaheadAdapterDetails2_categoryDetails = typeaheadAdapterDetails2 === null || typeaheadAdapterDetails2 === void 0 ? void 0 : typeaheadAdapterDetails2.categoryDetails) !== null && _typeaheadAdapterDetails2_categoryDetails !== void 0 ? _typeaheadAdapterDetails2_categoryDetails : void 0
        }));
    }
    return new CruiseESSAdapter(_object_spread_props(_object_spread({}, defaultCruiseESSAdapterConfig), {
        locale: locale,
        guid: guid,
        siteId: siteId
    }));
};
// src/components/cruises/form/__private/layout-field-config.ts
import { ViewSizes as ViewSizes10 } from "@shared-ui/viewport-context";
var defaultFieldConfig2 = {
    grow: 5,
    minWidth: 200,
    maxWidth: "full_width"
};
var defaultViewportConfig2 = {
    EGDSSearchFormLocationField: {
        minWidth: 200,
        maxWidth: 288,
        grow: 5
    },
    EGDSSearchFormDatePickerField: defaultFieldConfig2,
    SearchFormDurationSpanField: defaultFieldConfig2,
    EGDSSearchFormTravelersField: defaultFieldConfig2,
    EGDSSearchFormButton: {
        grow: 0
    },
    default: defaultFieldConfig2
};
var _obj9;
var layoutFieldConfigViewportMapping3 = (_obj9 = {}, _define_property(_obj9, ViewSizes10.SMALL, _object_spread_props(_object_spread({}, defaultViewportConfig2), {
    EGDSSearchFormLocationField: defaultFieldConfig2,
    EGDSSearchFormButton: {
        grow: 1,
        minWidth: 315
    },
    default: defaultFieldConfig2
})), _define_property(_obj9, ViewSizes10.MEDIUM, _object_spread_props(_object_spread({}, defaultViewportConfig2), {
    EGDSSearchFormButton: {
        grow: 0,
        minWidth: 32
    }
})), _define_property(_obj9, ViewSizes10.LARGE, _object_spread_props(_object_spread({}, defaultViewportConfig2), {
    EGDSSearchFormTravelersField: {
        minWidth: 200,
        maxWidth: 200,
        grow: 5
    }
})), _define_property(_obj9, ViewSizes10.EXTRA_LARGE, defaultViewportConfig2), _obj9);
var getFlexItemPropsByFieldType3 = function(fieldTypename, viewportSize) {
    var componentPropsMappingByViewport = layoutFieldConfigViewportMapping3[viewportSize];
    var _componentPropsMappingByViewport_fieldTypename;
    return (_componentPropsMappingByViewport_fieldTypename = componentPropsMappingByViewport[fieldTypename]) !== null && _componentPropsMappingByViewport_fieldTypename !== void 0 ? _componentPropsMappingByViewport_fieldTypename : componentPropsMappingByViewport.default;
};
// src/components/cruises/form/__private/cruise-search-form.tsx
var fieldComponents5 = [
    EGDSSearchFormLocationField,
    EGDSSearchFormDatePickerField,
    SearchFormDurationSpanField,
    EGDSSearchFormTravelersField,
    EGDSSearchFormButton
];
var _fragment6 = gql91(_templateObject95(), EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormButton.fragment, SearchFormDurationSpanField.fragment, EGDSErrorSummary.fragment, EGDSSearchPlayback.fragment, EGDSSearchFormTravelersField.fragment, SearchLocationFragment);
var defaultErrorState = {
    displayErrorSummary: false,
    errorCount: 0,
    errorLinkReference: null,
    fieldsWithErrors: []
};
var AdditionalPropsByField = _define_property({}, EGDSSearchFormLocationField.displayName, {});
var FormFieldsLayout2 = function(param) {
    var viewSize = param.viewSize, fields = param.fields, errorState = param.errorState, defaultValidationProps = param.defaultValidationProps;
    return /* @__PURE__ */ React122.createElement(UitkLayoutFlex26, {
        alignContent: "end",
        alignItems: "start",
        justifyContent: "center",
        wrap: "wrap",
        space: "three"
    }, fields.map(function(element, index) {
        var __typename = element.__typename;
        var FieldComponent = fieldComponents5.find(function(param) {
            var displayName = param.displayName;
            return displayName === __typename;
        });
        if (!FieldComponent) {
            return null;
        }
        var flexItemProps = getFlexItemPropsByFieldType3(__typename, viewSize);
        var fieldError = errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === __typename;
        });
        var validationProps = _object_spread_props(_object_spread({}, defaultValidationProps), {
            fieldError: fieldError
        });
        var fieldComponentProps = _object_spread({}, validationProps, AdditionalPropsByField[__typename]);
        return /* @__PURE__ */ React122.createElement(UitkLayoutFlexItem23, _object_spread({
            key: "field_".concat(__typename, "_").concat(index)
        }, flexItemProps), /* @__PURE__ */ React122.createElement("div", null, /* @__PURE__ */ React122.createElement(FieldComponent, _object_spread({
            data: element
        }, fieldComponentProps))));
    }));
};
var CruiseSearchForm2 = function(param) {
    var data = param.data, onFieldChange = param.onFieldChange, onSubmit = param.onSubmit, triggerSubmitOnFieldChange = param.triggerSubmitOnFieldChange, redirectToSearchResultOnSubmit = param.redirectToSearchResultOnSubmit;
    var context = useBexApi13().context;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var _ref = identity || {}, guid = _ref.duaid;
    var localizationContext = useLocalization16();
    var _React122_useState = _sliced_to_array(React122.useState({
        EGDSSearchFormLocationField: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React122_useState[0], setFieldsRefs = _React122_useState[1];
    var formRef = React122.useRef(null);
    var _React122_useState1 = _sliced_to_array(React122.useState(defaultErrorState), 2), errorState = _React122_useState1[0], setErrorState = _React122_useState1[1];
    var egdsElementId = data.egdsElementId, elements = data.elements, search6 = data.search, actionURL = data.actionURL, errorSummary5 = data.errorSummary, playback = data.playback, expertAdviceInfo = data.expertAdviceInfo, searchLocation = data.searchLocation;
    var _React122_useState2 = _sliced_to_array(React122.useState(playback), 2), playbackData = _React122_useState2[0], setPlaybackData = _React122_useState2[1];
    var _React122_useState3 = _sliced_to_array(React122.useState(true), 2), displayToggle = _React122_useState3[0], setDisplayToggle = _React122_useState3[1];
    var handlePlaybackToggle = function(open) {
        setDisplayToggle(open);
    };
    React122.useEffect(function() {
        setPlaybackData(playback);
    }, [
        playback
    ]);
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "cruise_search_form";
    var renderableElements = search6 ? _to_consumable_array(elements).concat([
        search6
    ]) : elements;
    var setFieldRefByTypename = React122.useCallback(function(typename, ref) {
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typename, ref));
        });
    }, []);
    var defaultValidationProps = {
        setFieldRefByTypename: setFieldRefByTypename
    };
    var handleFieldChange = function(field, event) {
        if (onFieldChange) {
            onFieldChange(field, event);
        }
        if (triggerSubmitOnFieldChange) {
            var _formRef_current;
            (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.dispatchEvent(new Event("submit", {
                cancelable: true,
                bubbles: true
            }));
        }
        setPlaybackData(function(prevPlaybackState) {
            if (!prevPlaybackState) {
                return null;
            }
            var DESTINATION = FieldNameMap6.DESTINATION, DATES = FieldNameMap6.DATES, DURATION = FieldNameMap6.DURATION;
            var primary = prevPlaybackState.primary, secondaries = prevPlaybackState.secondaries;
            var text = field.value;
            var newPrimary = field.name === DESTINATION ? _object_spread_props(_object_spread({}, primary), {
                text: text
            }) : primary;
            var _secondaries = _sliced_to_array(secondaries, 2), dates = _secondaries[0], duration = _secondaries[1];
            var isDateRangePicker = field.name === DATES;
            var newSecondaryDates = isDateRangePicker && dates.__typename === "EGDSBasicLocalizedText" ? _object_spread_props(_object_spread({}, dates), {
                text: getFormattedDates(text, localizationContext),
                template: dates.template,
                accessibilityTemplate: formatLocalizedString(dates.template, dates.models, getFormattedDates(text, localizationContext)),
                models: dates.models,
                egdsElementId: dates.egdsElementId
            }) : dates;
            var newSecondaryDuration = field.name === DURATION && duration.__typename === "EGDSCardinalLocalizedText" ? _object_spread_props(_object_spread({}, duration), {
                text: text,
                accessibilityText: formatDurationLocalizedString(duration.templates, duration.models, text.substring(0, text.lastIndexOf(" "))),
                models: duration.models,
                templates: duration.templates,
                egdsElementId: duration.egdsElementId
            }) : duration;
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary,
                secondaries: [
                    newSecondaryDates,
                    newSecondaryDuration
                ]
            });
        });
    };
    var handleSubmit = function(event) {
        var _formElements_find;
        var formElements = Array.from(event.currentTarget.elements);
        var isDestinationEmpty = !((_formElements_find = formElements.find(findFieldByNameAttribute("EGDSSearchFormLocationField-Location-destination_form_field"))) === null || _formElements_find === void 0 ? void 0 : _formElements_find.value);
        if (isDestinationEmpty) {
            setErrorState({
                fieldsWithErrors: [
                    {
                        __typename: "EGDSSearchFormLocationField",
                        isValid: false
                    }
                ],
                errorCount: 1,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs.EGDSSearchFormLocationField
            });
            event.preventDefault();
            return;
        }
        setErrorState(defaultErrorState);
        var queryParams = getSearchToolsQueryParams("CRUISES" /* CRUISES */ , formElements);
        if (onSubmit) {
            var urlSearchParams = new URLSearchParams(queryParams);
            var cruiseSearchCriteriaInput = getCruiseSearchCriteria(urlSearchParams);
            onSubmit(event, {
                cruiseSearchCriteriaInput: cruiseSearchCriteriaInput
            });
        }
        if (redirectToSearchResultOnSubmit) {
            event.preventDefault();
            window.location.href = "".concat(event.currentTarget.action).concat(queryParams);
        }
    };
    var typeaheadAdapter = getCruiseESSAdapter(data, locale, guid, siteId);
    typeaheadAdapter.setTypeaheadCategories();
    AdditionalPropsByField[EGDSSearchFormLocationField.displayName] = {
        adapter: typeaheadAdapter
    };
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var showErrorSummary = errorSummary5 && displayErrorSummary;
    var fieldsProps = {
        fields: renderableElements,
        errorState: errorState,
        defaultValidationProps: defaultValidationProps,
        searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
    };
    return /* @__PURE__ */ React122.createElement(UitkForm11, {
        ref: formRef,
        id: id,
        name: id,
        method: "GET",
        action: actionURL,
        onFieldChange: handleFieldChange,
        onSubmit: handleSubmit,
        hasRequiredFieldIndicator: true
    }, expertAdviceInfo && /* @__PURE__ */ React122.createElement(UitkSpacing39, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React122.createElement(UitkSubheading2, {
        tag: "p"
    }, expertAdviceInfo)), showErrorSummary && /* @__PURE__ */ React122.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }), /* @__PURE__ */ React122.createElement(UitkSpacing39, {
        margin: {
            blockstart: showErrorSummary ? "two" : void 0
        }
    }, /* @__PURE__ */ React122.createElement("div", null, /* @__PURE__ */ React122.createElement(Viewport33, null, /* @__PURE__ */ React122.createElement(ViewSmall31, null, playbackData ? /* @__PURE__ */ React122.createElement(EGDSSearchPlayback, {
        data: playbackData,
        display: displayToggle,
        onDisplayToggle: handlePlaybackToggle
    }, /* @__PURE__ */ React122.createElement(FormFieldsLayout2, _object_spread({
        viewSize: ViewSizes11.SMALL
    }, fieldsProps))) : /* @__PURE__ */ React122.createElement(FormFieldsLayout2, _object_spread({
        viewSize: ViewSizes11.SMALL
    }, fieldsProps))), /* @__PURE__ */ React122.createElement(ViewMedium30, null, /* @__PURE__ */ React122.createElement(FormFieldsLayout2, _object_spread({
        viewSize: ViewSizes11.MEDIUM
    }, fieldsProps))), /* @__PURE__ */ React122.createElement(ViewLarge12, null, /* @__PURE__ */ React122.createElement(FormFieldsLayout2, _object_spread({
        viewSize: ViewSizes11.LARGE
    }, fieldsProps)))))));
};
CruiseSearchForm2.fragment = _fragment6;
CruiseSearchForm2.displayName = "CruiseSearchForm";
// src/components/cruises/form/client-events.ts
import { SystemEvent as SystemEvent9, SystemEventLevel as SystemEventLevel9 } from "@shared-ui/logger-context";
var CLIENT_EVENTS7 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_CRUISES_SEARCH_FORM_QUERY_FAILURE: new SystemEvent9(SystemEventLevel9.ERROR, "SEARCH_TOOLS_CRUISES_SEARCH_FORM_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS6 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_CRUISES_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Cruises Search Form Fallback Presented",
        referrerId: "Web.Cruises.Search.Form.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_CRUISES_SEARCH_FORM_IMPRESSION: {
        linkName: "Cruises Search Form Presented",
        referrerId: "Web.Cruises.Search.Form.Presented"
    }
};
// src/components/cruises/form/cruises-search-form.tsx
var __Query9 = gql92(_templateObject96(), CruiseSearchForm2.fragment);
var smallViewportFormSkeletonProps4 = {
    rows: [
        {
            type: "primary"
        },
        {
            type: "primary"
        },
        {
            type: "primary"
        }
    ]
};
var mediumViewportFormSkeletonProps4 = {
    rows: [
        {
            type: "primary"
        }
    ]
};
var CruiseSearchForm = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, onFieldChange = props.onFieldChange, onSubmit = props.onSubmit, triggerSubmitOnFieldChange = props.triggerSubmitOnFieldChange, batchKey = props.batchKey, includePlayback = props.includePlayback, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit;
    var context = useBexApi14().context;
    var systemEvents = useLoggerEvents8(CLIENT_EVENTS7);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: !!includePlayback
    });
    var _React123_useState = _sliced_to_array(React123.useState(skipQuery), 2), skip = _React123_useState[0], setSkip = _React123_useState[1];
    var results = useQuery9(__Query9, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skip
    });
    var error = results.error, loading = results.loading, previousData = results.previousData;
    var data = results.data;
    React123.useEffect(function() {
        setSkip(skipQuery && !loading);
    }, [
        skipQuery,
        loading
    ]);
    if (loading && !data) {
        return /* @__PURE__ */ React123.createElement(Viewport34, null, /* @__PURE__ */ React123.createElement(ViewSmall32, null, /* @__PURE__ */ React123.createElement(FormSkeleton, _object_spread({}, smallViewportFormSkeletonProps4))), /* @__PURE__ */ React123.createElement(ViewMedium31, null, /* @__PURE__ */ React123.createElement(FormSkeleton, _object_spread({}, mediumViewportFormSkeletonProps4))));
    }
    if (!data && previousData) {
        data = previousData;
    }
    if (error) {
        systemEvents.SEARCH_TOOLS_CRUISES_SEARCH_FORM_QUERY_FAILURE.log({
            name: error.name,
            error: new Error(error.message)
        });
    }
    if (error || !data) {
        var fallback = getFallbackData4();
        if (fallback.__typename === "CruiseSearchForm") {
            return /* @__PURE__ */ React123.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React123.createElement(IntersectionTracker8, _object_spread({}, CLIENT_TRACKING_EVENTS6.SEARCH_TOOLS_CRUISES_SEARCH_FORM_FALLBACK_IMPRESSION), /* @__PURE__ */ React123.createElement(CruiseSearchForm2, {
                data: fallback,
                onFieldChange: onFieldChange,
                onSubmit: onSubmit,
                triggerSubmitOnFieldChange: triggerSubmitOnFieldChange,
                redirectToSearchResultOnSubmit: redirectToSearchResultOnSubmit
            })));
        }
    }
    if (!data || data.searchForm.cruise.__typename !== "CruiseSearchForm") {
        return null;
    }
    return /* @__PURE__ */ React123.createElement(IntersectionTracker8, _object_spread({}, CLIENT_TRACKING_EVENTS6.SEARCH_TOOLS_CRUISES_SEARCH_FORM_IMPRESSION), /* @__PURE__ */ React123.createElement(CruiseSearchForm2, {
        data: data.searchForm.cruise,
        onFieldChange: onFieldChange,
        onSubmit: onSubmit,
        triggerSubmitOnFieldChange: triggerSubmitOnFieldChange,
        redirectToSearchResultOnSubmit: redirectToSearchResultOnSubmit
    }));
};
CruiseSearchForm.displayName = "sharedui-CruiseSearchForm";
// src/components/flights/form/search-form.tsx
import React131 from "react";
import { SearchFormReflectionProvider as SearchFormReflectionProvider4 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewMedium as ViewMedium36, Viewport as Viewport39, ViewSizes as ViewSizes17, ViewSmall as ViewSmall37 } from "@shared-ui/viewport-context";
// src/components/flights/form/flight-options.tsx
import React125 from "react";
import { gql as gql94, useQuery as useQuery10 } from "@apollo/client";
import { useBexApi as useBexApi15 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents9 } from "@shared-ui/logger-context";
import { ViewMedium as ViewMedium32, Viewport as Viewport35, ViewSmall as ViewSmall33 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm12 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex27, UitkLayoutFlexItem as UitkLayoutFlexItem24 } from "uitk-react-layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton5 } from "uitk-react-skeleton";
// src/components/flights/utils/flight-options-fallback-data.ts
var getFallbackData5 = function() {
    return {
        searchForm: {
            flight: {
                directFlightsOnly: null,
                flightTypeSelector: {
                    action: {
                        analytics: {
                            linkName: "Web.Flight - Open Flight Type Selector",
                            referrerId: "Web.Flight.flight.type.selector.open",
                            __typename: "ClientSideAnalytics"
                        },
                        options: [
                            {
                                changeAnalytics: {
                                    linkName: "Flight roundtrip change",
                                    referrerId: "Web.Flight.Search.Tab.Roundtrip",
                                    __typename: "ClientSideAnalytics"
                                },
                                value: "ROUND_TRIP",
                                label: "Roundtrip",
                                selected: true,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                changeAnalytics: {
                                    linkName: "Flight one way change",
                                    referrerId: "Web.Flight.Search.Tab.Oneway",
                                    __typename: "ClientSideAnalytics"
                                },
                                value: "ONE_WAY",
                                label: "One-way",
                                selected: false,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                changeAnalytics: {
                                    linkName: "Flight multicity change",
                                    referrerId: "Web.Flight.Search.Tab.Multicity",
                                    __typename: "ClientSideAnalytics"
                                },
                                value: "MULTI_CITY",
                                label: "Multi-city",
                                selected: false,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        apply: {
                            egdsElementId: "flight_type_selector",
                            primary: "Apply",
                            disabled: false,
                            accessibility: null,
                            icon: null,
                            analytics: {
                                linkName: "Web.Flight - Flight Type Apply",
                                referrerId: "Web.Flight.flight.type.selector.apply.button.click",
                                __typename: "ClientSideAnalytics"
                            },
                            action: null,
                            __typename: "UIPrimaryButton"
                        },
                        __typename: "EGDSSearchFormSelectAction"
                    },
                    __typename: "EGDSSearchFormInputField"
                },
                elements: [
                    {
                        egdsElementId: "cabin_class",
                        value: "COACH",
                        label: "Cabin class",
                        placeholder: "Economy",
                        leftIcon: {
                            id: "airline_seat_recline_extra",
                            title: null,
                            token: "icon__airline_seat_recline_extra",
                            description: "airline_seat_recline_extra",
                            size: null,
                            __typename: "Icon"
                        },
                        action: {
                            analytics: {
                                linkName: "Open Cabin Class Selector",
                                referrerId: "Web.Flight.cabin.class.selector.open",
                                __typename: "ClientSideAnalytics"
                            },
                            options: [
                                {
                                    label: "Economy",
                                    selected: true,
                                    value: "COACH",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    label: "Premium economy",
                                    selected: false,
                                    value: "ECONOMY_PREMIUM",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    label: "Business class",
                                    selected: false,
                                    value: "BUSINESS",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    label: "First class",
                                    selected: false,
                                    value: "FIRST_CLASS",
                                    __typename: "EGDSBasicOption"
                                }
                            ],
                            __typename: "EGDSSearchFormSelectAction"
                        },
                        __typename: "EGDSSearchFormInputField"
                    }
                ],
                __typename: "FlightSearchForm"
            },
            __typename: "SearchFormResults"
        }
    };
};
// src/components/flights/form/__private/flight-type-selector-options.tsx
import React124 from "react";
import { gql as gql93 } from "@apollo/client";
import { UitkTab as UitkTab3, UitkTabs as UitkTabs3, UitkTabsType as UitkTabsType4 } from "@egds/react-core/tabs";
import { useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes as defaultViewSizes6, useMediaQueries as useMediaQueries6 } from "@shared-ui/viewport-context";
var __Fragment64 = gql93(_templateObject97(), EGDSPrimaryButton.fragment);
var FLIGHTS_TRIP_TYPE_MAP = {
    ONE_WAY: "ONE_WAY" /* ONE_WAY */ ,
    ROUND_TRIP: "ROUND_TRIP" /* ROUND_TRIP */ ,
    MULTI_CITY: "MULTI_DESTINATION" /* MULTI_DESTINATION */ 
};
var FlightTypeSelectorOptions = function(param) {
    var data = param.data, onFlightTypeSelect = param.onFlightTypeSelect;
    var viewportSize = useMediaQueries6({
        viewSizes: defaultViewSizes6
    });
    var track = useClickTracker32();
    var options = data.options.filter(function(param) {
        var __typename = param.__typename;
        return __typename === "EGDSBasicOption";
    });
    var _React124_useState = _sliced_to_array(React124.useState(options.findIndex(function(option) {
        return option.selected;
    })), 2), selectedTab = _React124_useState[0], setSelectedTab = _React124_useState[1];
    var onTabSelect = function(index) {
        var _options_index = options[index], value = _options_index.value, changeAnalytics = _options_index.changeAnalytics;
        setSelectedTab(index);
        onFlightTypeSelect === null || onFlightTypeSelect === void 0 ? void 0 : onFlightTypeSelect(FlightsTripType[FLIGHTS_TRIP_TYPE_MAP[value]]);
        if (changeAnalytics) {
            var linkName = changeAnalytics.linkName, referrerId = changeAnalytics.referrerId;
            track(linkName, referrerId);
        }
    };
    var isSmallViewportSize = viewportSize <= defaultViewSizes6.SMALL;
    var tabsProps = {
        selectedTab: selectedTab,
        onTabSelect: onTabSelect,
        tabsType: isSmallViewportSize ? UitkTabsType4.EQUAL_WIDTH : UitkTabsType4.NATURAL
    };
    return /* @__PURE__ */ React124.createElement(UitkTabs3, _object_spread({}, tabsProps), options.map(function(param) {
        var value = param.value, label = param.label;
        return /* @__PURE__ */ React124.createElement(UitkTab3, {
            id: "FlightSearchForm_".concat(value),
            key: value,
            name: label,
            targetURI: "#FlightSearchForm_".concat(value)
        });
    }));
};
FlightTypeSelectorOptions.fragment = __Fragment64;
FlightTypeSelectorOptions.displayName = "FlightTypeSelectorOptions";
// src/components/flights/form/client-events.ts
import { SystemEvent as SystemEvent10, SystemEventLevel as SystemEventLevel10 } from "@shared-ui/logger-context";
var CLIENT_EVENTS8 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_QUERY_FAILURE: new SystemEvent10(SystemEventLevel10.ERROR, "SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_QUERY_FAILURE"),
    SEARCH_TOOLS_FLIGHTS_OPTIONS_QUERY_FAILURE: new SystemEvent10(SystemEventLevel10.ERROR, "SEARCH_TOOLS_FLIGHTS_OPTIONS_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS7 = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_FALLBACK_IMPRESSION: {
        linkName: "Flights Search Form Fallback Presented",
        referrerId: "Web.Flights.Search.Form.Fallback.Presented"
    },
    SEARCH_TOOLS_FLIGHTS_OPTIONS_FALLBACK_IMPRESSION: {
        linkName: "Flights Options Fallback Presented",
        referrerId: "Web.Flights.Options.Fallback.Presented"
    },
    /**
   * Event to track the presentation of the search form
   * This is temporary hardcoded directly as it is part of a PoC
   * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
   */ SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_IMPRESSION: {
        linkName: "Flights Search Form Presented",
        referrerId: "Web.Flights.Search.Form.Presented"
    },
    SEARCH_TOOLS_FLIGHTS_OPTIONS_IMPRESSION: {
        linkName: "Flights Options Presented",
        referrerId: "Web.Flights.Options.Presented"
    }
};
// src/components/flights/form/flight-options.tsx
var __Query10 = gql94(_templateObject98(), FlightTypeSelectorOptions.fragment, EGDSSearchFormInputField.fragment, EGDSPill.fragment);
var FlightOptions = function(props) {
    var _data_searchForm, _flightTypeSelector_action;
    var inputs = props.inputs, skipSsr = props.skipSsr, onFlightTypeSelect = props.onFlightTypeSelect, onCabinClassSelect = props.onCabinClassSelect, onDirectFlightsSelect = props.onDirectFlightsSelect, batchKey = props.batchKey;
    var includeFlightType = inputs.includeFlightType;
    var context = useBexApi15().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var systemEvents = useLoggerEvents9(CLIENT_EVENTS8);
    var _useQuery10 = useQuery10(__Query10, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery10.data, error = _useQuery10.error, loading = _useQuery10.loading;
    var flightsOptionsData = data;
    React125.useEffect(function() {
        if (onCabinClassSelect) {
            var _cabinClassField_action;
            var cabinClassField = (flightsOptionsData === null || flightsOptionsData === void 0 ? void 0 : flightsOptionsData.searchForm.flight.__typename) === "FlightSearchForm" ? flightsOptionsData.searchForm.flight.elements.find(function(element) {
                var _element_action;
                return element.__typename === "EGDSSearchFormInputField" && ((_element_action = element.action) === null || _element_action === void 0 ? void 0 : _element_action.__typename) === "EGDSSearchFormSelectAction";
            }) : null;
            if ((cabinClassField === null || cabinClassField === void 0 ? void 0 : cabinClassField.__typename) === "EGDSSearchFormInputField" && ((_cabinClassField_action = cabinClassField.action) === null || _cabinClassField_action === void 0 ? void 0 : _cabinClassField_action.__typename) === "EGDSSearchFormSelectAction") {
                var cabinClassFieldName = "".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-").concat(cabinClassField.egdsElementId);
                var selectedOption = cabinClassField.action.options.find(function(option) {
                    return option.selected;
                });
                var _selectedOption_value;
                onCabinClassSelect({
                    name: cabinClassFieldName,
                    value: (_selectedOption_value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== null && _selectedOption_value !== void 0 ? _selectedOption_value : ""
                });
            }
        }
    }, [
        flightsOptionsData === null || flightsOptionsData === void 0 ? void 0 : flightsOptionsData.searchForm,
        onCabinClassSelect
    ]);
    if (loading) {
        return /* @__PURE__ */ React125.createElement(UitkLineSkeleton5, {
            animation: true,
            type: "secondary"
        });
    }
    var hasError = error || !data;
    if (hasError || ((_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : _data_searchForm.flight.__typename) !== "FlightSearchForm") {
        flightsOptionsData = getFallbackData5();
        systemEvents.SEARCH_TOOLS_FLIGHTS_OPTIONS_QUERY_FAILURE.log({
            name: error === null || error === void 0 ? void 0 : error.name,
            error: new Error(error === null || error === void 0 ? void 0 : error.message)
        });
    }
    var FallbackWrapper = hasError ? FallbackIndicatorWrapper : React125.Fragment;
    var _ref = flightsOptionsData === null || flightsOptionsData === void 0 ? void 0 : flightsOptionsData.searchForm.flight, elements = _ref.elements, flightTypeSelector = _ref.flightTypeSelector, directFlightsOnly = _ref.directFlightsOnly;
    var handleFieldChange = function(field) {
        onCabinClassSelect === null || onCabinClassSelect === void 0 ? void 0 : onCabinClassSelect(field);
    };
    var layoutFlexProps = {
        space: "three",
        alignItems: "start",
        wrap: "wrap"
    };
    var handleDirectFlightsSelect = function(event) {
        var checked = event.target.checked;
        onDirectFlightsSelect === null || onDirectFlightsSelect === void 0 ? void 0 : onDirectFlightsSelect(checked);
    };
    var typeSelector = includeFlightType && (flightTypeSelector === null || flightTypeSelector === void 0 ? void 0 : (_flightTypeSelector_action = flightTypeSelector.action) === null || _flightTypeSelector_action === void 0 ? void 0 : _flightTypeSelector_action.__typename) === "EGDSSearchFormSelectAction" && /* @__PURE__ */ React125.createElement(Viewport35, null, /* @__PURE__ */ React125.createElement(ViewSmall33, null, /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem24, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(FlightTypeSelectorOptions, {
        data: flightTypeSelector.action,
        onFlightTypeSelect: onFlightTypeSelect
    })))), /* @__PURE__ */ React125.createElement(ViewMedium32, null, /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(FlightTypeSelectorOptions, {
        data: flightTypeSelector.action,
        onFlightTypeSelect: onFlightTypeSelect
    })))));
    var cabinClass = /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(UitkForm12, {
        onFieldChange: handleFieldChange
    }, elements.map(function(element, idx) {
        return element.__typename === "EGDSSearchFormInputField" && /* @__PURE__ */ React125.createElement(EGDSSearchFormInputField, {
            data: element,
            triggerType: "pill" /* PILL */ ,
            key: idx
        });
    }))));
    var directFlights = directFlightsOnly && /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(EGDSPill, {
        data: directFlightsOnly,
        onChange: handleDirectFlightsSelect
    })));
    return /* @__PURE__ */ React125.createElement(FallbackWrapper, null, /* @__PURE__ */ React125.createElement(IntersectionTracker9, _object_spread({}, hasError ? CLIENT_TRACKING_EVENTS7.SEARCH_TOOLS_FLIGHTS_OPTIONS_FALLBACK_IMPRESSION : CLIENT_TRACKING_EVENTS7.SEARCH_TOOLS_FLIGHTS_OPTIONS_IMPRESSION), /* @__PURE__ */ React125.createElement(Viewport35, null, /* @__PURE__ */ React125.createElement(ViewSmall33, null, /* @__PURE__ */ React125.createElement(UitkLayoutFlex27, _object_spread({}, layoutFlexProps), typeSelector, cabinClass, directFlights)), /* @__PURE__ */ React125.createElement(ViewMedium32, null, /* @__PURE__ */ React125.createElement(UitkLayoutFlex27, _object_spread_props(_object_spread({}, layoutFlexProps), {
        alignItems: "center"
    }), typeSelector, cabinClass, directFlights)))));
};
FlightOptions.displayName = "sharedui-FlightOptions";
// src/components/flights/form/flights-search-form.tsx
import React130 from "react";
import { gql as gql96, useQuery as useQuery11 } from "@apollo/client";
import { useBexApi as useBexApi16 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents10 } from "@shared-ui/logger-context";
import { ViewMedium as ViewMedium35, Viewport as Viewport38, ViewSmall as ViewSmall36 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing42 } from "uitk-react-spacing";
// src/components/flights/utils/fallback-data-dates.ts
var TODAY3 = /* @__PURE__ */ new Date();
var START_DATE3 = /* @__PURE__ */ new Date();
START_DATE3.setDate(START_DATE3.getDate() + 14);
var DAY_AFTER_START_DATE3 = /* @__PURE__ */ new Date();
DAY_AFTER_START_DATE3.setDate(DAY_AFTER_START_DATE3.getDate() + 15);
var NEXT_TEN_MONTHS2 = /* @__PURE__ */ new Date();
NEXT_TEN_MONTHS2.setMonth(NEXT_TEN_MONTHS2.getMonth() + 10);
NEXT_TEN_MONTHS2.setDate(NEXT_TEN_MONTHS2.getDate() - 5);
function createDate3(date) {
    return {
        __typename: "Date",
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
}
var createDatePickerPlaceHolder = function(date) {
    var month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    return "".concat(month[date.getMonth()], " ").concat(date.getDate());
};
// src/components/flights/utils/flights-search-form-fallback-data.ts
var errorSummary4 = {
    egdsElementId: "search_form_error_summary",
    goToErrorLinkText: "Go to error",
    goToFirstErrorLinkText: "Go to first error",
    heading: "",
    body: null,
    analytics: {
        linkName: "Error summary link clicked",
        referrerId: "Web.Flight.Search.Error.Summary",
        __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
        linkName: "Error summary displayed",
        referrerId: "Web.Flight.Search.Error.Summary.Displayed",
        __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
        models: [
            {
                key: "errorCount",
                source: "errorCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "Please correct the error to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "Please correct the ${errorCount} errors to continue",
                __typename: "CardinalTemplate"
            }
        ],
        __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
};
var origin = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "origin_select",
    label: "Leaving from",
    placeholder: "Leaving from",
    value: null,
    errorMessage: "Please select where you're leaving from",
    validations: [
        {
            errorMessage: "Enter at least 3 characters of the airport name.",
            __typename: "EGDSMinLengthInputValidation"
        },
        {
            errorMessage: "Please select where you're leaving from",
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Origin Selection",
            referrerId: "Web.Flight.origin.location.open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "Homepage",
            drivable: false,
            isDestination: false,
            lineOfBusiness: "FLIGHTS",
            maxNumberOfResults: 10,
            packageType: null,
            personalize: true,
            regionType: 4959,
            typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: "roundtrip",
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "Search by city or airport",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
        linkName: "Origin Selection",
        referrerId: "Web.Flight.origin.location.close",
        __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
        linkName: "Origin change",
        referrerId: "Web.Flight.origin.location.change",
        __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
};
var destination3 = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "destination_select",
    label: "Going to",
    placeholder: "Going to",
    value: null,
    errorMessage: "Please select where you're going",
    validations: [
        {
            errorMessage: "Enter at least 3 characters of the airport name.",
            __typename: "EGDSMinLengthInputValidation"
        },
        {
            errorMessage: "Please select where you're going",
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Destination Selection",
            referrerId: "Web.Flight.destination.location.change",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "Homepage",
            drivable: false,
            isDestination: true,
            lineOfBusiness: "FLIGHTS",
            maxNumberOfResults: 10,
            packageType: null,
            personalize: true,
            regionType: 4959,
            typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo",
            subLob: "roundtrip",
            expUserId: "-1",
            trending: false
        },
        emptyResultsPlaceholder: "Search by city or airport",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
        linkName: "Destination Selection",
        referrerId: "Web.Flight.destination.location.close",
        __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
        linkName: "Destination change",
        referrerId: "Web.Flight.destination.location.change",
        __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
};
var horizontalSwapper = {
    __typename: "UISecondaryButton",
    egdsElementId: "location_swapper",
    primary: "",
    disabled: false,
    accessibility: "Swap origin and destination values",
    icon: {
        id: "",
        description: "swap_horiz",
        token: "",
        title: null,
        __typename: "Icon"
    },
    analytics: {
        linkName: "Swapper button clicked",
        referrerId: "Flight.locations.swapper.button.click",
        __typename: "ClientSideAnalytics"
    },
    action: null
};
var verticalSwapper = {
    __typename: "UISecondaryButton",
    egdsElementId: "location_swapper",
    primary: "",
    disabled: false,
    accessibility: "Swap origin and destination values",
    icon: {
        id: "",
        description: "swap_vert",
        token: "",
        title: null,
        __typename: "Icon"
    },
    analytics: {
        linkName: "Swapper button clicked",
        referrerId: "Flight.locations.swapper.button.click",
        __typename: "ClientSideAnalytics"
    },
    action: null
};
var validations = [
    {
        __typename: "EGDSSameValueInputValidation",
        errorMessage: "Please make sure your departure and arrival cities are different"
    }
];
var roundTripDatePickers = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date_form_field",
    label: "Dates",
    placeholder: "".concat(createDatePickerPlaceHolder(START_DATE3), " - ").concat(createDatePickerPlaceHolder(DAY_AFTER_START_DATE3)),
    errorMessage: "Check-out date must be after check-in date",
    validations: null,
    action: {
        accessibility: null,
        analytics: {
            linkName: "flight calendar selection",
            referrerId: "Web.Flight.Calendar.Open",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            flexibleDateContent: null,
            buttonText: "Done",
            buttonTextTemplate: null,
            clearButtonText: null,
            firstDayOfWeek: "SUN" /* SUN */ ,
            maxNumberOfDaysSelected: null,
            sameDaySelectionAllowed: false,
            selectedStartDate: _object_spread({}, createDate3(START_DATE3)),
            startDatePlaceholderText: createDatePickerPlaceHolder(START_DATE3),
            selectedEndDate: _object_spread({}, createDate3(DAY_AFTER_START_DATE3)),
            endDatePlaceholderText: createDatePickerPlaceHolder(DAY_AFTER_START_DATE3),
            validDaysLowerBoundInclusive: _object_spread({}, createDate3(TODAY3)),
            validDaysUpperBoundInclusive: _object_spread({}, createDate3(NEXT_TEN_MONTHS2)),
            submitButtonAnalytics: {
                linkName: "flight calendar submit",
                referrerId: "Web.Flight.Calendar.Submit",
                __typename: "ClientSideAnalytics"
            },
            nextButtonAnalytics: {
                linkName: "Calendar next",
                referrerId: "Web.Flight.Calendar.Next.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            previousButtonAnalytics: {
                linkName: "Calendar previous",
                referrerId: "Web.Flight.Calendar.Previous.Month.Click",
                __typename: "ClientSideAnalytics"
            },
            startDateButtonAnalytics: {
                linkName: "flight calendar start date click",
                referrerId: "Web.Flight.Calendar.Start.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            endDateButtonAnalytics: {
                linkName: "flight calendar end date click",
                referrerId: "Web.Flight.Calendar.End.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            clearDatesButtonAnalytics: null,
            showClearDatesButton: false,
            __typename: "EGDSDateRangePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var oneWayAndMultiCityDatePicker = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date_form_field",
    label: "Date",
    placeholder: createDatePickerPlaceHolder(START_DATE3),
    errorMessage: "Check-out date must be after check-in date",
    validations: null,
    action: {
        accessibility: null,
        analytics: {
            linkName: "flight calendar selection",
            referrerId: "Web.Flight.Calendar.Open",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            buttonText: "Done",
            firstDayOfWeek: "SUN" /* SUN */ ,
            selectedStartDate: _object_spread({}, createDate3(START_DATE3)),
            startDateButtonAnalytics: {
                linkName: "flight calendar start date click",
                referrerId: "Web.Flight.Calendar.Start.Date.Click",
                __typename: "ClientSideAnalytics"
            },
            submitButtonAnalytics: {
                linkName: "flight calendar submit",
                referrerId: "Web.Flight.Calendar.Submit",
                __typename: "ClientSideAnalytics"
            },
            validDaysLowerBoundInclusive: _object_spread({}, createDate3(TODAY3)),
            validDaysUpperBoundInclusive: _object_spread({}, createDate3(NEXT_TEN_MONTHS2)),
            __typename: "EGDSSingleDatePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var travelersField = {
    action: {
        analytics: {
            linkName: "Travelers selector displayed",
            referrerId: "Travelers selector updated",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            closeButton: {
                egdsElementId: "travelers_selector_close_button",
                primary: "Close",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers Selector Close button",
                    referrerId: "Web.Flight.Search.Traveler.Selector.Close.Button.Clicked",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            doneButton: {
                egdsElementId: "travelers_selector_done_button",
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers Selector Done button",
                    referrerId: "Web.Flight.Search.Traveler.Selector.Done.Button.Clicked",
                    __typename: "ClientSideAnalytics"
                },
                action: {
                    __typename: "ActivityAddOfferToTripAction",
                    accessibility: ""
                },
                __typename: "UIPrimaryButton"
            },
            title: "Travelers",
            travelers: {
                adults: {
                    decreaseAnalytics: {
                        linkName: "Adult traveler removed",
                        referrerId: "Web.Flights.Traveler.Remove.Adult",
                        __typename: "ClientSideAnalytics"
                    },
                    increaseAnalytics: {
                        linkName: "Adult traveler added",
                        referrerId: "Web.Flights.Traveler.Add.Adult",
                        __typename: "ClientSideAnalytics"
                    },
                    decreaseText: "Decrease the number of adults",
                    decreaseTextTemplate: null,
                    increaseText: "Increase the number of adults",
                    increaseTextTemplate: null,
                    egdsElementId: "traveler_selector_adult_step_input",
                    label: "Adults",
                    max: 6,
                    min: 1,
                    step: 1,
                    subLabel: null,
                    value: 1,
                    __typename: "EGDSTravelerStepInput"
                },
                children: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Children traveler removed",
                            referrerId: "Web.Flights.Traveler.Remove.Children",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Children traveler added",
                            referrerId: "Web.Flights.Traveler.Add.Children",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of children",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of children",
                        increaseTextTemplate: null,
                        egdsElementId: "traveler_selector_children_step_input",
                        label: "Children",
                        max: 5,
                        min: 0,
                        step: 1,
                        subLabel: "Ages 2 to 17",
                        value: 0,
                        __typename: "EGDSTravelerStepInput"
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "childNumber",
                                    source: "childNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Child ${childNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            {
                                label: "Select age",
                                value: "",
                                egdsElementId: "children_age_option",
                                __typename: "EGDSBasicOption",
                                changeAnalytics: null
                            },
                            {
                                label: "2",
                                value: "2",
                                egdsElementId: "children_age_option_2",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "3",
                                value: "3",
                                egdsElementId: "children_age_option_3",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "4",
                                value: "4",
                                egdsElementId: "children_age_option_4",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "5",
                                value: "5",
                                egdsElementId: "children_age_option_5",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "6",
                                value: "6",
                                egdsElementId: "children_age_option_6",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "7",
                                value: "7",
                                egdsElementId: "children_age_option_7",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "8",
                                value: "8",
                                egdsElementId: "children_age_option_8",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "9",
                                value: "9",
                                egdsElementId: "children_age_option_9",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "10",
                                value: "10",
                                egdsElementId: "children_age_option_10",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "11",
                                value: "11",
                                egdsElementId: "children_age_option_11",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "12",
                                value: "12",
                                egdsElementId: "children_age_option_12",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "13",
                                value: "13",
                                egdsElementId: "children_age_option_13",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "14",
                                value: "14",
                                egdsElementId: "children_age_option_14",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "15",
                                value: "15",
                                egdsElementId: "children_age_option_15",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "16",
                                value: "16",
                                egdsElementId: "children_age_option_16",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "17",
                                value: "17",
                                egdsElementId: "children_age_option_17",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        egdsElementId: "traveler_selector_children_age_selector",
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerChildren"
                },
                infantsInSeat: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Infant traveler removed",
                            referrerId: "Web.Flights.Traveler.Remove.InfantsInSeat",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Infant traveler added",
                            referrerId: "Web.Flights.Traveler.Add.InfantsInSeat",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of infants in seat",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of infants in seat",
                        increaseTextTemplate: null,
                        egdsElementId: "traveler_selector_infants_in_seat_step_input",
                        label: "Infants in seat",
                        max: 4,
                        min: 0,
                        step: 1,
                        subLabel: "Younger than 2",
                        value: 0,
                        __typename: "EGDSTravelerStepInput"
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "infantNumber",
                                    source: "infantNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Infant ${infantNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            {
                                label: "Select age",
                                value: "",
                                egdsElementId: "infants_age_option",
                                __typename: "EGDSBasicOption",
                                changeAnalytics: null
                            },
                            {
                                label: "0",
                                value: "0",
                                egdsElementId: "infants_age_option_0",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "1",
                                value: "1",
                                egdsElementId: "infants_age_option_1",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        egdsElementId: "traveler_selector_infant_age_selector",
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerInfant"
                },
                infantsOnLap: {
                    count: {
                        decreaseAnalytics: {
                            linkName: "Infant traveler removed",
                            referrerId: "Web.Flights.Traveler.Remove.InfantsOnLap",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Infant traveler added",
                            referrerId: "Web.Flights.Traveler.Add.InfantsOnLap",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of infants on lap",
                        decreaseTextTemplate: null,
                        increaseText: "Increase the number of infants on lap",
                        increaseTextTemplate: null,
                        egdsElementId: "traveler_selector_infants_on_lap_step_input",
                        label: "Infants on lap",
                        max: 4,
                        min: 0,
                        step: 1,
                        subLabel: "Younger than 2",
                        value: 0,
                        __typename: "EGDSTravelerStepInput"
                    },
                    ages: [],
                    ageTemplate: {
                        labelTemplate: {
                            models: [
                                {
                                    key: "infantNumber",
                                    source: "infantNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Infant ${infantNumber} age",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        options: [
                            {
                                label: "Select age",
                                value: "",
                                egdsElementId: "infants_age_option",
                                __typename: "EGDSBasicOption",
                                changeAnalytics: null
                            },
                            {
                                label: "0",
                                value: "0",
                                egdsElementId: "infants_age_option_0",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            },
                            {
                                label: "1",
                                value: "1",
                                egdsElementId: "infants_age_option_1",
                                changeAnalytics: null,
                                __typename: "EGDSBasicOption"
                            }
                        ],
                        egdsElementId: "traveler_selector_infant_age_selector",
                        value: null,
                        __typename: "EGDSTravelerChildAgeSelect"
                    },
                    __typename: "EGDSTravelerInfant"
                },
                pets: null,
                __typename: "EGDSTravelers"
            },
            validations: [
                {
                    errorMessage: "We allow up to 6 travelers per booking.",
                    maxCount: 6,
                    type: "MAX_TRAVELERS" /* MAX_TRAVELERS */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "We allow up to 6 travelers per booking.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed",
                            referrerId: "Web.Flight.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                },
                {
                    errorMessage: "Provide the age of the child.",
                    maxCount: null,
                    type: "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: "Go to error",
                        goToFirstErrorLinkText: "Go to first error",
                        heading: "",
                        body: null,
                        analytics: {
                            linkName: "Error summary link clicked",
                            referrerId: "Web.Flight.Traveler.Error.Summary",
                            __typename: "ClientSideAnalytics"
                        },
                        impressionAnalytics: {
                            linkName: "Error summary displayed",
                            referrerId: "Web.Flight.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: {
                            models: [
                                {
                                    key: "errorCount",
                                    source: "errorCount",
                                    __typename: "TemplateModel"
                                }
                            ],
                            templates: [
                                {
                                    category: "ZERO" /* ZERO */ ,
                                    template: "Please correct the ${errorCount} errors to continue",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "ONE" /* ONE */ ,
                                    template: "Please correct the error to continue",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "TWO" /* TWO */ ,
                                    template: "Please correct the ${errorCount} errors to continue",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "FEW" /* FEW */ ,
                                    template: "Please correct the ${errorCount} errors to continue",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "MANY" /* MANY */ ,
                                    template: "Please correct the ${errorCount} errors to continue",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "OTHER" /* OTHER */ ,
                                    template: "Please correct the ${errorCount} errors to continue",
                                    __typename: "CardinalTemplate"
                                }
                            ],
                            __typename: "EGDSCardinalLocalizedText"
                        },
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                },
                {
                    errorMessage: "There must be at least 1 traveler (age 12+) for each infant on lap.",
                    maxCount: null,
                    type: "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "There must be at least 1 traveler (age 12+) for each infant on lap.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed",
                            referrerId: "Web.Flight.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                },
                {
                    errorMessage: "There must be at least 1 traveler (age 12+) for every 2 infants in a seat.",
                    maxCount: null,
                    type: "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */ ,
                    infantsInSeatPerAdult: 2,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "There must be at least 1 traveler (age 12+) for every 2 infants in a seat.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed",
                            referrerId: "Web.Flight.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                }
            ],
            __typename: "EGDSBasicTravelerSelector"
        },
        accessibility: "expand to change the number of travelers",
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "travelerCount",
                source: "travelerCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "${travelerCount} traveler",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "${travelerCount} travelers",
                __typename: "CardinalTemplate"
            }
        ],
        secondaryTemplates: null,
        text: "1 traveler",
        __typename: "EGDSCardinalLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    },
    readOnly: false,
    __typename: "EGDSSearchFormTravelersField"
};
var search5 = {
    egdsElementId: "search_button",
    primary: "Search",
    disabled: false,
    accessibility: "Search",
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.Flight.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var buildLegs = function(id, datePickerField) {
    return [
        {
            id: id,
            locations: {
                __typename: "EGDSSearchFormLocationsField",
                egdsElementId: "locations",
                origin: {
                    __typename: "EGDSSearchFormLocationField",
                    egdsElementId: "origin_select",
                    label: "Leaving from",
                    placeholder: "Leaving from",
                    value: null,
                    errorMessage: "Please select where you're leaving from",
                    validations: [
                        {
                            errorMessage: "Enter at least 3 characters of the airport name.",
                            __typename: "EGDSMinLengthInputValidation"
                        },
                        {
                            errorMessage: "Please select where you're leaving from",
                            __typename: "EGDSRequiredInputValidation"
                        }
                    ],
                    required: false,
                    leftIcon: {
                        title: null,
                        __typename: "Icon"
                    },
                    action: {
                        accessibility: null,
                        analytics: {
                            linkName: "Origin Selection",
                            referrerId: "Web.Flight.origin.location.open",
                            __typename: "ClientSideAnalytics"
                        },
                        info: {
                            client: "Homepage",
                            drivable: false,
                            isDestination: false,
                            lineOfBusiness: "FLIGHTS",
                            maxNumberOfResults: 10,
                            packageType: null,
                            personalize: true,
                            regionType: 4959,
                            typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
                            isMultiLocation: null,
                            domain: null,
                            regionId: null,
                            showCurrentLocation: null,
                            __typename: "TypeaheadInfo",
                            subLob: "roundtrip",
                            expUserId: "-1",
                            trending: false
                        },
                        emptyResultsPlaceholder: "Search by city or airport",
                        categorize: false,
                        allowExactMatch: true,
                        listTitle: false,
                        selectedItemHeading: null,
                        clearAllText: null,
                        dismissButtonText: null,
                        __typename: "OpenTypeaheadAction"
                    },
                    closeAnalytics: {
                        linkName: "Origin Selection",
                        referrerId: "Web.Flight.origin.location.close",
                        __typename: "ClientSideAnalytics"
                    },
                    changeAnalytics: {
                        linkName: "Origin change",
                        referrerId: "Web.Flight.origin.location.change",
                        __typename: "ClientSideAnalytics"
                    },
                    multiLocations: null,
                    regionId: null,
                    debounceRate: null
                },
                destination: {
                    debounceRate: null,
                    __typename: "EGDSSearchFormLocationField",
                    egdsElementId: "destination_select",
                    label: "Going to",
                    placeholder: "Going to",
                    value: null,
                    errorMessage: "Please select where you're going",
                    validations: [
                        {
                            errorMessage: "Enter at least 3 characters of the airport name.",
                            __typename: "EGDSMinLengthInputValidation"
                        },
                        {
                            errorMessage: "Please select where you're going",
                            __typename: "EGDSRequiredInputValidation"
                        }
                    ],
                    required: false,
                    leftIcon: {
                        title: null,
                        __typename: "Icon"
                    },
                    action: {
                        accessibility: null,
                        analytics: {
                            linkName: "Destination Selection",
                            referrerId: "Web.Flight.destination.location.change",
                            __typename: "ClientSideAnalytics"
                        },
                        info: {
                            client: "Homepage",
                            drivable: false,
                            isDestination: true,
                            lineOfBusiness: "FLIGHTS",
                            maxNumberOfResults: 10,
                            packageType: null,
                            personalize: true,
                            regionType: 4959,
                            typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
                            isMultiLocation: null,
                            domain: null,
                            regionId: null,
                            showCurrentLocation: null,
                            __typename: "TypeaheadInfo",
                            subLob: "roundtrip",
                            expUserId: "-1",
                            trending: false
                        },
                        emptyResultsPlaceholder: "Search by city or airport",
                        categorize: false,
                        allowExactMatch: true,
                        listTitle: false,
                        selectedItemHeading: null,
                        clearAllText: null,
                        dismissButtonText: null,
                        __typename: "OpenTypeaheadAction"
                    },
                    closeAnalytics: {
                        linkName: "Destination Selection",
                        referrerId: "Web.Flight.destination.location.close",
                        __typename: "ClientSideAnalytics"
                    },
                    changeAnalytics: {
                        linkName: "Destination change",
                        referrerId: "Web.Flight.destination.location.change",
                        __typename: "ClientSideAnalytics"
                    },
                    multiLocations: null,
                    regionId: null
                },
                horizontalSwapper: {
                    egdsElementId: "location_swapper",
                    primary: "",
                    disabled: false,
                    accessibility: "Swap origin and destination values",
                    icon: {
                        id: "",
                        description: "swap_horiz",
                        token: "",
                        title: null,
                        __typename: "Icon"
                    },
                    analytics: {
                        linkName: "Swapper button clicked",
                        referrerId: "Flight.locations.swapper.button.click",
                        __typename: "ClientSideAnalytics"
                    },
                    action: null,
                    __typename: "UISecondaryButton"
                },
                verticalSwapper: {
                    egdsElementId: "location_swapper",
                    primary: "",
                    disabled: false,
                    accessibility: "Swap origin and destination values",
                    icon: {
                        id: "",
                        description: "swap_vert",
                        token: "",
                        title: null,
                        __typename: "Icon"
                    },
                    analytics: {
                        linkName: "Swapper button clicked",
                        referrerId: "Flight.locations.swapper.button.click",
                        __typename: "ClientSideAnalytics"
                    },
                    action: null,
                    __typename: "UISecondaryButton"
                },
                validations: [
                    {
                        errorMessage: "Please make sure your departure and arrival cities are different",
                        __typename: "EGDSSameValueInputValidation"
                    }
                ]
            },
            date: datePickerField,
            __typename: "FlightSearchFormLeg"
        }
    ];
};
var multiCityLegs = [
    {
        id: "multiDestinationLeg_0",
        locations: {
            egdsElementId: "locations",
            origin: {
                debounceRate: null,
                __typename: "EGDSSearchFormLocationField",
                egdsElementId: "origin_select",
                label: "Leaving from",
                placeholder: "Leaving from",
                value: null,
                errorMessage: "Please select where you're leaving from",
                validations: [
                    {
                        errorMessage: "Enter at least 3 characters of the airport name.",
                        __typename: "EGDSMinLengthInputValidation"
                    },
                    {
                        errorMessage: "Please select where you're leaving from",
                        __typename: "EGDSRequiredInputValidation"
                    }
                ],
                required: false,
                leftIcon: {
                    title: null,
                    __typename: "Icon"
                },
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "Origin Selection",
                        referrerId: "Web.Flight.origin.location.open",
                        __typename: "ClientSideAnalytics"
                    },
                    info: {
                        client: "Homepage",
                        drivable: false,
                        isDestination: false,
                        lineOfBusiness: "FLIGHTS",
                        maxNumberOfResults: 10,
                        packageType: null,
                        personalize: true,
                        regionType: 4959,
                        typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
                        isMultiLocation: null,
                        domain: null,
                        regionId: null,
                        showCurrentLocation: null,
                        __typename: "TypeaheadInfo",
                        subLob: "multicity",
                        expUserId: "-1",
                        trending: false
                    },
                    emptyResultsPlaceholder: "Search by city or airport",
                    categorize: false,
                    allowExactMatch: true,
                    listTitle: false,
                    selectedItemHeading: null,
                    clearAllText: null,
                    dismissButtonText: null,
                    __typename: "OpenTypeaheadAction"
                },
                closeAnalytics: {
                    linkName: "Origin Selection",
                    referrerId: "Web.Flight.origin.location.close",
                    __typename: "ClientSideAnalytics"
                },
                changeAnalytics: {
                    linkName: "Origin change",
                    referrerId: "Web.Flight.origin.location.change",
                    __typename: "ClientSideAnalytics"
                },
                multiLocations: null,
                regionId: null
            },
            destination: {
                debounceRate: null,
                __typename: "EGDSSearchFormLocationField",
                egdsElementId: "destination_select",
                label: "Going to",
                placeholder: "Going to",
                value: null,
                errorMessage: "Please select where you're going",
                validations: [
                    {
                        errorMessage: "Enter at least 3 characters of the airport name.",
                        __typename: "EGDSMinLengthInputValidation"
                    },
                    {
                        errorMessage: "Please select where you're going",
                        __typename: "EGDSRequiredInputValidation"
                    }
                ],
                required: false,
                leftIcon: {
                    title: null,
                    __typename: "Icon"
                },
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "Destination Selection",
                        referrerId: "Web.Flight.destination.location.change",
                        __typename: "ClientSideAnalytics"
                    },
                    info: {
                        client: "Homepage",
                        drivable: false,
                        isDestination: true,
                        lineOfBusiness: "FLIGHTS",
                        maxNumberOfResults: 10,
                        packageType: null,
                        personalize: true,
                        regionType: 4959,
                        typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
                        isMultiLocation: null,
                        domain: null,
                        regionId: null,
                        showCurrentLocation: null,
                        __typename: "TypeaheadInfo",
                        subLob: "multicity",
                        expUserId: "-1",
                        trending: false
                    },
                    emptyResultsPlaceholder: "Search by city or airport",
                    categorize: false,
                    allowExactMatch: true,
                    listTitle: false,
                    selectedItemHeading: null,
                    clearAllText: null,
                    dismissButtonText: null,
                    __typename: "OpenTypeaheadAction"
                },
                closeAnalytics: {
                    linkName: "Destination Selection",
                    referrerId: "Web.Flight.destination.location.close",
                    __typename: "ClientSideAnalytics"
                },
                changeAnalytics: {
                    linkName: "Destination change",
                    referrerId: "Web.Flight.destination.location.change",
                    __typename: "ClientSideAnalytics"
                },
                multiLocations: null,
                regionId: null
            },
            horizontalSwapper: {
                egdsElementId: "location_swapper",
                primary: "",
                disabled: false,
                accessibility: "Swap origin and destination values",
                icon: {
                    id: "",
                    description: "swap_horiz",
                    token: "",
                    title: null,
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Swapper button clicked",
                    referrerId: "Flight.locations.swapper.button.click",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UISecondaryButton"
            },
            verticalSwapper: {
                egdsElementId: "location_swapper",
                primary: "",
                disabled: false,
                accessibility: "Swap origin and destination values",
                icon: {
                    id: "",
                    description: "swap_vert",
                    token: "",
                    title: null,
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Swapper button clicked",
                    referrerId: "Flight.locations.swapper.button.click",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UISecondaryButton"
            },
            validations: [
                {
                    errorMessage: "Please make sure your departure and arrival cities are different",
                    __typename: "EGDSSameValueInputValidation"
                }
            ],
            __typename: "EGDSSearchFormLocationsField"
        },
        date: {
            egdsElementId: "date_form_field",
            label: "Date",
            placeholder: createDatePickerPlaceHolder(START_DATE3),
            errorMessage: "Check-out date must be after check-in date",
            validations: null,
            action: {
                accessibility: null,
                analytics: {
                    linkName: "flight calendar selection",
                    referrerId: "Web.Flight.Calendar.Open",
                    __typename: "ClientSideAnalytics"
                },
                datePicker: {
                    buttonText: "Done",
                    selectedStartDate: _object_spread({}, createDate3(START_DATE3)),
                    validDaysLowerBoundInclusive: _object_spread({}, createDate3(TODAY3)),
                    validDaysUpperBoundInclusive: _object_spread({}, createDate3(NEXT_TEN_MONTHS2)),
                    submitButtonAnalytics: {
                        linkName: "flight calendar submit",
                        referrerId: "Web.Flight.Calendar.Submit",
                        __typename: "ClientSideAnalytics"
                    },
                    startDateButtonAnalytics: {
                        linkName: "flight calendar start date click",
                        referrerId: "Web.Flight.Calendar.Start.Date.Click",
                        __typename: "ClientSideAnalytics"
                    },
                    firstDayOfWeek: "SUN" /* SUN */ ,
                    __typename: "EGDSSingleDatePicker"
                },
                __typename: "EGDSOpenDatePickerAction"
            },
            __typename: "EGDSSearchFormDatePickerField"
        },
        __typename: "FlightSearchFormLeg"
    },
    {
        id: "multiDestinationLeg_1",
        locations: {
            egdsElementId: "locations",
            origin: {
                debounceRate: null,
                __typename: "EGDSSearchFormLocationField",
                egdsElementId: "origin_select",
                label: "Leaving from",
                placeholder: "Leaving from",
                value: null,
                errorMessage: "Please select where you're leaving from",
                validations: [
                    {
                        errorMessage: "Enter at least 3 characters of the airport name.",
                        __typename: "EGDSMinLengthInputValidation"
                    },
                    {
                        errorMessage: "Please select where you're leaving from",
                        __typename: "EGDSRequiredInputValidation"
                    }
                ],
                required: false,
                leftIcon: {
                    title: null,
                    __typename: "Icon"
                },
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "Origin Selection",
                        referrerId: "Web.Flight.origin.location.open",
                        __typename: "ClientSideAnalytics"
                    },
                    info: {
                        client: "Homepage",
                        drivable: false,
                        isDestination: false,
                        lineOfBusiness: "FLIGHTS",
                        maxNumberOfResults: 10,
                        packageType: null,
                        personalize: true,
                        regionType: 4959,
                        typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
                        isMultiLocation: null,
                        domain: null,
                        regionId: null,
                        showCurrentLocation: null,
                        __typename: "TypeaheadInfo",
                        subLob: "multicity",
                        expUserId: "-1",
                        trending: false
                    },
                    emptyResultsPlaceholder: "Search by city or airport",
                    categorize: false,
                    allowExactMatch: true,
                    listTitle: false,
                    selectedItemHeading: null,
                    clearAllText: null,
                    dismissButtonText: null,
                    __typename: "OpenTypeaheadAction"
                },
                closeAnalytics: {
                    linkName: "Origin Selection",
                    referrerId: "Web.Flight.origin.location.close",
                    __typename: "ClientSideAnalytics"
                },
                changeAnalytics: {
                    linkName: "Origin change",
                    referrerId: "Web.Flight.origin.location.change",
                    __typename: "ClientSideAnalytics"
                },
                multiLocations: null,
                regionId: null
            },
            destination: {
                debounceRate: null,
                __typename: "EGDSSearchFormLocationField",
                egdsElementId: "destination_select",
                label: "Going to",
                placeholder: "Going to",
                value: null,
                errorMessage: "Please select where you're going",
                validations: [
                    {
                        errorMessage: "Enter at least 3 characters of the airport name.",
                        __typename: "EGDSMinLengthInputValidation"
                    },
                    {
                        errorMessage: "Please select where you're going",
                        __typename: "EGDSRequiredInputValidation"
                    }
                ],
                required: false,
                leftIcon: {
                    title: null,
                    __typename: "Icon"
                },
                action: {
                    accessibility: null,
                    analytics: {
                        linkName: "Destination Selection",
                        referrerId: "Web.Flight.destination.location.change",
                        __typename: "ClientSideAnalytics"
                    },
                    info: {
                        client: "Homepage",
                        drivable: false,
                        isDestination: true,
                        lineOfBusiness: "FLIGHTS",
                        maxNumberOfResults: 10,
                        packageType: null,
                        personalize: true,
                        regionType: 4959,
                        typeaheadFeatures: "nearby_airport|ta_hierarchy|consistent_display",
                        isMultiLocation: null,
                        domain: null,
                        regionId: null,
                        showCurrentLocation: null,
                        __typename: "TypeaheadInfo",
                        subLob: "multicity",
                        expUserId: "-1",
                        trending: false
                    },
                    emptyResultsPlaceholder: "Search by city or airport",
                    categorize: false,
                    allowExactMatch: true,
                    listTitle: false,
                    selectedItemHeading: null,
                    clearAllText: null,
                    dismissButtonText: null,
                    __typename: "OpenTypeaheadAction"
                },
                closeAnalytics: {
                    linkName: "Destination Selection",
                    referrerId: "Web.Flight.destination.location.close",
                    __typename: "ClientSideAnalytics"
                },
                changeAnalytics: {
                    linkName: "Destination change",
                    referrerId: "Web.Flight.destination.location.change",
                    __typename: "ClientSideAnalytics"
                },
                multiLocations: null,
                regionId: null
            },
            horizontalSwapper: {
                egdsElementId: "location_swapper",
                primary: "",
                disabled: false,
                accessibility: "Swap origin and destination values",
                icon: {
                    id: "",
                    description: "swap_horiz",
                    token: "",
                    title: null,
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Swapper button clicked",
                    referrerId: "Flight.locations.swapper.button.click",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UISecondaryButton"
            },
            verticalSwapper: {
                egdsElementId: "location_swapper",
                primary: "",
                disabled: false,
                accessibility: "Swap origin and destination values",
                icon: {
                    id: "",
                    description: "swap_vert",
                    token: "",
                    title: null,
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Swapper button clicked",
                    referrerId: "Flight.locations.swapper.button.click",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UISecondaryButton"
            },
            validations: [
                {
                    errorMessage: "Please make sure your departure and arrival cities are different",
                    __typename: "EGDSSameValueInputValidation"
                }
            ],
            __typename: "EGDSSearchFormLocationsField"
        },
        date: {
            egdsElementId: "date_form_field",
            label: "Date",
            placeholder: createDatePickerPlaceHolder(START_DATE3),
            errorMessage: "Check-out date must be after check-in date",
            validations: null,
            action: {
                accessibility: null,
                analytics: {
                    linkName: "flight calendar selection",
                    referrerId: "Web.Flight.Calendar.Open",
                    __typename: "ClientSideAnalytics"
                },
                datePicker: {
                    buttonText: "Done",
                    selectedStartDate: _object_spread({}, createDate3(START_DATE3)),
                    validDaysLowerBoundInclusive: _object_spread({}, createDate3(TODAY3)),
                    validDaysUpperBoundInclusive: _object_spread({}, createDate3(NEXT_TEN_MONTHS2)),
                    submitButtonAnalytics: {
                        linkName: "flight calendar submit",
                        referrerId: "Web.Flight.Calendar.Submit",
                        __typename: "ClientSideAnalytics"
                    },
                    startDateButtonAnalytics: {
                        linkName: "flight calendar start date click",
                        referrerId: "Web.Flight.Calendar.Start.Date.Click",
                        __typename: "ClientSideAnalytics"
                    },
                    firstDayOfWeek: "SUN" /* SUN */ ,
                    __typename: "EGDSSingleDatePicker"
                },
                __typename: "EGDSOpenDatePickerAction"
            },
            __typename: "EGDSSearchFormDatePickerField"
        },
        __typename: "FlightSearchFormLeg"
    }
];
var multiCityAddLegs = {
    accessibility: null,
    action: null,
    analytics: {
        linkName: "Add Leg button clicked",
        referrerId: "Web.Flight.Search.AddLeg.Button.Clicked",
        __typename: "ClientSideAnalytics"
    },
    disabled: false,
    egdsElementId: "add_leg_button",
    icon: {
        description: "ADD",
        id: "add",
        title: null,
        token: "icon__add",
        __typename: "Icon"
    },
    primary: "Add another flight",
    __typename: "UITertiaryButton"
};
var multiCityRemoveLeg = {
    accessibility: null,
    action: null,
    analytics: {
        linkName: "Remove Leg button clicked",
        referrerId: "Web.Flight.Search.RemoveLeg.Button.Clicked",
        __typename: "ClientSideAnalytics"
    },
    disabled: false,
    egdsElementId: "remove_leg_button",
    icon: null,
    primary: "Remove",
    __typename: "UITertiaryButton"
};
var multiCityLegHeading = {
    models: [
        {
            key: "legNumber",
            source: "legNumber",
            __typename: "TemplateModel"
        }
    ],
    template: "Flight ${legNumber}",
    __typename: "EGDSBasicLocalizedText"
};
var flightTripTypeDatePicker = function(flightTripType) {
    return flightTripType.valueOf() === "ROUND_TRIP" /* ROUND_TRIP */ .valueOf() ? roundTripDatePickers : oneWayAndMultiCityDatePicker;
};
var flightTripTypeLegs = function(flightTripType) {
    if (flightTripType.valueOf() === "MULTI_DESTINATION" /* MULTI_DESTINATION */ .valueOf()) {
        return {
            legs: multiCityLegs,
            addLeg: multiCityAddLegs,
            removeLeg: multiCityRemoveLeg,
            legHeading: multiCityLegHeading
        };
    }
    var datePicker5 = flightTripTypeDatePicker(flightTripType);
    return {
        legs: buildLegs(flightTripType, datePicker5),
        addLeg: null,
        removeLeg: null,
        legHeading: null
    };
};
var getFallbackData6 = function(flightTripType) {
    var legsData = flightTripTypeLegs(flightTripType);
    return {
        __typename: "FlightSearchForm",
        egdsElementId: "flight-search=form",
        actionURL: "/Flights-Search",
        errorSummary: errorSummary4,
        elements: [
            {
                egdsElementId: "flight_locations",
                origin: origin,
                destination: destination3,
                horizontalSwapper: horizontalSwapper,
                verticalSwapper: verticalSwapper,
                validations: validations,
                __typename: "EGDSSearchFormLocationsField"
            },
            flightTripTypeDatePicker(flightTripType),
            travelersField,
            {
                __typename: "EGDSSearchFormInputField"
            }
        ],
        search: search5,
        addLeg: legsData.addLeg,
        removeLeg: legsData.removeLeg,
        legHeading: legsData.legHeading,
        legs: legsData.legs,
        playback: null,
        maxAllowedLegs: 5,
        localDateFormat: "M/d/yyyy",
        softPackages: null,
        searchLocation: searchLocationFallback
    };
};
// src/components/flights/form/__private/flight-search-form.tsx
import React129 from "react";
import { useLocation } from "react-router-dom";
import { gql as gql95 } from "@apollo/client";
import { useLocalization as useLocalization18 } from "@shared-ui/localization-context";
import { ViewLarge as ViewLarge14, ViewMedium as ViewMedium34, Viewport as Viewport37, ViewSizes as ViewSizes16, ViewSmall as ViewSmall35 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm13 } from "uitk-react-form";
import { UitkSpacing as UitkSpacing41 } from "uitk-react-spacing";
// src/components/flights/utils/fields-map.ts
var FieldNameMap7 = /* @__PURE__ */ function(FieldNameMap8) {
    FieldNameMap8["TRAVEL_DATES"] = "EGDSDateRangePicker";
    FieldNameMap8["TRAVELER_SELECTOR"] = "EGDSBasicTravelerSelector";
    return FieldNameMap8;
}(FieldNameMap7 || {});
// src/components/flights/utils/query-params.ts
var tripTypeMap = {
    ONE_WAY: "oneway",
    ROUND_TRIP: "roundtrip",
    MULTI_DESTINATION: "multi"
};
var flightsCabinClassMap = {
    COACH: "economy",
    PREMIUM_ECONOMY: "premium",
    BUSINESS: "business",
    FIRST: "first"
};
var getFormattedDate2 = function(param, dateFormatHelper) {
    var day = param.day, month = param.month, year = param.year;
    var formattedDay = day < 10 ? "0".concat(day) : day;
    var formattedMonth = month < 10 ? "0".concat(month) : month;
    var formattedDate = dateFormatHelper.formatDateString("".concat(year, "-").concat(formattedMonth, "-").concat(formattedDay), {
        raw: dateFormatHelper.localDateFormat
    });
    return formattedDate;
};
var getQueryParamDateVariant2 = function(key, date) {
    var formatWithZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var day = date.day, month = date.month, year = date.year;
    var finalMonth = month < 10 ? "0".concat(month) : month;
    var finalDay = day < 10 ? "0".concat(day) : day;
    return "&".concat(key, "=").concat(year, "-").concat(formatWithZero ? finalMonth : month, "-").concat(formatWithZero ? finalDay : day);
};
var getDateFromInput = function(date) {
    var _date_split = _sliced_to_array(date.split("-"), 3), year = _date_split[0], month = _date_split[1], day = _date_split[2];
    return {
        __typename: "Date",
        year: Number(year),
        month: Number(month),
        day: Number(day)
    };
};
var getURLQueryParamsFromCriteria2 = function(criteria, currentQueryParams, dateFormatHelper, locationType) {
    var _criteria_primary_searchPreferences_advancedFilters, _criteria_primary_searchPreferences;
    var _criteria_primary = criteria.primary, tripType = _criteria_primary.tripType, journeyCriterias = _criteria_primary.journeyCriterias, travelers = _criteria_primary.travelers, searchPreferences = _criteria_primary.searchPreferences;
    var flightType = "flight-type=on";
    var mode = "mode=search";
    var trip = "trip=".concat(tripTypeMap[tripType]);
    var UNSPECIFIED_TYPE = "U";
    var legs = journeyCriterias.reduce(function(currentQueryParam, journey2, index) {
        var origin2 = journey2.origin, destination4 = journey2.destination, departureDate2 = journey2.departureDate, arrivalDate2 = journey2.arrivalDate;
        var _locationType_get;
        var fromType = (_locationType_get = locationType === null || locationType === void 0 ? void 0 : locationType.get(origin2)) !== null && _locationType_get !== void 0 ? _locationType_get : UNSPECIFIED_TYPE;
        var _locationType_get1;
        var toType = (_locationType_get1 = locationType === null || locationType === void 0 ? void 0 : locationType.get(destination4)) !== null && _locationType_get1 !== void 0 ? _locationType_get1 : UNSPECIFIED_TYPE;
        var leg = "&leg".concat(index + 1, "=from:").concat(origin2, ",to:").concat(destination4, ",departure:").concat(getFormattedDate2(departureDate2, dateFormatHelper), "TANYT,fromType:").concat(fromType, ",toType:").concat(toType);
        var roundLeg = arrivalDate2 ? "&leg2=from:".concat(destination4, ",to:").concat(origin2, ",departure:").concat(getFormattedDate2(arrivalDate2, dateFormatHelper), "TANYT,fromType:").concat(toType, ",toType:").concat(fromType) : "";
        return "".concat(currentQueryParam).concat(leg).concat(roundLeg);
    }, "");
    var cabinClass = searchPreferences ? "cabinclass:".concat(flightsCabinClassMap[searchPreferences.cabinClass]) : "";
    var options = "options=".concat(cabinClass);
    var hasChildInSeat = travelers.some(function(param) {
        var type = param.type;
        return type === "INFANT_IN_SEAT";
    }) ? "&ChildInSeat=seat" : "";
    var hasChildInLap = travelers.some(function(param) {
        var type = param.type;
        return type === "INFANT_IN_LAP";
    });
    var children = travelers.filter(function(traveler) {
        return traveler.type === "CHILD" || traveler.type === "INFANT_IN_LAP" || traveler.type === "INFANT_IN_SEAT";
    });
    var adults = travelers.filter(function(traveler) {
        return traveler.type === "ADULT";
    });
    var childrenQueryString = children.length > 0 ? "children:".concat(children.length, "[").concat(children.map(function(child) {
        return child.age;
    }).join(";"), "],") : "";
    var adultsString = adults.length > 0 ? "adults:".concat(adults.length, ",") : "";
    var infantinLapQueryString = hasChildInLap ? "infantinlap:Y" : "infantinlap:N";
    var travelersQueryString = "passengers=".concat(childrenQueryString).concat(adultsString).concat(infantinLapQueryString);
    var _journeyCriterias = _sliced_to_array(journeyCriterias, 1), journey = _journeyCriterias[0];
    var departureDate = journey.departureDate, arrivalDate = journey.arrivalDate;
    var dates = "&fromDate=".concat(getFormattedDate2(departureDate, dateFormatHelper)).concat(arrivalDate ? "&toDate=".concat(getFormattedDate2(arrivalDate, dateFormatHelper)) : "").concat(getQueryParamDateVariant2("d1", departureDate)).concat(arrivalDate ? getQueryParamDateVariant2("d2", arrivalDate) : "");
    var hasAirCreditIntent = (currentQueryParams === null || currentQueryParams === void 0 ? void 0 : currentQueryParams.get("airCreditIntent")) === "true";
    var airCreditIntent = hasAirCreditIntent ? "&airCreditIntent=true" : "";
    var filters = [];
    if ((_criteria_primary_searchPreferences = criteria.primary.searchPreferences) === null || _criteria_primary_searchPreferences === void 0 ? void 0 : (_criteria_primary_searchPreferences_advancedFilters = _criteria_primary_searchPreferences.advancedFilters) === null || _criteria_primary_searchPreferences_advancedFilters === void 0 ? void 0 : _criteria_primary_searchPreferences_advancedFilters.includes("NONSTOP" /* NONSTOP */ )) {
        filters.push({
            numOfStopFilterValue: {
                stopInfo: {
                    numberOfStops: 0,
                    stopFilterOperation: "EQUAL"
                }
            }
        });
    }
    var filtersParams = filters.length > 0 ? "&filters=".concat(JSON.stringify(filters)) : "";
    return "?".concat(flightType, "&").concat(mode, "&").concat(trip).concat(legs, "&").concat(options).concat(hasChildInSeat).concat(dates, "&").concat(travelersQueryString).concat(airCreditIntent).concat(filtersParams);
};
var getSoftPackagesURLQueryParamsFromInputs = function(inputs, flightType, directFlightsOnlySwitch, dateFormatHelper) {
    var prefixes = [
        "EGDS",
        "add-"
    ];
    var filteredInputs = inputs.filter(function(param) {
        var name = param.name;
        return prefixes.some(function(prefix) {
            return name.startsWith(prefix);
        });
    });
    var flightTypeParam = "tripType=".concat(flightType);
    var includesHotel = filteredInputs.some(function(hotel) {
        return hotel.name.startsWith("EGDSSoftPackagesPackageType") && hotel.value.includes("h");
    });
    var baseQueryParams = filteredInputs.reduce(function(queryParams2, input) {
        var name = input.name, value = input.value, checked = input.checked;
        if (name.startsWith("EGDSSoftPackagesPackageType")) {
            var partialStayParam = value.includes("h") ? "&isPartialStay=1" : "";
            return "".concat(queryParams2, "&packageType=").concat(value).concat(partialStayParam);
        }
        var locationPrefix2 = "EGDSSearchFormLocationField";
        if (name.startsWith(locationPrefix2)) {
            if (name.startsWith("".concat(locationPrefix2, "-AirportCode-origin_select"))) {
                return "".concat(queryParams2, "&ftla=").concat(value);
            }
            if (name.startsWith("".concat(locationPrefix2, "-RegionId-origin_select"))) {
                return "".concat(queryParams2, "&originId=").concat(value);
            }
            if (name.startsWith("".concat(locationPrefix2, "-AirportCode-destination_select"))) {
                return "".concat(queryParams2, "&ttla=").concat(value);
            }
            if (name.startsWith("".concat(locationPrefix2, "-Location-destination_select"))) {
                return "".concat(queryParams2, "&destination=").concat(value);
            }
            if (name.startsWith("".concat(locationPrefix2, "-DestinationId-destination_select"))) {
                return "".concat(queryParams2, "&destinationId=").concat(value);
            }
        }
        var travelersPrefix = "EGDSSearchFormTravelersField";
        if (name.startsWith(travelersPrefix)) {
            if (name.startsWith("".concat(travelersPrefix, "-Adult"))) {
                return "".concat(queryParams2, "&numberOfRooms=1&adultsPerRoom[1]=").concat(value);
            }
            if (name.startsWith("".concat(travelersPrefix, "-ChildrenAge"))) {
                var _name_split = _sliced_to_array(name.split("".concat(travelersPrefix, "-ChildrenAge-")), 2), childNumber = _name_split[1];
                return "".concat(queryParams2, "&childAges[1][").concat(childNumber, "]=").concat(value);
            }
            if (name.startsWith("".concat(travelersPrefix, "-InfantOnLapAge"))) {
                var infantSeatingParam = queryParams2.includes("InfantSeating") ? "" : "&InfantSeating=lap";
                var infantInSeatParam = queryParams2.includes("infantsInSeats") ? "" : "&infantsInSeats=0";
                var childNumber1 = (queryParams2.match(/childAges/g) || []).length + 1;
                var childAgeParam = "&childAges[1][".concat(childNumber1, "]=").concat(value);
                return "".concat(queryParams2).concat(infantSeatingParam).concat(infantInSeatParam).concat(childAgeParam);
            }
            if (name.startsWith("".concat(travelersPrefix, "-InfantInSeatAge"))) {
                var infantSeatingParam1 = queryParams2.includes("InfantSeating") ? "" : "&InfantSeating=seat";
                var infantInSeatParam1 = queryParams2.includes("infantsInSeats") ? "" : "&infantsInSeats=1";
                var childNumber2 = (queryParams2.match(/childAges/g) || []).length + 1;
                var childAgeParam1 = "&childAges[1][".concat(childNumber2, "]=").concat(value);
                return "".concat(queryParams2).concat(infantSeatingParam1).concat(infantInSeatParam1).concat(childAgeParam1);
            }
        }
        var singleDatePrefix = "EGDSSingleDatePicker";
        var softPackagesDates = "EGDSDateRangePickerSoftPackages";
        var datesPrefix = "EGDSDateRangePicker";
        if (name.includes(singleDatePrefix) || name.includes(softPackagesDates) || name.includes(datesPrefix)) {
            var date = getDateFromInput(value);
            var dateFormattedByLocale = getFormattedDate2(date, dateFormatHelper);
            if (name.startsWith(singleDatePrefix)) {
                var fromDate = "&fromDate=".concat(dateFormattedByLocale);
                return "".concat(queryParams2).concat(fromDate);
            }
            if (name.startsWith(softPackagesDates)) {
                var isStart = name.startsWith("".concat(softPackagesDates, "-StartDate-soft_packages_date_form_field"));
                var dDate = getQueryParamDateVariant2(isStart ? "d1" : "d2", date, true);
                var hotelDate = "&".concat(isStart ? "checkInDate" : "checkOutDate", "=").concat(dateFormattedByLocale);
                return "".concat(queryParams2).concat(dDate).concat(hotelDate);
            }
            if (name.startsWith(datesPrefix)) {
                var isStart1 = name.startsWith("".concat(datesPrefix, "-StartDate-date_form_field"));
                var flightDate = "&".concat(isStart1 ? "fromDate" : "toDate", "=").concat(dateFormattedByLocale);
                var dDate1 = getQueryParamDateVariant2(isStart1 ? "d1" : "d2", date, true);
                var hotelDate1 = "&".concat(isStart1 ? "checkInDate" : "checkOutDate", "=").concat(dateFormattedByLocale);
                return "".concat(queryParams2).concat(flightDate).concat(dDate1).concat(includesHotel ? hotelDate1 : "");
            }
        }
        var softPackageCheckboxPrefix = "add-";
        if (softPackageCheckboxPrefix) {
            if (name.startsWith("".concat(softPackageCheckboxPrefix, "hotel-switch")) && checked) {
                return "".concat(queryParams2, "&add-hotel-checkbox=");
            }
            if (name.startsWith("".concat(softPackageCheckboxPrefix, "car-switch")) && checked) {
                return "".concat(queryParams2, "&add-car-checkbox=");
            }
        }
        return queryParams2;
    }, "?".concat(flightTypeParam));
    var directFlightsOnly = directFlightsOnlySwitch ? "&isDirectFlight=true" : "";
    var numberOfChildren = (baseQueryParams.match(/childAges/g) || []).length;
    var queryParams = "".concat(baseQueryParams, "&childrenPerRoom[1]=").concat(numberOfChildren).concat(directFlightsOnly);
    return queryParams;
};
var _obj10;
// src/components/flights/utils/search-criteria.ts
var TravelersTypeMap2 = (_obj10 = {}, _define_property(_obj10, ADULT_COUNT_NAME_PREFIX, "ADULT" /* ADULT */ ), _define_property(_obj10, CHILDREN_NAME_PREFIX, "CHILD" /* CHILD */ ), _define_property(_obj10, INFANT_ON_LAP_NAME_PREFIX, "INFANT_IN_LAP" /* INFANT_IN_LAP */ ), _define_property(_obj10, INFANT_IN_SEAT_NAME_PREFIX, "INFANT_IN_SEAT" /* INFANT_IN_SEAT */ ), _obj10);
var TripTypeMap = {
    ROUND_TRIP: "ROUND_TRIP" /* ROUND_TRIP */ ,
    ONE_WAY: "ONE_WAY" /* ONE_WAY */ ,
    MULTI_CITY: "MULTI_DESTINATION" /* MULTI_DESTINATION */ 
};
var CabinClassMap2 = {
    ECONOMY: "COACH" /* COACH */ ,
    ECONOMY_PREMIUM: "PREMIUM_ECONOMY" /* PREMIUM_ECONOMY */ ,
    BUSINESS: "BUSINESS" /* BUSINESS */ ,
    FIRST_CLASS: "FIRST" /* FIRST */ 
};
var getSearchCriteriaFromSubmitEvent = function(event, tripType, directFlightsOnlySwitch) {
    var EGDS_PREFIX2 = "EGDS";
    var formElements = Array.from(event.currentTarget.elements);
    var inputElements = formElements.filter(function(element) {
        return element.name.startsWith(EGDS_PREFIX2);
    });
    var initialSearchCriteria = {
        primary: {
            journeyCriterias: [],
            travelers: [],
            tripType: tripType,
            searchPreferences: {
                advancedFilters: directFlightsOnlySwitch ? [
                    "NONSTOP" /* NONSTOP */ 
                ] : [],
                cabinClass: "COACH" /* COACH */ 
            }
        },
        secondary: null
    };
    return inputElements.reduce(flightCriteriaReducer, initialSearchCriteria);
};
var getSearchCriteriaFromSubmitRef = function(event, tripType) {
    var EGDS_PREFIX2 = "EGDS";
    var currentFormRef = event === null || event === void 0 ? void 0 : event.current;
    var initialSearchCriteria = {
        primary: {
            journeyCriterias: [],
            travelers: [],
            tripType: tripType
        },
        secondary: null
    };
    if (!currentFormRef) {
        return initialSearchCriteria;
    }
    var formElementsKeys = Object.keys(currentFormRef.elements);
    var inputElementsKeys = formElementsKeys.filter(function(element) {
        return element.startsWith(EGDS_PREFIX2);
    });
    var inputElements = inputElementsKeys.map(function(inputElementsKey) {
        return {
            name: inputElementsKey,
            value: currentFormRef.elements[inputElementsKey].value
        };
    });
    return inputElements.reduce(flightCriteriaReducer, initialSearchCriteria);
};
var flightCriteriaReducer = function(currentCriteriaInput, input) {
    var name = input.name, value = input.value;
    if (name.startsWith("".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-flight_type_selector"))) {
        var _TripTypeMap_value;
        var primary = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
            tripType: (_TripTypeMap_value = TripTypeMap[value]) !== null && _TripTypeMap_value !== void 0 ? _TripTypeMap_value : "ROUND_TRIP" /* ROUND_TRIP */ 
        });
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: primary
        });
    }
    if (name.startsWith("".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-cabin_class"))) {
        var _currentCriteriaInput_primary_searchPreferences, _CabinClassMap2_value;
        var searchPreferences = _object_spread_props(_object_spread({}, (_currentCriteriaInput_primary_searchPreferences = currentCriteriaInput.primary.searchPreferences) !== null && _currentCriteriaInput_primary_searchPreferences !== void 0 ? _currentCriteriaInput_primary_searchPreferences : {}), {
            cabinClass: (_CabinClassMap2_value = CabinClassMap2[value]) !== null && _CabinClassMap2_value !== void 0 ? _CabinClassMap2_value : "COACH" /* COACH */ 
        });
        var primary1 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
            searchPreferences: searchPreferences
        });
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: primary1
        });
    }
    if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
        var isAdultInput = name.startsWith(ADULT_COUNT_NAME_PREFIX);
        var childKeys = name.split("-");
        var key = isAdultInput ? ADULT_COUNT_NAME_PREFIX : childKeys.slice(0, childKeys.length - 1).join("-");
        var numericValue = Number.parseInt(value, 10);
        var travelers = isAdultInput ? Array.from(Array(numericValue).keys()).map(function(_) {
            return {
                type: TravelersTypeMap2[key],
                age: null
            };
        }) : [
            {
                type: TravelersTypeMap2[key],
                age: value ? numericValue : null
            }
        ];
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
                travelers: _to_consumable_array(currentCriteriaInput.primary.travelers).concat(_to_consumable_array(travelers))
            })
        });
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-origin_select"))) {
        var legPrefix = "".concat(LOCATION_NAME_PREFIX, "-origin_select-");
        var isMultiCity = name.startsWith(legPrefix);
        if (isMultiCity) {
            var _name_split = _sliced_to_array(name.split(legPrefix), 2), legNumber = _name_split[1];
            var journeyCriterias = _to_consumable_array(currentCriteriaInput.primary.journeyCriterias);
            var _journeyCriterias_Number;
            journeyCriterias[Number(legNumber)] = _object_spread_props(_object_spread({}, (_journeyCriterias_Number = journeyCriterias[Number(legNumber)]) !== null && _journeyCriterias_Number !== void 0 ? _journeyCriterias_Number : journeyCriterias[0]), {
                origin: value
            });
            var primary2 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
                journeyCriterias: _to_consumable_array(journeyCriterias)
            });
            return _object_spread_props(_object_spread({}, currentCriteriaInput), {
                primary: primary2
            });
        }
        var size = currentCriteriaInput.primary.journeyCriterias.length;
        var _currentCriteriaInput_primary_journeyCriterias_;
        var journeyCriteria = _object_spread_props(_object_spread({}, (_currentCriteriaInput_primary_journeyCriterias_ = currentCriteriaInput.primary.journeyCriterias[size - 1]) !== null && _currentCriteriaInput_primary_journeyCriterias_ !== void 0 ? _currentCriteriaInput_primary_journeyCriterias_ : {}), {
            origin: value
        });
        var primary3 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
            journeyCriterias: [
                journeyCriteria
            ]
        });
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: primary3
        });
    }
    if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination_select"))) {
        var legPrefix1 = "".concat(LOCATION_NAME_PREFIX, "-destination_select-");
        var isMultiCity1 = name.startsWith(legPrefix1);
        if (isMultiCity1) {
            var _name_split1 = _sliced_to_array(name.split(legPrefix1), 2), legNumber1 = _name_split1[1];
            var journeyCriterias1 = _to_consumable_array(currentCriteriaInput.primary.journeyCriterias);
            var _journeyCriterias_Number1;
            journeyCriterias1[Number(legNumber1)] = _object_spread_props(_object_spread({}, (_journeyCriterias_Number1 = journeyCriterias1[Number(legNumber1)]) !== null && _journeyCriterias_Number1 !== void 0 ? _journeyCriterias_Number1 : journeyCriterias1[0]), {
                destination: value
            });
            var primary21 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
                journeyCriterias: _to_consumable_array(journeyCriterias1)
            });
            return _object_spread_props(_object_spread({}, currentCriteriaInput), {
                primary: primary21
            });
        }
        var _currentCriteriaInput_primary_journeyCriterias_1;
        var journeyCriteria1 = _object_spread_props(_object_spread({}, (_currentCriteriaInput_primary_journeyCriterias_1 = currentCriteriaInput.primary.journeyCriterias[0]) !== null && _currentCriteriaInput_primary_journeyCriterias_1 !== void 0 ? _currentCriteriaInput_primary_journeyCriterias_1 : {}), {
            destination: value
        });
        var primary4 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
            journeyCriterias: [
                journeyCriteria1
            ]
        });
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: primary4
        });
    }
    if (name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX) || name.startsWith(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX)) {
        var _value_split_map = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
        var _currentCriteriaInput_primary_journeyCriterias_2;
        var journeyCriteria2 = _object_spread_props(_object_spread({}, (_currentCriteriaInput_primary_journeyCriterias_2 = currentCriteriaInput.primary.journeyCriterias[0]) !== null && _currentCriteriaInput_primary_journeyCriterias_2 !== void 0 ? _currentCriteriaInput_primary_journeyCriterias_2 : {}), _define_property({}, name.startsWith(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX) ? "departureDate" : "arrivalDate", {
            day: day,
            month: month,
            year: year
        }));
        var primary5 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
            journeyCriterias: [
                journeyCriteria2
            ]
        });
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: primary5
        });
    }
    if (name.startsWith(DATE_NAME_PREFIX)) {
        var _value_split_map1 = _sliced_to_array(value.split("-").map(function(partialDate) {
            return Number(partialDate);
        }), 3), year1 = _value_split_map1[0], month1 = _value_split_map1[1], day1 = _value_split_map1[2];
        var legPrefix2 = "".concat(DATE_NAME_PREFIX, "-date_form_field-");
        var isMultiCity2 = name.startsWith(legPrefix2);
        if (isMultiCity2) {
            var _name_split2 = _sliced_to_array(name.split(legPrefix2), 2), legNumber2 = _name_split2[1];
            var journeyCriterias2 = _to_consumable_array(currentCriteriaInput.primary.journeyCriterias);
            var _journeyCriterias_Number2;
            journeyCriterias2[Number(legNumber2)] = _object_spread_props(_object_spread({}, (_journeyCriterias_Number2 = journeyCriterias2[Number(legNumber2)]) !== null && _journeyCriterias_Number2 !== void 0 ? _journeyCriterias_Number2 : journeyCriterias2[0]), {
                departureDate: {
                    day: day1,
                    month: month1,
                    year: year1
                }
            });
            var primary22 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
                journeyCriterias: _to_consumable_array(journeyCriterias2)
            });
            return _object_spread_props(_object_spread({}, currentCriteriaInput), {
                primary: primary22
            });
        }
        var _currentCriteriaInput_primary_journeyCriterias_3;
        var journeyCriteria3 = _object_spread_props(_object_spread({}, (_currentCriteriaInput_primary_journeyCriterias_3 = currentCriteriaInput.primary.journeyCriterias[0]) !== null && _currentCriteriaInput_primary_journeyCriterias_3 !== void 0 ? _currentCriteriaInput_primary_journeyCriterias_3 : {}), {
            departureDate: {
                day: day1,
                month: month1,
                year: year1
            }
        });
        var primary6 = _object_spread_props(_object_spread({}, currentCriteriaInput.primary), {
            journeyCriterias: [
                journeyCriteria3
            ]
        });
        return _object_spread_props(_object_spread({}, currentCriteriaInput), {
            primary: primary6
        });
    }
    return currentCriteriaInput;
};
// src/components/flights/form/__private/fields-layout.tsx
import React127 from "react";
import { ViewSizes as ViewSizes13 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex28, UitkLayoutFlexItem as UitkLayoutFlexItem25 } from "uitk-react-layout-flex";
// src/components/flights/form/__private/fare-calendar/search-form-fare-calendar-wrapper.tsx
import React126 from "react";
import { FareCalendar, TripType } from "@shared-ui/flights-fare-calendar";
import { useLocalization as useLocalization17 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext8 } from "@shared-ui/retail-search-tools-reflection-provider";
import { useFormCallback as useFormCallback11 } from "uitk-react-form";
var DATE_FORMAT3 = "yyyy-MM-dd";
var SearchFormFareCalendarWrapper = function(props) {
    var action = props.action, egdsElementId = props.egdsElementId, label = props.label, placeholder = props.placeholder, origin2 = props.origin, destination4 = props.destination, skipReflection = props.skipReflection;
    var datePicker5 = action.datePicker;
    var formatDateString = useLocalization17().formatDateString;
    var _useSearchFormReflectionContext8 = useSearchFormReflectionContext8(), state = _useSearchFormReflectionContext8.state, dispatchReflectionAction = _useSearchFormReflectionContext8.dispatch;
    var _state_dates;
    var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {}, reflectionStartDate = _ref.start, reflectionEndDate = _ref.end;
    var reflectionOrigin = state.origin, reflectionDestination = state.destination;
    var _React126_useState = _sliced_to_array(React126.useState({
        startDate: (datePicker5 === null || datePicker5 === void 0 ? void 0 : datePicker5.selectedStartDate) ? formatDateString(convertToDateObject(datePicker5 === null || datePicker5 === void 0 ? void 0 : datePicker5.selectedStartDate), {
            raw: DATE_FORMAT3
        }) : "",
        endDate: (datePicker5 === null || datePicker5 === void 0 ? void 0 : datePicker5.selectedEndDate) ? formatDateString(convertToDateObject(datePicker5 === null || datePicker5 === void 0 ? void 0 : datePicker5.selectedEndDate), {
            raw: DATE_FORMAT3
        }) : "",
        shouldFireChangeEvent: false
    }), 2), dateState = _React126_useState[0], setDateState = _React126_useState[1];
    var startDate5 = dateState.startDate, endDate5 = dateState.endDate, shouldFireChangeEvent = dateState.shouldFireChangeEvent;
    var tripType = datePicker5.__typename === "EGDSDateRangePicker" ? TripType.ROUND_TRIP : TripType.ONE_WAY;
    var triggerFormCallback = useFormCallback11("FlightsFareCalendar-".concat(tripType), function(event) {
        return event;
    });
    React126.useEffect(function() {
        setDateState({
            startDate: reflectionStartDate || (datePicker5.selectedStartDate ? formatDateString(convertToDateObject(datePicker5.selectedStartDate), {
                raw: DATE_FORMAT3
            }) : ""),
            endDate: reflectionEndDate || (datePicker5.selectedEndDate ? formatDateString(convertToDateObject(datePicker5.selectedEndDate), {
                raw: DATE_FORMAT3
            }) : ""),
            shouldFireChangeEvent: false
        });
    }, [
        datePicker5
    ]);
    React126.useEffect(function() {
        if (shouldFireChangeEvent) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    shouldFireChangeEvent: false
                });
            });
            var eventString = tripType === TripType.ROUND_TRIP ? "".concat(startDate5, " - ").concat(endDate5) : "".concat(startDate5);
            triggerInputChangeEvent(eventString, triggerFormCallback);
        }
    }, [
        dateState
    ]);
    var handleDateChange = function(dateFields) {
        var start;
        var end;
        dateFields === null || dateFields === void 0 ? void 0 : dateFields.forEach(function(dateField) {
            var date = dateField.value, fieldName5 = dateField.fieldName;
            if (fieldName5 === "startDate" /* START_DATE */ ) {
                start = date;
            } else {
                end = date;
            }
        });
        if (start !== dateState.startDate || end !== dateState.endDate) {
            if (!skipReflection) {
                dispatchReflectionAction({
                    type: "UPDATE_DATES",
                    end: end,
                    start: start
                });
            }
            setDateState({
                startDate: start,
                endDate: end,
                shouldFireChangeEvent: true
            });
        }
    };
    var dateFieldProps = {
        startName: egdsElementId,
        startId: egdsElementId,
        startLabel: label,
        startPlaceholder: placeholder,
        buttonText: datePicker5.buttonText
    };
    var _reflectionOrigin_term, _reflectionDestination_term;
    var fareCalendarProps = {
        startDate: startDate5,
        endDate: endDate5,
        singleMode: tripType === TripType.ONE_WAY,
        dateFieldProps: dateFieldProps,
        onChange: handleDateChange,
        origin: (_reflectionOrigin_term = reflectionOrigin === null || reflectionOrigin === void 0 ? void 0 : reflectionOrigin.term) !== null && _reflectionOrigin_term !== void 0 ? _reflectionOrigin_term : origin2,
        destination: (_reflectionDestination_term = reflectionDestination === null || reflectionDestination === void 0 ? void 0 : reflectionDestination.term) !== null && _reflectionDestination_term !== void 0 ? _reflectionDestination_term : destination4,
        firstDayOfWeek: EGDSDayNameMap[datePicker5.firstDayOfWeek],
        tripType: tripType,
        onSubmitAnalytics: true,
        singleTrigger: tripType === TripType.ROUND_TRIP
    };
    return /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement(FareCalendar, _object_spread({}, fareCalendarProps)), tripType === TripType.ONE_WAY && /* @__PURE__ */ React126.createElement("input", {
        type: "hidden",
        "data-stid": DATE_NAME_PREFIX,
        name: "".concat(DATE_NAME_PREFIX, "-").concat(egdsElementId),
        value: startDate5
    }), tripType === TripType.ROUND_TRIP && /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement("input", {
        type: "hidden",
        "data-stid": DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX,
        name: "".concat(DATE_PICKER_PREFIX_MAP.START_DATE_NAME_PREFIX, "-").concat(egdsElementId),
        value: startDate5
    }), /* @__PURE__ */ React126.createElement("input", {
        type: "hidden",
        "data-stid": DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX,
        name: "".concat(DATE_PICKER_PREFIX_MAP.END_DATE_NAME_PREFIX, "-").concat(egdsElementId),
        value: endDate5
    })));
};
// src/components/flights/form/__private/layout-field-config.ts
import { ViewSizes as ViewSizes12 } from "@shared-ui/viewport-context";
var defaultFieldConfig3 = {};
var _obj11;
var layoutFieldConfigViewportMapping4 = (_obj11 = {}, _define_property(_obj11, ViewSizes12.SMALL, {
    default: {
        minWidth: "full_width"
    }
}), _define_property(_obj11, ViewSizes12.MEDIUM, {
    EGDSSearchFormLocationsField: {
        grow: 1,
        minWidth: "half_width"
    },
    EGDSSearchFormDatePickerField: {
        minWidth: "third_width",
        maxWidth: "third_width"
    },
    EGDSSearchFormTravelersField: {
        grow: 1
    },
    default: defaultFieldConfig3
}), _define_property(_obj11, ViewSizes12.LARGE, {
    EGDSSearchFormLocationsField: {
        minWidth: "half_width",
        maxWidth: "half_width"
    },
    EGDSSearchFormDatePickerField: {
        grow: 2
    },
    EGDSSearchFormTravelersField: {
        grow: 2
    },
    EGDSSearchFormButton: {
        grow: 0
    },
    default: defaultFieldConfig3
}), _define_property(_obj11, ViewSizes12.EXTRA_LARGE, {
    EGDSSearchFormLocationsField: {
        minWidth: "half_width",
        maxWidth: "full_width"
    },
    EGDSSearchFormDatePickerField: {
        grow: 2
    },
    EGDSSearchFormTravelersField: {
        grow: 2
    },
    EGDSSearchFormButton: {
        grow: 0
    },
    default: defaultFieldConfig3
}), _obj11);
var getFlexItemPropsByFieldType4 = function(fieldTypename, viewportSize) {
    var componentPropsMappingByViewport = layoutFieldConfigViewportMapping4[viewportSize];
    var _componentPropsMappingByViewport_fieldTypename;
    return (_componentPropsMappingByViewport_fieldTypename = componentPropsMappingByViewport[fieldTypename]) !== null && _componentPropsMappingByViewport_fieldTypename !== void 0 ? _componentPropsMappingByViewport_fieldTypename : componentPropsMappingByViewport.default;
};
// src/components/flights/form/__private/fields-layout.tsx
var fieldComponents6 = [
    EGDSErrorSummary,
    EGDSSearchFormLocationsField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormTravelersField
];
var FormFieldsLayout3 = function(props) {
    var viewSize = props.viewSize, fields = props.fields, legs = props.legs, defaultValidationProps = props.defaultValidationProps, errorState = props.errorState, onLocationsSelection = props.onLocationsSelection, updatePlaybackDates = props.updatePlaybackDates, fareCalendarData = props.fareCalendarData, search6 = props.search, softPackages = props.softPackages, additionalAdapterFields = props.additionalAdapterFields, searchLocationAnalytics = props.searchLocationAnalytics;
    var formFields = legs.length > 0 ? [
        legs[0].locations,
        legs[0].date
    ] : [];
    var travelerField = fields.filter(function(elem) {
        return elem.__typename === "EGDSSearchFormTravelersField";
    });
    if (travelerField.length > 0 && travelerField[0]) {
        formFields.push(travelerField[0]);
    }
    var priceCalendarContext = React127.useContext(PriceCalendarContext);
    var _ref = priceCalendarContext || {}, enablePriceCalendar = _ref.enablePriceCalendar, priceCalendarInputs = _ref.priceCalendarInputs;
    var priceCalendarProps = enablePriceCalendar && priceCalendarInputs.journeyCriteria.length > 0 ? {
        lobName: "flights",
        enablePriceCalendar: enablePriceCalendar,
        priceCalendarInputs: priceCalendarInputs
    } : void 0;
    return /* @__PURE__ */ React127.createElement(UitkLayoutFlex28, {
        alignContent: "start",
        justifyContent: "start",
        wrap: "wrap",
        space: "three"
    }, formFields.map(function(element, index) {
        var __typename = element.__typename;
        var FieldComponent = fieldComponents6.find(function(param) {
            var displayName = param.displayName;
            return displayName === __typename;
        });
        var flexItemProps = getFlexItemPropsByFieldType4(__typename, viewSize);
        var validationProps = _object_spread(_object_spread_props(_object_spread({}, defaultValidationProps), {
            fieldError: getFieldError(errorState, __typename)
        }), __typename === "EGDSSearchFormLocationsField" && {
            originFieldError: getFieldError(errorState, "".concat(element.origin.__typename, "Origin")),
            destinationFieldError: getFieldError(errorState, "".concat(element.destination.__typename, "Destination"))
        });
        var customFieldComponentProps = _object_spread({
            originRef: __typename === "EGDSSearchFormLocationsField" ? validationProps : null,
            destinationRef: __typename === "EGDSSearchFormLocationsField" ? validationProps : null,
            onLocationsSelection: __typename === "EGDSSearchFormLocationsField" ? onLocationsSelection : null,
            updatePlaybackDates: __typename === "EGDSSearchFormDatePickerField" ? updatePlaybackDates : null,
            searchLocationAnalytics: __typename === "EGDSSearchFormLocationsField" ? searchLocationAnalytics : null
        }, __typename === "EGDSSearchFormLocationsField" ? {
            additionalAdapterFields: additionalAdapterFields
        } : {});
        if (__typename === "EGDSSearchFormDatePickerField" && (fareCalendarData === null || fareCalendarData === void 0 ? void 0 : fareCalendarData.enabled)) {
            var searchFormFareCalendarWrapperProps = {
                action: element.action,
                egdsElementId: element.egdsElementId,
                label: element.label,
                placeholder: element.placeholder,
                origin: fareCalendarData.origin,
                destination: fareCalendarData.destination
            };
            return /* @__PURE__ */ React127.createElement(UitkLayoutFlexItem25, _object_spread({
                key: "field_".concat(__typename, "_").concat(index)
            }, flexItemProps), /* @__PURE__ */ React127.createElement("div", null, /* @__PURE__ */ React127.createElement(SearchFormFareCalendarWrapper, _object_spread_props(_object_spread({}, searchFormFareCalendarWrapperProps, element), {
                key: "SearchFormFareCalendarWrapper"
            }))));
        }
        return FieldComponent && /* @__PURE__ */ React127.createElement(UitkLayoutFlexItem25, _object_spread({
            key: "field_".concat(__typename, "_").concat(index)
        }, flexItemProps), /* @__PURE__ */ React127.createElement("div", null, /* @__PURE__ */ React127.createElement(FieldComponent, _object_spread(_object_spread_props(_object_spread({}, validationProps, customFieldComponentProps), {
            data: element
        }), {
            priceCalendarProps: priceCalendarProps
        }))));
    }), viewSize === ViewSizes13.SMALL && /* @__PURE__ */ React127.createElement(UitkLayoutFlexItem25, _object_spread({}, getFlexItemPropsByFieldType4("SoftPackages", viewSize)), /* @__PURE__ */ React127.createElement("div", null, softPackages)), search6 && search6.__typename === "EGDSSearchFormButton" && /* @__PURE__ */ React127.createElement(UitkLayoutFlexItem25, _object_spread({}, getFlexItemPropsByFieldType4("EGDSSearchFormButton", viewSize)), /* @__PURE__ */ React127.createElement("div", null, /* @__PURE__ */ React127.createElement(EGDSSearchFormButton, {
        data: search6
    }))));
};
// src/components/flights/form/__private/multicity-form.tsx
import React128 from "react";
import { useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext9 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewLarge as ViewLarge13, ViewMedium as ViewMedium33, Viewport as Viewport36, ViewSizes as ViewSizes15, ViewSmall as ViewSmall34 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon9 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex29, UitkLayoutFlexItem as UitkLayoutFlexItem26 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing40 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
// src/components/flights/form/__private/layout-field-config-multicity.ts
import { ViewSizes as ViewSizes14 } from "@shared-ui/viewport-context";
var defaultFieldConfig4 = {
    grow: 5,
    minWidth: 315,
    maxWidth: "full_width"
};
var defaultViewportConfig3 = {
    EGDSSearchFormButton: {},
    EGDSSearchFormLocationsField: _object_spread_props(_object_spread({}, defaultFieldConfig4), {
        grow: 10
    }),
    EGDSSearchFormDatePickerField: _object_spread_props(_object_spread({}, defaultFieldConfig4), {
        grow: 1
    }),
    EGDSSearchFormTravelersField: {
        grow: 3,
        minWidth: 225,
        maxWidth: 225
    },
    default: defaultFieldConfig4
};
var _obj12;
var layoutFieldConfigViewportMapping5 = (_obj12 = {}, _define_property(_obj12, ViewSizes14.SMALL, _object_spread_props(_object_spread({}, defaultViewportConfig3), {
    EGDSSearchFormTravelersField: {
        grow: 3
    },
    EGDSSearchFormButton: {
        grow: 1,
        minWidth: 315
    }
})), _define_property(_obj12, ViewSizes14.MEDIUM, _object_spread_props(_object_spread({}, defaultViewportConfig3), {
    EGDSSearchFormButton: {
        grow: 0,
        minWidth: 32
    }
})), _define_property(_obj12, ViewSizes14.LARGE, defaultViewportConfig3), _define_property(_obj12, ViewSizes14.EXTRA_LARGE, defaultViewportConfig3), _obj12);
var getMulticityFlexItemPropsByFieldType = function(fieldTypename, viewportSize) {
    var componentPropsMappingByViewport = layoutFieldConfigViewportMapping5[viewportSize];
    var _componentPropsMappingByViewport_fieldTypename;
    return (_componentPropsMappingByViewport_fieldTypename = componentPropsMappingByViewport[fieldTypename]) !== null && _componentPropsMappingByViewport_fieldTypename !== void 0 ? _componentPropsMappingByViewport_fieldTypename : componentPropsMappingByViewport.default;
};
// src/components/flights/form/__private/multicity-form.tsx
var fieldComponents7 = [
    EGDSErrorSummary,
    EGDSSearchFormLocationsField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormTravelersField,
    EGDSSearchFormButton,
    EGDSTertiaryButton
];
var FormField = function(props) {
    var element = props.element, index = props.index, defaultValidationProps = props.defaultValidationProps, viewSize = props.viewSize, errorState = props.errorState, onLocationsSelection = props.onLocationsSelection, legsElements = props.legsElements, updatePlaybackDates = props.updatePlaybackDates, additionalAdapterFields = props.additionalAdapterFields, searchLocationAnalytics = props.searchLocationAnalytics;
    var __typename = element.__typename;
    var FieldComponent = fieldComponents7.find(function(param) {
        var displayName = param.displayName;
        return displayName === __typename;
    });
    var flexItemProps = getMulticityFlexItemPropsByFieldType(__typename, viewSize);
    var validationProps = _object_spread(_object_spread_props(_object_spread({}, defaultValidationProps), {
        fieldError: getFieldError(errorState, __typename)
    }), __typename === "EGDSSearchFormLocationsField" && {
        originFieldError: getFieldError(errorState, "".concat(element.origin.__typename, "Origin-leg").concat(index)),
        destinationFieldError: getFieldError(errorState, "".concat(element.destination.__typename, "Destination-leg").concat(index))
    });
    var setFieldRef = function(typename, ref) {
        defaultValidationProps.setFieldRefByTypename(typename, ref, index.toString());
    };
    var customFieldComponentProps = _object_spread_props(_object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread({
        originRef: __typename === "EGDSSearchFormLocationsField" ? _object_spread_props(_object_spread({}, validationProps), {
            setFieldRefByTypename: setFieldRef
        }) : null,
        destinationRef: __typename === "EGDSSearchFormLocationsField" ? _object_spread_props(_object_spread({}, validationProps), {
            setFieldRefByTypename: setFieldRef
        }) : null
    }, __typename === "EGDSSearchFormLocationsField" ? {
        additionalAdapterFields: additionalAdapterFields
    } : {}), {
        index: index
    }), index > 0 ? {
        skipReflection: true
    } : {}), {
        // Use reflection only for the first leg but EGDSSearchFormDatePickerField
        onLocationsSelection: __typename === "EGDSSearchFormLocationsField" ? onLocationsSelection : null,
        updatePlaybackDates: __typename === "EGDSSearchFormDatePickerField" ? updatePlaybackDates : null,
        totalLegs: legsElements.length,
        input1Stid: __typename === "EGDSSearchFormDatePickerField" && index !== 0 ? index : null
    }), __typename === "EGDSSearchFormLocationsField" && {}), {
        searchLocationAnalytics: __typename === "EGDSSearchFormLocationsField" ? searchLocationAnalytics : null
    });
    return /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem26, _object_spread({
        key: "field_".concat(__typename, "_").concat(index)
    }, flexItemProps), /* @__PURE__ */ React128.createElement("div", null, FieldComponent && /* @__PURE__ */ React128.createElement(FieldComponent, _object_spread({
        data: element
    }, validationProps, customFieldComponentProps))));
};
var FormFieldsLayout4 = function(formProps) {
    var _addLeg_icon;
    var beforeLegsSlot = formProps.beforeLegsSlot, addLeg = formProps.addLeg, search6 = formProps.search, legsElements = formProps.legsElements, addLegClick = formProps.addLegClick, removeLegClick = formProps.removeLegClick, addLegDisabled = formProps.addLegDisabled;
    var addLegButtonRef = React128.createRef();
    var _addLeg_icon_id;
    var addALegAndSearchButton = /* @__PURE__ */ React128.createElement(React128.Fragment, null, (addLeg === null || addLeg === void 0 ? void 0 : addLeg.__typename) === "UITertiaryButton" && /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem26, null, /* @__PURE__ */ React128.createElement("div", null, /* @__PURE__ */ React128.createElement(UitkLink2, {
        size: "medium",
        onClick: addLegClick,
        domRef: addLegButtonRef
    }, /* @__PURE__ */ React128.createElement("button", {
        type: "button",
        disabled: addLegDisabled
    }, /* @__PURE__ */ React128.createElement(UitkIcon9, {
        name: (_addLeg_icon_id = (_addLeg_icon = addLeg.icon) === null || _addLeg_icon === void 0 ? void 0 : _addLeg_icon.id) !== null && _addLeg_icon_id !== void 0 ? _addLeg_icon_id : ""
    }), addLeg.primary)))), search6 && /* @__PURE__ */ React128.createElement(FormField, _object_spread({
        element: search6,
        index: 0
    }, formProps)));
    return /* @__PURE__ */ React128.createElement(React128.Fragment, null, /* @__PURE__ */ React128.createElement(UitkLayoutFlex29, {
        alignContent: "start",
        justifyContent: "start",
        wrap: "wrap",
        space: "three"
    }, beforeLegsSlot.map(function(element, index) {
        return /* @__PURE__ */ React128.createElement(FormField, _object_spread({
            key: "multicity_before_leg_".concat(index),
            element: element,
            index: index
        }, formProps));
    })), legsElements.map(function(leg, indexLeg) {
        var _leg_removeButton;
        return /* @__PURE__ */ React128.createElement(UitkSpacing40, {
            margin: {
                block: "three"
            },
            key: "field_leg_".concat(leg.uniqueKey)
        }, /* @__PURE__ */ React128.createElement("div", null, /* @__PURE__ */ React128.createElement(UitkSpacing40, {
            margin: {
                blockend: "three",
                blockstart: "six"
            }
        }, /* @__PURE__ */ React128.createElement(UitkLayoutFlex29, {
            wrap: "wrap",
            alignItems: "center",
            direction: "row",
            space: "three"
        }, leg.heading && leg.heading.__typename === "EGDSBasicLocalizedText" && /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem26, null, /* @__PURE__ */ React128.createElement("div", null, /* @__PURE__ */ React128.createElement(UitkHeading8, {
            size: 6,
            tag: "h3"
        }, formatLocalizedTokenString(leg.heading.template, leg.heading.models[0].key, (indexLeg + 1).toString())))), ((_leg_removeButton = leg.removeButton) === null || _leg_removeButton === void 0 ? void 0 : _leg_removeButton.__typename) === "UITertiaryButton" && /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem26, null, /* @__PURE__ */ React128.createElement("div", null, /* @__PURE__ */ React128.createElement(UitkLink2, {
            size: "medium",
            onClick: function() {
                return removeLegClick(indexLeg, addLegButtonRef);
            }
        }, /* @__PURE__ */ React128.createElement("button", {
            type: "button"
        }, leg.removeButton.primary)))))), /* @__PURE__ */ React128.createElement(UitkLayoutFlex29, {
            alignItems: "start",
            justifyContent: "space-between",
            wrap: "wrap",
            space: "three"
        }, leg.items.map(function(element, index) {
            return /* @__PURE__ */ React128.createElement(FormField, _object_spread({
                key: "multicity_leg_item_".concat(index),
                element: element,
                index: indexLeg
            }, formProps));
        }))));
    }), /* @__PURE__ */ React128.createElement(Viewport36, null, /* @__PURE__ */ React128.createElement(ViewSmall34, null, /* @__PURE__ */ React128.createElement(UitkLayoutFlex29, {
        justifyContent: "space-between",
        space: "three",
        direction: "column"
    }, addALegAndSearchButton)), /* @__PURE__ */ React128.createElement(ViewMedium33, null, /* @__PURE__ */ React128.createElement(UitkLayoutFlex29, {
        justifyContent: "space-between",
        wrap: "wrap",
        space: "three",
        alignItems: "center"
    }, addALegAndSearchButton))));
};
var generateUniqueKey = function() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(prefix, "_").concat(Math.random().toString(16).slice(2));
};
var MultiDestinationForm = function(props) {
    var track = useClickTracker33();
    var legs = props.legs, search6 = props.search, addLeg = props.addLeg, removeLeg = props.removeLeg, legHeading = props.legHeading, elements = props.elements, maxAllowedLegs = props.maxAllowedLegs, playback = props.playback, autoOpenPlayback = props.autoOpenPlayback, stickyPlayback = props.stickyPlayback, getFlightSearchCriteria = props.getFlightSearchCriteria, searchLocationAnalytics = props.searchLocationAnalytics;
    var beforeLegsSlot = elements.filter(function(elem) {
        return elem.__typename === "EGDSSearchFormTravelersField";
    });
    var state = useSearchFormReflectionContext9().state;
    var _state_dates;
    var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {}, reflectionStartDate = _ref.start;
    var initLegs = legs.map(function(leg, index) {
        var _legs__date_action;
        var legDate = leg.date;
        if (reflectionStartDate && /^\d{4}-\d{2}-\d{2}$/.test(reflectionStartDate) && index > 0 && ((_legs__date_action = legs[0].date.action) === null || _legs__date_action === void 0 ? void 0 : _legs__date_action.__typename) === "EGDSOpenDatePickerAction") {
            var dateParts = reflectionStartDate.split("-");
            legDate = _object_spread_props(_object_spread({}, legs[0].date), {
                action: _object_spread_props(_object_spread({}, legs[0].date.action), {
                    datePicker: _object_spread_props(_object_spread({}, legs[0].date.action.datePicker), {
                        selectedStartDate: _object_spread_props(_object_spread({}, legs[0].date.action.datePicker.selectedStartDate), {
                            day: parseInt(dateParts[2], 10),
                            month: parseInt(dateParts[1], 10),
                            year: parseInt(dateParts[0], 10)
                        })
                    })
                })
            });
        }
        return {
            items: [
                leg.locations,
                legDate
            ],
            heading: legHeading,
            removeButton: null,
            uniqueKey: generateUniqueKey()
        };
    });
    var _React128_useState = _sliced_to_array(React128.useState(initLegs), 2), legsElements = _React128_useState[0], setLegState = _React128_useState[1];
    var _React128_useState1 = _sliced_to_array(React128.useState(initLegs.length), 2), legsCount = _React128_useState1[0], setLegsCount = _React128_useState1[1];
    var _React128_useState2 = _sliced_to_array(React128.useState(false), 2), addLegDisabled = _React128_useState2[0], setAddLegDisabled = _React128_useState2[1];
    var defaultMaxAllowedLegs = 5;
    var addLegClick = function() {
        var _legs__date_action;
        if ((addLeg === null || addLeg === void 0 ? void 0 : addLeg.__typename) === "UITertiaryButton" && addLeg.analytics) {
            var _addLeg_analytics = addLeg.analytics, referrerId = _addLeg_analytics.referrerId, linkName = _addLeg_analytics.linkName;
            track(referrerId, linkName);
        }
        if (legsCount + 1 === maxAllowedLegs) {
            setAddLegDisabled(true);
        }
        setLegsCount(function(count) {
            return count + 1;
        });
        var initialLocationLeg = _object_spread_props(_object_spread({}, legs[0].locations), {
            origin: _object_spread_props(_object_spread({}, legs[0].locations.origin), {
                value: ""
            }),
            destination: _object_spread_props(_object_spread({}, legs[0].locations.destination), {
                value: ""
            })
        });
        var _getFlightSearchCriteria = getFlightSearchCriteria(), journeyCriterias = _getFlightSearchCriteria.primary.journeyCriterias;
        var legDate = legs[0].date;
        if (((_legs__date_action = legs[0].date.action) === null || _legs__date_action === void 0 ? void 0 : _legs__date_action.__typename) === "EGDSOpenDatePickerAction") {
            var lastDepartureDate = journeyCriterias[legsCount - 1].departureDate;
            legDate = _object_spread_props(_object_spread({}, legDate), {
                action: _object_spread_props(_object_spread({}, legs[0].date.action), {
                    datePicker: _object_spread_props(_object_spread({}, legs[0].date.action.datePicker), {
                        selectedStartDate: _object_spread({}, legs[0].date.action.datePicker.selectedStartDate, lastDepartureDate)
                    })
                })
            });
        }
        setLegState(function(prevState) {
            return _to_consumable_array(prevState).concat([
                {
                    items: [
                        initialLocationLeg,
                        legDate
                    ],
                    uniqueKey: generateUniqueKey(),
                    heading: legHeading,
                    removeButton: removeLeg
                }
            ]);
        });
    };
    var removeLegClick = function(index, addAnotherFlightRef) {
        var _addAnotherFlightRef_current;
        if ((removeLeg === null || removeLeg === void 0 ? void 0 : removeLeg.__typename) === "UITertiaryButton" && removeLeg.analytics) {
            var _removeLeg_analytics = removeLeg.analytics, referrerId = _removeLeg_analytics.referrerId, linkName = _removeLeg_analytics.linkName;
            track(referrerId, linkName);
        }
        addAnotherFlightRef === null || addAnotherFlightRef === void 0 ? void 0 : (_addAnotherFlightRef_current = addAnotherFlightRef.current) === null || _addAnotherFlightRef_current === void 0 ? void 0 : _addAnotherFlightRef_current.focus();
        if (addLegDisabled && legsCount - 1 < (maxAllowedLegs !== null && maxAllowedLegs !== void 0 ? maxAllowedLegs : defaultMaxAllowedLegs)) {
            setAddLegDisabled(false);
        }
        setLegsCount(function(count) {
            return count - 1;
        });
        setLegState(function(prevState) {
            var prevLegs = _to_consumable_array(prevState);
            prevLegs.splice(index, 1);
            return prevLegs;
        });
    };
    var _React128_useState3 = _sliced_to_array(React128.useState(!autoOpenPlayback), 2), displayPlayback = _React128_useState3[0], setDisplayPlayback = _React128_useState3[1];
    var handlePlaybackToggle = function(open) {
        setDisplayPlayback(open);
    };
    var formProps = _object_spread_props(_object_spread({}, props), {
        beforeLegsSlot: beforeLegsSlot,
        legsElements: legsElements,
        addLegClick: addLegClick,
        removeLegClick: removeLegClick,
        addLeg: addLeg,
        search: search6,
        addLegDisabled: addLegDisabled,
        searchLocationAnalytics: searchLocationAnalytics
    });
    return /* @__PURE__ */ React128.createElement(Viewport36, null, /* @__PURE__ */ React128.createElement(ViewSmall34, null, playback ? /* @__PURE__ */ React128.createElement(EGDSSearchPlayback, {
        data: playback,
        stickyPlayback: stickyPlayback,
        display: displayPlayback,
        onDisplayToggle: handlePlaybackToggle
    }, /* @__PURE__ */ React128.createElement(FormFieldsLayout4, _object_spread_props(_object_spread({}, formProps), {
        viewSize: ViewSizes15.SMALL
    }))) : /* @__PURE__ */ React128.createElement(FormFieldsLayout4, _object_spread_props(_object_spread({}, formProps), {
        viewSize: ViewSizes15.SMALL
    }))), /* @__PURE__ */ React128.createElement(ViewMedium33, null, /* @__PURE__ */ React128.createElement(FormFieldsLayout4, _object_spread_props(_object_spread({}, formProps), {
        viewSize: ViewSizes15.MEDIUM
    }))), /* @__PURE__ */ React128.createElement(ViewLarge13, null, /* @__PURE__ */ React128.createElement(FormFieldsLayout4, _object_spread_props(_object_spread({}, formProps), {
        viewSize: ViewSizes15.LARGE
    }))));
};
// src/components/flights/form/__private/flight-search-form.tsx
var getDateInputElements = function(formElements, startDateName, endDateName) {
    return {
        startDateInput: formElements.find(findFieldByNameAttribute(startDateName)),
        endDateInput: formElements.find(findFieldByNameAttribute(endDateName)),
        config: {
            maxNumberOfDaysSelected: 0
        }
    };
};
var getSoftPackageDateInputElements = function(formElements, startDateName, softPackageStartDateName, softPackageEndDateName) {
    return {
        startDateInput: formElements.find(findFieldByNameAttribute(startDateName)),
        endDateInput: void 0,
        softPackagesStartDateInput: softPackageStartDateName ? formElements.find(findFieldByNameAttribute(softPackageStartDateName)) : null,
        softPackageEndDateInput: softPackageEndDateName ? formElements.find(findFieldByNameAttribute(softPackageEndDateName)) : null,
        config: {
            maxNumberOfDaysSelected: 0
        }
    };
};
var getElementsToValidate = function(isMulticity, formElements) {
    var oneWaySoftPackagesEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (isMulticity) {
        var dateElements = getDateInputElements(formElements, "EGDSSingleDatePicker-Date-date_form_field-0", "EGDSSingleDatePicker-Date-date_form_field-1");
        var multiFormElementsToValidate = {
            location: {
                origin: formElements.filter(findFieldByNameAttribute("origin_select")),
                destination: formElements.filter(findFieldByNameAttribute("destination_select")),
                config: {
                    sameLocationSelected: true
                }
            },
            dates: dateElements
        };
        return multiFormElementsToValidate;
    }
    if (oneWaySoftPackagesEnabled) {
        var softPackagesDateElements = getSoftPackageDateInputElements(formElements, "EGDSSingleDatePicker-Date-date_form_field", "EGDSDateRangePickerSoftPackages-StartDate-soft_packages_date_form_field", "EGDSDateRangePickerSoftPackages-EndDate-soft_packages_date_form_field");
        var oneWaySoftPackagesElementsToValidate = {
            location: {
                origin: formElements.find(findFieldByNameAttribute("origin_select")),
                destination: formElements.find(findFieldByNameAttribute("destination_select")),
                config: {
                    sameLocationSelected: true
                }
            },
            dates: softPackagesDateElements
        };
        return oneWaySoftPackagesElementsToValidate;
    }
    var datesElements = getDateInputElements(formElements, "EGDSDateRangePicker-StartDate-date_form_field", "EGDSDateRangePicker-EndDate-date_form_field");
    var formElementsToValidate = {
        location: {
            origin: formElements.find(findFieldByNameAttribute("origin_select")),
            destination: formElements.find(findFieldByNameAttribute("destination_select")),
            config: {
                sameLocationSelected: true
            }
        },
        dates: datesElements
    };
    return formElementsToValidate;
};
var getElementsWithErrors = function(isMulticity, formElementsToValidate) {
    if (!isMulticity) {
        return getFormElementsWithErrors(formElementsToValidate);
    }
    return getMultiFormElementsWithErrors(formElementsToValidate);
};
var __Fragment65 = gql95(_templateObject99(), EGDSErrorSummary.fragment, EGDSSearchFormLocationsField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment, EGDSSearchFormButton.fragment, EGDSTertiaryButton.fragment, EGDSBasicLocalizedTextFragment, EGDSSearchPlayback.fragment, SoftPackages.fragment, SearchLocationFragment);
var locationTypeMap = /* @__PURE__ */ new Map();
var FlightSearchForm = function(props) {
    var _softPackages_addHotel, _softPackages_addCar;
    var onFieldChange = props.onFieldChange, flightType = props.flightType, useFareCalendar = props.useFareCalendar, onSubmit = props.onSubmit, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, stickyPlayback = props.stickyPlayback, displayPlayback = props.displayPlayback, onDisplayPlaybackToggle = props.onDisplayPlaybackToggle, cabinClass = props.cabinClass, directFlightsOnlySwitch = props.directFlightsOnlySwitch, data = props.data;
    var errorSummary5 = data.errorSummary, elements = data.elements, search6 = data.search, addLeg = data.addLeg, removeLeg = data.removeLeg, legHeading = data.legHeading, localDateFormat = data.localDateFormat, legs = data.legs, maxAllowedLegs = data.maxAllowedLegs, initialPlayback = data.playback, initialSoftPackages = data.softPackages, searchLocation = data.searchLocation;
    var localizationContext = useLocalization18();
    var formRef = React129.useRef(null);
    var searchParams = new URLSearchParams(useLocation().search);
    var _React129_useState = _sliced_to_array(React129.useState(initialPlayback), 2), playbackData = _React129_useState[0], setPlaybackData = _React129_useState[1];
    var handleOnTypeaheadSelection = function(selection) {
        var _selection_data_regionNames, _selection_data, _selection_data_type, _selection_data1;
        if ((selection === null || selection === void 0 ? void 0 : (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : (_selection_data_regionNames = _selection_data.regionNames) === null || _selection_data_regionNames === void 0 ? void 0 : _selection_data_regionNames.fullName) && (selection === null || selection === void 0 ? void 0 : (_selection_data1 = selection.data) === null || _selection_data1 === void 0 ? void 0 : (_selection_data_type = _selection_data1.type) === null || _selection_data_type === void 0 ? void 0 : _selection_data_type[0])) {
            locationTypeMap.set(selection.data.regionNames.fullName, selection.data.type[0].toUpperCase());
        }
        setPlaybackData(function(prevPlaybackState) {
            var _selection_data, _selection_data_origin, _selection_data1, _selection_data_origin1, _selection_data2, _selection_data_origin2, _selection_data3, _selection_data_destination, _selection_data4, _selection_data_destination1, _selection_data5, _selection_data_destination2, _selection_data6;
            if (!prevPlaybackState) {
                return null;
            }
            var primary = prevPlaybackState.primary, primaryTemplate = prevPlaybackState.primaryTemplate;
            var _selection_data_index;
            var index = (_selection_data_index = (_selection_data = selection.data) === null || _selection_data === void 0 ? void 0 : _selection_data.index) !== null && _selection_data_index !== void 0 ? _selection_data_index : 0;
            if (index > 0) {
                return _object_spread({}, prevPlaybackState);
            }
            var playbackOrigin = ((_selection_data1 = selection.data) === null || _selection_data1 === void 0 ? void 0 : (_selection_data_origin = _selection_data1.origin) === null || _selection_data_origin === void 0 ? void 0 : _selection_data_origin.includes("(")) ? (_selection_data2 = selection.data) === null || _selection_data2 === void 0 ? void 0 : (_selection_data_origin1 = _selection_data2.origin) === null || _selection_data_origin1 === void 0 ? void 0 : _selection_data_origin1.split("(")[0].trim() : (_selection_data3 = selection.data) === null || _selection_data3 === void 0 ? void 0 : (_selection_data_origin2 = _selection_data3.origin) === null || _selection_data_origin2 === void 0 ? void 0 : _selection_data_origin2.trim();
            var playbackDestination = ((_selection_data4 = selection.data) === null || _selection_data4 === void 0 ? void 0 : (_selection_data_destination = _selection_data4.destination) === null || _selection_data_destination === void 0 ? void 0 : _selection_data_destination.includes("(")) ? (_selection_data5 = selection.data) === null || _selection_data5 === void 0 ? void 0 : (_selection_data_destination1 = _selection_data5.destination) === null || _selection_data_destination1 === void 0 ? void 0 : _selection_data_destination1.split("(")[0].trim() : (_selection_data6 = selection.data) === null || _selection_data6 === void 0 ? void 0 : (_selection_data_destination2 = _selection_data6.destination) === null || _selection_data_destination2 === void 0 ? void 0 : _selection_data_destination2.trim();
            var originTemplateModel = "origin";
            var destinationTemplateModel = "destination";
            var originFilledTemplate = formatLocalizedTokenString(primaryTemplate === null || primaryTemplate === void 0 ? void 0 : primaryTemplate.text, originTemplateModel, playbackOrigin);
            var newPrimary = _object_spread_props(_object_spread({}, primary), {
                text: formatLocalizedTokenString(originFilledTemplate, destinationTemplateModel, playbackDestination)
            });
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary
            });
        });
    };
    var _React129_useState1 = _sliced_to_array(React129.useState({
        EGDSSearchFormLocationsField: null,
        EGDSSearchFormDatePickerField: null,
        EGDSDatePickerFieldSoftPackages: null
    }), 2), fieldsRefs = _React129_useState1[0], setFieldsRefs = _React129_useState1[1];
    var initialErrorState2 = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var _React129_useState2 = _sliced_to_array(React129.useState(initialErrorState2), 2), errorState = _React129_useState2[0], setErrorState = _React129_useState2[1];
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var setFieldRefByTypename = React129.useCallback(function(typename, ref, refIndex) {
        var _ref_current;
        var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
        var nameRef = refIndex ? "".concat(typenameRef, "-leg").concat(refIndex) : typenameRef;
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, nameRef, ref));
        });
    }, []);
    var isInitialMount = React129.useRef(true);
    var locationsField = legs.length > 0 ? legs[0].locations : null;
    var locations = locationsField ? locationsField : null;
    var _locations_origin_value;
    var origin2 = (_locations_origin_value = locations === null || locations === void 0 ? void 0 : locations.origin.value) !== null && _locations_origin_value !== void 0 ? _locations_origin_value : "";
    var _locations_destination_value;
    var destination4 = (_locations_destination_value = locations === null || locations === void 0 ? void 0 : locations.destination.value) !== null && _locations_destination_value !== void 0 ? _locations_destination_value : "";
    var _React129_useState3 = _sliced_to_array(React129.useState({
        origin: origin2,
        destination: destination4,
        enabled: useFareCalendar !== null && useFareCalendar !== void 0 ? useFareCalendar : false
    }), 2), fareCalendarData = _React129_useState3[0], setFareCalendarData = _React129_useState3[1];
    var _React129_useState4 = _sliced_to_array(React129.useState([
        {
            type: "ONE_WAY" /* ONE_WAY */ ,
            hasRendered: false
        },
        {
            type: "ROUND_TRIP" /* ROUND_TRIP */ ,
            hasRendered: false
        },
        {
            type: "MULTI_DESTINATION" /* MULTI_DESTINATION */ ,
            hasRendered: false
        }
    ]), 2), tripTypeRenders = _React129_useState4[0], setTripTypeRenders = _React129_useState4[1];
    var updateTripTypeRenders = function() {
        var updatedTripTypeRenders = tripTypeRenders.map(function(element) {
            var newElement = element;
            if (element.type === flightType && !element.hasRendered) {
                newElement.hasRendered = true;
            }
            return newElement;
        });
        setTripTypeRenders(updatedTripTypeRenders);
    };
    React129.useEffect(function() {
        if (isInitialMount.current) {
            updateTripTypeRenders();
            isInitialMount.current = false;
        } else {
            var _tripTypeRenders_find;
            var hasRendered = (_tripTypeRenders_find = tripTypeRenders.find(function(element) {
                return element.type === flightType;
            })) === null || _tripTypeRenders_find === void 0 ? void 0 : _tripTypeRenders_find.hasRendered;
            if (!hasRendered || flightType === "MULTI_DESTINATION" /* MULTI_DESTINATION */ ) {
                if (fareCalendarData.enabled) {
                    setFareCalendarData(_object_spread_props(_object_spread({}, fareCalendarData), {
                        origin: "",
                        destination: ""
                    }));
                }
            }
            updateTripTypeRenders();
        }
    }, [
        flightType
    ]);
    var _React129_useState5 = _sliced_to_array(React129.useState(initialSoftPackages), 2), softPackages = _React129_useState5[0], setSoftPackages = _React129_useState5[1];
    var isSoftPackagesHotelSelected = (softPackages === null || softPackages === void 0 ? void 0 : (_softPackages_addHotel = softPackages.addHotel) === null || _softPackages_addHotel === void 0 ? void 0 : _softPackages_addHotel.__typename) === "EGDSBasicCheckBox" && softPackages.addHotel.state === "CHECKED" /* CHECKED */ ;
    var isSoftPackagesCarSelected = (softPackages === null || softPackages === void 0 ? void 0 : (_softPackages_addCar = softPackages.addCar) === null || _softPackages_addCar === void 0 ? void 0 : _softPackages_addCar.__typename) === "EGDSBasicCheckBox" && softPackages.addCar.state === "CHECKED" /* CHECKED */ ;
    var isSoftPackages = isSoftPackagesCarSelected || isSoftPackagesHotelSelected;
    var handleProductSelect = function(event) {
        var _event_currentTarget = event.currentTarget, name = _event_currentTarget.name, checked = _event_currentTarget.checked;
        setSoftPackages(function(previous) {
            var _previous_addCar, _previous_addHotel;
            if ((previous === null || previous === void 0 ? void 0 : (_previous_addCar = previous.addCar) === null || _previous_addCar === void 0 ? void 0 : _previous_addCar.__typename) === "EGDSBasicCheckBox" && previous.addCar.name !== null && name.includes(previous.addCar.name)) {
                return _object_spread_props(_object_spread({}, previous), {
                    addCar: _object_spread_props(_object_spread({}, previous.addCar), {
                        state: checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
                    })
                });
            }
            if ((previous === null || previous === void 0 ? void 0 : (_previous_addHotel = previous.addHotel) === null || _previous_addHotel === void 0 ? void 0 : _previous_addHotel.__typename) === "EGDSBasicCheckBox" && previous.addHotel.name !== null && name.includes(previous.addHotel.name)) {
                return _object_spread_props(_object_spread({}, previous), {
                    addHotel: _object_spread_props(_object_spread({}, previous.addHotel), {
                        state: checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
                    })
                });
            }
            return previous;
        });
    };
    var softPackagesContent = softPackages && /* @__PURE__ */ React129.createElement(SoftPackages, {
        data: softPackages,
        onProductSelect: handleProductSelect,
        setFieldRefByTypename: setFieldRefByTypename,
        currentSearchFormProduct: "flights",
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormDatePickerFieldSoftPackages";
        })
    });
    React129.useEffect(function() {
        setSoftPackages(initialSoftPackages);
    }, [
        initialSoftPackages
    ]);
    var updatePlaybackDates = function(date, isStartDate) {
        setPlaybackData(function(prevPlaybackState) {
            if (!prevPlaybackState) {
                return null;
            }
            var secondaries = prevPlaybackState.secondaries;
            var _secondaries = _sliced_to_array(secondaries, 2), dates = _secondaries[0], travelers = _secondaries[1];
            var secondaryDates = dates.__typename === "EGDSPlainText" ? _object_spread_props(_object_spread({}, dates), {
                text: getSingleReplaceFormattedDates(date, dates.text, isStartDate, localizationContext)
            }) : dates;
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                secondaries: [
                    secondaryDates,
                    travelers
                ]
            });
        });
    };
    var handleFieldChange = function(field, event) {
        if (onFieldChange) {
            var flightSearchCriteria = getSearchCriteriaFromSubmitRef(formRef, flightType);
            var queryParams = getURLQueryParamsFromCriteria2(flightSearchCriteria, searchParams, {
                localDateFormat: localDateFormat,
                formatDateString: localizationContext.formatDateString
            }, locationTypeMap);
            onFieldChange(field, event, queryParams);
        }
        if (fareCalendarData.enabled) {
            switch(field.name){
                case "origin_select":
                    setFareCalendarData(_object_spread_props(_object_spread({}, fareCalendarData), {
                        origin: field.value
                    }));
                    break;
                case "destination_select":
                    setFareCalendarData(_object_spread_props(_object_spread({}, fareCalendarData), {
                        destination: field.value
                    }));
            }
        }
        setPlaybackData(function(prevPlaybackState) {
            if (!prevPlaybackState) {
                return null;
            }
            var TRAVELER_SELECTOR = FieldNameMap7.TRAVELER_SELECTOR;
            var secondaries = prevPlaybackState.secondaries;
            var text = field.value;
            var _secondaries = _sliced_to_array(secondaries, 2), dates = _secondaries[0], travelers = _secondaries[1];
            var secondaryTravelers = field.name === TRAVELER_SELECTOR ? _object_spread_props(_object_spread({}, travelers), {
                text: text
            }) : travelers;
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                secondaries: [
                    dates,
                    secondaryTravelers
                ]
            });
        });
    };
    var handleSubmit = function(event) {
        setErrorState(initialErrorState2);
        var formElements = Array.from(event.currentTarget.elements);
        var isMulticity = flightType === "MULTI_DESTINATION" /* MULTI_DESTINATION */ ;
        var formElementsToValidate = getElementsToValidate(isMulticity, formElements);
        var fieldsWithErrors = getElementsWithErrors(isMulticity, formElementsToValidate);
        var isFormValid = fieldsWithErrors.length === 0;
        if (!isFormValid) {
            var _fieldsWithErrors_;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: fieldsWithErrors.length,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
            });
            event.preventDefault();
            return;
        }
        if (onSubmit || redirectToSearchResultOnSubmit) {
            var flightSearchCriteria = getSearchCriteriaFromSubmitEvent(event, flightType, directFlightsOnlySwitch);
            if (onSubmit) {
                onSubmit(event, {
                    flightSearchCriteria: flightSearchCriteria
                });
            }
            if (redirectToSearchResultOnSubmit) {
                event.preventDefault();
                var _event_currentTarget = event.currentTarget, action = _event_currentTarget.action, formInputs = _event_currentTarget.elements;
                var inputs = Array.from(formInputs);
                var queryParams = isSoftPackages ? getSoftPackagesURLQueryParamsFromInputs(inputs, flightType, directFlightsOnlySwitch, {
                    localDateFormat: localDateFormat,
                    formatDateString: localizationContext.formatDateString
                }) : getURLQueryParamsFromCriteria2(flightSearchCriteria, searchParams, {
                    localDateFormat: localDateFormat,
                    formatDateString: localizationContext.formatDateString
                }, locationTypeMap);
                window.location.href = "".concat(action).concat(queryParams);
            }
        }
    };
    var fields = elements;
    var searchFormProps = _object_spread_props(_object_spread({}, props), {
        flightType: flightType,
        errorState: errorState,
        defaultValidationProps: {
            setFieldRefByTypename: setFieldRefByTypename
        },
        fields: fields,
        legs: legs,
        onLocationsSelection: handleOnTypeaheadSelection,
        maxAllowedLegs: maxAllowedLegs,
        fareCalendarData: fareCalendarData,
        search: search6,
        softPackages: softPackagesContent,
        updatePlaybackDates: updatePlaybackDates,
        searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
    });
    var _data_egdsElementId, _data_egdsElementId1;
    return /* @__PURE__ */ React129.createElement(UitkForm13, {
        id: (_data_egdsElementId = data.egdsElementId) !== null && _data_egdsElementId !== void 0 ? _data_egdsElementId : "search-flight-form",
        name: (_data_egdsElementId1 = data.egdsElementId) !== null && _data_egdsElementId1 !== void 0 ? _data_egdsElementId1 : "search-flight-form",
        method: "GET",
        action: isSoftPackages && (softPackages === null || softPackages === void 0 ? void 0 : softPackages.actionURL) ? softPackages.actionURL : data.actionURL,
        ref: formRef,
        onFieldChange: handleFieldChange,
        onSubmit: handleSubmit,
        hasRequiredFieldIndicator: true
    }, displayErrorSummary && errorSummary5 && /* @__PURE__ */ React129.createElement(UitkSpacing41, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React129.createElement("div", null, /* @__PURE__ */ React129.createElement(EGDSErrorSummary, {
        data: errorSummary5,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference
    }))), /* @__PURE__ */ React129.createElement(UitkSpacing41, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React129.createElement("div", {
        id: "FlightSearchForm_".concat(flightType),
        "data-testid": "FlightSearchForm_".concat(flightType)
    }, flightType === "MULTI_DESTINATION" /* MULTI_DESTINATION */  && (search6 === null || search6 === void 0 ? void 0 : search6.__typename) === "EGDSSearchFormButton" ? /* @__PURE__ */ React129.createElement(MultiDestinationForm, _object_spread_props(_object_spread({}, searchFormProps), {
        addLeg: addLeg,
        removeLeg: removeLeg,
        legHeading: legHeading,
        search: search6,
        legs: legs,
        elements: elements,
        playback: playbackData,
        getFlightSearchCriteria: function() {
            return getSearchCriteriaFromSubmitRef(formRef, flightType);
        }
    })) : /* @__PURE__ */ React129.createElement(Viewport37, null, /* @__PURE__ */ React129.createElement(ViewSmall35, null, playbackData ? /* @__PURE__ */ React129.createElement(EGDSSearchPlayback, {
        data: playbackData,
        stickyPlayback: stickyPlayback,
        display: displayPlayback,
        onDisplayToggle: onDisplayPlaybackToggle
    }, /* @__PURE__ */ React129.createElement(FormFieldsLayout3, _object_spread_props(_object_spread({}, searchFormProps), {
        viewSize: ViewSizes16.SMALL
    }))) : /* @__PURE__ */ React129.createElement(FormFieldsLayout3, _object_spread_props(_object_spread({}, searchFormProps), {
        viewSize: ViewSizes16.SMALL
    }))), /* @__PURE__ */ React129.createElement(ViewMedium34, null, /* @__PURE__ */ React129.createElement(FormFieldsLayout3, _object_spread_props(_object_spread({}, searchFormProps), {
        viewSize: ViewSizes16.MEDIUM
    }))), /* @__PURE__ */ React129.createElement(ViewLarge14, null, /* @__PURE__ */ React129.createElement(FormFieldsLayout3, _object_spread_props(_object_spread({}, searchFormProps), {
        viewSize: ViewSizes16.LARGE
    })))))), softPackagesContent && /* @__PURE__ */ React129.createElement(Viewport37, null, /* @__PURE__ */ React129.createElement(ViewMedium34, null, /* @__PURE__ */ React129.createElement(UitkSpacing41, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React129.createElement("div", null, softPackagesContent)))), /* @__PURE__ */ React129.createElement("input", {
        type: "hidden",
        name: cabinClass.name,
        value: cabinClass.value
    }));
};
FlightSearchForm.fragment = __Fragment65;
FlightSearchForm.displayName = "FlightSearchForm";
// src/components/flights/form/flights-search-form.tsx
var __Query11 = gql96(_templateObject100(), FlightSearchForm.fragment);
var PriceCalendarContext = React130.createContext({
    lobName: "flights",
    enablePriceCalendar: false,
    priceCalendarInputs: {
        flightsSearchContext: {
            tripType: "ROUND_TRIP" /* ROUND_TRIP */ 
        },
        journeyCriteria: []
    }
});
var FlightsSearchForm2 = function(props) {
    var _inputs_flightSearchCriteria, _inputs_flightSearchCriteria1;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, batchKey = props.batchKey, includePlayback = props.includePlayback, features = props.features, _props_enablePriceCalendar = props.enablePriceCalendar, enablePriceCalendar = _props_enablePriceCalendar === void 0 ? false : _props_enablePriceCalendar;
    var context = useBexApi16().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: !!includePlayback,
        features: features
    });
    var _inputs_flightSearchCriteria_primary_tripType;
    var flightType = (_inputs_flightSearchCriteria_primary_tripType = (_inputs_flightSearchCriteria = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria === void 0 ? void 0 : _inputs_flightSearchCriteria.primary.tripType) !== null && _inputs_flightSearchCriteria_primary_tripType !== void 0 ? _inputs_flightSearchCriteria_primary_tripType : "ROUND_TRIP" /* ROUND_TRIP */ ;
    var systemEvents = useLoggerEvents10(CLIENT_EVENTS8);
    var _useQuery11 = useQuery11(__Query11, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery
    }), data = _useQuery11.data, error = _useQuery11.error, loading = _useQuery11.loading;
    var flightSearchFormProps = _object_spread_props(_object_spread({}, props), {
        flightType: flightType
    });
    var priceCalendarValues = React130.useMemo(function() {
        var _inputs_flightSearchCriteria, _inputs_flightSearchCriteria1;
        var flightsSearchContext = (_inputs_flightSearchCriteria = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria === void 0 ? void 0 : _inputs_flightSearchCriteria.primary;
        var _inputs_flightSearchCriteria_primary_journeyCriterias;
        return {
            lobName: "flights",
            enablePriceCalendar: enablePriceCalendar,
            priceCalendarInputs: {
                flightsSearchContext: flightsSearchContext,
                journeyCriteria: (_inputs_flightSearchCriteria_primary_journeyCriterias = (_inputs_flightSearchCriteria1 = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria1 === void 0 ? void 0 : _inputs_flightSearchCriteria1.primary.journeyCriterias) !== null && _inputs_flightSearchCriteria_primary_journeyCriterias !== void 0 ? _inputs_flightSearchCriteria_primary_journeyCriterias : []
            }
        };
    }, [
        enablePriceCalendar,
        (_inputs_flightSearchCriteria1 = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria1 === void 0 ? void 0 : _inputs_flightSearchCriteria1.primary
    ]);
    if (loading) {
        return /* @__PURE__ */ React130.createElement(UitkSpacing42, {
            padding: {
                blockstart: "six"
            }
        }, /* @__PURE__ */ React130.createElement("div", null, /* @__PURE__ */ React130.createElement(Viewport38, null, /* @__PURE__ */ React130.createElement(ViewSmall36, null, /* @__PURE__ */ React130.createElement(FormSkeleton, {
            rows: [
                {
                    type: "primary"
                },
                {
                    type: "primary"
                },
                {
                    type: "primary"
                }
            ]
        })), /* @__PURE__ */ React130.createElement(ViewMedium35, null, /* @__PURE__ */ React130.createElement(FormSkeleton, {
            rows: [
                {
                    type: "primary"
                }
            ]
        })))));
    }
    if (error || (data === null || data === void 0 ? void 0 : data.searchForm.flight.__typename) !== "FlightSearchForm") {
        systemEvents.SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_QUERY_FAILURE.log({
            name: error === null || error === void 0 ? void 0 : error.name,
            error: new Error(error === null || error === void 0 ? void 0 : error.message)
        });
        return /* @__PURE__ */ React130.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */ React130.createElement(IntersectionTracker10, _object_spread({}, CLIENT_TRACKING_EVENTS7.SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_FALLBACK_IMPRESSION), /* @__PURE__ */ React130.createElement(FlightSearchForm, _object_spread_props(_object_spread({}, flightSearchFormProps), {
            data: getFallbackData6(flightType)
        }))));
    }
    return /* @__PURE__ */ React130.createElement(IntersectionTracker10, _object_spread({}, CLIENT_TRACKING_EVENTS7.SEARCH_TOOLS_FLIGHTS_SEARCH_FORM_IMPRESSION), /* @__PURE__ */ React130.createElement(PriceCalendarContext.Provider, {
        value: priceCalendarValues
    }, /* @__PURE__ */ React130.createElement(FlightSearchForm, _object_spread_props(_object_spread({}, flightSearchFormProps), {
        data: data.searchForm.flight
    }))));
};
FlightsSearchForm2.displayName = "sharedui-FlightsSearchForm";
// src/components/flights/form/search-form.tsx
var FlightsSearchForm = function(props) {
    var _inputs_flightSearchCriteria, _inputs_flightSearchCriteria1;
    var inputs = props.inputs, onFlightTypeSelect = props.onFlightTypeSelect, enableReflection = props.enableReflection, sticky = props.sticky, autoOpenPlayback = props.autoOpenPlayback, includePlayback = props.includePlayback, useFareCalendar = props.useFareCalendar, enablePriceCalendar = props.enablePriceCalendar;
    var _inputs_flightSearchCriteria_primary_tripType;
    var _React131_useState = _sliced_to_array(React131.useState((_inputs_flightSearchCriteria_primary_tripType = (_inputs_flightSearchCriteria = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria === void 0 ? void 0 : _inputs_flightSearchCriteria.primary.tripType) !== null && _inputs_flightSearchCriteria_primary_tripType !== void 0 ? _inputs_flightSearchCriteria_primary_tripType : "ROUND_TRIP" /* ROUND_TRIP */ ), 2), tripType = _React131_useState[0], setTripType = _React131_useState[1];
    var _React131_useState1 = _sliced_to_array(React131.useState({
        name: "",
        value: ""
    }), 2), cabinClass = _React131_useState1[0], setCabinClass = _React131_useState1[1];
    var _React131_useState2 = _sliced_to_array(React131.useState(false), 2), directFlightsOnlySwitch = _React131_useState2[0], setDirectFlightsOnlySwitch = _React131_useState2[1];
    var _React131_useState3 = _sliced_to_array(React131.useState(!autoOpenPlayback), 2), displayPlayback = _React131_useState3[0], setDisplayPlayback = _React131_useState3[1];
    var handlePlaybackToggle = function(isPlaybackOpen) {
        setDisplayPlayback(isPlaybackOpen);
    };
    React131.useEffect(function() {
        var _inputs_flightSearchCriteria;
        if ((_inputs_flightSearchCriteria = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria === void 0 ? void 0 : _inputs_flightSearchCriteria.primary.tripType) {
            setTripType(inputs.flightSearchCriteria.primary.tripType);
        }
    }, [
        (_inputs_flightSearchCriteria1 = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria1 === void 0 ? void 0 : _inputs_flightSearchCriteria1.primary.tripType
    ]);
    var handleFlightTypeSelect = React131.useCallback(function(flightTripType) {
        setTripType(flightTripType);
        onFlightTypeSelect === null || onFlightTypeSelect === void 0 ? void 0 : onFlightTypeSelect(flightTripType);
    }, [
        setTripType,
        onFlightTypeSelect
    ]);
    var handleCabinClassSelect = React131.useCallback(function(field) {
        setCabinClass(field);
    }, [
        setCabinClass
    ]);
    var handleDirectFlightsSelect = React131.useCallback(function(directFlights) {
        setDirectFlightsOnlySwitch(directFlights);
    }, [
        setDirectFlightsOnlySwitch
    ]);
    var baseForm = function(toggleValue) /* @__PURE__ */ {
        var _inputs_flightSearchCriteria, _inputs_flightSearchCriteria1;
        var _inputs_flightSearchCriteria_primary, _inputs_flightSearchCriteria_primary1;
        return React131.createElement(React131.Fragment, null, includePlayback && toggleValue ? /* @__PURE__ */ React131.createElement(FlightsSearchForm2, _object_spread_props(_object_spread({}, props), {
            inputs: _object_spread_props(_object_spread({}, inputs), {
                flightSearchCriteria: _object_spread_props(_object_spread({}, inputs.flightSearchCriteria), {
                    primary: _object_spread_props(_object_spread({}, (_inputs_flightSearchCriteria_primary = (_inputs_flightSearchCriteria = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria === void 0 ? void 0 : _inputs_flightSearchCriteria.primary) !== null && _inputs_flightSearchCriteria_primary !== void 0 ? _inputs_flightSearchCriteria_primary : {
                        journeyCriterias: [],
                        travelers: []
                    }), {
                        tripType: tripType
                    })
                })
            }),
            displayPlayback: displayPlayback,
            onDisplayPlaybackToggle: handlePlaybackToggle,
            cabinClass: cabinClass,
            useFareCalendar: useFareCalendar,
            enablePriceCalendar: enablePriceCalendar,
            directFlightsOnlySwitch: directFlightsOnlySwitch
        })) : /* @__PURE__ */ React131.createElement(React131.Fragment, null, /* @__PURE__ */ React131.createElement(FlightOptions, _object_spread_props(_object_spread({}, props), {
            inputs: _object_spread_props(_object_spread({}, inputs), {
                flightSearchCriteria: inputs.flightSearchCriteria ? {
                    primary: {
                        journeyCriterias: [],
                        travelers: [],
                        tripType: inputs.flightSearchCriteria.primary.tripType
                    }
                } : null
            }),
            onFlightTypeSelect: handleFlightTypeSelect,
            onCabinClassSelect: handleCabinClassSelect,
            onDirectFlightsSelect: handleDirectFlightsSelect
        })), /* @__PURE__ */ React131.createElement(FlightsSearchForm2, _object_spread_props(_object_spread({}, props), {
            inputs: _object_spread_props(_object_spread({}, inputs), {
                flightSearchCriteria: _object_spread_props(_object_spread({}, inputs.flightSearchCriteria), {
                    primary: _object_spread_props(_object_spread({}, (_inputs_flightSearchCriteria_primary1 = (_inputs_flightSearchCriteria1 = inputs.flightSearchCriteria) === null || _inputs_flightSearchCriteria1 === void 0 ? void 0 : _inputs_flightSearchCriteria1.primary) !== null && _inputs_flightSearchCriteria_primary1 !== void 0 ? _inputs_flightSearchCriteria_primary1 : {
                        journeyCriterias: [],
                        travelers: []
                    }), {
                        tripType: tripType
                    })
                })
            }),
            displayPlayback: displayPlayback,
            onDisplayPlaybackToggle: handlePlaybackToggle,
            cabinClass: cabinClass,
            useFareCalendar: useFareCalendar,
            enablePriceCalendar: enablePriceCalendar,
            directFlightsOnlySwitch: directFlightsOnlySwitch
        }))));
    };
    var formWithPossibleReflection = function(viewPort) {
        var content = baseForm(displayPlayback && viewPort === ViewSizes17.SMALL);
        return !enableReflection ? content : /* @__PURE__ */ React131.createElement(SearchFormReflectionProvider4, null, /* @__PURE__ */ React131.createElement("div", {
            "data-stid": "search-form-with-reflection"
        }, content));
    };
    return /* @__PURE__ */ React131.createElement("div", {
        "data-stid": "search-form-sticky"
    }, /* @__PURE__ */ React131.createElement(Viewport39, null, /* @__PURE__ */ React131.createElement(ViewSmall37, null, /* @__PURE__ */ React131.createElement("div", null, formWithPossibleReflection(ViewSizes17.SMALL))), /* @__PURE__ */ React131.createElement(ViewMedium36, null, /* @__PURE__ */ React131.createElement(React131.Fragment, null, sticky ? /* @__PURE__ */ React131.createElement(StickySearchForm, null, formWithPossibleReflection(ViewSizes17.MEDIUM)) : /* @__PURE__ */ React131.createElement("div", null, formWithPossibleReflection(ViewSizes17.MEDIUM))))));
};
export { ActivitySearchForm, CarsSearchForm, CruiseSearchForm, FlightsCabinClass, FlightsSearchForm, FlightsTripType, GroundTransportationSearchForm2 as GroundTransportationSearchForm, LodgingQueryParamsProvider, LodgingSearchForm2 as LodgingSearchForm, LodgingSearchFormFeatures, MultiItemSearchForm, MultiProductSearchForm, PackageType, ParamsKeys, PriceCalendarContext, SearchFormLayout, SearchFormProductType, SignalsMap as SearchFormSignalsMap, SearchFormWithBackgroundImage, TravelerDetailsType, getPropertySearchCriteriaFromQueryParams, useLodgingURLParamsToQueryInputs }; /* istanbul ignore file -- @preserve */  /* istanbul ignore next -- @preserve */  /* istanbul ignore if -- @preserve */  /*! Bundled license information:

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)
*/ 
//# sourceMappingURL=index.js.map